!(function () {
  function R(e) {
    return e && e.__esModule ? e.default : e;
  }
  var i =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof self
        ? self
        : "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : {},
    M = {},
    e = (function (o) {
      var e = Object.prototype,
        l = e.hasOwnProperty,
        t = "function" == typeof Symbol ? Symbol : {},
        r = t.iterator || "@@iterator",
        n = t.asyncIterator || "@@asyncIterator",
        i = t.toStringTag || "@@toStringTag";
      function a(e, t, n, r) {
        var i,
          o,
          a,
          s,
          t = t && t.prototype instanceof d ? t : d,
          t = Object.create(t.prototype),
          r = new b(r || []);
        return (
          (t._invoke =
            ((i = e),
            (o = n),
            (a = r),
            (s = "suspendedStart"),
            function (e, t) {
              if ("executing" === s)
                throw new Error("Generator is already running");
              if ("completed" === s) {
                if ("throw" === e) throw t;
                return x();
              }
              for (a.method = e, a.arg = t; ; ) {
                var n = a.delegate;
                if (n) {
                  var r = (function e(t, n) {
                
                  })(n, a);
                  if (r) {
                    if (r === u) continue;
                    return r;
                  }
                }
                if ("next" === a.method) a.sent = a._sent = a.arg;
                else if ("throw" === a.method) {
                  if ("suspendedStart" === s) throw ((s = "completed"), a.arg);
                  a.dispatchException(a.arg);
                } else "return" === a.method && a.abrupt("return", a.arg);
                s = "executing";
                r = c(i, o, a);
                if ("normal" === r.type) {
                  if (
                    ((s = a.done ? "completed" : "suspendedYield"), r.arg === u)
                  )
                    continue;
                  return { value: r.arg, done: a.done };
                }
                "throw" === r.type &&
                  ((s = "completed"), (a.method = "throw"), (a.arg = r.arg));
              }
            })),
          t
        );
      }
      function c(e, t, n) {
        try {
          return { type: "normal", arg: e.call(t, n) };
        } catch (e) {
          return { type: "throw", arg: e };
        }
      }
      o.wrap = a;
      var u = {};
      function d() {
        console.log("function d")
      }
      function s() {
      console.log("function s")}
      function p() {
      console.log("function p")}
      var f = {};
      f[r] = function () {
        return this;
      };
      (t = Object.getPrototypeOf), (t = t && t(t(w([]))));
      t && t !== e && l.call(t, r) && (f = t);
      var h = (p.prototype = d.prototype = Object.create(f));
      function m(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }
      function g(a) {
        console.log("function g(a)")
        var t;
        this._invoke = function (n, r) {
          function e() {
            return new Promise(function (e, t) {
              !(function t(e, n, r, i) {
                e = c(a[e], a, n);
                if ("throw" !== e.type) {
                  var o = e.arg,
                    n = o.value;
                  return n && "object" == typeof n && l.call(n, "__await")
                    ? Promise.resolve(n.__await).then(
                        function (e) {
                          t("next", e, r, i);
                        },
                        function (e) {
                          t("throw", e, r, i);
                        }
                      )
                    : Promise.resolve(n).then(
                        function (e) {
                          (o.value = e), r(o);
                        },
                        function (e) {
                          return t("throw", e, r, i);
                        }
                      );
                }
                i(e.arg);
              })(n, r, e, t);
            });
          }
          return (t = t ? t.then(e, e) : e());
        };
      }
      function v(e) {
        var t = { tryLoc: e[0] };
        1 in e && (t.catchLoc = e[1]),
          2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
          this.tryEntries.push(t);
      }
      function y(e) {
        var t = e.completion || {};
        (t.type = "normal"), delete t.arg, (e.completion = t);
      }
      function b(e) {
        (this.tryEntries = [{ tryLoc: "root" }]),
          e.forEach(v, this),
          this.reset(!0);
      }
      function w(t) {
        if (t) {
          var e = t[r];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;
          if (!isNaN(t.length)) {
            var n = -1,
              e = function e() {
                for (; ++n < t.length; )
                  if (l.call(t, n)) return (e.value = t[n]), (e.done = !1), e;
                return (e.value = void 0), (e.done = !0), e;
              };
            return (e.next = e);
          }
        }
        return { next: x };
      }
      function x() {
        return { value: void 0, done: !0 };
      }
      return (
        ((s.prototype = h.constructor = p).constructor = s),
        (p[i] = s.displayName = "GeneratorFunction"),
        (o.isGeneratorFunction = function (e) {
          e = "function" == typeof e && e.constructor;
          return (
            !!e &&
            (e === s || "GeneratorFunction" === (e.displayName || e.name))
          );
        }),
        (o.mark = function (e) {
          return (
            Object.setPrototypeOf
              ? Object.setPrototypeOf(e, p)
              : ((e.__proto__ = p), i in e || (e[i] = "GeneratorFunction")),
            (e.prototype = Object.create(h)),
            e
          );
        }),
        (o.awrap = function (e) {
          return { __await: e };
        }),
        m(g.prototype),
        (g.prototype[n] = function () {
          return this;
        }),
        (o.AsyncIterator = g),
        (o.async = function (e, t, n, r) {
          var i = new g(a(e, t, n, r));
          return o.isGeneratorFunction(t)
            ? i
            : i.next().then(function (e) {
                return e.done ? e.value : i.next();
              });
        }),
        m(h),
        (h[i] = "Generator"),
        (h[r] = function () {
          return this;
        }),
        (h.toString = function () {
          return "[object Generator]";
        }),
        (o.keys = function (n) {
          var e,
            r = [];
          for (e in n) r.push(e);
          return (
            r.reverse(),
            function e() {
              for (; r.length; ) {
                var t = r.pop();
                if (t in n) return (e.value = t), (e.done = !1), e;
              }
              return (e.done = !0), e;
            }
          );
        }),
        (o.values = w),
        (b.prototype = {
          constructor: b,
          reset: function (e) {
            if (
              ((this.prev = 0),
              (this.next = 0),
              (this.sent = this._sent = void 0),
              (this.done = !1),
              (this.delegate = null),
              (this.method = "next"),
              (this.arg = void 0),
              this.tryEntries.forEach(y),
              !e)
            )
              for (var t in this)
                "t" === t.charAt(0) &&
                  l.call(this, t) &&
                  !isNaN(+t.slice(1)) &&
                  (this[t] = void 0);
          },
          stop: function () {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function (n) {
            if (this.done) throw n;
            var r = this;
            function e(e, t) {
              return (
                (o.type = "throw"),
                (o.arg = n),
                (r.next = e),
                t && ((r.method = "next"), (r.arg = void 0)),
                !!t
              );
            }
            for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
              var i = this.tryEntries[t],
                o = i.completion;
              if ("root" === i.tryLoc) return e("end");
              if (i.tryLoc <= this.prev) {
                var a = l.call(i, "catchLoc"),
                  s = l.call(i, "finallyLoc");
                if (a && s) {
                  if (this.prev < i.catchLoc) return e(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return e(i.finallyLoc);
                } else if (a) {
                  if (this.prev < i.catchLoc) return e(i.catchLoc, !0);
                } else {
                  if (!s)
                    throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return e(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function (e, t) {
            for (var n = this.tryEntries.length - 1; 0 <= n; --n) {
              var r = this.tryEntries[n];
              if (
                r.tryLoc <= this.prev &&
                l.call(r, "finallyLoc") &&
                this.prev < r.finallyLoc
              ) {
                var i = r;
                break;
              }
            }
            i &&
              ("break" === e || "continue" === e) &&
              i.tryLoc <= t &&
              t <= i.finallyLoc &&
              (i = null);
            var o = i ? i.completion : {};
            return (
              (o.type = e),
              (o.arg = t),
              i
                ? ((this.method = "next"), (this.next = i.finallyLoc), u)
                : this.complete(o)
            );
          },
          complete: function (e, t) {
            if ("throw" === e.type) throw e.arg;
            return (
              "break" === e.type || "continue" === e.type
                ? (this.next = e.arg)
                : "return" === e.type
                ? ((this.rval = this.arg = e.arg),
                  (this.method = "return"),
                  (this.next = "end"))
                : "normal" === e.type && t && (this.next = t),
              u
            );
          },
          finish: function (e) {
            for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
              var n = this.tryEntries[t];
              if (n.finallyLoc === e)
                return this.complete(n.completion, n.afterLoc), y(n), u;
            }
          },
          catch: function (e) {
            for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
              var n = this.tryEntries[t];
              if (n.tryLoc === e) {
                var r,
                  i = n.completion;
                return "throw" === i.type && ((r = i.arg), y(n)), r;
              }
            }
            throw new Error("illegal catch attempt");
          },
          delegateYield: function (e, t, n) {
            return (
              (this.delegate = { iterator: w(e), resultName: t, nextLoc: n }),
              "next" === this.method && (this.arg = void 0),
              u
            );
          },
        }),
        o
      );
    })(M);
  try {
    regeneratorRuntime = e;
  } catch (R) {
    Function("r", "regeneratorRuntime = r")(e);
  }
  function l(e, t, n, r, i, o, a) {
    try {
      var s = e[o](a),
        l = s.value;
    } catch (e) {
      return n(e), 0;
    }
    s.done ? t(l) : Promise.resolve(l).then(r, i);
  }
  var N = function (s) {
    return function () {
      var e = this,
        a = arguments;
      return new Promise(function (t, n) {
        var r = s.apply(e, a);
        function i(e) {
          l(r, t, n, i, o, "next", e);
        }
        function o(e) {
          l(r, t, n, i, o, "throw", e);
        }
        i(void 0);
      });
    };
  };
  function r(e, t, n) {
    var r = 1 < arguments.length && void 0 !== t ? t : 0,
      i = 2 < arguments.length && void 0 !== n ? n : 1;
    return Math.min(Math.max(r, e), i);
  }
  var c,
    u,
    d,
    E,
    t = !1;
  function S() {
    t ||
      ((t = !0),
      (c = Object.getOwnPropertySymbols),
      (u = Object.prototype.hasOwnProperty),
      (d = Object.prototype.propertyIsEnumerable),
      (E = (function () {
        try {
          if (!Object.assign) return;
          var e = new String("abc");
          if (((e[5] = "de"), "5" === Object.getOwnPropertyNames(e)[0])) return;
          for (var t = {}, n = 0; n < 10; n++)
            t["_" + String.fromCharCode(n)] = n;
          if (
            "0123456789" !==
            Object.getOwnPropertyNames(t)
              .map(function (e) {
                return t[e];
              })
              .join("")
          )
            return;
          var r = {};
          return (
            "abcdefghijklmnopqrst".split("").forEach(function (e) {
              r[e] = e;
            }),
            "abcdefghijklmnopqrst" ===
              Object.keys(Object.assign({}, r)).join("")
          );
        } catch (e) {
          return;
        }
      })()
        ? Object.assign
        : function (e, t) {
            for (
              var n,
                r,
                i = (function (e) {
                  if (null == e)
                    throw new TypeError(
                      "Object.assign cannot be called with null or undefined"
                    );
                  return Object(e);
                })(e),
                o = 1;
              o < arguments.length;
              o++
            ) {
              for (var a in (n = Object(arguments[o])))
                u.call(n, a) && (i[a] = n[a]);
              if (c) {
                r = c(n);
                for (var s = 0; s < r.length; s++)
                  d.call(n, r[s]) && (i[r[s]] = n[r[s]]);
              }
            }
            return i;
          }));
  }
  var p,
    f,
    h,
    n,
    o,
    a,
    s,
    m,
    g,
    v,
    y,
    b,
    w,
    x,
    C,
    k,
    T,
    P,
    z,
    O,
    L,
    I,
    _ = !1;
  function D(e) {
    for (
      var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e,
        n = 1;
      n < arguments.length;
      n++
    )
      t += "&args[]=" + encodeURIComponent(arguments[n]);
    return (
      "Minified React error #" +
      e +
      "; visit " +
      t +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    );
  }
  function A(e, t, n) {
    (this.props = e),
      (this.context = t),
      (this.refs = w),
      (this.updater = n || b);
  }
  function F() {}
  function B(e, t, n) {
    (this.props = e),
      (this.context = t),
      (this.refs = w),
      (this.updater = n || b);
  }
  function W(e, t, n) {
    var r,
      i = {},
      o = null,
      a = null;
    if (null != t)
      for (r in (void 0 !== t.ref && (a = t.ref),
      void 0 !== t.key && (o = "" + t.key),
      t))
        T.call(t, r) && !P.hasOwnProperty(r) && (i[r] = t[r]);
    var s = arguments.length - 2;
    if (1 === s) i.children = n;
    else if (1 < s) {
      for (var l = Array(s), c = 0; c < s; c++) l[c] = arguments[c + 2];
      i.children = l;
    }
    if (e && e.defaultProps)
      for (r in (s = e.defaultProps)) void 0 === i[r] && (i[r] = s[r]);
    return {
      $$typeof: f,
      type: e,
      key: o,
      ref: a,
      props: i,
      _owner: k.current,
    };
  }
  function $(e) {
    return "object" == typeof e && null !== e && e.$$typeof === f;
  }
  function j(e, t, n, r) {
    if (O.length) {
      var i = O.pop();
      return (
        (i.result = e),
        (i.keyPrefix = t),
        (i.func = n),
        (i.context = r),
        (i.count = 0),
        i
      );
    }
    return { result: e, keyPrefix: t, func: n, context: r, count: 0 };
  }
  function H(e) {
    (e.result = null),
      (e.keyPrefix = null),
      (e.func = null),
      (e.context = null),
      (e.count = 0),
      O.length < 10 && O.push(e);
  }
  function V(e, t, n) {
    return null == e
      ? 0
      : (function e(t, n, r, i) {
          var o = typeof t;
          ("undefined" !== o && "boolean" !== o) || (t = null);
          var a = !1;
          if (null === t) a = !0;
          else
            switch (o) {
              case "string":
              case "number":
                a = !0;
                break;
              case "object":
                switch (t.$$typeof) {
                  case f:
                  case h:
                    a = !0;
                }
            }
          if (a) return r(i, t, "" === n ? "." + q(t, 0) : n), 1;
          if (((a = 0), (n = "" === n ? "." : n + ":"), Array.isArray(t)))
            for (var s = 0; s < t.length; s++) {
              var l = n + q((o = t[s]), s);
              a += e(o, l, r, i);
            }
          else if (
            "function" ==
            typeof (l =
              null !== t &&
              "object" == typeof t &&
              "function" == typeof (l = (y && t[y]) || t["@@iterator"])
                ? l
                : null)
          )
            for (t = l.call(t), s = 0; !(o = t.next()).done; )
              a += e((o = o.value), (l = n + q(o, s++)), r, i);
          else if ("object" === o)
            throw (
              ((r = "" + t),
              Error(
                D(
                  31,
                  "[object Object]" === r
                    ? "object with keys {" + Object.keys(t).join(", ") + "}"
                    : r,
                  ""
                )
              ))
            );
          return a;
        })(e, "", t, n);
  }
  function q(e, t) {
    return "object" == typeof e && null !== e && null != e.key
      ? ((e = e.key),
        (n = { "=": "=0", ":": "=2" }),
        "$" +
          ("" + e).replace(/[=:]/g, function (e) {
            return n[e];
          }))
      : t.toString(36);
    var n;
  }
  function U(e, t) {
    e.func.call(e.context, t, e.count++);
  }
  function G(e, t, n) {
    var r = e.result,
      i = e.keyPrefix;
    (e = e.func.call(e.context, t, e.count++)),
      Array.isArray(e)
        ? Y(e, r, n, function (e) {
            return e;
          })
        : null != e &&
          ($(e) &&
            ((n =
              i +
              (!(i = e).key || (t && t.key === e.key)
                ? ""
                : ("" + e.key).replace(z, "$&/") + "/") +
              n),
            (e = {
              $$typeof: f,
              type: i.type,
              key: n,
              ref: i.ref,
              props: i.props,
              _owner: i._owner,
            })),
          r.push(e));
  }
  function Y(e, t, n, r, i) {
    var o = "";
    null != n && (o = ("" + n).replace(z, "$&/") + "/"),
      V(e, G, (t = j(t, o, r, i))),
      H(t);
  }
  function X() {
    var e = C.current;
    if (null === e) throw Error(D(321));
    return e;
  }
  var K,
    Z = !1;
  function Q() {
    Z ||
      ((Z = !0),
      (K = {}),
      _ ||
        ((_ = !0),
        S(),
        (p = E),
        (x = "function" == typeof Symbol && Symbol.for),
        (f = x ? Symbol.for("react.element") : 60103),
        (h = x ? Symbol.for("react.portal") : 60106),
        (n = x ? Symbol.for("react.fragment") : 60107),
        (L = x ? Symbol.for("react.strict_mode") : 60108),
        (o = x ? Symbol.for("react.profiler") : 60114),
        (a = x ? Symbol.for("react.provider") : 60109),
        (s = x ? Symbol.for("react.context") : 60110),
        (m = x ? Symbol.for("react.forward_ref") : 60112),
        (I = x ? Symbol.for("react.suspense") : 60113),
        x && Symbol.for("react.suspense_list"),
        (g = x ? Symbol.for("react.memo") : 60115),
        (v = x ? Symbol.for("react.lazy") : 60116),
        x && Symbol.for("react.fundamental"),
        x && Symbol.for("react.responder"),
        x && Symbol.for("react.scope"),
        (y = "function" == typeof Symbol && Symbol.iterator),
        (b = {
          isMounted: function () {
            return !1;
          },
          enqueueForceUpdate: function () {},
          enqueueReplaceState: function () {},
          enqueueSetState: function () {},
        }),
        (w = {}),
        (A.prototype.isReactComponent = {}),
        (A.prototype.setState = function (e, t) {
          if ("object" != typeof e && "function" != typeof e && null != e)
            throw Error(D(85));
          this.updater.enqueueSetState(this, e, t, "setState");
        }),
        (A.prototype.forceUpdate = function (e) {
          this.updater.enqueueForceUpdate(this, e, "forceUpdate");
        }),
        (F.prototype = A.prototype),
        ((x = B.prototype = new F()).constructor = B),
        p(x, A.prototype),
        (x.isPureReactComponent = !0),
        (C = { current: null }),
        (k = { current: null }),
        (T = Object.prototype.hasOwnProperty),
        (P = { key: !0, ref: !0, __self: !0, __source: !0 }),
        (z = /\/+/g),
        (I = {
          default: (L = {
            Children: {
              map: function (e, t, n) {
                if (null == e) return e;
                var r = [];
                return Y(e, r, null, t, n), r;
              },
              forEach: function (e, t, n) {
                if (null == e) return e;
                V(e, U, (t = j(null, null, t, n))), H(t);
              },
              count: function (e) {
                return V(
                  e,
                  function () {
                    return null;
                  },
                  null
                );
              },
              toArray: function (e) {
                var t = [];
                return (
                  Y(e, t, null, function (e) {
                    return e;
                  }),
                  t
                );
              },
              only: function (e) {
                if (!$(e)) throw Error(D(143));
                return e;
              },
            },
            createRef: function () {
              return { current: null };
            },
            Component: A,
            PureComponent: B,
            createContext: function (e, t) {
              return (
                void 0 === t && (t = null),
                ((e = {
                  $$typeof: s,
                  _calculateChangedBits: t,
                  _currentValue: e,
                  _currentValue2: e,
                  _threadCount: 0,
                  Provider: null,
                  Consumer: null,
                }).Provider = { $$typeof: a, _context: e }),
                (e.Consumer = e)
              );
            },
            forwardRef: function (e) {
              return { $$typeof: m, render: e };
            },
            lazy: function (e) {
              return { $$typeof: v, _ctor: e, _status: -1, _result: null };
            },
            memo: function (e, t) {
              return { $$typeof: g, type: e, compare: void 0 === t ? null : t };
            },
            useCallback: function (e, t) {
              return X().useCallback(e, t);
            },
            useContext: function (e, t) {
              return X().useContext(e, t);
            },
            useEffect: function (e, t) {
              return X().useEffect(e, t);
            },
            useImperativeHandle: function (e, t, n) {
              return X().useImperativeHandle(e, t, n);
            },
            useDebugValue: function () {},
            useLayoutEffect: function (e, t) {
              return X().useLayoutEffect(e, t);
            },
            useMemo: function (e, t) {
              return X().useMemo(e, t);
            },
            useReducer: function (e, t, n) {
              return X().useReducer(e, t, n);
            },
            useRef: function (e) {
              return X().useRef(e);
            },
            useState: function (e) {
              return X().useState(e);
            },
            Fragment: n,
            Profiler: o,
            StrictMode: L,
            Suspense: I,
            createElement: W,
            cloneElement: function (e, t, n) {
              if (null == e) throw Error(D(267, e));
              var r,
                i = p({}, e.props),
                o = e.key,
                a = e.ref,
                s = e._owner;
              if (null != t)
                for (l in (void 0 !== t.ref && ((a = t.ref), (s = k.current)),
                void 0 !== t.key && (o = "" + t.key),
                e.type && e.type.defaultProps && (r = e.type.defaultProps),
                t))
                  T.call(t, l) &&
                    !P.hasOwnProperty(l) &&
                    (i[l] = (void 0 === t[l] && void 0 !== r ? r : t)[l]);
              var l = arguments.length - 2;
              if (1 === l) i.children = n;
              else if (1 < l) {
                r = Array(l);
                for (var c = 0; c < l; c++) r[c] = arguments[c + 2];
                i.children = r;
              }
              return {
                $$typeof: f,
                type: e.type,
                key: o,
                ref: a,
                props: i,
                _owner: s,
              };
            },
            createFactory: function (e) {
              var t = W.bind(null, e);
              return (t.type = e), t;
            },
            isValidElement: $,
            version: "16.12.0",
            __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
              ReactCurrentDispatcher: C,
              ReactCurrentBatchConfig: { suspense: null },
              ReactCurrentOwner: k,
              IsSomeRendererActing: { current: !(O = []) },
              assign: p,
            },
          }),
        }),
        (I = (I = L || I).default || I)),
      (K = I));
  }
  var J,
    ee,
    te,
    ne,
    re,
    ie,
    oe,
    ae,
    se,
    le,
    ce,
    ue,
    de,
    pe = !1;
  function fe(e, t) {
    var n = e.length;
    e.push(t);
    e: for (;;) {
      var r = Math.floor((n - 1) / 2),
        i = e[r];
      if (!(void 0 !== i && 0 < ge(i, t))) break e;
      (e[r] = t), (e[n] = i), (n = r);
    }
  }
  function he(e) {
    return void 0 === (e = e[0]) ? null : e;
  }
  function me(e) {
    var t = e[0];
    if (void 0 !== t) {
      var n = e.pop();
      if (n !== t) {
        e[0] = n;
        e: for (var r = 0, i = e.length; r < i; ) {
          var o = 2 * (r + 1) - 1,
            a = e[o],
            s = 1 + o,
            l = e[s];
          if (void 0 !== a && ge(a, n) < 0)
            r =
              void 0 !== l && ge(l, a) < 0
                ? ((e[r] = l), (e[s] = n), s)
                : ((e[r] = a), (e[o] = n), o);
          else {
            if (!(void 0 !== l && ge(l, n) < 0)) break e;
            (e[r] = l), (e[s] = n), (r = s);
          }
        }
      }
      return t;
    }
  }
  function ge(e, t) {
    var n = e.sortIndex - t.sortIndex;
    return 0 != n ? n : e.id - t.id;
  }
  function ve(e) {
    for (var t = he(oe); null !== t; ) {
      if (null === t.callback) me(oe);
      else {
        if (!(t.startTime <= e)) break;
        me(oe), (t.sortIndex = t.expirationTime), fe(ie, t);
      }
      t = he(oe);
    }
  }
  function ye(e) {
    var t;
    (de = !1),
      ve(e),
      ue ||
        (null !== he(ie)
          ? ((ue = !0), ee(be))
          : null !== (t = he(oe)) && te(ye, t.startTime - e));
  }
  function be(e, t) {
    (ue = !1), de && ((de = !1), ne()), (ce = !0);
    var n = le;
    try {
      for (
        ve(t), se = he(ie);
        null !== se && (!(se.expirationTime > t) || (e && !re()));

      ) {
        var r = se.callback;
        null !== r
          ? ((se.callback = null),
            (le = se.priorityLevel),
            (r = r(se.expirationTime <= t)),
            (t = J()),
            "function" == typeof r
              ? (se.callback = r)
              : se === he(ie) && me(ie),
            ve(t))
          : me(ie),
          (se = he(ie));
      }
      var i =
        null !== se || (null !== (i = he(oe)) && te(ye, i.startTime - t), !1);
      return i;
    } finally {
      (se = null), (le = n), (ce = !1);
    }
  }
  function we(e) {
    switch (e) {
      case 1:
        return -1;
      case 2:
        return 250;
      case 5:
        return 1073741823;
      case 4:
        return 1e4;
      default:
        return 5e3;
    }
  }
  var xe,
    Ee,
    Se,
    Ce,
    ke,
    Te,
    Pe,
    ze,
    Oe,
    Re,
    Me,
    Ne,
    Le,
    Ie,
    _e,
    De,
    Ae,
    Fe,
    Be,
    We,
    $e,
    je,
    He,
    Ve,
    qe,
    Ue,
    Ge,
    Ye,
    Xe,
    Ke,
    Ze,
    Qe,
    Je,
    et,
    tt,
    nt,
    rt,
    it,
    ot,
    at,
    st,
    lt,
    ct,
    ut,
    dt,
    pt,
    ft,
    ht,
    mt,
    gt,
    vt,
    yt,
    bt,
    wt,
    xt,
    Et,
    St,
    Ct,
    kt,
    Tt,
    Pt,
    zt,
    Ot,
    Rt,
    Mt,
    Nt,
    Lt,
    It,
    _t,
    Dt,
    At,
    Ft,
    Bt,
    Wt,
    $t,
    jt,
    Ht,
    Vt,
    qt,
    Ut,
    Gt,
    Yt,
    Xt,
    Kt,
    Zt,
    Qt,
    Jt,
    en,
    tn,
    nn,
    rn,
    on,
    an,
    sn,
    ln,
    cn,
    un,
    dn,
    pn,
    fn,
    hn,
    mn,
    gn,
    vn,
    yn,
    bn,
    wn,
    xn,
    En,
    Sn,
    Cn,
    kn,
    Tn,
    Pn,
    zn,
    On,
    Rn,
    Mn,
    Nn,
    Ln,
    In,
    _n,
    Dn,
    An,
    Fn,
    Bn,
    Wn,
    $n,
    jn,
    Hn,
    Vn,
    qn,
    Un,
    Gn,
    Yn,
    Xn,
    Kn,
    Zn,
    Qn,
    Jn,
    er,
    tr,
    nr,
    rr,
    ir,
    or,
    ar,
    sr,
    lr,
    cr,
    ur,
    dr,
    pr,
    fr,
    hr,
    mr,
    gr,
    vr,
    yr,
    br,
    wr,
    xr,
    Er,
    Sr,
    Cr,
    kr,
    Tr,
    Pr,
    zr,
    Or,
    Rr,
    Mr,
    Nr,
    Lr,
    Ir,
    _r,
    Dr,
    Ar,
    Fr,
    Br,
    Wr,
    $r,
    jr,
    Hr,
    Vr,
    qr,
    Ur,
    Gr,
    Yr,
    Xr,
    Kr,
    Zr,
    Qr,
    Jr,
    ei,
    ti,
    ni,
    ri,
    ii,
    oi,
    ai,
    si,
    li,
    ci,
    ui,
    di,
    pi,
    fi,
    hi,
    mi,
    gi,
    vi,
    yi,
    bi,
    wi,
    xi,
    Ei,
    Si,
    Ci,
    ki,
    Ti,
    Pi,
    zi,
    Oi,
    Ri,
    Mi,
    Ni,
    Li,
    Ii,
    _i,
    Di,
    Ai,
    Fi,
    Bi,
    Wi,
    $i,
    ji,
    Hi,
    Vi,
    qi,
    Ui,
    Gi,
    Yi,
    Xi,
    Ki,
    Zi,
    Qi,
    Ji,
    eo,
    to,
    no,
    ro,
    io,
    oo,
    ao,
    so,
    lo,
    co,
    uo,
    po,
    fo = !1;
  function ho(e) {
    for (
      var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e,
        n = 1;
      n < arguments.length;
      n++
    )
      t += "&args[]=" + encodeURIComponent(arguments[n]);
    return (
      "Minified React error #" +
      e +
      "; visit " +
      t +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    );
  }
  function mo() {
    if (Ce)
      for (var e in ke) {
        var t = ke[e],
          n = Ce.indexOf(e);
        if (!(-1 < n)) throw Error(ho(96, e));
        if (!Te[n]) {
          if (!t.extractEvents) throw Error(ho(97, e));
          for (var r in (n = (Te[n] = t).eventTypes)) {
            var i = void 0,
              o = n[r],
              a = t,
              s = r;
            if (Pe.hasOwnProperty(s)) throw Error(ho(99, s));
            var l = (Pe[s] = o).phasedRegistrationNames;
            if (l) {
              for (i in l) l.hasOwnProperty(i) && go(l[i], a, s);
              i = !0;
            } else
              i = !!o.registrationName && (go(o.registrationName, a, s), !0);
            if (!i) throw Error(ho(98, r, e));
          }
        }
      }
  }
  function go(e, t, n) {
    if (ze[e]) throw Error(ho(100, e));
    (ze[e] = t), (Oe[e] = t.eventTypes[n].dependencies);
  }
  function vo(e, t, n, r, i, o, a, s, l) {
    (Re = !1),
      (Me = null),
      function (e, t, n, r, i, o, a, s, l) {
        var c = Array.prototype.slice.call(arguments, 3);
        try {
          t.apply(n, c);
        } catch (e) {
          this.onError(e);
        }
      }.apply(Ie, arguments);
  }
  function yo(e, t, n) {
    var r = e.type || "unknown-event";
    (e.currentTarget = Ae(n)),
      (function (e, t, n, r, i, o, a, s, l) {
        if ((vo.apply(this, arguments), Re)) {
          if (!Re) throw Error(ho(198));
          var c = Me;
          (Re = !1), (Me = null), Ne || ((Ne = !0), (Le = c));
        }
      })(r, t, void 0, e),
      (e.currentTarget = null);
  }
  function bo(e, t) {
    if (null == t) throw Error(ho(30));
    return null == e
      ? t
      : Array.isArray(e)
      ? (Array.isArray(t) ? e.push.apply(e, t) : e.push(t), e)
      : Array.isArray(t)
      ? [e].concat(t)
      : [e, t];
  }
  function wo(e, t, n) {
    Array.isArray(e) ? e.forEach(t, n) : e && t.call(n, e);
  }
  function xo(e) {
    if (e) {
      var t = e._dispatchListeners,
        n = e._dispatchInstances;
      if (Array.isArray(t))
        for (var r = 0; r < t.length && !e.isPropagationStopped(); r++)
          yo(e, t[r], n[r]);
      else t && yo(e, t, n);
      (e._dispatchListeners = null),
        (e._dispatchInstances = null),
        e.isPersistent() || e.constructor.release(e);
    }
  }
  function Eo(e) {
    if ((null !== e && (Fe = bo(Fe, e)), (e = Fe), (Fe = null), e)) {
      if ((wo(e, xo), Fe)) throw Error(ho(95));
      if (Ne) throw ((e = Le), (Ne = !1), (Le = null), e);
    }
  }
  function So(e, t) {
    var n = e.stateNode;
    if (!n) return null;
    var r = _e(n);
    if (!r) return null;
    n = r[t];
    e: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
        (r = !r.disabled) ||
          (r = !(
            "button" === (e = e.type) ||
            "input" === e ||
            "select" === e ||
            "textarea" === e
          )),
          (e = !r);
        break e;
      default:
        e = !1;
    }
    if (e) return null;
    if (n && "function" != typeof n) throw Error(ho(231, t, typeof n));
    return n;
  }
  function Co(e) {
    return null !== e &&
      "object" == typeof e &&
      "function" == typeof (e = (et && e[et]) || e["@@iterator"])
      ? e
      : null;
  }
  function ko(e) {
    if (null == e) return null;
    if ("function" == typeof e) return e.displayName || e.name || null;
    if ("string" == typeof e) return e;
    switch (e) {
      case He:
        return "Fragment";
      case je:
        return "Portal";
      case qe:
        return "Profiler";
      case Ve:
        return "StrictMode";
      case Ke:
        return "Suspense";
      case Ze:
        return "SuspenseList";
    }
    if ("object" == typeof e)
      switch (e.$$typeof) {
        case Ge:
          return "Context.Consumer";
        case Ue:
          return "Context.Provider";
        case Xe:
          var t = (t = e.render).displayName || t.name || "";
          return (
            e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef")
          );
        case Qe:
          return ko(e.type);
        case Je:
          if ((e = 1 === e._status ? e._result : null)) return ko(e);
      }
    return null;
  }
  function To(e) {
    var t = "";
    do {
      e: switch (e.tag) {
        case 3:
        case 4:
        case 6:
        case 7:
        case 10:
        case 9:
          var n = "";
          break e;
        default:
          var r = e._debugOwner,
            i = e._debugSource,
            o = ko(e.type),
            n = null;
          r && (n = ko(r.type)),
            (r = o),
            (o = ""),
            i
              ? (o =
                  " (at " +
                  i.fileName.replace(We, "") +
                  ":" +
                  i.lineNumber +
                  ")")
              : n && (o = " (created by " + n + ")"),
            (n = "\n    in " + (r || "Unknown") + o);
      }
    } while (((t += n), (e = e.return)));
    return t;
  }
  function Po(e) {
    if ((e = De(e))) {
      if ("function" != typeof nt) throw Error(ho(280));
      var t = _e(e.stateNode);
      nt(e.stateNode, e.type, t);
    }
  }
  function zo(e) {
    rt ? (it ? it.push(e) : (it = [e])) : (rt = e);
  }
  function Oo() {
    if (rt) {
      var e = rt,
        t = it;
      if (((it = rt = null), Po(e), t)) for (e = 0; e < t.length; e++) Po(t[e]);
    }
  }
  function Ro(e, t) {
    return e(t);
  }
  function Mo(e, t, n, r) {
    return e(t, n, r);
  }
  function No() {}
  function Lo() {
    (null === rt && null === it) || (No(), Oo());
  }
  function Io(e, t, n, r, i, o) {
    (this.acceptsBooleans = 2 === t || 3 === t || 4 === t),
      (this.attributeName = r),
      (this.attributeNamespace = i),
      (this.mustUseProperty = n),
      (this.propertyName = e),
      (this.type = t),
      (this.sanitizeURL = o);
  }
  function _o(e) {
    return e[1].toUpperCase();
  }
  function Do(e) {
    switch (typeof e) {
      case "boolean":
      case "number":
      case "object":
      case "string":
      case "undefined":
        return e;
      default:
        return "";
    }
  }
  function Ao(e, n, t, r) {
    var i,
      o = pt.hasOwnProperty(n) ? pt[n] : null;
    (null !== o
      ? 0 !== o.type
      : r ||
        !(2 < n.length) ||
        ("o" !== n[0] && "O" !== n[0]) ||
        ("n" !== n[1] && "N" !== n[1])) &&
      ((function (r, e, t) {
        if (
          null == r ||
          (function (e, t, n) {
            if (null === t || 0 !== t.type)
              switch (typeof r) {
                case "function":
                case "symbol":
                  return 1;
                case "boolean":
                  return (
                    !n &&
                    (null !== t
                      ? !t.acceptsBooleans
                      : "data-" !== (e = e.toLowerCase().slice(0, 5)) &&
                        "aria-" !== e)
                  );
                default:
                  return;
              }
          })(n, e, t)
        )
          return 1;
        if (!t && null !== e)
          switch (e.type) {
            case 3:
              return !r;
            case 4:
              return !1 === r;
            case 5:
              return isNaN(r);
            case 6:
              return isNaN(r) || r < 1;
          }
      })(t, o, r) && (t = null),
      r || null === o
        ? ((i = n),
          (ct.call(dt, i) ||
            (!ct.call(ut, i) &&
              (lt.test(i) ? (dt[i] = !0) : ((ut[i] = !0), 0)))) &&
            (null === t ? e.removeAttribute(n) : e.setAttribute(n, "" + t)))
        : o.mustUseProperty
        ? (e[o.propertyName] = null === t ? 3 !== o.type && "" : t)
        : ((n = o.attributeName),
          (r = o.attributeNamespace),
          null === t
            ? e.removeAttribute(n)
            : ((t = 3 === (o = o.type) || (4 === o && !0 === t) ? "" : "" + t),
              r ? e.setAttributeNS(r, n, t) : e.setAttribute(n, t))));
  }
  function Fo(e) {
    var t = e.type;
    return (
      (e = e.nodeName) &&
      "input" === e.toLowerCase() &&
      ("checkbox" === t || "radio" === t)
    );
  }
  function Bo(e) {
    e._valueTracker ||
      (e._valueTracker = (function (e) {
        var t = Fo(e) ? "checked" : "value",
          n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
          r = "" + e[t];
        if (
          !e.hasOwnProperty(t) &&
          void 0 !== n &&
          "function" == typeof n.get &&
          "function" == typeof n.set
        ) {
          var i = n.get,
            o = n.set;
          return (
            Object.defineProperty(e, t, {
              configurable: !0,
              get: function () {
                return i.call(this);
              },
              set: function (e) {
                (r = "" + e), o.call(this, e);
              },
            }),
            Object.defineProperty(e, t, { enumerable: n.enumerable }),
            {
              getValue: function () {
                return r;
              },
              setValue: function (e) {
                r = "" + e;
              },
              stopTracking: function () {
                (e._valueTracker = null), delete e[t];
              },
            }
          );
        }
      })(e));
  }
  function Wo(e) {
    if (e) {
      var t = e._valueTracker;
      if (!t) return 1;
      var n = t.getValue(),
        r = "";
      return (
        e && (r = Fo(e) ? (e.checked ? "true" : "false") : e.value),
        (e = r) !== n && (t.setValue(e), 1)
      );
    }
  }
  function $o(e, t) {
    var n = t.checked;
    return Ee({}, t, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: null != n ? n : e._wrapperState.initialChecked,
    });
  }
  function jo(e, t) {
    var n = null == t.defaultValue ? "" : t.defaultValue,
      r = null != t.checked ? t.checked : t.defaultChecked,
      n = Do(null != t.value ? t.value : n);
    e._wrapperState = {
      initialChecked: r,
      initialValue: n,
      controlled:
        "checkbox" === t.type || "radio" === t.type
          ? null != t.checked
          : null != t.value,
    };
  }
  function Ho(e, t) {
    null != (t = t.checked) && Ao(e, "checked", t, !1);
  }
  function Vo(e, t) {
    Ho(e, t);
    var n = Do(t.value),
      r = t.type;
    if (null != n)
      "number" === r
        ? ((0 === n && "" === e.value) || e.value != n) && (e.value = "" + n)
        : e.value !== "" + n && (e.value = "" + n);
    else if ("submit" === r || "reset" === r)
      return e.removeAttribute("value"), 0;
    t.hasOwnProperty("value")
      ? Uo(e, t.type, n)
      : t.hasOwnProperty("defaultValue") && Uo(e, t.type, Do(t.defaultValue)),
      null == t.checked &&
        null != t.defaultChecked &&
        (e.defaultChecked = !!t.defaultChecked);
  }
  function qo(e, t, n) {
    if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
      var r = t.type;
      if (
        !(
          ("submit" !== r && "reset" !== r) ||
          (void 0 !== t.value && null !== t.value)
        )
      )
        return;
      (t = "" + e._wrapperState.initialValue),
        n || t === e.value || (e.value = t),
        (e.defaultValue = t);
    }
    "" !== (n = e.name) && (e.name = ""),
      (e.defaultChecked = !e.defaultChecked),
      (e.defaultChecked = !!e._wrapperState.initialChecked),
      "" !== n && (e.name = n);
  }
  function Uo(e, t, n) {
    ("number" === t && e.ownerDocument.activeElement === e) ||
      (null == n
        ? (e.defaultValue = "" + e._wrapperState.initialValue)
        : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
  }
  function Go(e, t) {
    return (
      (e = Ee({ children: void 0 }, t)),
      (n = t.children),
      (r = ""),
      xe.Children.forEach(n, function (e) {
        null != e && (r += e);
      }),
      (t = r) && (e.children = t),
      e
    );
    var n, r;
  }
  function Yo(e, t, n, r) {
    if (((e = e.options), t)) {
      t = {};
      for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
      for (n = 0; n < e.length; n++)
        (i = t.hasOwnProperty("$" + e[n].value)),
          e[n].selected !== i && (e[n].selected = i),
          i && r && (e[n].defaultSelected = !0);
    } else {
      for (n = "" + Do(n), t = null, i = 0; i < e.length; i++) {
        if (e[i].value === n)
          return (e[i].selected = !0), r && (e[i].defaultSelected = !0), 0;
        null !== t || e[i].disabled || (t = e[i]);
      }
      null !== t && (t.selected = !0);
    }
  }
  function Xo(e, t) {
    if (null != t.dangerouslySetInnerHTML) throw Error(ho(91));
    return Ee({}, t, {
      value: void 0,
      defaultValue: void 0,
      children: "" + e._wrapperState.initialValue,
    });
  }
  function Ko(e, t) {
    var n = t.value;
    if (null == n) {
      if (((n = t.defaultValue), null != (t = t.children))) {
        if (null != n) throw Error(ho(92));
        if (Array.isArray(t)) {
          if (!(t.length <= 1)) throw Error(ho(93));
          t = t[0];
        }
        n = t;
      }
      null == n && (n = "");
    }
    e._wrapperState = { initialValue: Do(n) };
  }
  function Zo(e, t) {
    var n = Do(t.value),
      r = Do(t.defaultValue);
    null != n &&
      ((n = "" + n) !== e.value && (e.value = n),
      null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)),
      null != r && (e.defaultValue = "" + r);
  }
  function Qo(e) {
    var t = e.textContent;
    t === e._wrapperState.initialValue &&
      "" !== t &&
      null !== t &&
      (e.value = t);
  }
  function Jo(e) {
    switch (e) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function ea(e, t) {
    return null == e || "http://www.w3.org/1999/xhtml" === e
      ? Jo(t)
      : "http://www.w3.org/2000/svg" === e && "foreignObject" === t
      ? "http://www.w3.org/1999/xhtml"
      : e;
  }
  function ta(e, t) {
    if (t) {
      var n = e.firstChild;
      if (n && n === e.lastChild && 3 === n.nodeType)
        return (n.nodeValue = t), 0;
    }
    e.textContent = t;
  }
  function na(e, t) {
    var n = {};
    return (
      (n[e.toLowerCase()] = t.toLowerCase()),
      (n["Webkit" + e] = "webkit" + t),
      (n["Moz" + e] = "moz" + t),
      n
    );
  }
  function ra(e) {
    if (yt[e]) return yt[e];
    if (!vt[e]) return e;
    var t,
      n = vt[e];
    for (t in n) if (n.hasOwnProperty(t) && t in bt) return (yt[e] = n[t]);
    return e;
  }
  function ia(e) {
    var t = e,
      n = e;
    if (e.alternate) for (; t.return; ) t = t.return;
    else
      for (
        e = t;
        0 != (1026 & (t = e).effectTag) && (n = t.return), (e = t.return), e;

      );
    return 3 === t.tag ? n : null;
  }
  function oa(e) {
    if (13 === e.tag) {
      var t = e.memoizedState;
      if (
        (null === t && null !== (e = e.alternate) && (t = e.memoizedState),
        null !== t)
      )
        return t.dehydrated;
    }
    return null;
  }
  function aa(e) {
    if (ia(e) !== e) throw Error(ho(188));
  }
  function sa(e) {
    if (
      !(e = (function (e) {
        var t = e.alternate;
        if (!t) {
          if (null === (t = ia(e))) throw Error(ho(188));
          return t !== e ? null : e;
        }
        for (var n = e, r = t; ; ) {
          var i = n.return;
          if (null === i) break;
          var o = i.alternate;
          if (null !== o) {
            if (i.child === o.child) {
              for (o = i.child; o; ) {
                if (o === n) return aa(i), e;
                if (o === r) return aa(i), t;
                o = o.sibling;
              }
              throw Error(ho(188));
            }
            if (n.return !== r.return) (n = i), (r = o);
            else {
              for (var a = !1, s = i.child; s; ) {
                if (s === n) {
                  (a = !0), (n = i), (r = o);
                  break;
                }
                if (s === r) {
                  (a = !0), (r = i), (n = o);
                  break;
                }
                s = s.sibling;
              }
              if (!a) {
                for (s = o.child; s; ) {
                  if (s === n) {
                    (a = !0), (n = o), (r = i);
                    break;
                  }
                  if (s === r) {
                    (a = !0), (r = o), (n = i);
                    break;
                  }
                  s = s.sibling;
                }
                if (!a) throw Error(ho(189));
              }
            }
            if (n.alternate !== r) throw Error(ho(190));
          } else {
            if (null === (r = i.return)) break;
            n = r;
          }
        }
        if (3 !== n.tag) throw Error(ho(188));
        return n.stateNode.current === n ? e : t;
      })(e))
    )
      return null;
    for (var t = e; ; ) {
      if (5 === t.tag || 6 === t.tag) return t;
      if (t.child) t = (t.child.return = t).child;
      else {
        if (t === e) break;
        for (; !t.sibling; ) {
          if (!t.return || t.return === e) return null;
          t = t.return;
        }
        (t.sibling.return = t.return), (t = t.sibling);
      }
    }
    return null;
  }
  function la(e, t, n, r) {
    return {
      blockedOn: e,
      topLevelType: t,
      eventSystemFlags: 32 | n,
      nativeEvent: r,
    };
  }
  function ca(e, t) {
    switch (e) {
      case "focus":
      case "blur":
        Rt = null;
        break;
      case "dragenter":
      case "dragleave":
        Mt = null;
        break;
      case "mouseover":
      case "mouseout":
        Nt = null;
        break;
      case "pointerover":
      case "pointerout":
        Lt.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        It.delete(t.pointerId);
    }
  }
  function ua(e, t, n, r, i) {
    return (
      null === e || e.nativeEvent !== i
        ? ((e = la(t, n, r, i)), null !== t && null !== (t = rs(t)) && Tt(t))
        : (e.eventSystemFlags |= r),
      e
    );
  }
  function da(e) {
    if (null === e.blockedOn) {
      var t = Aa(e.topLevelType, e.eventSystemFlags, e.nativeEvent);
      if (null === t) return 1;
      var n = rs(t);
      return null !== n && Tt(n), (e.blockedOn = t), 0;
    }
  }
  function pa(e, t, n) {
    da(e) && n.delete(t);
  }
  function fa() {
    for (zt = !1; 0 < Ot.length; ) {
      var e = Ot[0];
      if (null !== e.blockedOn) {
        null !== (e = rs(e.blockedOn)) && kt(e);
        break;
      }
      var t = Aa(e.topLevelType, e.eventSystemFlags, e.nativeEvent);
      null !== t ? (e.blockedOn = t) : Ot.shift();
    }
    null !== Rt && da(Rt) && (Rt = null),
      null !== Mt && da(Mt) && (Mt = null),
      null !== Nt && da(Nt) && (Nt = null),
      Lt.forEach(pa),
      It.forEach(pa);
  }
  function ha(e, t) {
    e.blockedOn === t &&
      ((e.blockedOn = null),
      zt ||
        ((zt = !0),
        Se.unstable_scheduleCallback(Se.unstable_NormalPriority, fa)));
  }
  function ma(t) {
    function e(e) {
      return ha(e, t);
    }
    if (0 < Ot.length) {
      ha(Ot[0], t);
      for (var n = 1; n < Ot.length; n++) {
        var r = Ot[n];
        r.blockedOn === t && (r.blockedOn = null);
      }
    }
    for (
      null !== Rt && ha(Rt, t),
        null !== Mt && ha(Mt, t),
        null !== Nt && ha(Nt, t),
        Lt.forEach(e),
        It.forEach(e),
        n = 0;
      n < _t.length;
      n++
    )
      (r = _t[n]).blockedOn === t && (r.blockedOn = null);
    for (; 0 < _t.length && null === (n = _t[0]).blockedOn; )
      (function (e) {
        var t = ns(e.target);
        if (null !== t) {
          var n = ia(t);
          if (null !== n)
            if (13 === (t = n.tag)) {
              if (null !== (t = oa(n)))
                return (
                  (e.blockedOn = t),
                  Se.unstable_runWithPriority(e.priority, function () {
                    Pt(n);
                  })
                );
            } else if (3 === t && n.stateNode.hydrate)
              return (e.blockedOn =
                3 === n.tag ? n.stateNode.containerInfo : null);
        }
        e.blockedOn = null;
      })(n),
        null === n.blockedOn && _t.shift();
  }
  function ga(e) {
    return (
      (e = e.target || e.srcElement || window).correspondingUseElement &&
        (e = e.correspondingUseElement),
      3 === e.nodeType ? e.parentNode : e
    );
  }
  function va(e) {
    for (; (e = e.return), e && 5 !== e.tag; );
    return e || null;
  }
  function ya(e, t, n) {
    (t = So(e, n.dispatchConfig.phasedRegistrationNames[t])) &&
      ((n._dispatchListeners = bo(n._dispatchListeners, t)),
      (n._dispatchInstances = bo(n._dispatchInstances, e)));
  }
  function ba(e) {
    if (e && e.dispatchConfig.phasedRegistrationNames) {
      for (var t = e._targetInst, n = []; t; ) n.push(t), (t = va(t));
      for (t = n.length; 0 < t--; ) ya(n[t], "captured", e);
      for (t = 0; t < n.length; t++) ya(n[t], "bubbled", e);
    }
  }
  function wa(e, t, n) {
    e &&
      n &&
      n.dispatchConfig.registrationName &&
      (t = So(e, n.dispatchConfig.registrationName)) &&
      ((n._dispatchListeners = bo(n._dispatchListeners, t)),
      (n._dispatchInstances = bo(n._dispatchInstances, e)));
  }
  function xa(e) {
    e && e.dispatchConfig.registrationName && wa(e._targetInst, null, e);
  }
  function Ea(e) {
    wo(e, ba);
  }
  function Sa() {
    return !0;
  }
  function Ca() {
    return !1;
  }
  function ka(e, t, n, r) {
    for (var i in ((this.dispatchConfig = e),
    (this._targetInst = t),
    (this.nativeEvent = n),
    (e = this.constructor.Interface)))
      e.hasOwnProperty(i) &&
        ((t = e[i])
          ? (this[i] = t(n))
          : "target" === i
          ? (this.target = r)
          : (this[i] = n[i]));
    return (
      (this.isDefaultPrevented = (
        null != n.defaultPrevented ? n.defaultPrevented : !1 === n.returnValue
      )
        ? Sa
        : Ca),
      (this.isPropagationStopped = Ca),
      this
    );
  }
  function Ta(e, t, n, r) {
    if (this.eventPool.length) {
      var i = this.eventPool.pop();
      return this.call(i, e, t, n, r), i;
    }
    return new this(e, t, n, r);
  }
  function Pa(e) {
    if (!(e instanceof this)) throw Error(ho(279));
    e.destructor(), this.eventPool.length < 10 && this.eventPool.push(e);
  }
  function za(e) {
    (e.eventPool = []), (e.getPooled = Ta), (e.release = Pa);
  }
  function Oa(e) {
    var t = e.keyCode;
    return (
      "charCode" in e
        ? 0 === (e = e.charCode) && 13 === t && (e = 13)
        : (e = t),
      10 === e && (e = 13),
      32 <= e || 13 === e ? e : 0
    );
  }
  function Ra(e) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(e) : !!(e = Vt[e]) && !!t[e];
  }
  function Ma() {
    return Ra;
  }
  function Na(e) {
    var t = e.targetInst,
      n = t;
    do {
      if (!n) {
        e.ancestors.push(n);
        break;
      }
      var r = n;
      if (3 === r.tag) r = r.stateNode.containerInfo;
      else {
        for (; r.return; ) r = r.return;
        r = 3 !== r.tag ? null : r.stateNode.containerInfo;
      }
    } while (
      r &&
      ((5 !== (t = n.tag) && 6 !== t) || e.ancestors.push(n), (n = ns(r)))
    );
    for (n = 0; n < e.ancestors.length; n++) {
      t = e.ancestors[n];
      for (
        var i = ga(e.nativeEvent),
          r = e.topLevelType,
          o = e.nativeEvent,
          a = e.eventSystemFlags,
          s = null,
          l = 0;
        l < Te.length;
        l++
      ) {
        var c = Te[l];
        (c = c && c.extractEvents(r, t, o, i, a)) && (s = bo(s, c));
      }
      Eo(s);
    }
  }
  function La(e, t) {
    Ia(t, e, !1);
  }
  function Ia(e, t, n) {
    switch (un(t)) {
      case 0:
        var r = function (e, t, n) {
          at || No();
          var r = Da,
            i = at;
          at = !0;
          try {
            Mo(r, e, t, n);
          } finally {
            (at = i) || Lo();
          }
        }.bind(null, t, 1);
        break;
      case 1:
        r = function (e, t, n) {
          cn(ln, Da.bind(null, e, t, n));
        }.bind(null, t, 1);
        break;
      default:
        r = Da.bind(null, t, 1);
    }
    n ? e.addEventListener(t, r, !0) : e.addEventListener(t, r, !1);
  }
  function _a(e, t, n, r) {
    var i;
    e = pn.length
      ? (((i = pn.pop()).topLevelType = e),
        (i.eventSystemFlags = t),
        (i.nativeEvent = n),
        (i.targetInst = r),
        i)
      : {
          topLevelType: e,
          eventSystemFlags: t,
          nativeEvent: n,
          targetInst: r,
          ancestors: [],
        };
    try {
      if (((t = Na), (n = e), st)) t(n, void 0);
      else {
        st = !0;
        try {
          ot(t, n, void 0);
        } finally {
          (st = !1), Lo();
        }
      }
    } finally {
      (e.topLevelType = null),
        (e.nativeEvent = null),
        (e.targetInst = null),
        (e.ancestors.length = 0),
        pn.length < dn && pn.push(e);
    }
  }
  function Da(e, t, n) {
    var r;
    fn &&
      (0 < Ot.length && -1 < Dt.indexOf(e)
        ? ((e = la(null, e, t, n)), Ot.push(e))
        : null === (r = Aa(e, t, n))
        ? ca(e, n)
        : -1 < Dt.indexOf(e)
        ? ((e = la(r, e, t, n)), Ot.push(e))
        : (function (e, t, n, r) {
            switch (t) {
              case "focus":
                return (Rt = ua(Rt, e, t, n, r)), 1;
              case "dragenter":
                return (Mt = ua(Mt, e, t, n, r)), 1;
              case "mouseover":
                return (Nt = ua(Nt, e, t, n, r)), 1;
              case "pointerover":
                var i = r.pointerId;
                return Lt.set(i, ua(Lt.get(i) || null, e, t, n, r)), 1;
              case "gotpointercapture":
                return (
                  (i = r.pointerId),
                  It.set(i, ua(It.get(i) || null, e, t, n, r)),
                  1
                );
            }
          })(r, e, t, n) || (ca(e, n), _a(e, t, n, null)));
  }
  function Aa(e, t, n) {
    var r = ga(n);
    if (null !== (r = ns(r))) {
      var i = ia(r);
      if (null === i) r = null;
      else {
        var o = i.tag;
        if (13 === o) {
          if (null !== (r = oa(i))) return r;
          r = null;
        } else if (3 === o) {
          if (i.stateNode.hydrate)
            return 3 === i.tag ? i.stateNode.containerInfo : null;
          r = null;
        } else i !== r && (r = null);
      }
    }
    return _a(e, t, n, r), null;
  }
  function Fa(e) {
    if (!tt) return !1;
    var t = (e = "on" + e) in document;
    return (
      t ||
        ((t = document.createElement("div")).setAttribute(e, "return;"),
        (t = "function" == typeof t[e])),
      t
    );
  }
  function Ba(e) {
    var t = hn.get(e);
    return void 0 === t && ((t = new Set()), hn.set(e, t)), t;
  }
  function Wa(e, t, n) {
    if (!n.has(e)) {
      switch (e) {
        case "scroll":
          Ia(t, "scroll", !0);
          break;
        case "focus":
        case "blur":
          Ia(t, "focus", !0), Ia(t, "blur", !0), n.add("blur"), n.add("focus");
          break;
        case "cancel":
        case "close":
          Fa(e) && Ia(t, e, !0);
          break;
        case "invalid":
        case "submit":
        case "reset":
          break;
        default:
          -1 === Ct.indexOf(e) && La(e, t);
      }
      n.add(e);
    }
  }
  function $a(e, t, n) {
    return null == t || "boolean" == typeof t || "" === t
      ? ""
      : n || "number" != typeof t || 0 === t || (mn.hasOwnProperty(e) && mn[e])
      ? ("" + t).trim()
      : t + "px";
  }
  function ja(e, t) {
    for (var n in ((e = e.style), t)) {
      var r, i;
      t.hasOwnProperty(n) &&
        ((r = 0 === n.indexOf("--")),
        (i = $a(n, t[n], r)),
        "float" === n && (n = "cssFloat"),
        r ? e.setProperty(n, i) : (e[n] = i));
    }
  }
  function Ha(e, t) {
    if (t) {
      if (vn[e] && (null != t.children || null != t.dangerouslySetInnerHTML))
        throw Error(ho(137, e, ""));
      if (null != t.dangerouslySetInnerHTML) {
        if (null != t.children) throw Error(ho(60));
        if (
          !(
            "object" == typeof t.dangerouslySetInnerHTML &&
            "__html" in t.dangerouslySetInnerHTML
          )
        )
          throw Error(ho(61));
      }
      if (null != t.style && "object" != typeof t.style)
        throw Error(ho(62, ""));
    }
  }
  function Va(e, t) {
    if (-1 === e.indexOf("-")) return "string" == typeof t.is;
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  function qa(e, t) {
    var n = Ba(
      (e = 9 === e.nodeType || 11 === e.nodeType ? e : e.ownerDocument)
    );
    t = Oe[t];
    for (var r = 0; r < t.length; r++) Wa(t[r], e, n);
  }
  function Ua() {}
  function Ga(t) {
    if (
      void 0 === (t = t || ("undefined" != typeof document ? document : void 0))
    )
      return null;
    try {
      return t.activeElement || t.body;
    } catch (e) {
      return t.body;
    }
  }
  function Ya(e) {
    for (; e && e.firstChild; ) e = e.firstChild;
    return e;
  }
  function Xa(e, t) {
    var n,
      r = Ya(e);
    for (e = 0; r; ) {
      if (3 === r.nodeType) {
        if (((n = e + r.textContent.length), e <= t && t <= n))
          return { node: r, offset: t - e };
        e = n;
      }
      e: {
        for (; r; ) {
          if (r.nextSibling) {
            r = r.nextSibling;
            break e;
          }
          r = r.parentNode;
        }
        r = void 0;
      }
      r = Ya(r);
    }
  }
  function Ka() {
    for (var e = window, t = Ga(); t instanceof e.HTMLIFrameElement; ) {
      try {
        var n = "string" == typeof t.contentWindow.location.href;
      } catch (e) {
        n = !1;
      }
      if (!n) break;
      t = Ga((e = t.contentWindow).document);
    }
    return t;
  }
  function Za(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return (
      t &&
      (("input" === t &&
        ("text" === e.type ||
          "search" === e.type ||
          "tel" === e.type ||
          "url" === e.type ||
          "password" === e.type)) ||
        "textarea" === t ||
        "true" === e.contentEditable)
    );
  }
  function Qa(e, t) {
    switch (e) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        return !!t.autoFocus;
    }
    return !1;
  }
  function Ja(e, t) {
    return (
      "textarea" === e ||
      "option" === e ||
      "noscript" === e ||
      "string" == typeof t.children ||
      "number" == typeof t.children ||
      ("object" == typeof t.dangerouslySetInnerHTML &&
        null !== t.dangerouslySetInnerHTML &&
        null != t.dangerouslySetInnerHTML.__html)
    );
  }
  function es(e) {
    for (; null != e; e = e.nextSibling) {
      var t = e.nodeType;
      if (1 === t || 3 === t) break;
    }
    return e;
  }
  function ts(e) {
    e = e.previousSibling;
    for (var t = 0; e; ) {
      if (8 === e.nodeType) {
        var n = e.data;
        if (n === yn || n === xn || n === wn) {
          if (0 === t) return e;
          t--;
        } else n === bn && t++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  function ns(e) {
    var t = e[Tn];
    if (t) return t;
    for (var n = e.parentNode; n; ) {
      if ((t = n[zn] || n[Tn])) {
        if (
          ((n = t.alternate),
          null !== t.child || (null !== n && null !== n.child))
        )
          for (e = ts(e); null !== e; ) {
            if ((n = e[Tn])) return n;
            e = ts(e);
          }
        return t;
      }
      n = (e = n).parentNode;
    }
    return null;
  }
  function rs(e) {
    return !(e = e[Tn] || e[zn]) ||
      (5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag)
      ? null
      : e;
  }
  function is(e) {
    if (5 === e.tag || 6 === e.tag) return e.stateNode;
    throw Error(ho(33));
  }
  function os(e) {
    return e[Pn] || null;
  }
  function as() {
    if (Mn) return Mn;
    for (
      var e = Rn,
        t = e.length,
        n = ("value" in On) ? On.value : On.textContent,
        r = n.length,
        i = 0;
      i < t && e[i] === n[i];
      i++
    );
    for (var o = t - i, a = 1; a <= o && e[t - a] === n[r - a]; a++);
    return (Mn = n.slice(i, 1 < a ? 1 - a : void 0));
  }
  function ss(e, t) {
    switch (e) {
      case "keyup":
        return -1 !== In.indexOf(t.keyCode);
      case "keydown":
        return 229 !== t.keyCode;
      case "keypress":
      case "mousedown":
      case "blur":
        return 1;
      default:
        return;
    }
  }
  function ls(e) {
    return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
  }
  function cs(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return "input" === t ? jn[e.type] : "textarea" === t;
  }
  function us(e, t, n) {
    return (
      ((e = ka.getPooled(Hn.change, e, t, n)).type = "change"), zo(n), Ea(e), e
    );
  }
  function ds(e) {
    Eo(e);
  }
  function ps(e) {
    if (Wo(is(e))) return e;
  }
  function fs(e, t) {
    if ("change" === e) return t;
  }
  function hs() {
    Vn && (Vn.detachEvent("onpropertychange", ms), (qn = Vn = null));
  }
  function ms(e) {
    if ("value" === e.propertyName && ps(qn))
      if (((e = us(qn, e, ga(e))), at)) Eo(e);
      else {
        at = !0;
        try {
          Ro(ds, e);
        } finally {
          (at = !1), Lo();
        }
      }
  }
  function gs(e, t, n) {
    "focus" === e
      ? (hs(), (qn = n), (Vn = t).attachEvent("onpropertychange", ms))
      : "blur" === e && hs();
  }
  function vs(e) {
    if ("selectionchange" === e || "keyup" === e || "keydown" === e)
      return ps(qn);
  }
  function ys(e, t) {
    if ("click" === e) return ps(t);
  }
  function bs(e, t) {
    if ("input" === e || "change" === e) return ps(t);
  }
  function ws(e, t) {
    return (e === t && (0 !== e || 1 / e == 1 / t)) || (e != e && t != t);
  }
  function xs(e, t) {
    if (Zn(e, t)) return !0;
    if (
      "object" != typeof e ||
      null === e ||
      "object" != typeof t ||
      null === t
    )
      return !1;
    var n = Object.keys(e),
      r = Object.keys(t);
    if (n.length !== r.length) return !1;
    for (r = 0; r < n.length; r++)
      if (!Qn.call(t, n[r]) || !Zn(e[n[r]], t[n[r]])) return !1;
    return !0;
  }
  function Es(e, t) {
    var n =
      t.window === t ? t.document : 9 === t.nodeType ? t : t.ownerDocument;
    return ir || null == tr || tr !== Ga(n)
      ? null
      : ((n =
          "selectionStart" in (n = tr) && Za(n)
            ? { start: n.selectionStart, end: n.selectionEnd }
            : {
                anchorNode: (n = (
                  (n.ownerDocument && n.ownerDocument.defaultView) ||
                  window
                ).getSelection()).anchorNode,
                anchorOffset: n.anchorOffset,
                focusNode: n.focusNode,
                focusOffset: n.focusOffset,
              }),
        rr && xs(rr, n)
          ? null
          : ((rr = n),
            ((e = ka.getPooled(er.select, nr, e, t)).type = "select"),
            (e.target = tr),
            Ea(e),
            e));
  }
  function Ss(e) {
    sr < 0 || ((e.current = ar[sr]), (ar[sr] = null), sr--);
  }
  function Cs(e, t) {
    (ar[++sr] = e.current), (e.current = t);
  }
  function ks(e, t) {
    var n = e.type.contextTypes;
    if (!n) return lr;
    var r = e.stateNode;
    if (r && r.__reactInternalMemoizedUnmaskedChildContext === t)
      return r.__reactInternalMemoizedMaskedChildContext;
    var i,
      o = {};
    for (i in n) o[i] = t[i];
    return (
      r &&
        (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t),
        (e.__reactInternalMemoizedMaskedChildContext = o)),
      o
    );
  }
  function Ts(e) {
    return null != e.childContextTypes;
  }
  function Ps() {
    Ss(ur), Ss(cr);
  }
  function zs() {
    Ss(ur), Ss(cr);
  }
  function Os(e, t, n) {
    if (cr.current !== lr) throw Error(ho(168));
    Cs(cr, t), Cs(ur, n);
  }
  function Rs(e, t, n) {
    var r,
      i = e.stateNode;
    if (((e = t.childContextTypes), "function" != typeof i.getChildContext))
      return n;
    for (r in (i = i.getChildContext()))
      if (!(r in e)) throw Error(ho(108, ko(t) || "Unknown", r));
    return Ee({}, n, {}, i);
  }
  function Ms(e) {
    e =
      ((e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext) || lr;
    return (dr = cr.current), Cs(cr, e), Cs(ur, ur.current), 1;
  }
  function Ns(e, t, n) {
    var r = e.stateNode;
    if (!r) throw Error(ho(169));
    n
      ? ((t = Rs(e, t, dr)),
        (r.__reactInternalMemoizedMergedChildContext = t),
        Ss(ur),
        Ss(cr),
        Cs(cr, t))
      : Ss(ur),
      Cs(ur, n);
  }
  function Ls() {
    switch (yr()) {
      case br:
        return 99;
      case wr:
        return 98;
      case xr:
        return 97;
      case Er:
        return 96;
      case Sr:
        return 95;
      default:
        throw Error(ho(332));
    }
  }
  function Is(e) {
    switch (e) {
      case 99:
        return br;
      case 98:
        return wr;
      case 97:
        return xr;
      case 96:
        return Er;
      case 95:
        return Sr;
      default:
        throw Error(ho(332));
    }
  }
  function _s(e, t) {
    return (e = Is(e)), pr(e, t);
  }
  function Ds(e, t, n) {
    return (e = Is(e)), fr(e, t, n);
  }
  function As(e) {
    return null === Tr ? ((Tr = [e]), (Pr = fr(br, Bs))) : Tr.push(e), Cr;
  }
  function Fs() {
    var e;
    null !== Pr && ((e = Pr), (Pr = null), hr(e)), Bs();
  }
  function Bs() {
    if (!zr && null !== Tr) {
      zr = !0;
      var t = 0;
      try {
        var n = Tr;
        _s(99, function () {
          for (; t < n.length; t++)
            for (var e = n[t]; (e = e(!0)), null !== e; );
        }),
          (Tr = null);
      } catch (n) {
        throw (null !== Tr && (Tr = Tr.slice(t + 1)), fr(br, Fs), n);
      } finally {
        zr = !1;
      }
    }
  }
  function Ws(e, t, n) {
    return 1073741821 - (1 + (((1073741821 - e + t / 10) / (n /= 10)) | 0)) * n;
  }
  function $s(e, t) {
    if (e && e.defaultProps)
      for (var n in ((t = Ee({}, t)), (e = e.defaultProps)))
        void 0 === t[n] && (t[n] = e[n]);
    return t;
  }
  function js() {
    _r = Ir = Lr = null;
  }
  function Hs(e, t) {
    e = e.type._context;
    Cs(Nr, e._currentValue), (e._currentValue = t);
  }
  function Vs(e) {
    var t = Nr.current;
    Ss(Nr), (e.type._context._currentValue = t);
  }
  function qs(e, t) {
    for (; null !== e; ) {
      var n = e.alternate;
      if (e.childExpirationTime < t)
        (e.childExpirationTime = t),
          null !== n &&
            n.childExpirationTime < t &&
            (n.childExpirationTime = t);
      else {
        if (!(null !== n && n.childExpirationTime < t)) break;
        n.childExpirationTime = t;
      }
      e = e.return;
    }
  }
  function Us(e, t) {
    (_r = Ir = null) !== (e = (Lr = e).dependencies) &&
      null !== e.firstContext &&
      (e.expirationTime >= t && (gi = !0), (e.firstContext = null));
  }
  function Gs(e, t) {
    if (_r !== e && !1 !== t && 0 !== t)
      if (
        (("number" == typeof t && 1073741823 !== t) ||
          ((_r = e), (t = 1073741823)),
        (t = { context: e, observedBits: t, next: null }),
        null === Ir)
      ) {
        if (null === Lr) throw Error(ho(308));
        (Ir = t),
          (Lr.dependencies = {
            expirationTime: 0,
            firstContext: t,
            responders: null,
          });
      } else Ir = Ir.next = t;
    return e._currentValue;
  }
  function Ys(e) {
    return {
      baseState: e,
      firstUpdate: null,
      lastUpdate: null,
      firstCapturedUpdate: null,
      lastCapturedUpdate: null,
      firstEffect: null,
      lastEffect: null,
      firstCapturedEffect: null,
      lastCapturedEffect: null,
    };
  }
  function Xs(e) {
    return {
      baseState: e.baseState,
      firstUpdate: e.firstUpdate,
      lastUpdate: e.lastUpdate,
      firstCapturedUpdate: null,
      lastCapturedUpdate: null,
      firstEffect: null,
      lastEffect: null,
      firstCapturedEffect: null,
      lastCapturedEffect: null,
    };
  }
  function Ks(e, t) {
    return {
      expirationTime: e,
      suspenseConfig: t,
      tag: 0,
      payload: null,
      callback: null,
      next: null,
      nextEffect: null,
    };
  }
  function Zs(e, t) {
    null === e.lastUpdate
      ? (e.firstUpdate = e.lastUpdate = t)
      : ((e.lastUpdate.next = t), (e.lastUpdate = t));
  }
  function Qs(e, t) {
    var n,
      r,
      i = e.alternate;
    null === i
      ? (r = null) === (n = e.updateQueue) &&
        (n = e.updateQueue = Ys(e.memoizedState))
      : ((n = e.updateQueue),
        (r = i.updateQueue),
        null === n
          ? null === r
            ? ((n = e.updateQueue = Ys(e.memoizedState)),
              (r = i.updateQueue = Ys(i.memoizedState)))
            : (n = e.updateQueue = Xs(r))
          : null === r && (r = i.updateQueue = Xs(n))),
      null === r || n === r
        ? Zs(n, t)
        : null === n.lastUpdate || null === r.lastUpdate
        ? (Zs(n, t), Zs(r, t))
        : (Zs(n, t), (r.lastUpdate = t));
  }
  function Js(e, t) {
    var n = e.updateQueue;
    null ===
    (n = null === n ? (e.updateQueue = Ys(e.memoizedState)) : el(e, n))
      .lastCapturedUpdate
      ? (n.firstCapturedUpdate = n.lastCapturedUpdate = t)
      : ((n.lastCapturedUpdate.next = t), (n.lastCapturedUpdate = t));
  }
  function el(e, t) {
    var n = e.alternate;
    return null !== n && t === n.updateQueue && (t = e.updateQueue = Xs(t)), t;
  }
  function tl(e, t, n, r, i, o) {
    switch (n.tag) {
      case 1:
        return "function" == typeof (e = n.payload) ? e.call(o, r, i) : e;
      case 3:
        e.effectTag = (-4097 & e.effectTag) | 64;
      case 0:
        if (
          null ==
          (i = "function" == typeof (e = n.payload) ? e.call(o, r, i) : e)
        )
          break;
        return Ee({}, r, i);
      case 2:
        Dr = !0;
    }
    return r;
  }
  function nl(e, t, n, r, i) {
    Dr = !1;
    for (
      var o = (t = el(e, t)).baseState,
        a = null,
        s = 0,
        l = t.firstUpdate,
        c = o;
      null !== l;

    ) {
      var u = l.expirationTime;
      u < i
        ? (null === a && ((a = l), (o = c)), s < u && (s = u))
        : (Lc(u, l.suspenseConfig),
          (c = tl(e, 0, l, c, n, r)),
          null !== l.callback &&
            ((e.effectTag |= 32),
            (l.nextEffect = null) === t.lastEffect
              ? (t.firstEffect = t.lastEffect = l)
              : ((t.lastEffect.nextEffect = l), (t.lastEffect = l)))),
        (l = l.next);
    }
    for (u = null, l = t.firstCapturedUpdate; null !== l; ) {
      var d = l.expirationTime;
      d < i
        ? (null === u && ((u = l), null === a && (o = c)), s < d && (s = d))
        : ((c = tl(e, 0, l, c, n, r)),
          null !== l.callback &&
            ((e.effectTag |= 32),
            (l.nextEffect = null) === t.lastCapturedEffect
              ? (t.firstCapturedEffect = t.lastCapturedEffect = l)
              : ((t.lastCapturedEffect.nextEffect = l),
                (t.lastCapturedEffect = l)))),
        (l = l.next);
    }
    null === a && (t.lastUpdate = null),
      null === u ? (t.lastCapturedUpdate = null) : (e.effectTag |= 32),
      null === a && null === u && (o = c),
      (t.baseState = o),
      (t.firstUpdate = a),
      (t.firstCapturedUpdate = u),
      Ic(s),
      (e.expirationTime = s),
      (e.memoizedState = c);
  }
  function rl(e, t, n) {
    null !== t.firstCapturedUpdate &&
      (null !== t.lastUpdate &&
        ((t.lastUpdate.next = t.firstCapturedUpdate),
        (t.lastUpdate = t.lastCapturedUpdate)),
      (t.firstCapturedUpdate = t.lastCapturedUpdate = null)),
      il(t.firstEffect, n),
      (t.firstEffect = t.lastEffect = null),
      il(t.firstCapturedEffect, n),
      (t.firstCapturedEffect = t.lastCapturedEffect = null);
  }
  function il(e, t) {
    for (; null !== e; ) {
      var n = e.callback;
      if (null !== n) {
        e.callback = null;
        var r = t;
        if ("function" != typeof n) throw Error(ho(191, n));
        n.call(r);
      }
      e = e.nextEffect;
    }
  }
  function ol(e, t, n, r) {
    (n = null == (n = n(r, (t = e.memoizedState))) ? t : Ee({}, t, n)),
      (e.memoizedState = n),
      null !== (r = e.updateQueue) &&
        0 === e.expirationTime &&
        (r.baseState = n);
  }
  function al(e, t, n, r, i, o, a) {
    return "function" == typeof (e = e.stateNode).shouldComponentUpdate
      ? e.shouldComponentUpdate(r, o, a)
      : !(
          t.prototype &&
          t.prototype.isPureReactComponent &&
          xs(n, r) &&
          xs(i, o)
        );
  }
  function sl(e, t, n) {
    var r = !1,
      i = lr,
      o = t.contextType;
    return (
      (t = new t(
        n,
        (o =
          "object" == typeof o && null !== o
            ? Gs(o)
            : ((i = Ts(t) ? dr : cr.current),
              (r = null != t.contextTypes) ? ks(e, i) : lr))
      )),
      (e.memoizedState =
        null !== t.state && void 0 !== t.state ? t.state : null),
      (t.updater = Br),
      ((e.stateNode = t)._reactInternalFiber = e),
      r &&
        (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = i),
        (e.__reactInternalMemoizedMaskedChildContext = o)),
      t
    );
  }
  function ll(e, t, n, r) {
    (e = t.state),
      "function" == typeof t.componentWillReceiveProps &&
        t.componentWillReceiveProps(n, r),
      "function" == typeof t.UNSAFE_componentWillReceiveProps &&
        t.UNSAFE_componentWillReceiveProps(n, r),
      t.state !== e && Br.enqueueReplaceState(t, t.state, null);
  }
  function cl(e, t, n, r) {
    var i = e.stateNode;
    (i.props = n), (i.state = e.memoizedState), (i.refs = Fr);
    var o = t.contextType;
    "object" == typeof o && null !== o
      ? (i.context = Gs(o))
      : ((o = Ts(t) ? dr : cr.current), (i.context = ks(e, o))),
      null !== (o = e.updateQueue) &&
        (nl(e, o, n, i, r), (i.state = e.memoizedState)),
      "function" == typeof (o = t.getDerivedStateFromProps) &&
        (ol(e, 0, o, n), (i.state = e.memoizedState)),
      "function" == typeof t.getDerivedStateFromProps ||
        "function" == typeof i.getSnapshotBeforeUpdate ||
        ("function" != typeof i.UNSAFE_componentWillMount &&
          "function" != typeof i.componentWillMount) ||
        ((t = i.state),
        "function" == typeof i.componentWillMount && i.componentWillMount(),
        "function" == typeof i.UNSAFE_componentWillMount &&
          i.UNSAFE_componentWillMount(),
        t !== i.state && Br.enqueueReplaceState(i, i.state, null),
        null !== (o = e.updateQueue) &&
          (nl(e, o, n, i, r), (i.state = e.memoizedState))),
      "function" == typeof i.componentDidMount && (e.effectTag |= 4);
  }
  function ul(e, t, n) {
    if (
      null !== (e = n.ref) &&
      "function" != typeof e &&
      "object" != typeof e
    ) {
      if (n._owner) {
        if ((n = n._owner)) {
          if (1 !== n.tag) throw Error(ho(309));
          var r = n.stateNode;
        }
        if (!r) throw Error(ho(147, e));
        var i = "" + e;
        return null !== t &&
          null !== t.ref &&
          "function" == typeof t.ref &&
          t.ref._stringRef === i
          ? t.ref
          : (((t = function (e) {
              var t = r.refs;
              t === Fr && (t = r.refs = {}),
                null === e ? delete t[i] : (t[i] = e);
            })._stringRef = i),
            t);
      }
      if ("string" != typeof e) throw Error(ho(284));
      if (!n._owner) throw Error(ho(290, e));
    }
    return e;
  }
  function dl(e, t) {
    if ("textarea" !== e.type)
      throw Error(
        ho(
          31,
          "[object Object]" === Object.prototype.toString.call(t)
            ? "object with keys {" + Object.keys(t).join(", ") + "}"
            : t,
          ""
        )
      );
  }
  function pl(d) {
    function p(e, t) {
      var n;
      d &&
        (null !== (n = e.lastEffect)
          ? ((n.nextEffect = t), (e.lastEffect = t))
          : (e.firstEffect = e.lastEffect = t),
        (t.nextEffect = null),
        (t.effectTag = 8));
    }
    function f(e, t) {
      if (!d) return null;
      for (; null !== t; ) p(e, t), (t = t.sibling);
      return null;
    }
    function h(e, t) {
      for (e = new Map(); null !== t; )
        null !== t.key ? e.set(t.key, t) : e.set(t.index, t), (t = t.sibling);
      return e;
    }
    function a(e, t) {
      return ((e = Gc(e, t)).index = 0), (e.sibling = null), e;
    }
    function m(e, t, n) {
      return (
        (e.index = n),
        d
          ? null === (n = e.alternate) || (n = n.index) < t
            ? ((e.effectTag = 2), t)
            : n
          : t
      );
    }
    function s(e) {
      return d && null === e.alternate && (e.effectTag = 2), e;
    }
    function o(e, t, n, r) {
      return (
        null === t || 6 !== t.tag
          ? ((t = Kc(n, e.mode, r)).return = e)
          : ((t = a(t, n)).return = e),
        t
      );
    }
    function l(e, t, n, r) {
      return (
        null !== t && t.elementType === n.type
          ? ((r = a(t, n.props)).ref = ul(0, t, n))
          : ((r = Yc(n.type, n.key, n.props, null, e.mode, r)).ref = ul(
              0,
              t,
              n
            )),
        (r.return = e),
        r
      );
    }
    function c(e, t, n, r) {
      return (
        null === t ||
        4 !== t.tag ||
        t.stateNode.containerInfo !== n.containerInfo ||
        t.stateNode.implementation !== n.implementation
          ? ((t = Zc(n, e.mode, r)).return = e)
          : ((t = a(t, n.children || [])).return = e),
        t
      );
    }
    function u(e, t, n, r, i) {
      return (
        null === t || 7 !== t.tag
          ? ((t = Xc(n, e.mode, r, i)).return = e)
          : ((t = a(t, n)).return = e),
        t
      );
    }
    function g(e, t, n) {
      if ("string" == typeof t || "number" == typeof t)
        return ((t = Kc("" + t, e.mode, n)).return = e), t;
      if ("object" == typeof t && null !== t) {
        switch (t.$$typeof) {
          case $e:
            return (
              ((n = Yc(t.type, t.key, t.props, null, e.mode, n)).ref = ul(
                0,
                null,
                t
              )),
              (n.return = e),
              n
            );
          case je:
            return ((t = Zc(t, e.mode, n)).return = e), t;
        }
        if (Wr(t) || Co(t)) return ((t = Xc(t, e.mode, n, null)).return = e), t;
        dl(e, t);
      }
      return null;
    }
    function v(e, t, n, r) {
      var i = null !== t ? t.key : null;
      if ("string" == typeof n || "number" == typeof n)
        return null !== i ? null : o(e, t, "" + n, r);
      if ("object" == typeof n && null !== n) {
        switch (n.$$typeof) {
          case $e:
            return n.key === i
              ? n.type === He
                ? u(e, t, n.props.children, r, i)
                : l(e, t, n, r)
              : null;
          case je:
            return n.key === i ? c(e, t, n, r) : null;
        }
        if (Wr(n) || Co(n)) return null !== i ? null : u(e, t, n, r, null);
        dl(e, n);
      }
      return null;
    }
    function y(e, t, n, r, i) {
      if ("string" == typeof r || "number" == typeof r)
        return o(t, (e = e.get(n) || null), "" + r, i);
      if ("object" == typeof r && null !== r) {
        switch (r.$$typeof) {
          case $e:
            return (
              (e = e.get(null === r.key ? n : r.key) || null),
              r.type === He
                ? u(t, e, r.props.children, i, r.key)
                : l(t, e, r, i)
            );
          case je:
            return c(t, (e = e.get(null === r.key ? n : r.key) || null), r, i);
        }
        if (Wr(r) || Co(r)) return u(t, (e = e.get(n) || null), r, i, null);
        dl(t, r);
      }
      return null;
    }
    return function (e, t, n, r) {
      var i =
        "object" == typeof n && null !== n && n.type === He && null === n.key;
      i && (n = n.props.children);
      var o = "object" == typeof n && null !== n;
      if (o)
        switch (n.$$typeof) {
          case $e:
            e: {
              for (o = n.key, i = t; null !== i; ) {
                if (i.key === o) {
                  if (7 === i.tag ? n.type === He : i.elementType === n.type) {
                    f(e, i.sibling),
                      ((t = a(
                        i,
                        n.type === He ? n.props.children : n.props
                      )).ref = ul(0, i, n)),
                      (t.return = e),
                      (e = t);
                    break e;
                  }
                  f(e, i);
                  break;
                }
                p(e, i), (i = i.sibling);
              }
              e =
                n.type === He
                  ? (((t = Xc(n.props.children, e.mode, r, n.key)).return = e),
                    t)
                  : (((r = Yc(
                      n.type,
                      n.key,
                      n.props,
                      null,
                      e.mode,
                      r
                    )).ref = ul(0, t, n)),
                    (r.return = e),
                    r);
            }
            return s(e);
          case je:
            e: {
              for (i = n.key; null !== t; ) {
                if (t.key === i) {
                  if (
                    4 === t.tag &&
                    t.stateNode.containerInfo === n.containerInfo &&
                    t.stateNode.implementation === n.implementation
                  ) {
                    f(e, t.sibling),
                      ((t = a(t, n.children || [])).return = e),
                      (e = t);
                    break e;
                  }
                  f(e, t);
                  break;
                }
                p(e, t), (t = t.sibling);
              }
              ((t = Zc(n, e.mode, r)).return = e), (e = t);
            }
            return s(e);
        }
      if ("string" == typeof n || "number" == typeof n)
        return (
          (n = "" + n),
          s(
            (e =
              (null !== t && 6 === t.tag
                ? (f(e, t.sibling), ((t = a(t, n)).return = e))
                : (f(e, t), ((t = Kc(n, e.mode, r)).return = e)),
              t))
          )
        );
      if (Wr(n))
        return (function (t, e, n, r) {
          for (
            var i = null, o = null, a = e, s = (e = 0), l = null;
            null !== a && s < n.length;
            s++
          ) {
            a.index > s ? ((l = a), (a = null)) : (l = a.sibling);
            var c = v(t, a, n[s], r);
            if (null === c) {
              null === a && (a = l);
              break;
            }
            d && a && null === c.alternate && p(t, a),
              (e = m(c, e, s)),
              null === o ? (i = c) : (o.sibling = c),
              (o = c),
              (a = l);
          }
          if (s === n.length) return f(t, a), i;
          if (null === a) {
            for (; s < n.length; s++)
              null !== (a = g(t, n[s], r)) &&
                ((e = m(a, e, s)),
                null === o ? (i = a) : (o.sibling = a),
                (o = a));
            return i;
          }
          for (a = h(t, a); s < n.length; s++)
            null !== (l = y(a, t, s, n[s], r)) &&
              (d &&
                null !== l.alternate &&
                a.delete(null === l.key ? s : l.key),
              (e = m(l, e, s)),
              null === o ? (i = l) : (o.sibling = l),
              (o = l));
          return (
            d &&
              a.forEach(function (e) {
                return p(t, e);
              }),
            i
          );
        })(e, t, n, r);
      if (Co(n))
        return (function (t, e, n, r) {
          var i = Co(n);
          if ("function" != typeof i) throw Error(ho(150));
          if (null == (n = i.call(n))) throw Error(ho(151));
          for (
            var o = (i = null), a = e, s = (e = 0), l = null, c = n.next();
            null !== a && !c.done;
            s++, c = n.next()
          ) {
            a.index > s ? ((l = a), (a = null)) : (l = a.sibling);
            var u = v(t, a, c.value, r);
            if (null === u) {
              null === a && (a = l);
              break;
            }
            d && a && null === u.alternate && p(t, a),
              (e = m(u, e, s)),
              null === o ? (i = u) : (o.sibling = u),
              (o = u),
              (a = l);
          }
          if (c.done) return f(t, a), i;
          if (null === a) {
            for (; !c.done; s++, c = n.next())
              null !== (c = g(t, c.value, r)) &&
                ((e = m(c, e, s)),
                null === o ? (i = c) : (o.sibling = c),
                (o = c));
            return i;
          }
          for (a = h(t, a); !c.done; s++, c = n.next())
            null !== (c = y(a, t, s, c.value, r)) &&
              (d &&
                null !== c.alternate &&
                a.delete(null === c.key ? s : c.key),
              (e = m(c, e, s)),
              null === o ? (i = c) : (o.sibling = c),
              (o = c));
          return (
            d &&
              a.forEach(function (e) {
                return p(t, e);
              }),
            i
          );
        })(e, t, n, r);
      if ((o && dl(e, n), void 0 === n && !i))
        switch (e.tag) {
          case 1:
          case 0:
            throw (
              ((e = e.type),
              Error(ho(152, e.displayName || e.name || "Component")))
            );
        }
      return f(e, t);
    };
  }
  function fl(e) {
    if (e === Hr) throw Error(ho(174));
    return e;
  }
  function hl(e, t) {
    Cs(Ur, t), Cs(qr, e), Cs(Vr, Hr);
    var n = t.nodeType;
    switch (n) {
      case 9:
      case 11:
        t = (t = t.documentElement) ? t.namespaceURI : ea(null, "");
        break;
      default:
        t = ea(
          (t = (n = 8 === n ? t.parentNode : t).namespaceURI || null),
          n.tagName
        );
    }
    Ss(Vr), Cs(Vr, t);
  }
  function ml() {
    Ss(Vr), Ss(qr), Ss(Ur);
  }
  function gl(e) {
    fl(Ur.current);
    var t = fl(Vr.current),
      n = ea(t, e.type);
    t !== n && (Cs(qr, e), Cs(Vr, n));
  }
  function vl(e) {
    qr.current === e && (Ss(Vr), Ss(qr));
  }
  function yl(e) {
    for (var t = e; null !== t; ) {
      if (13 === t.tag) {
        var n = t.memoizedState;
        if (
          null !== n &&
          (null === (n = n.dehydrated) || n.data === wn || n.data === xn)
        )
          return t;
      } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
        if (0 != (64 & t.effectTag)) return t;
      } else if (null !== t.child) {
        t = (t.child.return = t).child;
        continue;
      }
      if (t === e) break;
      for (; null === t.sibling; ) {
        if (null === t.return || t.return === e) return null;
        t = t.return;
      }
      (t.sibling.return = t.return), (t = t.sibling);
    }
    return null;
  }
  function bl(e, t) {
    return { responder: e, props: t };
  }
  function wl() {
    throw Error(ho(321));
  }
  function xl(e, t) {
    if (null !== t) {
      for (var n = 0; n < t.length && n < e.length; n++)
        if (!Zn(e[n], t[n])) return;
      return 1;
    }
  }
  function El(e, t, n, r, i, o) {
    if (
      ((Kr = o),
      (Zr = t),
      (Jr = null !== e ? e.memoizedState : null),
      (Yr.current = null === Jr ? ui : di),
      (t = n(r, i)),
      ai)
    ) {
      for (
        ;
        (ai = !1),
          (li += 1),
          (Jr = null !== e ? e.memoizedState : null),
          (ni = ei),
          (ii = ti = Qr = null),
          (Yr.current = di),
          (t = n(r, i)),
          ai;

      );
      (si = null), (li = 0);
    }
    if (
      ((Yr.current = ci),
      ((e = Zr).memoizedState = ei),
      (e.expirationTime = ri),
      (e.updateQueue = ii),
      (e.effectTag |= oi),
      (e = null !== Qr && null !== Qr.next),
      (ni = ti = ei = Jr = Qr = Zr = null),
      (ii = null),
      (oi = ri = Kr = 0),
      e)
    )
      throw Error(ho(300));
    return t;
  }
  function Sl() {
    (Yr.current = ci),
      (ni = ti = ei = Jr = Qr = Zr = null),
      (ai = !1),
      (si = ii = null),
      (li = oi = ri = Kr = 0);
  }
  function Cl() {
    var e = {
      memoizedState: null,
      baseState: null,
      queue: null,
      baseUpdate: null,
      next: null,
    };
    return null === ti ? (ei = ti = e) : (ti = ti.next = e), ti;
  }
  function kl() {
    if (null !== ni)
      (ni = (ti = ni).next), (Jr = null !== (Qr = Jr) ? Qr.next : null);
    else {
      if (null === Jr) throw Error(ho(310));
      var e = {
        memoizedState: (Qr = Jr).memoizedState,
        baseState: Qr.baseState,
        queue: Qr.queue,
        baseUpdate: Qr.baseUpdate,
        next: null,
      };
      (ti = null === ti ? (ei = e) : (ti.next = e)), (Jr = Qr.next);
    }
    return ti;
  }
  function Tl(e, t) {
    return "function" == typeof t ? t(e) : t;
  }
  function Pl(e) {
    var t = kl(),
      n = t.queue;
    if (null === n) throw Error(ho(311));
    if (((n.lastRenderedReducer = e), 0 < li)) {
      var r = n.dispatch;
      if (null !== si) {
        var i = si.get(n);
        if (void 0 !== i) {
          si.delete(n);
          for (
            var o = t.memoizedState;
            (o = e(o, i.action)), (i = i.next), null !== i;

          );
          return (
            Zn(o, t.memoizedState) || (gi = !0),
            (t.memoizedState = o),
            t.baseUpdate === n.last && (t.baseState = o),
            [(n.lastRenderedState = o), r]
          );
        }
      }
      return [t.memoizedState, r];
    }
    r = n.last;
    var a = t.baseUpdate,
      o = t.baseState;
    if (
      null !==
      (r =
        null !== a
          ? (null !== r && (r.next = null), a.next)
          : null !== r
          ? r.next
          : null)
    ) {
      var s = (i = null),
        l = r,
        c = !1;
      do {
        var u = l.expirationTime;
      } while (
        (u < Kr
          ? (c || ((c = !0), (s = a), (i = o)), ri < u && Ic((ri = u)))
          : (Lc(u, l.suspenseConfig),
            (o = l.eagerReducer === e ? l.eagerState : e(o, l.action))),
        null !== (l = (a = l).next) && l !== r)
      );
      c || ((s = a), (i = o)),
        Zn(o, t.memoizedState) || (gi = !0),
        (t.memoizedState = o),
        (t.baseUpdate = s),
        (t.baseState = i),
        (n.lastRenderedState = o);
    }
    return [t.memoizedState, n.dispatch];
  }
  function zl(e) {
    var t = Cl();
    return (
      "function" == typeof e && (e = e()),
      (t.memoizedState = t.baseState = e),
      (e = (e = t.queue = {
        last: null,
        dispatch: null,
        lastRenderedReducer: Tl,
        lastRenderedState: e,
      }).dispatch = Bl.bind(null, Zr, e)),
      [t.memoizedState, e]
    );
  }
  function Ol(e) {
    return Pl(Tl);
  }
  function Rl(e, t, n, r) {
    return (
      (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
      null === ii
        ? ((ii = { lastEffect: null }).lastEffect = e.next = e)
        : null === (t = ii.lastEffect)
        ? (ii.lastEffect = e.next = e)
        : ((n = t.next), ((t.next = e).next = n), (ii.lastEffect = e)),
      e
    );
  }
  function Ml(e, t, n, r) {
    var i = Cl();
    (oi |= e), (i.memoizedState = Rl(t, n, void 0, void 0 === r ? null : r));
  }
  function Nl(e, t, n, r) {
    var i = kl();
    r = void 0 === r ? null : r;
    var o = void 0;
    if (null !== Qr) {
      var a = Qr.memoizedState,
        o = a.destroy;
      if (null !== r && xl(r, a.deps)) return void Rl(0, n, o, r);
    }
    (oi |= e), (i.memoizedState = Rl(t, n, o, r));
  }
  function Ll(e, t) {
    return Ml(516, 192, e, t);
  }
  function Il(e, t) {
    return Nl(516, 192, e, t);
  }
  function _l(e, t) {
    return "function" == typeof t
      ? ((e = e()),
        t(e),
        function () {
          t(null);
        })
      : null != t
      ? ((e = e()),
        (t.current = e),
        function () {
          t.current = null;
        })
      : void 0;
  }
  function Dl() {}
  function Al(e, t) {
    return (Cl().memoizedState = [e, void 0 === t ? null : t]), e;
  }
  function Fl(e, t) {
    var n = kl();
    t = void 0 === t ? null : t;
    var r = n.memoizedState;
    return null !== r && null !== t && xl(t, r[1])
      ? r[0]
      : ((n.memoizedState = [e, t]), e);
  }
  function Bl(e, t, n) {
    if (!(li < 25)) throw Error(ho(301));
    var r = e.alternate;
    if (e === Zr || (null !== r && r === Zr))
      if (
        ((ai = !0),
        (e = {
          expirationTime: Kr,
          suspenseConfig: null,
          action: n,
          eagerReducer: null,
          eagerState: null,
          next: null,
        }),
        null === si && (si = new Map()),
        void 0 === (n = si.get(t)))
      )
        si.set(t, e);
      else {
        for (t = n; null !== t.next; ) t = t.next;
        t.next = e;
      }
    else {
      var i,
        o = wc(),
        a = {
          expirationTime: (o = xc(o, e, (a = Ar.suspense))),
          suspenseConfig: a,
          action: n,
          eagerReducer: null,
          eagerState: null,
          next: null,
        },
        s = t.last;
      if (
        (null === s
          ? (a.next = a)
          : (null !== (i = s.next) && (a.next = i), (s.next = a)),
        (t.last = a),
        0 === e.expirationTime &&
          (null === r || 0 === r.expirationTime) &&
          null !== (r = t.lastRenderedReducer))
      )
        try {
          var l = t.lastRenderedState,
            c = r(l, n);
          if (((a.eagerReducer = r), (a.eagerState = c), Zn(c, l))) return;
        } catch (e) {}
      Ec(e, o);
    }
  }
  function Wl(e, t) {
    var n = qc(5, null, null, 0);
    (n.elementType = "DELETED"),
      (n.type = "DELETED"),
      (n.stateNode = t),
      (n.return = e),
      (n.effectTag = 8),
      null !== e.lastEffect
        ? ((e.lastEffect.nextEffect = n), (e.lastEffect = n))
        : (e.firstEffect = e.lastEffect = n);
  }
  function $l(e, t) {
    switch (e.tag) {
      case 5:
        var n = e.type;
        return (
          null !==
            (t =
              1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase()
                ? null
                : t) && ((e.stateNode = t), 1)
        );
      case 6:
        return (
          null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) &&
          ((e.stateNode = t), 1)
        );
      case 13:
      default:
        return;
    }
  }
  function jl(e) {
    if (hi) {
      var t = fi;
      if (t) {
        var n = t;
        if (!$l(e, t)) {
          if (!(t = es(n.nextSibling)) || !$l(e, t))
            return (
              (e.effectTag = (-1025 & e.effectTag) | 2), (pi = e), (hi = !1)
            );
          Wl(pi, n);
        }
        (pi = e), (fi = es(t.firstChild));
      } else (e.effectTag = (-1025 & e.effectTag) | 2), (hi = !1), (pi = e);
    }
  }
  function Hl(e) {
    for (
      e = e.return;
      null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;

    )
      e = e.return;
    pi = e;
  }
  function Vl(e) {
    if (e === pi) {
      if (!hi) return Hl(e), (hi = !0), 0;
      var t = e.type;
      if (
        5 !== e.tag ||
        ("head" !== t && "body" !== t && !Ja(t, e.memoizedProps))
      )
        for (t = fi; t; ) Wl(e, t), (t = es(t.nextSibling));
      if ((Hl(e), 13 === e.tag)) {
        if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null))
          throw Error(ho(317));
        e: {
          for (e = e.nextSibling, t = 0; e; ) {
            if (8 === e.nodeType) {
              var n = e.data;
              if (n === bn) {
                if (0 === t) {
                  fi = es(e.nextSibling);
                  break e;
                }
                t--;
              } else (n !== yn && n !== xn && n !== wn) || t++;
            }
            e = e.nextSibling;
          }
          fi = null;
        }
      } else fi = pi ? es(e.stateNode.nextSibling) : null;
      return 1;
    }
  }
  function ql() {
    (fi = pi = null), (hi = !1);
  }
  function Ul(e, t, n, r) {
    t.child = null === e ? jr(t, null, n, r) : $r(t, e.child, n, r);
  }
  function Gl(e, t, n, r, i) {
    n = n.render;
    var o = t.ref;
    return (
      Us(t, i),
      (r = El(e, t, n, r, o, i)),
      null === e || gi
        ? ((t.effectTag |= 1), Ul(e, t, r, i), t.child)
        : ((t.updateQueue = e.updateQueue),
          (t.effectTag &= -517),
          e.expirationTime <= i && (e.expirationTime = 0),
          oc(e, t, i))
    );
  }
  function Yl(e, t, n, r, i, o) {
    if (null !== e)
      return (
        (a = e.child),
        i < o &&
        ((i = a.memoizedProps),
        (n = null !== (n = n.compare) ? n : xs)(i, r) && e.ref === t.ref)
          ? oc(e, t, o)
          : ((t.effectTag |= 1),
            ((e = Gc(a, r)).ref = t.ref),
            ((e.return = t).child = e))
      );
    var a = n.type;
    return "function" != typeof a ||
      Uc(a) ||
      void 0 !== a.defaultProps ||
      null !== n.compare ||
      void 0 !== n.defaultProps
      ? (((e = Yc(n.type, null, r, null, t.mode, o)).ref = t.ref),
        ((e.return = t).child = e))
      : ((t.tag = 15), (t.type = a), Xl(e, t, a, r, i, o));
  }
  function Xl(e, t, n, r, i, o) {
    return null !== e &&
      xs(e.memoizedProps, r) &&
      e.ref === t.ref &&
      ((gi = !1), i < o)
      ? oc(e, t, o)
      : Zl(e, t, n, r, o);
  }
  function Kl(e, t) {
    var n = t.ref;
    ((null === e && null !== n) || (null !== e && e.ref !== n)) &&
      (t.effectTag |= 128);
  }
  function Zl(e, t, n, r, i) {
    var o = ks(t, (o = Ts(n) ? dr : cr.current));
    return (
      Us(t, i),
      (n = El(e, t, n, r, o, i)),
      null === e || gi
        ? ((t.effectTag |= 1), Ul(e, t, n, i), t.child)
        : ((t.updateQueue = e.updateQueue),
          (t.effectTag &= -517),
          e.expirationTime <= i && (e.expirationTime = 0),
          oc(e, t, i))
    );
  }
  function Ql(e, t, n, r, i) {
    var o, a, s, l, c, u, d, p, f;
    return (
      Ts(n) ? ((o = !0), Ms(t)) : (o = !1),
      Us(t, i),
      (r =
        null === t.stateNode
          ? (null !== e &&
              ((e.alternate = null), (t.alternate = null), (t.effectTag |= 2)),
            sl(t, n, r),
            cl(t, n, r, i),
            !0)
          : null === e
          ? ((a = t.stateNode),
            (s = t.memoizedProps),
            (a.props = s),
            (p = a.context),
            (l =
              "object" == typeof (l = n.contextType) && null !== l
                ? Gs(l)
                : ks(t, (l = Ts(n) ? dr : cr.current))),
            (u =
              "function" == typeof (c = n.getDerivedStateFromProps) ||
              "function" == typeof a.getSnapshotBeforeUpdate) ||
              ("function" != typeof a.UNSAFE_componentWillReceiveProps &&
                "function" != typeof a.componentWillReceiveProps) ||
              (s === r && p === l) ||
              ll(0, a, r, l),
            (Dr = !1),
            (d = t.memoizedState),
            (p = a.state = d),
            null !== (f = t.updateQueue) &&
              (nl(t, f, r, a, i), (p = t.memoizedState)),
            s !== r || d !== p || ur.current || Dr
              ? ("function" == typeof c &&
                  (ol(t, 0, c, r), (p = t.memoizedState)),
                (s = Dr || al(t, n, s, r, d, p, l))
                  ? (u ||
                      ("function" != typeof a.UNSAFE_componentWillMount &&
                        "function" != typeof a.componentWillMount) ||
                      ("function" == typeof a.componentWillMount &&
                        a.componentWillMount(),
                      "function" == typeof a.UNSAFE_componentWillMount &&
                        a.UNSAFE_componentWillMount()),
                    "function" == typeof a.componentDidMount &&
                      (t.effectTag |= 4))
                  : ("function" == typeof a.componentDidMount &&
                      (t.effectTag |= 4),
                    (t.memoizedProps = r),
                    (t.memoizedState = p)),
                (a.props = r),
                (a.state = p),
                (a.context = l),
                s)
              : ("function" == typeof a.componentDidMount && (t.effectTag |= 4),
                !1))
          : ((a = t.stateNode),
            (s = t.memoizedProps),
            (a.props = t.type === t.elementType ? s : $s(t.type, s)),
            (p = a.context),
            (l =
              "object" == typeof (l = n.contextType) && null !== l
                ? Gs(l)
                : ks(t, (l = Ts(n) ? dr : cr.current))),
            (u =
              "function" == typeof (c = n.getDerivedStateFromProps) ||
              "function" == typeof a.getSnapshotBeforeUpdate) ||
              ("function" != typeof a.UNSAFE_componentWillReceiveProps &&
                "function" != typeof a.componentWillReceiveProps) ||
              (s === r && p === l) ||
              ll(0, a, r, l),
            (Dr = !1),
            (p = t.memoizedState),
            (d = a.state = p),
            null !== (f = t.updateQueue) &&
              (nl(t, f, r, a, i), (d = t.memoizedState)),
            s !== r || p !== d || ur.current || Dr
              ? ("function" == typeof c &&
                  (ol(t, 0, c, r), (d = t.memoizedState)),
                (c = Dr || al(t, n, s, r, p, d, l))
                  ? (u ||
                      ("function" != typeof a.UNSAFE_componentWillUpdate &&
                        "function" != typeof a.componentWillUpdate) ||
                      ("function" == typeof a.componentWillUpdate &&
                        a.componentWillUpdate(r, d, l),
                      "function" == typeof a.UNSAFE_componentWillUpdate &&
                        a.UNSAFE_componentWillUpdate(r, d, l)),
                    "function" == typeof a.componentDidUpdate &&
                      (t.effectTag |= 4),
                    "function" == typeof a.getSnapshotBeforeUpdate &&
                      (t.effectTag |= 256))
                  : ("function" != typeof a.componentDidUpdate ||
                      (s === e.memoizedProps && p === e.memoizedState) ||
                      (t.effectTag |= 4),
                    "function" != typeof a.getSnapshotBeforeUpdate ||
                      (s === e.memoizedProps && p === e.memoizedState) ||
                      (t.effectTag |= 256),
                    (t.memoizedProps = r),
                    (t.memoizedState = d)),
                (a.props = r),
                (a.state = d),
                (a.context = l),
                c)
              : ("function" != typeof a.componentDidUpdate ||
                  (s === e.memoizedProps && p === e.memoizedState) ||
                  (t.effectTag |= 4),
                "function" != typeof a.getSnapshotBeforeUpdate ||
                  (s === e.memoizedProps && p === e.memoizedState) ||
                  (t.effectTag |= 256),
                !1))),
      Jl(e, t, n, r, o, i)
    );
  }
  function Jl(e, t, n, r, i, o) {
    Kl(e, t);
    var a = 0 != (64 & t.effectTag);
    if (!r && !a) return i && Ns(t, n, !1), oc(e, t, o);
    (r = t.stateNode), (mi.current = t);
    var s =
      a && "function" != typeof n.getDerivedStateFromError ? null : r.render();
    return (
      (t.effectTag |= 1),
      null !== e && a
        ? ((t.child = $r(t, e.child, null, o)), (t.child = $r(t, null, s, o)))
        : Ul(e, t, s, o),
      (t.memoizedState = r.state),
      i && Ns(t, n, !0),
      t.child
    );
  }
  function ec(e) {
    var t = e.stateNode;
    t.pendingContext
      ? Os(0, t.pendingContext, t.pendingContext !== t.context)
      : t.context && Os(0, t.context, !1),
      hl(e, t.containerInfo);
  }
  function tc(e, t, n) {
    var r,
      i = t.mode,
      o = t.pendingProps,
      a = Gr.current,
      s = !1;
    if (
      ((r = 0 != (64 & t.effectTag)) ||
        (r = 0 != (2 & a) && (null === e || null !== e.memoizedState)),
      r
        ? ((s = !0), (t.effectTag &= -65))
        : (null !== e && null === e.memoizedState) ||
          void 0 === o.fallback ||
          !0 === o.unstable_avoidThisFallback ||
          (a |= 1),
      Cs(Gr, 1 & a),
      null === e)
    ) {
      if ((void 0 !== o.fallback && jl(t), s)) {
        if (
          ((s = o.fallback),
          0 == (2 & ((o = Xc(null, i, 0, null)).return = t).mode))
        )
          for (
            e = (null !== t.memoizedState ? t.child : t).child, o.child = e;
            null !== e;

          )
            (e.return = o), (e = e.sibling);
        return (
          ((n = Xc(s, i, n, null)).return = t),
          (o.sibling = n),
          (t.memoizedState = vi),
          (t.child = o),
          n
        );
      }
      return (
        (i = o.children),
        (t.memoizedState = null),
        (t.child = jr(t, null, i, n))
      );
    }
    if (null !== e.memoizedState) {
      if (((i = (e = e.child).sibling), s)) {
        if (
          ((o = o.fallback),
          0 == (2 & ((n = Gc(e, e.pendingProps)).return = t).mode) &&
            (s = (null !== t.memoizedState ? t.child : t).child) !== e.child)
        )
          for (n.child = s; null !== s; ) (s.return = n), (s = s.sibling);
        return (
          ((i = Gc(i, o, i.expirationTime)).return = t),
          (n.sibling = i),
          (n.childExpirationTime = 0),
          (t.memoizedState = vi),
          (t.child = n),
          i
        );
      }
      return (
        (n = $r(t, e.child, o.children, n)),
        (t.memoizedState = null),
        (t.child = n)
      );
    }
    if (((e = e.child), s)) {
      if (
        ((s = o.fallback),
        ((o = Xc(null, i, 0, null)).return = t),
        null !== (o.child = e) && (e.return = o),
        0 == (2 & t.mode))
      )
        for (
          e = (null !== t.memoizedState ? t.child : t).child, o.child = e;
          null !== e;

        )
          (e.return = o), (e = e.sibling);
      return (
        ((n = Xc(s, i, n, null)).return = t),
        ((o.sibling = n).effectTag |= 2),
        (o.childExpirationTime = 0),
        (t.memoizedState = vi),
        (t.child = o),
        n
      );
    }
    return (t.memoizedState = null), (t.child = $r(t, e, o.children, n));
  }
  function nc(e, t) {
    e.expirationTime < t && (e.expirationTime = t);
    var n = e.alternate;
    null !== n && n.expirationTime < t && (n.expirationTime = t),
      qs(e.return, t);
  }
  function rc(e, t, n, r, i, o) {
    var a = e.memoizedState;
    null === a
      ? (e.memoizedState = {
          isBackwards: t,
          rendering: null,
          last: r,
          tail: n,
          tailExpiration: 0,
          tailMode: i,
          lastEffect: o,
        })
      : ((a.isBackwards = t),
        (a.rendering = null),
        (a.last = r),
        (a.tail = n),
        (a.tailExpiration = 0),
        (a.tailMode = i),
        (a.lastEffect = o));
  }
  function ic(e, t, n) {
    var r = t.pendingProps,
      i = r.revealOrder,
      o = r.tail;
    if ((Ul(e, t, r.children, n), 0 != (2 & (r = Gr.current))))
      (r = (1 & r) | 2), (t.effectTag |= 64);
    else {
      if (null !== e && 0 != (64 & e.effectTag))
        e: for (e = t.child; null !== e; ) {
          if (13 === e.tag) null !== e.memoizedState && nc(e, n);
          else if (19 === e.tag) nc(e, n);
          else if (null !== e.child) {
            e = (e.child.return = e).child;
            continue;
          }
          if (e === t) break e;
          for (; null === e.sibling; ) {
            if (null === e.return || e.return === t) break e;
            e = e.return;
          }
          (e.sibling.return = e.return), (e = e.sibling);
        }
      r &= 1;
    }
    if ((Cs(Gr, r), 0 == (2 & t.mode))) t.memoizedState = null;
    else
      switch (i) {
        case "forwards":
          for (n = t.child, i = null; null !== n; )
            null !== (e = n.alternate) && null === yl(e) && (i = n),
              (n = n.sibling);
          null === (n = i)
            ? ((i = t.child), (t.child = null))
            : ((i = n.sibling), (n.sibling = null)),
            rc(t, !1, i, n, o, t.lastEffect);
          break;
        case "backwards":
          for (n = null, i = t.child, t.child = null; null !== i; ) {
            if (null !== (e = i.alternate) && null === yl(e)) {
              t.child = i;
              break;
            }
            (e = i.sibling), (i.sibling = n), (n = i), (i = e);
          }
          rc(t, !0, n, null, o, t.lastEffect);
          break;
        case "together":
          rc(t, !1, null, null, void 0, t.lastEffect);
          break;
        default:
          t.memoizedState = null;
      }
    return t.child;
  }
  function oc(e, t, n) {
    null !== e && (t.dependencies = e.dependencies);
    var r = t.expirationTime;
    if ((0 !== r && Ic(r), t.childExpirationTime < n)) return null;
    if (null !== e && t.child !== e.child) throw Error(ho(153));
    if (null !== t.child) {
      for (
        n = Gc((e = t.child), e.pendingProps, e.expirationTime),
          (t.child = n).return = t;
        null !== e.sibling;

      )
        (e = e.sibling),
          ((n = n.sibling = Gc(
            e,
            e.pendingProps,
            e.expirationTime
          )).return = t);
      n.sibling = null;
    }
    return t.child;
  }
  function ac(e) {
    e.effectTag |= 4;
  }
  function sc(e, t) {
    switch (e.tailMode) {
      case "hidden":
        t = e.tail;
        for (var n = null; null !== t; )
          null !== t.alternate && (n = t), (t = t.sibling);
        null === n ? (e.tail = null) : (n.sibling = null);
        break;
      case "collapsed":
        n = e.tail;
        for (var r = null; null !== n; )
          null !== n.alternate && (r = n), (n = n.sibling);
        null === r
          ? t || null === e.tail
            ? (e.tail = null)
            : (e.tail.sibling = null)
          : (r.sibling = null);
    }
  }
  function lc(e, t) {
    return { value: e, source: t, stack: To(t) };
  }
  function cc(e, t) {
    var n = t.source;
    null === t.stack && null !== n && To(n),
      null !== n && ko(n.type),
      (t = t.value),
      null !== e && 1 === e.tag && ko(e.type);
    try {
      console.error(t);
    } catch (e) {
      setTimeout(function () {
        throw e;
      });
    }
  }
  function uc(e) {
    var t = e.ref;
    if (null !== t)
      if ("function" == typeof t)
        try {
          t(null);
        } catch (t) {
          jc(e, t);
        }
      else t.current = null;
  }
  function dc(e, t, n) {
    if (null !== (n = null !== (n = n.updateQueue) ? n.lastEffect : null)) {
      var r,
        i = (n = n.next);
      do {} while (
        (0 != (i.tag & e) &&
          ((r = i.destroy), (i.destroy = void 0) !== r && r()),
        0 != (i.tag & t) && ((r = i.create), (i.destroy = r())),
        (i = i.next) !== n)
      );
    }
  }
  function pc(e, r, t) {
    switch (("function" == typeof co && co(r), r.tag)) {
      case 0:
      case 11:
      case 14:
      case 15:
        var i;
        null !== (e = r.updateQueue) &&
          null !== (e = e.lastEffect) &&
          ((i = e.next),
          _s(97 < t ? 97 : t, function () {
            var e = i;
            do {
              var t = e.destroy;
              if (void 0 !== t) {
                var n = r;
                try {
                  t();
                } catch (e) {
                  jc(n, e);
                }
              }
            } while ((e = e.next) !== i);
          }));
        break;
      case 1:
        uc(r),
          "function" == typeof (t = r.stateNode).componentWillUnmount &&
            (function (e, t) {
              try {
                (t.props = e.memoizedProps),
                  (t.state = e.memoizedState),
                  t.componentWillUnmount();
              } catch (t) {
                jc(e, t);
              }
            })(r, t);
        break;
      case 5:
        uc(r);
        break;
      case 4:
        mc(e, r, t);
    }
  }
  function fc(e) {
    return 5 === e.tag || 3 === e.tag || 4 === e.tag;
  }
  function hc(e) {
    e: {
      for (var t = e.return; null !== t; ) {
        if (fc(t)) {
          var n = t;
          break e;
        }
        t = t.return;
      }
      throw Error(ho(160));
    }
    switch (((t = n.stateNode), n.tag)) {
      case 5:
        var r = !1;
        break;
      case 3:
      case 4:
        (t = t.containerInfo), (r = !0);
        break;
      default:
        throw Error(ho(161));
    }
    16 & n.effectTag && (ta(t, ""), (n.effectTag &= -17));
    e: t: for (n = e; ; ) {
      for (; null === n.sibling; ) {
        if (null === n.return || fc(n.return)) {
          n = null;
          break e;
        }
        n = n.return;
      }
      for (
        n.sibling.return = n.return, n = n.sibling;
        5 !== n.tag && 6 !== n.tag && 18 !== n.tag;

      ) {
        if (2 & n.effectTag) continue t;
        if (null === n.child || 4 === n.tag) continue t;
        n = (n.child.return = n).child;
      }
      if (!(2 & n.effectTag)) {
        n = n.stateNode;
        break e;
      }
    }
    for (var i = e; ; ) {
      var o = 5 === i.tag || 6 === i.tag;
      if (o) {
        var a,
          s = o ? i.stateNode : i.stateNode.instance;
        n
          ? r
            ? ((a = s),
              (s = n),
              (8 === (o = t).nodeType ? o.parentNode : o).insertBefore(a, s))
            : t.insertBefore(s, n)
          : r
          ? (8 === (a = t).nodeType
              ? (o = a.parentNode).insertBefore(s, a)
              : (o = a).appendChild(s),
            null != (a = a._reactRootContainer) ||
              null !== o.onclick ||
              (o.onclick = Ua))
          : t.appendChild(s);
      } else if (4 !== i.tag && null !== i.child) {
        i = (i.child.return = i).child;
        continue;
      }
      if (i === e) break;
      for (; null === i.sibling; ) {
        if (null === i.return || i.return === e) return;
        i = i.return;
      }
      (i.sibling.return = i.return), (i = i.sibling);
    }
  }
  function mc(e, t, n) {
    for (var r, i, o = t, a = !1; ; ) {
      if (!a) {
        a = o.return;
        e: for (;;) {
          if (null === a) throw Error(ho(160));
          switch (((r = a.stateNode), a.tag)) {
            case 5:
              i = !1;
              break e;
            case 3:
            case 4:
              (r = r.containerInfo), (i = !0);
              break e;
          }
          a = a.return;
        }
        a = !0;
      }
      if (5 === o.tag || 6 === o.tag) {
        e: for (var s = e, l = o, c = n, u = l; ; )
          if ((pc(s, u, c), null !== u.child && 4 !== u.tag))
            (u.child.return = u), (u = u.child);
          else {
            if (u === l) break;
            for (; null === u.sibling; ) {
              if (null === u.return || u.return === l) break e;
              u = u.return;
            }
            (u.sibling.return = u.return), (u = u.sibling);
          }
        i
          ? ((s = r),
            (l = o.stateNode),
            (8 === s.nodeType ? s.parentNode : s).removeChild(l))
          : r.removeChild(o.stateNode);
      } else if (4 === o.tag) {
        if (null !== o.child) {
          (r = o.stateNode.containerInfo),
            (i = !0),
            (o = (o.child.return = o).child);
          continue;
        }
      } else if ((pc(e, o, n), null !== o.child)) {
        o = (o.child.return = o).child;
        continue;
      }
      if (o === t) break;
      for (; null === o.sibling; ) {
        if (null === o.return || o.return === t) return;
        4 === (o = o.return).tag && (a = !1);
      }
      (o.sibling.return = o.return), (o = o.sibling);
    }
  }
  function gc(e, t) {
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        dc(4, 8, t);
        break;
      case 1:
        break;
      case 5:
        var n = t.stateNode;
        if (null != n) {
          var r = t.memoizedProps,
            i = null !== e ? e.memoizedProps : r;
          e = t.type;
          var o = t.updateQueue;
          if ((t.updateQueue = null) !== o) {
            for (
              n[Pn] = r,
                "input" === e &&
                  "radio" === r.type &&
                  null != r.name &&
                  Ho(n, r),
                Va(e, i),
                t = Va(e, r),
                i = 0;
              i < o.length;
              i += 2
            ) {
              var a = o[i],
                s = o[i + 1];
              "style" === a
                ? ja(n, s)
                : "dangerouslySetInnerHTML" === a
                ? gt(n, s)
                : "children" === a
                ? ta(n, s)
                : Ao(n, a, s, t);
            }
            switch (e) {
              case "input":
                Vo(n, r);
                break;
              case "textarea":
                Zo(n, r);
                break;
              case "select":
                (t = n._wrapperState.wasMultiple),
                  (n._wrapperState.wasMultiple = !!r.multiple),
                  null != (e = r.value)
                    ? Yo(n, !!r.multiple, e, !1)
                    : t !== !!r.multiple &&
                      (null != r.defaultValue
                        ? Yo(n, !!r.multiple, r.defaultValue, !0)
                        : Yo(n, !!r.multiple, r.multiple ? [] : "", !1));
            }
          }
        }
        break;
      case 6:
        if (null === t.stateNode) throw Error(ho(162));
        t.stateNode.nodeValue = t.memoizedProps;
        break;
      case 3:
        (t = t.stateNode).hydrate && ((t.hydrate = !1), ma(t.containerInfo));
        break;
      case 12:
        break;
      case 13:
        if (
          (null === (n = t).memoizedState
            ? (r = !1)
            : ((r = !0), (n = t.child), (Yi = Rr())),
          null !== n)
        )
          e: for (e = n; ; ) {
            if (5 === e.tag)
              (o = e.stateNode),
                r
                  ? "function" == typeof (o = o.style).setProperty
                    ? o.setProperty("display", "none", "important")
                    : (o.display = "none")
                  : ((o = e.stateNode),
                    (i =
                      null != (i = e.memoizedProps.style) &&
                      i.hasOwnProperty("display")
                        ? i.display
                        : null),
                    (o.style.display = $a("display", i)));
            else if (6 === e.tag)
              e.stateNode.nodeValue = r ? "" : e.memoizedProps;
            else {
              if (
                13 === e.tag &&
                null !== e.memoizedState &&
                null === e.memoizedState.dehydrated
              ) {
                ((o = e.child.sibling).return = e), (e = o);
                continue;
              }
              if (null !== e.child) {
                e = (e.child.return = e).child;
                continue;
              }
            }
            if (e === n) break e;
            for (; null === e.sibling; ) {
              if (null === e.return || e.return === n) break e;
              e = e.return;
            }
            (e.sibling.return = e.return), (e = e.sibling);
          }
        vc(t);
        break;
      case 19:
        vc(t);
        break;
      case 17:
      case 20:
      case 21:
        break;
      default:
        throw Error(ho(163));
    }
  }
  function vc(n) {
    var r,
      e = n.updateQueue;
    null !== e &&
      ((n.updateQueue = null) === (r = n.stateNode) &&
        (r = n.stateNode = new Ei()),
      e.forEach(function (e) {
        var t = function (e, t) {
          var n = e.stateNode;
          null !== n && n.delete(t),
            (t = 0),
            (t = xc((t = wc()), e, null)),
            null !== (e = Sc(e, t)) && kc(e);
        }.bind(null, n, e);
        r.has(e) || (r.add(e), e.then(t, t));
      }));
  }
  function yc(e, t, n) {
    ((n = Ks(n, null)).tag = 3), (n.payload = { element: null });
    var r = t.value;
    return (
      (n.callback = function () {
        Zi || ((Zi = !0), (Qi = r)), cc(e, t);
      }),
      n
    );
  }
  function bc(t, n, e) {
    (e = Ks(e, null)).tag = 3;
    var r,
      i = t.type.getDerivedStateFromError;
    "function" == typeof i &&
      ((r = n.value),
      (e.payload = function () {
        return cc(t, n), i(r);
      }));
    var o = t.stateNode;
    return (
      null !== o &&
        "function" == typeof o.componentDidCatch &&
        (e.callback = function () {
          "function" != typeof i &&
            (null === Ji ? (Ji = new Set([this])) : Ji.add(this), cc(t, n));
          var e = n.stack;
          this.componentDidCatch(n.value, {
            componentStack: null !== e ? e : "",
          });
        }),
      e
    );
  }
  function wc() {
    return (Ai & (Oi | Ri)) !== Pi
      ? 1073741821 - ((Rr() / 10) | 0)
      : 0 !== ao
      ? ao
      : (ao = 1073741821 - ((Rr() / 10) | 0));
  }
  function xc(e, t, n) {
    if (0 == (2 & (t = t.mode))) return 1073741823;
    var r = Ls();
    if (0 == (4 & t)) return 99 === r ? 1073741823 : 1073741822;
    if ((Ai & Oi) !== Pi) return Wi;
    if (null !== n) e = Ws(e, 0 | n.timeoutMs || 5e3, 250);
    else
      switch (r) {
        case 99:
          e = 1073741823;
          break;
        case 98:
          e = Ws(e, 150, 100);
          break;
        case 97:
        case 96:
          e = Ws(e, 5e3, 250);
          break;
        case 95:
          e = 2;
          break;
        default:
          throw Error(ho(326));
      }
    return null !== Fi && e === Wi && --e, e;
  }
  function Ec(e, t) {
    if (50 < io) throw ((io = 0), (oo = null), Error(ho(185)));
    var n;
    null !== (e = Sc(e, t)) &&
      ((n = Ls()),
      1073741823 === t
        ? (Ai & zi) !== Pi && (Ai & (Oi | Ri)) === Pi
          ? Pc(e)
          : (kc(e), Ai === Pi && Fs())
        : kc(e),
      (4 & Ai) === Pi ||
        (98 !== n && 99 !== n) ||
        (null === ro
          ? (ro = new Map([[e, t]]))
          : (void 0 === (n = ro.get(e)) || t < n) && ro.set(e, t)));
  }
  function Sc(e, t) {
    e.expirationTime < t && (e.expirationTime = t);
    var n = e.alternate;
    null !== n && n.expirationTime < t && (n.expirationTime = t);
    var r = e.return,
      i = null;
    if (null === r && 3 === e.tag) i = e.stateNode;
    else
      for (; null !== r; ) {
        if (
          ((n = r.alternate),
          r.childExpirationTime < t && (r.childExpirationTime = t),
          null !== n &&
            n.childExpirationTime < t &&
            (n.childExpirationTime = t),
          null === r.return && 3 === r.tag)
        ) {
          i = r.stateNode;
          break;
        }
        r = r.return;
      }
    return (
      null !== i && (Fi === i && (Ic(t), $i === _i && eu(i, Wi)), tu(i, t)), i
    );
  }
  function Cc(e) {
    var t = e.lastExpiredTime;
    return 0 !== t ||
      !Jc(e, (t = e.firstPendingTime)) ||
      (t = e.lastPingedTime) > (e = e.nextKnownPendingLevel)
      ? t
      : e;
  }
  function kc(e) {
    if (0 !== e.lastExpiredTime)
      (e.callbackExpirationTime = 1073741823),
        (e.callbackPriority = 99),
        (e.callbackNode = As(Pc.bind(null, e)));
    else {
      var t = Cc(e),
        n = e.callbackNode;
      if (0 === t)
        null !== n &&
          ((e.callbackNode = null),
          (e.callbackExpirationTime = 0),
          (e.callbackPriority = 90));
      else {
        var r = wc(),
          r =
            1073741823 === t
              ? 99
              : 1 === t || 2 === t
              ? 95
              : (r = 10 * (1073741821 - t) - 10 * (1073741821 - r)) <= 0
              ? 99
              : r <= 250
              ? 98
              : r <= 5250
              ? 97
              : 95;
        if (null !== n) {
          var i = e.callbackPriority;
          if (e.callbackExpirationTime === t && r <= i) return;
          n !== Cr && hr(n);
        }
        (e.callbackExpirationTime = t),
          (e.callbackPriority = r),
          (t =
            1073741823 === t
              ? As(Pc.bind(null, e))
              : Ds(r, Tc.bind(null, e), {
                  timeout: 10 * (1073741821 - t) - Rr(),
                })),
          (e.callbackNode = t);
      }
    }
  }
  function Tc(e, t) {
    if (((ao = 0), t)) return nu(e, (t = wc())), kc(e), null;
    var n = Cc(e);
    if (0 !== n) {
      if (((t = e.callbackNode), (Ai & (Oi | Ri)) !== Pi)) throw Error(ho(327));
      if ((Bc(), (e === Fi && n === Wi) || Rc(e, n), null !== Bi)) {
        var r = Ai;
        Ai |= Oi;
        for (var i = Nc(); ; )
          try {
            !(function () {
              for (; null !== Bi && !mr(); ) Bi = _c(Bi);
            })();
            break;
          } catch (t) {
            Mc(e, t);
          }
        if ((js(), (Ai = r), (ki.current = i), $i === Ni))
          throw ((t = ji), Rc(e, n), eu(e, n), kc(e), t);
        if (null === Bi)
          switch (
            ((i = e.finishedWork = e.current.alternate),
            (e.finishedExpirationTime = n),
            (r = $i),
            (Fi = null),
            r)
          ) {
            case Mi:
            case Ni:
              throw Error(ho(345));
            case Li:
              nu(e, 2 < n ? 2 : n);
              break;
            case Ii:
              if (
                (eu(e, n),
                n === (r = e.lastSuspendedTime) &&
                  (e.nextKnownPendingLevel = Ac(i)),
                1073741823 === Hi && 10 < (i = Yi + Xi - Rr()))
              ) {
                if (Gi) {
                  var o = e.lastPingedTime;
                  if (0 === o || n <= o) {
                    (e.lastPingedTime = n), Rc(e, n);
                    break;
                  }
                }
                if (0 !== (o = Cc(e)) && o !== n) break;
                if (0 !== r && r !== n) {
                  e.lastPingedTime = r;
                  break;
                }
                e.timeoutHandle = Cn(Fc.bind(null, e), i);
                break;
              }
              Fc(e);
              break;
            case _i:
              if (
                (eu(e, n),
                n === (r = e.lastSuspendedTime) &&
                  (e.nextKnownPendingLevel = Ac(i)),
                Gi && (0 === (i = e.lastPingedTime) || n <= i))
              ) {
                (e.lastPingedTime = n), Rc(e, n);
                break;
              }
              if (0 !== (i = Cc(e)) && i !== n) break;
              if (0 !== r && r !== n) {
                e.lastPingedTime = r;
                break;
              }
              if (
                (1073741823 !== Vi
                  ? (r = 10 * (1073741821 - Vi) - Rr())
                  : 1073741823 === Hi
                  ? (r = 0)
                  : ((r = 10 * (1073741821 - Hi) - 5e3),
                    (r = (i = Rr()) - r) < 0 && (r = 0),
                    (n = 10 * (1073741821 - n) - i) <
                      (r =
                        (r < 120
                          ? 120
                          : r < 480
                          ? 480
                          : r < 1080
                          ? 1080
                          : r < 1920
                          ? 1920
                          : r < 3e3
                          ? 3e3
                          : r < 4320
                          ? 4320
                          : 1960 * Ci(r / 1960)) - r) && (r = n)),
                10 < r)
              ) {
                e.timeoutHandle = Cn(Fc.bind(null, e), r);
                break;
              }
              Fc(e);
              break;
            case Di:
              if (1073741823 !== Hi && null !== qi) {
                o = Hi;
                var a = qi;
                if (
                  10 <
                  (r =
                    (r = 0 | a.busyMinDurationMs) <= 0
                      ? 0
                      : ((i = 0 | a.busyDelayMs),
                        (o =
                          Rr() -
                          (10 * (1073741821 - o) - (0 | a.timeoutMs || 5e3))) <=
                        i
                          ? 0
                          : i + r - o))
                ) {
                  eu(e, n), (e.timeoutHandle = Cn(Fc.bind(null, e), r));
                  break;
                }
              }
              Fc(e);
              break;
            default:
              throw Error(ho(329));
          }
        if ((kc(e), e.callbackNode === t)) return Tc.bind(null, e);
      }
    }
    return null;
  }
  function Pc(e) {
    var t = 0 !== (t = e.lastExpiredTime) ? t : 1073741823;
    if (e.finishedExpirationTime === t) Fc(e);
    else {
      if ((Ai & (Oi | Ri)) !== Pi) throw Error(ho(327));
      if ((Bc(), (e === Fi && t === Wi) || Rc(e, t), null !== Bi)) {
        var n = Ai;
        Ai |= Oi;
        for (var r = Nc(); ; )
          try {
            !(function () {
              for (; null !== Bi; ) Bi = _c(Bi);
            })();
            break;
          } catch (t) {
            Mc(e, t);
          }
        if ((js(), (Ai = n), (ki.current = r), $i === Ni))
          throw ((n = ji), Rc(e, t), eu(e, t), kc(e), n);
        if (null !== Bi) throw Error(ho(261));
        (e.finishedWork = e.current.alternate),
          (e.finishedExpirationTime = t),
          (Fi = null),
          Fc(e),
          kc(e);
      }
    }
    return null;
  }
  function zc(e, t) {
    var n = Ai;
    Ai |= 1;
    try {
      return e(t);
    } finally {
      (Ai = n) === Pi && Fs();
    }
  }
  function Oc(e, t) {
    var n = Ai;
    (Ai &= -2), (Ai |= zi);
    try {
      return e(t);
    } finally {
      (Ai = n) === Pi && Fs();
    }
  }
  function Rc(e, t) {
    (e.finishedWork = null), (e.finishedExpirationTime = 0);
    var n = e.timeoutHandle;
    if ((-1 !== n && ((e.timeoutHandle = -1), kn(n)), null !== Bi))
      for (n = Bi.return; null !== n; ) {
        var r = n;
        switch (r.tag) {
          case 1:
            null != r.type.childContextTypes && Ps();
            break;
          case 3:
            ml(), zs();
            break;
          case 5:
            vl(r);
            break;
          case 4:
            ml();
            break;
          case 13:
          case 19:
            Ss(Gr);
            break;
          case 10:
            Vs(r);
        }
        n = n.return;
      }
    (Bi = Gc((Fi = e).current, null)),
      (Wi = t),
      ($i = Mi),
      (Vi = Hi = 1073741823),
      (qi = ji = null),
      (Ui = 0),
      (Gi = !1);
  }
  function Mc(e, t) {
    for (;;) {
      try {
        if ((js(), Sl(), null === Bi || null === Bi.return))
          return ($i = Ni), (ji = t), 0;
        e: {
          var n = e,
            r = Bi.return,
            i = Bi,
            o = t;
          if (
            ((t = Wi),
            (i.effectTag |= 2048),
            (i.firstEffect = i.lastEffect = null) !== o &&
              "object" == typeof o &&
              "function" == typeof o.then)
          ) {
            var a,
              s = o,
              l = 0 != (1 & Gr.current),
              c = r;
            do {
              if (
                ((u = 13 === c.tag) &&
                  (u =
                    null !== (a = c.memoizedState)
                      ? null !== a.dehydrated
                      : void 0 !== (d = c.memoizedProps).fallback &&
                        (!0 !== d.unstable_avoidThisFallback || !l)),
                u)
              ) {
                var u,
                  d = c.updateQueue;
                if (
                  (null === d
                    ? ((u = new Set()).add(s), (c.updateQueue = u))
                    : d.add(s),
                  0 == (2 & c.mode))
                ) {
                  (c.effectTag |= 64),
                    (i.effectTag &= -2981),
                    1 === i.tag &&
                      (null === i.alternate
                        ? (i.tag = 17)
                        : (((p = Ks(1073741823, null)).tag = 2), Qs(i, p))),
                    (i.expirationTime = 1073741823);
                  break e;
                }
                (o = void 0), (i = t);
                var p = n.pingCache;
                null === p
                  ? ((p = n.pingCache = new Si()), (o = new Set()), p.set(s, o))
                  : void 0 === (o = p.get(s)) && ((o = new Set()), p.set(s, o)),
                  o.has(i) ||
                    (o.add(i), (p = Hc.bind(null, n, s, i)), s.then(p, p)),
                  (c.effectTag |= 4096),
                  (c.expirationTime = t);
                break e;
              }
            } while (null !== (c = c.return));
            o = Error(
              (ko(i.type) || "A React component") +
                " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." +
                To(i)
            );
          }
          $i !== Di && ($i = Li), (o = lc(o, i)), (c = r);
          do {
            switch (c.tag) {
              case 3:
                (s = o),
                  (c.effectTag |= 4096),
                  (c.expirationTime = t),
                  Js(c, yc(c, s, t));
                break e;
              case 1:
                s = o;
                var f = c.type,
                  h = c.stateNode;
                if (
                  0 == (64 & c.effectTag) &&
                  ("function" == typeof f.getDerivedStateFromError ||
                    (null !== h &&
                      "function" == typeof h.componentDidCatch &&
                      (null === Ji || !Ji.has(h))))
                ) {
                  (c.effectTag |= 4096),
                    (c.expirationTime = t),
                    Js(c, bc(c, s, t));
                  break e;
                }
            }
          } while (null !== (c = c.return));
        }
        Bi = Dc(Bi);
      } catch (e) {
        t = e;
        continue;
      }
      break;
    }
  }
  function Nc() {
    var e = ki.current;
    return (ki.current = ci), null === e ? ci : e;
  }
  function Lc(e, t) {
    e < Hi && 2 < e && (Hi = e),
      null !== t && e < Vi && 2 < e && ((Vi = e), (qi = t));
  }
  function Ic(e) {
    Ui < e && (Ui = e);
  }
  function _c(e) {
    var t = so(e.alternate, e, Wi);
    return (
      (e.memoizedProps = e.pendingProps),
      null === t && (t = Dc(e)),
      (Ti.current = null),
      t
    );
  }
  function Dc(e) {
    Bi = e;
    do {
      var t = Bi.alternate;
      if (((e = Bi.return), 0 == (2048 & Bi.effectTag))) {
        e: {
          var n = t,
            r = Wi,
            i = (t = Bi).pendingProps;
          switch (t.tag) {
            case 2:
            case 16:
              break;
            case 15:
            case 0:
              break;
            case 1:
              Ts(t.type) && Ps();
              break;
            case 3:
              ml(),
                zs(),
                (i = t.stateNode).pendingContext &&
                  ((i.context = i.pendingContext), (i.pendingContext = null)),
                (null !== n && null !== n.child) || !Vl(t) || ac(t),
                bi(t);
              break;
            case 5:
              vl(t), (r = fl(Ur.current));
              var o = t.type;
              if (null !== n && null != t.stateNode)
                wi(n, t, o, i, r), n.ref !== t.ref && (t.effectTag |= 128);
              else if (i) {
                var a = fl(Vr.current);
                if (Vl(t)) {
                  var s = (i = t).stateNode,
                    n = i.type,
                    l = i.memoizedProps,
                    c = r;
                  switch (
                    ((s[Tn] = i), (s[Pn] = l), (o = void 0), (r = s), n)
                  ) {
                    case "iframe":
                    case "object":
                    case "embed":
                      La("load", r);
                      break;
                    case "video":
                    case "audio":
                      for (s = 0; s < Ct.length; s++) La(Ct[s], r);
                      break;
                    case "source":
                      La("error", r);
                      break;
                    case "img":
                    case "image":
                    case "link":
                      La("error", r), La("load", r);
                      break;
                    case "form":
                      La("reset", r), La("submit", r);
                      break;
                    case "details":
                      La("toggle", r);
                      break;
                    case "input":
                      jo(r, l), La("invalid", r), qa(c, "onChange");
                      break;
                    case "select":
                      (r._wrapperState = { wasMultiple: !!l.multiple }),
                        La("invalid", r),
                        qa(c, "onChange");
                      break;
                    case "textarea":
                      Ko(r, l), La("invalid", r), qa(c, "onChange");
                  }
                  for (o in (Ha(n, l), (s = null), l))
                    l.hasOwnProperty(o) &&
                      ((a = l[o]),
                      "children" === o
                        ? "string" == typeof a
                          ? r.textContent !== a && (s = ["children", a])
                          : "number" == typeof a &&
                            r.textContent !== "" + a &&
                            (s = ["children", "" + a])
                        : ze.hasOwnProperty(o) && null != a && qa(c, o));
                  switch (n) {
                    case "input":
                      Bo(r), qo(r, l, !0);
                      break;
                    case "textarea":
                      Bo(r), Qo(r);
                      break;
                    case "select":
                    case "option":
                      break;
                    default:
                      "function" == typeof l.onClick && (r.onclick = Ua);
                  }
                  (o = s), (i.updateQueue = o), (i = null !== o) && ac(t);
                } else {
                  (n = t),
                    (c = o),
                    (l = i),
                    (s = 9 === r.nodeType ? r : r.ownerDocument),
                    a === ht.html && (a = Jo(c)),
                    a === ht.html
                      ? "script" === c
                        ? (((l = s.createElement("div")).innerHTML =
                            "<script></script>"),
                          (s = l.removeChild(l.firstChild)))
                        : "string" == typeof l.is
                        ? (s = s.createElement(c, { is: l.is }))
                        : ((s = s.createElement(c)),
                          "select" === c &&
                            ((c = s),
                            l.multiple
                              ? (c.multiple = !0)
                              : l.size && (c.size = l.size)))
                      : (s = s.createElementNS(a, c)),
                    ((l = s)[Tn] = n),
                    (l[Pn] = i),
                    yi(l, t, !1, !1),
                    (t.stateNode = l);
                  var u = r,
                    d = Va((c = o), (n = i));
                  switch (c) {
                    case "iframe":
                    case "object":
                    case "embed":
                      La("load", l), (r = n);
                      break;
                    case "video":
                    case "audio":
                      for (r = 0; r < Ct.length; r++) La(Ct[r], l);
                      r = n;
                      break;
                    case "source":
                      La("error", l), (r = n);
                      break;
                    case "img":
                    case "image":
                    case "link":
                      La("error", l), La("load", l), (r = n);
                      break;
                    case "form":
                      La("reset", l), La("submit", l), (r = n);
                      break;
                    case "details":
                      La("toggle", l), (r = n);
                      break;
                    case "input":
                      jo(l, n),
                        (r = $o(l, n)),
                        La("invalid", l),
                        qa(u, "onChange");
                      break;
                    case "option":
                      r = Go(l, n);
                      break;
                    case "select":
                      (l._wrapperState = { wasMultiple: !!n.multiple }),
                        (r = Ee({}, n, { value: void 0 })),
                        La("invalid", l),
                        qa(u, "onChange");
                      break;
                    case "textarea":
                      Ko(l, n),
                        (r = Xo(l, n)),
                        La("invalid", l),
                        qa(u, "onChange");
                      break;
                    default:
                      r = n;
                  }
                  Ha(c, r), (s = void 0), (a = c);
                  var p,
                    f = l,
                    h = r;
                  for (s in h)
                    h.hasOwnProperty(s) &&
                      ((p = h[s]),
                      "style" === s
                        ? ja(f, p)
                        : "dangerouslySetInnerHTML" === s
                        ? null != (p = p ? p.__html : void 0) && gt(f, p)
                        : "children" === s
                        ? "string" == typeof p
                          ? ("textarea" === a && "" === p) || ta(f, p)
                          : "number" == typeof p && ta(f, "" + p)
                        : "suppressContentEditableWarning" !== s &&
                          "suppressHydrationWarning" !== s &&
                          "autoFocus" !== s &&
                          (ze.hasOwnProperty(s)
                            ? null != p && qa(u, s)
                            : null != p && Ao(f, s, p, d)));
                  switch (c) {
                    case "input":
                      Bo(l), qo(l, n, !1);
                      break;
                    case "textarea":
                      Bo(l), Qo(l);
                      break;
                    case "option":
                      null != n.value &&
                        l.setAttribute("value", "" + Do(n.value));
                      break;
                    case "select":
                      ((r = l).multiple = !!n.multiple),
                        null != (l = n.value)
                          ? Yo(r, !!n.multiple, l, !1)
                          : null != n.defaultValue &&
                            Yo(r, !!n.multiple, n.defaultValue, !0);
                      break;
                    default:
                      "function" == typeof r.onClick && (l.onclick = Ua);
                  }
                  (i = Qa(o, i)) && ac(t);
                }
                null !== t.ref && (t.effectTag |= 128);
              } else if (null === t.stateNode) throw Error(ho(166));
              break;
            case 6:
              if (n && null != t.stateNode) xi(n, t, n.memoizedProps, i);
              else {
                if ("string" != typeof i && null === t.stateNode)
                  throw Error(ho(166));
                (r = fl(Ur.current)),
                  fl(Vr.current),
                  Vl(t)
                    ? ((o = (i = t).stateNode),
                      (r = i.memoizedProps),
                      (o[Tn] = i),
                      (i = o.nodeValue !== r) && ac(t))
                    : ((o = t),
                      ((i = (9 === r.nodeType
                        ? r
                        : r.ownerDocument
                      ).createTextNode(i))[Tn] = o),
                      (t.stateNode = i));
              }
              break;
            case 11:
              break;
            case 13:
              if ((Ss(Gr), (i = t.memoizedState), 0 != (64 & t.effectTag))) {
                t.expirationTime = r;
                break e;
              }
              (i = null !== i),
                (o = !1),
                null === n
                  ? void 0 !== t.memoizedProps.fallback && Vl(t)
                  : ((o = null !== (r = n.memoizedState)),
                    i ||
                      null === r ||
                      (null !== (r = n.child.sibling) &&
                        (null !== (l = t.firstEffect)
                          ? ((t.firstEffect = r).nextEffect = l)
                          : ((t.firstEffect = t.lastEffect = r).nextEffect = null),
                        (r.effectTag = 8)))),
                i &&
                  !o &&
                  0 != (2 & t.mode) &&
                  ((null === n &&
                    !0 !== t.memoizedProps.unstable_avoidThisFallback) ||
                  0 != (1 & Gr.current)
                    ? $i === Mi && ($i = Ii)
                    : (($i !== Mi && $i !== Ii) || ($i = _i),
                      0 !== Ui && null !== Fi && (eu(Fi, Wi), tu(Fi, Ui)))),
                (i || o) && (t.effectTag |= 4);
              break;
            case 7:
            case 8:
            case 12:
              break;
            case 4:
              ml(), bi(t);
              break;
            case 10:
              Vs(t);
              break;
            case 9:
            case 14:
              break;
            case 17:
              Ts(t.type) && Ps();
              break;
            case 19:
              if ((Ss(Gr), null === (i = t.memoizedState))) break;
              if (((o = 0 != (64 & t.effectTag)), null === (l = i.rendering))) {
                if (o) sc(i, !1);
                else if ($i !== Mi || (null !== n && 0 != (64 & n.effectTag)))
                  for (n = t.child; null !== n; ) {
                    if (null !== (l = yl(n))) {
                      for (
                        t.effectTag |= 64,
                          sc(i, !1),
                          null !== (o = l.updateQueue) &&
                            ((t.updateQueue = o), (t.effectTag |= 4)),
                          null === i.lastEffect && (t.firstEffect = null),
                          t.lastEffect = i.lastEffect,
                          i = r,
                          o = t.child;
                        null !== o;

                      )
                        (n = i),
                          ((r = o).effectTag &= 2),
                          (r.nextEffect = null),
                          (r.firstEffect = null),
                          (r.lastEffect = null) === (l = r.alternate)
                            ? ((r.childExpirationTime = 0),
                              (r.expirationTime = n),
                              (r.child = null),
                              (r.memoizedProps = null),
                              (r.memoizedState = null),
                              (r.updateQueue = null),
                              (r.dependencies = null))
                            : ((r.childExpirationTime = l.childExpirationTime),
                              (r.expirationTime = l.expirationTime),
                              (r.child = l.child),
                              (r.memoizedProps = l.memoizedProps),
                              (r.memoizedState = l.memoizedState),
                              (r.updateQueue = l.updateQueue),
                              (n = l.dependencies),
                              (r.dependencies =
                                null === n
                                  ? null
                                  : {
                                      expirationTime: n.expirationTime,
                                      firstContext: n.firstContext,
                                      responders: n.responders,
                                    })),
                          (o = o.sibling);
                      Cs(Gr, (1 & Gr.current) | 2), (t = t.child);
                      break e;
                    }
                    n = n.sibling;
                  }
              } else {
                if (!o)
                  if (null !== (n = yl(l))) {
                    if (
                      ((t.effectTag |= 64),
                      (o = !0),
                      null !== (r = n.updateQueue) &&
                        ((t.updateQueue = r), (t.effectTag |= 4)),
                      sc(i, !0),
                      null === i.tail &&
                        "hidden" === i.tailMode &&
                        !l.alternate)
                    ) {
                      null !== (t = t.lastEffect = i.lastEffect) &&
                        (t.nextEffect = null);
                      break;
                    }
                  } else
                    Rr() > i.tailExpiration &&
                      1 < r &&
                      ((t.effectTag |= 64),
                      sc(i, !(o = !0)),
                      (t.expirationTime = t.childExpirationTime = r - 1));
                i.isBackwards
                  ? ((l.sibling = t.child), (t.child = l))
                  : (null !== (r = i.last) ? (r.sibling = l) : (t.child = l),
                    (i.last = l));
              }
              if (null === i.tail) break;
              0 === i.tailExpiration && (i.tailExpiration = Rr() + 500),
                (r = i.tail),
                (i.rendering = r),
                (i.tail = r.sibling),
                (i.lastEffect = t.lastEffect),
                (r.sibling = null),
                (i = Gr.current),
                Cs(Gr, (i = o ? (1 & i) | 2 : 1 & i)),
                (t = r);
              break e;
            case 20:
            case 21:
              break;
            default:
              throw Error(ho(156, t.tag));
          }
          t = null;
        }
        if (((i = Bi), 1 === Wi || 1 !== i.childExpirationTime)) {
          for (o = 0, r = i.child; null !== r; )
            (n = r.expirationTime) > o && (o = n),
              (l = r.childExpirationTime) > o && (o = l),
              (r = r.sibling);
          i.childExpirationTime = o;
        }
        if (null !== t) return t;
        null !== e &&
          0 == (2048 & e.effectTag) &&
          (null === e.firstEffect && (e.firstEffect = Bi.firstEffect),
          null !== Bi.lastEffect &&
            (null !== e.lastEffect &&
              (e.lastEffect.nextEffect = Bi.firstEffect),
            (e.lastEffect = Bi.lastEffect)),
          1 < Bi.effectTag &&
            (null !== e.lastEffect
              ? (e.lastEffect.nextEffect = Bi)
              : (e.firstEffect = Bi),
            (e.lastEffect = Bi)));
      } else {
        if (
          null !==
          (t = (function (e) {
            switch (e.tag) {
              case 1:
                Ts(e.type) && Ps();
                var t = e.effectTag;
                return 4096 & t ? ((e.effectTag = (-4097 & t) | 64), e) : null;
              case 3:
                if ((ml(), zs(), 0 != (64 & (t = e.effectTag))))
                  throw Error(ho(285));
                return (e.effectTag = (-4097 & t) | 64), e;
              case 5:
                return vl(e), null;
              case 13:
                return (
                  Ss(Gr),
                  4096 & (t = e.effectTag)
                    ? ((e.effectTag = (-4097 & t) | 64), e)
                    : null
                );
              case 19:
                return Ss(Gr), null;
              case 4:
                return ml(), null;
              case 10:
                return Vs(e), null;
              default:
                return null;
            }
          })(Bi))
        )
          return (t.effectTag &= 2047), t;
        null !== e &&
          ((e.firstEffect = e.lastEffect = null), (e.effectTag |= 2048));
      }
      if (null !== (t = Bi.sibling)) return t;
    } while (null !== (Bi = e));
    return $i === Mi && ($i = Di), null;
  }
  function Ac(e) {
    var t = e.expirationTime;
    return t > (e = e.childExpirationTime) ? t : e;
  }
  function Fc(e) {
    var t = Ls();
    return (
      _s(
        99,
        function (e, t) {
          for (; Bc(), null !== to; );
          if ((Ai & (Oi | Ri)) !== Pi) throw Error(ho(327));
          var n = e.finishedWork,
            r = e.finishedExpirationTime;
          if (null === n) return null;
          if (
            ((e.finishedWork = null),
            (e.finishedExpirationTime = 0),
            n === e.current)
          )
            throw Error(ho(177));
          (e.callbackNode = null),
            (e.callbackExpirationTime = 0),
            (e.callbackPriority = 90),
            (e.nextKnownPendingLevel = 0);
          var i,
            o = Ac(n);
          if (
            ((e.firstPendingTime = o),
            r <= e.lastSuspendedTime
              ? (e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0)
              : r <= e.firstSuspendedTime && (e.firstSuspendedTime = r - 1),
            r <= e.lastPingedTime && (e.lastPingedTime = 0),
            r <= e.lastExpiredTime && (e.lastExpiredTime = 0),
            e === Fi && ((Bi = Fi = null), (Wi = 0)),
            (o =
              1 < n.effectTag
                ? null !== n.lastEffect
                  ? ((n.lastEffect.nextEffect = n), n.firstEffect)
                  : n
                : n.firstEffect),
            null !== o)
          ) {
            var a = Ai;
            (Ai |= Ri), (Ti.current = null), (En = fn);
            var s = Ka();
            if (Za(s)) {
              if ("selectionStart" in s)
                var l = { start: s.selectionStart, end: s.selectionEnd };
              else
                e: {
                  var c =
                    (l = ((l = s.ownerDocument) && l.defaultView) || window)
                      .getSelection && l.getSelection();
                  if (c && 0 !== c.rangeCount) {
                    l = c.anchorNode;
                    var u = c.anchorOffset,
                      d = c.focusNode;
                    c = c.focusOffset;
                    try {
                      l.nodeType, d.nodeType;
                    } catch (e) {
                      l = null;
                      break e;
                    }
                    var p = 0,
                      f = -1,
                      h = -1,
                      m = 0,
                      g = 0,
                      v = s,
                      y = null;
                    t: for (;;) {
                      for (
                        ;
                        v !== l || (0 !== u && 3 !== v.nodeType) || (f = p + u),
                          v !== d ||
                            (0 !== c && 3 !== v.nodeType) ||
                            (h = p + c),
                          3 === v.nodeType && (p += v.nodeValue.length),
                          null !== (i = v.firstChild);

                      )
                        (y = v), (v = i);
                      for (;;) {
                        if (v === s) break t;
                        if (
                          (y === l && ++m === u && (f = p),
                          y === d && ++g === c && (h = p),
                          null !== (i = v.nextSibling))
                        )
                          break;
                        y = (v = y).parentNode;
                      }
                      v = i;
                    }
                    l = -1 === f || -1 === h ? null : { start: f, end: h };
                  } else l = null;
                }
              l = l || { start: 0, end: 0 };
            } else l = null;
            (fn = !(Sn = { focusedElem: s, selectionRange: l })), (Ki = o);
            do {
              try {
                !(function () {
                  for (; null !== Ki; ) {
                    var e = Ki.effectTag;
                    0 != (256 & e) &&
                      (function (e, t) {
                        switch (t.tag) {
                          case 0:
                          case 11:
                          case 15:
                            dc(2, 0, t);
                            break;
                          case 1:
                            var n, r;
                            256 & t.effectTag &&
                              null !== e &&
                              ((n = e.memoizedProps),
                              (r = e.memoizedState),
                              (t = (e = t.stateNode).getSnapshotBeforeUpdate(
                                t.elementType === t.type ? n : $s(t.type, n),
                                r
                              )),
                              (e.__reactInternalSnapshotBeforeUpdate = t));
                            break;
                          case 3:
                          case 5:
                          case 6:
                          case 4:
                          case 17:
                            break;
                          default:
                            throw Error(ho(163));
                        }
                      })(Ki.alternate, Ki),
                      0 == (512 & e) ||
                        eo ||
                        ((eo = !0),
                        Ds(97, function () {
                          return Bc(), null;
                        })),
                      (Ki = Ki.nextEffect);
                  }
                })();
              } catch (e) {
                if (null === Ki) throw Error(ho(330));
                jc(Ki, e), (Ki = Ki.nextEffect);
              }
            } while (null !== Ki);
            Ki = o;
            do {
              try {
                for (s = e, l = t; null !== Ki; ) {
                  var b,
                    w,
                    x = Ki.effectTag;
                  switch (
                    (16 & x && ta(Ki.stateNode, ""),
                    128 & x &&
                      (null === (b = Ki.alternate) ||
                        (null !== (w = b.ref) &&
                          ("function" == typeof w
                            ? w(null)
                            : (w.current = null)))),
                    1038 & x)
                  ) {
                    case 2:
                      hc(Ki), (Ki.effectTag &= -3);
                      break;
                    case 6:
                      hc(Ki), (Ki.effectTag &= -3), gc(Ki.alternate, Ki);
                      break;
                    case 1024:
                      Ki.effectTag &= -1025;
                      break;
                    case 1028:
                      (Ki.effectTag &= -1025), gc(Ki.alternate, Ki);
                      break;
                    case 4:
                      gc(Ki.alternate, Ki);
                      break;
                    case 8:
                      mc(s, (u = Ki), l),
                        (function e(t) {
                          var n = t.alternate;
                          (t.return = null),
                            (t.child = null),
                            (t.memoizedState = null),
                            (t.updateQueue = null),
                            (t.dependencies = null),
                            (t.alternate = null),
                            (t.firstEffect = null),
                            (t.lastEffect = null),
                            (t.pendingProps = null),
                            (t.memoizedProps = null) !== n && e(n);
                        })(u);
                  }
                  Ki = Ki.nextEffect;
                }
              } catch (e) {
                if (null === Ki) throw Error(ho(330));
                jc(Ki, e), (Ki = Ki.nextEffect);
              }
            } while (null !== Ki);
            if (
              ((w = Sn),
              (b = Ka()),
              (x = w.focusedElem),
              (l = w.selectionRange),
              b !== x &&
                x &&
                x.ownerDocument &&
                (function e(t, n) {
                  return (
                    !(!t || !n) &&
                    (t === n ||
                      ((!t || 3 !== t.nodeType) &&
                        (n && 3 === n.nodeType
                          ? e(t, n.parentNode)
                          : "contains" in t
                          ? t.contains(n)
                          : !!t.compareDocumentPosition &&
                            !!(16 & t.compareDocumentPosition(n)))))
                  );
                })(x.ownerDocument.documentElement, x))
            ) {
              null !== l &&
                Za(x) &&
                ((b = l.start),
                void 0 === (w = l.end) && (w = b),
                "selectionStart" in x
                  ? ((x.selectionStart = b),
                    (x.selectionEnd = Math.min(w, x.value.length)))
                  : (w =
                      ((b = x.ownerDocument || document) && b.defaultView) ||
                      window).getSelection &&
                    ((w = w.getSelection()),
                    (u = x.textContent.length),
                    (s = Math.min(l.start, u)),
                    (l = void 0 === l.end ? s : Math.min(l.end, u)),
                    !w.extend && l < s && ((u = l), (l = s), (s = u)),
                    (u = Xa(x, s)),
                    (d = Xa(x, l)),
                    u &&
                      d &&
                      (1 !== w.rangeCount ||
                        w.anchorNode !== u.node ||
                        w.anchorOffset !== u.offset ||
                        w.focusNode !== d.node ||
                        w.focusOffset !== d.offset) &&
                      ((b = b.createRange()).setStart(u.node, u.offset),
                      w.removeAllRanges(),
                      l < s
                        ? (w.addRange(b), w.extend(d.node, d.offset))
                        : (b.setEnd(d.node, d.offset), w.addRange(b))))),
                (b = []);
              for (w = x; (w = w.parentNode); )
                1 === w.nodeType &&
                  b.push({ element: w, left: w.scrollLeft, top: w.scrollTop });
              for (
                "function" == typeof x.focus && x.focus(), x = 0;
                x < b.length;
                x++
              )
                ((w = b[x]).element.scrollLeft = w.left),
                  (w.element.scrollTop = w.top);
            }
            (fn = !!En), (En = Sn = null), (e.current = n), (Ki = o);
            do {
              try {
                for (x = r; null !== Ki; ) {
                  var E,
                    S = Ki.effectTag;
                  if (36 & S) {
                    var C = Ki.alternate;
                    switch (((w = x), (b = Ki).tag)) {
                      case 0:
                      case 11:
                      case 15:
                        dc(16, 32, b);
                        break;
                      case 1:
                        var k = b.stateNode;
                        4 & b.effectTag &&
                          (null === C
                            ? k.componentDidMount()
                            : ((T =
                                b.elementType === b.type
                                  ? C.memoizedProps
                                  : $s(b.type, C.memoizedProps)),
                              k.componentDidUpdate(
                                T,
                                C.memoizedState,
                                k.__reactInternalSnapshotBeforeUpdate
                              )));
                        var T = b.updateQueue;
                        null !== T && rl(0, T, k);
                        break;
                      case 3:
                        k = b.updateQueue;
                        if (null !== k) {
                          if ((s = null) !== b.child)
                            switch (b.child.tag) {
                              case 5:
                                s = b.child.stateNode;
                                break;
                              case 1:
                                s = b.child.stateNode;
                            }
                          rl(0, k, s);
                        }
                        break;
                      case 5:
                        var P = b.stateNode;
                        null === C &&
                          4 & b.effectTag &&
                          Qa(b.type, b.memoizedProps) &&
                          P.focus();
                        break;
                      case 6:
                      case 4:
                      case 12:
                        break;
                      case 13:
                        null !== b.memoizedState ||
                          (null !== (P = b.alternate) &&
                            (null === (P = P.memoizedState) ||
                              (null !== (P = P.dehydrated) && ma(P))));
                        break;
                      case 19:
                      case 17:
                      case 20:
                      case 21:
                        break;
                      default:
                        throw Error(ho(163));
                    }
                  }
                  128 & S &&
                    ((b = void 0),
                    null !== (E = Ki.ref) &&
                      ((S = Ki.stateNode),
                      (b = (Ki.tag, S)),
                      "function" == typeof E ? E(b) : (E.current = b))),
                    (Ki = Ki.nextEffect);
                }
              } catch (e) {
                if (null === Ki) throw Error(ho(330));
                jc(Ki, e), (Ki = Ki.nextEffect);
              }
            } while (null !== Ki);
            (Ki = null), kr(), (Ai = a);
          } else e.current = n;
          if (eo) (eo = !1), (to = e), (no = t);
          else
            for (Ki = o; null !== Ki; )
              (t = Ki.nextEffect), (Ki.nextEffect = null), (Ki = t);
          if (
            (0 === (t = e.firstPendingTime) && (Ji = null),
            1073741823 === t
              ? e === oo
                ? io++
                : ((io = 0), (oo = e))
              : (io = 0),
            "function" == typeof lo && lo(n.stateNode, r),
            kc(e),
            Zi)
          )
            throw ((Zi = !1), (e = Qi), (Qi = null), e);
          return (Ai & zi) !== Pi || Fs(), null;
        }.bind(null, e, t)
      ),
      null
    );
  }
  function Bc() {
    if (90 !== no) {
      var e = 97 < no ? 97 : no;
      return (no = 90), _s(e, Wc);
    }
  }
  function Wc() {
    if (null === to) return !1;
    var e = to;
    if (((to = null), (Ai & (Oi | Ri)) !== Pi)) throw Error(ho(331));
    var t = Ai;
    for (Ai |= Ri, e = e.current.firstEffect; null !== e; ) {
      try {
        var n = e;
        if (0 != (512 & n.effectTag))
          switch (n.tag) {
            case 0:
            case 11:
            case 15:
              dc(128, 0, n), dc(0, 64, n);
          }
      } catch (t) {
        if (null === e) throw Error(ho(330));
        jc(e, t);
      }
      (n = e.nextEffect), (e.nextEffect = null), (e = n);
    }
    return (Ai = t), Fs(), !0;
  }
  function $c(e, t, n) {
    Qs(e, (t = yc(e, (t = lc(n, t)), 1073741823))),
      null !== (e = Sc(e, 1073741823)) && kc(e);
  }
  function jc(e, t) {
    if (3 === e.tag) $c(e, e, t);
    else
      for (var n = e.return; null !== n; ) {
        if (3 === n.tag) {
          $c(n, e, t);
          break;
        }
        if (1 === n.tag) {
          var r = n.stateNode;
          if (
            "function" == typeof n.type.getDerivedStateFromError ||
            ("function" == typeof r.componentDidCatch &&
              (null === Ji || !Ji.has(r)))
          ) {
            Qs(n, (e = bc(n, (e = lc(t, e)), 1073741823))),
              null !== (n = Sc(n, 1073741823)) && kc(n);
            break;
          }
        }
        n = n.return;
      }
  }
  function Hc(e, t, n) {
    var r = e.pingCache;
    null !== r && r.delete(t),
      Fi === e && Wi === n
        ? $i === _i || ($i === Ii && 1073741823 === Hi && Rr() - Yi < Xi)
          ? Rc(e, Wi)
          : (Gi = !0)
        : Jc(e, n) &&
          ((0 !== (t = e.lastPingedTime) && t < n) ||
            ((e.lastPingedTime = n),
            e.finishedExpirationTime === n &&
              ((e.finishedExpirationTime = 0), (e.finishedWork = null)),
            kc(e)));
  }
  function Vc(e, t, n, r) {
    (this.tag = e),
      (this.key = n),
      (this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null),
      (this.index = 0),
      (this.ref = null),
      (this.pendingProps = t),
      (this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null),
      (this.mode = r),
      (this.effectTag = 0),
      (this.lastEffect = this.firstEffect = this.nextEffect = null),
      (this.childExpirationTime = this.expirationTime = 0),
      (this.alternate = null);
  }
  function qc(e, t, n, r) {
    return new Vc(e, t, n, r);
  }
  function Uc(e) {
    return (e = e.prototype) && e.isReactComponent;
  }
  function Gc(e, t) {
    var n = e.alternate;
    return (
      null === n
        ? (((n = qc(e.tag, t, e.key, e.mode)).elementType = e.elementType),
          (n.type = e.type),
          (n.stateNode = e.stateNode),
          ((n.alternate = e).alternate = n))
        : ((n.pendingProps = t),
          (n.effectTag = 0),
          (n.nextEffect = null),
          (n.firstEffect = null),
          (n.lastEffect = null)),
      (n.childExpirationTime = e.childExpirationTime),
      (n.expirationTime = e.expirationTime),
      (n.child = e.child),
      (n.memoizedProps = e.memoizedProps),
      (n.memoizedState = e.memoizedState),
      (n.updateQueue = e.updateQueue),
      (t = e.dependencies),
      (n.dependencies =
        null === t
          ? null
          : {
              expirationTime: t.expirationTime,
              firstContext: t.firstContext,
              responders: t.responders,
            }),
      (n.sibling = e.sibling),
      (n.index = e.index),
      (n.ref = e.ref),
      n
    );
  }
  function Yc(e, t, n, r, i, o) {
    var a = 2;
    if ("function" == typeof (r = e)) Uc(e) && (a = 1);
    else if ("string" == typeof e) a = 5;
    else
      e: switch (e) {
        case He:
          return Xc(n.children, i, o, t);
        case Ye:
          (a = 8), (i |= 7);
          break;
        case Ve:
          (a = 8), (i |= 1);
          break;
        case qe:
          return (
            ((e = qc(12, n, t, 8 | i)).elementType = qe),
            (e.type = qe),
            (e.expirationTime = o),
            e
          );
        case Ke:
          return (
            ((e = qc(13, n, t, i)).type = Ke),
            (e.elementType = Ke),
            (e.expirationTime = o),
            e
          );
        case Ze:
          return (
            ((e = qc(19, n, t, i)).elementType = Ze), (e.expirationTime = o), e
          );
        default:
          if ("object" == typeof e && null !== e)
            switch (e.$$typeof) {
              case Ue:
                a = 10;
                break e;
              case Ge:
                a = 9;
                break e;
              case Xe:
                a = 11;
                break e;
              case Qe:
                a = 14;
                break e;
              case Je:
                (a = 16), (r = null);
                break e;
            }
          throw Error(ho(130, null == e ? e : typeof e, ""));
      }
    return (
      ((t = qc(a, n, t, i)).elementType = e),
      (t.type = r),
      (t.expirationTime = o),
      t
    );
  }
  function Xc(e, t, n, r) {
    return ((e = qc(7, e, r, t)).expirationTime = n), e;
  }
  function Kc(e, t, n) {
    return ((e = qc(6, e, null, t)).expirationTime = n), e;
  }
  function Zc(e, t, n) {
    return (
      ((t = qc(
        4,
        null !== e.children ? e.children : [],
        e.key,
        t
      )).expirationTime = n),
      (t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation,
      }),
      t
    );
  }
  function Qc(e, t, n) {
    (this.tag = t),
      (this.current = null),
      (this.containerInfo = e),
      (this.pingCache = this.pendingChildren = null),
      (this.finishedExpirationTime = 0),
      (this.finishedWork = null),
      (this.timeoutHandle = -1),
      (this.pendingContext = this.context = null),
      (this.hydrate = n),
      (this.callbackNode = null),
      (this.callbackPriority = 90),
      (this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0);
  }
  function Jc(e, t) {
    var n = e.firstSuspendedTime;
    return (e = e.lastSuspendedTime), 0 !== n && t <= n && e <= t;
  }
  function eu(e, t) {
    var n = e.firstSuspendedTime,
      r = e.lastSuspendedTime;
    n < t && (e.firstSuspendedTime = t),
      (t < r || 0 === n) && (e.lastSuspendedTime = t),
      t <= e.lastPingedTime && (e.lastPingedTime = 0),
      t <= e.lastExpiredTime && (e.lastExpiredTime = 0);
  }
  function tu(e, t) {
    t > e.firstPendingTime && (e.firstPendingTime = t);
    var n = e.firstSuspendedTime;
    0 !== n &&
      (n <= t
        ? (e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0)
        : t >= e.lastSuspendedTime && (e.lastSuspendedTime = t + 1),
      t > e.nextKnownPendingLevel && (e.nextKnownPendingLevel = t));
  }
  function nu(e, t) {
    var n = e.lastExpiredTime;
    (0 === n || t < n) && (e.lastExpiredTime = t);
  }
  function ru(e, t, n, r) {
    var i = t.current,
      o = wc(),
      a = Ar.suspense,
      o = xc(o, i, a);
    e: if (n) {
      t: {
        if (ia((n = n._reactInternalFiber)) !== n || 1 !== n.tag)
          throw Error(ho(170));
        var s = n;
        do {
          switch (s.tag) {
            case 3:
              s = s.stateNode.context;
              break t;
            case 1:
              if (Ts(s.type)) {
                s = s.stateNode.__reactInternalMemoizedMergedChildContext;
                break t;
              }
          }
        } while (null !== (s = s.return));
        throw Error(ho(171));
      }
      if (1 === n.tag) {
        var l = n.type;
        if (Ts(l)) {
          n = Rs(n, l, s);
          break e;
        }
      }
      n = s;
    } else n = lr;
    return (
      null === t.context ? (t.context = n) : (t.pendingContext = n),
      ((t = Ks(o, a)).payload = { element: e }),
      null !== (r = void 0 === r ? null : r) && (t.callback = r),
      Qs(i, t),
      Ec(i, o),
      o
    );
  }
  function iu(e) {
    return (e = e.current).child ? (e.child.tag, e.child.stateNode) : null;
  }
  function ou(e, t) {
    null !== (e = e.memoizedState) &&
      null !== e.dehydrated &&
      e.retryTime < t &&
      (e.retryTime = t);
  }
  function au(e, t) {
    ou(e, t), (e = e.alternate) && ou(e, t);
  }
  function su(e, t, n) {
    var r,
      i,
      o = new Qc(e, t, (n = null != n && !0 === n.hydrate)),
      a = qc(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0);
    ((o.current = a).stateNode = o),
      (e[zn] = o.current),
      n &&
        0 !== t &&
        ((r = 9 === e.nodeType ? e : e.ownerDocument),
        (i = Ba(r)),
        Dt.forEach(function (e) {
          Wa(e, r, i);
        }),
        At.forEach(function (e) {
          Wa(e, r, i);
        })),
      (this._internalRoot = o);
  }
  function lu(e) {
    return (
      e &&
      (1 === e.nodeType ||
        9 === e.nodeType ||
        11 === e.nodeType ||
        (8 === e.nodeType && " react-mount-point-unstable " === e.nodeValue))
    );
  }
  function cu(e, t, n, r, i) {
    var o,
      a,
      s,
      l = n._reactRootContainer;
    return (
      l
        ? ((s = l._internalRoot),
          "function" == typeof i &&
            ((o = i),
            (i = function () {
              var e = iu(s);
              o.call(e);
            })),
          ru(t, s, e, i))
        : ((s = (l = n._reactRootContainer = (function (e, t) {
            if (
              !(t =
                t ||
                !(
                  !(t = e
                    ? 9 === e.nodeType
                      ? e.documentElement
                      : e.firstChild
                    : null) ||
                  1 !== t.nodeType ||
                  !t.hasAttribute("data-reactroot")
                ))
            )
              for (var n; (n = e.lastChild); ) e.removeChild(n);
            return new su(e, 0, t ? { hydrate: !0 } : void 0);
          })(n, r))._internalRoot),
          "function" == typeof i &&
            ((a = i),
            (i = function () {
              var e = iu(s);
              a.call(e);
            })),
          Oc(function () {
            ru(t, s, e, i);
          })),
      iu(s)
    );
  }
  function uu(e, t) {
    var n =
      2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!lu(t)) throw Error(ho(200));
    return (function (e, t, n, r) {
      var i = 3 < arguments.length && void 0 !== r ? r : null;
      return {
        $$typeof: je,
        key: null == i ? null : "" + i,
        children: e,
        containerInfo: t,
        implementation: n,
      };
    })(e, t, null, n);
  }
  var du = {};
  function pu(e) {
    if (e.type) return e;
    if ("#" === e.charAt(0))
      return pu(
        (function (e) {
          e = e.substr(1);
          var t = new RegExp(".{1,".concat(e.length / 3, "}"), "g"),
            t = e.match(t);
          return (
            t &&
              1 === t[0].length &&
              (t = t.map(function (e) {
                return e + e;
              })),
            t
              ? "rgb(".concat(
                  t
                    .map(function (e) {
                      return parseInt(e, 16);
                    })
                    .join(", "),
                  ")"
                )
              : ""
          );
        })(e)
      );
    var t = e.indexOf("("),
      n = e.substring(0, t);
    if (-1 === ["rgb", "rgba", "hsl", "hsla"].indexOf(n))
      throw new Error(
        [
          "Material-UI: unsupported `".concat(e, "` color."),
          "We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().",
        ].join("\n")
      );
    return {
      type: n,
      values: e
        .substring(t + 1, e.length - 1)
        .split(",")
        .map(function (e) {
          return parseFloat(e);
        }),
    };
  }
  function fu(e) {
    var t = e.type,
      e = e.values;
    return (
      -1 !== t.indexOf("rgb")
        ? (e = e.map(function (e, t) {
            return t < 3 ? parseInt(e, 10) : e;
          }))
        : -1 !== t.indexOf("hsl") &&
          ((e[1] = "".concat(e[1], "%")), (e[2] = "".concat(e[2], "%"))),
      "".concat(t, "(").concat(e.join(", "), ")")
    );
  }
  function hu(e) {
    var t,
      n,
      r,
      i,
      o,
      a,
      s,
      e = (e = ("hsl" === (e = pu(e)).type
        ? pu(
            ((n = (t = pu((t = e))).values),
            (r = n[0]),
            (i = n[1] / 100),
            (o = n[2] / 100),
            (a = i * Math.min(o, 1 - o)),
            (s = function (e) {
              var t =
                1 < arguments.length && void 0 !== arguments[1]
                  ? arguments[1]
                  : (e + r / 30) % 12;
              return o - a * Math.max(Math.min(t - 3, 9 - t, 1), -1);
            }),
            (i = "rgb"),
            (s = [
              Math.round(255 * s(0)),
              Math.round(255 * s(8)),
              Math.round(255 * s(4)),
            ]),
            "hsla" === t.type && ((i += "a"), s.push(n[3])),
            fu({ type: i, values: s }))
          )
        : e
      ).values).map(function (e) {
        return (e /= 255) <= 0.03928
          ? e / 12.92
          : Math.pow((e + 0.055) / 1.055, 2.4);
      });
    return Number((0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2]).toFixed(3));
  }
  function mu(e, t) {
    var n = 1 < arguments.length && void 0 !== t ? t : 0.15;
    return (0.5 < hu(e) ? vu : yu)(e, n);
  }
  function gu(e, t) {
    return (
      (e = pu(e)),
      (t = r(t)),
      ("rgb" !== e.type && "hsl" !== e.type) || (e.type += "a"),
      (e.values[3] = t),
      fu(e)
    );
  }
  function vu(e, t) {
    if (((e = pu(e)), (t = r(t)), -1 !== e.type.indexOf("hsl")))
      e.values[2] *= 1 - t;
    else if (-1 !== e.type.indexOf("rgb"))
      for (var n = 0; n < 3; n += 1) e.values[n] *= 1 - t;
    return fu(e);
  }
  function yu(e, t) {
    if (((e = pu(e)), (t = r(t)), -1 !== e.type.indexOf("hsl")))
      e.values[2] += (100 - e.values[2]) * t;
    else if (-1 !== e.type.indexOf("rgb"))
      for (var n = 0; n < 3; n += 1) e.values[n] += (255 - e.values[n]) * t;
    return fu(e);
  }
  function bu(e, t, n) {
    return (
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function wu(e, t) {
    if (null == e) return {};
    for (var n, r = {}, i = Object.keys(e), o = 0; o < i.length; o++)
      (n = i[o]), 0 <= t.indexOf(n) || (r[n] = e[n]);
    return r;
  }
  function xu(e, t) {
    if (null == e) return {};
    var n,
      r = wu(e, t);
    if (Object.getOwnPropertySymbols)
      for (var i = Object.getOwnPropertySymbols(e), o = 0; o < i.length; o++)
        (n = i[o]),
          0 <= t.indexOf(n) ||
            (Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]));
    return r;
  }
  function Eu() {
    return (Eu =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
            r = arguments[t];
          for (n in r)
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }).apply(this, arguments);
  }
  !(function e() {
    if (
      "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
      "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
    )
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
      } catch (e) {
        console.error(e);
      }
  })(),
    (function () {
      if (
        (1,
        Q(),
        (xe = K),
        S(),
        (Ee = E),
        fo ||
          ((fo = !0),
          (gr = {}),
          pe ||
            ((pe = !0),
            (or = {}),
            Object.defineProperty(or, "__esModule", { value: !0 }),
            "undefined" == typeof window || "function" != typeof MessageChannel
              ? ((s = a = null),
                (l = function () {
                  if (null !== a)
                    try {
                      var e = J();
                      a(!0, e), (a = null);
                    } catch (e) {
                      throw (setTimeout(l, 0), e);
                    }
                }),
                (c = Date.now()),
                (J = function () {
                  return Date.now() - c;
                }),
                (or.unstable_now = J),
                (ee = function (e) {
                  null !== a
                    ? setTimeout(ee, 0, e)
                    : ((a = e), setTimeout(l, 0));
                }),
                (te = function (e, t) {
                  s = setTimeout(e, t);
                }),
                (ne = function () {
                  clearTimeout(s);
                }),
                (re = function () {
                  return !1;
                }),
                (uo = function () {}),
                (Gn = or.unstable_forceFrameRate = uo))
              : ((u = window.performance),
                (d = window.Date),
                (p = window.setTimeout),
                (f = window.clearTimeout),
                "undefined" != typeof console &&
                  ((w = window.cancelAnimationFrame),
                  "function" != typeof window.requestAnimationFrame &&
                    console.error(
                      "This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"
                    ),
                  "function" != typeof w &&
                    console.error(
                      "This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"
                    )),
                (J =
                  "object" == typeof u && "function" == typeof u.now
                    ? function () {
                        return u.now();
                      }
                    : ((h = d.now()),
                      function () {
                        return d.now() - h;
                      })),
                (or.unstable_now = J),
                (m = !1),
                (g = null),
                (v = -1),
                (y = 5),
                (b = 0),
                (re = function () {
                  return J() >= b;
                }),
                (Gn = function () {}),
                (uo = function (e) {
                  e < 0 || 125 < e
                    ? console.error(
                        "forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"
                      )
                    : (y = 0 < e ? Math.floor(1e3 / e) : 5);
                }),
                (or.unstable_forceFrameRate = uo),
                (w = new MessageChannel()),
                (x = w.port2),
                (w.port1.onmessage = function () {
                  if (null !== g) {
                    var e = J();
                    b = e + y;
                    try {
                      g(!0, e) ? x.postMessage(null) : ((m = !1), (g = null));
                    } catch (e) {
                      throw (x.postMessage(null), e);
                    }
                  } else m = !1;
                }),
                (ee = function (e) {
                  (g = e), m || ((m = !0), x.postMessage(null));
                }),
                (te = function (e, t) {
                  v = p(function () {
                    e(J());
                  }, t);
                }),
                (ne = function () {
                  f(v), (v = -1);
                })),
            (ie = []),
            (oe = []),
            (ae = 1),
            (se = null),
            (de = ue = ce = !(le = 3)),
            (Be = Gn),
            (or.unstable_ImmediatePriority = 1),
            (or.unstable_UserBlockingPriority = 2),
            (or.unstable_NormalPriority = 3),
            (or.unstable_IdlePriority = 5),
            (or.unstable_LowPriority = 4),
            (sn = function (e, t) {
              switch (e) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                  break;
                default:
                  e = 3;
              }
              var n = le;
              le = e;
              try {
                return t();
              } finally {
                le = n;
              }
            }),
            (or.unstable_runWithPriority = sn),
            (Kn = function (e) {
              switch (le) {
                case 1:
                case 2:
                case 3:
                  var t = 3;
                  break;
                default:
                  t = le;
              }
              var n = le;
              le = t;
              try {
                return e();
              } finally {
                le = n;
              }
            }),
            (or.unstable_next = Kn),
            (uo = function (e, t, n) {
              var r,
                i = J();
              return (
                "object" == typeof n && null !== n
                  ? ((r =
                      "number" == typeof (r = n.delay) && 0 < r ? i + r : i),
                    (n = "number" == typeof n.timeout ? n.timeout : we(e)))
                  : ((n = we(e)), (r = i)),
                (e = {
                  id: ae++,
                  callback: t,
                  priorityLevel: e,
                  startTime: r,
                  expirationTime: (n = r + n),
                  sortIndex: -1,
                }),
                i < r
                  ? ((e.sortIndex = r),
                    fe(oe, e),
                    null === he(ie) &&
                      e === he(oe) &&
                      (de ? ne() : (de = !0), te(ye, r - i)))
                  : ((e.sortIndex = n),
                    fe(ie, e),
                    ue || ce || ((ue = !0), ee(be))),
                e
              );
            }),
            (or.unstable_scheduleCallback = uo),
            (Gn = function (e) {
              e.callback = null;
            }),
            (or.unstable_cancelCallback = Gn),
            (sn = function (t) {
              var n = le;
              return function () {
                var e = le;
                le = n;
                try {
                  return t.apply(this, arguments);
                } finally {
                  le = e;
                }
              };
            }),
            (or.unstable_wrapCallback = sn),
            (Kn = function () {
              return le;
            }),
            (or.unstable_getCurrentPriorityLevel = Kn),
            (uo = function () {
              var e = J();
              ve(e);
              var t = he(ie);
              return (
                (t !== se &&
                  null !== se &&
                  null !== t &&
                  null !== t.callback &&
                  t.startTime <= e &&
                  t.expirationTime < se.expirationTime) ||
                re()
              );
            }),
            (or.unstable_shouldYield = uo),
            (or.unstable_requestPaint = Be),
            (Gn = function () {
              ue || ce || ((ue = !0), ee(be));
            }),
            (or.unstable_continueExecution = Gn),
            (sn = function () {}),
            (or.unstable_pauseExecution = sn),
            (Kn = function () {
              return he(ie);
            }),
            (or.unstable_getFirstCallbackNode = Kn),
            (or.unstable_Profiling = null)),
          (gr = or)),
        (Se = gr),
        !xe)
      )
        throw Error(ho(227));
      (ke = {}),
        (Te = []),
        (Pe = {}),
        (ze = {}),
        (Ne = Re = !(Oe = {})),
        (Ie = {
          onError: function (e) {
            (Re = !0), (Me = e);
          },
        }),
        (Fe = Ae = De = _e = Le = Me = Ce = null),
        (uo = {
          injectEventPluginOrder: function (e) {
            if (Ce) throw Error(ho(101));
            (Ce = Array.prototype.slice.call(e)), mo();
          },
          injectEventPluginsByName: function (e) {
            var t,
              n = !1;
            for (t in e)
              if (e.hasOwnProperty(t)) {
                var r = e[t];
                if (!ke.hasOwnProperty(t) || ke[t] !== r) {
                  if (ke[t]) throw Error(ho(102, t));
                  (ke[t] = r), (n = !0);
                }
              }
            n && mo();
          },
        }),
        (Be =
          xe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED).hasOwnProperty(
          "ReactCurrentDispatcher"
        ) || (Be.ReactCurrentDispatcher = { current: null }),
        Be.hasOwnProperty("ReactCurrentBatchConfig") ||
          (Be.ReactCurrentBatchConfig = { suspense: null }),
        (We = /^(.*)[\\\/]/),
        (Gn = "function" == typeof Symbol && Symbol.for),
        ($e = Gn ? Symbol.for("react.element") : 60103),
        (je = Gn ? Symbol.for("react.portal") : 60106),
        (He = Gn ? Symbol.for("react.fragment") : 60107),
        (Ve = Gn ? Symbol.for("react.strict_mode") : 60108),
        (qe = Gn ? Symbol.for("react.profiler") : 60114),
        (Ue = Gn ? Symbol.for("react.provider") : 60109),
        (Ge = Gn ? Symbol.for("react.context") : 60110),
        (Ye = Gn ? Symbol.for("react.concurrent_mode") : 60111),
        (Xe = Gn ? Symbol.for("react.forward_ref") : 60112),
        (Ke = Gn ? Symbol.for("react.suspense") : 60113),
        (Ze = Gn ? Symbol.for("react.suspense_list") : 60120),
        (Qe = Gn ? Symbol.for("react.memo") : 60115),
        (Je = Gn ? Symbol.for("react.lazy") : 60116),
        Gn && Symbol.for("react.fundamental"),
        Gn && Symbol.for("react.responder"),
        Gn && Symbol.for("react.scope"),
        (et = "function" == typeof Symbol && Symbol.iterator),
        (tt = !(
          "undefined" == typeof window ||
          void 0 === window.document ||
          void 0 === window.document.createElement
        )),
        (it = rt = nt = null),
        (ot = Ro),
        (st = at = !1),
        new Map(),
        (lt = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/),
        (ct = Object.prototype.hasOwnProperty),
        (ut = {}),
        (dt = {}),
        (pt = {}),
        "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
          .split(" ")
          .forEach(function (e) {
            pt[e] = new Io(e, 0, !1, e, null, !1);
          }),
        [
          ["acceptCharset", "accept-charset"],
          ["className", "class"],
          ["htmlFor", "for"],
          ["httpEquiv", "http-equiv"],
        ].forEach(function (e) {
          var t = e[0];
          pt[t] = new Io(t, 1, !1, e[1], null, !1);
        }),
        ["contentEditable", "draggable", "spellCheck", "value"].forEach(
          function (e) {
            pt[e] = new Io(e, 2, !1, e.toLowerCase(), null, !1);
          }
        ),
        [
          "autoReverse",
          "externalResourcesRequired",
          "focusable",
          "preserveAlpha",
        ].forEach(function (e) {
          pt[e] = new Io(e, 2, !1, e, null, !1);
        }),
        "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
          .split(" ")
          .forEach(function (e) {
            pt[e] = new Io(e, 3, !1, e.toLowerCase(), null, !1);
          }),
        ["checked", "multiple", "muted", "selected"].forEach(function (e) {
          pt[e] = new Io(e, 3, !0, e, null, !1);
        }),
        ["capture", "download"].forEach(function (e) {
          pt[e] = new Io(e, 4, !1, e, null, !1);
        }),
        ["cols", "rows", "size", "span"].forEach(function (e) {
          pt[e] = new Io(e, 6, !1, e, null, !1);
        }),
        ["rowSpan", "start"].forEach(function (e) {
          pt[e] = new Io(e, 5, !1, e.toLowerCase(), null, !1);
        }),
        (ft = /[\-:]([a-z])/g),
        "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
          .split(" ")
          .forEach(function (e) {
            var t = e.replace(ft, _o);
            pt[t] = new Io(t, 1, !1, e, null, !1);
          }),
        "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
          .split(" ")
          .forEach(function (e) {
            var t = e.replace(ft, _o);
            pt[t] = new Io(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
          }),
        ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
          var t = e.replace(ft, _o);
          pt[t] = new Io(
            t,
            1,
            !1,
            e,
            "http://www.w3.org/XML/1998/namespace",
            !1
          );
        }),
        ["tabIndex", "crossOrigin"].forEach(function (e) {
          pt[e] = new Io(e, 1, !1, e.toLowerCase(), null, !1);
        }),
        (pt.xlinkHref = new Io(
          "xlinkHref",
          1,
          !1,
          "xlink:href",
          "http://www.w3.org/1999/xlink",
          !0
        )),
        ["src", "href", "action", "formAction"].forEach(function (e) {
          pt[e] = new Io(e, 1, !1, e.toLowerCase(), null, !0);
        }),
        (ht = {
          html: "http://www.w3.org/1999/xhtml",
          mathml: "http://www.w3.org/1998/Math/MathML",
          svg: "http://www.w3.org/2000/svg",
        }),
        (o = function (e, t) {
          if (e.namespaceURI !== ht.svg || "innerHTML" in e) e.innerHTML = t;
          else {
            for (
              (mt = mt || document.createElement("div")).innerHTML =
                "<svg>" + t.valueOf().toString() + "</svg>",
                t = mt.firstChild;
              e.firstChild;

            )
              e.removeChild(e.firstChild);
            for (; t.firstChild; ) e.appendChild(t.firstChild);
          }
        }),
        (gt =
          "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction
            ? function (e, t, n, r) {
                MSApp.execUnsafeLocalFunction(function () {
                  return o(e, t);
                });
              }
            : o),
        (vt = {
          animationend: na("Animation", "AnimationEnd"),
          animationiteration: na("Animation", "AnimationIteration"),
          animationstart: na("Animation", "AnimationStart"),
          transitionend: na("Transition", "TransitionEnd"),
        }),
        (yt = {}),
        (bt = {}),
        tt &&
          ((bt = document.createElement("div").style),
          "AnimationEvent" in window ||
            (delete vt.animationend.animation,
            delete vt.animationiteration.animation,
            delete vt.animationstart.animation),
          "TransitionEvent" in window || delete vt.transitionend.transition),
        (wt = ra("animationend")),
        (xt = ra("animationiteration")),
        (Et = ra("animationstart")),
        (St = ra("transitionend")),
        (Ct = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(
          " "
        )),
        (zt = !1),
        (Ot = []),
        (Nt = Mt = Rt = null),
        (Lt = new Map()),
        (It = new Map()),
        (_t = []),
        (Dt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(
          " "
        )),
        (At = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(
          " "
        )),
        Ee(ka.prototype, {
          preventDefault: function () {
            this.defaultPrevented = !0;
            var e = this.nativeEvent;
            e &&
              (e.preventDefault
                ? e.preventDefault()
                : "unknown" != typeof e.returnValue && (e.returnValue = !1),
              (this.isDefaultPrevented = Sa));
          },
          stopPropagation: function () {
            var e = this.nativeEvent;
            e &&
              (e.stopPropagation
                ? e.stopPropagation()
                : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0),
              (this.isPropagationStopped = Sa));
          },
          persist: function () {
            this.isPersistent = Sa;
          },
          isPersistent: Ca,
          destructor: function () {
            for (var e in this.constructor.Interface) this[e] = null;
            (this.nativeEvent = this._targetInst = this.dispatchConfig = null),
              (this.isPropagationStopped = this.isDefaultPrevented = Ca),
              (this._dispatchInstances = this._dispatchListeners = null);
          },
        }),
        (ka.Interface = {
          type: null,
          target: null,
          currentTarget: function () {
            return null;
          },
          eventPhase: null,
          bubbles: null,
          cancelable: null,
          timeStamp: function (e) {
            return e.timeStamp || Date.now();
          },
          defaultPrevented: null,
          isTrusted: null,
        }),
        (ka.extend = function (e) {
          function t() {}
          function n() {
            return r.apply(this, arguments);
          }
          var r = this;
          t.prototype = r.prototype;
          var i = new t();
          return (
            Ee(i, n.prototype),
            (((n.prototype = i).constructor = n).Interface = Ee(
              {},
              r.Interface,
              e
            )),
            (n.extend = r.extend),
            za(n),
            n
          );
        }),
        za(ka),
        (Ft = ka.extend({
          animationName: null,
          elapsedTime: null,
          pseudoElement: null,
        })),
        (Bt = ka.extend({
          clipboardData: function (e) {
            return ("clipboardData" in e ? e : window).clipboardData;
          },
        })),
        (Wt = ka.extend({ view: null, detail: null })),
        ($t = Wt.extend({ relatedTarget: null })),
        (jt = {
          Esc: "Escape",
          Spacebar: " ",
          Left: "ArrowLeft",
          Up: "ArrowUp",
          Right: "ArrowRight",
          Down: "ArrowDown",
          Del: "Delete",
          Win: "OS",
          Menu: "ContextMenu",
          Apps: "ContextMenu",
          Scroll: "ScrollLock",
          MozPrintableKey: "Unidentified",
        }),
        (Ht = {
          8: "Backspace",
          9: "Tab",
          12: "Clear",
          13: "Enter",
          16: "Shift",
          17: "Control",
          18: "Alt",
          19: "Pause",
          20: "CapsLock",
          27: "Escape",
          32: " ",
          33: "PageUp",
          34: "PageDown",
          35: "End",
          36: "Home",
          37: "ArrowLeft",
          38: "ArrowUp",
          39: "ArrowRight",
          40: "ArrowDown",
          45: "Insert",
          46: "Delete",
          112: "F1",
          113: "F2",
          114: "F3",
          115: "F4",
          116: "F5",
          117: "F6",
          118: "F7",
          119: "F8",
          120: "F9",
          121: "F10",
          122: "F11",
          123: "F12",
          144: "NumLock",
          145: "ScrollLock",
          224: "Meta",
        }),
        (Vt = {
          Alt: "altKey",
          Control: "ctrlKey",
          Meta: "metaKey",
          Shift: "shiftKey",
        }),
        (qt = Wt.extend({
          key: function (e) {
            if (e.key) {
              var t = jt[e.key] || e.key;
              if ("Unidentified" !== t) return t;
            }
            return "keypress" === e.type
              ? 13 === (e = Oa(e))
                ? "Enter"
                : String.fromCharCode(e)
              : "keydown" === e.type || "keyup" === e.type
              ? Ht[e.keyCode] || "Unidentified"
              : "";
          },
          location: null,
          ctrlKey: null,
          shiftKey: null,
          altKey: null,
          metaKey: null,
          repeat: null,
          locale: null,
          getModifierState: Ma,
          charCode: function (e) {
            return "keypress" === e.type ? Oa(e) : 0;
          },
          keyCode: function (e) {
            return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
          },
          which: function (e) {
            return "keypress" === e.type
              ? Oa(e)
              : "keydown" === e.type || "keyup" === e.type
              ? e.keyCode
              : 0;
          },
        })),
        (Gt = Ut = 0),
        (Xt = Yt = !1),
        (Kt = Wt.extend({
          screenX: null,
          screenY: null,
          clientX: null,
          clientY: null,
          pageX: null,
          pageY: null,
          ctrlKey: null,
          shiftKey: null,
          altKey: null,
          metaKey: null,
          getModifierState: Ma,
          button: null,
          buttons: null,
          relatedTarget: function (e) {
            return (
              e.relatedTarget ||
              (e.fromElement === e.srcElement ? e.toElement : e.fromElement)
            );
          },
          movementX: function (e) {
            if ("movementX" in e) return e.movementX;
            var t = Ut;
            return (
              (Ut = e.screenX),
              Yt ? ("mousemove" === e.type ? e.screenX - t : 0) : ((Yt = !0), 0)
            );
          },
          movementY: function (e) {
            if ("movementY" in e) return e.movementY;
            var t = Gt;
            return (
              (Gt = e.screenY),
              Xt ? ("mousemove" === e.type ? e.screenY - t : 0) : ((Xt = !0), 0)
            );
          },
        })),
        (Zt = Kt.extend({
          pointerId: null,
          width: null,
          height: null,
          pressure: null,
          tangentialPressure: null,
          tiltX: null,
          tiltY: null,
          twist: null,
          pointerType: null,
          isPrimary: null,
        })),
        (Qt = Kt.extend({ dataTransfer: null })),
        (Jt = Wt.extend({
          touches: null,
          targetTouches: null,
          changedTouches: null,
          altKey: null,
          metaKey: null,
          ctrlKey: null,
          shiftKey: null,
          getModifierState: Ma,
        })),
        (en = ka.extend({
          propertyName: null,
          elapsedTime: null,
          pseudoElement: null,
        })),
        (tn = Kt.extend({
          deltaX: function (e) {
            return "deltaX" in e
              ? e.deltaX
              : "wheelDeltaX" in e
              ? -e.wheelDeltaX
              : 0;
          },
          deltaY: function (e) {
            return "deltaY" in e
              ? e.deltaY
              : "wheelDeltaY" in e
              ? -e.wheelDeltaY
              : "wheelDelta" in e
              ? -e.wheelDelta
              : 0;
          },
          deltaZ: null,
          deltaMode: null,
        })),
        (nn = [
          ["blur", "blur", 0],
          ["cancel", "cancel", 0],
          ["click", "click", 0],
          ["close", "close", 0],
          ["contextmenu", "contextMenu", 0],
          ["copy", "copy", 0],
          ["cut", "cut", 0],
          ["auxclick", "auxClick", 0],
          ["dblclick", "doubleClick", 0],
          ["dragend", "dragEnd", 0],
          ["dragstart", "dragStart", 0],
          ["drop", "drop", 0],
          ["focus", "focus", 0],
          ["input", "input", 0],
          ["invalid", "invalid", 0],
          ["keydown", "keyDown", 0],
          ["keypress", "keyPress", 0],
          ["keyup", "keyUp", 0],
          ["mousedown", "mouseDown", 0],
          ["mouseup", "mouseUp", 0],
          ["paste", "paste", 0],
          ["pause", "pause", 0],
          ["play", "play", 0],
          ["pointercancel", "pointerCancel", 0],
          ["pointerdown", "pointerDown", 0],
          ["pointerup", "pointerUp", 0],
          ["ratechange", "rateChange", 0],
          ["reset", "reset", 0],
          ["seeked", "seeked", 0],
          ["submit", "submit", 0],
          ["touchcancel", "touchCancel", 0],
          ["touchend", "touchEnd", 0],
          ["touchstart", "touchStart", 0],
          ["volumechange", "volumeChange", 0],
          ["drag", "drag", 1],
          ["dragenter", "dragEnter", 1],
          ["dragexit", "dragExit", 1],
          ["dragleave", "dragLeave", 1],
          ["dragover", "dragOver", 1],
          ["mousemove", "mouseMove", 1],
          ["mouseout", "mouseOut", 1],
          ["mouseover", "mouseOver", 1],
          ["pointermove", "pointerMove", 1],
          ["pointerout", "pointerOut", 1],
          ["pointerover", "pointerOver", 1],
          ["scroll", "scroll", 1],
          ["toggle", "toggle", 1],
          ["touchmove", "touchMove", 1],
          ["wheel", "wheel", 1],
          ["abort", "abort", 2],
          [wt, "animationEnd", 2],
          [xt, "animationIteration", 2],
          [Et, "animationStart", 2],
          ["canplay", "canPlay", 2],
          ["canplaythrough", "canPlayThrough", 2],
          ["durationchange", "durationChange", 2],
          ["emptied", "emptied", 2],
          ["encrypted", "encrypted", 2],
          ["ended", "ended", 2],
          ["error", "error", 2],
          ["gotpointercapture", "gotPointerCapture", 2],
          ["load", "load", 2],
          ["loadeddata", "loadedData", 2],
          ["loadedmetadata", "loadedMetadata", 2],
          ["loadstart", "loadStart", 2],
          ["lostpointercapture", "lostPointerCapture", 2],
          ["playing", "playing", 2],
          ["progress", "progress", 2],
          ["seeking", "seeking", 2],
          ["stalled", "stalled", 2],
          ["suspend", "suspend", 2],
          ["timeupdate", "timeUpdate", 2],
          [St, "transitionEnd", 2],
          ["waiting", "waiting", 2],
        ]),
        (rn = {}),
        (on = {}),
        (an = 0);
      for (; an < nn.length; an++) {
        var e = nn[an],
          t = e[0],
          n = e[1],
          r = e[2],
          e = "on" + (n[0].toUpperCase() + n.slice(1)),
          r = {
            phasedRegistrationNames: { bubbled: e, captured: e + "Capture" },
            dependencies: [t],
            eventPriority: r,
          };
        (rn[n] = r), (on[t] = r);
      }
      var i, o, a, s, l, c, u, d, p, f, h, m, g, v, y, b, w, x;
      (sn = {
        eventTypes: rn,
        getEventPriority: function (e) {
          return void 0 !== (e = on[e]) ? e.eventPriority : 2;
        },
        extractEvents: function (e, t, n, r) {
          var i = on[e];
          if (!i) return null;
          switch (e) {
            case "keypress":
              if (0 === Oa(n)) return null;
            case "keydown":
            case "keyup":
              e = qt;
              break;
            case "blur":
            case "focus":
              e = $t;
              break;
            case "click":
              if (2 === n.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              e = Kt;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              e = Qt;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              e = Jt;
              break;
            case wt:
            case xt:
            case Et:
              e = Ft;
              break;
            case St:
              e = en;
              break;
            case "scroll":
              e = Wt;
              break;
            case "wheel":
              e = tn;
              break;
            case "copy":
            case "cut":
            case "paste":
              e = Bt;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              e = Zt;
              break;
            default:
              e = ka;
          }
          return Ea((t = e.getPooled(i, t, n, r))), t;
        },
      }),
        (ln = Se.unstable_UserBlockingPriority),
        (cn = Se.unstable_runWithPriority),
        (un = sn.getEventPriority),
        (dn = 10),
        (pn = []),
        (fn = !0),
        (hn = new ("function" == typeof WeakMap ? WeakMap : Map)()),
        (mn = {
          animationIterationCount: !0,
          borderImageOutset: !0,
          borderImageSlice: !0,
          borderImageWidth: !0,
          boxFlex: !0,
          boxFlexGroup: !0,
          boxOrdinalGroup: !0,
          columnCount: !0,
          columns: !0,
          flex: !0,
          flexGrow: !0,
          flexPositive: !0,
          flexShrink: !0,
          flexNegative: !0,
          flexOrder: !0,
          gridArea: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowSpan: !0,
          gridRowStart: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnSpan: !0,
          gridColumnStart: !0,
          fontWeight: !0,
          lineClamp: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          tabSize: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
          fillOpacity: !0,
          floodOpacity: !0,
          stopOpacity: !0,
          strokeDasharray: !0,
          strokeDashoffset: !0,
          strokeMiterlimit: !0,
          strokeOpacity: !0,
          strokeWidth: !0,
        }),
        (gn = ["Webkit", "ms", "Moz", "O"]),
        Object.keys(mn).forEach(function (t) {
          gn.forEach(function (e) {
            (e = e + t.charAt(0).toUpperCase() + t.substring(1)),
              (mn[e] = mn[t]);
          });
        }),
        (vn = Ee(
          { menuitem: !0 },
          {
            area: !0,
            base: !0,
            br: !0,
            col: !0,
            embed: !0,
            hr: !0,
            img: !0,
            input: !0,
            keygen: !0,
            link: !0,
            meta: !0,
            param: !0,
            source: !0,
            track: !0,
            wbr: !0,
          }
        )),
        (yn = "$"),
        (bn = "/$"),
        (wn = "$?"),
        (xn = "$!"),
        (Sn = En = null),
        (Cn = "function" == typeof setTimeout ? setTimeout : void 0),
        (kn = "function" == typeof clearTimeout ? clearTimeout : void 0),
        (Kn = Math.random().toString(36).slice(2)),
        (Tn = "__reactInternalInstance$" + Kn),
        (Pn = "__reactEventHandlers$" + Kn),
        (zn = "__reactContainere$" + Kn),
        (Nn = ka.extend({ data: (Mn = Rn = On = null) })),
        (Ln = ka.extend({ data: null })),
        (In = [9, 13, 27, 32]),
        (_n = tt && "CompositionEvent" in window),
        (or = null),
        tt && "documentMode" in document && (or = document.documentMode),
        (Dn = tt && "TextEvent" in window && !or),
        (An = tt && (!_n || (or && 8 < or && or <= 11))),
        (Fn = String.fromCharCode(32)),
        (Bn = {
          beforeInput: {
            phasedRegistrationNames: {
              bubbled: "onBeforeInput",
              captured: "onBeforeInputCapture",
            },
            dependencies: ["compositionend", "keypress", "textInput", "paste"],
          },
          compositionEnd: {
            phasedRegistrationNames: {
              bubbled: "onCompositionEnd",
              captured: "onCompositionEndCapture",
            },
            dependencies: "blur compositionend keydown keypress keyup mousedown".split(
              " "
            ),
          },
          compositionStart: {
            phasedRegistrationNames: {
              bubbled: "onCompositionStart",
              captured: "onCompositionStartCapture",
            },
            dependencies: "blur compositionstart keydown keypress keyup mousedown".split(
              " "
            ),
          },
          compositionUpdate: {
            phasedRegistrationNames: {
              bubbled: "onCompositionUpdate",
              captured: "onCompositionUpdateCapture",
            },
            dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(
              " "
            ),
          },
        }),
        (jn = {
          color: !($n = Wn = !(gr = {
            eventTypes: Bn,
            extractEvents: function (e, t, n, r) {
              var i;
              if (_n)
                e: {
                  switch (e) {
                    case "compositionstart":
                      var o = Bn.compositionStart;
                      break e;
                    case "compositionend":
                      o = Bn.compositionEnd;
                      break e;
                    case "compositionupdate":
                      o = Bn.compositionUpdate;
                      break e;
                  }
                  o = void 0;
                }
              else
                $n
                  ? ss(e, n) && (o = Bn.compositionEnd)
                  : "keydown" === e &&
                    229 === n.keyCode &&
                    (o = Bn.compositionStart);
              return (
                (i = o
                  ? (An &&
                      "ko" !== n.locale &&
                      ($n || o !== Bn.compositionStart
                        ? o === Bn.compositionEnd && $n && (i = as())
                        : ((Rn =
                            "value" in (On = r) ? On.value : On.textContent),
                          ($n = !0))),
                    (o = Nn.getPooled(o, t, n, r)),
                    (!i && null === (i = ls(n))) || (o.data = i),
                    Ea(o),
                    o)
                  : null),
                (e = (Dn
                  ? function (e, t) {
                      switch (e) {
                        case "compositionend":
                          return ls(t);
                        case "keypress":
                          return 32 !== t.which ? null : ((Wn = !0), Fn);
                        case "textInput":
                          return (e = t.data) === Fn && Wn ? null : e;
                        default:
                          return null;
                      }
                    }
                  : function (e, t) {
                      if ($n)
                        return "compositionend" === e || (!_n && ss(e, t))
                          ? ((e = as()), (Mn = Rn = On = null), ($n = !1), e)
                          : null;
                      switch (e) {
                        case "paste":
                          return null;
                        case "keypress":
                          if (
                            !(t.ctrlKey || t.altKey || t.metaKey) ||
                            (t.ctrlKey && t.altKey)
                          ) {
                            if (t.char && 1 < t.char.length) return t.char;
                            if (t.which) return String.fromCharCode(t.which);
                          }
                          return null;
                        case "compositionend":
                          return An && "ko" !== t.locale ? null : t.data;
                        default:
                          return null;
                      }
                    })(e, n))
                  ? (((t = Ln.getPooled(Bn.beforeInput, t, n, r)).data = e),
                    Ea(t))
                  : (t = null),
                null === i ? t : null === t ? i : [i, t]
              );
            },
          })),
          date: !0,
          datetime: !0,
          "datetime-local": !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0,
        }),
        (Hn = {
          change: {
            phasedRegistrationNames: {
              bubbled: "onChange",
              captured: "onChangeCapture",
            },
            dependencies: "blur change click focus input keydown keyup selectionchange".split(
              " "
            ),
          },
        }),
        (qn = Vn = null),
        (Un = !1),
        tt &&
          (Un =
            Fa("input") &&
            (!document.documentMode || 9 < document.documentMode)),
        (Gn = {
          eventTypes: Hn,
          _isInputEventSupported: Un,
          extractEvents: function (e, t, n, r) {
            var i,
              o,
              a = t ? is(t) : window,
              s = a.nodeName && a.nodeName.toLowerCase();
            if (
              ("select" === s || ("input" === s && "file" === a.type)
                ? (i = fs)
                : cs(a)
                ? Un
                  ? (i = bs)
                  : ((i = vs), (o = gs))
                : !(s = a.nodeName) ||
                  "input" !== s.toLowerCase() ||
                  ("checkbox" !== a.type && "radio" !== a.type) ||
                  (i = ys),
              (i = i && i(e, t)))
            )
              return us(i, n, r);
            o && o(e, a, t),
              "blur" === e &&
                (e = a._wrapperState) &&
                e.controlled &&
                "number" === a.type &&
                Uo(a, "number", a.value);
          },
        }),
        (Kn = {
          eventTypes: (Yn = {
            mouseEnter: {
              registrationName: "onMouseEnter",
              dependencies: ["mouseout", "mouseover"],
            },
            mouseLeave: {
              registrationName: "onMouseLeave",
              dependencies: ["mouseout", "mouseover"],
            },
            pointerEnter: {
              registrationName: "onPointerEnter",
              dependencies: ["pointerout", "pointerover"],
            },
            pointerLeave: {
              registrationName: "onPointerLeave",
              dependencies: ["pointerout", "pointerover"],
            },
          }),
          extractEvents: function (e, t, n, r, i) {
            var o,
              a,
              s,
              l,
              c = "mouseover" === e || "pointerover" === e,
              u = "mouseout" === e || "pointerout" === e;
            if (
              (c && 0 == (32 & i) && (n.relatedTarget || n.fromElement)) ||
              (!u && !c)
            )
              return null;
            if (
              ((i =
                r.window === r
                  ? r
                  : (i = r.ownerDocument)
                  ? i.defaultView || i.parentWindow
                  : window),
              u
                ? ((u = t),
                  null !==
                    (t = (t = n.relatedTarget || n.toElement) ? ns(t) : null) &&
                    (t !== (c = ia(t)) || (5 !== t.tag && 6 !== t.tag)) &&
                    (t = null))
                : (u = null),
              u === t)
            )
              return null;
            if (
              ("mouseout" === e || "mouseover" === e
                ? ((o = Kt),
                  (a = Yn.mouseLeave),
                  (s = Yn.mouseEnter),
                  (l = "mouse"))
                : ("pointerout" !== e && "pointerover" !== e) ||
                  ((o = Zt),
                  (a = Yn.pointerLeave),
                  (s = Yn.pointerEnter),
                  (l = "pointer")),
              (e = null == u ? i : is(u)),
              (i = null == t ? i : is(t)),
              ((a = o.getPooled(a, u, n, r)).type = l + "leave"),
              (a.target = e),
              (a.relatedTarget = i),
              ((r = o.getPooled(s, t, n, r)).type = l + "enter"),
              (r.target = i),
              (r.relatedTarget = e),
              (l = t),
              (o = u) && l)
            )
              e: {
                for (e = l, u = 0, t = s = o; t; t = va(t)) u++;
                for (t = 0, i = e; i; i = va(i)) t++;
                for (; 0 < u - t; ) (s = va(s)), u--;
                for (; 0 < t - u; ) (e = va(e)), t--;
                for (; u--; ) {
                  if (s === e || s === e.alternate) break e;
                  (s = va(s)), (e = va(e));
                }
                s = null;
              }
            else s = null;
            for (
              e = s, s = [];
              o && o !== e && (null === (u = o.alternate) || u !== e);

            )
              s.push(o), (o = va(o));
            for (
              o = [];
              l && l !== e && (null === (u = l.alternate) || u !== e);

            )
              o.push(l), (l = va(l));
            for (l = 0; l < s.length; l++) wa(s[l], "bubbled", a);
            for (l = o.length; 0 < l--; ) wa(o[l], "captured", r);
            return n === Xn ? ((Xn = null), [a]) : ((Xn = n), [a, r]);
          },
        }),
        (Zn = "function" == typeof Object.is ? Object.is : ws),
        (Qn = Object.prototype.hasOwnProperty),
        (Jn = tt && "documentMode" in document && document.documentMode <= 11),
        (er = {
          select: {
            phasedRegistrationNames: {
              bubbled: "onSelect",
              captured: "onSelectCapture",
            },
            dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(
              " "
            ),
          },
        }),
        (rr = nr = tr = null),
        (ir = !1),
        (or = {
          eventTypes: er,
          extractEvents: function (e, t, n, r) {
            var i,
              o =
                r.window === r
                  ? r.document
                  : 9 === r.nodeType
                  ? r
                  : r.ownerDocument;
            if (!(i = !o)) {
              e: {
                (o = Ba(o)), (i = Oe.onSelect);
                for (var a = 0; a < i.length; a++)
                  if (!o.has(i[a])) {
                    o = !1;
                    break e;
                  }
                o = !0;
              }
              i = !o;
            }
            if (i) return null;
            switch (((o = t ? is(t) : window), e)) {
              case "focus":
                (!cs(o) && "true" !== o.contentEditable) ||
                  ((tr = o), (nr = t), (rr = null));
                break;
              case "blur":
                rr = nr = tr = null;
                break;
              case "mousedown":
                ir = !0;
                break;
              case "contextmenu":
              case "mouseup":
              case "dragend":
                return (ir = !1), Es(n, r);
              case "selectionchange":
                if (Jn) break;
              case "keydown":
              case "keyup":
                return Es(n, r);
            }
            return null;
          },
        }),
        uo.injectEventPluginOrder(
          "ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(
            " "
          )
        ),
        (_e = os),
        (De = rs),
        (Ae = is),
        uo.injectEventPluginsByName({
          SimpleEventPlugin: sn,
          EnterLeaveEventPlugin: Kn,
          ChangeEventPlugin: Gn,
          SelectEventPlugin: or,
          BeforeInputEventPlugin: gr,
        }),
        new Set(),
        (ar = []),
        (cr = { current: (lr = {}) }),
        (ur = { current: !(sr = -1) }),
        (dr = lr),
        (pr = Se.unstable_runWithPriority),
        (fr = Se.unstable_scheduleCallback),
        (hr = Se.unstable_cancelCallback),
        (mr = Se.unstable_shouldYield),
        (gr = Se.unstable_requestPaint),
        (vr = Se.unstable_now),
        (yr = Se.unstable_getCurrentPriorityLevel),
        (br = Se.unstable_ImmediatePriority),
        (wr = Se.unstable_UserBlockingPriority),
        (xr = Se.unstable_NormalPriority),
        (Er = Se.unstable_LowPriority),
        (Sr = Se.unstable_IdlePriority),
        (kr = void 0 !== gr ? gr : function () {}),
        (Pr = Tr = null),
        (zr = !(Cr = {})),
        (Or = vr()),
        (Rr =
          Or < 1e4
            ? vr
            : function () {
                return vr() - Or;
              }),
        (Mr = 3),
        (_r = Ir = Lr = null),
        (Dr = !(Nr = { current: null })),
        (Ar = Be.ReactCurrentBatchConfig),
        (Fr = new xe.Component().refs),
        (Br = {
          isMounted: function (e) {
            return !!(e = e._reactInternalFiber) && ia(e) === e;
          },
          enqueueSetState: function (e, t, n) {
            e = e._reactInternalFiber;
            var r = wc(),
              i = Ar.suspense;
            ((i = Ks((r = xc(r, e, i)), i)).payload = t),
              null != n && (i.callback = n),
              Qs(e, i),
              Ec(e, r);
          },
          enqueueReplaceState: function (e, t, n) {
            e = e._reactInternalFiber;
            var r = wc(),
              i = Ar.suspense;
            ((i = Ks((r = xc(r, e, i)), i)).tag = 1),
              (i.payload = t),
              null != n && (i.callback = n),
              Qs(e, i),
              Ec(e, r);
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternalFiber;
            var n = wc(),
              r = Ar.suspense;
            ((r = Ks((n = xc(n, e, r)), r)).tag = 2),
              null != t && (r.callback = t),
              Qs(e, r),
              Ec(e, n);
          },
        }),
        (Wr = Array.isArray),
        ($r = pl(!0)),
        (jr = pl(!1)),
        (Vr = { current: (Hr = {}) }),
        (qr = { current: Hr }),
        (Ur = { current: Hr }),
        (Gr = { current: 0 }),
        (Yr = Be.ReactCurrentDispatcher),
        (Xr = Be.ReactCurrentBatchConfig),
        (ai = !1),
        (li = oi = ri = Kr = 0),
        (ci = {
          readContext: Gs,
          useCallback: wl,
          useContext: wl,
          useEffect: wl,
          useImperativeHandle: wl,
          useLayoutEffect: wl,
          useMemo: wl,
          useReducer: wl,
          useRef: wl,
          useState: wl,
          useDebugValue: wl,
          useResponder: wl,
          useDeferredValue: wl,
          useTransition: wl,
        }),
        (ui = {
          readContext: Gs,
          useCallback: Al,
          useContext: Gs,
          useEffect: Ll,
          useImperativeHandle: function (e, t, n) {
            return (
              (n = null != n ? n.concat([e]) : null),
              Ml(4, 36, _l.bind(null, t, e), n)
            );
          },
          useLayoutEffect: function (e, t) {
            return Ml(4, 36, e, t);
          },
          useMemo: function (e, t) {
            var n = Cl();
            return (
              (t = void 0 === t ? null : t),
              (e = e()),
              (n.memoizedState = [e, t]),
              e
            );
          },
          useReducer: function (e, t, n) {
            var r = Cl();
            return (
              (t = void 0 !== n ? n(t) : t),
              (r.memoizedState = r.baseState = t),
              (e = (e = r.queue = {
                last: null,
                dispatch: null,
                lastRenderedReducer: e,
                lastRenderedState: t,
              }).dispatch = Bl.bind(null, Zr, e)),
              [r.memoizedState, e]
            );
          },
          useRef: function (e) {
            return (e = { current: e }), (Cl().memoizedState = e);
          },
          useState: zl,
          useDebugValue: Dl,
          useResponder: bl,
          useDeferredValue: function (t, n) {
            var e = zl(t),
              r = e[0],
              i = e[1];
            return (
              Ll(
                function () {
                  Se.unstable_next(function () {
                    var e = Xr.suspense;
                    Xr.suspense = void 0 === n ? null : n;
                    try {
                      i(t);
                    } finally {
                      Xr.suspense = e;
                    }
                  });
                },
                [t, n]
              ),
              r
            );
          },
          useTransition: function (n) {
            var e = zl(!1),
              t = e[0],
              r = e[1];
            return [
              Al(
                function (t) {
                  r(!0),
                    Se.unstable_next(function () {
                      var e = Xr.suspense;
                      Xr.suspense = void 0 === n ? null : n;
                      try {
                        r(!1), t();
                      } finally {
                        Xr.suspense = e;
                      }
                    });
                },
                [n, t]
              ),
              t,
            ];
          },
        }),
        (fi = pi = si = ii = ni = ti = ei = Jr = Qr = Zr = null),
        (hi = !(di = {
          readContext: Gs,
          useCallback: Fl,
          useContext: Gs,
          useEffect: Il,
          useImperativeHandle: function (e, t, n) {
            return (
              (n = null != n ? n.concat([e]) : null),
              Nl(4, 36, _l.bind(null, t, e), n)
            );
          },
          useLayoutEffect: function (e, t) {
            return Nl(4, 36, e, t);
          },
          useMemo: function (e, t) {
            var n = kl();
            t = void 0 === t ? null : t;
            var r = n.memoizedState;
            return null !== r && null !== t && xl(t, r[1])
              ? r[0]
              : ((e = e()), (n.memoizedState = [e, t]), e);
          },
          useReducer: Pl,
          useRef: function () {
            return kl().memoizedState;
          },
          useState: Ol,
          useDebugValue: Dl,
          useResponder: bl,
          useDeferredValue: function (t, n) {
            var e = Ol(),
              r = e[0],
              i = e[1];
            return (
              Il(
                function () {
                  Se.unstable_next(function () {
                    var e = Xr.suspense;
                    Xr.suspense = void 0 === n ? null : n;
                    try {
                      i(t);
                    } finally {
                      Xr.suspense = e;
                    }
                  });
                },
                [t, n]
              ),
              r
            );
          },
          useTransition: function (n) {
            var e = Ol(),
              t = e[0],
              r = e[1];
            return [
              Fl(
                function (t) {
                  r(!0),
                    Se.unstable_next(function () {
                      var e = Xr.suspense;
                      Xr.suspense = void 0 === n ? null : n;
                      try {
                        r(!1), t();
                      } finally {
                        Xr.suspense = e;
                      }
                    });
                },
                [n, t]
              ),
              t,
            ];
          },
        })),
        (mi = Be.ReactCurrentOwner),
        (gi = !1),
        (vi = { dehydrated: null, retryTime: 0 }),
        (yi = function (e, t) {
          for (var n = t.child; null !== n; ) {
            if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);
            else if (4 !== n.tag && null !== n.child) {
              n = (n.child.return = n).child;
              continue;
            }
            if (n === t) break;
            for (; null === n.sibling; ) {
              if (null === n.return || n.return === t) return;
              n = n.return;
            }
            (n.sibling.return = n.return), (n = n.sibling);
          }
        }),
        (bi = function () {}),
        (wi = function (e, t, n, r, i) {
          var o = e.memoizedProps;
          if (o !== r) {
            var a,
              s,
              l = t.stateNode;
            switch ((fl(Vr.current), (e = null), n)) {
              case "input":
                (o = $o(l, o)), (r = $o(l, r)), (e = []);
                break;
              case "option":
                (o = Go(l, o)), (r = Go(l, r)), (e = []);
                break;
              case "select":
                (o = Ee({}, o, { value: void 0 })),
                  (r = Ee({}, r, { value: void 0 })),
                  (e = []);
                break;
              case "textarea":
                (o = Xo(l, o)), (r = Xo(l, r)), (e = []);
                break;
              default:
                "function" != typeof o.onClick &&
                  "function" == typeof r.onClick &&
                  (l.onclick = Ua);
            }
            for (a in (Ha(n, r), (n = null), o))
              if (!r.hasOwnProperty(a) && o.hasOwnProperty(a) && null != o[a])
                if ("style" === a)
                  for (s in (l = o[a]))
                    l.hasOwnProperty(s) && ((n = n || {}), (n[s] = ""));
                else
                  "dangerouslySetInnerHTML" !== a &&
                    "children" !== a &&
                    "suppressContentEditableWarning" !== a &&
                    "suppressHydrationWarning" !== a &&
                    "autoFocus" !== a &&
                    (ze.hasOwnProperty(a)
                      ? (e = e || [])
                      : (e = e || []).push(a, null));
            for (a in r) {
              var c = r[a],
                l = null != o ? o[a] : void 0;
              if (r.hasOwnProperty(a) && c !== l && (null != c || null != l))
                if ("style" === a)
                  if (l) {
                    for (s in l)
                      !l.hasOwnProperty(s) ||
                        (c && c.hasOwnProperty(s)) ||
                        ((n = n || {}), (n[s] = ""));
                    for (s in c)
                      c.hasOwnProperty(s) &&
                        l[s] !== c[s] &&
                        ((n = n || {}), (n[s] = c[s]));
                  } else n || (e = e || []).push(a, n), (n = c);
                else
                  "dangerouslySetInnerHTML" === a
                    ? ((c = c ? c.__html : void 0),
                      (l = l ? l.__html : void 0),
                      null != c && l !== c && (e = e || []).push(a, "" + c))
                    : "children" === a
                    ? l === c ||
                      ("string" != typeof c && "number" != typeof c) ||
                      (e = e || []).push(a, "" + c)
                    : "suppressContentEditableWarning" !== a &&
                      "suppressHydrationWarning" !== a &&
                      (ze.hasOwnProperty(a)
                        ? (null != c && qa(i, a), e || l === c || (e = []))
                        : (e = e || []).push(a, c));
            }
            n && (e = e || []).push("style", n),
              (i = e),
              (t.updateQueue = i) && ac(t);
          }
        }),
        (xi = function (e, t, n, r) {
          n !== r && ac(t);
        }),
        (Ei = "function" == typeof WeakSet ? WeakSet : Set),
        (Si = "function" == typeof WeakMap ? WeakMap : Map),
        (Ci = Math.ceil),
        (ki = Be.ReactCurrentDispatcher),
        (Ti = Be.ReactCurrentOwner),
        (zi = 8),
        (Oi = 16),
        (Ri = 32),
        (Ni = 1),
        (Li = 2),
        (Ii = 3),
        (_i = 4),
        (Di = 5),
        (Ai = Pi = 0),
        ($i = Mi = Wi = 0),
        (Gi = !(Vi = Hi = 1073741823)),
        (eo = Zi = !(Xi = 500)),
        (no = 90),
        (ao = io = Yi = Ui = 0),
        (so = function (e, t, n) {
          var r,
            i,
            o = t.expirationTime;
          if (null !== e) {
            var a = t.pendingProps;
            if (e.memoizedProps !== a || ur.current) gi = !0;
            else {
              if (o < n) {
                switch (((gi = !1), t.tag)) {
                  case 3:
                    ec(t), ql();
                    break;
                  case 5:
                    if ((gl(t), 4 & t.mode && 1 !== n && a.hidden))
                      return (
                        (t.expirationTime = t.childExpirationTime = 1), null
                      );
                    break;
                  case 1:
                    Ts(t.type) && Ms(t);
                    break;
                  case 4:
                    hl(t, t.stateNode.containerInfo);
                    break;
                  case 10:
                    Hs(t, t.memoizedProps.value);
                    break;
                  case 13:
                    if (null !== t.memoizedState)
                      return 0 !== (o = t.child.childExpirationTime) && n <= o
                        ? tc(e, t, n)
                        : (Cs(Gr, 1 & Gr.current),
                          null !== (t = oc(e, t, n)) ? t.sibling : null);
                    Cs(Gr, 1 & Gr.current);
                    break;
                  case 19:
                    if (
                      ((o = t.childExpirationTime >= n),
                      0 != (64 & e.effectTag))
                    ) {
                      if (o) return ic(e, t, n);
                      t.effectTag |= 64;
                    }
                    if (
                      (null !== (a = t.memoizedState) &&
                        ((a.rendering = null), (a.tail = null)),
                      Cs(Gr, Gr.current),
                      !o)
                    )
                      return null;
                }
                return oc(e, t, n);
              }
              gi = !1;
            }
          } else gi = !1;
          switch (((t.expirationTime = 0), t.tag)) {
            case 2:
              var s,
                l,
                o = t.type;
              return (
                null !== e &&
                  ((e.alternate = null),
                  (t.alternate = null),
                  (t.effectTag |= 2)),
                (e = t.pendingProps),
                (a = ks(t, cr.current)),
                Us(t, n),
                (a = El(null, t, o, e, a, n)),
                (t.effectTag |= 1),
                (t =
                  "object" == typeof a &&
                  null !== a &&
                  "function" == typeof a.render &&
                  void 0 === a.$$typeof
                    ? ((t.tag = 1),
                      Sl(),
                      Ts(o) ? ((s = !0), Ms(t)) : (s = !1),
                      (t.memoizedState =
                        null !== a.state && void 0 !== a.state
                          ? a.state
                          : null),
                      "function" == typeof (l = o.getDerivedStateFromProps) &&
                        ol(t, 0, l, e),
                      (a.updater = Br),
                      cl(((t.stateNode = a)._reactInternalFiber = t), o, e, n),
                      Jl(null, t, o, !0, s, n))
                    : ((t.tag = 0), Ul(null, t, a, n), t.child))
              );
            case 16:
              if (
                ((a = t.elementType),
                null !== e &&
                  ((e.alternate = null),
                  (t.alternate = null),
                  (t.effectTag |= 2)),
                (e = t.pendingProps),
                -1 === (r = a)._status &&
                  ((r._status = 0),
                  (i = (i = r._ctor)()),
                  (r._result = i).then(
                    function (e) {
                      0 === r._status &&
                        ((e = e.default), (r._status = 1), (r._result = e));
                    },
                    function (e) {
                      0 === r._status && ((r._status = 2), (r._result = e));
                    }
                  )),
                1 !== a._status)
              )
                throw a._result;
              switch (
                ((a = a._result),
                (t.type = a),
                (s = t.tag = (function (e) {
                  if ("function" == typeof e) return Uc(e) ? 1 : 0;
                  if (null != e) {
                    if ((e = e.$$typeof) === Xe) return 11;
                    if (e === Qe) return 14;
                  }
                  return 2;
                })(a)),
                (e = $s(a, e)),
                s)
              ) {
                case 0:
                  t = Zl(null, t, a, e, n);
                  break;
                case 1:
                  t = Ql(null, t, a, e, n);
                  break;
                case 11:
                  t = Gl(null, t, a, e, n);
                  break;
                case 14:
                  t = Yl(null, t, a, $s(a.type, e), o, n);
                  break;
                default:
                  throw Error(ho(306, a, ""));
              }
              return t;
            case 0:
              return (
                (o = t.type),
                (a = t.pendingProps),
                Zl(e, t, o, (a = t.elementType === o ? a : $s(o, a)), n)
              );
            case 1:
              return (
                (o = t.type),
                (a = t.pendingProps),
                Ql(e, t, o, (a = t.elementType === o ? a : $s(o, a)), n)
              );
            case 3:
              if ((ec(t), null === (o = t.updateQueue))) throw Error(ho(282));
              if (
                ((a = null !== (a = t.memoizedState) ? a.element : null),
                nl(t, o, t.pendingProps, null, n),
                (o = t.memoizedState.element) === a)
              )
                ql(), (t = oc(e, t, n));
              else {
                if (
                  ((a = t.stateNode.hydrate) &&
                    ((fi = es(t.stateNode.containerInfo.firstChild)),
                    (pi = t),
                    (a = hi = !0)),
                  a)
                )
                  for (n = jr(t, null, o, n), t.child = n; n; )
                    (n.effectTag = (-3 & n.effectTag) | 1024), (n = n.sibling);
                else Ul(e, t, o, n), ql();
                t = t.child;
              }
              return t;
            case 5:
              return (
                gl(t),
                null === e && jl(t),
                (o = t.type),
                (a = t.pendingProps),
                (s = null !== e ? e.memoizedProps : null),
                (l = a.children),
                Ja(o, a)
                  ? (l = null)
                  : null !== s && Ja(o, s) && (t.effectTag |= 16),
                Kl(e, t),
                (t =
                  4 & t.mode && 1 !== n && a.hidden
                    ? ((t.expirationTime = t.childExpirationTime = 1), null)
                    : (Ul(e, t, l, n), t.child))
              );
            case 6:
              return null === e && jl(t), null;
            case 13:
              return tc(e, t, n);
            case 4:
              return (
                hl(t, t.stateNode.containerInfo),
                (o = t.pendingProps),
                null === e ? (t.child = $r(t, null, o, n)) : Ul(e, t, o, n),
                t.child
              );
            case 11:
              return (
                (o = t.type),
                (a = t.pendingProps),
                Gl(e, t, o, (a = t.elementType === o ? a : $s(o, a)), n)
              );
            case 7:
              return Ul(e, t, t.pendingProps, n), t.child;
            case 8:
            case 12:
              return Ul(e, t, t.pendingProps.children, n), t.child;
            case 10:
              e: {
                if (
                  ((o = t.type._context),
                  (a = t.pendingProps),
                  (l = t.memoizedProps),
                  Hs(t, (s = a.value)),
                  null !== l)
                ) {
                  var c = l.value;
                  if (
                    0 ==
                    (s = Zn(c, s)
                      ? 0
                      : 0 |
                        ("function" == typeof o._calculateChangedBits
                          ? o._calculateChangedBits(c, s)
                          : 1073741823))
                  ) {
                    if (l.children === a.children && !ur.current) {
                      t = oc(e, t, n);
                      break e;
                    }
                  } else
                    for (
                      null !== (c = t.child) && (c.return = t);
                      null !== c;

                    ) {
                      var u = c.dependencies;
                      if (null !== u) {
                        l = c.child;
                        for (var d = u.firstContext; null !== d; ) {
                          if (d.context === o && 0 != (d.observedBits & s)) {
                            1 === c.tag &&
                              (((d = Ks(n, null)).tag = 2), Qs(c, d)),
                              c.expirationTime < n && (c.expirationTime = n),
                              null !== (d = c.alternate) &&
                                d.expirationTime < n &&
                                (d.expirationTime = n),
                              qs(c.return, n),
                              u.expirationTime < n && (u.expirationTime = n);
                            break;
                          }
                          d = d.next;
                        }
                      } else
                        l = 10 === c.tag && c.type === t.type ? null : c.child;
                      if (null !== l) l.return = c;
                      else
                        for (l = c; null !== l; ) {
                          if (l === t) {
                            l = null;
                            break;
                          }
                          if (null !== (c = l.sibling)) {
                            (c.return = l.return), (l = c);
                            break;
                          }
                          l = l.return;
                        }
                      c = l;
                    }
                }
                Ul(e, t, a.children, n), (t = t.child);
              }
              return t;
            case 9:
              return (
                (a = t.type),
                (o = (s = t.pendingProps).children),
                Us(t, n),
                (o = o((a = Gs(a, s.unstable_observedBits)))),
                (t.effectTag |= 1),
                Ul(e, t, o, n),
                t.child
              );
            case 14:
              return (
                (s = $s((a = t.type), t.pendingProps)),
                Yl(e, t, a, (s = $s(a.type, s)), o, n)
              );
            case 15:
              return Xl(e, t, t.type, t.pendingProps, o, n);
            case 17:
              return (
                (o = t.type),
                (a = t.pendingProps),
                (a = t.elementType === o ? a : $s(o, a)),
                null !== e &&
                  ((e.alternate = null),
                  (t.alternate = null),
                  (t.effectTag |= 2)),
                (t.tag = 1),
                Ts(o) ? ((e = !0), Ms(t)) : (e = !1),
                Us(t, n),
                sl(t, o, a),
                cl(t, o, a, n),
                Jl(null, t, o, !0, e, n)
              );
            case 19:
              return ic(e, t, n);
          }
          throw Error(ho(156, t.tag));
        }),
        (co = lo = oo = ro = to = Ji = Qi = Ki = qi = ji = Bi = Fi = null),
        (su.prototype.render = function (e, t) {
          ru(e, this._internalRoot, null, void 0 === t ? null : t);
        }),
        (su.prototype.unmount = function (e) {
          var t = this._internalRoot,
            n = void 0 === e ? null : e,
            r = t.containerInfo;
          ru(null, t, null, function () {
            (r[zn] = null) !== n && n();
          });
        }),
        (kt = function (e) {
          var t;
          13 === e.tag && (Ec(e, (t = Ws(wc(), 150, 100))), au(e, t));
        }),
        (Tt = function (e) {
          var t;
          13 === e.tag && (wc(), Ec(e, (t = Mr++)), au(e, t));
        }),
        (Pt = function (e) {
          var t;
          13 === e.tag && (Ec(e, (t = xc((t = wc()), e, null))), au(e, t));
        }),
        (nt = function (e, t, n) {
          switch (t) {
            case "input":
              if ((Vo(e, n), (t = n.name), "radio" === n.type && null != t)) {
                for (n = e; n.parentNode; ) n = n.parentNode;
                for (
                  n = n.querySelectorAll(
                    "input[name=" + JSON.stringify("" + t) + '][type="radio"]'
                  ),
                    t = 0;
                  t < n.length;
                  t++
                ) {
                  var r = n[t];
                  if (r !== e && r.form === e.form) {
                    var i = os(r);
                    if (!i) throw Error(ho(90));
                    Wo(r), Vo(r, i);
                  }
                }
              }
              break;
            case "textarea":
              Zo(e, n);
              break;
            case "select":
              null != (t = n.value) && Yo(e, !!n.multiple, t, !1);
          }
        }),
        (Mo = function (e, t, n, r) {
          var i = Ai;
          Ai |= 4;
          try {
            return _s(98, e.bind(null, t, n, r));
          } finally {
            (Ai = i) === Pi && Fs();
          }
        }),
        (No = function () {
          var e;
          (Ai & (1 | Oi | Ri)) === Pi &&
            (null !== ro &&
              ((e = ro),
              (ro = null),
              e.forEach(function (e, t) {
                nu(t, e), kc(t);
              }),
              Fs()),
            Bc());
        }),
        (uo = {
          createPortal: uu,
          findDOMNode: function (e) {
            if (null == e) return null;
            if (1 === e.nodeType) return e;
            var t = e._reactInternalFiber;
            if (void 0 !== t) return null === (e = sa(t)) ? null : e.stateNode;
            if ("function" == typeof e.render) throw Error(ho(188));
            throw Error(ho(268, Object.keys(e)));
          },
          hydrate: function (e, t, n) {
            if (!lu(t)) throw Error(ho(200));
            return cu(null, e, t, !0, n);
          },
          render: function (e, t, n) {
            if (!lu(t)) throw Error(ho(200));
            return cu(null, e, t, !1, n);
          },
          unstable_renderSubtreeIntoContainer: function (e, t, n, r) {
            if (!lu(n)) throw Error(ho(200));
            if (null == e || void 0 === e._reactInternalFiber)
              throw Error(ho(38));
            return cu(e, t, n, !1, r);
          },
          unmountComponentAtNode: function (e) {
            if (!lu(e)) throw Error(ho(40));
            return (
              !!e._reactRootContainer &&
              (Oc(function () {
                cu(null, null, e, !1, function () {
                  (e._reactRootContainer = null), (e[zn] = null);
                });
              }),
              !0)
            );
          },
          unstable_createPortal: function () {
            return uu.apply(void 0, arguments);
          },
          unstable_batchedUpdates: (Ro = zc),
          flushSync: function (e, t) {
            if ((Ai & (Oi | Ri)) !== Pi) throw Error(ho(187));
            var n = Ai;
            Ai |= 1;
            try {
              return _s(99, e.bind(null, t));
            } finally {
              (Ai = n), Fs();
            }
          },
          __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
            Events: [
              rs,
              is,
              os,
              uo.injectEventPluginsByName,
              Pe,
              Ea,
              function (e) {
                wo(e, xa);
              },
              zo,
              Oo,
              Da,
              Eo,
              Bc,
              {
                current: !(ot = function (e, t) {
                  var n = Ai;
                  Ai |= 2;
                  try {
                    return e(t);
                  } finally {
                    (Ai = n) === Pi && Fs();
                  }
                }),
              },
            ],
          },
        }),
        (i = (w = {
          findFiberByHostInstance: ns,
          bundleType: 0,
          version: "16.12.0",
          rendererPackageName: "react-dom",
        }).findFiberByHostInstance),
        (function (e) {
          if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
            var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (t.isDisabled || !t.supportsFiber) return;
            try {
              var n = t.inject(e);
              (lo = function (e) {
                try {
                  t.onCommitFiberRoot(
                    n,
                    e,
                    void 0,
                    64 == (64 & e.current.effectTag)
                  );
                } catch (e) {}
              }),
                (co = function (e) {
                  try {
                    t.onCommitFiberUnmount(n, e);
                  } catch (e) {}
                });
            } catch (e) {}
          }
        })(
          Ee({}, w, {
            overrideHookState: null,
            overrideProps: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: Be.ReactCurrentDispatcher,
            findHostInstanceByFiber: function (e) {
              return null === (e = sa(e)) ? null : e.stateNode;
            },
            findFiberByHostInstance: function (e) {
              return i ? i(e) : null;
            },
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
          })
        ),
        (po = (uo = uo).default || uo);
    })(),
    (du = po);
  var Su = Eu;
  function Cu(e) {
    return (Cu =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              "function" == typeof Symbol &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          })(e);
  }
  var ku,
    Tu = Cu;
  function Pu(e) {
    return e && "object" === Tu(e) && !Array.isArray(e);
  }
  function zu(t, n, e) {
    var r = 2 < arguments.length && void 0 !== e ? e : { clone: !0 },
      i = r.clone ? Su({}, t) : t;
    return (
      Pu(t) &&
        Pu(n) &&
        Object.keys(n).forEach(function (e) {
          "__proto__" !== e &&
            (Pu(n[e]) && e in t ? (i[e] = zu(t[e], n[e], r)) : (i[e] = n[e]));
        }),
      i
    );
  }
  function Ou() {}
  function Ru() {}
  var Mu,
    Nu,
    Lu,
    Iu,
    _u,
    Du,
    Au,
    Fu,
    Bu,
    Wu,
    $u,
    ju,
    Hu,
    Vu,
    qu,
    Uu,
    Gu,
    Yu = {};
  function Xu(e) {
    if ("object" == typeof e && null !== e) {
      var t = e.$$typeof;
      switch (t) {
        case Mu:
          switch ((e = e.type)) {
            case Fu:
            case Bu:
            case Lu:
            case _u:
            case Iu:
            case $u:
              return e;
            default:
              switch ((e = e && e.$$typeof)) {
                case Au:
                case Wu:
                case Vu:
                case Hu:
                case Du:
                  return e;
                default:
                  return t;
              }
          }
        case Nu:
          return t;
      }
    }
  }
  function Ku(e) {
    return Xu(e) === Bu;
  }
  (((RP = R(
    (!1 || (Wd = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"),
    (ku = Wd),
    (Ru.resetWarningCache = Ou),
    (Yu = (function () {
      function e(e, t, n, r, i, o) {
        if (o !== ku) {
          o = new Error(
            "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
          );
          throw ((o.name = "Invariant Violation"), o);
        }
      }
      function t() {
        return e;
      }
      var n = {
        array: (e.isRequired = e),
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: Ru,
        resetWarningCache: Ou,
      };
      return (n.PropTypes = n);
    })()))
  )).element,
  function () {
    return null;
  }).isRequired =
    (RP.element.isRequired,
    function () {
      return null;
    })),
    Yu.elementType;
  var Zu = {},
    Qu = {};
  Object.defineProperty(Qu, "__esModule", { value: !0 }),
    (of = "function" == typeof Symbol && Symbol.for),
    (Mu = of ? Symbol.for("react.element") : 60103),
    (Nu = of ? Symbol.for("react.portal") : 60106),
    (Lu = of ? Symbol.for("react.fragment") : 60107),
    (Iu = of ? Symbol.for("react.strict_mode") : 60108),
    (_u = of ? Symbol.for("react.profiler") : 60114),
    (Du = of ? Symbol.for("react.provider") : 60109),
    (Au = of ? Symbol.for("react.context") : 60110),
    (Fu = of ? Symbol.for("react.async_mode") : 60111),
    (Bu = of ? Symbol.for("react.concurrent_mode") : 60111),
    (Wu = of ? Symbol.for("react.forward_ref") : 60112),
    ($u = of ? Symbol.for("react.suspense") : 60113),
    (ju = of ? Symbol.for("react.suspense_list") : 60120),
    (Hu = of ? Symbol.for("react.memo") : 60115),
    (Vu = of ? Symbol.for("react.lazy") : 60116),
    (qu = of ? Symbol.for("react.fundamental") : 60117),
    (Uu = of ? Symbol.for("react.responder") : 60118),
    (Gu = of ? Symbol.for("react.scope") : 60119),
    (Qu.typeOf = Xu),
    (Qu.AsyncMode = Fu),
    (Qu.ConcurrentMode = Bu),
    (Qu.ContextConsumer = Au),
    (Qu.ContextProvider = Du),
    (Qu.Element = Mu),
    (Qu.ForwardRef = Wu),
    (Qu.Fragment = Lu),
    (Qu.Lazy = Vu),
    (Qu.Memo = Hu),
    (Qu.Portal = Nu),
    (Qu.Profiler = _u),
    (Qu.StrictMode = Iu),
    (Qu.Suspense = $u),
    (ap = function (e) {
      return (
        "string" == typeof e ||
        "function" == typeof e ||
        e === Lu ||
        e === Bu ||
        e === _u ||
        e === Iu ||
        e === $u ||
        e === ju ||
        ("object" == typeof e &&
          null !== e &&
          (e.$$typeof === Vu ||
            e.$$typeof === Hu ||
            e.$$typeof === Du ||
            e.$$typeof === Au ||
            e.$$typeof === Wu ||
            e.$$typeof === qu ||
            e.$$typeof === Uu ||
            e.$$typeof === Gu))
      );
    }),
    (Qu.isValidElementType = ap),
    (Jf = function (e) {
      return Ku(e) || Xu(e) === Fu;
    }),
    (Qu.isAsyncMode = Jf),
    (Qu.isConcurrentMode = Ku),
    (dp = function (e) {
      return Xu(e) === Au;
    }),
    (Qu.isContextConsumer = dp),
    (vp = function (e) {
      return Xu(e) === Du;
    }),
    (Qu.isContextProvider = vp),
    (bp = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === Mu;
    }),
    (Qu.isElement = bp),
    (xp = function (e) {
      return Xu(e) === Wu;
    }),
    (Qu.isForwardRef = xp),
    (Sp = function (e) {
      return Xu(e) === Lu;
    }),
    (Qu.isFragment = Sp),
    (If = function (e) {
      return Xu(e) === Vu;
    }),
    (Qu.isLazy = If),
    (_f = function (e) {
      return Xu(e) === Hu;
    }),
    (Qu.isMemo = _f),
    (Hf = function (e) {
      return Xu(e) === Nu;
    }),
    (Qu.isPortal = Hf),
    (Vf = function (e) {
      return Xu(e) === _u;
    }),
    (Qu.isProfiler = Vf),
    (Zf = function (e) {
      return Xu(e) === Iu;
    }),
    (Qu.isStrictMode = Zf),
    (Qf = function (e) {
      return Xu(e) === $u;
    }),
    (Qu.isSuspense = Qf),
    (Zu = Qu),
    ("undefined" != typeof window && window.Math == Math) ||
      ("undefined" != typeof self && self.Math == Math) ||
      Function("return this")(),
    RP.oneOfType([RP.func, RP.object]);
  var Ju = ["xs", "sm", "md", "lg", "xl"],
    ed = { black: "#000", white: "#fff" },
    td = {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
      A100: "#d5d5d5",
      A200: "#aaaaaa",
      A400: "#303030",
      A700: "#616161",
    },
    nd = "#7986cb",
    rd = "#3f51b5",
    id = "#303f9f",
    od = "#ff4081",
    ad = "#f50057",
    sd = "#c51162",
    ld = "#e57373",
    cd = "#f44336",
    ud = "#d32f2f",
    dd = "#ffb74d",
    pd = "#ff9800",
    fd = "#f57c00",
    hd = "#64b5f6",
    md = "#2196f3",
    gd = "#1976d2",
    vd = "#81c784",
    yd = "#4caf50",
    bd = "#388e3c",
    wd = {
      text: {
        primary: "rgba(0, 0, 0, 0.87)",
        secondary: "rgba(0, 0, 0, 0.54)",
        disabled: "rgba(0, 0, 0, 0.38)",
        hint: "rgba(0, 0, 0, 0.38)",
      },
      divider: "rgba(0, 0, 0, 0.12)",
      background: { paper: ed.white, default: td[50] },
      action: {
        active: "rgba(0, 0, 0, 0.54)",
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        disabled: "rgba(0, 0, 0, 0.26)",
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpaciy: 0.12,
      },
    },
    xd = {
      text: {
        primary: ed.white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)",
      },
      divider: "rgba(255, 255, 255, 0.12)",
      background: { paper: td[800], default: "#303030" },
      action: {
        active: ed.white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpaciy: 0.24,
      },
    };
  function Ed(e, t, n, r) {
    e[t] ||
      (e.hasOwnProperty(n)
        ? (e[t] = e[n])
        : "light" === t
        ? (e.light = yu(e.main, r))
        : "dark" === t && (e.dark = vu(e.main, 1.5 * r)));
  }
  function Sd(e) {
    var t = e.primary,
      n = void 0 === t ? { light: nd, main: rd, dark: id } : t,
      r = e.secondary,
      i = void 0 === r ? { light: od, main: ad, dark: sd } : r,
      o = e.error,
      a = void 0 === o ? { light: ld, main: cd, dark: ud } : o,
      s = e.warning,
      l = void 0 === s ? { light: dd, main: pd, dark: fd } : s,
      t = e.info,
      r = void 0 === t ? { light: hd, main: md, dark: gd } : t,
      o = e.success,
      s = void 0 === o ? { light: vd, main: yd, dark: bd } : o,
      t = e.type,
      o = void 0 === t ? "light" : t,
      t = e.contrastThreshold,
      c = void 0 === t ? 3 : t,
      t = e.tonalOffset,
      u = void 0 === t ? 0.2 : t,
      t = xu(e, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset",
      ]);
    function d(e) {
      if (!e)
        throw new TypeError(
          "Material-UI: missing background argument in getContrastText(".concat(
            e,
            ")."
          )
        );
      var t;
      return (
        (t = e),
        (e = xd.text.primary),
        (t = hu(t)),
        (e = hu(e)),
        ((Math.max(t, e) + 0.05) / (Math.min(t, e) + 0.05) >= c ? xd : wd).text
          .primary
      );
    }
    function p(e) {
      var t =
          1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 500,
        n =
          2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 300,
        r =
          3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : 700;
      return (
        !(e = Su({}, e)).main && e[t] && (e.main = e[t]),
        Ed(e, "light", n, u),
        Ed(e, "dark", r, u),
        e.contrastText || (e.contrastText = d(e.main)),
        e
      );
    }
    e = { dark: xd, light: wd };
    return zu(
      Su(
        {
          common: ed,
          type: o,
          primary: p(n),
          secondary: p(i, "A400", "A200", "A700"),
          error: p(a),
          warning: p(l),
          info: p(r),
          success: p(s),
          grey: td,
          contrastThreshold: c,
          getContrastText: d,
          augmentColor: p,
          tonalOffset: u,
        },
        e[o]
      ),
      t
    );
  }
  function Cd(e) {
    return Math.round(1e5 * e) / 1e5;
  }
  var kd = { textTransform: "uppercase" },
    Td = '"Roboto", "Helvetica", "Arial", sans-serif';
  function Pd(e, t, n, r, i, o, a, s, l, c, u, d) {
    return [
      ""
        .concat(arguments.length <= 0 ? void 0 : e, "px ")
        .concat(arguments.length <= 1 ? void 0 : t, "px ")
        .concat(arguments.length <= 2 ? void 0 : n, "px ")
        .concat(arguments.length <= 3 ? void 0 : r, "px rgba(0,0,0,")
        .concat(0.2, ")"),
      ""
        .concat(arguments.length <= 4 ? void 0 : i, "px ")
        .concat(arguments.length <= 5 ? void 0 : o, "px ")
        .concat(arguments.length <= 6 ? void 0 : a, "px ")
        .concat(arguments.length <= 7 ? void 0 : s, "px rgba(0,0,0,")
        .concat(0.14, ")"),
      ""
        .concat(arguments.length <= 8 ? void 0 : l, "px ")
        .concat(arguments.length <= 9 ? void 0 : c, "px ")
        .concat(arguments.length <= 10 ? void 0 : u, "px ")
        .concat(arguments.length <= 11 ? void 0 : d, "px rgba(0,0,0,")
        .concat(0.12, ")"),
    ].join(",");
  }
  var zd = [
      "none",
      Pd(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
      Pd(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
      Pd(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
      Pd(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
      Pd(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
      Pd(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
      Pd(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
      Pd(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
      Pd(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
      Pd(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
      Pd(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
      Pd(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
      Pd(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
      Pd(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
      Pd(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
      Pd(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
      Pd(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
      Pd(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
      Pd(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
      Pd(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
      Pd(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
      Pd(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
      Pd(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
      Pd(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8),
    ],
    Od = { borderRadius: 4 };
  function Rd(e) {
    var r,
      t = 0 < arguments.length && void 0 !== e ? e : 8;
    if (t.mui) return t;
    r =
      "function" == typeof t
        ? t
        : function (e) {
            return t * e;
          };
    function n() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
        t[n] = arguments[n];
      return 0 === t.length
        ? r(1)
        : 1 === t.length
        ? r(t[0])
        : t
            .map(function (e) {
              e = r(e);
              return "number" == typeof e ? "".concat(e, "px") : e;
            })
            .join(" ");
    }
    return (
      Object.defineProperty(n, "unit", {
        get: function () {
          return t;
        },
      }),
      (n.mui = !0),
      n
    );
  }
  var Md = {
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
      easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
      sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
    },
    Nd = {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    };
  function Ld(e) {
    return "".concat(Math.round(e), "ms");
  }
  var Id = {
      easing: Md,
      duration: Nd,
      create: function () {
        var e =
            0 < arguments.length && void 0 !== arguments[0]
              ? arguments[0]
              : ["all"],
          t =
            1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          n = t.duration,
          r = void 0 === n ? Nd.standard : n,
          n = t.easing,
          i = void 0 === n ? Md.easeInOut : n,
          n = t.delay,
          o = void 0 === n ? 0 : n;
        return (
          xu(t, ["duration", "easing", "delay"]),
          (Array.isArray(e) ? e : [e])
            .map(function (e) {
              return ""
                .concat(e, " ")
                .concat("string" == typeof r ? r : Ld(r), " ")
                .concat(i, " ")
                .concat("string" == typeof o ? o : Ld(o));
            })
            .join(",")
        );
      },
      getAutoHeightDuration: function (e) {
        if (!e) return 0;
        e /= 36;
        return Math.round(10 * (4 + 15 * Math.pow(e, 0.25) + e / 5));
      },
    },
    _d = {
      mobileStepper: 1e3,
      speedDial: 1050,
      appBar: 1100,
      drawer: 1200,
      modal: 1300,
      snackbar: 1400,
      tooltip: 1500,
    };
  function Dd(e) {
    for (
      var o,
        t,
        a,
        n,
        s,
        r,
        i,
        l,
        c,
        u,
        d = 0 < arguments.length && void 0 !== e ? e : {},
        p = d.breakpoints,
        f = void 0 === p ? {} : p,
        h = d.mixins,
        m = void 0 === h ? {} : h,
        g = d.palette,
        v = void 0 === g ? {} : g,
        y = d.spacing,
        b = d.typography,
        p = void 0 === b ? {} : b,
        h = xu(d, [
          "breakpoints",
          "mixins",
          "palette",
          "spacing",
          "typography",
        ]),
        g = Sd(v),
        v =
          ((d = (b = f).values),
          (l =
            void 0 === d ? { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 } : d),
          (c = void 0 === (d = b.unit) ? "px" : d),
          (u = void 0 === (d = b.step) ? 5 : d),
          (b = xu(b, ["values", "unit", "step"])),
          Su(
            {
              keys: Ju,
              values: l,
              up: S,
              down: function (e) {
                var t = Ju.indexOf(e) + 1,
                  n = l[Ju[t]];
                return t === Ju.length
                  ? S("xs")
                  : "@media (max-width:"
                      .concat(("number" == typeof n && 0 < t ? n : e) - u / 100)
                      .concat(c, ")");
              },
              between: C,
              only: function (e) {
                return C(e, e);
              },
              width: function (e) {
                return l[e];
              },
            },
            b
          )),
        f = Rd(y),
        h = zu(
          {
            breakpoints: v,
            direction: "ltr",
            mixins:
              ((i = f),
              (d = m),
              Su(
                {
                  gutters: function () {
                    var e =
                      0 < arguments.length && void 0 !== arguments[0]
                        ? arguments[0]
                        : {};
                    return Su(
                      { paddingLeft: i(2), paddingRight: i(2) },
                      e,
                      bu(
                        {},
                        r.up("sm"),
                        Su(
                          { paddingLeft: i(3), paddingRight: i(3) },
                          e[r.up("sm")]
                        )
                      )
                    );
                  },
                  toolbar:
                    (bu(
                      (b = { minHeight: 56 }),
                      "".concat(
                        (r = v).up("xs"),
                        " and (orientation: landscape)"
                      ),
                      { minHeight: 48 }
                    ),
                    bu(b, r.up("sm"), { minHeight: 64 }),
                    b),
                },
                d
              )),
            overrides: {},
            palette: g,
            props: {},
            shadows: zd,
            typography:
              ((y = g),
              (v = "function" == typeof (m = p) ? m(y) : m),
              (o = void 0 === (b = v.fontFamily) ? Td : b),
              (g = void 0 === (d = v.fontSize) ? 14 : d),
              (y = void 0 === (p = v.fontWeightLight) ? 300 : p),
              (b = void 0 === (m = v.fontWeightRegular) ? 400 : m),
              (p = void 0 === (d = v.fontWeightMedium) ? 500 : d),
              (d = void 0 === (m = v.fontWeightBold) ? 700 : m),
              (t = void 0 === (m = v.htmlFontSize) ? 16 : m),
              (a = v.allVariants),
              (m = v.pxToRem),
              (v = xu(v, [
                "fontFamily",
                "fontSize",
                "fontWeightLight",
                "fontWeightRegular",
                "fontWeightMedium",
                "fontWeightBold",
                "htmlFontSize",
                "allVariants",
                "pxToRem",
              ])),
              (n = g / 14),
              (s =
                m ||
                function (e) {
                  return "".concat((e / t) * n, "rem");
                }),
              (m = {
                h1: (m = function (e, t, n, r, i) {
                  return Su(
                    {
                      fontFamily: o,
                      fontWeight: e,
                      fontSize: s(t),
                      lineHeight: n,
                    },
                    o === Td
                      ? { letterSpacing: "".concat(Cd(r / t), "em") }
                      : {},
                    {},
                    i,
                    {},
                    a
                  );
                })(y, 96, 1.167, -1.5),
                h2: m(y, 60, 1.2, -0.5),
                h3: m(b, 48, 1.167, 0),
                h4: m(b, 34, 1.235, 0.25),
                h5: m(b, 24, 1.334, 0),
                h6: m(p, 20, 1.6, 0.15),
                subtitle1: m(b, 16, 1.75, 0.15),
                subtitle2: m(p, 14, 1.57, 0.1),
                body1: m(b, 16, 1.5, 0.15),
                body2: m(b, 14, 1.43, 0.15),
                button: m(p, 14, 1.75, 0.4, kd),
                caption: m(b, 12, 1.66, 0.4),
                overline: m(b, 12, 2.66, 1, kd),
              }),
              zu(
                Su(
                  {
                    htmlFontSize: t,
                    pxToRem: s,
                    round: Cd,
                    fontFamily: o,
                    fontSize: g,
                    fontWeightLight: y,
                    fontWeightRegular: b,
                    fontWeightMedium: p,
                    fontWeightBold: d,
                  },
                  m
                ),
                v,
                { clone: !1 }
              )),
            spacing: f,
            shape: Od,
            transitions: Id,
            zIndex: _d,
          },
          h
        ),
        w = arguments.length,
        x = new Array(1 < w ? w - 1 : 0),
        E = 1;
      E < w;
      E++
    )
      x[E - 1] = arguments[E];
    function S(e) {
      e = "number" == typeof l[e] ? l[e] : e;
      return "@media (min-width:".concat(e).concat(c, ")");
    }
    function C(e, t) {
      var n = Ju.indexOf(t);
      return n === Ju.length - 1
        ? S(e)
        : "@media (min-width:"
            .concat("number" == typeof l[e] ? l[e] : e)
            .concat(c, ") and ") +
            "(max-width:"
              .concat(
                (-1 !== n && "number" == typeof l[Ju[n + 1]]
                  ? l[Ju[n + 1]]
                  : t) -
                  u / 100
              )
              .concat(c, ")");
    }
    return x.reduce(function (e, t) {
      return zu(e, t);
    }, h);
  }
  var Ad =
      "function" == typeof Symbol && Symbol.for
        ? Symbol.for("mui.nested")
        : "__THEME_NESTED__",
    Fd = [
      "checked",
      "disabled",
      "error",
      "focused",
      "focusVisible",
      "required",
      "expanded",
      "selected",
    ];
  function Bd(e) {
    var t = e.theme,
      n = e.name,
      r = e.props;
    if (!t || !t.props || !t.props[n]) return r;
    var i,
      o = t.props[n];
    for (i in o) void 0 === r[i] && (r[i] = o[i]);
    return r;
  }
  var Wd =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              "function" == typeof Symbol &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          },
    $d =
      "object" === ("undefined" == typeof window ? "undefined" : Wd(window)) &&
      "object" ===
        ("undefined" == typeof document ? "undefined" : Wd(document)) &&
      9 === document.nodeType;
  function jd(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  function Hd(e, t, n) {
    return t && jd(e.prototype, t), n && jd(e, n), e;
  }
  function Vd(e, t) {
    (e.prototype = Object.create(t.prototype)),
      ((e.prototype.constructor = e).__proto__ = t);
  }
  function qd(e) {
    if (void 0 === e)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return e;
  }
  var Ud = {}.constructor;
  function Gd(e) {
    if (null == e || "object" != typeof e) return e;
    if (Array.isArray(e)) return e.map(Gd);
    if (e.constructor !== Ud) return e;
    var t,
      n = {};
    for (t in e) n[t] = Gd(e[t]);
    return n;
  }
  function Yd(e, t, n) {
    void 0 === e && (e = "unnamed");
    var r = n.jss,
      t = Gd(t);
    return r.plugins.onCreateRule(e, t, n) || (e[0], null);
  }
  var Xd = function (e, t) {
    for (var n = "", r = 0; r < e.length && "!important" !== e[r]; r++)
      n && (n += t), (n += e[r]);
    return n;
  };
  function Kd(e, t) {
    if ((void 0 === t && (t = !1), !Array.isArray(e))) return e;
    var n = "";
    if (Array.isArray(e[0]))
      for (var r = 0; r < e.length && "!important" !== e[r]; r++)
        n && (n += ", "), (n += Xd(e[r], " "));
    else n = Xd(e, ", ");
    return t || "!important" !== e[e.length - 1] || (n += " !important"), n;
  }
  function Zd(e, t) {
    for (var n = "", r = 0; r < t; r++) n += "  ";
    return n + e;
  }
  function Qd(e, t, n) {
    void 0 === n && (n = {});
    var r = "";
    if (!t) return r;
    var i,
      o = n.indent,
      a = void 0 === o ? 0 : o,
      s = t.fallbacks;
    if ((e && a++, s))
      if (Array.isArray(s))
        for (var l = 0; l < s.length; l++) {
          var c,
            u = s[l];
          for (c in u) {
            var d = u[c];
            null != d &&
              (r && (r += "\n"), (r += "" + Zd(c + ": " + Kd(d) + ";", a)));
          }
        }
      else
        for (var p in s) {
          var f = s[p];
          null != f &&
            (r && (r += "\n"), (r += "" + Zd(p + ": " + Kd(f) + ";", a)));
        }
    for (i in t) {
      var h = t[i];
      null != h &&
        "fallbacks" !== i &&
        (r && (r += "\n"), (r += "" + Zd(i + ": " + Kd(h) + ";", a)));
    }
    return (r || n.allowEmpty) && e
      ? Zd(e + " {" + (r = r && "\n" + r + "\n"), --a) + Zd("}", a)
      : r;
  }
  function Jd(e) {
    return ip ? ip(e) : e.replace(rp, "\\$1");
  }
  function ep(e, n) {
    return "string" == typeof e
      ? e.replace(gp, function (e, t) {
          return t in n ? n[t] : e;
        })
      : e;
  }
  function tp(e, t, n) {
    var r = e[t];
    (n = ep(r, n)) !== r && (e[t] = n);
  }
  var np,
    rp = /([[\].#*$><+~=|^:(),"'`\s])/g,
    ip = "undefined" != typeof CSS && CSS.escape,
    op = (function (o) {
      function e(e, t, n) {
        var r;
        ((r = o.call(this, e, t, n) || this).selectorText = void 0),
          (r.id = void 0),
          (r.renderable = void 0);
        var i = n.selector,
          e = n.scoped,
          t = n.sheet,
          n = n.generateId;
        return (
          i
            ? (r.selectorText = i)
            : !1 !== e &&
              ((r.id = n(qd(qd(r)), t)), (r.selectorText = "." + Jd(r.id))),
          r
        );
      }
      Vd(e, o);
      var t = e.prototype;
      return (
        (t.applyTo = function (e) {
          var t = this.renderer;
          if (t) {
            var n,
              r = this.toJSON();
            for (n in r) t.setProperty(e, n, r[n]);
          }
          return this;
        }),
        (t.toJSON = function () {
          var e,
            t = {};
          for (e in this.style) {
            var n = this.style[e];
            "object" != typeof n
              ? (t[e] = n)
              : Array.isArray(n) && (t[e] = Kd(n));
          }
          return t;
        }),
        (t.toString = function (e) {
          var t = this.options.sheet,
            e = t && t.options.link ? Su({}, e, { allowEmpty: !0 }) : e;
          return Qd(this.selectorText, this.style, e);
        }),
        Hd(e, [
          {
            key: "selector",
            set: function (e) {
              var t, n;
              e !== this.selectorText &&
                ((this.selectorText = e),
                (t = this.renderer),
                (n = this.renderable) &&
                  t &&
                  (t.setSelector(n, e) || t.replaceRule(n, this)));
            },
            get: function () {
              return this.selectorText;
            },
          },
        ]),
        e
      );
    })(
      (of =
        ((Hp.prototype.prop = function (e, t, n) {
          if (void 0 === t) return this.style[e];
          var r = !!n && n.force;
          if (!r && this.style[e] === t) return this;
          var i = t;
          (n && !1 === n.process) ||
            (i = this.options.jss.plugins.onChangeValue(t, e, this));
          (n = null == i || !1 === i), (t = e in this.style);
          if (n && !t && !r) return this;
          t = n && t;
          if (
            (t ? delete this.style[e] : (this.style[e] = i),
            this.renderable && this.renderer)
          )
            return (
              t
                ? this.renderer.removeProperty(this.renderable, e)
                : this.renderer.setProperty(this.renderable, e, i),
              this
            );
          i = this.options.sheet;
          return i && i.attached, this;
        }),
        Hp))
    ),
    ap = {
      onCreateRule: function (e, t, n) {
        return "@" === e[0] || (n.parent && "keyframes" === n.parent.type)
          ? null
          : new op(e, t, n);
      },
    },
    sp = { indent: 1, children: !0 },
    lp = /@([\w-]+)/,
    cp =
      (((Jf = jp.prototype).getRule = function (e) {
        return this.rules.get(e);
      }),
      (Jf.indexOf = function (e) {
        return this.rules.indexOf(e);
      }),
      (Jf.addRule = function (e, t, n) {
        n = this.rules.add(e, t, n);
        return n ? (this.options.jss.plugins.onProcessRule(n), n) : null;
      }),
      (Jf.toString = function (e) {
        if (
          (void 0 === e && (e = sp),
          null == e.indent && (e.indent = sp.indent),
          null == e.children && (e.children = sp.children),
          !1 === e.children)
        )
          return this.query + " {}";
        e = this.rules.toString(e);
        return e ? this.query + " {\n" + e + "\n}" : "";
      }),
      jp),
    up = /@media|@supports\s+/,
    dp = {
      onCreateRule: function (e, t, n) {
        return up.test(e) ? new cp(e, t, n) : null;
      },
    },
    pp = { indent: 1, children: !0 },
    fp = /@keyframes\s+([\w-]+)/,
    hp =
      (($p.prototype.toString = function (e) {
        if (
          (void 0 === e && (e = pp),
          null == e.indent && (e.indent = pp.indent),
          null == e.children && (e.children = pp.children),
          !1 === e.children)
        )
          return this.at + " " + this.id + " {}";
        e = (e = this.rules.toString(e)) && "\n" + e + "\n";
        return this.at + " " + this.id + " {" + e + "}";
      }),
      $p),
    mp = /@keyframes\s+/,
    gp = /\$([\w-]+)/g,
    vp = {
      onCreateRule: function (e, t, n) {
        return "string" == typeof e && mp.test(e) ? new hp(e, t, n) : null;
      },
      onProcessStyle: function (e, t, n) {
        return (
          "style" === t.type &&
            n &&
            ("animation-name" in e && tp(e, "animation-name", n.keyframes),
            "animation" in e && tp(e, "animation", n.keyframes)),
          e
        );
      },
      onChangeValue: function (e, t, n) {
        var r = n.options.sheet;
        if (!r) return e;
        switch (t) {
          case "animation":
          case "animation-name":
            return ep(e, r.keyframes);
          default:
            return e;
        }
      },
    },
    yp =
      (Vd(Wp, (np = of)),
      (Wp.prototype.toString = function (e) {
        var t = this.options.sheet,
          e = t && t.options.link ? Su({}, e, { allowEmpty: !0 }) : e;
        return Qd(this.key, this.style, e);
      }),
      Wp),
    bp = {
      onCreateRule: function (e, t, n) {
        return n.parent && "keyframes" === n.parent.type
          ? new yp(e, t, n)
          : null;
      },
    },
    wp =
      ((Bp.prototype.toString = function (e) {
        if (Array.isArray(this.style)) {
          for (var t = "", n = 0; n < this.style.length; n++)
            (t += Qd(this.key, this.style[n])),
              this.style[n + 1] && (t += "\n");
          return t;
        }
        return Qd(this.key, this.style, e);
      }),
      Bp),
    xp = {
      onCreateRule: function (e, t, n) {
        return "@font-face" === e ? new wp(e, t, n) : null;
      },
    },
    Ep =
      ((Fp.prototype.toString = function (e) {
        return Qd(this.key, this.style, e);
      }),
      Fp),
    Sp = {
      onCreateRule: function (e, t, n) {
        return "@viewport" === e || "@-ms-viewport" === e
          ? new Ep(e, t, n)
          : null;
      },
    },
    Cp =
      ((Ap.prototype.toString = function (e) {
        if (Array.isArray(this.value)) {
          for (var t = "", n = 0; n < this.value.length; n++)
            (t += this.key + " " + this.value[n] + ";"),
              this.value[n + 1] && (t += "\n");
          return t;
        }
        return this.key + " " + this.value + ";";
      }),
      Ap),
    kp = { "@charset": !0, "@import": !0, "@namespace": !0 },
    Tp = [
      ap,
      dp,
      vp,
      bp,
      xp,
      Sp,
      {
        onCreateRule: function (e, t, n) {
          return e in kp ? new Cp(e, t, n) : null;
        },
      },
    ],
    Pp = { process: !0 },
    zp = { force: !0, process: !0 },
    Op =
      (((If = Dp.prototype).add = function (e, t, n) {
        var r = this.options,
          i = r.parent,
          o = r.sheet,
          a = r.jss,
          s = r.Renderer,
          l = r.generateId,
          r = r.scoped,
          r = Su(
            {
              classes: this.classes,
              parent: i,
              sheet: o,
              jss: a,
              Renderer: s,
              generateId: l,
              scoped: r,
              name: e,
            },
            n
          ),
          n = e;
        e in this.raw && (n = e + "-d" + this.counter++),
          (this.raw[n] = t),
          n in this.classes && (r.selector = "." + Jd(this.classes[n]));
        t = Yd(n, t, r);
        if (!t) return null;
        this.register(t);
        r = void 0 === r.index ? this.index.length : r.index;
        return this.index.splice(r, 0, t), t;
      }),
      (If.get = function (e) {
        return this.map[e];
      }),
      (If.remove = function (e) {
        this.unregister(e),
          delete this.raw[e.key],
          this.index.splice(this.index.indexOf(e), 1);
      }),
      (If.indexOf = function (e) {
        return this.index.indexOf(e);
      }),
      (If.process = function () {
        var e = this.options.jss.plugins;
        this.index.slice(0).forEach(e.onProcessRule, e);
      }),
      (If.register = function (e) {
        (this.map[e.key] = e) instanceof op
          ? (this.map[e.selector] = e).id && (this.classes[e.key] = e.id)
          : e instanceof hp &&
            this.keyframes &&
            (this.keyframes[e.name] = e.id);
      }),
      (If.unregister = function (e) {
        delete this.map[e.key],
          e instanceof op
            ? (delete this.map[e.selector], delete this.classes[e.key])
            : e instanceof hp && delete this.keyframes[e.name];
      }),
      (If.update = function () {
        var e, t, n;
        if (
          ("string" == typeof (arguments.length <= 0 ? void 0 : arguments[0])
            ? ((e = arguments.length <= 0 ? void 0 : arguments[0]),
              (t = arguments.length <= 1 ? void 0 : arguments[1]),
              (n = arguments.length <= 2 ? void 0 : arguments[2]))
            : ((t = arguments.length <= 0 ? void 0 : arguments[0]),
              (n = arguments.length <= 1 ? void 0 : arguments[1]),
              (e = null)),
          e)
        )
          this.updateOne(this.map[e], t, n);
        else
          for (var r = 0; r < this.index.length; r++)
            this.updateOne(this.index[r], t, n);
      }),
      (If.updateOne = function (e, t, n) {
        void 0 === n && (n = Pp);
        var r = this.options,
          i = r.jss.plugins,
          r = r.sheet;
        if (e.rules instanceof Dp) e.rules.update(t, n);
        else {
          var o = e,
            a = o.style;
          if ((i.onUpdate(t, e, r, n), n.process && a && a !== o.style)) {
            for (var s in (i.onProcessStyle(o.style, o, r), o.style)) {
              var l = o.style[s];
              l !== a[s] && o.prop(s, l, zp);
            }
            for (var c in a) {
              var u = o.style[c],
                d = a[c];
              null == u && u !== d && o.prop(c, null, zp);
            }
          }
        }
      }),
      (If.toString = function (e) {
        for (
          var t = "", n = this.options.sheet, r = !!n && n.options.link, i = 0;
          i < this.index.length;
          i++
        ) {
          var o = this.index[i].toString(e);
          (o || r) && (t && (t += "\n"), (t += o));
        }
        return t;
      }),
      Dp),
    Rp =
      (((_f = _p.prototype).attach = function () {
        return (
          this.attached ||
            (this.renderer && this.renderer.attach(),
            (this.attached = !0),
            this.deployed || this.deploy()),
          this
        );
      }),
      (_f.detach = function () {
        return (
          this.attached &&
            (this.renderer && this.renderer.detach(), (this.attached = !1)),
          this
        );
      }),
      (_f.addRule = function (e, t, n) {
        var r = this.queue;
        this.attached && !r && (this.queue = []);
        n = this.rules.add(e, t, n);
        return n
          ? (this.options.jss.plugins.onProcessRule(n),
            this.attached
              ? this.deployed &&
                (r
                  ? r.push(n)
                  : (this.insertRule(n),
                    this.queue &&
                      (this.queue.forEach(this.insertRule, this),
                      (this.queue = void 0))))
              : (this.deployed = !1),
            n)
          : null;
      }),
      (_f.insertRule = function (e) {
        this.renderer && this.renderer.insertRule(e);
      }),
      (_f.addRules = function (e, t) {
        var n,
          r = [];
        for (n in e) {
          var i = this.addRule(n, e[n], t);
          i && r.push(i);
        }
        return r;
      }),
      (_f.getRule = function (e) {
        return this.rules.get(e);
      }),
      (_f.deleteRule = function (e) {
        e = "object" == typeof e ? e : this.rules.get(e);
        return (
          !!e &&
          (this.rules.remove(e),
          !(this.attached && e.renderable && this.renderer) ||
            this.renderer.deleteRule(e.renderable))
        );
      }),
      (_f.indexOf = function (e) {
        return this.rules.indexOf(e);
      }),
      (_f.deploy = function () {
        return (
          this.renderer && this.renderer.deploy(), (this.deployed = !0), this
        );
      }),
      (_f.update = function () {
        var e;
        return (e = this.rules).update.apply(e, arguments), this;
      }),
      (_f.updateOne = function (e, t, n) {
        return this.rules.updateOne(e, t, n), this;
      }),
      (_f.toString = function (e) {
        return this.rules.toString(e);
      }),
      _p),
    Mp =
      (((Hf = Ip.prototype).onCreateRule = function (e, t, n) {
        for (var r = 0; r < this.registry.onCreateRule.length; r++) {
          var i = this.registry.onCreateRule[r](e, t, n);
          if (i) return i;
        }
        return null;
      }),
      (Hf.onProcessRule = function (e) {
        if (!e.isProcessed) {
          for (
            var t = e.options.sheet, n = 0;
            n < this.registry.onProcessRule.length;
            n++
          )
            this.registry.onProcessRule[n](e, t);
          e.style && this.onProcessStyle(e.style, e, t), (e.isProcessed = !0);
        }
      }),
      (Hf.onProcessStyle = function (e, t, n) {
        for (var r = 0; r < this.registry.onProcessStyle.length; r++)
          t.style = this.registry.onProcessStyle[r](t.style, t, n);
      }),
      (Hf.onProcessSheet = function (e) {
        for (var t = 0; t < this.registry.onProcessSheet.length; t++)
          this.registry.onProcessSheet[t](e);
      }),
      (Hf.onUpdate = function (e, t, n, r) {
        for (var i = 0; i < this.registry.onUpdate.length; i++)
          this.registry.onUpdate[i](e, t, n, r);
      }),
      (Hf.onChangeValue = function (e, t, n) {
        for (var r = e, i = 0; i < this.registry.onChangeValue.length; i++)
          r = this.registry.onChangeValue[i](r, t, n);
        return r;
      }),
      (Hf.use = function (e, t) {
        void 0 === t && (t = { queue: "external" });
        t = this.plugins[t.queue];
        -1 === t.indexOf(e) &&
          (t.push(e),
          (this.registry = []
            .concat(this.plugins.external, this.plugins.internal)
            .reduce(
              function (e, t) {
                for (var n in t) n in e && e[n].push(t[n]);
                return e;
              },
              {
                onCreateRule: [],
                onProcessRule: [],
                onProcessStyle: [],
                onProcessSheet: [],
                onChangeValue: [],
                onUpdate: [],
              }
            )));
      }),
      Ip),
    Np = new (((Vf = Lp.prototype).add = function (e) {
      var t = this.registry,
        n = e.options.index;
      if (-1 === t.indexOf(e))
        if (0 === t.length || n >= this.index) t.push(e);
        else
          for (var r = 0; r < t.length; r++)
            if (t[r].options.index > n) return void t.splice(r, 0, e);
    }),
    (Vf.reset = function () {
      this.registry = [];
    }),
    (Vf.remove = function (e) {
      e = this.registry.indexOf(e);
      this.registry.splice(e, 1);
    }),
    (Vf.toString = function (e) {
      for (
        var e = void 0 === e ? {} : e,
          t = e.attached,
          n = wu(e, ["attached"]),
          r = "",
          i = 0;
        i < this.registry.length;
        i++
      ) {
        var o = this.registry[i];
        (null != t && o.attached !== t) ||
          (r && (r += "\n"), (r += o.toString(n)));
      }
      return r;
    }),
    Hd(Lp, [
      {
        key: "index",
        get: function () {
          return 0 === this.registry.length
            ? 0
            : this.registry[this.registry.length - 1].options.index;
        },
      },
    ]),
    Lp)();
  function Lp() {
    this.registry = [];
  }
  function Ip() {
    (this.plugins = { internal: [], external: [] }), (this.registry = void 0);
  }
  function _p(e, t) {
    for (var n in ((this.options = void 0),
    (this.deployed = void 0),
    (this.attached = void 0),
    (this.rules = void 0),
    (this.renderer = void 0),
    (this.classes = void 0),
    (this.keyframes = void 0),
    (this.queue = void 0),
    (this.attached = !1),
    (this.deployed = !1),
    (this.classes = {}),
    (this.keyframes = {}),
    (this.options = Su({}, t, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes,
    })),
    t.Renderer && (this.renderer = new t.Renderer(this)),
    (this.rules = new Op(this.options)),
    e))
      this.rules.add(n, e[n]);
    this.rules.process();
  }
  function Dp(e) {
    (this.map = {}),
      (this.raw = {}),
      (this.index = []),
      (this.counter = 0),
      (this.options = void 0),
      (this.classes = void 0),
      (this.keyframes = void 0),
      (this.options = e),
      (this.classes = e.classes),
      (this.keyframes = e.keyframes);
  }
  function Ap(e, t, n) {
    (this.type = "simple"),
      (this.key = void 0),
      (this.value = void 0),
      (this.options = void 0),
      (this.isProcessed = !1),
      (this.renderable = void 0),
      (this.key = e),
      (this.value = t),
      (this.options = n);
  }
  function Fp(e, t, n) {
    (this.type = "viewport"),
      (this.at = "@viewport"),
      (this.key = void 0),
      (this.style = void 0),
      (this.options = void 0),
      (this.isProcessed = !1),
      (this.renderable = void 0),
      (this.key = e),
      (this.style = t),
      (this.options = n);
  }
  function Bp(e, t, n) {
    (this.type = "font-face"),
      (this.at = "@font-face"),
      (this.key = void 0),
      (this.style = void 0),
      (this.options = void 0),
      (this.isProcessed = !1),
      (this.renderable = void 0),
      (this.key = e),
      (this.style = t),
      (this.options = n);
  }
  function Wp() {
    for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return (
      ((e = np.call.apply(np, [this].concat(n)) || this).renderable = void 0), e
    );
  }
  function $p(e, t, n) {
    (this.type = "keyframes"),
      (this.at = "@keyframes"),
      (this.key = void 0),
      (this.name = void 0),
      (this.id = void 0),
      (this.rules = void 0),
      (this.options = void 0),
      (this.isProcessed = !1),
      (this.renderable = void 0);
    var r = e.match(fp);
    r && r[1] ? (this.name = r[1]) : (this.name = "noname"),
      (this.key = this.type + "-" + this.name);
    var i,
      o = (this.options = n).scoped,
      e = n.sheet,
      r = n.generateId;
    for (i in ((this.id = !1 === o ? this.name : Jd(r(this, e))),
    (this.rules = new Op(Su({}, n, { parent: this }))),
    t))
      this.rules.add(i, t[i], Su({}, n, { parent: this }));
    this.rules.process();
  }
  function jp(e, t, n) {
    (this.type = "conditional"),
      (this.at = void 0),
      (this.key = void 0),
      (this.query = void 0),
      (this.rules = void 0),
      (this.options = void 0),
      (this.isProcessed = !1),
      (this.renderable = void 0),
      (this.key = e),
      (this.query = n.name);
    var r,
      e = e.match(lp);
    for (r in ((this.at = e ? e[1] : "unknown"),
    (this.options = n),
    (this.rules = new Op(Su({}, n, { parent: this }))),
    t))
      this.rules.add(r, t[r]);
    this.rules.process();
  }
  function Hp(e, t, n) {
    (this.type = "style"),
      (this.key = void 0),
      (this.isProcessed = !1),
      (this.style = void 0),
      (this.renderer = void 0),
      (this.renderable = void 0),
      (this.options = void 0);
    var r = n.sheet,
      i = n.Renderer;
    (this.key = e),
      (this.options = n),
      (this.style = t),
      r ? (this.renderer = r.renderer) : i && (this.renderer = new i());
  }
  function Vp(i) {
    void 0 === i && (i = {});
    var o = 0;
    return function (e, t) {
      o += 1;
      var n = "",
        r = "";
      return (
        t &&
          (t.options.classNamePrefix && (r = t.options.classNamePrefix),
          null != t.options.jss.id && (n = String(t.options.jss.id))),
        i.minify
          ? "" + (r || "c") + qp + n + o
          : r + e.key + "-" + qp + (n ? "-" + n : "") + "-" + o
      );
    };
  }
  null ==
    (Zf =
      "undefined" != typeof window && window.Math == Math
        ? window
        : "undefined" != typeof self && self.Math == Math
        ? self
        : Function("return this")())[
      (Qf = "2f1acc6c3a606b082e5eef5e54414ffb")
    ] && (Zf[Qf] = 0);
  var qp = Zf[Qf]++;
  function Up(e, t) {
    try {
      return e.attributeStyleMap
        ? e.attributeStyleMap.get(t)
        : e.style.getPropertyValue(t);
    } catch (e) {
      return "";
    }
  }
  function Gp(e, t, n) {
    try {
      var r = n;
      if (
        Array.isArray(n) &&
        ((r = Kd(n, !0)), "!important" === n[n.length - 1])
      )
        return e.style.setProperty(t, r, "important"), !0;
      e.attributeStyleMap
        ? e.attributeStyleMap.set(t, r)
        : e.style.setProperty(t, r);
    } catch (e) {
      return !1;
    }
    return !0;
  }
  function Yp(e, t) {
    try {
      e.attributeStyleMap
        ? e.attributeStyleMap.delete(t)
        : e.style.removeProperty(t);
    } catch (e) {}
  }
  function Xp(e, t) {
    return (e.selectorText = t), e.selectorText === t;
  }
  var Kp = (Qu = function (e) {
    var t;
    return function () {
      return (t = t || e());
    };
  })(function () {
    return document.querySelector("head");
  });
  function Zp(e, t, n) {
    var r = e.cssRules.length;
    (void 0 === n || r < n) && (n = r);
    try {
      "insertRule" in e
        ? e.insertRule(t, n)
        : "appendRule" in e && e.appendRule(t);
    } catch (e) {
      return !1;
    }
    return e.cssRules[n];
  }
  var Qp = Qu(function () {
      var e = document.querySelector('meta[property="csp-nonce"]');
      return e ? e.getAttribute("content") : null;
    }),
    Jp =
      (((Wd = rf.prototype).attach = function () {
        var e, t, n;
        !this.element.parentNode &&
          this.sheet &&
          ((e = this.element),
          (t = this.sheet.options),
          (n = t.insertionPoint),
          !1 !==
            (t = (function (e) {
              var t = Np.registry;
              if (0 < t.length) {
                var n = (function (e, t) {
                  for (var n = 0; n < e.length; n++) {
                    var r = e[n];
                    if (
                      r.attached &&
                      r.options.index > t.index &&
                      r.options.insertionPoint === t.insertionPoint
                    )
                      return r;
                  }
                  return null;
                })(t, e);
                if (n && n.renderer)
                  return {
                    parent: n.renderer.element.parentNode,
                    node: n.renderer.element,
                  };
                if (
                  (n = (function (e, t) {
                    for (var n = e.length - 1; 0 <= n; n--) {
                      var r = e[n];
                      if (
                        r.attached &&
                        r.options.insertionPoint === t.insertionPoint
                      )
                        return r;
                    }
                    return null;
                  })(t, e)) &&
                  n.renderer
                )
                  return {
                    parent: n.renderer.element.parentNode,
                    node: n.renderer.element.nextSibling,
                  };
              }
              if ((e = e.insertionPoint) && "string" == typeof e) {
                e = (function (e) {
                  for (var t = Kp(), n = 0; n < t.childNodes.length; n++) {
                    var r = t.childNodes[n];
                    if (8 === r.nodeType && r.nodeValue.trim() === e) return r;
                  }
                  return null;
                })(e);
                if (e) return { parent: e.parentNode, node: e.nextSibling };
              }
              return !1;
            })(t)) && t.parent
            ? t.parent.insertBefore(e, t.node)
            : n && "number" == typeof n.nodeType
            ? (t = n.parentNode) && t.insertBefore(e, n.nextSibling)
            : Kp().appendChild(e),
          (e = Boolean(this.sheet && this.sheet.deployed)),
          this.hasInsertedRules &&
            e &&
            ((this.hasInsertedRules = !1), this.deploy()));
      }),
      (Wd.detach = function () {
        var e = this.element.parentNode;
        e && e.removeChild(this.element);
      }),
      (Wd.deploy = function () {
        var e = this.sheet;
        e &&
          (e.options.link
            ? this.insertRules(e.rules)
            : (this.element.textContent = "\n" + e.toString() + "\n"));
      }),
      (Wd.insertRules = function (e, t) {
        for (var n = 0; n < e.index.length; n++)
          this.insertRule(e.index[n], n, t);
      }),
      (Wd.insertRule = function (e, t, n) {
        if ((void 0 === n && (n = this.element.sheet), e.rules)) {
          var r = e,
            i = n;
          return (
            (("conditional" !== e.type && "keyframes" !== e.type) ||
              !1 !== (i = Zp(n, r.toString({ children: !1 }), t))) &&
            (this.insertRules(r.rules, i), i)
          );
        }
        if (
          e.renderable &&
          e.renderable.parentStyleSheet === this.element.sheet
        )
          return e.renderable;
        i = e.toString();
        if (!i) return !1;
        t = Zp(n, i, t);
        return !1 !== t && ((this.hasInsertedRules = !0), (e.renderable = t));
      }),
      (Wd.deleteRule = function (e) {
        var t = this.element.sheet,
          e = this.indexOf(e);
        return -1 !== e && (t.deleteRule(e), !0);
      }),
      (Wd.indexOf = function (e) {
        for (var t = this.element.sheet.cssRules, n = 0; n < t.length; n++)
          if (e === t[n]) return n;
        return -1;
      }),
      (Wd.replaceRule = function (e, t) {
        e = this.indexOf(e);
        return (
          -1 !== e && (this.element.sheet.deleteRule(e), this.insertRule(t, e))
        );
      }),
      (Wd.getRules = function () {
        return this.element.sheet.cssRules;
      }),
      rf),
    ef = 0,
    tf =
      (((Jf = nf.prototype).setup = function (e) {
        return (
          void 0 === e && (e = {}),
          e.createGenerateId &&
            (this.options.createGenerateId = e.createGenerateId),
          e.id && (this.options.id = Su({}, this.options.id, e.id)),
          (e.createGenerateId || e.id) &&
            (this.generateId = this.options.createGenerateId(this.options.id)),
          null != e.insertionPoint &&
            (this.options.insertionPoint = e.insertionPoint),
          "Renderer" in e && (this.options.Renderer = e.Renderer),
          e.plugins && this.use.apply(this, e.plugins),
          this
        );
      }),
      (Jf.createStyleSheet = function (e, t) {
        void 0 === t && (t = {});
        var n = t.index;
        "number" != typeof n && (n = 0 === Np.index ? 0 : Np.index + 1);
        n = new Rp(
          e,
          Su({}, t, {
            jss: this,
            generateId: t.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: n,
          })
        );
        return this.plugins.onProcessSheet(n), n;
      }),
      (Jf.removeStyleSheet = function (e) {
        return e.detach(), Np.remove(e), this;
      }),
      (Jf.createRule = function (e, t, n) {
        if (
          (void 0 === t && (t = {}),
          void 0 === n && (n = {}),
          "object" == typeof e)
        )
          return this.createRule(void 0, e, t);
        n = Su({}, n, { name: e, jss: this, Renderer: this.options.Renderer });
        n.generateId || (n.generateId = this.generateId),
          n.classes || (n.classes = {}),
          n.keyframes || (n.keyframes = {});
        n = Yd(e, t, n);
        return n && this.plugins.onProcessRule(n), n;
      }),
      (Jf.use = function () {
        for (
          var t = this, e = arguments.length, n = new Array(e), r = 0;
          r < e;
          r++
        )
          n[r] = arguments[r];
        return (
          n.forEach(function (e) {
            t.plugins.use(e);
          }),
          this
        );
      }),
      nf);
  function nf(e) {
    (this.id = ef++),
      (this.version = "10.0.4"),
      (this.plugins = new Mp()),
      (this.options = {
        id: { minify: !1 },
        createGenerateId: Vp,
        Renderer: $d ? Jp : null,
        plugins: [],
      }),
      (this.generateId = Vp({ minify: !1 }));
    for (var t = 0; t < Tp.length; t++)
      this.plugins.use(Tp[t], { queue: "internal" });
    this.setup(e);
  }
  function rf(e) {
    (this.getPropertyValue = Up),
      (this.setProperty = Gp),
      (this.removeProperty = Yp),
      (this.setSelector = Xp),
      (this.element = void 0),
      (this.sheet = void 0),
      (this.hasInsertedRules = !1),
      e && Np.add(e),
      (this.sheet = e);
    var t = this.sheet ? this.sheet.options : {},
      n = t.media,
      e = t.meta,
      t = t.element;
    (this.element =
      t || (((t = document.createElement("style")).textContent = "\n"), t)),
      this.element.setAttribute("data-jss", ""),
      n && this.element.setAttribute("media", n),
      e && this.element.setAttribute("data-meta", e);
    e = Qp();
    e && this.element.setAttribute("nonce", e);
  }
  var of = "undefined" != typeof CSS && CSS && "number" in CSS,
    af =
      "fnValues" +
      (dp =
        ((ap = function (e) {
          return new tf(e);
        })(),
        Date.now())),
    sf = "fnStyle" + ++dp,
    lf = "@global",
    cf = "@global ",
    uf =
      (((vp = hf.prototype).getRule = function (e) {
        return this.rules.get(e);
      }),
      (vp.addRule = function (e, t, n) {
        n = this.rules.add(e, t, n);
        return this.options.jss.plugins.onProcessRule(n), n;
      }),
      (vp.indexOf = function (e) {
        return this.rules.indexOf(e);
      }),
      (vp.toString = function () {
        return this.rules.toString();
      }),
      hf),
    df =
      ((ff.prototype.toString = function (e) {
        return this.rule ? this.rule.toString(e) : "";
      }),
      ff),
    pf = /\s*,\s*/g;
  function ff(e, t, n) {
    (this.type = "global"),
      (this.at = lf),
      (this.options = void 0),
      (this.rule = void 0),
      (this.isProcessed = !1),
      (this.key = void 0),
      (this.key = e),
      (this.options = n);
    e = e.substr(cf.length);
    this.rule = n.jss.createRule(e, t, Su({}, n, { parent: this }));
  }
  function hf(e, t, n) {
    for (var r in ((this.type = "global"),
    (this.at = lf),
    (this.rules = void 0),
    (this.options = void 0),
    (this.key = void 0),
    (this.isProcessed = !1),
    (this.key = e),
    (this.options = n),
    (this.rules = new Op(Su({}, n, { parent: this }))),
    t))
      this.rules.add(r, t[r]);
    this.rules.process();
  }
  function mf(e, t) {
    for (var n = e.split(pf), r = "", i = 0; i < n.length; i++)
      (r += t + " " + n[i].trim()), n[i + 1] && (r += ", ");
    return r;
  }
  function gf() {
    return {
      onCreateRule: function (e, t, n) {
        if (!e) return null;
        if (e === lf) return new uf(e, t, n);
        if ("@" === e[0] && e.substr(0, cf.length) === cf)
          return new df(e, t, n);
        t = n.parent;
        return (
          t &&
            ("global" === t.type ||
              (t.options.parent && "global" === t.options.parent.type)) &&
            (n.scoped = !1),
          !1 === n.scoped && (n.selector = e),
          null
        );
      },
      onProcessRule: function (e) {
        "style" === e.type &&
          ((function (e) {
            var t = e.options,
              n = e.style,
              r = n ? n[lf] : null;
            if (r) {
              for (var i in r)
                t.sheet.addRule(
                  i,
                  r[i],
                  Su({}, t, { selector: mf(i, e.selector) })
                );
              delete n[lf];
            }
          })(e),
          (function (e) {
            var t,
              n,
              r = e.options,
              i = e.style;
            for (t in i)
              "@" === t[0] &&
                t.substr(0, lf.length) === lf &&
                ((n = mf(t.substr(lf.length), e.selector)),
                r.sheet.addRule(n, i[t], Su({}, r, { selector: n })),
                delete i[t]);
          })(e));
      },
    };
  }
  var vf = /\s*,\s*/g,
    yf = /&/g,
    bf = /\$([\w-]+)/g;
  function wf() {
    return {
      onProcessStyle: function (e, t, n) {
        if ("style" !== t.type) return e;
        var r,
          i,
          o,
          a,
          s,
          l = t,
          c = l.options.parent;
        for (i in e) {
          var u,
            d = -1 !== i.indexOf("&"),
            p = "@" === i[0];
          (d || p) &&
            ((o = l),
            (a = c),
            (r = (s = r)
              ? Su({}, s, { index: s.index + 1 })
              : ((s = void 0 === (s = o.options.nestingLevel) ? 1 : s + 1),
                delete (o = Su({}, o.options, {
                  nestingLevel: s,
                  index: a.indexOf(o) + 1,
                })).name,
                o)),
            d
              ? ((u =
                  u ||
                  (function (r, i) {
                    return function (e, t) {
                      var n = r.getRule(t) || (i && i.getRule(t));
                      return n ? n.selector : t;
                    };
                  })(c, n)),
                (d = (d = (function (e, t) {
                  for (
                    var n = t.split(vf), r = e.split(vf), i = "", o = 0;
                    o < n.length;
                    o++
                  )
                    for (var a = n[o], s = 0; s < r.length; s++) {
                      var l = r[s];
                      i && (i += ", "),
                        (i +=
                          -1 !== l.indexOf("&")
                            ? l.replace(yf, a)
                            : a + " " + l);
                    }
                  return i;
                })(i, l.selector)).replace(bf, u)),
                c.addRule(d, e[i], Su({}, r, { selector: d })))
              : p &&
                c
                  .addRule(i, {}, r)
                  .addRule(l.key, e[i], { selector: l.selector }),
            delete e[i]);
        }
        return e;
      },
    };
  }
  var xf = /[A-Z]/g,
    Ef = /^ms-/,
    Sf = {};
  function Cf(e) {
    return "-" + e.toLowerCase();
  }
  function kf(e) {
    if (Sf.hasOwnProperty(e)) return Sf[e];
    var t = e.replace(xf, Cf);
    return (Sf[e] = Ef.test(t) ? "-" + t : t);
  }
  function Tf(e) {
    var t,
      n = {};
    for (t in e) n[0 === t.indexOf("--") ? t : kf(t)] = e[t];
    return (
      e.fallbacks &&
        (Array.isArray(e.fallbacks)
          ? (n.fallbacks = e.fallbacks.map(Tf))
          : (n.fallbacks = Tf(e.fallbacks))),
      n
    );
  }
  function Pf(e) {
    function t(e) {
      return e[1].toUpperCase();
    }
    var n,
      r = /(-[a-z])/g,
      i = {};
    for (n in e) (i[n] = e[n]), (i[n.replace(r, t)] = e[n]);
    return i;
  }
  (bp = of && CSS ? CSS.px : "px"),
    (xp = of && CSS ? CSS.ms : "ms"),
    (Sp = of && CSS ? CSS.percent : "%");
  var zf = Pf({
    "animation-delay": xp,
    "animation-duration": xp,
    "background-position": bp,
    "background-position-x": bp,
    "background-position-y": bp,
    "background-size": bp,
    border: bp,
    "border-bottom": bp,
    "border-bottom-left-radius": bp,
    "border-bottom-right-radius": bp,
    "border-bottom-width": bp,
    "border-left": bp,
    "border-left-width": bp,
    "border-radius": bp,
    "border-right": bp,
    "border-right-width": bp,
    "border-top": bp,
    "border-top-left-radius": bp,
    "border-top-right-radius": bp,
    "border-top-width": bp,
    "border-width": bp,
    margin: bp,
    "margin-bottom": bp,
    "margin-left": bp,
    "margin-right": bp,
    "margin-top": bp,
    padding: bp,
    "padding-bottom": bp,
    "padding-left": bp,
    "padding-right": bp,
    "padding-top": bp,
    "mask-position-x": bp,
    "mask-position-y": bp,
    "mask-size": bp,
    height: bp,
    width: bp,
    "min-height": bp,
    "max-height": bp,
    "min-width": bp,
    "max-width": bp,
    bottom: bp,
    left: bp,
    top: bp,
    right: bp,
    "box-shadow": bp,
    "text-shadow": bp,
    "column-gap": bp,
    "column-rule": bp,
    "column-rule-width": bp,
    "column-width": bp,
    "font-size": bp,
    "font-size-delta": bp,
    "letter-spacing": bp,
    "text-indent": bp,
    "text-stroke": bp,
    "text-stroke-width": bp,
    "word-spacing": bp,
    motion: bp,
    "motion-offset": bp,
    outline: bp,
    "outline-offset": bp,
    "outline-width": bp,
    perspective: bp,
    "perspective-origin-x": Sp,
    "perspective-origin-y": Sp,
    "transform-origin": Sp,
    "transform-origin-x": Sp,
    "transform-origin-y": Sp,
    "transform-origin-z": Sp,
    "transition-delay": xp,
    "transition-duration": xp,
    "vertical-align": bp,
    "flex-basis": bp,
    "shape-margin": bp,
    size: bp,
    grid: bp,
    "grid-gap": bp,
    "grid-row-gap": bp,
    "grid-column-gap": bp,
    "grid-template-rows": bp,
    "grid-template-columns": bp,
    "grid-auto-rows": bp,
    "grid-auto-columns": bp,
    "box-shadow-x": bp,
    "box-shadow-y": bp,
    "box-shadow-blur": bp,
    "box-shadow-spread": bp,
    "font-line-height": bp,
    "text-shadow-x": bp,
    "text-shadow-y": bp,
    "text-shadow-blur": bp,
  });
  function Of(e, t, n) {
    if (!t) return t;
    if (Array.isArray(t))
      for (var r = 0; r < t.length; r++) t[r] = Of(e, t[r], n);
    else if ("object" == typeof t)
      if ("fallbacks" === e) for (var i in t) t[i] = Of(i, t[i], n);
      else for (var o in t) t[o] = Of(e + "-" + o, t[o], n);
    else if ("number" == typeof t)
      return n[e]
        ? "" + t + n[e]
        : zf[e]
        ? "function" == typeof zf[e]
          ? zf[e](t).toString()
          : "" + t + zf[e]
        : t.toString();
    return t;
  }
  function Rf(e) {
    if (
      Symbol.iterator in Object(e) ||
      "[object Arguments]" === Object.prototype.toString.call(e)
    )
      return Array.from(e);
  }
  function Mf(e) {
    return (
      (function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++)
            n[t] = e[t];
          return n;
        }
      })(e) ||
      Rf(e) ||
      (function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      })()
    );
  }
  var Nf = "",
    Lf = "",
    If = "",
    _f = $d && "ontouchstart" in document.documentElement;
  if ($d) {
    var Df,
      Af = { Moz: "-moz-", ms: "-ms-", O: "-o-", Webkit: "-webkit-" },
      Ff = document.createElement("p").style;
    for (Df in Af)
      if (Df + "Transform" in Ff) {
        Lf = Af[(Nf = Df)];
        break;
      }
    "Webkit" === Nf && "msHyphens" in Ff && ((Nf = "ms"), (Lf = Af.ms)),
      "Webkit" === Nf && "-apple-trailing-word" in Ff && (If = "apple");
  }
  var Bf = Nf,
    Wf = Lf,
    $f = If,
    jf = _f,
    Hf = {
      noPrefill: ["appearance"],
      supportedProperty: function (e) {
        return "appearance" === e && ("ms" === Bf ? "-webkit-" + e : Wf + e);
      },
    },
    Vf = {
      noPrefill: ["color-adjust"],
      supportedProperty: function (e) {
        return (
          "color-adjust" === e && ("Webkit" === Bf ? Wf + "print-" + e : e)
        );
      },
    },
    qf = /[-\s]+(.)?/g;
  function Uf(e, t) {
    return t ? t.toUpperCase() : "";
  }
  function Gf(e) {
    return e.replace(qf, Uf);
  }
  function Yf(e) {
    return Gf("-" + e);
  }
  function Xf(e) {
    return Wf + e;
  }
  var Kf,
    Zf = {
      noPrefill: ["mask"],
      supportedProperty: function (e, t) {
        if (!/^mask/.test(e)) return !1;
        if ("Webkit" === Bf) {
          if (Gf("mask-image") in t) return e;
          if (Bf + Yf("mask-image") in t) return Wf + e;
        }
        return e;
      },
    },
    Qf = {
      noPrefill: ["text-orientation"],
      supportedProperty: function (e) {
        return "text-orientation" === e && ("apple" !== $f || jf ? e : Wf + e);
      },
    },
    Qu = {
      noPrefill: ["transform"],
      supportedProperty: function (e, t, n) {
        return "transform" === e && (n.transform ? e : Wf + e);
      },
    },
    Wd = {
      noPrefill: ["transition"],
      supportedProperty: function (e, t, n) {
        return "transition" === e && (n.transition ? e : Wf + e);
      },
    },
    Jf = {
      noPrefill: ["writing-mode"],
      supportedProperty: function (e) {
        return (
          "writing-mode" === e && ("Webkit" === Bf || "ms" === Bf ? Wf + e : e)
        );
      },
    },
    dp = {
      noPrefill: ["user-select"],
      supportedProperty: function (e) {
        return (
          "user-select" === e &&
          ("Moz" === Bf || "ms" === Bf || "apple" === $f ? Wf + e : e)
        );
      },
    },
    vp = {
      supportedProperty: function (e, t) {
        return (
          !!/^break-/.test(e) &&
          ("Webkit" === Bf
            ? "WebkitColumn" + Yf(e) in t && Wf + "column-" + e
            : "Moz" === Bf && "page" + Yf(e) in t && "page-" + e)
        );
      },
    },
    of = {
      supportedProperty: function (e, t) {
        if (!/^(border|margin|padding)-inline/.test(e)) return !1;
        if ("Moz" === Bf) return e;
        e = e.replace("-inline", "");
        return Bf + Yf(e) in t && Wf + e;
      },
    },
    Sp = {
      supportedProperty: function (e, t) {
        return Gf(e) in t && e;
      },
    },
    xp = {
      supportedProperty: function (e, t) {
        var n = Yf(e);
        return "-" === e[0] || ("-" === e[0] && "-" === e[1])
          ? e
          : Bf + n in t
          ? Wf + e
          : "Webkit" !== Bf && "Webkit" + n in t && "-webkit-" + e;
      },
    },
    bp = {
      supportedProperty: function (e) {
        return (
          "scroll-snap" === e.substring(0, 11) &&
          ("ms" === Bf ? "" + Wf + e : e)
        );
      },
    },
    If = {
      supportedProperty: function (e) {
        return (
          "overscroll-behavior" === e &&
          ("ms" === Bf ? Wf + "scroll-chaining" : e)
        );
      },
    },
    eh = {
      "flex-grow": "flex-positive",
      "flex-shrink": "flex-negative",
      "flex-basis": "flex-preferred-size",
      "justify-content": "flex-pack",
      order: "flex-order",
      "align-items": "flex-align",
      "align-content": "flex-line-pack",
    },
    _f = {
      supportedProperty: function (e, t) {
        e = eh[e];
        return !!e && Bf + Yf(e) in t && Wf + e;
      },
    },
    th = {
      flex: "box-flex",
      "flex-grow": "box-flex",
      "flex-direction": ["box-orient", "box-direction"],
      order: "box-ordinal-group",
      "align-items": "box-align",
      "flex-flow": ["box-orient", "box-direction"],
      "justify-content": "box-pack",
    },
    nh = Object.keys(th),
    rh = (Qu = [
      Hf,
      Vf,
      Zf,
      Qf,
      Qu,
      Wd,
      Jf,
      dp,
      vp,
      of,
      Sp,
      xp,
      bp,
      If,
      _f,
      {
        supportedProperty: function (e, t, n) {
          n = n.multiple;
          if (-1 < nh.indexOf(e)) {
            var r = th[e];
            if (!Array.isArray(r)) return Bf + Yf(r) in t && Wf + r;
            if (!n) return !1;
            for (var i = 0; i < r.length; i++)
              if (!(Bf + Yf(r[0]) in t)) return !1;
            return r.map(Xf);
          }
          return !1;
        },
      },
    ])
      .filter(function (e) {
        return e.supportedProperty;
      })
      .map(function (e) {
        return e.supportedProperty;
      }),
    Wd = Qu.filter(function (e) {
      return e.noPrefill;
    }).reduce(function (e, t) {
      return e.push.apply(e, Mf(t.noPrefill)), e;
    }, []),
    ih = {};
  if ($d) {
    Kf = document.createElement("p");
    var oh,
      ah = window.getComputedStyle(document.documentElement, "");
    for (oh in ah) isNaN(oh) || (ih[ah[oh]] = ah[oh]);
    Wd.forEach(function (e) {
      return delete ih[e];
    });
  }
  function sh(e, t) {
    if ((void 0 === t && (t = {}), !Kf)) return e;
    if (null != ih[e]) return ih[e];
    ("transition" !== e && "transform" !== e) || (t[e] = e in Kf.style);
    for (
      var n = 0;
      n < rh.length && ((ih[e] = rh[n](e, Kf.style, t)), !ih[e]);
      n++
    );
    try {
      Kf.style[e] = "";
    } catch (e) {
      return !1;
    }
    return ih[e];
  }
  var lh,
    ch = {},
    uh = {
      transition: 1,
      "transition-property": 1,
      "-webkit-transition": 1,
      "-webkit-transition-property": 1,
    },
    dh = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
  function ph(e, t, n) {
    return "var" === t
      ? "var"
      : "all" === t
      ? "all"
      : "all" === n
      ? ", all"
      : (t ? sh(t) : ", " + sh(n)) || t || n;
  }
  function fh(e, t) {
    var n = t;
    if (!lh || "content" === e) return t;
    if ("string" != typeof n || !isNaN(parseInt(n, 10))) return n;
    t = e + n;
    if (null != ch[t]) return ch[t];
    try {
      lh.style[e] = n;
    } catch (e) {
      return (ch[t] = !1);
    }
    if (uh[e]) n = n.replace(dh, ph);
    else if (
      "" === lh.style[e] &&
      ("-ms-flex" === (n = Wf + n) && (lh.style[e] = "-ms-flexbox"),
      (lh.style[e] = n),
      "" === lh.style[e])
    )
      return (ch[t] = !1);
    return (lh.style[e] = ""), (ch[t] = n), ch[t];
  }
  function hh(e) {
    var t = 0 < arguments.length && void 0 !== e ? e : {},
      n = t.baseClasses,
      r = t.newClasses;
    if ((t.Component, !r)) return n;
    var i = Su({}, n);
    return (
      Object.keys(r).forEach(function (e) {
        r[e] && (i[e] = "".concat(n[e], " ").concat(r[e]));
      }),
      i
    );
  }
  $d && (lh = document.createElement("p")), Q(), Q();
  var mh = R(K),
    gh = mh.createContext(null),
    vh = function (e, t, n, r) {
      var i = e.get(t);
      i || ((i = new Map()), e.set(t, i)), i.set(n, r);
    },
    yh = function (e, t, n) {
      t = e.get(t);
      return t ? t.get(n) : void 0;
    },
    bh = function (e, t, n) {
      e.get(t).delete(n);
    };
  function wh() {
    return mh.useContext(gh);
  }
  Q();
  var xh,
    Jf = ap({
      plugins: [
        {
          onCreateRule: function (e, t, n) {
            if ("function" != typeof t) return null;
            n = Yd(e, {}, n);
            return (n[sf] = t), n;
          },
          onProcessStyle: function (e, t) {
            if (af in t || sf in t) return e;
            var n,
              r = {};
            for (n in e) {
              var i = e[n];
              "function" == typeof i && (delete e[n], (r[n] = i));
            }
            return (t[af] = r), e;
          },
          onUpdate: function (e, t, n, r) {
            var i = t,
              t = i[sf];
            t && (i.style = t(e) || {});
            var o = i[af];
            if (o) for (var a in o) i.prop(a, o[a](e), r);
          },
        },
        gf(),
        wf(),
        {
          onProcessStyle: function (e) {
            if (Array.isArray(e)) {
              for (var t = 0; t < e.length; t++) e[t] = Tf(e[t]);
              return e;
            }
            return Tf(e);
          },
          onChangeValue: function (e, t, n) {
            if (0 === t.indexOf("--")) return e;
            var r = kf(t);
            return t === r ? e : (n.prop(r, e), null);
          },
        },
        (function (e) {
          void 0 === e && (e = {});
          var r = Pf(e);
          return {
            onProcessStyle: function (e, t) {
              if ("style" !== t.type) return e;
              for (var n in e) e[n] = Of(n, e[n], r);
              return e;
            },
            onChangeValue: function (e, t) {
              return Of(t, e, r);
            },
          };
        })(),
        "undefined" == typeof window
          ? null
          : {
              onProcessRule: function (e) {
                "keyframes" === e.type &&
                  (e.at =
                    "-" === (e = e.at)[1] || "ms" === Bf
                      ? e
                      : "@" + Wf + "keyframes" + e.substr(10));
              },
              onProcessStyle: function (e, t) {
                return "style" !== t.type ? e : Sh(e);
              },
              onChangeValue: function (e, t) {
                return fh(t, Kd(e)) || e;
              },
            },
        ((xh = function (e, t) {
          return e.length === t.length ? (t < e ? 1 : -1) : e.length - t.length;
        }),
        {
          onProcessStyle: function (e, t) {
            if ("style" !== t.type) return e;
            for (
              var n = {}, r = Object.keys(e).sort(xh), i = 0;
              i < r.length;
              i++
            )
              n[r[i]] = e[r[i]];
            return n;
          },
        }),
      ],
    }),
    dp = {
      disableGeneration: !1,
      generateClassName: (function (e) {
        var t = 0 < arguments.length && void 0 !== e ? e : {},
          n = t.disableGlobal,
          r = void 0 !== n && n,
          i = void 0 === (n = t.productionPrefix) ? "pwzrjss" : n,
          o = void 0 === (t = t.seed) ? "" : t,
          a = "" === o ? "" : "".concat(o, "-"),
          s = 0;
        return function (e, t) {
          s += 1;
          var n = t.options.name;
          if (!n || 0 !== n.indexOf("Pwzr") || t.options.link || r)
            return "".concat(a).concat(i).concat(s);
          if (-1 !== Fd.indexOf(e.key)) return "Pwzr-".concat(e.key);
          e = "".concat(a).concat(n, "-").concat(e.key);
          return t.options.theme[Ad] && "" === o
            ? "".concat(e, "-").concat(s)
            : e;
        };
      })(),
      jss: Jf,
      sheetsCache: null,
      sheetsManager: new Map(),
      sheetsRegistry: null,
    },
    Eh = mh.createContext(dp);
  function Sh(e) {
    for (var t in e) {
      var n,
        r,
        i,
        o,
        a = e[t];
      "fallbacks" === t && Array.isArray(a)
        ? (e[t] = a.map(Sh))
        : ((n = !1),
          (r = sh(t)) && r !== t && (n = !0),
          (i = !1),
          (o = fh(r, Kd(a))) && o !== a && (i = !0),
          (n || i) && (n && delete e[t], (e[r || t] = o || a)));
    }
    return e;
  }
  var Ch = {},
    kh = -1e9;
  function Th(e, t) {
    var o,
      a,
      n = 1 < arguments.length && void 0 !== t ? t : {},
      g = n.name,
      r = n.classNamePrefix,
      s = n.Component,
      i = n.defaultTheme,
      l = void 0 === i ? Ch : i,
      c = xu(n, ["name", "classNamePrefix", "Component", "defaultTheme"]),
      v =
        ((a = "function" == typeof (o = e)),
        {
          create: function (e, t) {
            var n;
            try {
              n = a ? o(e) : o;
            } catch (e) {
              throw e;
            }
            if (!t || !e.overrides || !e.overrides[t]) return n;
            var r = e.overrides[t],
              i = Su({}, n);
            return (
              Object.keys(r).forEach(function (e) {
                i[e] = zu(i[e], r[e]);
              }),
              i
            );
          },
          options: {},
        }),
      r = g || r || "makeStyles";
    return (
      (v.options = { index: (kh += 1), name: g, meta: r, classNamePrefix: r }),
      function () {
        var e,
          t,
          n,
          r,
          i,
          d =
            0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
          p = wh() || l,
          f = Su({}, mh.useContext(Eh), {}, c),
          h = mh.useRef(),
          m = mh.useRef();
        return (
          (t = function () {
            var e,
              t,
              n,
              r,
              i,
              o,
              a,
              s,
              l,
              c,
              u = {
                name: g,
                state: {},
                stylesCreator: v,
                stylesOptions: f,
                theme: p,
              };
            return (
              (t = d),
              (o = (e = u).state),
              (a = e.theme),
              (s = e.stylesOptions),
              (l = e.stylesCreator),
              (c = e.name),
              s.disableGeneration ||
                ((n = yh(s.sheetsManager, l, a)) ||
                  ((n = { refs: 0, staticSheet: null, dynamicStyles: null }),
                  vh(s.sheetsManager, l, a, n)),
                ((i = Su({}, l.options, {}, s, {
                  theme: a,
                  flip:
                    "boolean" == typeof s.flip ? s.flip : "rtl" === a.direction,
                })).generateId =
                  i.serverGenerateClassName || i.generateClassName),
                (e = s.sheetsRegistry),
                0 === n.refs &&
                  (s.sheetsCache && (r = yh(s.sheetsCache, l, a)),
                  (c = l.create(a, c)),
                  r ||
                    ((r = s.jss.createStyleSheet(
                      c,
                      Su({ link: !1 }, i)
                    )).attach(),
                    s.sheetsCache && vh(s.sheetsCache, l, a, r)),
                  e && e.add(r),
                  (n.staticSheet = r),
                  (n.dynamicStyles = (function e(t) {
                    var n,
                      r = null;
                    for (n in t) {
                      var i = t[n],
                        o = typeof i;
                      "function" == o
                        ? ((r = r || {})[n] = i)
                        : "object" != o ||
                          null === i ||
                          Array.isArray(i) ||
                          ((i = e(i)) && ((r = r || {})[n] = i));
                    }
                    return r;
                  })(c))),
                n.dynamicStyles
                  ? ((i = s.jss.createStyleSheet(
                      n.dynamicStyles,
                      Su({ link: !0 }, i)
                    )).update(t),
                    i.attach(),
                    (o.dynamicSheet = i),
                    (o.classes = hh({
                      baseClasses: n.staticSheet.classes,
                      newClasses: i.classes,
                    })),
                    e && e.add(i))
                  : (o.classes = n.staticSheet.classes),
                (n.refs += 1)),
              (m.current = !1),
              (h.current = u),
              function () {
                var e, t, n, r, i, o;
                (n = (e = u).state),
                  (r = e.theme),
                  (i = e.stylesOptions),
                  (o = e.stylesCreator),
                  i.disableGeneration ||
                    (--(t = yh(i.sheetsManager, o, r)).refs,
                    (e = i.sheetsRegistry),
                    0 === t.refs &&
                      (bh(i.sheetsManager, o, r),
                      i.jss.removeStyleSheet(t.staticSheet),
                      e && e.remove(t.staticSheet)),
                    n.dynamicSheet &&
                      (i.jss.removeStyleSheet(n.dynamicSheet),
                      e && e.remove(n.dynamicSheet)));
              }
            );
          }),
          (n = [p, v]),
          (i = mh.useRef([])),
          (n = mh.useMemo(function () {
            return {};
          }, n)),
          i.current !== n && ((i.current = n), (r = t())),
          mh.useEffect(
            function () {
              return function () {
                r && r();
              };
            },
            [n]
          ),
          mh.useEffect(function () {
            var e, t;
            m.current &&
              ((e = h.current),
              (t = d),
              (e = e.state).dynamicSheet && e.dynamicSheet.update(t)),
              (m.current = !0);
          }),
          (e = h.current),
          (i = d.classes),
          (t = s),
          (n = e.state),
          e.stylesOptions.disableGeneration
            ? i || {}
            : (n.cacheClasses ||
                (n.cacheClasses = { value: null, lastProp: null, lastJSS: {} }),
              (e = !1),
              n.classes !== n.cacheClasses.lastJSS &&
                ((n.cacheClasses.lastJSS = n.classes), (e = !0)),
              i !== n.cacheClasses.lastProp &&
                ((n.cacheClasses.lastProp = i), (e = !0)),
              e &&
                (n.cacheClasses.value = hh({
                  baseClasses: n.cacheClasses.lastJSS,
                  newClasses: i,
                  Component: t,
                })),
              n.cacheClasses.value)
        );
      }
    );
  }
  Q(), Q(), Q();
  var Ph = function () {
      for (var e, t = 0, n = ""; t < arguments.length; )
        (e = (function e(t) {
          var n,
            r,
            i = "";
          if (t)
            if ("object" == typeof t)
              if (t.push)
                for (n = 0; n < t.length; n++)
                  t[n] && (r = e(t[n])) && (i && (i += " "), (i += r));
              else
                for (n in t) t[n] && (r = e(n)) && (i && (i += " "), (i += r));
            else "boolean" == typeof t || t.call || (i && (i += " "), (i += t));
          return i;
        })(arguments[t++])) && (n && (n += " "), (n += e));
      return n;
    },
    zh = {
      childContextTypes: !0,
      contextType: !0,
      contextTypes: !0,
      defaultProps: !0,
      displayName: !0,
      getDefaultProps: !0,
      getDerivedStateFromError: !0,
      getDerivedStateFromProps: !0,
      mixins: !0,
      propTypes: !0,
      type: !0,
    },
    Oh = {
      name: !0,
      length: !0,
      prototype: !0,
      caller: !0,
      callee: !0,
      arguments: !0,
      arity: !0,
    },
    Rh = {
      $$typeof: !0,
      compare: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0,
      type: !0,
    },
    Mh = {};
  function Nh(e) {
    return Zu.isMemo(e) ? Rh : Mh[e.$$typeof] || zh;
  }
  function Lh(e, t, n) {
    if ("string" != typeof t) {
      var r;
      !Bh || ((r = Fh(t)) && r !== Bh && Lh(e, r, n));
      var i = _h(t);
      Dh && (i = i.concat(Dh(t)));
      for (var o = Nh(e), a = Nh(t), s = 0; s < i.length; ++s) {
        var l = i[s];
        if (!(Oh[l] || (n && n[l]) || (a && a[l]) || (o && o[l]))) {
          var c = Ah(t, l);
          try {
            Ih(e, l, c);
          } catch (e) {}
        }
      }
    }
    return e;
  }
  (Mh[Zu.ForwardRef] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
  }),
    (Mh[Zu.Memo] = Rh);
  var Ih = Object.defineProperty,
    _h = Object.getOwnPropertyNames,
    Dh = Object.getOwnPropertySymbols,
    Ah = Object.getOwnPropertyDescriptor,
    Fh = Object.getPrototypeOf,
    Bh = Object.prototype;
  function Wh(e) {
    var t = e.children,
      n = e.theme,
      r = wh(),
      e = mh.useMemo(
        function () {
          var e,
            t,
            e =
              null === r
                ? n
                : ((e = r),
                  "function" != typeof (t = n) ? Su({}, e, {}, t) : t(e));
          return null != e && (e[Ad] = null !== r), e;
        },
        [n, r]
      );
    return mh.createElement(gh.Provider, { value: e }, t);
  }
  Q(), Q();
  var $h = R(Lh);
  function jh(e) {
    (0 < arguments.length && void 0 !== e ? e : {}).defaultTheme;
    return 1;
  }
  Q(), jh();
  var Hh = Dd();
  function Vh(e, t) {
    return Th(
      e,
      Su({ defaultTheme: Hh }, 1 < arguments.length && void 0 !== t ? t : {})
    );
  }
  function qh() {
    return wh() || Hh;
  }
  function Uh(e, t) {
    return (function (t, e) {
      var n = 1 < arguments.length && void 0 !== e ? e : {};
      return function (a) {
        var s = n.defaultTheme,
          e = n.withTheme,
          l = void 0 !== e && e,
          c = n.name,
          e = xu(n, ["defaultTheme", "withTheme", "name"]),
          u = Th(
            t,
            Su(
              {
                defaultTheme: s,
                Component: a,
                name: c || a.displayName,
                classNamePrefix: c,
              },
              e
            )
          ),
          e = mh.forwardRef(function (e, t) {
            e.classes;
            var n = e.innerRef,
              r = xu(e, ["classes", "innerRef"]),
              i = u(e),
              o = r;
            return (
              ("string" != typeof c && !l) ||
                ((e = wh() || s),
                c && (o = Bd({ theme: e, name: c, props: r })),
                l && !o.theme && (o.theme = e)),
              mh.createElement(a, Su({ ref: n || t, classes: i }, o))
            );
          });
        return (e.defaultProps = a.defaultProps), $h(e, a), e;
      };
    })(e, Su({ defaultTheme: Hh }, t));
  }
  function Gh(e, t) {
    return (
      (function (e) {
        if (Array.isArray(e)) return e;
      })(e) ||
      (function (e, t) {
        if (
          Symbol.iterator in Object(e) ||
          "[object Arguments]" === Object.prototype.toString.call(e)
        ) {
          var n = [],
            r = !0,
            i = !1,
            o = void 0;
          try {
            for (
              var a, s = e[Symbol.iterator]();
              !(r = (a = s.next()).done) &&
              (n.push(a.value), !t || n.length !== t);
              r = !0
            );
          } catch (e) {
            (i = !0), (o = e);
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (i) throw o;
            }
          }
          return n;
        }
      })(e, t) ||
      (function () {
        throw new TypeError(
          "Invalid attempt to destructure non-iterable instance"
        );
      })()
    );
  }
  jh({ defaultTheme: Hh }), Q();
  var Yh = {};
  function Xh(e) {
    return (
      (Yh = Xh =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            }),
      Xh(e)
    );
  }
  (Yh = Xh), Q();
  var Kh = function (e, t, n) {
    return (
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  };
  function Zh(e, t) {
    var n = 1 < arguments.length && void 0 !== t ? t : {},
      r = wh(),
      i = Bd({ theme: r, name: "PwzrUseMediaQuery", props: {} }),
      o = (o = "function" == typeof e ? e(r) : e).replace(/^@media( ?)/m, ""),
      a = "undefined" != typeof window && void 0 !== window.matchMedia,
      i = Su({}, i, {}, n),
      n = i.defaultMatches,
      s = void 0 !== n && n,
      n = i.matchMedia,
      l = void 0 === n ? (a ? window.matchMedia : null) : n,
      n = i.noSsr,
      c = void 0 !== n && n,
      n = i.ssrMatchMedia,
      u = void 0 === n ? null : n,
      i = mh.useState(function () {
        return c && a ? l(o).matches : u ? u(o).matches : s;
      }),
      n = i[0],
      d = i[1];
    return (
      mh.useEffect(
        function () {
          var e = !0;
          if (a) {
            function t() {
              e && d(n.matches);
            }
            var n = l(o);
            return (
              t(),
              n.addListener(t),
              function () {
                (e = !1), n.removeListener(t);
              }
            );
          }
        },
        [o, l, a]
      ),
      n
    );
  }
  Q(), Q();
  var Qh =
      "undefined" != typeof Map
        ? Map
        : (Object.defineProperty(rm.prototype, "size", {
            get: function () {
              return this.__entries__.length;
            },
            enumerable: !0,
            configurable: !0,
          }),
          (rm.prototype.get = function (e) {
            (e = nm(this.__entries__, e)), (e = this.__entries__[e]);
            return e && e[1];
          }),
          (rm.prototype.set = function (e, t) {
            var n = nm(this.__entries__, e);
            ~n ? (this.__entries__[n][1] = t) : this.__entries__.push([e, t]);
          }),
          (rm.prototype.delete = function (e) {
            var t = this.__entries__,
              e = nm(t, e);
            ~e && t.splice(e, 1);
          }),
          (rm.prototype.has = function (e) {
            return !!~nm(this.__entries__, e);
          }),
          (rm.prototype.clear = function () {
            this.__entries__.splice(0);
          }),
          (rm.prototype.forEach = function (e, t) {
            void 0 === t && (t = null);
            for (var n = 0, r = this.__entries__; n < r.length; n++) {
              var i = r[n];
              e.call(t, i[1], i[0]);
            }
          }),
          rm),
    Jh =
      "undefined" != typeof window &&
      "undefined" != typeof document &&
      window.document === document,
    em =
      void 0 !== i && i.Math === Math
        ? i
        : "undefined" != typeof self && self.Math === Math
        ? self
        : "undefined" != typeof window && window.Math === Math
        ? window
        : Function("return this")(),
    tm =
      "function" == typeof requestAnimationFrame
        ? requestAnimationFrame.bind(em)
        : function (e) {
            return setTimeout(function () {
              return e(Date.now());
            }, 1e3 / 60);
          };
  function nm(e, n) {
    var r = -1;
    return (
      e.some(function (e, t) {
        return e[0] === n && ((r = t), !0);
      }),
      r
    );
  }
  function rm() {
    this.__entries__ = [];
  }
  function im(e, t) {
    for (var n = 0, r = Object.keys(t); n < r.length; n++) {
      var i = r[n];
      Object.defineProperty(e, i, {
        value: t[i],
        enumerable: !1,
        writable: !1,
        configurable: !0,
      });
    }
    return e;
  }
  var om = [
      "top",
      "right",
      "bottom",
      "left",
      "width",
      "height",
      "size",
      "weight",
    ],
    am = "undefined" != typeof MutationObserver,
    sm =
      ((um.prototype.addObserver = function (e) {
        ~this.observers_.indexOf(e) || this.observers_.push(e),
          this.connected_ || this.connect_();
      }),
      (um.prototype.removeObserver = function (e) {
        var t = this.observers_,
          e = t.indexOf(e);
        ~e && t.splice(e, 1),
          !t.length && this.connected_ && this.disconnect_();
      }),
      (um.prototype.refresh = function () {
        this.updateObservers_() && this.refresh();
      }),
      (um.prototype.updateObservers_ = function () {
        var e = this.observers_.filter(function (e) {
          return e.gatherActive(), e.hasActive();
        });
        return (
          e.forEach(function (e) {
            return e.broadcastActive();
          }),
          0 < e.length
        );
      }),
      (um.prototype.connect_ = function () {
        Jh &&
          !this.connected_ &&
          (document.addEventListener("transitionend", this.onTransitionEnd_),
          window.addEventListener("resize", this.refresh),
          am
            ? ((this.mutationsObserver_ = new MutationObserver(this.refresh)),
              this.mutationsObserver_.observe(document, {
                attributes: !0,
                childList: !0,
                characterData: !0,
                subtree: !0,
              }))
            : (document.addEventListener("DOMSubtreeModified", this.refresh),
              (this.mutationEventsAdded_ = !0)),
          (this.connected_ = !0));
      }),
      (um.prototype.disconnect_ = function () {
        Jh &&
          this.connected_ &&
          (document.removeEventListener("transitionend", this.onTransitionEnd_),
          window.removeEventListener("resize", this.refresh),
          this.mutationsObserver_ && this.mutationsObserver_.disconnect(),
          this.mutationEventsAdded_ &&
            document.removeEventListener("DOMSubtreeModified", this.refresh),
          (this.mutationsObserver_ = null),
          (this.mutationEventsAdded_ = !1),
          (this.connected_ = !1));
      }),
      (um.prototype.onTransitionEnd_ = function (e) {
        var e = e.propertyName,
          t = void 0 === e ? "" : e;
        om.some(function (e) {
          return !!~t.indexOf(e);
        }) && this.refresh();
      }),
      (um.getInstance = function () {
        return this.instance_ || (this.instance_ = new um()), this.instance_;
      }),
      (um.instance_ = null),
      um),
    lm = function (e) {
      return (e && e.ownerDocument && e.ownerDocument.defaultView) || em;
    },
    cm = mm(0, 0, 0, 0);
  function um() {
    function e() {
      o && ((o = !1), r()), a && n();
    }
    function t() {
      tm(e);
    }
    function n() {
      var e = Date.now();
      if (o) {
        if (e - s < 2) return;
        a = !0;
      } else (a = !(o = !0)), setTimeout(t, i);
      s = e;
    }
    var r, i, o, a, s;
    (this.connected_ = !1),
      (this.mutationEventsAdded_ = !1),
      (this.mutationsObserver_ = null),
      (this.observers_ = []),
      (this.onTransitionEnd_ = this.onTransitionEnd_.bind(this)),
      (this.refresh =
        ((r = this.refresh.bind(this)), (a = o = !(i = 20)), (s = 0), n));
  }
  function dm(e) {
    return parseFloat(e) || 0;
  }
  function pm(n) {
    for (var e = [], t = 1; t < arguments.length; t++) e[t - 1] = arguments[t];
    return e.reduce(function (e, t) {
      return e + dm(n["border-" + t + "-width"]);
    }, 0);
  }
  var fm =
    "undefined" != typeof SVGGraphicsElement
      ? function (e) {
          return e instanceof lm(e).SVGGraphicsElement;
        }
      : function (e) {
          return (
            e instanceof lm(e).SVGElement && "function" == typeof e.getBBox
          );
        };
  function hm(e) {
    return Jh
      ? fm(e)
        ? mm(0, 0, (t = e.getBBox()).width, t.height)
        : (function (e) {
            var t = e.clientWidth,
              n = e.clientHeight;
            if (!t && !n) return cm;
            var r = lm(e).getComputedStyle(e),
              i = (function (e) {
                for (
                  var t = {}, n = 0, r = ["top", "right", "bottom", "left"];
                  n < r.length;
                  n++
                ) {
                  var i = r[n],
                    o = e["padding-" + i];
                  t[i] = dm(o);
                }
                return t;
              })(r),
              o = i.left + i.right,
              a = i.top + i.bottom,
              s = dm(r.width),
              l = dm(r.height);
            return (
              "border-box" === r.boxSizing &&
                (Math.round(s + o) !== t && (s -= pm(r, "left", "right") + o),
                Math.round(l + a) !== n && (l -= pm(r, "top", "bottom") + a)),
              e !== lm(e).document.documentElement &&
                ((t = Math.round(s + o) - t),
                (n = Math.round(l + a) - n),
                1 !== Math.abs(t) && (s -= t),
                1 !== Math.abs(n) && (l -= n)),
              mm(i.left, i.top, s, l)
            );
          })(e)
      : cm;
    var t;
  }
  function mm(e, t, n, r) {
    return { x: e, y: t, width: n, height: r };
  }
  function gm(e, t) {
    var n,
      r,
      i,
      o,
      t =
        ((n = t.x),
        (r = t.y),
        (i = t.width),
        (o = t.height),
        (t = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object),
        (t = Object.create(t.prototype)),
        im(t, {
          x: n,
          y: r,
          width: i,
          height: o,
          top: r,
          right: n + i,
          bottom: o + r,
          left: n,
        }),
        t);
    im(this, { target: e, contentRect: t });
  }
  function vm(e) {
    if (!(this instanceof vm))
      throw new TypeError("Cannot call a class as a function.");
    if (!arguments.length)
      throw new TypeError("1 argument required, but only 0 present.");
    var t = sm.getInstance(),
      t = new bm(e, t, this);
    wm.set(this, t);
  }
  var ym =
      ((Em.prototype.isActive = function () {
        var e = hm(this.target);
        return (
          (this.contentRect_ = e).width !== this.broadcastWidth ||
          e.height !== this.broadcastHeight
        );
      }),
      (Em.prototype.broadcastRect = function () {
        var e = this.contentRect_;
        return (
          (this.broadcastWidth = e.width), (this.broadcastHeight = e.height), e
        );
      }),
      Em),
    bm =
      ((xm.prototype.observe = function (e) {
        if (!arguments.length)
          throw new TypeError("1 argument required, but only 0 present.");
        if ("undefined" != typeof Element && Element instanceof Object) {
          if (!(e instanceof lm(e).Element))
            throw new TypeError('parameter 1 is not of type "Element".');
          var t = this.observations_;
          t.has(e) ||
            (t.set(e, new ym(e)),
            this.controller_.addObserver(this),
            this.controller_.refresh());
        }
      }),
      (xm.prototype.unobserve = function (e) {
        if (!arguments.length)
          throw new TypeError("1 argument required, but only 0 present.");
        if ("undefined" != typeof Element && Element instanceof Object) {
          if (!(e instanceof lm(e).Element))
            throw new TypeError('parameter 1 is not of type "Element".');
          var t = this.observations_;
          t.has(e) &&
            (t.delete(e), t.size || this.controller_.removeObserver(this));
        }
      }),
      (xm.prototype.disconnect = function () {
        this.clearActive(),
          this.observations_.clear(),
          this.controller_.removeObserver(this);
      }),
      (xm.prototype.gatherActive = function () {
        var t = this;
        this.clearActive(),
          this.observations_.forEach(function (e) {
            e.isActive() && t.activeObservations_.push(e);
          });
      }),
      (xm.prototype.broadcastActive = function () {
        var e, t;
        this.hasActive() &&
          ((e = this.callbackCtx_),
          (t = this.activeObservations_.map(function (e) {
            return new gm(e.target, e.broadcastRect());
          })),
          this.callback_.call(e, t, e),
          this.clearActive());
      }),
      (xm.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
      }),
      (xm.prototype.hasActive = function () {
        return 0 < this.activeObservations_.length;
      }),
      xm),
    wm = new ("undefined" != typeof WeakMap ? WeakMap : Qh)();
  function xm(e, t, n) {
    if (
      ((this.activeObservations_ = []),
      (this.observations_ = new Qh()),
      "function" != typeof e)
    )
      throw new TypeError(
        "The callback provided as parameter 1 is not a function."
      );
    (this.callback_ = e), (this.controller_ = t), (this.callbackCtx_ = n);
  }
  function Em(e) {
    (this.broadcastWidth = 0),
      (this.broadcastHeight = 0),
      (this.contentRect_ = mm(0, 0, 0, 0)),
      (this.target = e);
  }
  ["observe", "unobserve", "disconnect"].forEach(function (t) {
    vm.prototype[t] = function () {
      var e;
      return (e = wm.get(this))[t].apply(e, arguments);
    };
  });
  var Sm = void 0 !== em.ResizeObserver ? em.ResizeObserver : vm;
  function Cm(e) {
    var t = typeof e;
    return null != e && ("object" == t || "function" == t);
  }
  function km() {
    return Tm.Date.now();
  }
  var vp = "object" == typeof i && i && i.Object === Object && i,
    of = "object" == typeof self && self && self.Object === Object && self,
    Tm = vp || of || Function("return this")(),
    Sp = Tm.Symbol,
    Pm = (xp = Object.prototype).hasOwnProperty,
    zm = xp.toString,
    Om = Sp ? Sp.toStringTag : void 0,
    Rm = Object.prototype.toString,
    Mm = Sp ? Sp.toStringTag : void 0,
    Nm = /^\s+|\s+$/g,
    Lm = /^[-+]0x[0-9a-f]+$/i,
    Im = /^0b[01]+$/i,
    _m = /^0o[0-7]+$/i,
    Dm = parseInt;
  function Am(e) {
    if ("number" == typeof e) return e;
    if (
      "symbol" == typeof (t = e) ||
      (null != t &&
        "object" == typeof t &&
        "[object Symbol]" ==
          (null == (t = t)
            ? void 0 === t
              ? "[object Undefined]"
              : "[object Null]"
            : Mm && Mm in Object(t)
            ? (function (e) {
                var t = Pm.call(e, Om),
                  n = e[Om];
                try {
                  var r = !(e[Om] = void 0);
                } catch (e) {}
                var i = zm.call(e);
                return r && (t ? (e[Om] = n) : delete e[Om]), i;
              })(t)
            : Rm.call(t)))
    )
      return NaN;
    var t;
    if (
      (Cm(e) &&
        (e = Cm((n = "function" == typeof e.valueOf ? e.valueOf() : e))
          ? n + ""
          : n),
      "string" != typeof e)
    )
      return 0 === e ? e : +e;
    e = e.replace(Nm, "");
    var n = Im.test(e);
    return n || _m.test(e) ? Dm(e.slice(2), n ? 2 : 8) : Lm.test(e) ? NaN : +e;
  }
  var Fm = Math.max,
    Bm = Math.min;
  function Wm(r, n, e) {
    var i,
      o,
      a,
      s,
      l,
      c,
      u = 0,
      d = !1,
      p = !1,
      t = !0;
    if ("function" != typeof r) throw new TypeError("Expected a function");
    function f(e) {
      var t = i,
        n = o;
      return (i = o = void 0), (u = e), (s = r.apply(n, t));
    }
    function h(e) {
      var t = e - c;
      return void 0 === c || n <= t || t < 0 || (p && a <= e - u);
    }
    function m() {
      var e,
        t = km();
      if (h(t)) return g(t);
      l = setTimeout(m, ((e = n - (t - c)), p ? Bm(e, a - (t - u)) : e));
    }
    function g(e) {
      return (l = void 0), t && i ? f(e) : ((i = o = void 0), s);
    }
    function v() {
      var e = km(),
        t = h(e);
      if (((i = arguments), (o = this), (c = e), t)) {
        if (void 0 === l)
          return (u = t = c), (l = setTimeout(m, n)), d ? f(t) : s;
        if (p) return clearTimeout(l), (l = setTimeout(m, n)), f(c);
      }
      return void 0 === l && (l = setTimeout(m, n)), s;
    }
    return (
      (n = Am(n) || 0),
      Cm(e) &&
        ((d = !!e.leading),
        (a = (p = "maxWait" in e) ? Fm(Am(e.maxWait) || 0, n) : a),
        (t = "trailing" in e ? !!e.trailing : t)),
      (v.cancel = function () {
        void 0 !== l && clearTimeout(l), (i = c = o = l = void (u = 0));
      }),
      (v.flush = function () {
        return void 0 === l ? s : g(km());
      }),
      v
    );
  }
  var $m = {
      debounce: Wm,
      throttle: function (e, t, n) {
        var r = !0,
          i = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return (
          Cm(n) &&
            ((r = "leading" in n ? !!n.leading : r),
            (i = "trailing" in n ? !!n.trailing : i)),
          Wm(e, t, { leading: r, maxWait: t, trailing: i })
        );
      },
    },
    jm = function (e) {
      return "function" == typeof e;
    },
    Hm = function () {
      return "undefined" == typeof window;
    };
  function Vm(e) {
    return (Vm =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              "function" == typeof Symbol &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          })(e);
  }
  function qm(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  function Um(e) {
    return (Um = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
  }
  function Gm(e, t) {
    return (Gm =
      Object.setPrototypeOf ||
      function (e, t) {
        return (e.__proto__ = t), e;
      })(e, t);
  }
  Q();
  var Ym =
    ((function (e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && Gm(e, t);
    })(Xm, K.PureComponent),
    qm(Xm.prototype, [
      {
        key: "render",
        value: function () {
          return this.props.children;
        },
      },
    ]),
    Xm);
  function Xm() {
    return (
      (function (e, t) {
        if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function");
      })(this, Xm),
      (e = this),
      !(t = Um(Xm).apply(this, arguments)) ||
      ("object" !== Vm(t) && "function" != typeof t)
        ? (function (e) {
            if (void 0 === e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return e;
          })(e)
        : t
    );
    var e, t;
  }
  function Km(e) {
    return (Km =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              "function" == typeof Symbol &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          })(e);
  }
  function Zm(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  function Qm(e) {
    return (Qm = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
  }
  function Jm(e) {
    if (void 0 === e)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return e;
  }
  function eg(e, t) {
    return (eg =
      Object.setPrototypeOf ||
      function (e, t) {
        return (e.__proto__ = t), e;
      })(e, t);
  }
  function tg(e, t, n) {
    return (
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  var ng =
    ((function (e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && eg(e, t);
    })(rg, K.PureComponent),
    Zm(rg.prototype, [
      {
        key: "componentDidMount",
        value: function () {
          this.toggleObserver("observe");
        },
      },
      {
        key: "componentWillUnmount",
        value: function () {
          this.toggleObserver("unobserve"),
            this.rafClean(),
            this.cancelHandler(),
            (this.unmounted = !0);
        },
      },
      {
        key: "render",
        value: function () {
          return mh.createElement(
            Ym,
            { ref: this.onRef },
            this.getTargetComponent()
          );
        },
      },
    ]),
    rg);
  function rg(e) {
    var l;
    !(function (e) {
      if (!(e instanceof rg))
        throw new TypeError("Cannot call a class as a function");
    })(this),
      (n = this),
      (r = Qm(rg).call(this, e)),
      (l = !r || ("object" !== Km(r) && "function" != typeof r) ? Jm(n) : r),
      tg(Jm(l), "cancelHandler", function () {
        l.resizeHandler &&
          l.resizeHandler.cancel &&
          (l.resizeHandler.cancel(), (l.resizeHandler = null));
      }),
      tg(Jm(l), "rafClean", function () {
        l.raf && l.raf.cancel && (l.raf.cancel(), (l.raf = null));
      }),
      tg(Jm(l), "toggleObserver", function (e) {
        var t = l.getElement();
        t && l.resizeObserver[e] && l.resizeObserver[e](t);
      }),
      tg(Jm(l), "getElement", function () {
        var e = l.props,
          t = e.querySelector,
          e = e.targetDomEl;
        if (!Hm()) {
          if (t) return document.querySelector(t);
          if (e && (e instanceof Element || e instanceof HTMLDocument))
            return e;
          e = l.element && du.findDOMNode(l.element);
          return e ? e.parentElement : void 0;
        }
      }),
      tg(Jm(l), "createUpdater", function () {
        return (
          l.rafClean(),
          (l.raf =
            ((i = null),
            (e.cancel = function () {
              i && (cancelAnimationFrame(i), (i = null));
            }),
            e)),
          l.raf
        );
        function e() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          (r = t),
            (i =
              i ||
              requestAnimationFrame(function () {
                (i = null),
                  function (e) {
                    var t = e.width,
                      n = e.height,
                      r = l.props.onResize;
                    jm(r) && r(t, n), l.setState({ width: t, height: n });
                  }.apply(void 0, r);
              }));
        }
        var r, i;
      }),
      tg(Jm(l), "createResizeHandler", function (e) {
        var r,
          t = l.state,
          i = t.width,
          o = t.height,
          t = l.props,
          a = t.handleWidth,
          s = t.handleHeight;
        (a || s) &&
          ((r = l.createUpdater()),
          e.forEach(function (e) {
            var t = (e && e.contentRect) || {},
              n = t.width,
              e = t.height,
              t = (a && i !== n) || (s && o !== e);
            l.skipOnMount || !t || Hm() || r({ width: n, height: e }),
              (l.skipOnMount = !1);
          }));
      }),
      tg(Jm(l), "onRef", function (e) {
        l.element = e;
      }),
      tg(Jm(l), "getRenderType", function () {
        var e = l.props,
          t = e.render,
          e = e.children;
        return jm(t)
          ? "renderProp"
          : jm(e)
          ? "childFunction"
          : K.isValidElement(e)
          ? "child"
          : Array.isArray(e)
          ? "childArray"
          : "parent";
      }),
      tg(Jm(l), "getTargetComponent", function () {
        var e = l.props,
          t = e.render,
          n = e.children,
          r = e.nodeType,
          e = l.state,
          i = { width: e.width, height: e.height };
        switch (l.getRenderType()) {
          case "renderProp":
            return K.cloneElement(t(i), { key: "resize-detector" });
          case "childFunction":
            return K.cloneElement(n(i));
          case "child":
            return K.cloneElement(n, i);
          case "childArray":
            return n.map(function (e) {
              return !!e && K.cloneElement(e, i);
            });
          default:
            return K.createElement(r);
        }
      });
    var t = e.skipOnMount,
      n = e.refreshMode,
      r = e.refreshRate,
      e = e.refreshOptions;
    (l.state = { width: void 0, height: void 0 }),
      (l.skipOnMount = t),
      (l.raf = null),
      (l.element = null),
      (l.unmounted = !1);
    n = $m[n];
    return (
      (l.resizeHandler = n
        ? n(l.createResizeHandler, r, e)
        : l.createResizeHandler),
      (l.resizeObserver = new Sm(l.resizeHandler)),
      l
    );
  }
  (ng.propTypes = {
    handleWidth: Yu.bool,
    handleHeight: Yu.bool,
    skipOnMount: Yu.bool,
    refreshRate: Yu.number,
    refreshMode: Yu.string,
    refreshOptions: Yu.shape({ leading: Yu.bool, trailing: Yu.bool }),
    querySelector: Yu.string,
    targetDomEl: Yu.any,
    onResize: Yu.func,
    render: Yu.func,
    children: Yu.any,
    nodeType: Yu.node,
  }),
    (ng.defaultProps = {
      handleWidth: !1,
      handleHeight: !1,
      skipOnMount: !1,
      refreshRate: 1e3,
      refreshMode: void 0,
      refreshOptions: void 0,
      querySelector: null,
      targetDomEl: null,
      onResize: null,
      render: void 0,
      children: null,
      nodeType: "div",
    }),
    Q();
  var bp = function (e) {
      return e && e.__esModule ? e : { default: e };
    },
    ig = {};
  function og() {
    return (
      (ig = og =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n,
              r = arguments[t];
            for (n in r)
              Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
          return e;
        }),
      og.apply(this, arguments)
    );
  }
  function ag(e) {
    return e.charAt(0).toUpperCase() + e.slice(1);
  }
  (ig = og),
    (If = {}),
    Object.defineProperty(If, "__esModule", { value: !0 }),
    Q(),
    ((_f = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.color,
        a = void 0 === o ? "inherit" : o,
        s = e.component,
        l = void 0 === s ? "svg" : s,
        c = e.fontSize,
        u = void 0 === c ? "default" : c,
        o = e.htmlColor,
        s = e.titleAccess,
        c = e.viewBox,
        c = void 0 === c ? "0 0 24 24" : c,
        e = xu(e, [
          "children",
          "classes",
          "className",
          "color",
          "component",
          "fontSize",
          "htmlColor",
          "titleAccess",
          "viewBox",
        ]);
      return mh.createElement(
        l,
        Su(
          {
            className: Ph(
              r.root,
              i,
              "inherit" !== a && r["color".concat(ag(a))],
              "default" !== u && r["fontSize".concat(ag(u))]
            ),
            focusable: "false",
            viewBox: c,
            color: o,
            "aria-hidden": s ? void 0 : "true",
            role: s ? "img" : "presentation",
            ref: t,
          },
          e
        ),
        n,
        s ? mh.createElement("title", null, s) : null
      );
    })).muiName = "SvgIcon");
  var sg = Uh(
    function (e) {
      return {
        root: {
          userSelect: "none",
          width: "1em",
          height: "1em",
          display: "inline-block",
          fill: "currentColor",
          flexShrink: 0,
          fontSize: e.typography.pxToRem(24),
          transition: e.transitions.create("fill", {
            duration: e.transitions.duration.shorter,
          }),
        },
        colorPrimary: { color: e.palette.primary.main },
        colorSecondary: { color: e.palette.secondary.main },
        colorAction: { color: e.palette.action.active },
        colorError: { color: e.palette.error.main },
        colorDisabled: { color: e.palette.action.disabled },
        fontSizeInherit: { fontSize: "inherit" },
        fontSizeSmall: { fontSize: e.typography.pxToRem(20) },
        fontSizeLarge: { fontSize: e.typography.pxToRem(35) },
      };
    },
    { name: "PwzrSvgIcon" }
  )(_f);
  (If.default = sg),
    (Qu = {}),
    Object.defineProperty(Qu, "__esModule", { value: !0 }),
    (Qu.default = function (n, e) {
      var t = cg.default.memo(
        cg.default.forwardRef(function (e, t) {
          return cg.default.createElement(
            ug.default,
            (0, lg.default)({ ref: t }, e),
            n
          );
        })
      );
      return (t.muiName = ug.default.muiName), t;
    });
  var lg = bp(ig),
    cg = bp((Q(), K)),
    ug = bp(If),
    Wd = {};
  Object.defineProperty(Wd, "__esModule", { value: !0 });
  var dg = void 0;
  (Wd.default = dg),
    (ap = bp((Q(), K))),
    (dg = (0, bp(Qu).default)(
      ap.default.createElement("path", {
        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z",
      }),
      "KeyboardArrowLeft"
    )),
    (Wd.default = dg),
    (Jf = {}),
    Object.defineProperty(Jf, "__esModule", { value: !0 });
  var pg = void 0;
  (Jf.default = pg),
    (dp = bp((Q(), K))),
    (pg = (0, bp(Qu).default)(
      dp.default.createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z",
      }),
      "KeyboardArrowRight"
    )),
    (Jf.default = pg),
    (vp = {}),
    Object.defineProperty(vp, "__esModule", { value: !0 });
  var fg = void 0;
  (vp.default = fg),
    (of = bp((Q(), K))),
    (fg = (0, bp(Qu).default)(
      of.default.createElement("path", {
        d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z",
      }),
      "KeyboardArrowDown"
    )),
    (vp.default = fg),
    (xp = {}),
    Object.defineProperty(xp, "__esModule", { value: !0 });
  var hg = void 0;
  (xp.default = hg),
    (Sp = bp((Q(), K))),
    (hg = (0, bp(Qu).default)(
      Sp.default.createElement("path", {
        d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z",
      }),
      "KeyboardArrowUp"
    )),
    (xp.default = hg),
    Q();
  var Yu = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.component,
        o = void 0 === i ? "div" : i,
        a = e.square,
        s = void 0 !== a && a,
        i = e.elevation,
        a = void 0 === i ? 1 : i,
        i = e.variant,
        i = void 0 === i ? "elevation" : i,
        e = xu(e, [
          "classes",
          "className",
          "component",
          "square",
          "elevation",
          "variant",
        ]);
      return mh.createElement(
        o,
        Su(
          {
            className: Ph(
              n.root,
              r,
              "outlined" === i ? n.outlined : n["elevation".concat(a)],
              !s && n.rounded
            ),
            ref: t,
          },
          e
        )
      );
    }),
    mg = Uh(
      function (e) {
        var n = {};
        return (
          e.shadows.forEach(function (e, t) {
            n["elevation".concat(t)] = { boxShadow: e };
          }),
          Su(
            {
              root: {
                backgroundColor: e.palette.background.paper,
                color: e.palette.text.primary,
                transition: e.transitions.create("box-shadow"),
              },
              rounded: { borderRadius: e.shape.borderRadius },
              outlined: { border: "1px solid ".concat(e.palette.divider) },
            },
            n
          )
        );
      },
      { name: "PwzrPaper" }
    )(Yu);
  function gg(n) {
    var e = mh.memo(
      mh.forwardRef(function (e, t) {
        return mh.createElement(sg, Su({}, e, { ref: t }), n);
      })
    );
    return (e.muiName = sg.muiName), e;
  }
  Q(),
    (_f = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.color,
        o = void 0 === i ? "primary" : i,
        i = e.position,
        i = void 0 === i ? "fixed" : i,
        e = xu(e, ["classes", "className", "color", "position"]);
      return mh.createElement(
        mg,
        Su(
          {
            square: !0,
            component: "header",
            elevation: 4,
            className: Ph(
              n.root,
              n["position".concat(ag(i))],
              n["color".concat(ag(o))],
              r,
              "fixed" === i && "mui-fixed"
            ),
            ref: t,
          },
          e
        )
      );
    })),
    Uh(
      function (e) {
        var t =
          "light" === e.palette.type
            ? e.palette.grey[100]
            : e.palette.grey[900];
        return {
          root: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            boxSizing: "border-box",
            zIndex: e.zIndex.appBar,
            flexShrink: 0,
          },
          positionFixed: {
            position: "fixed",
            top: 0,
            left: "auto",
            right: 0,
            "@media print": { position: "absolute" },
          },
          positionAbsolute: {
            position: "absolute",
            top: 0,
            left: "auto",
            right: 0,
          },
          positionSticky: {
            position: "sticky",
            top: 0,
            left: "auto",
            right: 0,
          },
          positionStatic: { position: "static", transform: "translateZ(0)" },
          positionRelative: { position: "relative" },
          colorDefault: {
            backgroundColor: t,
            color: e.palette.getContrastText(t),
          },
          colorPrimary: {
            backgroundColor: e.palette.primary.main,
            color: e.palette.primary.contrastText,
          },
          colorSecondary: {
            backgroundColor: e.palette.secondary.main,
            color: e.palette.secondary.contrastText,
          },
          colorInherit: { color: "inherit" },
          colorTransparent: {
            backgroundColor: "transparent",
            color: "inherit",
          },
        };
      },
      { name: "PwzrAppBar" }
    )(_f),
    Q(),
    Q(),
    Q();
  var vg = gg(
      mh.createElement("path", {
        d:
          "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
      })
    ),
    If = mh.forwardRef(function (e, t) {
      var n,
        r,
        i,
        o = e.alt,
        a = e.children,
        s = e.classes,
        l = e.className,
        c = e.component,
        u = void 0 === c ? "div" : c,
        d = e.imgProps,
        p = e.sizes,
        f = e.src,
        h = e.srcSet,
        m = e.variant,
        g = void 0 === m ? "circle" : m,
        v = xu(e, [
          "alt",
          "children",
          "classes",
          "className",
          "component",
          "imgProps",
          "sizes",
          "src",
          "srcSet",
          "variant",
        ]),
        e =
          ((n = (m = { src: f, srcSet: h }).src),
          (r = m.srcSet),
          (e = mh.useState(!1)),
          (m = e[0]),
          (i = e[1]),
          mh.useEffect(
            function () {
              if (n || r) {
                i(!1);
                var e = !0,
                  t = new Image();
                return (
                  (t.src = n),
                  (t.srcSet = r),
                  (t.onload = function () {
                    e && i("loaded");
                  }),
                  (t.onerror = function () {
                    e && i("error");
                  }),
                  function () {
                    e = !1;
                  }
                );
              }
            },
            [n, r]
          ),
          m),
        m = f || h,
        e = m && "error" !== e,
        c = e
          ? mh.createElement(
              "img",
              Su({ alt: o, src: f, srcSet: h, sizes: p, className: s.img }, d)
            )
          : null != a
          ? a
          : m && o
          ? o[0]
          : mh.createElement(vg, { className: s.fallback });
      return mh.createElement(
        u,
        Su(
          {
            className: Ph(s.root, s.system, s[g], l, !e && s.colorDefault),
            ref: t,
          },
          v
        ),
        c
      );
    });
  Uh(
    function (e) {
      return {
        root: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          width: 40,
          height: 40,
          fontFamily: e.typography.fontFamily,
          fontSize: e.typography.pxToRem(20),
          lineHeight: 1,
          borderRadius: "50%",
          overflow: "hidden",
          userSelect: "none",
        },
        colorDefault: {
          color: e.palette.background.default,
          backgroundColor:
            "light" === e.palette.type
              ? e.palette.grey[400]
              : e.palette.grey[600],
        },
        circle: {},
        rounded: { borderRadius: e.shape.borderRadius },
        square: { borderRadius: 0 },
        img: {
          width: "100%",
          height: "100%",
          textAlign: "center",
          objectFit: "cover",
          color: "transparent",
          textIndent: 1e4,
        },
        fallback: { width: "75%", height: "75%" },
      };
    },
    { name: "PwzrAvatar" }
  )(If),
    Q(),
    Q();
  var yg = mh.createContext(null);
  function bg(e, t) {
    var n = Object.create(null);
    return (
      e &&
        K.Children.map(e, function (e) {
          return e;
        }).forEach(function (e) {
          n[e.key] = ((e = e), t && K.isValidElement(e) ? t(e) : e);
        }),
      n
    );
  }
  function wg(e, t, n) {
    return (null != n[t] ? n : e.props)[t];
  }
  Q();
  var xg =
      Object.values ||
      function (t) {
        return Object.keys(t).map(function (e) {
          return t[e];
        });
      },
    Eg = (function (n) {
      function e(e, t) {
        t = (e = n.call(this, e, t) || this).handleExited.bind(qd(qd(e)));
        return (
          (e.state = {
            contextValue: { isMounting: !0 },
            handleExited: t,
            firstRender: !0,
          }),
          e
        );
      }
      Vd(e, n);
      var t = e.prototype;
      return (
        (t.componentDidMount = function () {
          (this.mounted = !0),
            this.setState({ contextValue: { isMounting: !1 } });
        }),
        (t.componentWillUnmount = function () {
          this.mounted = !1;
        }),
        (e.getDerivedStateFromProps = function (e, t) {
          var n,
            r,
            a,
            s,
            l,
            c,
            u,
            i = t.children,
            o = t.handleExited;
          return {
            children: t.firstRender
              ? ((r = o),
                bg((n = e).children, function (e) {
                  return K.cloneElement(e, {
                    onExited: r.bind(null, e),
                    in: !0,
                    appear: wg(e, "appear", n),
                    enter: wg(e, "enter", n),
                    exit: wg(e, "exit", n),
                  });
                }))
              : ((s = i),
                (l = o),
                (c = bg((a = e).children)),
                (u = (function (t, n) {
                  function e(e) {
                    return (e in n ? n : t)[e];
                  }
                  (t = t || {}), (n = n || {});
                  var r,
                    i,
                    o = Object.create(null),
                    a = [];
                  for (i in t)
                    i in n ? a.length && ((o[i] = a), (a = [])) : a.push(i);
                  var s,
                    l = {};
                  for (s in n) {
                    if (o[s])
                      for (r = 0; r < o[s].length; r++) {
                        var c = o[s][r];
                        l[o[s][r]] = e(c);
                      }
                    l[s] = e(s);
                  }
                  for (r = 0; r < a.length; r++) l[a[r]] = e(a[r]);
                  return l;
                })(s, c)),
                Object.keys(u).forEach(function (e) {
                  var t,
                    n,
                    r,
                    i,
                    o = u[e];
                  K.isValidElement(o) &&
                    ((t = e in s),
                    (n = e in c),
                    (r = s[e]),
                    (i = K.isValidElement(r) && !r.props.in),
                    !n || (t && !i)
                      ? n || !t || i
                        ? n &&
                          t &&
                          K.isValidElement(r) &&
                          (u[e] = K.cloneElement(o, {
                            onExited: l.bind(null, o),
                            in: r.props.in,
                            exit: wg(o, "exit", a),
                            enter: wg(o, "enter", a),
                          }))
                        : (u[e] = K.cloneElement(o, { in: !1 }))
                      : (u[e] = K.cloneElement(o, {
                          onExited: l.bind(null, o),
                          in: !0,
                          exit: wg(o, "exit", a),
                          enter: wg(o, "enter", a),
                        })));
                }),
                u),
            firstRender: !1,
          };
        }),
        (t.handleExited = function (t, e) {
          var n = bg(this.props.children);
          t.key in n ||
            (t.props.onExited && t.props.onExited(e),
            this.mounted &&
              this.setState(function (e) {
                e = Su({}, e.children);
                return delete e[t.key], { children: e };
              }));
        }),
        (t.render = function () {
          var e = this.props,
            t = e.component,
            n = e.childFactory,
            r = wu(e, ["component", "childFactory"]),
            e = this.state.contextValue,
            n = xg(this.state.children).map(n);
          return (
            delete r.appear,
            delete r.enter,
            delete r.exit,
            null === t
              ? mh.createElement(yg.Provider, { value: e }, n)
              : mh.createElement(
                  yg.Provider,
                  { value: e },
                  mh.createElement(t, r, n)
                )
          );
        }),
        e
      );
    })(mh.Component);
  (Eg.propTypes = {}),
    (Eg.defaultProps = {
      component: "div",
      childFactory: function (e) {
        return e;
      },
    }),
    Q();
  var Sg = "unmounted",
    Cg = "exited",
    kg = "entering",
    Tg = "entered",
    Pg = "exiting",
    zg = R(du),
    Og = (function (i) {
      function e(e, t) {
        var n,
          r = i.call(this, e, t) || this,
          t = t && !t.isMounting ? e.enter : e.appear;
        return (
          (r.appearStatus = null),
          e.in
            ? t
              ? ((n = Cg), (r.appearStatus = kg))
              : (n = Tg)
            : (n = e.unmountOnExit || e.mountOnEnter ? Sg : Cg),
          (r.state = { status: n }),
          (r.nextCallback = null),
          r
        );
      }
      Vd(e, i),
        (e.getDerivedStateFromProps = function (e, t) {
          return e.in && t.status === Sg ? { status: Cg } : null;
        });
      var t = e.prototype;
      return (
        (t.componentDidMount = function () {
          this.updateStatus(!0, this.appearStatus);
        }),
        (t.componentDidUpdate = function (e) {
          var t = null;
          e !== this.props &&
            ((e = this.state.status),
            this.props.in
              ? e !== kg && e !== Tg && (t = kg)
              : (e !== kg && e !== Tg) || (t = Pg)),
            this.updateStatus(!1, t);
        }),
        (t.componentWillUnmount = function () {
          this.cancelNextCallback();
        }),
        (t.getTimeouts = function () {
          var e,
            t,
            n = this.props.timeout,
            r = (e = t = n);
          return (
            null != n &&
              "number" != typeof n &&
              ((r = n.exit),
              (e = n.enter),
              (t = void 0 !== n.appear ? n.appear : e)),
            { exit: r, enter: e, appear: t }
          );
        }),
        (t.updateStatus = function (e, t) {
          var n;
          void 0 === e && (e = !1),
            null !== t
              ? (this.cancelNextCallback(),
                (n = zg.findDOMNode(this)),
                t === kg ? this.performEnter(n, e) : this.performExit(n))
              : this.props.unmountOnExit &&
                this.state.status === Cg &&
                this.setState({ status: Sg });
        }),
        (t.performEnter = function (e, t) {
          var n = this,
            r = this.props.enter,
            i = this.context ? this.context.isMounting : t,
            o = this.getTimeouts(),
            a = i ? o.appear : o.enter;
          t || r
            ? (this.props.onEnter(e, i),
              this.safeSetState({ status: kg }, function () {
                n.props.onEntering(e, i),
                  n.onTransitionEnd(e, a, function () {
                    n.safeSetState({ status: Tg }, function () {
                      n.props.onEntered(e, i);
                    });
                  });
              }))
            : this.safeSetState({ status: Tg }, function () {
                n.props.onEntered(e);
              });
        }),
        (t.performExit = function (e) {
          var t = this,
            n = this.props.exit,
            r = this.getTimeouts();
          n
            ? (this.props.onExit(e),
              this.safeSetState({ status: Pg }, function () {
                t.props.onExiting(e),
                  t.onTransitionEnd(e, r.exit, function () {
                    t.safeSetState({ status: Cg }, function () {
                      t.props.onExited(e);
                    });
                  });
              }))
            : this.safeSetState({ status: Cg }, function () {
                t.props.onExited(e);
              });
        }),
        (t.cancelNextCallback = function () {
          null !== this.nextCallback &&
            (this.nextCallback.cancel(), (this.nextCallback = null));
        }),
        (t.safeSetState = function (e, t) {
          (t = this.setNextCallback(t)), this.setState(e, t);
        }),
        (t.setNextCallback = function (t) {
          var n = this,
            r = !0;
          return (
            (this.nextCallback = function (e) {
              r && ((r = !1), (n.nextCallback = null), t(e));
            }),
            (this.nextCallback.cancel = function () {
              r = !1;
            }),
            this.nextCallback
          );
        }),
        (t.onTransitionEnd = function (e, t, n) {
          this.setNextCallback(n);
          n = null == t && !this.props.addEndListener;
          e && !n
            ? (this.props.addEndListener &&
                this.props.addEndListener(e, this.nextCallback),
              null != t && setTimeout(this.nextCallback, t))
            : setTimeout(this.nextCallback, 0);
        }),
        (t.render = function () {
          var e = this.state.status;
          if (e === Sg) return null;
          var t = this.props,
            n = t.children,
            t = wu(t, ["children"]);
          if (
            (delete t.in,
            delete t.mountOnEnter,
            delete t.unmountOnExit,
            delete t.appear,
            delete t.enter,
            delete t.exit,
            delete t.timeout,
            delete t.addEndListener,
            delete t.onEnter,
            delete t.onEntering,
            delete t.onEntered,
            delete t.onExit,
            delete t.onExiting,
            delete t.onExited,
            "function" == typeof n)
          )
            return mh.createElement(yg.Provider, { value: null }, n(e, t));
          n = mh.Children.only(n);
          return mh.createElement(
            yg.Provider,
            { value: null },
            mh.cloneElement(n, t)
          );
        }),
        e
      );
    })(mh.Component);
  function Rg() {}
  function Mg(e) {
    return e.scrollTop;
  }
  function Ng(e, t) {
    var n = e.timeout,
      e = e.style,
      e = void 0 === e ? {} : e;
    return {
      duration:
        e.transitionDuration || "number" == typeof n ? n : n[t.mode] || 0,
      delay: e.transitionDelay,
    };
  }
  function Lg(e, t) {
    "function" == typeof e ? e(t) : e && (e.current = t);
  }
  function Ig(t, n) {
    return mh.useMemo(
      function () {
        return null == t && null == n
          ? null
          : function (e) {
              Lg(t, e), Lg(n, e);
            };
      },
      [t, n]
    );
  }
  (Og.contextType = yg),
    (Og.propTypes = {}),
    (Og.defaultProps = {
      in: !1,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1,
      enter: !0,
      exit: !0,
      onEnter: Rg,
      onEntering: Rg,
      onEntered: Rg,
      onExit: Rg,
      onExiting: Rg,
      onExited: Rg,
    }),
    (Og.UNMOUNTED = 0),
    (Og.EXITED = 1),
    (Og.ENTERING = 2),
    (Og.ENTERED = 3),
    (Og.EXITING = 4),
    Q(),
    Q();
  var _g = { entering: { opacity: 1 }, entered: { opacity: 1 } },
    Dg = { enter: Nd.enteringScreen, exit: Nd.leavingScreen },
    Ag = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.in,
        i = e.onEnter,
        o = e.onExit,
        a = e.style,
        s = e.timeout,
        l = void 0 === s ? Dg : s,
        e = xu(e, ["children", "in", "onEnter", "onExit", "style", "timeout"]),
        c = qh(),
        u = Ig(n.ref, t);
      return mh.createElement(
        Og,
        Su(
          {
            appear: !0,
            in: r,
            onEnter: function (e, t) {
              Mg(e);
              var n = Ng({ style: a, timeout: l }, { mode: "enter" });
              (e.style.webkitTransition = c.transitions.create("opacity", n)),
                (e.style.transition = c.transitions.create("opacity", n)),
                i && i(e, t);
            },
            onExit: function (e) {
              var t = Ng({ style: a, timeout: l }, { mode: "exit" });
              (e.style.webkitTransition = c.transitions.create("opacity", t)),
                (e.style.transition = c.transitions.create("opacity", t)),
                o && o(e);
            },
            timeout: l,
          },
          e
        ),
        function (e, t) {
          return mh.cloneElement(
            n,
            Su(
              {
                style: Su(
                  {
                    opacity: 0,
                    visibility: "exited" !== e || r ? void 0 : "hidden",
                  },
                  _g[e],
                  {},
                  a,
                  {},
                  n.props.style
                ),
                ref: u,
              },
              t
            )
          );
        }
      );
    });
  Q();
  var ap = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.invisible,
        a = void 0 !== o && o,
        s = e.open,
        o = e.transitionDuration,
        e = xu(e, [
          "children",
          "classes",
          "className",
          "invisible",
          "open",
          "transitionDuration",
        ]);
      return mh.createElement(
        Ag,
        Su({ in: s, timeout: o }, e),
        mh.createElement(
          "div",
          {
            className: Ph(r.root, i, a && r.invisible),
            "aria-hidden": !0,
            ref: t,
          },
          n
        )
      );
    }),
    Fg = Uh(
      {
        root: {
          zIndex: -1,
          position: "fixed",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          right: 0,
          bottom: 0,
          top: 0,
          left: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          WebkitTapHighlightColor: "transparent",
        },
        invisible: { backgroundColor: "transparent" },
      },
      { name: "PwzrBackdrop" }
    )(ap);
  Q(),
    (Wd = mh.forwardRef(function (e, t) {
      var n = e.anchorOrigin,
        r = void 0 === n ? { vertical: "top", horizontal: "right" } : n,
        i = e.badgeContent,
        o = e.children,
        a = e.classes,
        s = e.className,
        l = e.color,
        c = void 0 === l ? "default" : l,
        u = e.component,
        d = void 0 === u ? "span" : u,
        p = e.invisible,
        f = e.max,
        h = void 0 === f ? 99 : f,
        n = e.overlap,
        l = void 0 === n ? "rectangle" : n,
        u = e.showZero,
        f = void 0 !== u && u,
        n = e.variant,
        u = void 0 === n ? "standard" : n,
        n = xu(e, [
          "anchorOrigin",
          "badgeContent",
          "children",
          "classes",
          "className",
          "color",
          "component",
          "invisible",
          "max",
          "overlap",
          "showZero",
          "variant",
        ]),
        e = p;
      null == p && ((0 === i && !f) || (null == i && "dot" !== u)) && (e = !0);
      f = "";
      return (
        "dot" !== u && (f = h < i ? "".concat(h, "+") : i),
        mh.createElement(
          d,
          Su({ className: Ph(a.root, s), ref: t }, n),
          o,
          mh.createElement(
            "span",
            {
              className: Ph(
                a.badge,
                a["".concat(r.horizontal).concat(ag(r.vertical), "}")],
                a[
                  "anchorOrigin"
                    .concat(ag(r.vertical))
                    .concat(ag(r.horizontal))
                    .concat(ag(l))
                ],
                "default" !== c && a["color".concat(ag(c))],
                e && a.invisible,
                "dot" === u && a.dot
              ),
            },
            f
          )
        )
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            position: "relative",
            display: "inline-flex",
            verticalAlign: "middle",
            flexShrink: 0,
          },
          badge: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            position: "absolute",
            boxSizing: "border-box",
            fontFamily: e.typography.fontFamily,
            fontWeight: e.typography.fontWeightMedium,
            fontSize: e.typography.pxToRem(12),
            minWidth: 20,
            lineHeight: 1,
            padding: "0 6px",
            height: 20,
            borderRadius: 10,
            zIndex: 1,
            transition: e.transitions.create("transform", {
              easing: e.transitions.easing.easeInOut,
              duration: e.transitions.duration.enteringScreen,
            }),
          },
          colorPrimary: {
            backgroundColor: e.palette.primary.main,
            color: e.palette.primary.contrastText,
          },
          colorSecondary: {
            backgroundColor: e.palette.secondary.main,
            color: e.palette.secondary.contrastText,
          },
          colorError: {
            backgroundColor: e.palette.error.main,
            color: e.palette.error.contrastText,
          },
          dot: { borderRadius: 4, height: 8, minWidth: 8, padding: 0 },
          anchorOriginTopRightRectangle: {
            top: 0,
            right: 0,
            transform: "scale(1) translate(50%, -50%)",
            transformOrigin: "100% 0%",
            "&$invisible": { transform: "scale(0) translate(50%, -50%)" },
          },
          anchorOriginBottomRightRectangle: {
            bottom: 0,
            right: 0,
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
            "&$invisible": { transform: "scale(0) translate(50%, 50%)" },
          },
          anchorOriginTopLeftRectangle: {
            top: 0,
            left: 0,
            transform: "scale(1) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            "&$invisible": { transform: "scale(0) translate(-50%, -50%)" },
          },
          anchorOriginBottomLeftRectangle: {
            bottom: 0,
            left: 0,
            transform: "scale(1) translate(-50%, 50%)",
            transformOrigin: "0% 100%",
            "&$invisible": { transform: "scale(0) translate(-50%, 50%)" },
          },
          anchorOriginTopRightCircle: {
            top: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, -50%)",
            transformOrigin: "100% 0%",
            "&$invisible": { transform: "scale(0) translate(50%, -50%)" },
          },
          anchorOriginBottomRightCircle: {
            bottom: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
            "&$invisible": { transform: "scale(0) translate(50%, 50%)" },
          },
          anchorOriginTopLeftCircle: {
            top: "14%",
            left: "14%",
            transform: "scale(1) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            "&$invisible": { transform: "scale(0) translate(-50%, -50%)" },
          },
          anchorOriginBottomLeftCircle: {
            bottom: "14%",
            left: "14%",
            transform: "scale(1) translate(-50%, 50%)",
            transformOrigin: "0% 100%",
            "&$invisible": { transform: "scale(0) translate(-50%, 50%)" },
          },
          invisible: {
            transition: e.transitions.create("transform", {
              easing: e.transitions.easing.easeInOut,
              duration: e.transitions.duration.leavingScreen,
            }),
          },
        };
      },
      { name: "PwzrBadge" }
    )(Wd),
    Q(),
    (dp = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.component,
        a = void 0 === o ? "div" : o,
        s = e.onChange,
        o = e.showLabels,
        l = void 0 !== o && o,
        c = e.value,
        e = xu(e, [
          "children",
          "classes",
          "className",
          "component",
          "onChange",
          "showLabels",
          "value",
        ]);
      return mh.createElement(
        a,
        Su({ className: Ph(r.root, i), ref: t }, e),
        mh.Children.map(n, function (e, t) {
          if (!mh.isValidElement(e)) return null;
          t = void 0 === e.props.value ? t : e.props.value;
          return mh.cloneElement(e, {
            selected: t === c,
            showLabel: void 0 !== e.props.showLabel ? e.props.showLabel : l,
            value: t,
            onChange: s,
          });
        })
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            display: "flex",
            justifyContent: "center",
            height: 56,
            backgroundColor: e.palette.background.paper,
          },
        };
      },
      { name: "PwzrBottomNavigation" }
    )(dp),
    Q();
  var Bg = "undefined" != typeof window ? mh.useLayoutEffect : mh.useEffect;
  function Wg(e) {
    var t = e.children,
      n = e.defer,
      r = void 0 !== n && n,
      i = e.fallback,
      n = void 0 === i ? null : i,
      e = mh.useState(!1),
      i = e[0],
      o = e[1];
    return (
      Bg(
        function () {
          r || o(!0);
        },
        [r]
      ),
      mh.useEffect(
        function () {
          r && o(!0);
        },
        [r]
      ),
      mh.createElement(mh.Fragment, null, i ? t : n)
    );
  }
  Q();
  var $g = "undefined" != typeof window ? mh.useLayoutEffect : mh.useEffect;
  function jg(e) {
    var t = mh.useRef(e);
    return (
      $g(function () {
        t.current = e;
      }),
      mh.useCallback(function () {
        return t.current.apply(void 0, arguments);
      }, [])
    );
  }
  Q(), Q();
  var Hg = !0,
    Vg = !1,
    qg = null,
    Ug = {
      text: !0,
      search: !0,
      url: !0,
      tel: !0,
      email: !0,
      password: !0,
      number: !0,
      date: !0,
      month: !0,
      week: !0,
      time: !0,
      datetime: !0,
      "datetime-local": !0,
    };
  function Gg(e) {
    e.metaKey || e.altKey || e.ctrlKey || (Hg = !0);
  }
  function Yg() {
    Hg = !1;
  }
  function Xg() {
    "hidden" === this.visibilityState && Vg && (Hg = !0);
  }
  function Kg(e) {
    var t,
      n,
      r = e.target;
    try {
      return r.matches(":focus-visible");
    } catch (e) {}
    return (
      Hg ||
      ((t = r.type),
      !("INPUT" !== (n = r.tagName) || !Ug[t] || r.readOnly) ||
        ("TEXTAREA" === n && !r.readOnly) ||
        !!r.isContentEditable)
    );
  }
  function Zg() {
    (Vg = !0),
      window.clearTimeout(qg),
      (qg = window.setTimeout(function () {
        Vg = !1;
      }, 100));
  }
  function Qg() {
    return {
      isFocusVisible: Kg,
      onBlurVisible: Zg,
      ref: mh.useCallback(function (e) {
        var e = zg.findDOMNode(e);
        null != e &&
          ((e = e.ownerDocument).addEventListener("keydown", Gg, !0),
          e.addEventListener("mousedown", Yg, !0),
          e.addEventListener("pointerdown", Yg, !0),
          e.addEventListener("touchstart", Yg, !0),
          e.addEventListener("visibilitychange", Xg, !0));
      }, []),
    };
  }
  Q(), Q();
  var Jg = "undefined" == typeof window ? mh.useEffect : mh.useLayoutEffect;
  function ev(e) {
    var t = e.classes,
      n = e.pulsate,
      r = void 0 !== n && n,
      i = e.rippleX,
      o = e.rippleY,
      a = e.rippleSize,
      s = e.in,
      l = e.onExited,
      n = void 0 === l ? function () {} : l,
      c = e.timeout,
      l = mh.useState(!1),
      e = l[0],
      u = l[1],
      l = Ph(t.ripple, t.rippleVisible, r && t.ripplePulsate),
      i = { width: a, height: a, top: -a / 2 + o, left: -a / 2 + i },
      t = Ph(t.child, e && t.childLeaving, r && t.childPulsate),
      d = jg(n);
    return (
      Jg(
        function () {
          if (!s) {
            u(!0);
            var e = setTimeout(d, c);
            return function () {
              clearTimeout(e);
            };
          }
        },
        [d, s, c]
      ),
      mh.createElement(
        "span",
        { className: l, style: i },
        mh.createElement("span", { className: t })
      )
    );
  }
  var Jf = mh.forwardRef(function (e, t) {
      var n = e.center,
        d = void 0 !== n && n,
        o = e.classes,
        r = e.className,
        i = xu(e, ["center", "classes", "className"]),
        n = mh.useState([]),
        e = n[0],
        a = n[1],
        s = mh.useRef(0),
        l = mh.useRef(null);
      mh.useEffect(
        function () {
          l.current && (l.current(), (l.current = null));
        },
        [e]
      );
      var p = mh.useRef(!1),
        f = mh.useRef(null),
        h = mh.useRef(null),
        m = mh.useRef(null);
      mh.useEffect(function () {
        return function () {
          clearTimeout(f.current);
        };
      }, []);
      var g = mh.useCallback(
          function (e) {
            var t = e.pulsate,
              n = e.rippleX,
              r = e.rippleY,
              i = e.rippleSize,
              e = e.cb;
            a(function (e) {
              return [].concat(Mf(e), [
                mh.createElement(ev, {
                  key: s.current,
                  classes: o,
                  timeout: 550,
                  pulsate: t,
                  rippleX: n,
                  rippleY: r,
                  rippleSize: i,
                }),
              ]);
            }),
              (s.current += 1),
              (l.current = e);
          },
          [o]
        ),
        c = mh.useCallback(
          function () {
            var e,
              t,
              n,
              r =
                0 < arguments.length && void 0 !== arguments[0]
                  ? arguments[0]
                  : {},
              i =
                1 < arguments.length && void 0 !== arguments[1]
                  ? arguments[1]
                  : {},
              o = 2 < arguments.length ? arguments[2] : void 0,
              a = i.pulsate,
              s = void 0 !== a && a,
              l = i.center,
              c = void 0 === l ? d || i.pulsate : l,
              u = i.fakeElement,
              a = void 0 !== u && u;
            "mousedown" === r.type && p.current
              ? (p.current = !1)
              : ("touchstart" === r.type && (p.current = !0),
                (i = (l = a ? null : m.current)
                  ? l.getBoundingClientRect()
                  : { width: 0, height: 0, left: 0, top: 0 }),
                (t =
                  c ||
                  (0 === r.clientX && 0 === r.clientY) ||
                  (!r.clientX && !r.touches)
                    ? ((e = Math.round(i.width / 2)), Math.round(i.height / 2))
                    : ((u = r.clientX || r.touches[0].clientX),
                      (a = r.clientY || r.touches[0].clientY),
                      (e = Math.round(u - i.left)),
                      Math.round(a - i.top))),
                c
                  ? (n = Math.sqrt(
                      (2 * Math.pow(i.width, 2) + Math.pow(i.height, 2)) / 3
                    )) %
                      2 ==
                      0 && (n += 1)
                  : ((i =
                      2 * Math.max(Math.abs((l ? l.clientWidth : 0) - e), e) +
                      2),
                    (l =
                      2 * Math.max(Math.abs((l ? l.clientHeight : 0) - t), t) +
                      2),
                    (n = Math.sqrt(Math.pow(i, 2) + Math.pow(l, 2)))),
                r.touches
                  ? null === h.current &&
                    ((h.current = function () {
                      g({
                        pulsate: s,
                        rippleX: e,
                        rippleY: t,
                        rippleSize: n,
                        cb: o,
                      });
                    }),
                    (f.current = setTimeout(function () {
                      h.current && (h.current(), (h.current = null));
                    }, 80)))
                  : g({
                      pulsate: s,
                      rippleX: e,
                      rippleY: t,
                      rippleSize: n,
                      cb: o,
                    }));
          },
          [d, g]
        ),
        u = mh.useCallback(
          function () {
            c({}, { pulsate: !0 });
          },
          [c]
        ),
        v = mh.useCallback(function (e, t) {
          return (
            clearTimeout(f.current),
            "touchend" === e.type && h.current
              ? (e.persist(),
                h.current(),
                (h.current = null),
                void (f.current = setTimeout(function () {
                  v(e, t);
                })))
              : ((h.current = null),
                a(function (e) {
                  return 0 < e.length ? e.slice(1) : e;
                }),
                void (l.current = t))
          );
        }, []);
      return (
        mh.useImperativeHandle(
          t,
          function () {
            return { pulsate: u, start: c, stop: v };
          },
          [u, c, v]
        ),
        mh.createElement(
          "span",
          Su({ className: Ph(o.root, r), ref: m }, i),
          mh.createElement(Eg, { component: null, exit: !0 }, e)
        )
      );
    }),
    tv = Uh(
      function (e) {
        return {
          root: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit",
          },
          ripple: { opacity: 0, position: "absolute" },
          rippleVisible: {
            opacity: 0.3,
            transform: "scale(1)",
            animation: "$enter "
              .concat(550, "ms ")
              .concat(e.transitions.easing.easeInOut),
          },
          ripplePulsate: {
            animationDuration: "".concat(e.transitions.duration.shorter, "ms"),
          },
          child: {
            opacity: 1,
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "currentColor",
          },
          childLeaving: {
            opacity: 0,
            animation: "$exit "
              .concat(550, "ms ")
              .concat(e.transitions.easing.easeInOut),
          },
          childPulsate: {
            position: "absolute",
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(
              e.transitions.easing.easeInOut,
              " 200ms infinite"
            ),
          },
          "@keyframes enter": {
            "0%": { transform: "scale(0)", opacity: 0.1 },
            "100%": { transform: "scale(1)", opacity: 0.3 },
          },
          "@keyframes exit": { "0%": { opacity: 1 }, "100%": { opacity: 0 } },
          "@keyframes pulsate": {
            "0%": { transform: "scale(1)" },
            "50%": { transform: "scale(0.92)" },
            "100%": { transform: "scale(1)" },
          },
        };
      },
      { flip: !1, name: "PwzrTouchRipple" }
    )(mh.memo(Jf)),
    of = mh.forwardRef(function (e, t) {
      var n = e.action,
        r = e.buttonRef,
        i = e.centerRipple,
        o = void 0 !== i && i,
        a = e.children,
        s = e.classes,
        l = e.className,
        c = e.component,
        u = void 0 === c ? "button" : c,
        d = e.disabled,
        p = void 0 !== d && d,
        f = e.disableRipple,
        h = void 0 !== f && f,
        m = e.disableTouchRipple,
        g = void 0 !== m && m,
        v = e.focusRipple,
        y = void 0 !== v && v,
        b = e.focusVisibleClassName,
        w = e.onBlur,
        x = e.onClick,
        E = e.onFocus,
        S = e.onFocusVisible,
        C = e.onKeyDown,
        k = e.onKeyUp,
        T = e.onMouseDown,
        P = e.onMouseLeave,
        z = e.onMouseUp,
        O = e.onTouchEnd,
        R = e.onTouchMove,
        M = e.onTouchStart,
        N = e.onDragLeave,
        L = e.tabIndex,
        I = void 0 === L ? 0 : L,
        _ = e.TouchRippleProps,
        D = e.type,
        i = void 0 === D ? "button" : D,
        c = xu(e, [
          "action",
          "buttonRef",
          "centerRipple",
          "children",
          "classes",
          "className",
          "component",
          "disabled",
          "disableRipple",
          "disableTouchRipple",
          "focusRipple",
          "focusVisibleClassName",
          "onBlur",
          "onClick",
          "onFocus",
          "onFocusVisible",
          "onKeyDown",
          "onKeyUp",
          "onMouseDown",
          "onMouseLeave",
          "onMouseUp",
          "onTouchEnd",
          "onTouchMove",
          "onTouchStart",
          "onDragLeave",
          "tabIndex",
          "TouchRippleProps",
          "type",
        ]),
        A = mh.useRef(null),
        F = mh.useRef(null),
        d = mh.useState(!1),
        B = d[0],
        W = d[1];
      p && B && W(!1);
      var f = Qg(),
        $ = f.isFocusVisible,
        j = f.onBlurVisible,
        m = f.ref;
      function H(t, n, e) {
        var r = 2 < arguments.length && void 0 !== e ? e : g;
        return jg(function (e) {
          return n && n(e), !r && F.current && F.current[t](e), !0;
        });
      }
      mh.useImperativeHandle(
        n,
        function () {
          return {
            focusVisible: function () {
              W(!0), A.current.focus();
            },
          };
        },
        []
      ),
        mh.useEffect(
          function () {
            B && y && !h && F.current.pulsate();
          },
          [h, y, B]
        );
      function V() {
        var e = zg.findDOMNode(A.current);
        return u && "button" !== u && !("A" === e.tagName && e.href);
      }
      var v = H("start", T),
        L = H("stop", N),
        D = H("stop", z),
        e = H("stop", function (e) {
          B && e.preventDefault(), P && P(e);
        }),
        d = H("start", M),
        f = H("stop", O),
        n = H("stop", R),
        T = H(
          "stop",
          function (e) {
            B && (j(e), W(!1)), w && w(e);
          },
          !1
        ),
        N = jg(function (e) {
          p ||
            (A.current || (A.current = e.currentTarget),
            $(e) && (W(!0), S && S(e)),
            E && E(e));
        }),
        q = mh.useRef(!1),
        z = jg(function (e) {
          y &&
            !q.current &&
            B &&
            F.current &&
            " " === e.key &&
            ((q.current = !0),
            e.persist(),
            F.current.stop(e, function () {
              F.current.start(e);
            })),
            C && C(e),
            e.target === e.currentTarget &&
              V() &&
              "Enter" === e.key &&
              (e.preventDefault(), x && x(e));
        }),
        M = jg(function (e) {
          y &&
            " " === e.key &&
            F.current &&
            B &&
            !e.defaultPrevented &&
            ((q.current = !1),
            e.persist(),
            F.current.stop(e, function () {
              F.current.pulsate(e);
            })),
            k && k(e),
            e.target === e.currentTarget &&
              V() &&
              " " === e.key &&
              !e.defaultPrevented &&
              (e.preventDefault(), x && x(e));
        }),
        O = u;
      "button" === O && c.href && (O = "a");
      R = {};
      "button" === O
        ? ((R.type = i), (R.disabled = p))
        : (("a" === O && c.href) || (R.role = "button"),
          (R["aria-disabled"] = p));
      (t = Ig(r, t)), (m = Ig(m, A)), (m = Ig(t, m));
      return mh.createElement(
        O,
        Su(
          {
            className: Ph(s.root, l, B && [s.focusVisible, b], p && s.disabled),
            onBlur: T,
            onClick: x,
            onFocus: N,
            onKeyDown: z,
            onKeyUp: M,
            onMouseDown: v,
            onMouseLeave: e,
            onMouseUp: D,
            onDragLeave: L,
            onTouchEnd: f,
            onTouchMove: n,
            onTouchStart: d,
            ref: m,
            tabIndex: p ? -1 : I,
          },
          R,
          c
        ),
        a,
        h || p
          ? null
          : mh.createElement(
              Wg,
              null,
              mh.createElement(tv, Su({ ref: F, center: o }, _))
            )
      );
    }),
    nv = Uh(
      {
        root: {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          WebkitTapHighlightColor: "transparent",
          backgroundColor: "transparent",
          outline: 0,
          border: 0,
          margin: 0,
          borderRadius: 0,
          padding: 0,
          cursor: "pointer",
          userSelect: "none",
          verticalAlign: "middle",
          "-moz-appearance": "none",
          "-webkit-appearance": "none",
          textDecoration: "none",
          color: "inherit",
          "&::-moz-focus-inner": { borderStyle: "none" },
          "&$disabled": { pointerEvents: "none", cursor: "default" },
        },
        disabled: {},
        focusVisible: {},
      },
      { name: "PwzrButtonBase" }
    )(of);
  function rv(e, t) {
    return t ? zu(e, t, { clone: !1 }) : e;
  }
  Q(),
    (vp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.icon,
        o = e.label,
        a = e.onChange,
        s = e.onClick,
        l = e.selected,
        c = e.showLabel,
        u = e.value,
        e = xu(e, [
          "classes",
          "className",
          "icon",
          "label",
          "onChange",
          "onClick",
          "selected",
          "showLabel",
          "value",
        ]);
      return mh.createElement(
        nv,
        Su(
          {
            ref: t,
            className: Ph(n.root, r, l ? n.selected : !c && n.iconOnly),
            focusRipple: !0,
            onClick: function (e) {
              a && a(e, u), s && s(e);
            },
          },
          e
        ),
        mh.createElement(
          "span",
          { className: n.wrapper },
          i,
          mh.createElement(
            "span",
            { className: Ph(n.label, l ? n.selected : !c && n.iconOnly) },
            o
          )
        )
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            transition: e.transitions.create(["color", "padding-top"], {
              duration: e.transitions.duration.short,
            }),
            padding: "6px 12px 8px",
            minWidth: 80,
            maxWidth: 168,
            color: e.palette.text.secondary,
            flex: "1",
            "&$iconOnly": { paddingTop: 16 },
            "&$selected": { paddingTop: 6, color: e.palette.primary.main },
          },
          selected: {},
          iconOnly: {},
          wrapper: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            flexDirection: "column",
          },
          label: {
            fontFamily: e.typography.fontFamily,
            fontSize: e.typography.pxToRem(12),
            opacity: 1,
            transition: "font-size 0.2s, opacity 0.2s",
            transitionDelay: "0.1s",
            "&$iconOnly": { opacity: 0, transitionDelay: "0s" },
            "&$selected": { fontSize: e.typography.pxToRem(14) },
          },
        };
      },
      { name: "PwzrBottomNavigationAction" }
    )(vp);
  var iv = { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 },
    ov = {
      keys: ["xs", "sm", "md", "lg", "xl"],
      up: function (e) {
        return "@media (min-width:".concat(iv[e], "px)");
      },
    };
  function av(e, r, i) {
    if (Array.isArray(r)) {
      var o = e.theme.breakpoints || ov;
      return r.reduce(function (e, t, n) {
        return (e[o.up(o.keys[n])] = i(r[n])), e;
      }, {});
    }
    if ("object" !== Tu(r)) return i(r);
    var n = e.theme.breakpoints || ov;
    return Object.keys(r).reduce(function (e, t) {
      return (e[n.up(t)] = i(r[t])), e;
    }, {});
  }
  function sv(e, t) {
    return t && "string" == typeof t
      ? t.split(".").reduce(function (e, t) {
          return e && e[t] ? e[t] : null;
        }, e)
      : null;
  }
  function lv(e) {
    var r = e.prop,
      t = e.cssProperty,
      i = void 0 === t ? e.prop : t,
      o = e.themeKey,
      a = e.transform,
      e = function (e) {
        if (null == e[r]) return null;
        var t = e[r],
          n = sv(e.theme, o) || {};
        return av(e, t, function (e) {
          var t;
          return (
            "function" == typeof n
              ? (t = n(e))
              : Array.isArray(n)
              ? (t = n[e] || e)
              : ((t = sv(n, e) || e), a && (t = a(t))),
            !1 === i ? t : bu({}, i, t)
          );
        });
      };
    return (e.propTypes = {}), (e.filterProps = [r]), e;
  }
  function cv() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    function r(n) {
      return t.reduce(function (e, t) {
        t = t(n);
        return t ? rv(e, t) : e;
      }, {});
    }
    return (
      (r.propTypes = {}),
      (r.filterProps = t.reduce(function (e, t) {
        return e.concat(t.filterProps);
      }, [])),
      r
    );
  }
  function uv(e) {
    return "number" != typeof e ? e : "".concat(e, "px solid");
  }
  function dv(e) {
    return e <= 1 ? "".concat(100 * e, "%") : e;
  }
  function pv(e) {
    if (Array.isArray(e)) return e;
  }
  function fv() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  function hv(e, t) {
    return (
      pv(e) ||
      (function (e, t) {
        if (
          Symbol.iterator in Object(e) ||
          "[object Arguments]" === Object.prototype.toString.call(e)
        ) {
          var n = [],
            r = !0,
            i = !1,
            o = void 0;
          try {
            for (
              var a, s = e[Symbol.iterator]();
              !(r = (a = s.next()).done) &&
              (n.push(a.value), !t || n.length !== t);
              r = !0
            );
          } catch (e) {
            (i = !0), (o = e);
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (i) throw o;
            }
          }
          return n;
        }
      })(e, t) ||
      fv()
    );
  }
  (bp = cv(
    lv({ prop: "border", themeKey: "borders", transform: uv }),
    lv({ prop: "borderTop", themeKey: "borders", transform: uv }),
    lv({ prop: "borderRight", themeKey: "borders", transform: uv }),
    lv({ prop: "borderBottom", themeKey: "borders", transform: uv }),
    lv({ prop: "borderLeft", themeKey: "borders", transform: uv }),
    lv({ prop: "borderColor", themeKey: "palette" }),
    lv({ prop: "borderRadius", themeKey: "shape" })
  )),
    (Qu = cv(
      lv({
        prop: "displayPrint",
        cssProperty: !1,
        transform: function (e) {
          return { "@media print": { display: e } };
        },
      }),
      lv({ prop: "display" }),
      lv({ prop: "overflow" }),
      lv({ prop: "textOverflow" }),
      lv({ prop: "visibility" }),
      lv({ prop: "whiteSpace" })
    )),
    (Sp = cv(
      lv({ prop: "flexBasis" }),
      lv({ prop: "flexDirection" }),
      lv({ prop: "flexWrap" }),
      lv({ prop: "justifyContent" }),
      lv({ prop: "alignItems" }),
      lv({ prop: "alignContent" }),
      lv({ prop: "order" }),
      lv({ prop: "flex" }),
      lv({ prop: "flexGrow" }),
      lv({ prop: "flexShrink" }),
      lv({ prop: "alignSelf" }),
      lv({ prop: "justifyItems" }),
      lv({ prop: "justifySelf" })
    )),
    (xp = cv(
      lv({ prop: "gridGap" }),
      lv({ prop: "gridColumnGap" }),
      lv({ prop: "gridRowGap" }),
      lv({ prop: "gridColumn" }),
      lv({ prop: "gridRow" }),
      lv({ prop: "gridAutoFlow" }),
      lv({ prop: "gridAutoColumns" }),
      lv({ prop: "gridAutoRows" }),
      lv({ prop: "gridTemplateColumns" }),
      lv({ prop: "gridTemplateRows" }),
      lv({ prop: "gridTemplateAreas" }),
      lv({ prop: "gridArea" })
    )),
    (Yu = cv(
      lv({ prop: "color", themeKey: "palette" }),
      lv({
        prop: "bgcolor",
        cssProperty: "backgroundColor",
        themeKey: "palette",
      })
    )),
    (_f = cv(
      lv({ prop: "position" }),
      lv({ prop: "zIndex", themeKey: "zIndex" }),
      lv({ prop: "top" }),
      lv({ prop: "right" }),
      lv({ prop: "bottom" }),
      lv({ prop: "left" })
    )),
    (If = lv({ prop: "boxShadow", themeKey: "shadows" })),
    (ap = lv({ prop: "width", transform: dv })),
    (Wd = lv({ prop: "maxWidth", transform: dv })),
    (dp = lv({ prop: "minWidth", transform: dv })),
    (Jf = lv({ prop: "height", transform: dv })),
    (of = lv({ prop: "maxHeight", transform: dv })),
    (vp = lv({ prop: "minHeight", transform: dv })),
    lv({ prop: "size", cssProperty: "width", transform: dv }),
    lv({ prop: "size", cssProperty: "height", transform: dv }),
    (of = cv(ap, Wd, dp, Jf, of, vp, lv({ prop: "boxSizing" })));
  var mv,
    gv = { m: "margin", p: "padding" },
    vv = {
      t: "Top",
      r: "Right",
      b: "Bottom",
      l: "Left",
      x: ["Left", "Right"],
      y: ["Top", "Bottom"],
    },
    yv = { marginX: "mx", marginY: "my", paddingX: "px", paddingY: "py" },
    bv =
      ((mv = {}),
      function (e) {
        return (
          void 0 === mv[e] &&
            (mv[e] = (function (e) {
              if (e.length > 2) {
                if (!yv[e]) return [e];
                e = yv[e];
              }
              var t = hv(e.split(""), 2),
                n = t[0],
                r = t[1],
                i = gv[n],
                o = vv[r] || "";
              return Array.isArray(o)
                ? o.map(function (e) {
                    return i + e;
                  })
                : [i + o];
            })(e)),
          mv[e]
        );
      }),
    wv = [
      "m",
      "mt",
      "mr",
      "mb",
      "ml",
      "mx",
      "my",
      "p",
      "pt",
      "pr",
      "pb",
      "pl",
      "px",
      "py",
      "margin",
      "marginTop",
      "marginRight",
      "marginBottom",
      "marginLeft",
      "marginX",
      "marginY",
      "padding",
      "paddingTop",
      "paddingRight",
      "paddingBottom",
      "paddingLeft",
      "paddingX",
      "paddingY",
    ];
  function xv(i) {
    var t,
      o =
        "number" == typeof (t = i.theme.spacing || 8)
          ? function (e) {
              return t * e;
            }
          : Array.isArray(t)
          ? function (e) {
              return t[e];
            }
          : "function" == typeof t
          ? t
          : function () {};
    return Object.keys(i)
      .map(function (e) {
        if (-1 === wv.indexOf(e)) return null;
        var t,
          r,
          n =
            ((t = bv(e)),
            (r = o),
            function (n) {
              return t.reduce(function (e, t) {
                return (
                  (e[t] = (function (e) {
                    if ("string" == typeof e) return e;
                    var t = r(Math.abs(e));
                    return 0 <= e
                      ? t
                      : "number" == typeof t
                      ? -t
                      : "-".concat(t);
                  })(n)),
                  e
                );
              }, {});
            }),
          e = i[e];
        return av(i, e, n);
      })
      .reduce(rv, {});
  }
  (xv.propTypes = {}), (xv.filterProps = wv);
  var Ev,
    vp = cv(
      lv({ prop: "fontFamily", themeKey: "typography" }),
      lv({ prop: "fontSize", themeKey: "typography" }),
      lv({ prop: "fontStyle", themeKey: "typography" }),
      lv({ prop: "fontWeight", themeKey: "typography" }),
      lv({ prop: "letterSpacing" }),
      lv({ prop: "lineHeight" }),
      lv({ prop: "textAlign" })
    );
  (function (n) {
    var u,
      e = (t =
        1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {})
        .name,
      t = xu(t, ["name"]),
      d = Th(
        "function" == typeof n
          ? function (t) {
              return {
                root: function (e) {
                  return n(Su({ theme: t }, e));
                },
              };
            }
          : { root: n },
        Su(
          {
            Component: "div",
            name: e || "div".displayName,
            classNamePrefix: e,
          },
          t
        )
      );
    n.filterProps && ((u = n.filterProps), delete n.filterProps),
      n.propTypes && (n.propTypes, delete n.propTypes),
      (t = mh.forwardRef(function (e, t) {
        var n,
          r,
          i,
          o = e.children,
          a = e.className,
          s = e.clone,
          l = e.component,
          c = xu(e, ["children", "className", "clone", "component"]),
          e = d(e),
          a = Ph(e.root, a),
          c = c;
        if (
          (u &&
            ((n = c),
            (r = u),
            (i = {}),
            Object.keys(n).forEach(function (e) {
              -1 === r.indexOf(e) && (i[e] = n[e]);
            }),
            (c = i)),
          s)
        )
          return mh.cloneElement(
            o,
            Su({ className: Ph(o.props.className, a) }, c)
          );
        if ("function" == typeof o) return o(Su({ className: a }, c));
        l = l || "div";
        return mh.createElement(l, Su({ ref: t, className: a }, c), o);
      })),
      R(Lh)(t, "div");
  })(
    ((Ev = cv(bp, Qu, Sp, xp, _f, Yu, If, of, xv, vp)),
    ((Sp = function (e) {
      var t,
        n,
        r,
        i = Ev(e);
      return e.css
        ? Su(
            {},
            rv(i, Ev(Su({ theme: e.theme }, e.css))),
            {},
            ((t = e.css),
            (n = [Ev.filterProps]),
            (r = {}),
            Object.keys(t).forEach(function (e) {
              -1 === n.indexOf(e) && (r[e] = t[e]);
            }),
            r)
          )
        : i;
    }).propTypes = {}),
    (Sp.filterProps = ["css"].concat(Mf(Ev.filterProps))),
    (xp = Sp)),
    Su({ defaultTheme: Hh }, { name: "PwzrBox" })
  ),
    Q();
  var Sv = {
      h1: "h1",
      h2: "h2",
      h3: "h3",
      h4: "h4",
      h5: "h5",
      h6: "h6",
      subtitle1: "h6",
      subtitle2: "h6",
      body1: "p",
      body2: "p",
    },
    _f = mh.forwardRef(function (e, t) {
      var n = e.align,
        r = void 0 === n ? "inherit" : n,
        i = e.classes,
        o = e.className,
        a = e.color,
        s = void 0 === a ? "initial" : a,
        l = e.component,
        c = e.display,
        u = void 0 === c ? "initial" : c,
        d = e.gutterBottom,
        p = void 0 !== d && d,
        n = e.noWrap,
        a = void 0 !== n && n,
        c = e.paragraph,
        d = void 0 !== c && c,
        n = e.variant,
        c = void 0 === n ? "body1" : n,
        n = e.variantMapping,
        n = void 0 === n ? Sv : n,
        e = xu(e, [
          "align",
          "classes",
          "className",
          "color",
          "component",
          "display",
          "gutterBottom",
          "noWrap",
          "paragraph",
          "variant",
          "variantMapping",
        ]),
        n = l || (d ? "p" : n[c] || Sv[c]) || "span";
      return mh.createElement(
        n,
        Su(
          {
            className: Ph(
              i.root,
              o,
              "inherit" !== c && i[c],
              "initial" !== s && i["color".concat(ag(s))],
              a && i.noWrap,
              p && i.gutterBottom,
              d && i.paragraph,
              "inherit" !== r && i["align".concat(ag(r))],
              "initial" !== u && i["display".concat(ag(u))]
            ),
            ref: t,
          },
          e
        )
      );
    }),
    Cv = Uh(
      function (e) {
        return {
          root: { margin: 0 },
          body2: e.typography.body2,
          body1: e.typography.body1,
          caption: e.typography.caption,
          button: e.typography.button,
          h1: e.typography.h1,
          h2: e.typography.h2,
          h3: e.typography.h3,
          h4: e.typography.h4,
          h5: e.typography.h5,
          h6: e.typography.h6,
          subtitle1: e.typography.subtitle1,
          subtitle2: e.typography.subtitle2,
          overline: e.typography.overline,
          srOnly: {
            position: "absolute",
            height: 1,
            width: 1,
            overflow: "hidden",
          },
          alignLeft: { textAlign: "left" },
          alignCenter: { textAlign: "center" },
          alignRight: { textAlign: "right" },
          alignJustify: { textAlign: "justify" },
          noWrap: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
          gutterBottom: { marginBottom: "0.35em" },
          paragraph: { marginBottom: 16 },
          colorInherit: { color: "inherit" },
          colorPrimary: { color: e.palette.primary.main },
          colorSecondary: { color: e.palette.secondary.main },
          colorTextPrimary: { color: e.palette.text.primary },
          colorTextSecondary: { color: e.palette.text.secondary },
          colorError: { color: e.palette.error.main },
          displayInline: { display: "inline" },
          displayBlock: { display: "block" },
        };
      },
      { name: "PwzrTypography" }
    )(_f);
  Q(), Q(), Q();
  var kv = gg(
      mh.createElement("path", {
        d:
          "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
      })
    ),
    Tv = Uh(
      function (e) {
        return {
          root: { display: "flex" },
          icon: {
            width: 24,
            height: 16,
            backgroundColor: e.palette.grey[100],
            color: e.palette.grey[700],
            borderRadius: 2,
            marginLeft: e.spacing(0.5),
            marginRight: e.spacing(0.5),
            cursor: "pointer",
            "&:hover, &:focus": { backgroundColor: e.palette.grey[200] },
            "&:active": {
              boxShadow: e.shadows[0],
              backgroundColor: mu(e.palette.grey[200], 0.12),
            },
          },
        };
      },
      { name: "PrivateBreadcrumbCollapsed" }
    )(function (e) {
      var t = e.classes,
        e = xu(e, ["classes"]);
      return mh.createElement(
        "li",
        Su({ className: t.root }, e),
        mh.createElement(kv, { className: t.icon })
      );
    }),
    Yu = mh.forwardRef(function (e, t) {
      var r,
        i,
        o,
        n = e.children,
        a = e.classes,
        s = e.className,
        l = e.component,
        c = void 0 === l ? "nav" : l,
        u = e.itemsAfterCollapse,
        d = void 0 === u ? 1 : u,
        p = e.itemsBeforeCollapse,
        f = void 0 === p ? 1 : p,
        h = e.maxItems,
        l = void 0 === h ? 8 : h,
        u = e.separator,
        p = void 0 === u ? "/" : u,
        h = xu(e, [
          "children",
          "classes",
          "className",
          "component",
          "itemsAfterCollapse",
          "itemsBeforeCollapse",
          "maxItems",
          "separator",
        ]),
        u = mh.useState(!1),
        e = u[0],
        m = u[1],
        n = mh.Children.toArray(n)
          .filter(function (e) {
            return mh.isValidElement(e);
          })
          .map(function (e, t) {
            return mh.createElement(
              "li",
              { className: a.li, key: "child-".concat(t) },
              e
            );
          });
      return mh.createElement(
        Cv,
        Su(
          {
            ref: t,
            component: c,
            color: "textSecondary",
            className: Ph(a.root, s),
          },
          h
        ),
        mh.createElement(
          "ol",
          { className: a.ol },
          ((r =
            e || (l && n.length <= l)
              ? n
              : f + d >= (n = n).length
              ? n
              : [].concat(
                  Mf(n.slice(0, f)),
                  [
                    mh.createElement(Tv, {
                      key: "ellipsis",
                      onClick: function () {
                        m(!0);
                      },
                    }),
                  ],
                  Mf(n.slice(n.length - d, n.length))
                )),
          (i = a.separator),
          (o = p),
          r.reduce(function (e, t, n) {
            return (
              n < r.length - 1
                ? (e = e.concat(
                    t,
                    mh.createElement(
                      "li",
                      {
                        "aria-hidden": !0,
                        key: "separator-".concat(n),
                        className: i,
                      },
                      o
                    )
                  ))
                : e.push(t),
              e
            );
          }, []))
        )
      );
    });
  Uh(
    {
      root: {},
      ol: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        padding: 0,
        margin: 0,
        listStyle: "none",
      },
      li: {},
      separator: {
        display: "flex",
        userSelect: "none",
        marginLeft: 8,
        marginRight: 8,
      },
    },
    { name: "PwzrBreadcrumbs" }
  )(Yu),
    Q(),
    (If = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.color,
        a = void 0 === o ? "default" : o,
        s = e.component,
        l = void 0 === s ? "button" : s,
        c = e.disabled,
        u = void 0 !== c && c,
        d = e.disableElevation,
        p = void 0 !== d && d,
        f = e.disableFocusRipple,
        h = void 0 !== f && f,
        m = e.endIcon,
        g = e.focusVisibleClassName,
        o = e.fullWidth,
        s = void 0 !== o && o,
        c = e.size,
        d = void 0 === c ? "medium" : c,
        f = e.startIcon,
        o = e.type,
        c = void 0 === o ? "button" : o,
        o = e.variant,
        o = void 0 === o ? "text" : o,
        e = xu(e, [
          "children",
          "classes",
          "className",
          "color",
          "component",
          "disabled",
          "disableElevation",
          "disableFocusRipple",
          "endIcon",
          "focusVisibleClassName",
          "fullWidth",
          "size",
          "startIcon",
          "type",
          "variant",
        ]),
        f =
          f &&
          mh.createElement(
            "span",
            { className: Ph(r.startIcon, r["iconSize".concat(ag(d))]) },
            f
          ),
        m =
          m &&
          mh.createElement(
            "span",
            { className: Ph(r.endIcon, r["iconSize".concat(ag(d))]) },
            m
          );
      return mh.createElement(
        nv,
        Su(
          {
            className: Ph(
              r.root,
              r[o],
              i,
              "inherit" === a
                ? r.colorInherit
                : "default" !== a && r["".concat(o).concat(ag(a))],
              "medium" !== d && [
                r["".concat(o, "Size").concat(ag(d))],
                r["size".concat(ag(d))],
              ],
              p && r.disableElevation,
              u && r.disabled,
              s && r.fullWidth
            ),
            component: l,
            disabled: u,
            focusRipple: !h,
            focusVisibleClassName: Ph(r.focusVisible, g),
            ref: t,
            type: c,
          },
          e
        ),
        mh.createElement("span", { className: r.label }, f, n, m)
      );
    })),
    (of = Uh(
      function (e) {
        return {
          root: Su({}, e.typography.button, {
            boxSizing: "border-box",
            minWidth: 64,
            padding: "6px 16px",
            borderRadius: e.shape.borderRadius,
            color: e.palette.text.primary,
            transition: e.transitions.create(
              ["background-color", "box-shadow", "border"],
              { duration: e.transitions.duration.short }
            ),
            "&:hover": {
              textDecoration: "none",
              backgroundColor: gu(
                e.palette.text.primary,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
              "&$disabled": { backgroundColor: "transparent" },
            },
            "&$disabled": { color: e.palette.action.disabled },
          }),
          label: {
            width: "100%",
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit",
          },
          text: { padding: "6px 8px" },
          textPrimary: {
            color: e.palette.primary.main,
            "&:hover": {
              backgroundColor: gu(
                e.palette.primary.main,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
          },
          textSecondary: {
            color: e.palette.secondary.main,
            "&:hover": {
              backgroundColor: gu(
                e.palette.secondary.main,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
          },
          outlined: {
            padding: "5px 15px",
            border: "1px solid ".concat(
              "light" === e.palette.type
                ? "rgba(0, 0, 0, 0.23)"
                : "rgba(255, 255, 255, 0.23)"
            ),
            "&$disabled": {
              border: "1px solid ".concat(e.palette.action.disabledBackground),
            },
          },
          outlinedPrimary: {
            color: e.palette.primary.main,
            border: "1px solid ".concat(gu(e.palette.primary.main, 0.5)),
            "&:hover": {
              border: "1px solid ".concat(e.palette.primary.main),
              backgroundColor: gu(
                e.palette.primary.main,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
          },
          outlinedSecondary: {
            color: e.palette.secondary.main,
            border: "1px solid ".concat(gu(e.palette.secondary.main, 0.5)),
            "&:hover": {
              border: "1px solid ".concat(e.palette.secondary.main),
              backgroundColor: gu(
                e.palette.secondary.main,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
            "&$disabled": {
              border: "1px solid ".concat(e.palette.action.disabled),
            },
          },
          contained: {
            color: e.palette.getContrastText(e.palette.grey[300]),
            backgroundColor: e.palette.grey[300],
            boxShadow: e.shadows[2],
            "&:hover": {
              backgroundColor: e.palette.grey.A100,
              boxShadow: e.shadows[4],
              "@media (hover: none)": {
                boxShadow: e.shadows[2],
                backgroundColor: e.palette.grey[300],
              },
              "&$disabled": {
                backgroundColor: e.palette.action.disabledBackground,
              },
            },
            "&$focusVisible": { boxShadow: e.shadows[6] },
            "&:active": { boxShadow: e.shadows[8] },
            "&$disabled": {
              color: e.palette.action.disabled,
              boxShadow: e.shadows[0],
              backgroundColor: e.palette.action.disabledBackground,
            },
          },
          containedPrimary: {
            color: e.palette.primary.contrastText,
            backgroundColor: e.palette.primary.main,
            "&:hover": {
              backgroundColor: e.palette.primary.dark,
              "@media (hover: none)": {
                backgroundColor: e.palette.primary.main,
              },
            },
          },
          containedSecondary: {
            color: e.palette.secondary.contrastText,
            backgroundColor: e.palette.secondary.main,
            "&:hover": {
              backgroundColor: e.palette.secondary.dark,
              "@media (hover: none)": {
                backgroundColor: e.palette.secondary.main,
              },
            },
          },
          disableElevation: {
            boxShadow: "none",
            "&:hover": { boxShadow: "none" },
            "&$focusVisible": { boxShadow: "none" },
            "&:active": { boxShadow: "none" },
            "&$disabled": { boxShadow: "none" },
          },
          focusVisible: {},
          disabled: {},
          colorInherit: { color: "inherit", borderColor: "currentColor" },
          textSizeSmall: {
            padding: "4px 5px",
            fontSize: e.typography.pxToRem(13),
          },
          textSizeLarge: {
            padding: "8px 11px",
            fontSize: e.typography.pxToRem(15),
          },
          outlinedSizeSmall: {
            padding: "3px 9px",
            fontSize: e.typography.pxToRem(13),
          },
          outlinedSizeLarge: {
            padding: "7px 21px",
            fontSize: e.typography.pxToRem(15),
          },
          containedSizeSmall: {
            padding: "4px 10px",
            fontSize: e.typography.pxToRem(13),
          },
          containedSizeLarge: {
            padding: "8px 22px",
            fontSize: e.typography.pxToRem(15),
          },
          sizeSmall: {},
          sizeLarge: {},
          fullWidth: { width: "100%" },
          startIcon: {
            display: "inherit",
            marginRight: 8,
            marginLeft: -4,
            "&$iconSizeSmall": { marginLeft: -2 },
          },
          endIcon: {
            display: "inherit",
            marginRight: -4,
            marginLeft: 8,
            "&$iconSizeSmall": { marginRight: -2 },
          },
          iconSizeSmall: { "& > *:first-child": { fontSize: 18 } },
          iconSizeMedium: { "& > *:first-child": { fontSize: 20 } },
          iconSizeLarge: { "& > *:first-child": { fontSize: 22 } },
        };
      },
      { name: "PwzrButton" }
    )(If)),
    Q(),
    of.styles,
    (vp = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.color,
        a = void 0 === o ? "default" : o,
        s = e.component,
        l = void 0 === s ? "div" : s,
        o = e.disabled,
        c = void 0 !== o && o,
        s = e.disableFocusRipple,
        u = void 0 !== s && s,
        o = e.disableRipple,
        d = void 0 !== o && o,
        s = e.fullWidth,
        p = void 0 !== s && s,
        o = e.orientation,
        s = void 0 === o ? "horizontal" : o,
        o = e.size,
        f = void 0 === o ? "medium" : o,
        o = e.variant,
        h = void 0 === o ? "outlined" : o,
        e = xu(e, [
          "children",
          "classes",
          "className",
          "color",
          "component",
          "disabled",
          "disableFocusRipple",
          "disableRipple",
          "fullWidth",
          "orientation",
          "size",
          "variant",
        ]),
        m = Ph(
          r.grouped,
          r["grouped".concat(ag(s))],
          r["grouped".concat(ag(h))],
          r["grouped".concat(ag(h)).concat(ag(s))],
          r["grouped".concat(ag(h)).concat("default" !== a ? ag(a) : "")],
          c && r.disabled
        );
      return mh.createElement(
        l,
        Su(
          {
            role: "group",
            className: Ph(
              r.root,
              i,
              p && r.fullWidth,
              "contained" === h && r.contained,
              "vertical" === s && r.vertical
            ),
            ref: t,
          },
          e
        ),
        mh.Children.map(n, function (e) {
          return mh.isValidElement(e)
            ? mh.cloneElement(e, {
                className: Ph(m, e.props.className),
                disabled: e.props.disabled || c,
                color: e.props.color || a,
                disableFocusRipple: u,
                disableRipple: d,
                fullWidth: p,
                size: e.props.size || f,
                variant: e.props.variant || h,
              })
            : null;
        })
      );
    })),
    Uh(
      function (e) {
        return {
          root: { display: "inline-flex", borderRadius: e.shape.borderRadius },
          contained: { boxShadow: e.shadows[2] },
          disabled: {},
          fullWidth: { width: "100%" },
          vertical: { flexDirection: "column" },
          grouped: { minWidth: 40 },
          groupedHorizontal: {
            "&:not(:first-child)": {
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
            },
            "&:not(:last-child)": {
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
            },
          },
          groupedVertical: {
            "&:not(:first-child)": {
              borderTopRightRadius: 0,
              borderTopLeftRadius: 0,
            },
            "&:not(:last-child)": {
              borderBottomRightRadius: 0,
              borderBottomLeftRadius: 0,
            },
          },
          groupedText: {},
          groupedTextHorizontal: {
            "&:not(:last-child)": {
              borderRight: "1px solid ".concat(
                "light" === e.palette.type
                  ? "rgba(0, 0, 0, 0.23)"
                  : "rgba(255, 255, 255, 0.23)"
              ),
            },
          },
          groupedTextVertical: {
            "&:not(:last-child)": {
              borderBottom: "1px solid ".concat(
                "light" === e.palette.type
                  ? "rgba(0, 0, 0, 0.23)"
                  : "rgba(255, 255, 255, 0.23)"
              ),
            },
          },
          groupedTextPrimary: {
            "&:not(:last-child)": {
              borderColor: gu(e.palette.primary.main, 0.5),
            },
          },
          groupedTextSecondary: {
            "&:not(:last-child)": {
              borderColor: gu(e.palette.secondary.main, 0.5),
            },
          },
          groupedOutlined: {},
          groupedOutlinedHorizontal: {
            "&:not(:first-child)": { marginLeft: -1 },
            "&:not(:last-child)": { borderRightColor: "transparent" },
          },
          groupedOutlinedVertical: {
            "&:not(:first-child)": { marginTop: -1 },
            "&:not(:last-child)": { borderBottomColor: "transparent" },
          },
          groupedOutlinedPrimary: {
            "&:hover": { borderColor: e.palette.primary.main },
          },
          groupedOutlinedSecondary: {
            "&:hover": { borderColor: e.palette.secondary.main },
          },
          groupedContained: { boxShadow: "none" },
          groupedContainedHorizontal: {
            "&:not(:last-child)": {
              borderRight: "1px solid ".concat(e.palette.grey[400]),
              "&$disabled": {
                borderRight: "1px solid ".concat(e.palette.action.disabled),
              },
            },
          },
          groupedContainedVertical: {
            "&:not(:last-child)": {
              borderBottom: "1px solid ".concat(e.palette.grey[400]),
              "&$disabled": {
                borderBottom: "1px solid ".concat(e.palette.action.disabled),
              },
            },
          },
          groupedContainedPrimary: {
            "&:not(:last-child)": { borderColor: e.palette.primary.dark },
          },
          groupedContainedSecondary: {
            "&:not(:last-child)": { borderColor: e.palette.secondary.dark },
          },
        };
      },
      { name: "PwzrButtonGroup" }
    )(vp),
    Q(),
    (Sp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.raised,
        i = void 0 !== i && i,
        e = xu(e, ["classes", "className", "raised"]);
      return mh.createElement(
        mg,
        Su({ className: Ph(n.root, r), elevation: i ? 8 : 1, ref: t }, e)
      );
    })),
    Uh({ root: { overflow: "hidden" } }, { name: "PwzrCard" })(Sp),
    Q(),
    (xp = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.focusVisibleClassName,
        e = xu(e, [
          "children",
          "classes",
          "className",
          "focusVisibleClassName",
        ]);
      return mh.createElement(
        nv,
        Su(
          {
            className: Ph(r.root, i),
            focusVisibleClassName: Ph(o, r.focusVisible),
            ref: t,
          },
          e
        ),
        n,
        mh.createElement("span", { className: r.focusHighlight })
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            display: "block",
            textAlign: "inherit",
            width: "100%",
            "&:hover $focusHighlight": {
              opacity: e.palette.action.hoverOpacity,
            },
            "&$focusVisible $focusHighlight": { opacity: 0.12 },
          },
          focusVisible: {},
          focusHighlight: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit",
            opacity: 0,
            backgroundColor: "currentcolor",
            transition: e.transitions.create("opacity", {
              duration: e.transitions.duration.short,
            }),
          },
        };
      },
      { name: "PwzrCardActionArea" }
    )(xp),
    Q(),
    (_f = mh.forwardRef(function (e, t) {
      var n = e.disableSpacing,
        r = void 0 !== n && n,
        i = e.classes,
        n = e.className,
        e = xu(e, ["disableSpacing", "classes", "className"]);
      return mh.createElement(
        "div",
        Su({ className: Ph(i.root, n, !r && i.spacing), ref: t }, e)
      );
    })),
    Uh(
      {
        root: { display: "flex", alignItems: "center", padding: 8 },
        spacing: { "& > :not(:first-child)": { marginLeft: 8 } },
      },
      { name: "PwzrCardActions" }
    )(_f),
    Q(),
    (Yu = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.component,
        i = void 0 === i ? "div" : i,
        e = xu(e, ["classes", "className", "component"]);
      return mh.createElement(i, Su({ className: Ph(n.root, r), ref: t }, e));
    })),
    Uh(
      { root: { padding: 16, "&:last-child": { paddingBottom: 24 } } },
      { name: "PwzrCardContent" }
    )(Yu),
    Q(),
    (If = mh.forwardRef(function (e, t) {
      var n = e.action,
        r = e.avatar,
        i = e.classes,
        o = e.className,
        a = e.component,
        s = void 0 === a ? "div" : a,
        l = e.disableTypography,
        c = void 0 !== l && l,
        u = e.subheader,
        d = e.subheaderTypographyProps,
        a = e.title,
        l = e.titleTypographyProps,
        e = xu(e, [
          "action",
          "avatar",
          "classes",
          "className",
          "component",
          "disableTypography",
          "subheader",
          "subheaderTypographyProps",
          "title",
          "titleTypographyProps",
        ]),
        a = a;
      null == a ||
        a.type === Cv ||
        c ||
        (a = mh.createElement(
          Cv,
          Su(
            {
              variant: r ? "body2" : "h5",
              className: i.title,
              component: "span",
              display: "block",
            },
            l
          ),
          a
        ));
      return (
        null == u ||
          u.type === Cv ||
          c ||
          (u = mh.createElement(
            Cv,
            Su(
              {
                variant: r ? "body2" : "body1",
                className: i.subheader,
                color: "textSecondary",
                component: "span",
                display: "block",
              },
              d
            ),
            u
          )),
        mh.createElement(
          s,
          Su({ className: Ph(i.root, o), ref: t }, e),
          r && mh.createElement("div", { className: i.avatar }, r),
          mh.createElement("div", { className: i.content }, a, u),
          n && mh.createElement("div", { className: i.action }, n)
        )
      );
    })),
    Uh(
      {
        root: { display: "flex", alignItems: "center", padding: 16 },
        avatar: { flex: "0 0 auto", marginRight: 16 },
        action: {
          flex: "0 0 auto",
          alignSelf: "flex-start",
          marginTop: -8,
          marginRight: -8,
        },
        content: { flex: "1 1 auto" },
        title: {},
        subheader: {},
      },
      { name: "PwzrCardHeader" }
    )(If),
    Q();
  var Pv = ["video", "audio", "picture", "iframe", "img"],
    of = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.component,
        a = void 0 === o ? "div" : o,
        s = e.image,
        l = e.src,
        c = e.style,
        o = xu(e, [
          "children",
          "classes",
          "className",
          "component",
          "image",
          "src",
          "style",
        ]),
        e = -1 !== Pv.indexOf(a),
        c = !e && s ? Su({ backgroundImage: 'url("'.concat(s, '")') }, c) : c;
      return mh.createElement(
        a,
        Su(
          {
            className: Ph(
              r.root,
              i,
              e && r.media,
              -1 !== "picture img".indexOf(a) && r.img
            ),
            ref: t,
            style: c,
            src: e ? s || l : void 0,
          },
          o
        ),
        n
      );
    });
  function zv(e) {
    var t = e.controlled,
      n = e.default,
      r = (e.name, mh.useRef(void 0 !== t).current),
      e = mh.useState(n),
      n = e[0],
      i = e[1];
    return [
      r ? t : n,
      mh.useCallback(function (e) {
        r || i(e);
      }, []),
    ];
  }
  Uh(
    {
      root: {
        display: "block",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      },
      media: { width: "100%" },
      img: { objectFit: "cover" },
    },
    { name: "PwzrCardMedia" }
  )(of),
    Q(),
    Q(),
    Q(),
    Q(),
    Q();
  var Ov = mh.createContext();
  function Rv() {
    return mh.useContext(Ov);
  }
  function Mv() {
    return mh.useContext(Ov);
  }
  var vp = mh.forwardRef(function (e, t) {
      var n = e.edge,
        r = void 0 !== n && n,
        i = e.children,
        o = e.classes,
        a = e.className,
        s = e.color,
        l = void 0 === s ? "default" : s,
        c = e.disabled,
        n = void 0 !== c && c,
        s = e.disableFocusRipple,
        c = void 0 !== s && s,
        s = e.size,
        s = void 0 === s ? "medium" : s,
        e = xu(e, [
          "edge",
          "children",
          "classes",
          "className",
          "color",
          "disabled",
          "disableFocusRipple",
          "size",
        ]);
      return mh.createElement(
        nv,
        Su(
          {
            className: Ph(
              o.root,
              a,
              "default" !== l && o["color".concat(ag(l))],
              n && o.disabled,
              "small" === s && o["size".concat(ag(s))],
              { start: o.edgeStart, end: o.edgeEnd }[r]
            ),
            centerRipple: !0,
            focusRipple: !c,
            disabled: n,
            ref: t,
          },
          e
        ),
        mh.createElement("span", { className: o.label }, i)
      );
    }),
    Nv = Uh(
      function (e) {
        return {
          root: {
            textAlign: "center",
            flex: "0 0 auto",
            fontSize: e.typography.pxToRem(24),
            padding: 12,
            borderRadius: "50%",
            overflow: "visible",
            color: e.palette.action.active,
            transition: e.transitions.create("background-color", {
              duration: e.transitions.duration.shortest,
            }),
            "&:hover": {
              backgroundColor: gu(
                e.palette.action.active,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
            "&$disabled": {
              backgroundColor: "transparent",
              color: e.palette.action.disabled,
            },
          },
          edgeStart: { marginLeft: -12, "$sizeSmall&": { marginLeft: -3 } },
          edgeEnd: { marginRight: -12, "$sizeSmall&": { marginRight: -3 } },
          colorInherit: { color: "inherit" },
          colorPrimary: {
            color: e.palette.primary.main,
            "&:hover": {
              backgroundColor: gu(
                e.palette.primary.main,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
          },
          colorSecondary: {
            color: e.palette.secondary.main,
            "&:hover": {
              backgroundColor: gu(
                e.palette.secondary.main,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
          },
          disabled: {},
          sizeSmall: { padding: 3, fontSize: e.typography.pxToRem(18) },
          label: {
            width: "100%",
            display: "flex",
            alignItems: "inherit",
            justifyContent: "inherit",
          },
        };
      },
      { name: "PwzrIconButton" }
    )(vp);
  Q();
  var Sp = mh.forwardRef(function (e, t) {
      var n = e.autoFocus,
        r = e.checked,
        i = e.checkedIcon,
        o = e.classes,
        a = e.className,
        s = e.defaultChecked,
        l = e.disabled,
        c = e.icon,
        u = e.id,
        d = e.inputProps,
        p = e.inputRef,
        f = e.name,
        h = e.onBlur,
        m = e.onChange,
        g = e.onFocus,
        v = e.readOnly,
        y = e.required,
        b = e.tabIndex,
        w = e.type,
        x = e.value,
        E = xu(e, [
          "autoFocus",
          "checked",
          "checkedIcon",
          "classes",
          "className",
          "defaultChecked",
          "disabled",
          "icon",
          "id",
          "inputProps",
          "inputRef",
          "name",
          "onBlur",
          "onChange",
          "onFocus",
          "readOnly",
          "required",
          "tabIndex",
          "type",
          "value",
        ]),
        S = hv(
          zv({ controlled: r, default: Boolean(s), name: "SwitchBase" }),
          2
        ),
        e = S[0],
        C = S[1],
        k = Mv(),
        S = l;
      k && void 0 === S && (S = k.disabled);
      l = "checkbox" === w || "radio" === w;
      return mh.createElement(
        Nv,
        Su(
          {
            component: "span",
            className: Ph(o.root, a, e && o.checked, S && o.disabled),
            disabled: S,
            tabIndex: null,
            role: void 0,
            onFocus: function (e) {
              g && g(e), k && k.onFocus && k.onFocus(e);
            },
            onBlur: function (e) {
              h && h(e), k && k.onBlur && k.onBlur(e);
            },
            ref: t,
          },
          E
        ),
        mh.createElement(
          "input",
          Su(
            {
              autoFocus: n,
              checked: r,
              defaultChecked: s,
              className: o.input,
              disabled: S,
              id: l && u,
              name: f,
              onChange: function (e) {
                var t = e.target.checked;
                C(t), m && m(e, t);
              },
              readOnly: v,
              ref: p,
              required: y,
              tabIndex: b,
              type: w,
              value: x,
            },
            d
          )
        ),
        e ? i : c
      );
    }),
    Lv = Uh(
      {
        root: { padding: 9 },
        checked: {},
        disabled: {},
        input: {
          cursor: "inherit",
          position: "absolute",
          opacity: 0,
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          margin: 0,
          padding: 0,
          zIndex: 1,
        },
      },
      { name: "PrivateSwitchBase" }
    )(Sp);
  Q(),
    (xp = gg(
      mh.createElement("path", {
        d:
          "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
      })
    )),
    Q(),
    (_f = gg(
      mh.createElement("path", {
        d:
          "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
      })
    )),
    Q();
  var Yu = gg(
      mh.createElement("path", {
        d:
          "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z",
      })
    ),
    Iv = mh.createElement(_f, null),
    _v = mh.createElement(xp, null),
    Dv = mh.createElement(Yu, null),
    If = mh.forwardRef(function (e, t) {
      var n = e.checkedIcon,
        r = void 0 === n ? Iv : n,
        i = e.classes,
        o = e.color,
        a = void 0 === o ? "secondary" : o,
        s = e.icon,
        l = void 0 === s ? _v : s,
        c = e.indeterminate,
        n = void 0 !== c && c,
        o = e.indeterminateIcon,
        s = void 0 === o ? Dv : o,
        c = e.inputProps,
        o = e.size,
        o = void 0 === o ? "medium" : o,
        e = xu(e, [
          "checkedIcon",
          "classes",
          "color",
          "icon",
          "indeterminate",
          "indeterminateIcon",
          "inputProps",
          "size",
        ]);
      return mh.createElement(
        Lv,
        Su(
          {
            type: "checkbox",
            classes: {
              root: Ph(i.root, i["color".concat(ag(a))], n && i.indeterminate),
              checked: i.checked,
              disabled: i.disabled,
            },
            color: a,
            inputProps: Su({ "data-indeterminate": n }, c),
            icon: mh.cloneElement(n ? s : l, {
              fontSize: "small" === o ? "small" : "default",
            }),
            checkedIcon: mh.cloneElement(n ? s : r, {
              fontSize: "small" === o ? "small" : "default",
            }),
            ref: t,
          },
          e
        )
      );
    });
  Uh(
    function (e) {
      return {
        root: { color: e.palette.text.secondary },
        checked: {},
        disabled: {},
        indeterminate: {},
        colorPrimary: {
          "&$checked": {
            color: e.palette.primary.main,
            "&:hover": {
              backgroundColor: gu(
                e.palette.primary.main,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
          },
          "&$disabled": { color: e.palette.action.disabled },
        },
        colorSecondary: {
          "&$checked": {
            color: e.palette.secondary.main,
            "&:hover": {
              backgroundColor: gu(
                e.palette.secondary.main,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
          },
          "&$disabled": { color: e.palette.action.disabled },
        },
      };
    },
    { name: "PwzrCheckbox" }
  )(If),
    Q(),
    Q();
  var Av = gg(
      mh.createElement("path", {
        d:
          "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z",
      })
    ),
    of = mh.forwardRef(function (e, t) {
      var n = e.avatar,
        r = e.classes,
        i = e.className,
        o = e.clickable,
        a = e.color,
        s = void 0 === a ? "default" : a,
        l = e.component,
        c = e.deleteIcon,
        u = e.disabled,
        d = void 0 !== u && u,
        p = e.icon,
        f = e.label,
        h = e.onClick,
        m = e.onDelete,
        g = e.onKeyUp,
        v = e.size,
        y = void 0 === v ? "medium" : v,
        b = e.variant,
        w = void 0 === b ? "default" : b,
        a = xu(e, [
          "avatar",
          "classes",
          "className",
          "clickable",
          "color",
          "component",
          "deleteIcon",
          "disabled",
          "icon",
          "label",
          "onClick",
          "onDelete",
          "onKeyUp",
          "size",
          "variant",
        ]),
        x = mh.useRef(null),
        u = Ig(x, t),
        v = function (e) {
          e.stopPropagation(), m && m(e);
        },
        b = !(!1 === o || !h) || o,
        e = "small" === y,
        t = l || (b ? nv : "div"),
        o = t === nv ? { component: "div" } : {},
        y = null;
      m &&
        ((l = Ph(
          "default" !== s &&
            ("default" === w
              ? r["deleteIconColor".concat(ag(s))]
              : r["deleteIconOutlinedColor".concat(ag(s))]),
          e && r.deleteIconSmall
        )),
        (y =
          c && mh.isValidElement(c)
            ? mh.cloneElement(c, {
                className: Ph(c.props.className, r.deleteIcon, l),
                onClick: v,
              })
            : mh.createElement(Av, {
                className: Ph(r.deleteIcon, l),
                onClick: v,
              })));
      v = null;
      n &&
        mh.isValidElement(n) &&
        (v = mh.cloneElement(n, {
          className: Ph(
            r.avatar,
            n.props.className,
            e && r.avatarSmall,
            "default" !== s && r["avatarColor".concat(ag(s))]
          ),
        }));
      n = null;
      return (
        p &&
          mh.isValidElement(p) &&
          (n = mh.cloneElement(p, {
            className: Ph(
              r.icon,
              p.props.className,
              e && r.iconSmall,
              "default" !== s && r["iconColor".concat(ag(s))]
            ),
          })),
        mh.createElement(
          t,
          Su(
            {
              role: b || m ? "button" : void 0,
              className: Ph(
                r.root,
                i,
                "default" !== s && [
                  r["color".concat(ag(s))],
                  b && r["clickableColor".concat(ag(s))],
                  m && r["deletableColor".concat(ag(s))],
                ],
                "default" !== w && [
                  r.outlined,
                  {
                    primary: r.outlinedPrimary,
                    secondary: r.outlinedSecondary,
                  }[s],
                ],
                d && r.disabled,
                e && r.sizeSmall,
                b && r.clickable,
                m && r.deletable
              ),
              "aria-disabled": !!d || void 0,
              tabIndex: b || m ? 0 : void 0,
              onClick: h,
              onKeyUp: function (e) {
                var t;
                g && g(e),
                  e.currentTarget === e.target &&
                    ((t = e.key),
                    !m || ("Backspace" !== t && "Delete" !== t)
                      ? "Escape" === t && x.current && x.current.blur()
                      : m(e));
              },
              ref: u,
            },
            o,
            a
          ),
          v || n,
          mh.createElement(
            "span",
            { className: Ph(r.label, e && r.labelSmall) },
            f
          ),
          y
        )
      );
    });
  function Fv(e) {
    return (e && e.ownerDocument) || document;
  }
  function Bv(e) {
    return e.substring(2).toLowerCase();
  }
  Uh(
    function (e) {
      var t =
          "light" === e.palette.type
            ? e.palette.grey[300]
            : e.palette.grey[700],
        n = gu(e.palette.text.primary, 0.26);
      return {
        root: {
          fontFamily: e.typography.fontFamily,
          fontSize: e.typography.pxToRem(13),
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          height: 32,
          color: e.palette.getContrastText(t),
          backgroundColor: t,
          borderRadius: 16,
          whiteSpace: "nowrap",
          transition: e.transitions.create(["background-color", "box-shadow"]),
          cursor: "default",
          outline: 0,
          textDecoration: "none",
          border: "none",
          padding: 0,
          verticalAlign: "middle",
          boxSizing: "border-box",
          "&$disabled": { opacity: 0.5, pointerEvents: "none" },
          "& $avatar": {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color:
              "light" === e.palette.type
                ? e.palette.grey[700]
                : e.palette.grey[300],
            fontSize: e.typography.pxToRem(12),
          },
          "& $avatarColorPrimary": {
            color: e.palette.primary.contrastText,
            backgroundColor: e.palette.primary.dark,
          },
          "& $avatarColorSecondary": {
            color: e.palette.secondary.contrastText,
            backgroundColor: e.palette.secondary.dark,
          },
          "& $avatarSmall": {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: e.typography.pxToRem(10),
          },
        },
        sizeSmall: { height: 24 },
        colorPrimary: {
          backgroundColor: e.palette.primary.main,
          color: e.palette.primary.contrastText,
        },
        colorSecondary: {
          backgroundColor: e.palette.secondary.main,
          color: e.palette.secondary.contrastText,
        },
        disabled: {},
        clickable: {
          userSelect: "none",
          WebkitTapHighlightColor: "transparent",
          cursor: "pointer",
          "&:hover, &:focus": { backgroundColor: mu(t, 0.08) },
          "&:active": { boxShadow: e.shadows[1] },
        },
        clickableColorPrimary: {
          "&:hover, &:focus": {
            backgroundColor: mu(e.palette.primary.main, 0.08),
          },
        },
        clickableColorSecondary: {
          "&:hover, &:focus": {
            backgroundColor: mu(e.palette.secondary.main, 0.08),
          },
        },
        deletable: { "&:focus": { backgroundColor: mu(t, 0.08) } },
        deletableColorPrimary: {
          "&:focus": { backgroundColor: mu(e.palette.primary.main, 0.2) },
        },
        deletableColorSecondary: {
          "&:focus": { backgroundColor: mu(e.palette.secondary.main, 0.2) },
        },
        outlined: {
          backgroundColor: "transparent",
          border: "1px solid ".concat(
            "light" === e.palette.type
              ? "rgba(0, 0, 0, 0.23)"
              : "rgba(255, 255, 255, 0.23)"
          ),
          "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
            backgroundColor: gu(
              e.palette.text.primary,
              e.palette.action.hoverOpacity
            ),
          },
          "& $avatar": { marginLeft: 4 },
          "& $avatarSmall": { marginLeft: 2 },
          "& $icon": { marginLeft: 4 },
          "& $iconSmall": { marginLeft: 2 },
          "& $deleteIcon": { marginRight: 5 },
          "& $deleteIconSmall": { marginRight: 3 },
        },
        outlinedPrimary: {
          color: e.palette.primary.main,
          border: "1px solid ".concat(e.palette.primary.main),
          "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
            backgroundColor: gu(
              e.palette.primary.main,
              e.palette.action.hoverOpacity
            ),
          },
        },
        outlinedSecondary: {
          color: e.palette.secondary.main,
          border: "1px solid ".concat(e.palette.secondary.main),
          "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
            backgroundColor: gu(
              e.palette.secondary.main,
              e.palette.action.hoverOpacity
            ),
          },
        },
        avatar: {},
        avatarSmall: {},
        avatarColorPrimary: {},
        avatarColorSecondary: {},
        icon: {
          color:
            "light" === e.palette.type
              ? e.palette.grey[700]
              : e.palette.grey[300],
          marginLeft: 5,
          marginRight: -6,
        },
        iconSmall: { width: 18, height: 18, marginLeft: 4, marginRight: -4 },
        iconColorPrimary: { color: "inherit" },
        iconColorSecondary: { color: "inherit" },
        label: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          paddingLeft: 12,
          paddingRight: 12,
          whiteSpace: "nowrap",
        },
        labelSmall: { paddingLeft: 8, paddingRight: 8 },
        deleteIcon: {
          WebkitTapHighlightColor: "transparent",
          color: n,
          height: 22,
          width: 22,
          cursor: "pointer",
          margin: "0 5px 0 -6px",
          "&:hover": { color: gu(n, 0.4) },
        },
        deleteIconSmall: {
          height: 16,
          width: 16,
          marginRight: 4,
          marginLeft: -4,
        },
        deleteIconColorPrimary: {
          color: gu(e.palette.primary.contrastText, 0.7),
          "&:hover, &:active": { color: e.palette.primary.contrastText },
        },
        deleteIconColorSecondary: {
          color: gu(e.palette.secondary.contrastText, 0.7),
          "&:hover, &:active": { color: e.palette.secondary.contrastText },
        },
        deleteIconOutlinedColorPrimary: {
          color: gu(e.palette.primary.main, 0.7),
          "&:hover, &:active": { color: e.palette.primary.main },
        },
        deleteIconOutlinedColorSecondary: {
          color: gu(e.palette.secondary.main, 0.7),
          "&:hover, &:active": { color: e.palette.secondary.main },
        },
      };
    },
    { name: "PwzrChip" }
  )(of),
    Q(),
    (vp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.color,
        o = void 0 === i ? "primary" : i,
        a = e.disableShrink,
        s = void 0 !== a && a,
        l = e.size,
        c = void 0 === l ? 40 : l,
        u = e.style,
        d = e.thickness,
        p = void 0 === d ? 3.6 : d,
        f = e.value,
        h = void 0 === f ? 0 : f,
        m = e.variant,
        i = void 0 === m ? "indeterminate" : m,
        a = xu(e, [
          "classes",
          "className",
          "color",
          "disableShrink",
          "size",
          "style",
          "thickness",
          "value",
          "variant",
        ]),
        l = {},
        d = {},
        f = {};
      return (
        ("determinate" !== i && "static" !== i) ||
          ((m = 2 * Math.PI * ((44 - p) / 2)),
          (l.strokeDasharray = m.toFixed(3)),
          (f["aria-valuenow"] = Math.round(h)),
          "static" === i
            ? ((l.strokeDashoffset = "".concat(
                (((100 - h) / 100) * m).toFixed(3),
                "px"
              )),
              (d.transform = "rotate(-90deg)"))
            : ((l.strokeDashoffset = "".concat(
                ((e = (100 - h) / 100) * e * m).toFixed(3),
                "px"
              )),
              (d.transform = "rotate(".concat(
                (
                  270 *
                  ((h = h / 70),
                  (h = +Math.min(Math.max(0, h), 1)),
                  --h * h * h + 1)
                ).toFixed(3),
                "deg)"
              )))),
        mh.createElement(
          "div",
          Su(
            {
              className: Ph(
                n.root,
                r,
                "inherit" !== o && n["color".concat(ag(o))],
                { indeterminate: n.indeterminate, static: n.static }[i]
              ),
              style: Su({ width: c, height: c }, d, {}, u),
              ref: t,
              role: "progressbar",
            },
            f,
            a
          ),
          mh.createElement(
            "svg",
            {
              className: n.svg,
              viewBox: ""
                .concat(22, " ")
                .concat(22, " ")
                .concat(44, " ")
                .concat(44),
            },
            mh.createElement("circle", {
              className: Ph(
                n.circle,
                s && n.circleDisableShrink,
                {
                  indeterminate: n.circleIndeterminate,
                  static: n.circleStatic,
                }[i]
              ),
              style: l,
              cx: 44,
              cy: 44,
              r: (44 - p) / 2,
              fill: "none",
              strokeWidth: p,
            })
          )
        )
      );
    })),
    Uh(
      function (e) {
        return {
          root: { display: "inline-block" },
          static: { transition: e.transitions.create("transform") },
          indeterminate: { animation: "$circular-rotate 1.4s linear infinite" },
          colorPrimary: { color: e.palette.primary.main },
          colorSecondary: { color: e.palette.secondary.main },
          svg: { display: "block" },
          circle: { stroke: "currentColor" },
          circleStatic: {
            transition: e.transitions.create("stroke-dashoffset"),
          },
          circleIndeterminate: {
            animation: "$circular-dash 1.4s ease-in-out infinite",
            strokeDasharray: "80px, 200px",
            strokeDashoffset: "0px",
          },
          "@keyframes circular-rotate": {
            "100%": { transform: "rotate(360deg)" },
          },
          "@keyframes circular-dash": {
            "0%": { strokeDasharray: "1px, 200px", strokeDashoffset: "0px" },
            "50%": {
              strokeDasharray: "100px, 200px",
              strokeDashoffset: "-15px",
            },
            "100%": {
              strokeDasharray: "100px, 200px",
              strokeDashoffset: "-125px",
            },
          },
          circleDisableShrink: { animation: "none" },
        };
      },
      { name: "PwzrCircularProgress", flip: !1 }
    )(vp),
    Q();
  var Wv = mh.forwardRef(function (e, t) {
    var n = e.children,
      r = e.mouseEvent,
      i = void 0 === r ? "onClick" : r,
      r = e.touchEvent,
      o = void 0 === r ? "onTouchEnd" : r,
      a = e.onClickAway,
      s = mh.useRef(!1),
      l = mh.useRef(null),
      c = mh.useRef(!1);
    mh.useEffect(function () {
      return (
        (c.current = !0),
        function () {
          c.current = !1;
        }
      );
    }, []);
    var u = Ig(l, t),
      t = mh.useCallback(
        function (e) {
          Lg(u, zg.findDOMNode(e));
        },
        [u]
      ),
      t = Ig(n.ref, t),
      d = jg(function (e) {
        var t;
        c.current &&
          (s.current
            ? (s.current = !1)
            : !l.current ||
              ((t = Fv(l.current)).documentElement &&
                t.documentElement.contains(e.target) &&
                !l.current.contains(e.target) &&
                a(e)));
      }),
      p = mh.useCallback(function () {
        s.current = !0;
      }, []);
    return (
      mh.useEffect(
        function () {
          if (!1 !== o) {
            var e = Bv(o),
              t = Fv(l.current);
            return (
              t.addEventListener(e, d),
              t.addEventListener("touchmove", p),
              function () {
                t.removeEventListener(e, d),
                  t.removeEventListener("touchmove", p);
              }
            );
          }
        },
        [d, p, o]
      ),
      mh.useEffect(
        function () {
          if (!1 !== i) {
            var e = Bv(i),
              t = Fv(l.current);
            return (
              t.addEventListener(e, d),
              function () {
                t.removeEventListener(e, d);
              }
            );
          }
        },
        [d, i]
      ),
      mh.createElement(mh.Fragment, null, mh.cloneElement(n, { ref: t }))
    );
  });
  Q(),
    ((Sp = mh.forwardRef(function (e, n) {
      var r = e.children,
        i = e.classes,
        o = e.className,
        t = e.collapsedHeight,
        a = void 0 === t ? "0px" : t,
        t = e.component,
        s = void 0 === t ? "div" : t,
        l = e.in,
        c = e.onEnter,
        u = e.onEntered,
        d = e.onEntering,
        p = e.onExit,
        f = e.onExiting,
        h = e.style,
        t = e.timeout,
        m = void 0 === t ? Nd.standard : t,
        e = xu(e, [
          "children",
          "classes",
          "className",
          "collapsedHeight",
          "component",
          "in",
          "onEnter",
          "onEntered",
          "onEntering",
          "onExit",
          "onExiting",
          "style",
          "timeout",
        ]),
        g = qh(),
        v = mh.useRef(),
        y = mh.useRef(null),
        b = mh.useRef(),
        w = "number" == typeof a ? "".concat(a, "px") : a;
      return (
        mh.useEffect(function () {
          return function () {
            clearTimeout(v.current);
          };
        }, []),
        mh.createElement(
          Og,
          Su(
            {
              in: l,
              onEnter: function (e, t) {
                (e.style.height = w), c && c(e, t);
              },
              onEntered: function (e, t) {
                (e.style.height = "auto"), u && u(e, t);
              },
              onEntering: function (e, t) {
                var n,
                  r = y.current ? y.current.clientHeight : 0,
                  i = Ng({ style: h, timeout: m }, { mode: "enter" }).duration;
                "auto" === m
                  ? ((n = g.transitions.getAutoHeightDuration(r)),
                    (e.style.transitionDuration = "".concat(n, "ms")),
                    (b.current = n))
                  : (e.style.transitionDuration =
                      "string" == typeof i ? i : "".concat(i, "ms")),
                  (e.style.height = "".concat(r, "px")),
                  d && d(e, t);
              },
              onExit: function (e) {
                var t = y.current ? y.current.clientHeight : 0;
                (e.style.height = "".concat(t, "px")), p && p(e);
              },
              onExiting: function (e) {
                var t = y.current ? y.current.clientHeight : 0,
                  n = Ng({ style: h, timeout: m }, { mode: "exit" }).duration;
                "auto" === m
                  ? ((t = g.transitions.getAutoHeightDuration(t)),
                    (e.style.transitionDuration = "".concat(t, "ms")),
                    (b.current = t))
                  : (e.style.transitionDuration =
                      "string" == typeof n ? n : "".concat(n, "ms")),
                  (e.style.height = w),
                  f && f(e);
              },
              addEndListener: function (e, t) {
                "auto" === m && (v.current = setTimeout(t, b.current || 0));
              },
              timeout: "auto" === m ? null : m,
            },
            e
          ),
          function (e, t) {
            return mh.createElement(
              s,
              Su(
                {
                  className: Ph(
                    i.container,
                    o,
                    {
                      entered: i.entered,
                      exited: !l && "0px" === w && i.hidden,
                    }[e]
                  ),
                  style: Su({ minHeight: w }, h),
                  ref: n,
                },
                t
              ),
              mh.createElement(
                "div",
                { className: i.wrapper, ref: y },
                mh.createElement("div", { className: i.wrapperInner }, r)
              )
            );
          }
        )
      );
    })).muiSupportAuto = !0);
  var $v = Uh(
    function (e) {
      return {
        container: {
          height: 0,
          overflow: "hidden",
          transition: e.transitions.create("height"),
        },
        entered: { height: "auto", overflow: "visible" },
        hidden: { visibility: "hidden" },
        wrapper: { display: "flex" },
        wrapperInner: { width: "100%" },
      };
    },
    { name: "PwzrCollapse" }
  )(Sp);
  Q(),
    (_f = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.component,
        o = void 0 === i ? "div" : i,
        a = e.disableGutters,
        s = void 0 !== a && a,
        i = e.fixed,
        a = void 0 !== i && i,
        i = e.maxWidth,
        i = void 0 === i ? "lg" : i,
        e = xu(e, [
          "classes",
          "className",
          "component",
          "disableGutters",
          "fixed",
          "maxWidth",
        ]);
      return mh.createElement(
        o,
        Su(
          {
            className: Ph(
              n.root,
              r,
              a && n.fixed,
              s && n.disableGutters,
              !1 !== i && n["maxWidth".concat(ag(String(i)))]
            ),
            ref: t,
          },
          e
        )
      );
    })),
    Uh(
      function (r) {
        return {
          root: bu(
            {
              width: "100%",
              marginLeft: "auto",
              boxSizing: "border-box",
              marginRight: "auto",
              paddingLeft: r.spacing(2),
              paddingRight: r.spacing(2),
            },
            r.breakpoints.up("sm"),
            { paddingLeft: r.spacing(3), paddingRight: r.spacing(3) }
          ),
          disableGutters: { paddingLeft: 0, paddingRight: 0 },
          fixed: Object.keys(r.breakpoints.values).reduce(function (e, t) {
            var n = r.breakpoints.values[t];
            return 0 !== n && (e[r.breakpoints.up(t)] = { maxWidth: n }), e;
          }, {}),
          maxWidthXs: bu({}, r.breakpoints.up("xs"), {
            maxWidth: Math.max(r.breakpoints.values.xs, 444),
          }),
          maxWidthSm: bu({}, r.breakpoints.up("sm"), {
            maxWidth: r.breakpoints.values.sm,
          }),
          maxWidthMd: bu({}, r.breakpoints.up("md"), {
            maxWidth: r.breakpoints.values.md,
          }),
          maxWidthLg: bu({}, r.breakpoints.up("lg"), {
            maxWidth: r.breakpoints.values.lg,
          }),
          maxWidthXl: bu({}, r.breakpoints.up("xl"), {
            maxWidth: r.breakpoints.values.xl,
          }),
        };
      },
      { name: "PwzrContainer" }
    )(_f),
    Q();
  var jv = {
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
    boxSizing: "border-box",
  };
  Uh(
    function (e) {
      return {
        "@global": {
          html: jv,
          "*, *::before, *::after": { boxSizing: "inherit" },
          "strong, b": { fontWeight: e.typography.fontWeightBold },
          body: Su(
            { margin: 0 },
            Su({ color: (t = e).palette.text.primary }, t.typography.body2, {
              backgroundColor: t.palette.background.default,
              "@media print": { backgroundColor: t.palette.common.white },
            }),
            { "&::backdrop": { backgroundColor: e.palette.background.default } }
          ),
        },
      };
      var t;
    },
    { name: "PwzrCssBaseline" }
  )(function (e) {
    var t = void 0 === (t = e.children) ? null : t;
    return e.classes, mh.createElement(mh.Fragment, null, t);
  }),
    Q();
  var Hv = "undefined" != typeof window ? mh.useLayoutEffect : mh.useEffect,
    Vv = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.container,
        i = e.disablePortal,
        o = void 0 !== i && i,
        a = e.onRendered,
        e = mh.useState(null),
        s = e[0],
        l = e[1],
        e = Ig(mh.isValidElement(n) ? n.ref : null, t);
      return (
        Hv(
          function () {
            var e;
            o ||
              l(
                ((e = "function" == typeof (e = r) ? e() : e),
                zg.findDOMNode(e) || document.body)
              );
          },
          [r, o]
        ),
        Hv(
          function () {
            if (s && !o)
              return (
                Lg(t, s),
                function () {
                  Lg(t, null);
                }
              );
          },
          [t, s, o]
        ),
        Hv(
          function () {
            a && (s || o) && a();
          },
          [a, s, o]
        ),
        o
          ? mh.isValidElement(n)
            ? mh.cloneElement(n, { ref: e })
            : n
          : s && zg.createPortal(n, s)
      );
    });
  function qv() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return t.reduce(
      function (r, i) {
        return null == i
          ? r
          : function () {
              for (
                var e = arguments.length, t = new Array(e), n = 0;
                n < e;
                n++
              )
                t[n] = arguments[n];
              r.apply(this, t), i.apply(this, t);
            };
      },
      function () {}
    );
  }
  function Uv() {
    var e = document.createElement("div");
    (e.style.width = "99px"),
      (e.style.height = "99px"),
      (e.style.position = "absolute"),
      (e.style.top = "-9999px"),
      (e.style.overflow = "scroll"),
      document.body.appendChild(e);
    var t = e.offsetWidth - e.clientWidth;
    return document.body.removeChild(e), t;
  }
  function Gv(e) {
    return Fv(e).defaultView || window;
  }
  function Yv(e, t) {
    t
      ? e.setAttribute("aria-hidden", "true")
      : e.removeAttribute("aria-hidden");
  }
  function Xv(e) {
    return parseInt(window.getComputedStyle(e)["padding-right"], 10) || 0;
  }
  function Kv(e, t, n, r, i) {
    var o = 3 < arguments.length && void 0 !== r ? r : [],
      a = 4 < arguments.length ? i : void 0,
      s = [t, n].concat(Mf(o)),
      l = ["TEMPLATE", "SCRIPT", "STYLE"];
    [].forEach.call(e.children, function (e) {
      1 === e.nodeType &&
        -1 === s.indexOf(e) &&
        -1 === l.indexOf(e.tagName) &&
        Yv(e, a);
    });
  }
  function Zv(e, n) {
    var r = -1;
    return (
      e.some(function (e, t) {
        return !!n(e) && ((r = t), !0);
      }),
      r
    );
  }
  function Qv() {
    (function (e) {
      if (!(e instanceof Qv))
        throw new TypeError("Cannot call a class as a function");
    })(this),
      (this.modals = []),
      (this.containers = []);
  }
  function Jv(e) {
    var t = e.children,
      n = e.disableAutoFocus,
      i = void 0 !== n && n,
      n = e.disableEnforceFocus,
      o = void 0 !== n && n,
      n = e.disableRestoreFocus,
      a = void 0 !== n && n,
      r = e.getDoc,
      s = e.isEnabled,
      l = e.open,
      c = mh.useRef(),
      u = mh.useRef(null),
      d = mh.useRef(null),
      p = mh.useRef(),
      f = mh.useRef(null),
      e = mh.useCallback(function (e) {
        f.current = zg.findDOMNode(e);
      }, []),
      e = Ig(t.ref, e);
    return (
      mh.useMemo(
        function () {
          l && "undefined" != typeof window && (p.current = r().activeElement);
        },
        [l]
      ),
      mh.useEffect(
        function () {
          if (l) {
            var t = Fv(f.current);
            i ||
              !f.current ||
              f.current.contains(t.activeElement) ||
              (f.current.hasAttribute("tabIndex") ||
                f.current.setAttribute("tabIndex", -1),
              f.current.focus());
            function e() {
              o || !s() || c.current
                ? (c.current = !1)
                : f.current &&
                  !f.current.contains(t.activeElement) &&
                  f.current.focus();
            }
            function n(e) {
              !o &&
                s() &&
                9 === e.keyCode &&
                t.activeElement === f.current &&
                ((c.current = !0), (e.shiftKey ? d : u).current.focus());
            }
            t.addEventListener("focus", e, !0),
              t.addEventListener("keydown", n, !0);
            var r = setInterval(function () {
              e();
            }, 50);
            return function () {
              clearInterval(r),
                t.removeEventListener("focus", e, !0),
                t.removeEventListener("keydown", n, !0),
                a ||
                  (p.current && p.current.focus && p.current.focus(),
                  (p.current = null));
            };
          }
        },
        [i, o, a, s, l]
      ),
      mh.createElement(
        mh.Fragment,
        null,
        mh.createElement("div", {
          tabIndex: 0,
          ref: u,
          "data-test": "sentinelStart",
        }),
        mh.cloneElement(t, { ref: e }),
        mh.createElement("div", {
          tabIndex: 0,
          ref: d,
          "data-test": "sentinelEnd",
        })
      )
    );
  }
  Q(),
    Hd(Qv, [
      {
        key: "add",
        value: function (e, t) {
          var n = this.modals.indexOf(e);
          if (-1 !== n) return n;
          (n = this.modals.length),
            this.modals.push(e),
            e.modalRef && Yv(e.modalRef, !1);
          var r,
            i =
              ((r = []),
              [].forEach.call(t.children, function (e) {
                e.getAttribute &&
                  "true" === e.getAttribute("aria-hidden") &&
                  r.push(e);
              }),
              r);
          Kv(t, e.mountNode, e.modalRef, i, !0);
          var o = Zv(this.containers, function (e) {
            return e.container === t;
          });
          return (
            -1 !== o
              ? this.containers[o].modals.push(e)
              : this.containers.push({
                  modals: [e],
                  container: t,
                  restore: null,
                  hiddenSiblingNodes: i,
                }),
            n
          );
        },
      },
      {
        key: "mount",
        value: function (t, e) {
          var n,
            r,
            i,
            o,
            a = Zv(this.containers, function (e) {
              return -1 !== e.modals.indexOf(t);
            }),
            a = this.containers[a];
          a.restore ||
            (a.restore =
              ((e = e),
              (i = []),
              (o = []),
              (a = (a = a).container),
              e.disableScrollLock ||
                (((e = Fv(a)).body === a
                  ? Gv(e).innerWidth > e.documentElement.clientWidth
                  : a.scrollHeight > a.clientHeight) &&
                  ((r = Uv()),
                  i.push({
                    value: a.style.paddingRight,
                    key: "padding-right",
                    el: a,
                  }),
                  (a.style["padding-right"] = "".concat(Xv(a) + r, "px")),
                  (n = Fv(a).querySelectorAll(".mui-fixed")),
                  [].forEach.call(n, function (e) {
                    o.push(e.style.paddingRight),
                      (e.style.paddingRight = "".concat(Xv(e) + r, "px"));
                  })),
                (a =
                  "HTML" === (e = a.parentElement).nodeName &&
                  "scroll" === window.getComputedStyle(e)["overflow-y"]
                    ? e
                    : a),
                i.push({ value: a.style.overflow, key: "overflow", el: a }),
                (a.style.overflow = "hidden")),
              function () {
                n &&
                  [].forEach.call(n, function (e, t) {
                    o[t]
                      ? (e.style.paddingRight = o[t])
                      : e.style.removeProperty("padding-right");
                  }),
                  i.forEach(function (e) {
                    var t = e.value,
                      n = e.el,
                      e = e.key;
                    t ? n.style.setProperty(e, t) : n.style.removeProperty(e);
                  });
              }));
        },
      },
      {
        key: "remove",
        value: function (t) {
          var e = this.modals.indexOf(t);
          if (-1 === e) return e;
          var n = Zv(this.containers, function (e) {
              return -1 !== e.modals.indexOf(t);
            }),
            r = this.containers[n];
          return (
            r.modals.splice(r.modals.indexOf(t), 1),
            this.modals.splice(e, 1),
            0 === r.modals.length
              ? (r.restore && r.restore(),
                t.modalRef && Yv(t.modalRef, !0),
                Kv(
                  r.container,
                  t.mountNode,
                  t.modalRef,
                  r.hiddenSiblingNodes,
                  !1
                ),
                this.containers.splice(n, 1))
              : (r = r.modals[r.modals.length - 1]).modalRef &&
                Yv(r.modalRef, !1),
            e
          );
        },
      },
      {
        key: "isTopModal",
        value: function (e) {
          return (
            0 < this.modals.length && this.modals[this.modals.length - 1] === e
          );
        },
      },
    ]),
    (xp = Qv),
    Q(),
    Q();
  var ey = {
      root: {
        zIndex: -1,
        position: "fixed",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent",
      },
      invisible: { backgroundColor: "transparent" },
    },
    ty = mh.forwardRef(function (e, t) {
      var n = e.invisible,
        r = void 0 !== n && n,
        n = e.open,
        e = xu(e, ["invisible", "open"]);
      return n
        ? mh.createElement(
            "div",
            Su({ "aria-hidden": !0, ref: t }, e, {
              style: Su({}, ey.root, {}, r ? ey.invisible : {}, {}, e.style),
            })
          )
        : null;
    }),
    ny = new xp(),
    ry = mh.forwardRef(function (e, t) {
      function n() {
        return Fv(M.current);
      }
      function r() {
        return (
          (R.current.modalRef = N.current),
          (R.current.mountNode = M.current),
          R.current
        );
      }
      function i() {
        S.mount(r(), { disableScrollLock: E }), (N.current.scrollTop = 0);
      }
      var o = wh(),
        a = Bd({ name: "PwzrModal", props: Su({}, e), theme: o }),
        s = a.BackdropComponent,
        l = void 0 === s ? ty : s,
        c = a.BackdropProps,
        u = a.children,
        d = a.closeAfterTransition,
        p = void 0 !== d && d,
        f = a.container,
        h = a.disableAutoFocus,
        m = void 0 !== h && h,
        g = a.disableBackdropClick,
        v = void 0 !== g && g,
        y = a.disableEnforceFocus,
        b = void 0 !== y && y,
        w = a.disableEscapeKeyDown,
        x = void 0 !== w && w,
        e = a.disablePortal,
        s = void 0 !== e && e,
        d = a.disableRestoreFocus,
        h = void 0 !== d && d,
        g = a.disableScrollLock,
        E = void 0 !== g && g,
        y = a.hideBackdrop,
        w = void 0 !== y && y,
        e = a.keepMounted,
        d = void 0 !== e && e,
        g = a.manager,
        S = void 0 === g ? ny : g,
        C = a.onBackdropClick,
        k = a.onClose,
        T = a.onEscapeKeyDown,
        P = a.onRendered,
        z = a.open,
        y = xu(a, [
          "BackdropComponent",
          "BackdropProps",
          "children",
          "closeAfterTransition",
          "container",
          "disableAutoFocus",
          "disableBackdropClick",
          "disableEnforceFocus",
          "disableEscapeKeyDown",
          "disablePortal",
          "disableRestoreFocus",
          "disableScrollLock",
          "hideBackdrop",
          "keepMounted",
          "manager",
          "onBackdropClick",
          "onClose",
          "onEscapeKeyDown",
          "onRendered",
          "open",
        ]),
        e = mh.useState(!0),
        g = e[0],
        O = e[1],
        R = mh.useRef({}),
        M = mh.useRef(null),
        N = mh.useRef(null),
        t = Ig(N, t),
        L = !!a.children && a.children.props.hasOwnProperty("in"),
        I = jg(function () {
          var e,
            e =
              ((e = "function" == typeof (e = f) ? e() : e),
              zg.findDOMNode(e) || n().body);
          S.add(r(), e), N.current && i();
        }),
        _ = mh.useCallback(
          function () {
            return S.isTopModal(r());
          },
          [S]
        ),
        a = jg(function (e) {
          (M.current = e) && (P && P(), z && _() ? i() : Yv(N.current, !0));
        }),
        D = mh.useCallback(
          function () {
            S.remove(r());
          },
          [S]
        );
      if (
        (mh.useEffect(
          function () {
            return function () {
              D();
            };
          },
          [D]
        ),
        mh.useEffect(
          function () {
            z ? I() : (L && p) || D();
          },
          [z, D, L, p, I]
        ),
        !d && !z && (!L || g))
      )
        return null;
      (d = {
        root: {
          position: "fixed",
          zIndex: (o || { zIndex: _d }).zIndex.modal,
          right: 0,
          bottom: 0,
          top: 0,
          left: 0,
        },
        hidden: { visibility: "hidden" },
      }),
        (o = {});
      return (
        void 0 === u.props.tabIndex && (o.tabIndex = u.props.tabIndex || "-1"),
        L &&
          ((o.onEnter = qv(function () {
            O(!1);
          }, u.props.onEnter)),
          (o.onExited = qv(function () {
            O(!0), p && D();
          }, u.props.onExited))),
        mh.createElement(
          Vv,
          { ref: a, container: f, disablePortal: s },
          mh.createElement(
            "div",
            Su(
              {
                ref: t,
                onKeyDown: function (e) {
                  "Escape" === e.key &&
                    _() &&
                    (e.stopPropagation(),
                    T && T(e),
                    !x && k && k(e, "escapeKeyDown"));
                },
                role: "presentation",
              },
              y,
              {
                style: Su({}, d.root, {}, !z && g ? d.hidden : {}, {}, y.style),
              }
            ),
            w
              ? null
              : mh.createElement(
                  l,
                  Su(
                    {
                      open: z,
                      onClick: function (e) {
                        e.target === e.currentTarget &&
                          (C && C(e), !v && k && k(e, "backdropClick"));
                      },
                    },
                    c
                  )
                ),
            mh.createElement(
              Jv,
              {
                disableEnforceFocus: b,
                disableAutoFocus: m,
                disableRestoreFocus: h,
                getDoc: n,
                isEnabled: _,
                open: z,
              },
              mh.cloneElement(u, o)
            )
          )
        )
      );
    });
  Q();
  var iy = { enter: Nd.enteringScreen, exit: Nd.leavingScreen },
    Yu = mh.forwardRef(function (e, t) {
      var n = e.BackdropProps,
        r = e.children,
        i = e.classes,
        o = e.className,
        a = e.disableBackdropClick,
        s = void 0 !== a && a,
        l = e.disableEscapeKeyDown,
        c = void 0 !== l && l,
        u = e.fullScreen,
        d = void 0 !== u && u,
        p = e.fullWidth,
        f = void 0 !== p && p,
        h = e.maxWidth,
        m = void 0 === h ? "sm" : h,
        g = e.onBackdropClick,
        v = e.onClose,
        y = e.onEnter,
        b = e.onEntered,
        w = e.onEntering,
        x = e.onEscapeKeyDown,
        E = e.onExit,
        S = e.onExited,
        C = e.onExiting,
        k = e.open,
        T = e.PaperComponent,
        P = void 0 === T ? mg : T,
        z = e.PaperProps,
        a = void 0 === z ? {} : z,
        l = e.scroll,
        u = void 0 === l ? "paper" : l,
        p = e.TransitionComponent,
        h = void 0 === p ? Ag : p,
        T = e.transitionDuration,
        z = void 0 === T ? iy : T,
        l = e.TransitionProps,
        p = e["aria-describedby"],
        T = e["aria-labelledby"],
        e = xu(e, [
          "BackdropProps",
          "children",
          "classes",
          "className",
          "disableBackdropClick",
          "disableEscapeKeyDown",
          "fullScreen",
          "fullWidth",
          "maxWidth",
          "onBackdropClick",
          "onClose",
          "onEnter",
          "onEntered",
          "onEntering",
          "onEscapeKeyDown",
          "onExit",
          "onExited",
          "onExiting",
          "open",
          "PaperComponent",
          "PaperProps",
          "scroll",
          "TransitionComponent",
          "transitionDuration",
          "TransitionProps",
          "aria-describedby",
          "aria-labelledby",
        ]),
        O = mh.useRef();
      return mh.createElement(
        ry,
        Su(
          {
            className: Ph(i.root, o),
            BackdropComponent: Fg,
            BackdropProps: Su({ transitionDuration: z }, n),
            closeAfterTransition: !0,
            disableBackdropClick: s,
            disableEscapeKeyDown: c,
            onEscapeKeyDown: x,
            onClose: v,
            open: k,
            ref: t,
          },
          e
        ),
        mh.createElement(
          h,
          Su(
            {
              appear: !0,
              in: k,
              timeout: z,
              onEnter: y,
              onEntering: w,
              onEntered: b,
              onExit: E,
              onExiting: C,
              onExited: S,
              role: "none presentation",
            },
            l
          ),
          mh.createElement(
            "div",
            {
              className: Ph(i.container, i["scroll".concat(ag(u))]),
              onClick: function (e) {
                e.target === e.currentTarget &&
                  e.target === O.current &&
                  ((O.current = null),
                  g && g(e),
                  !s && v && v(e, "backdropClick"));
              },
              onMouseDown: function (e) {
                O.current = e.target;
              },
            },
            mh.createElement(
              P,
              Su(
                {
                  elevation: 24,
                  role: "dialog",
                  "aria-describedby": p,
                  "aria-labelledby": T,
                },
                a,
                {
                  className: Ph(
                    i.paper,
                    i["paperScroll".concat(ag(u))],
                    i["paperWidth".concat(ag(String(m)))],
                    a.className,
                    d && i.paperFullScreen,
                    f && i.paperFullWidth
                  ),
                }
              ),
              r
            )
          )
        )
      );
    });
  function oy(i, e) {
    var o,
      a = 1 < arguments.length && void 0 !== e ? e : 166;
    function t() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
        t[n] = arguments[n];
      var r = this;
      clearTimeout(o),
        (o = setTimeout(function () {
          i.apply(r, t);
        }, a));
    }
    return (
      (t.clear = function () {
        clearTimeout(o);
      }),
      t
    );
  }
  function ay(e, t) {
    var n,
      r,
      i,
      o,
      a,
      e =
        ((n = e),
        (o = (r = t).getBoundingClientRect()),
        (e = a = 0),
        (i =
          r.fakeTransform ||
          (i = window.getComputedStyle(r)).getPropertyValue(
            "-webkit-transform"
          ) ||
          i.getPropertyValue("transform")) &&
          "none" !== i &&
          "string" == typeof i &&
          ((i = i.split("(")[1].split(")")[0].split(",")),
          (a = parseInt(i[4], 10)),
          (e = parseInt(i[5], 10))),
        "left" === n
          ? "translateX("
              .concat(window.innerWidth, "px) translateX(-")
              .concat(o.left - a, "px)")
          : "right" === n
          ? "translateX(-".concat(o.left + o.width - a, "px)")
          : "up" === n
          ? "translateY("
              .concat(window.innerHeight, "px) translateY(-")
              .concat(o.top - e, "px)")
          : "translateY(-".concat(o.top + o.height - e, "px)"));
    e && ((t.style.webkitTransform = e), (t.style.transform = e));
  }
  Uh(
    function (e) {
      return {
        root: { "@media print": { position: "absolute !important" } },
        scrollPaper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        scrollBody: {
          overflowY: "auto",
          overflowX: "hidden",
          textAlign: "center",
          "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0",
          },
        },
        container: {
          height: "100%",
          "@media print": { height: "auto" },
          outline: 0,
        },
        paper: {
          margin: 32,
          position: "relative",
          overflowY: "auto",
          "@media print": { overflowY: "visible", boxShadow: "none" },
        },
        paperScrollPaper: {
          display: "flex",
          flexDirection: "column",
          maxHeight: "calc(100% - 64px)",
        },
        paperScrollBody: {
          display: "inline-block",
          verticalAlign: "middle",
          textAlign: "left",
        },
        paperWidthFalse: { maxWidth: "calc(100% - 64px)" },
        paperWidthXs: {
          maxWidth: Math.max(e.breakpoints.values.xs, 444),
          "&$paperScrollBody": bu(
            {},
            e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 64),
            { maxWidth: "calc(100% - 64px)" }
          ),
        },
        paperWidthSm: {
          maxWidth: e.breakpoints.values.sm,
          "&$paperScrollBody": bu(
            {},
            e.breakpoints.down(e.breakpoints.values.sm + 64),
            { maxWidth: "calc(100% - 64px)" }
          ),
        },
        paperWidthMd: {
          maxWidth: e.breakpoints.values.md,
          "&$paperScrollBody": bu(
            {},
            e.breakpoints.down(e.breakpoints.values.md + 64),
            { maxWidth: "calc(100% - 64px)" }
          ),
        },
        paperWidthLg: {
          maxWidth: e.breakpoints.values.lg,
          "&$paperScrollBody": bu(
            {},
            e.breakpoints.down(e.breakpoints.values.lg + 64),
            { maxWidth: "calc(100% - 64px)" }
          ),
        },
        paperWidthXl: {
          maxWidth: e.breakpoints.values.xl,
          "&$paperScrollBody": bu(
            {},
            e.breakpoints.down(e.breakpoints.values.xl + 64),
            { maxWidth: "calc(100% - 64px)" }
          ),
        },
        paperFullWidth: { width: "calc(100% - 64px)" },
        paperFullScreen: {
          margin: 0,
          width: "100%",
          maxWidth: "100%",
          height: "100%",
          maxHeight: "none",
          borderRadius: 0,
          "&$paperScrollBody": { margin: 0, maxWidth: "100%" },
        },
      };
    },
    { name: "PwzrDialog" }
  )(Yu),
    Q(),
    (If = mh.forwardRef(function (e, t) {
      var n = e.disableSpacing,
        r = void 0 !== n && n,
        i = e.classes,
        n = e.className,
        e = xu(e, ["disableSpacing", "classes", "className"]);
      return mh.createElement(
        "div",
        Su({ className: Ph(i.root, n, !r && i.spacing), ref: t }, e)
      );
    })),
    Uh(
      {
        root: {
          display: "flex",
          alignItems: "center",
          padding: 8,
          justifyContent: "flex-end",
          flex: "0 0 auto",
        },
        spacing: { "& > :not(:first-child)": { marginLeft: 8 } },
      },
      { name: "PwzrDialogActions" }
    )(If),
    Q(),
    (of = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.dividers,
        i = void 0 !== i && i,
        e = xu(e, ["classes", "className", "dividers"]);
      return mh.createElement(
        "div",
        Su({ className: Ph(n.root, r, i && n.dividers), ref: t }, e)
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            flex: "1 1 auto",
            WebkitOverflowScrolling: "touch",
            overflowY: "auto",
            padding: "8px 24px",
            "&:first-child": { paddingTop: 20 },
          },
          dividers: {
            padding: "16px 24px",
            borderTop: "1px solid ".concat(e.palette.divider),
            borderBottom: "1px solid ".concat(e.palette.divider),
          },
        };
      },
      { name: "PwzrDialogContent" }
    )(of),
    Q(),
    (vp = mh.forwardRef(function (e, t) {
      return mh.createElement(
        Cv,
        Su(
          { component: "p", variant: "body1", color: "textSecondary", ref: t },
          e
        )
      );
    })),
    Uh({ root: { marginBottom: 12 } }, { name: "PwzrDialogContentText" })(vp),
    Q(),
    (Sp = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.disableTypography,
        o = void 0 !== o && o,
        e = xu(e, ["children", "classes", "className", "disableTypography"]);
      return mh.createElement(
        "div",
        Su({ className: Ph(r.root, i), ref: t }, e),
        o ? n : mh.createElement(Cv, { component: "h2", variant: "h6" }, n)
      );
    })),
    Uh(
      { root: { margin: 0, padding: "16px 24px", flex: "0 0 auto" } },
      { name: "PwzrDialogTitle" }
    )(Sp),
    Q(),
    (_f = mh.forwardRef(function (e, t) {
      var n = e.absolute,
        r = void 0 !== n && n,
        i = e.classes,
        o = e.className,
        a = e.component,
        s = void 0 === a ? "hr" : a,
        l = e.flexItem,
        c = void 0 !== l && l,
        u = e.light,
        n = void 0 !== u && u,
        a = e.orientation,
        l = void 0 === a ? "horizontal" : a,
        u = e.role,
        a = void 0 === u ? ("hr" !== s ? "separator" : void 0) : u,
        u = e.variant,
        u = void 0 === u ? "fullWidth" : u,
        e = xu(e, [
          "absolute",
          "classes",
          "className",
          "component",
          "flexItem",
          "light",
          "orientation",
          "role",
          "variant",
        ]);
      return mh.createElement(
        s,
        Su(
          {
            className: Ph(
              i.root,
              o,
              "fullWidth" !== u && i[u],
              r && i.absolute,
              c && i.flexItem,
              n && i.light,
              "vertical" === l && i.vertical
            ),
            role: a,
            ref: t,
          },
          e
        )
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            height: 1,
            margin: 0,
            border: "none",
            flexShrink: 0,
            backgroundColor: e.palette.divider,
          },
          absolute: { position: "absolute", bottom: 0, left: 0, width: "100%" },
          inset: { marginLeft: 72 },
          light: { backgroundColor: gu(e.palette.divider, 0.08) },
          middle: { marginLeft: e.spacing(2), marginRight: e.spacing(2) },
          vertical: { height: "100%", width: 1 },
          flexItem: { alignSelf: "stretch", height: "auto" },
        };
      },
      { name: "PwzrDivider" }
    )(_f),
    Q();
  var sy = { enter: Nd.enteringScreen, exit: Nd.leavingScreen },
    ly = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.direction,
        i = void 0 === r ? "down" : r,
        o = e.in,
        a = e.onEnter,
        s = e.onEntering,
        l = e.onExit,
        c = e.onExited,
        u = e.style,
        r = e.timeout,
        d = void 0 === r ? sy : r,
        r = xu(e, [
          "children",
          "direction",
          "in",
          "onEnter",
          "onEntering",
          "onExit",
          "onExited",
          "style",
          "timeout",
        ]),
        p = qh(),
        f = mh.useRef(null),
        e = mh.useCallback(function (e) {
          f.current = zg.findDOMNode(e);
        }, []),
        e = Ig(n.ref, e),
        h = Ig(e, t),
        m = mh.useCallback(
          function () {
            f.current && ay(i, f.current);
          },
          [i]
        );
      return (
        mh.useEffect(
          function () {
            if (!o && "down" !== i && "right" !== i) {
              var e = oy(function () {
                f.current && ay(i, f.current);
              });
              return (
                window.addEventListener("resize", e),
                function () {
                  e.clear(), window.removeEventListener("resize", e);
                }
              );
            }
          },
          [i, o]
        ),
        mh.useEffect(
          function () {
            o || m();
          },
          [o, m]
        ),
        mh.createElement(
          Og,
          Su(
            {
              onEnter: function (e, t) {
                var n = f.current;
                ay(i, n), Mg(n), a && a(n, t);
              },
              onEntering: function (e, t) {
                var n = f.current,
                  r = Ng({ timeout: d, style: u }, { mode: "enter" });
                (n.style.webkitTransition = p.transitions.create(
                  "-webkit-transform",
                  Su({}, r, { easing: p.transitions.easing.easeOut })
                )),
                  (n.style.transition = p.transitions.create(
                    "transform",
                    Su({}, r, { easing: p.transitions.easing.easeOut })
                  )),
                  (n.style.webkitTransform = "none"),
                  (n.style.transform = "none"),
                  s && s(n, t);
              },
              onExit: function () {
                var e = f.current,
                  t = Ng({ timeout: d, style: u }, { mode: "exit" });
                (e.style.webkitTransition = p.transitions.create(
                  "-webkit-transform",
                  Su({}, t, { easing: p.transitions.easing.sharp })
                )),
                  (e.style.transition = p.transitions.create(
                    "transform",
                    Su({}, t, { easing: p.transitions.easing.sharp })
                  )),
                  ay(i, e),
                  l && l(e);
              },
              onExited: function () {
                var e = f.current;
                (e.style.webkitTransition = ""),
                  (e.style.transition = ""),
                  c && c(e);
              },
              appear: !0,
              in: o,
              timeout: d,
            },
            r
          ),
          function (e, t) {
            return mh.cloneElement(
              n,
              Su(
                {
                  ref: h,
                  style: Su(
                    { visibility: "exited" !== e || o ? void 0 : "hidden" },
                    u,
                    {},
                    n.props.style
                  ),
                },
                t
              )
            );
          }
        )
      );
    });
  Q();
  var cy = { left: "right", right: "left", top: "down", bottom: "up" };
  function uy(e) {
    return -1 !== ["left", "right"].indexOf(e);
  }
  function dy(e, t) {
    return "rtl" === e.direction && uy(t) ? cy[t] : t;
  }
  var py = { enter: Nd.enteringScreen, exit: Nd.leavingScreen },
    xp = mh.forwardRef(function (e, t) {
      var n = e.anchor,
        r = void 0 === n ? "left" : n,
        i = e.BackdropProps,
        o = e.children,
        a = e.classes,
        s = e.className,
        l = e.elevation,
        c = void 0 === l ? 16 : l,
        u = e.ModalProps,
        d = (u = void 0 === u ? {} : u).BackdropProps,
        p = xu(u, ["BackdropProps"]),
        f = e.onClose,
        h = e.open,
        m = void 0 !== h && h,
        g = e.PaperProps,
        n = void 0 === g ? {} : g,
        l = e.SlideProps,
        u = e.transitionDuration,
        h = void 0 === u ? py : u,
        g = e.variant,
        u = void 0 === g ? "temporary" : g,
        g = xu(e, [
          "anchor",
          "BackdropProps",
          "children",
          "classes",
          "className",
          "elevation",
          "ModalProps",
          "onClose",
          "open",
          "PaperProps",
          "SlideProps",
          "transitionDuration",
          "variant",
        ]),
        e = qh(),
        v = mh.useRef(!1);
      mh.useEffect(function () {
        v.current = !0;
      }, []);
      (r = dy(e, r)),
        (o = mh.createElement(
          mg,
          Su({ elevation: "temporary" === u ? c : 0, square: !0 }, n, {
            className: Ph(
              a.paper,
              a["paperAnchor".concat(ag(r))],
              n.className,
              "temporary" !== u && a["paperAnchorDocked".concat(ag(r))]
            ),
          }),
          o
        ));
      if ("permanent" === u)
        return mh.createElement(
          "div",
          Su({ className: Ph(a.root, a.docked, s), ref: t }, g),
          o
        );
      o = mh.createElement(
        ly,
        Su({ in: m, direction: cy[r], timeout: h, appear: v.current }, l),
        o
      );
      return "persistent" === u
        ? mh.createElement(
            "div",
            Su({ className: Ph(a.root, a.docked, s), ref: t }, g),
            o
          )
        : mh.createElement(
            ry,
            Su(
              {
                BackdropProps: Su({}, i, {}, d, { transitionDuration: h }),
                BackdropComponent: Fg,
                className: Ph(a.root, a.modal, s),
                open: m,
                onClose: f,
                ref: t,
              },
              g,
              p
            ),
            o
          );
    }),
    fy = Uh(
      function (e) {
        return {
          root: {},
          docked: { flex: "0 0 auto" },
          paper: {
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            flex: "1 0 auto",
            zIndex: e.zIndex.drawer,
            WebkitOverflowScrolling: "touch",
            position: "fixed",
            top: 0,
            outline: 0,
          },
          paperAnchorLeft: { left: 0, right: "auto" },
          paperAnchorRight: { left: "auto", right: 0 },
          paperAnchorTop: {
            top: 0,
            left: 0,
            bottom: "auto",
            right: 0,
            height: "auto",
            maxHeight: "100%",
          },
          paperAnchorBottom: {
            top: "auto",
            left: 0,
            bottom: 0,
            right: 0,
            height: "auto",
            maxHeight: "100%",
          },
          paperAnchorDockedLeft: {
            borderRight: "1px solid ".concat(e.palette.divider),
          },
          paperAnchorDockedTop: {
            borderBottom: "1px solid ".concat(e.palette.divider),
          },
          paperAnchorDockedRight: {
            borderLeft: "1px solid ".concat(e.palette.divider),
          },
          paperAnchorDockedBottom: {
            borderTop: "1px solid ".concat(e.palette.divider),
          },
          modal: {},
        };
      },
      { name: "PwzrDrawer", flip: !1 }
    )(xp);
  Q(), Q();
  var hy = mh.createContext({}),
    Yu = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.defaultExpanded,
        a = void 0 !== o && o,
        s = e.disabled,
        l = void 0 !== s && s,
        c = e.expanded,
        u = e.onChange,
        d = e.square,
        o = void 0 !== d && d,
        s = e.TransitionComponent,
        d = void 0 === s ? $v : s,
        s = e.TransitionProps,
        e = xu(e, [
          "children",
          "classes",
          "className",
          "defaultExpanded",
          "disabled",
          "expanded",
          "onChange",
          "square",
          "TransitionComponent",
          "TransitionProps",
        ]),
        c = hv(zv({ controlled: c, default: a, name: "ExpansionPanel" }), 2),
        p = c[0],
        f = c[1],
        h = mh.useCallback(
          function (e) {
            f(!p), u && u(e, !p);
          },
          [p, u, f]
        ),
        c = pv((a = mh.Children.toArray(n))) || Rf(a) || fv(),
        n = c[0],
        a = c.slice(1),
        c = mh.useMemo(
          function () {
            return { expanded: p, disabled: l, toggle: h };
          },
          [p, l, h]
        );
      return mh.createElement(
        mg,
        Su(
          {
            className: Ph(
              r.root,
              i,
              p && r.expanded,
              l && r.disabled,
              !o && r.rounded
            ),
            ref: t,
            square: o,
          },
          e
        ),
        mh.createElement(hy.Provider, { value: c }, n),
        mh.createElement(
          d,
          Su({ in: p, timeout: "auto" }, s),
          mh.createElement(
            "div",
            {
              "aria-labelledby": n.props.id,
              id: n.props["aria-controls"],
              role: "region",
            },
            a
          )
        )
      );
    });
  function my(e) {
    var n = e.props,
      t = e.states,
      r = e.muiFormControl;
    return t.reduce(function (e, t) {
      return (e[t] = n[t]), r && void 0 === n[t] && (e[t] = r[t]), e;
    }, {});
  }
  function gy(e, t) {
    return parseInt(e[t], 10) || 0;
  }
  Uh(
    function (e) {
      var t = { duration: e.transitions.duration.shortest };
      return {
        root: {
          position: "relative",
          transition: e.transitions.create(["margin"], t),
          "&:before": {
            position: "absolute",
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: e.palette.divider,
            transition: e.transitions.create(
              ["opacity", "background-color"],
              t
            ),
          },
          "&:first-child": { "&:before": { display: "none" } },
          "&$expanded": {
            margin: "16px 0",
            "&:first-child": { marginTop: 0 },
            "&:last-child": { marginBottom: 0 },
            "&:before": { opacity: 0 },
          },
          "&$expanded + &": { "&:before": { display: "none" } },
          "&$disabled": {
            backgroundColor: e.palette.action.disabledBackground,
          },
        },
        rounded: {
          borderRadius: 0,
          "&:first-child": {
            borderTopLeftRadius: e.shape.borderRadius,
            borderTopRightRadius: e.shape.borderRadius,
          },
          "&:last-child": {
            borderBottomLeftRadius: e.shape.borderRadius,
            borderBottomRightRadius: e.shape.borderRadius,
            "@supports (-ms-ime-align: auto)": {
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
            },
          },
        },
        expanded: {},
        disabled: {},
      };
    },
    { name: "PwzrExpansionPanel" }
  )(Yu),
    Q(),
    (If = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.disableSpacing,
        i = void 0 !== i && i,
        e = xu(e, ["classes", "className", "disableSpacing"]);
      return mh.createElement(
        "div",
        Su({ className: Ph(n.root, r, !i && n.spacing), ref: t }, e)
      );
    })),
    Uh(
      {
        root: {
          display: "flex",
          alignItems: "center",
          padding: 8,
          justifyContent: "flex-end",
        },
        spacing: { "& > :not(:first-child)": { marginLeft: 8 } },
      },
      { name: "PwzrExpansionPanelActions" }
    )(If),
    Q(),
    (of = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        e = xu(e, ["classes", "className"]);
      return mh.createElement(
        "div",
        Su({ className: Ph(n.root, r), ref: t }, e)
      );
    })),
    Uh(
      { root: { display: "flex", padding: "8px 24px 24px" } },
      { name: "PwzrExpansionPanelDetails" }
    )(of),
    Q(),
    (vp = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.expandIcon,
        a = e.IconButtonProps,
        s = e.onBlur,
        l = e.onClick,
        c = e.onFocusVisible,
        u = xu(e, [
          "children",
          "classes",
          "className",
          "expandIcon",
          "IconButtonProps",
          "onBlur",
          "onClick",
          "onFocusVisible",
        ]),
        d = mh.useState(!1),
        p = d[0],
        f = d[1],
        h = mh.useContext(hy),
        e = h.disabled,
        d = void 0 !== e && e,
        e = h.expanded,
        m = h.toggle;
      return mh.createElement(
        nv,
        Su(
          {
            focusRipple: !1,
            disableRipple: !0,
            disabled: d,
            component: "div",
            "aria-expanded": e,
            className: Ph(
              r.root,
              i,
              d && r.disabled,
              e && r.expanded,
              p && r.focused
            ),
            onFocusVisible: function (e) {
              f(!0), c && c(e);
            },
            onBlur: function (e) {
              f(!1), s && s(e);
            },
            onClick: function (e) {
              m && m(e), l && l(e);
            },
            ref: t,
          },
          u
        ),
        mh.createElement(
          "div",
          { className: Ph(r.content, e && r.expanded) },
          n
        ),
        o &&
          mh.createElement(
            Nv,
            Su(
              {
                className: Ph(r.expandIcon, e && r.expanded),
                edge: "end",
                component: "div",
                tabIndex: null,
                role: null,
                "aria-hidden": !0,
              },
              a
            ),
            o
          )
      );
    })),
    Uh(
      function (e) {
        var t = { duration: e.transitions.duration.shortest };
        return {
          root: {
            display: "flex",
            minHeight: 48,
            transition: e.transitions.create(
              ["min-height", "background-color"],
              t
            ),
            padding: "0 24px 0 24px",
            "&:hover:not($disabled)": { cursor: "pointer" },
            "&$expanded": { minHeight: 64 },
            "&$focused": { backgroundColor: e.palette.grey[300] },
            "&$disabled": { opacity: 0.38 },
          },
          expanded: {},
          focused: {},
          disabled: {},
          content: {
            display: "flex",
            flexGrow: 1,
            transition: e.transitions.create(["margin"], t),
            margin: "12px 0",
            "&$expanded": { margin: "20px 0" },
          },
          expandIcon: {
            transform: "rotate(0deg)",
            transition: e.transitions.create("transform", t),
            "&:hover": { backgroundColor: "transparent" },
            "&$expanded": { transform: "rotate(180deg)" },
          },
        };
      },
      { name: "PwzrExpansionPanelSummary" }
    )(vp),
    Q(),
    (Sp = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.color,
        a = void 0 === o ? "default" : o,
        s = e.component,
        l = void 0 === s ? "button" : s,
        c = e.disabled,
        u = void 0 !== c && c,
        d = e.disableFocusRipple,
        o = void 0 !== d && d,
        s = e.focusVisibleClassName,
        c = e.size,
        d = void 0 === c ? "large" : c,
        c = e.variant,
        c = void 0 === c ? "round" : c,
        e = xu(e, [
          "children",
          "classes",
          "className",
          "color",
          "component",
          "disabled",
          "disableFocusRipple",
          "focusVisibleClassName",
          "size",
          "variant",
        ]);
      return mh.createElement(
        nv,
        Su(
          {
            className: Ph(
              r.root,
              i,
              "round" !== c && r.extended,
              "large" !== d && r["size".concat(ag(d))],
              u && r.disabled,
              {
                primary: r.primary,
                secondary: r.secondary,
                inherit: r.colorInherit,
              }[a]
            ),
            component: l,
            disabled: u,
            focusRipple: !o,
            focusVisibleClassName: Ph(r.focusVisible, s),
            ref: t,
          },
          e
        ),
        mh.createElement("span", { className: r.label }, n)
      );
    })),
    Uh(
      function (e) {
        return {
          root: Su({}, e.typography.button, {
            boxSizing: "border-box",
            minHeight: 36,
            transition: e.transitions.create(
              ["background-color", "box-shadow", "border"],
              { duration: e.transitions.duration.short }
            ),
            borderRadius: "50%",
            padding: 0,
            minWidth: 0,
            width: 56,
            height: 56,
            boxShadow: e.shadows[6],
            "&:active": { boxShadow: e.shadows[12] },
            color: e.palette.getContrastText(e.palette.grey[300]),
            backgroundColor: e.palette.grey[300],
            "&:hover": {
              backgroundColor: e.palette.grey.A100,
              "@media (hover: none)": { backgroundColor: e.palette.grey[300] },
              "&$disabled": {
                backgroundColor: e.palette.action.disabledBackground,
              },
              textDecoration: "none",
            },
            "&$focusVisible": { boxShadow: e.shadows[6] },
            "&$disabled": {
              color: e.palette.action.disabled,
              boxShadow: e.shadows[0],
              backgroundColor: e.palette.action.disabledBackground,
            },
          }),
          label: {
            width: "100%",
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit",
          },
          primary: {
            color: e.palette.primary.contrastText,
            backgroundColor: e.palette.primary.main,
            "&:hover": {
              backgroundColor: e.palette.primary.dark,
              "@media (hover: none)": {
                backgroundColor: e.palette.primary.main,
              },
            },
          },
          secondary: {
            color: e.palette.secondary.contrastText,
            backgroundColor: e.palette.secondary.main,
            "&:hover": {
              backgroundColor: e.palette.secondary.dark,
              "@media (hover: none)": {
                backgroundColor: e.palette.secondary.main,
              },
            },
          },
          extended: {
            borderRadius: 24,
            padding: "0 16px",
            width: "auto",
            minHeight: "auto",
            minWidth: 48,
            height: 48,
            "&$sizeSmall": {
              width: "auto",
              padding: "0 8px",
              borderRadius: 17,
              minWidth: 34,
              height: 34,
            },
            "&$sizeMedium": {
              width: "auto",
              padding: "0 16px",
              borderRadius: 20,
              minWidth: 40,
              height: 40,
            },
          },
          focusVisible: {},
          disabled: {},
          colorInherit: { color: "inherit" },
          sizeSmall: { width: 40, height: 40 },
          sizeMedium: { width: 48, height: 48 },
        };
      },
      { name: "PwzrFab" }
    )(Sp),
    Q();
  var vy = "undefined" != typeof window ? mh.useLayoutEffect : mh.useEffect,
    yy = {
      visibility: "hidden",
      position: "absolute",
      overflow: "hidden",
      height: 0,
      top: 0,
      left: 0,
      transform: "translateZ(0)",
    },
    by = mh.forwardRef(function (l, e) {
      var t = l.onChange,
        n = l.rows,
        c = l.rowsMax,
        r = l.rowsMin,
        i = void 0 === r ? 1 : r,
        o = l.style,
        a = l.value,
        r = xu(l, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]),
        u = n || i,
        s = mh.useRef(null != a).current,
        d = mh.useRef(null),
        n = Ig(e, d),
        p = mh.useRef(null),
        i = mh.useState({}),
        e = i[0],
        f = i[1],
        h = mh.useCallback(
          function () {
            var e = d.current,
              t = window.getComputedStyle(e),
              n = p.current;
            (n.style.width = t.width),
              (n.value = e.value || l.placeholder || "x");
            var r = t["box-sizing"],
              i = gy(t, "padding-bottom") + gy(t, "padding-top"),
              o = gy(t, "border-bottom-width") + gy(t, "border-top-width"),
              e = n.scrollHeight - i;
            n.value = "x";
            (t = n.scrollHeight - i), (n = e);
            u && (n = Math.max(Number(u) * t, n)),
              c && (n = Math.min(Number(c) * t, n));
            var a = (n = Math.max(n, t)) + ("border-box" === r ? i + o : 0),
              s = Math.abs(n - e) <= 1;
            f(function (e) {
              return (0 < a && 1 < Math.abs((e.outerHeightStyle || 0) - a)) ||
                e.overflow !== s
                ? { overflow: s, outerHeightStyle: a }
                : e;
            });
          },
          [c, u, l.placeholder]
        );
      return (
        mh.useEffect(
          function () {
            var e = oy(function () {
              h();
            });
            return (
              window.addEventListener("resize", e),
              function () {
                e.clear(), window.removeEventListener("resize", e);
              }
            );
          },
          [h]
        ),
        vy(function () {
          h();
        }),
        mh.createElement(
          mh.Fragment,
          null,
          mh.createElement(
            "textarea",
            Su(
              {
                value: a,
                onChange: function (e) {
                  s || h(), t && t(e);
                },
                ref: n,
                rows: u,
                style: Su(
                  {
                    height: e.outerHeightStyle,
                    overflow: e.overflow ? "hidden" : null,
                  },
                  o
                ),
              },
              r
            )
          ),
          mh.createElement("textarea", {
            "aria-hidden": !0,
            className: l.className,
            readOnly: !0,
            ref: p,
            tabIndex: -1,
            style: Su({}, yy, {}, o),
          })
        )
      );
    });
  function wy(e) {
    return null != e && !(Array.isArray(e) && 0 === e.length);
  }
  function xy(e, t) {
    var n = 1 < arguments.length && void 0 !== t && t;
    return (
      e &&
      ((wy(e.value) && "" !== e.value) ||
        (n && wy(e.defaultValue) && "" !== e.defaultValue))
    );
  }
  Q();
  var Ey = "undefined" == typeof window ? mh.useEffect : mh.useLayoutEffect,
    _f = mh.forwardRef(function (e, t) {
      var n = e["aria-describedby"],
        r = e.autoComplete,
        i = e.autoFocus,
        o = e.classes,
        a = e.className,
        s = (e.color, e.defaultValue),
        l = e.disabled,
        c = e.endAdornment,
        u = (e.error, e.fullWidth),
        d = void 0 !== u && u,
        p = e.id,
        f = e.inputComponent,
        h = void 0 === f ? "input" : f,
        m = e.inputProps,
        g = void 0 === m ? {} : m,
        v = e.inputRef,
        y = (e.margin, e.multiline),
        b = void 0 !== y && y,
        w = e.name,
        x = e.onBlur,
        E = e.onChange,
        S = e.onClick,
        C = e.onFocus,
        k = e.onKeyDown,
        T = e.onKeyUp,
        P = e.placeholder,
        z = e.readOnly,
        O = e.renderSuffix,
        R = e.rows,
        M = e.rowsMax,
        u = e.rowsMin,
        N = e.startAdornment,
        f = e.type,
        m = void 0 === f ? "text" : f,
        y = e.value,
        f = xu(e, [
          "aria-describedby",
          "autoComplete",
          "autoFocus",
          "classes",
          "className",
          "color",
          "defaultValue",
          "disabled",
          "endAdornment",
          "error",
          "fullWidth",
          "id",
          "inputComponent",
          "inputProps",
          "inputRef",
          "margin",
          "multiline",
          "name",
          "onBlur",
          "onChange",
          "onClick",
          "onFocus",
          "onKeyDown",
          "onKeyUp",
          "placeholder",
          "readOnly",
          "renderSuffix",
          "rows",
          "rowsMax",
          "rowsMin",
          "startAdornment",
          "type",
          "value",
        ]),
        L = null != g.value ? g.value : y,
        I = mh.useRef(null != L).current,
        _ = mh.useRef(),
        y = mh.useCallback(function (e) {}, []),
        y = Ig(g.ref, y),
        v = Ig(v, y),
        y = Ig(_, v),
        v = mh.useState(!1),
        D = v[0],
        A = v[1],
        F = Rv(),
        B = my({
          props: e,
          muiFormControl: F,
          states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "margin",
            "required",
            "filled",
          ],
        });
      (B.focused = F ? F.focused : D),
        mh.useEffect(
          function () {
            !F && l && D && (A(!1), x && x());
          },
          [F, l, D, x]
        );
      var W = F && F.onFilled,
        $ = F && F.onEmpty,
        j = mh.useCallback(
          function (e) {
            xy(e) ? W && W() : $ && $();
          },
          [W, $]
        );
      Ey(
        function () {
          I && j({ value: L });
        },
        [L, j, I]
      ),
        mh.useEffect(function () {
          j(_.current);
        }, []);
      (e = h), (h = Su({}, g, { ref: y }));
      return (
        "string" != typeof e
          ? (h = Su({ inputRef: y, type: m }, h, { ref: null }))
          : b
          ? (e =
              !R || M || u
                ? ((h = Su({ rows: R, rowsMax: M }, h)), by)
                : "textarea")
          : (h = Su({ type: m }, h)),
        mh.useEffect(
          function () {
            F && F.setAdornedStart(Boolean(N));
          },
          [F, N]
        ),
        mh.createElement(
          "div",
          Su(
            {
              className: Ph(
                o.root,
                o["color".concat(ag(B.color || "primary"))],
                a,
                B.disabled && o.disabled,
                B.error && o.error,
                d && o.fullWidth,
                B.focused && o.focused,
                F && o.formControl,
                b && o.multiline,
                N && o.adornedStart,
                c && o.adornedEnd,
                "dense" === B.margin && o.marginDense
              ),
              onClick: function (e) {
                _.current && e.currentTarget === e.target && _.current.focus(),
                  S && S(e);
              },
              ref: t,
            },
            f
          ),
          N,
          mh.createElement(
            Ov.Provider,
            { value: null },
            mh.createElement(
              e,
              Su(
                {
                  "aria-invalid": B.error,
                  "aria-describedby": n,
                  autoComplete: r,
                  autoFocus: i,
                  defaultValue: s,
                  disabled: B.disabled,
                  id: p,
                  onAnimationStart: function (e) {
                    j(
                      "mui-auto-fill-cancel" === e.animationName
                        ? _.current
                        : { value: "x" }
                    );
                  },
                  name: w,
                  placeholder: P,
                  readOnly: z,
                  required: B.required,
                  rows: R,
                  value: L,
                  onKeyDown: k,
                  onKeyUp: T,
                },
                h,
                {
                  className: Ph(
                    o.input,
                    g.className,
                    B.disabled && o.disabled,
                    b && o.inputMultiline,
                    B.hiddenLabel && o.inputHiddenLabel,
                    N && o.inputAdornedStart,
                    c && o.inputAdornedEnd,
                    "search" === m && o.inputTypeSearch,
                    "dense" === B.margin && o.inputMarginDense
                  ),
                  onBlur: function (e) {
                    x && x(e),
                      g.onBlur && g.onBlur(e),
                      F && F.onBlur ? F.onBlur(e) : A(!1);
                  },
                  onChange: function (e) {
                    if (!I) {
                      var t = e.target || _.current;
                      if (null == t)
                        throw new TypeError(
                          "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info."
                        );
                      j({ value: t.value });
                    }
                    for (
                      var n = arguments.length,
                        r = new Array(1 < n ? n - 1 : 0),
                        i = 1;
                      i < n;
                      i++
                    )
                      r[i - 1] = arguments[i];
                    g.onChange && g.onChange.apply(g, [e].concat(r)),
                      E && E.apply(void 0, [e].concat(r));
                  },
                  onFocus: function (e) {
                    B.disabled
                      ? e.stopPropagation()
                      : (C && C(e),
                        g.onFocus && g.onFocus(e),
                        F && F.onFocus ? F.onFocus(e) : A(!0));
                  },
                }
              )
            )
          ),
          c,
          O ? O(Su({}, B, { startAdornment: N })) : null
        )
      );
    }),
    Sy = Uh(
      function (e) {
        var t = "light" === e.palette.type,
          n = {
            color: "currentColor",
            opacity: t ? 0.42 : 0.5,
            transition: e.transitions.create("opacity", {
              duration: e.transitions.duration.shorter,
            }),
          },
          r = { opacity: "0 !important" },
          t = { opacity: t ? 0.42 : 0.5 };
        return {
          "@global": {
            "@keyframes mui-auto-fill": { from: {} },
            "@keyframes mui-auto-fill-cancel": { from: {} },
          },
          root: Su({}, e.typography.body1, {
            color: e.palette.text.primary,
            lineHeight: "1.1875em",
            boxSizing: "border-box",
            position: "relative",
            cursor: "text",
            display: "inline-flex",
            alignItems: "center",
            "&$disabled": { color: e.palette.text.disabled, cursor: "default" },
          }),
          formControl: {},
          focused: {},
          disabled: {},
          adornedStart: {},
          adornedEnd: {},
          error: {},
          marginDense: {},
          multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            "&$marginDense": { paddingTop: 3 },
          },
          colorSecondary: {},
          fullWidth: { width: "100%" },
          input: {
            font: "inherit",
            color: "currentColor",
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: "content-box",
            background: "none",
            height: "1.1875em",
            margin: 0,
            WebkitTapHighlightColor: "transparent",
            display: "block",
            minWidth: 0,
            width: "100%",
            animationName: "mui-auto-fill-cancel",
            "&::-webkit-input-placeholder": n,
            "&::-moz-placeholder": n,
            "&:-ms-input-placeholder": n,
            "&::-ms-input-placeholder": n,
            "&:focus": { outline: 0 },
            "&:invalid": { boxShadow: "none" },
            "&::-webkit-search-decoration": { "-webkit-appearance": "none" },
            "label[data-shrink=false] + $formControl &": {
              "&::-webkit-input-placeholder": r,
              "&::-moz-placeholder": r,
              "&:-ms-input-placeholder": r,
              "&::-ms-input-placeholder": r,
              "&:focus::-webkit-input-placeholder": t,
              "&:focus::-moz-placeholder": t,
              "&:focus:-ms-input-placeholder": t,
              "&:focus::-ms-input-placeholder": t,
            },
            "&$disabled": { opacity: 1 },
            "&:-webkit-autofill": {
              animationDuration: "5000s",
              animationName: "mui-auto-fill",
            },
          },
          inputMarginDense: { paddingTop: 3 },
          inputMultiline: { height: "auto", resize: "none", padding: 0 },
          inputTypeSearch: {
            "-moz-appearance": "textfield",
            "-webkit-appearance": "textfield",
          },
          inputAdornedStart: {},
          inputAdornedEnd: {},
          inputHiddenLabel: {},
        };
      },
      { name: "PwzrInputBase" }
    )(_f);
  function Cy(e, t) {
    return mh.isValidElement(e) && -1 !== t.indexOf(e.type.muiName);
  }
  Q(),
    ((xp = mh.forwardRef(function (e, t) {
      var n = e.disableUnderline,
        r = e.classes,
        i = e.fullWidth,
        o = void 0 !== i && i,
        a = e.inputComponent,
        s = void 0 === a ? "input" : a,
        i = e.multiline,
        a = void 0 !== i && i,
        i = e.type,
        i = void 0 === i ? "text" : i,
        e = xu(e, [
          "disableUnderline",
          "classes",
          "fullWidth",
          "inputComponent",
          "multiline",
          "type",
        ]);
      return mh.createElement(
        Sy,
        Su(
          {
            classes: Su({}, r, {
              root: Ph(r.root, !n && r.underline),
              underline: null,
            }),
            fullWidth: o,
            inputComponent: s,
            multiline: a,
            ref: t,
            type: i,
          },
          e
        )
      );
    })).muiName = "Input"),
    (Yu = Uh(
      function (e) {
        var t = "light" === e.palette.type,
          n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)",
          r = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
        return {
          root: {
            position: "relative",
            backgroundColor: r,
            borderTopLeftRadius: e.shape.borderRadius,
            borderTopRightRadius: e.shape.borderRadius,
            transition: e.transitions.create("background-color", {
              duration: e.transitions.duration.shorter,
              easing: e.transitions.easing.easeOut,
            }),
            "&:hover": {
              backgroundColor: t
                ? "rgba(0, 0, 0, 0.13)"
                : "rgba(255, 255, 255, 0.13)",
              "@media (hover: none)": { backgroundColor: r },
            },
            "&$focused": {
              backgroundColor: t
                ? "rgba(0, 0, 0, 0.09)"
                : "rgba(255, 255, 255, 0.09)",
            },
            "&$disabled": {
              backgroundColor: t
                ? "rgba(0, 0, 0, 0.12)"
                : "rgba(255, 255, 255, 0.12)",
            },
          },
          colorSecondary: {
            "&$underline:after": {
              borderBottomColor: e.palette.secondary.main,
            },
          },
          underline: {
            "&:after": {
              borderBottom: "2px solid ".concat(e.palette.primary.main),
              left: 0,
              bottom: 0,
              content: '""',
              position: "absolute",
              right: 0,
              transform: "scaleX(0)",
              transition: e.transitions.create("transform", {
                duration: e.transitions.duration.shorter,
                easing: e.transitions.easing.easeOut,
              }),
              pointerEvents: "none",
            },
            "&$focused:after": { transform: "scaleX(1)" },
            "&$error:after": {
              borderBottomColor: e.palette.error.main,
              transform: "scaleX(1)",
            },
            "&:before": {
              borderBottom: "1px solid ".concat(n),
              left: 0,
              bottom: 0,
              content: '"\\00a0"',
              position: "absolute",
              right: 0,
              transition: e.transitions.create("border-bottom-color", {
                duration: e.transitions.duration.shorter,
              }),
              pointerEvents: "none",
            },
            "&:hover:before": {
              borderBottom: "1px solid ".concat(e.palette.text.primary),
            },
            "&$disabled:before": { borderBottomStyle: "dotted" },
          },
          focused: {},
          disabled: {},
          adornedStart: { paddingLeft: 12 },
          adornedEnd: { paddingRight: 12 },
          error: {},
          marginDense: {},
          multiline: {
            padding: "27px 12px 10px",
            "&$marginDense": { paddingTop: 23, paddingBottom: 6 },
          },
          input: {
            padding: "27px 12px 10px",
            "&:-webkit-autofill": {
              WebkitBoxShadow:
                "dark" === e.palette.type ? "0 0 0 100px #266798 inset" : null,
              WebkitTextFillColor: "dark" === e.palette.type ? "#fff" : null,
              borderTopLeftRadius: "inherit",
              borderTopRightRadius: "inherit",
            },
          },
          inputMarginDense: { paddingTop: 23, paddingBottom: 6 },
          inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            "&$inputMarginDense": { paddingTop: 10, paddingBottom: 11 },
          },
          inputMultiline: { padding: 0 },
          inputAdornedStart: { paddingLeft: 0 },
          inputAdornedEnd: { paddingRight: 0 },
        };
      },
      { name: "PwzrFilledInput" }
    )(xp)),
    Q(),
    Q();
  var If = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.color,
        a = void 0 === o ? "primary" : o,
        s = e.component,
        l = void 0 === s ? "div" : s,
        c = e.disabled,
        u = void 0 !== c && c,
        d = e.error,
        p = void 0 !== d && d,
        f = e.fullWidth,
        h = void 0 !== f && f,
        m = e.hiddenLabel,
        g = void 0 !== m && m,
        v = e.margin,
        y = void 0 === v ? "none" : v,
        b = e.required,
        o = void 0 !== b && b,
        s = e.size,
        c = e.variant,
        d = void 0 === c ? "standard" : c,
        f = xu(e, [
          "children",
          "classes",
          "className",
          "color",
          "component",
          "disabled",
          "error",
          "fullWidth",
          "hiddenLabel",
          "margin",
          "required",
          "size",
          "variant",
        ]),
        m = mh.useState(function () {
          var t = !1;
          return (
            n &&
              mh.Children.forEach(n, function (e) {
                !Cy(e, ["Input", "Select"]) ||
                  ((e = Cy(e, ["Select"]) ? e.props.input : e) &&
                    e.props.startAdornment &&
                    (t = !0));
              }),
            t
          );
        }),
        v = m[0],
        b = m[1],
        c = mh.useState(function () {
          var t = !1;
          return (
            n &&
              mh.Children.forEach(n, function (e) {
                Cy(e, ["Input", "Select"]) && xy(e.props, !0) && (t = !0);
              }),
            t
          );
        }),
        e = c[0],
        w = c[1],
        m = mh.useState(!1),
        c = m[0],
        x = m[1];
      u && c && x(!1);
      (m = mh.useCallback(function () {
        w(!0);
      }, [])),
        (d = {
          adornedStart: v,
          setAdornedStart: b,
          color: a,
          disabled: u,
          error: p,
          filled: e,
          focused: c,
          fullWidth: h,
          hiddenLabel: g,
          margin: ("small" === s ? "dense" : void 0) || y,
          onBlur: function () {
            x(!1);
          },
          onEmpty: mh.useCallback(function () {
            w(!1);
          }, []),
          onFilled: m,
          onFocus: function () {
            x(!0);
          },
          registerEffect: void 0,
          required: o,
          variant: d,
        });
      return mh.createElement(
        Ov.Provider,
        { value: d },
        mh.createElement(
          l,
          Su(
            {
              className: Ph(
                r.root,
                i,
                "none" !== y && r["margin".concat(ag(y))],
                h && r.fullWidth
              ),
              ref: t,
            },
            f
          ),
          n
        )
      );
    }),
    ky = Uh(
      {
        root: {
          display: "inline-flex",
          flexDirection: "column",
          position: "relative",
          minWidth: 0,
          padding: 0,
          margin: 0,
          border: 0,
          zIndex: 0,
          verticalAlign: "top",
        },
        marginNormal: { marginTop: 16, marginBottom: 8 },
        marginDense: { marginTop: 8, marginBottom: 4 },
        fullWidth: { width: "100%" },
      },
      { name: "PwzrFormControl" }
    )(If);
  Q(),
    (of = mh.forwardRef(function (t, e) {
      t.checked;
      var n = t.classes,
        r = t.className,
        i = t.control,
        o = t.disabled,
        a = (t.inputRef, t.label),
        s = t.labelPlacement,
        l = void 0 === s ? "end" : s,
        c =
          (t.name,
          t.onChange,
          t.value,
          xu(t, [
            "checked",
            "classes",
            "className",
            "control",
            "disabled",
            "inputRef",
            "label",
            "labelPlacement",
            "name",
            "onChange",
            "value",
          ])),
        s = Mv(),
        o = o;
      void 0 === o && void 0 !== i.props.disabled && (o = i.props.disabled),
        void 0 === o && s && (o = s.disabled);
      var u = { disabled: o };
      return (
        ["checked", "name", "onChange", "value", "inputRef"].forEach(function (
          e
        ) {
          void 0 === i.props[e] && void 0 !== t[e] && (u[e] = t[e]);
        }),
        mh.createElement(
          "label",
          Su(
            {
              className: Ph(
                n.root,
                r,
                "end" !== l && n["labelPlacement".concat(ag(l))],
                o && n.disabled
              ),
              ref: e,
            },
            c
          ),
          mh.cloneElement(i, u),
          mh.createElement(
            Cv,
            { component: "span", className: Ph(n.label, o && n.disabled) },
            a
          )
        )
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
            verticalAlign: "middle",
            WebkitTapHighlightColor: "transparent",
            marginLeft: -11,
            marginRight: 16,
            "&$disabled": { cursor: "default" },
          },
          labelPlacementStart: {
            flexDirection: "row-reverse",
            marginLeft: 16,
            marginRight: -11,
          },
          labelPlacementTop: {
            flexDirection: "column-reverse",
            marginLeft: 16,
          },
          labelPlacementBottom: { flexDirection: "column", marginLeft: 16 },
          disabled: {},
          label: { "&$disabled": { color: e.palette.text.disabled } },
        };
      },
      { name: "PwzrFormControlLabel" }
    )(of),
    Q();
  var vp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.row,
        i = void 0 !== i && i,
        e = xu(e, ["classes", "className", "row"]);
      return mh.createElement(
        "div",
        Su({ className: Ph(n.root, r, i && n.row), ref: t }, e)
      );
    }),
    Ty = Uh(
      {
        root: { display: "flex", flexDirection: "column", flexWrap: "wrap" },
        row: { flexDirection: "row" },
      },
      { name: "PwzrFormGroup" }
    )(vp);
  Q();
  var Sp = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.component,
        a = void 0 === o ? "p" : o,
        o =
          (e.disabled,
          e.error,
          e.filled,
          e.focused,
          e.margin,
          e.required,
          e.variant,
          xu(e, [
            "children",
            "classes",
            "className",
            "component",
            "disabled",
            "error",
            "filled",
            "focused",
            "margin",
            "required",
            "variant",
          ])),
        e = my({
          props: e,
          muiFormControl: Mv(),
          states: [
            "variant",
            "margin",
            "disabled",
            "error",
            "filled",
            "focused",
            "required",
          ],
        });
      return mh.createElement(
        a,
        Su(
          {
            className: Ph(
              r.root,
              ("filled" === e.variant || "outlined" === e.variant) &&
                r.contained,
              i,
              e.disabled && r.disabled,
              e.error && r.error,
              e.filled && r.filled,
              e.focused && r.focused,
              e.required && r.required,
              "dense" === e.margin && r.marginDense
            ),
            ref: t,
          },
          o
        ),
        " " === n
          ? mh.createElement("span", {
              dangerouslySetInnerHTML: { __html: "&#8203;" },
            })
          : n
      );
    }),
    Py = Uh(
      function (e) {
        return {
          root: Su({ color: e.palette.text.secondary }, e.typography.caption, {
            textAlign: "left",
            marginTop: 3,
            margin: 0,
            "&$disabled": { color: e.palette.text.disabled },
            "&$error": { color: e.palette.error.main },
          }),
          error: {},
          disabled: {},
          marginDense: { marginTop: 4 },
          contained: { marginLeft: 14, marginRight: 14 },
          focused: {},
          filled: {},
          required: {},
        };
      },
      { name: "PwzrFormHelperText" }
    )(Sp);
  Q();
  var _f = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = (e.color, e.component),
        a = void 0 === o ? "label" : o,
        o =
          (e.disabled,
          e.error,
          e.filled,
          e.focused,
          e.required,
          xu(e, [
            "children",
            "classes",
            "className",
            "color",
            "component",
            "disabled",
            "error",
            "filled",
            "focused",
            "required",
          ])),
        e = my({
          props: e,
          muiFormControl: Mv(),
          states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled",
          ],
        });
      return mh.createElement(
        a,
        Su(
          {
            className: Ph(
              r.root,
              r["color".concat(ag(e.color || "primary"))],
              i,
              e.disabled && r.disabled,
              e.error && r.error,
              e.filled && r.filled,
              e.focused && r.focused,
              e.required && r.required
            ),
            ref: t,
          },
          o
        ),
        n,
        e.required &&
          mh.createElement(
            "span",
            { className: Ph(r.asterisk, e.error && r.error) },
            " ",
            "*"
          )
      );
    }),
    zy = Uh(
      function (e) {
        return {
          root: Su({ color: e.palette.text.secondary }, e.typography.body1, {
            lineHeight: 1,
            padding: 0,
            "&$focused": { color: e.palette.primary.main },
            "&$disabled": { color: e.palette.text.disabled },
            "&$error": { color: e.palette.error.main },
          }),
          colorSecondary: { "&$focused": { color: e.palette.secondary.main } },
          focused: {},
          disabled: {},
          error: {},
          filled: {},
          required: {},
          asterisk: { "&$error": { color: e.palette.error.main } },
        };
      },
      { name: "PwzrFormLabel" }
    )(_f);
  Q();
  var Oy = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    Ry = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  function My(e, t) {
    var n = 1 < arguments.length && void 0 !== t ? t : 1,
      r = parseFloat(e);
    return "".concat(r / n).concat(String(e).replace(String(r), "") || "px");
  }
  var xp = mh.forwardRef(function (e, t) {
      var n = e.alignContent,
        r = void 0 === n ? "stretch" : n,
        i = e.alignItems,
        o = void 0 === i ? "stretch" : i,
        a = e.classes,
        s = e.className,
        l = e.component,
        c = void 0 === l ? "div" : l,
        u = e.container,
        d = void 0 !== u && u,
        p = e.direction,
        f = void 0 === p ? "row" : p,
        h = e.item,
        m = void 0 !== h && h,
        g = e.justify,
        v = void 0 === g ? "flex-start" : g,
        y = e.lg,
        n = void 0 !== y && y,
        i = e.md,
        l = void 0 !== i && i,
        u = e.sm,
        p = void 0 !== u && u,
        h = e.spacing,
        g = void 0 === h ? 0 : h,
        y = e.wrap,
        i = void 0 === y ? "wrap" : y,
        u = e.xl,
        h = void 0 !== u && u,
        y = e.xs,
        u = void 0 !== y && y,
        y = e.zeroMinWidth,
        y = void 0 !== y && y,
        e = xu(e, [
          "alignContent",
          "alignItems",
          "classes",
          "className",
          "component",
          "container",
          "direction",
          "item",
          "justify",
          "lg",
          "md",
          "sm",
          "spacing",
          "wrap",
          "xl",
          "xs",
          "zeroMinWidth",
        ]),
        h = Ph(
          a.root,
          s,
          d && [a.container, 0 !== g && a["spacing-xs-".concat(String(g))]],
          m && a.item,
          y && a.zeroMinWidth,
          "row" !== f && a["direction-xs-".concat(String(f))],
          "wrap" !== i && a["wrap-xs-".concat(String(i))],
          "stretch" !== o && a["align-items-xs-".concat(String(o))],
          "stretch" !== r && a["align-content-xs-".concat(String(r))],
          "flex-start" !== v && a["justify-xs-".concat(String(v))],
          !1 !== u && a["grid-xs-".concat(String(u))],
          !1 !== p && a["grid-sm-".concat(String(p))],
          !1 !== l && a["grid-md-".concat(String(l))],
          !1 !== n && a["grid-lg-".concat(String(n))],
          !1 !== h && a["grid-xl-".concat(String(h))]
        );
      return mh.createElement(c, Su({ className: h, ref: t }, e));
    }),
    Ny = Uh(
      function (a) {
        return Su(
          {
            root: {},
            container: {
              boxSizing: "border-box",
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
            },
            item: { boxSizing: "border-box", margin: "0" },
            zeroMinWidth: { minWidth: 0 },
            "direction-xs-column": { flexDirection: "column" },
            "direction-xs-column-reverse": { flexDirection: "column-reverse" },
            "direction-xs-row-reverse": { flexDirection: "row-reverse" },
            "wrap-xs-nowrap": { flexWrap: "nowrap" },
            "wrap-xs-wrap-reverse": { flexWrap: "wrap-reverse" },
            "align-items-xs-center": { alignItems: "center" },
            "align-items-xs-flex-start": { alignItems: "flex-start" },
            "align-items-xs-flex-end": { alignItems: "flex-end" },
            "align-items-xs-baseline": { alignItems: "baseline" },
            "align-content-xs-center": { alignContent: "center" },
            "align-content-xs-flex-start": { alignContent: "flex-start" },
            "align-content-xs-flex-end": { alignContent: "flex-end" },
            "align-content-xs-space-between": { alignContent: "space-between" },
            "align-content-xs-space-around": { alignContent: "space-around" },
            "justify-xs-center": { justifyContent: "center" },
            "justify-xs-flex-end": { justifyContent: "flex-end" },
            "justify-xs-space-between": { justifyContent: "space-between" },
            "justify-xs-space-around": { justifyContent: "space-around" },
            "justify-xs-space-evenly": { justifyContent: "space-evenly" },
          },
          ((n = a),
          (r = {}),
          Oy.forEach(function (e) {
            var t = n.spacing(e);
            0 !== t &&
              (r["spacing-".concat("xs", "-").concat(e)] = {
                margin: "-".concat(My(t, 2)),
                width: "calc(100% + ".concat(My(t), ")"),
                "& > $item": { padding: My(t, 2) },
              });
          }),
          r),
          {},
          a.breakpoints.keys.reduce(function (e, t) {
            return (
              (n = e),
              (r = a),
              (i = t),
              (o = {}),
              Ry.forEach(function (e) {
                var t = "grid-".concat(i, "-").concat(e);
                !0 !== e
                  ? "auto" !== e
                    ? ((e = "".concat(Math.round((e / 12) * 1e8) / 1e6, "%")),
                      (o[t] = { flexBasis: e, flexGrow: 0, maxWidth: e }))
                    : (o[t] = {
                        flexBasis: "auto",
                        flexGrow: 0,
                        maxWidth: "none",
                      })
                  : (o[t] = { flexBasis: 0, flexGrow: 1, maxWidth: "100%" });
              }),
              "xs" === i ? Su(n, o) : (n[r.breakpoints.up(i)] = o),
              e
            );
            var n, r, i, o;
          }, {})
        );
        var n, r;
      },
      { name: "PwzrGrid" }
    )(xp);
  function Ly(e, t) {
    var n;
    e &&
      e.complete &&
      (e.width / e.height >
      e.parentElement.offsetWidth / e.parentElement.offsetHeight
        ? ((n = e.classList).remove.apply(n, Mf(t.imgFullWidth.split(" "))),
          (n = e.classList).add.apply(n, Mf(t.imgFullHeight.split(" "))))
        : ((n = e.classList).remove.apply(n, Mf(t.imgFullHeight.split(" "))),
          (e = e.classList).add.apply(e, Mf(t.imgFullWidth.split(" ")))));
  }
  function Iy(e) {
    return "scale(".concat(e, ", ").concat(Math.pow(e, 2), ")");
  }
  Q(),
    (If = mh.forwardRef(function (e, t) {
      var n = e.cellHeight,
        r = void 0 === n ? 180 : n,
        i = e.children,
        o = e.classes,
        a = e.className,
        s = e.cols,
        l = void 0 === s ? 2 : s,
        n = e.component,
        s = void 0 === n ? "ul" : n,
        n = e.spacing,
        c = void 0 === n ? 4 : n,
        n = e.style,
        e = xu(e, [
          "cellHeight",
          "children",
          "classes",
          "className",
          "cols",
          "component",
          "spacing",
          "style",
        ]);
      return mh.createElement(
        s,
        Su(
          {
            className: Ph(o.root, a),
            ref: t,
            style: Su({ margin: -c / 2 }, n),
          },
          e
        ),
        mh.Children.map(i, function (e) {
          if (!mh.isValidElement(e)) return null;
          var t = e.props.cols || 1,
            n = e.props.rows || 1;
          return mh.cloneElement(e, {
            style: Su(
              {
                width: "".concat((100 / l) * t, "%"),
                height: "auto" === r ? "auto" : r * n + c,
                padding: c / 2,
              },
              e.props.style
            ),
          });
        })
      );
    })),
    Uh(
      {
        root: {
          display: "flex",
          flexWrap: "wrap",
          overflowY: "auto",
          listStyle: "none",
          padding: 0,
          WebkitOverflowScrolling: "touch",
        },
      },
      { name: "PwzrGridList" }
    )(If),
    Q(),
    (of = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = (e.cols, e.component),
        o = void 0 === o ? "li" : o,
        e =
          (e.rows,
          xu(e, [
            "children",
            "classes",
            "className",
            "cols",
            "component",
            "rows",
          ])),
        a = mh.useRef(null);
      return (
        mh.useEffect(function () {
          var e, t;
          (e = a.current),
            (t = r),
            e &&
              (e.complete
                ? Ly(e, t)
                : e.addEventListener("load", function () {
                    Ly(e, t);
                  }));
        }),
        mh.useEffect(
          function () {
            var e = oy(function () {
              Ly(a.current, r);
            });
            return (
              window.addEventListener("resize", e),
              function () {
                e.clear(), window.removeEventListener("resize", e);
              }
            );
          },
          [r]
        ),
        mh.createElement(
          o,
          Su({ className: Ph(r.root, i), ref: t }, e),
          mh.createElement(
            "div",
            { className: r.tile },
            mh.Children.map(n, function (e) {
              return mh.isValidElement(e)
                ? "img" === e.type || Cy(e, ["Image"])
                  ? mh.cloneElement(e, { ref: a })
                  : e
                : null;
            })
          )
        )
      );
    })),
    Uh(
      {
        root: { boxSizing: "border-box", flexShrink: 0 },
        tile: {
          position: "relative",
          display: "block",
          height: "100%",
          overflow: "hidden",
        },
        imgFullHeight: {
          height: "100%",
          transform: "translateX(-50%)",
          position: "relative",
          left: "50%",
        },
        imgFullWidth: {
          width: "100%",
          position: "relative",
          transform: "translateY(-50%)",
          top: "50%",
        },
      },
      { name: "PwzrGridListTile" }
    )(of),
    Q(),
    (vp = mh.forwardRef(function (e, t) {
      var n = e.actionIcon,
        r = e.actionPosition,
        i = void 0 === r ? "right" : r,
        o = e.classes,
        a = e.className,
        s = e.subtitle,
        l = e.title,
        r = e.titlePosition,
        r = void 0 === r ? "bottom" : r,
        e = xu(e, [
          "actionIcon",
          "actionPosition",
          "classes",
          "className",
          "subtitle",
          "title",
          "titlePosition",
        ]),
        i = n && i;
      return mh.createElement(
        "div",
        Su(
          {
            className: Ph(
              o.root,
              a,
              "top" === r ? o.titlePositionTop : o.titlePositionBottom,
              s && o.rootSubtitle
            ),
            ref: t,
          },
          e
        ),
        mh.createElement(
          "div",
          {
            className: Ph(
              o.titleWrap,
              {
                left: o.titleWrapActionPosLeft,
                right: o.titleWrapActionPosRight,
              }[i]
            ),
          },
          mh.createElement("div", { className: o.title }, l),
          s ? mh.createElement("div", { className: o.subtitle }, s) : null
        ),
        n
          ? mh.createElement(
              "div",
              {
                className: Ph(
                  o.actionIcon,
                  "left" === i && o.actionIconActionPosLeft
                ),
              },
              n
            )
          : null
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            position: "absolute",
            left: 0,
            right: 0,
            height: 48,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            fontFamily: e.typography.fontFamily,
          },
          titlePositionBottom: { bottom: 0 },
          titlePositionTop: { top: 0 },
          rootSubtitle: { height: 68 },
          titleWrap: {
            flexGrow: 1,
            marginLeft: 16,
            marginRight: 16,
            color: e.palette.common.white,
            overflow: "hidden",
          },
          titleWrapActionPosLeft: { marginLeft: 0 },
          titleWrapActionPosRight: { marginRight: 0 },
          title: {
            fontSize: e.typography.pxToRem(16),
            lineHeight: "24px",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          },
          subtitle: {
            fontSize: e.typography.pxToRem(12),
            lineHeight: 1,
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          },
          actionIcon: {},
          actionIconActionPosLeft: { order: -1 },
        };
      },
      { name: "PwzrGridListTileBar" }
    )(vp),
    Q();
  var _y = {
      entering: { opacity: 1, transform: Iy(1) },
      entered: { opacity: 1, transform: "none" },
    },
    Dy = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.in,
        o = e.onEnter,
        i = e.onExit,
        a = e.style,
        s = e.timeout,
        l = void 0 === s ? "auto" : s,
        e = xu(e, ["children", "in", "onEnter", "onExit", "style", "timeout"]),
        c = mh.useRef(),
        u = mh.useRef(),
        d = Ig(n.ref, t),
        p = qh();
      return (
        mh.useEffect(function () {
          return function () {
            clearTimeout(c.current);
          };
        }, []),
        mh.createElement(
          Og,
          Su(
            {
              appear: !0,
              in: r,
              onEnter: function (e, t) {
                Mg(e);
                var n,
                  r = Ng({ style: a, timeout: l }, { mode: "enter" }),
                  i = r.duration,
                  r = r.delay;
                "auto" === l
                  ? ((n = p.transitions.getAutoHeightDuration(e.clientHeight)),
                    (u.current = n))
                  : (n = i),
                  (e.style.transition = [
                    p.transitions.create("opacity", { duration: n, delay: r }),
                    p.transitions.create("transform", {
                      duration: 0.666 * n,
                      delay: r,
                    }),
                  ].join(",")),
                  o && o(e, t);
              },
              onExit: function (e) {
                var t,
                  n = Ng({ style: a, timeout: l }, { mode: "exit" }),
                  r = n.duration,
                  n = n.delay;
                "auto" === l
                  ? ((t = p.transitions.getAutoHeightDuration(e.clientHeight)),
                    (u.current = t))
                  : (t = r),
                  (e.style.transition = [
                    p.transitions.create("opacity", { duration: t, delay: n }),
                    p.transitions.create("transform", {
                      duration: 0.666 * t,
                      delay: n || 0.333 * t,
                    }),
                  ].join(",")),
                  (e.style.opacity = "0"),
                  (e.style.transform = Iy(0.75)),
                  i && i(e);
              },
              addEndListener: function (e, t) {
                "auto" === l && (c.current = setTimeout(t, u.current || 0));
              },
              timeout: "auto" === l ? null : l,
            },
            e
          ),
          function (e, t) {
            return mh.cloneElement(
              n,
              Su(
                {
                  style: Su(
                    {
                      opacity: 0,
                      transform: Iy(0.75),
                      visibility: "exited" !== e || r ? void 0 : "hidden",
                    },
                    _y[e],
                    {},
                    a,
                    {},
                    n.props.style
                  ),
                  ref: d,
                },
                t
              )
            );
          }
        )
      );
    });
  function Ay(e, t) {
    return !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2]
      ? Ju.indexOf(e) <= Ju.indexOf(t)
      : Ju.indexOf(e) < Ju.indexOf(t);
  }
  (Dy.muiSupportAuto = !0), Q(), Q();
  var Fy = "undefined" == typeof window ? mh.useEffect : mh.useLayoutEffect,
    Sp = function () {
      var n =
        0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
      return function (s) {
        var e = n.withTheme,
          l = void 0 !== e && e,
          e = n.noSSR,
          c = void 0 !== e && e,
          u = n.initialWidth;
        function t(e) {
          var t = qh(),
            r = e.theme || t,
            n = Bd({ theme: r, name: "PwzrWithWidth", props: Su({}, e) }),
            i = n.initialWidth,
            o = n.width,
            t = xu(n, ["initialWidth", "width"]),
            e = mh.useState(!1),
            n = e[0],
            a = e[1];
          Fy(function () {
            a(!0);
          }, []);
          (e = Mf(r.breakpoints.keys)
            .reverse()
            .reduce(function (e, t) {
              var n = Zh(r.breakpoints.up(t));
              return !e && n ? t : e;
            }, null)),
            (t = Su(
              { width: o || (n || c ? e : void 0) || i || u },
              l ? { theme: r } : {},
              {},
              t
            ));
          return void 0 === t.width ? null : mh.createElement(s, t);
        }
        return $h(t, s), t;
      };
    };
  function By(e) {
    var t = e.children,
      n = e.only,
      r = e.width,
      i = qh(),
      o = !0;
    if (n)
      if (Array.isArray(n)) {
        for (var a = 0; a < n.length; a += 1)
          if (r === n[a]) {
            o = !1;
            break;
          }
      } else n && r === n && (o = !1);
    if (o)
      for (var s = 0; s < i.breakpoints.keys.length; s += 1) {
        var l = i.breakpoints.keys[s],
          c = e["".concat(l, "Up")],
          u = e["".concat(l, "Down")];
        if (
          (c && Ay(l, r)) ||
          (u &&
            (function (e, t) {
              return !(2 < arguments.length && void 0 !== arguments[2]) ||
                arguments[2]
                ? Ju.indexOf(t) <= Ju.indexOf(e)
                : Ju.indexOf(t) < Ju.indexOf(e);
            })(l, r))
        ) {
          o = !1;
          break;
        }
      }
    return o ? t : null;
  }
  (By.propTypes = {
    children: RP.node,
    className: RP.string,
    implementation: RP.oneOf(["js", "css"]),
    initialWidth: RP.oneOf(["xs", "sm", "md", "lg", "xl"]),
    lgDown: RP.bool,
    lgUp: RP.bool,
    mdDown: RP.bool,
    mdUp: RP.bool,
    only: RP.oneOfType([
      RP.oneOf(["xs", "sm", "md", "lg", "xl"]),
      RP.arrayOf(RP.oneOf(["xs", "sm", "md", "lg", "xl"])),
    ]),
    smDown: RP.bool,
    smUp: RP.bool,
    width: RP.string.isRequired,
    xlDown: RP.bool,
    xlUp: RP.bool,
    xsDown: RP.bool,
    xsUp: RP.bool,
  }),
    Sp()(By),
    Q(),
    Uh(
      function (n) {
        var r = { display: "none" };
        return n.breakpoints.keys.reduce(function (e, t) {
          return (
            (e["only".concat(ag(t))] = bu({}, n.breakpoints.only(t), r)),
            (e["".concat(t, "Up")] = bu({}, n.breakpoints.up(t), r)),
            (e["".concat(t, "Down")] = bu({}, n.breakpoints.down(t), r)),
            e
          );
        }, {});
      },
      { name: "PrivateHiddenCss" }
    )(function (e) {
      var t = e.children,
        n = e.classes,
        r = e.className,
        i = e.only,
        o = (xu(e, ["children", "classes", "className", "only"]), qh()),
        a = [];
      r && a.push(r);
      for (var s = 0; s < o.breakpoints.keys.length; s += 1) {
        var l = o.breakpoints.keys[s],
          c = e["".concat(l, "Up")],
          u = e["".concat(l, "Down")];
        c && a.push(n["".concat(l, "Up")]),
          u && a.push(n["".concat(l, "Down")]);
      }
      return (
        i &&
          (Array.isArray(i) ? i : [i]).forEach(function (e) {
            a.push(n["only".concat(ag(e))]);
          }),
        mh.createElement("div", { className: a.join(" ") }, t)
      );
    }),
    Q(),
    ((_f = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.color,
        o = void 0 === i ? "inherit" : i,
        a = e.component,
        i = void 0 === a ? "span" : a,
        a = e.fontSize,
        a = void 0 === a ? "default" : a,
        e = xu(e, ["classes", "className", "color", "component", "fontSize"]);
      return mh.createElement(
        i,
        Su(
          {
            className: Ph(
              "material-icons",
              n.root,
              r,
              "inherit" !== o && n["color".concat(ag(o))],
              "default" !== a && n["fontSize".concat(ag(a))]
            ),
            "aria-hidden": !0,
            ref: t,
          },
          e
        )
      );
    })).muiName = "Icon"),
    Uh(
      function (e) {
        return {
          root: {
            userSelect: "none",
            fontSize: e.typography.pxToRem(24),
            width: "1em",
            height: "1em",
            overflow: "hidden",
            flexShrink: 0,
          },
          colorPrimary: { color: e.palette.primary.main },
          colorSecondary: { color: e.palette.secondary.main },
          colorAction: { color: e.palette.action.active },
          colorError: { color: e.palette.error.main },
          colorDisabled: { color: e.palette.action.disabled },
          fontSizeInherit: { fontSize: "inherit" },
          fontSizeSmall: { fontSize: e.typography.pxToRem(20) },
          fontSizeLarge: { fontSize: e.typography.pxToRem(36) },
        };
      },
      { name: "PwzrIcon" }
    )(_f),
    Q(),
    ((xp = mh.forwardRef(function (e, t) {
      var n = e.disableUnderline,
        r = e.classes,
        i = e.fullWidth,
        o = void 0 !== i && i,
        a = e.inputComponent,
        s = void 0 === a ? "input" : a,
        i = e.multiline,
        a = void 0 !== i && i,
        i = e.type,
        i = void 0 === i ? "text" : i,
        e = xu(e, [
          "disableUnderline",
          "classes",
          "fullWidth",
          "inputComponent",
          "multiline",
          "type",
        ]);
      return mh.createElement(
        Sy,
        Su(
          {
            classes: Su({}, r, {
              root: Ph(r.root, !n && r.underline),
              underline: null,
            }),
            fullWidth: o,
            inputComponent: s,
            multiline: a,
            ref: t,
            type: i,
          },
          e
        )
      );
    })).muiName = "Input"),
    (If = Uh(
      function (e) {
        var t =
          "light" === e.palette.type
            ? "rgba(0, 0, 0, 0.42)"
            : "rgba(255, 255, 255, 0.7)";
        return {
          root: { position: "relative" },
          formControl: { "label + &": { marginTop: 16 } },
          focused: {},
          disabled: {},
          colorSecondary: {
            "&$underline:after": {
              borderBottomColor: e.palette.secondary.main,
            },
          },
          underline: {
            "&:after": {
              borderBottom: "2px solid ".concat(e.palette.primary.main),
              left: 0,
              bottom: 0,
              content: '""',
              position: "absolute",
              right: 0,
              transform: "scaleX(0)",
              transition: e.transitions.create("transform", {
                duration: e.transitions.duration.shorter,
                easing: e.transitions.easing.easeOut,
              }),
              pointerEvents: "none",
            },
            "&$focused:after": { transform: "scaleX(1)" },
            "&$error:after": {
              borderBottomColor: e.palette.error.main,
              transform: "scaleX(1)",
            },
            "&:before": {
              borderBottom: "1px solid ".concat(t),
              left: 0,
              bottom: 0,
              content: '"\\00a0"',
              position: "absolute",
              right: 0,
              transition: e.transitions.create("border-bottom-color", {
                duration: e.transitions.duration.shorter,
              }),
              pointerEvents: "none",
            },
            "&:hover:not($disabled):before": {
              borderBottom: "2px solid ".concat(e.palette.text.primary),
              "@media (hover: none)": { borderBottom: "1px solid ".concat(t) },
            },
            "&$disabled:before": { borderBottomStyle: "dotted" },
          },
          error: {},
          marginDense: {},
          multiline: {},
          fullWidth: {},
          input: {},
          inputMarginDense: {},
          inputMultiline: {},
          inputTypeSearch: {},
        };
      },
      { name: "PwzrInput" }
    )(xp)),
    Q(),
    (of = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.component,
        a = void 0 === o ? "div" : o,
        s = e.disablePointerEvents,
        l = void 0 !== s && s,
        c = e.disableTypography,
        u = void 0 !== c && c,
        o = e.position,
        s = e.variant,
        c = xu(e, [
          "children",
          "classes",
          "className",
          "component",
          "disablePointerEvents",
          "disableTypography",
          "position",
          "variant",
        ]),
        e = Rv() || {},
        s = s;
      return (
        e && !s && (s = e.variant),
        mh.createElement(
          Ov.Provider,
          { value: null },
          mh.createElement(
            a,
            Su(
              {
                className: Ph(
                  r.root,
                  i,
                  l && r.disablePointerEvents,
                  e.hiddenLabel && r.hiddenLabel,
                  "filled" === s && r.filled,
                  { start: r.positionStart, end: r.positionEnd }[o],
                  "dense" === e.margin && r.marginDense
                ),
                ref: t,
              },
              c
            ),
            "string" != typeof n || u
              ? n
              : mh.createElement(Cv, { color: "textSecondary" }, n)
          )
        )
      );
    })),
    Uh(
      {
        root: {
          display: "flex",
          height: "0.01em",
          maxHeight: "2em",
          alignItems: "center",
          whiteSpace: "nowrap",
        },
        filled: { "&$positionStart:not($hiddenLabel)": { marginTop: 16 } },
        positionStart: { marginRight: 8 },
        positionEnd: { marginLeft: 8 },
        disablePointerEvents: { pointerEvents: "none" },
        hiddenLabel: {},
        marginDense: {},
      },
      { name: "PwzrInputAdornment" }
    )(of),
    Q();
  var vp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.disableAnimation,
        o = void 0 !== i && i,
        a = (e.margin, e.shrink),
        s =
          (e.variant,
          xu(e, [
            "classes",
            "className",
            "disableAnimation",
            "margin",
            "shrink",
            "variant",
          ])),
        i = Mv(),
        a = a;
      void 0 === a && i && (a = i.filled || i.focused || i.adornedStart);
      e = my({ props: e, muiFormControl: i, states: ["margin", "variant"] });
      return mh.createElement(
        zy,
        Su(
          {
            "data-shrink": a,
            className: Ph(
              n.root,
              r,
              i && n.formControl,
              !o && n.animated,
              a && n.shrink,
              "dense" === e.margin && n.marginDense,
              { filled: n.filled, outlined: n.outlined }[e.variant]
            ),
            classes: {
              focused: n.focused,
              disabled: n.disabled,
              error: n.error,
              required: n.required,
              asterisk: n.asterisk,
            },
            ref: t,
          },
          s
        )
      );
    }),
    Wy = Uh(
      function (e) {
        return {
          root: { display: "block", transformOrigin: "top left" },
          focused: {},
          disabled: {},
          error: {},
          required: {},
          asterisk: {},
          formControl: {
            position: "absolute",
            left: 0,
            top: 0,
            transform: "translate(0, 24px) scale(1)",
          },
          marginDense: { transform: "translate(0, 21px) scale(1)" },
          shrink: {
            transform: "translate(0, 1.5px) scale(0.75)",
            transformOrigin: "top left",
          },
          animated: {
            transition: e.transitions.create(["color", "transform"], {
              duration: e.transitions.duration.shorter,
              easing: e.transitions.easing.easeOut,
            }),
          },
          filled: {
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(12px, 20px) scale(1)",
            "&$marginDense": { transform: "translate(12px, 17px) scale(1)" },
            "&$shrink": {
              transform: "translate(12px, 10px) scale(0.75)",
              "&$marginDense": {
                transform: "translate(12px, 7px) scale(0.75)",
              },
            },
          },
          outlined: {
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(14px, 20px) scale(1)",
            "&$marginDense": { transform: "translate(14px, 12px) scale(1)" },
            "&$shrink": { transform: "translate(14px, -6px) scale(0.75)" },
          },
        };
      },
      { name: "PwzrInputLabel" }
    )(vp);
  Q();
  var _f = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.color,
        o = void 0 === i ? "primary" : i,
        a = e.value,
        s = e.valueBuffer,
        l = e.variant,
        c = void 0 === l ? "indeterminate" : l,
        u = xu(e, [
          "classes",
          "className",
          "color",
          "value",
          "valueBuffer",
          "variant",
        ]),
        i = qh(),
        l = {},
        e = { bar1: {}, bar2: {} };
      return (
        ("determinate" !== c && "buffer" !== c) ||
          (void 0 !== a &&
            ((l["aria-valuenow"] = Math.round(a)),
            (a = a - 100),
            "rtl" === i.direction && (a = -a),
            (e.bar1.transform = "translateX(".concat(a, "%)")))),
        "buffer" === c &&
          void 0 !== s &&
          ((s = (s || 0) - 100),
          "rtl" === i.direction && (s = -s),
          (e.bar2.transform = "translateX(".concat(s, "%)"))),
        mh.createElement(
          "div",
          Su(
            {
              className: Ph(
                n.root,
                n["color".concat(ag(o))],
                r,
                {
                  determinate: n.determinate,
                  indeterminate: n.indeterminate,
                  buffer: n.buffer,
                  query: n.query,
                }[c]
              ),
              role: "progressbar",
            },
            l,
            { ref: t },
            u
          ),
          "buffer" === c
            ? mh.createElement("div", {
                className: Ph(n.dashed, n["dashedColor".concat(ag(o))]),
              })
            : null,
          mh.createElement("div", {
            className: Ph(
              n.bar,
              n["barColor".concat(ag(o))],
              ("indeterminate" === c || "query" === c) && n.bar1Indeterminate,
              { determinate: n.bar1Determinate, buffer: n.bar1Buffer }[c]
            ),
            style: e.bar1,
          }),
          "determinate" === c
            ? null
            : mh.createElement("div", {
                className: Ph(
                  n.bar,
                  ("indeterminate" === c || "query" === c) &&
                    n.bar2Indeterminate,
                  "buffer" === c
                    ? [n["color".concat(ag(o))], n.bar2Buffer]
                    : n["barColor".concat(ag(o))]
                ),
                style: e.bar2,
              })
        )
      );
    }),
    $y = Uh(
      function (t) {
        var e = function (e) {
            return "light" === t.palette.type ? yu(e, 0.62) : vu(e, 0.5);
          },
          n = e(t.palette.primary.main),
          e = e(t.palette.secondary.main);
        return {
          root: { position: "relative", overflow: "hidden", height: 4 },
          colorPrimary: { backgroundColor: n },
          colorSecondary: { backgroundColor: e },
          determinate: {},
          indeterminate: {},
          buffer: { backgroundColor: "transparent" },
          query: { transform: "rotate(180deg)" },
          dashed: {
            position: "absolute",
            marginTop: 0,
            height: "100%",
            width: "100%",
            animation: "$buffer 3s infinite linear",
          },
          dashedColorPrimary: {
            backgroundImage: "radial-gradient("
              .concat(n, " 0%, ")
              .concat(n, " 16%, transparent 42%)"),
            backgroundSize: "10px 10px",
            backgroundPosition: "0px -23px",
          },
          dashedColorSecondary: {
            backgroundImage: "radial-gradient("
              .concat(e, " 0%, ")
              .concat(e, " 16%, transparent 42%)"),
            backgroundSize: "10px 10px",
            backgroundPosition: "0px -23px",
          },
          bar: {
            width: "100%",
            position: "absolute",
            left: 0,
            bottom: 0,
            top: 0,
            transition: "transform 0.2s linear",
            transformOrigin: "left",
          },
          barColorPrimary: { backgroundColor: t.palette.primary.main },
          barColorSecondary: { backgroundColor: t.palette.secondary.main },
          bar1Indeterminate: {
            width: "auto",
            animation:
              "$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite",
          },
          bar1Determinate: { transition: "transform .".concat(4, "s linear") },
          bar1Buffer: {
            zIndex: 1,
            transition: "transform .".concat(4, "s linear"),
          },
          bar2Indeterminate: {
            width: "auto",
            animation:
              "$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite",
          },
          bar2Buffer: { transition: "transform .".concat(4, "s linear") },
          "@keyframes indeterminate1": {
            "0%": { left: "-35%", right: "100%" },
            "60%": { left: "100%", right: "-90%" },
            "100%": { left: "100%", right: "-90%" },
          },
          "@keyframes indeterminate2": {
            "0%": { left: "-200%", right: "100%" },
            "60%": { left: "107%", right: "-8%" },
            "100%": { left: "107%", right: "-8%" },
          },
          "@keyframes buffer": {
            "0%": { opacity: 1, backgroundPosition: "0px -23px" },
            "50%": { opacity: 0, backgroundPosition: "0px -23px" },
            "100%": { opacity: 1, backgroundPosition: "-200px -23px" },
          },
        };
      },
      { name: "PwzrLinearProgress" }
    )(_f);
  Q(),
    (xp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.color,
        o = void 0 === i ? "primary" : i,
        a = e.component,
        s = void 0 === a ? "a" : a,
        l = e.onBlur,
        c = e.onFocus,
        u = e.TypographyClasses,
        d = e.underline,
        p = void 0 === d ? "hover" : d,
        i = e.variant,
        a = void 0 === i ? "inherit" : i,
        d = xu(e, [
          "classes",
          "className",
          "color",
          "component",
          "onBlur",
          "onFocus",
          "TypographyClasses",
          "underline",
          "variant",
        ]),
        i = Qg(),
        f = i.isFocusVisible,
        h = i.onBlurVisible,
        e = i.ref,
        i = mh.useState(!1),
        m = i[0],
        g = i[1],
        e = Ig(t, e);
      return mh.createElement(
        Cv,
        Su(
          {
            className: Ph(
              n.root,
              n["underline".concat(ag(p))],
              r,
              m && n.focusVisible,
              "button" === s && n.button
            ),
            classes: u,
            color: o,
            component: s,
            onBlur: function (e) {
              m && (h(), g(!1)), l && l(e);
            },
            onFocus: function (e) {
              f(e) && g(!0), c && c(e);
            },
            ref: e,
            variant: a,
          },
          d
        )
      );
    })),
    Uh(
      {
        root: {},
        underlineNone: { textDecoration: "none" },
        underlineHover: {
          textDecoration: "none",
          "&:hover": { textDecoration: "underline" },
        },
        underlineAlways: { textDecoration: "underline" },
        button: {
          position: "relative",
          WebkitTapHighlightColor: "transparent",
          backgroundColor: "transparent",
          outline: 0,
          border: 0,
          margin: 0,
          borderRadius: 0,
          padding: 0,
          cursor: "pointer",
          userSelect: "none",
          verticalAlign: "middle",
          "-moz-appearance": "none",
          "-webkit-appearance": "none",
          "&::-moz-focus-inner": { borderStyle: "none" },
          "&$focusVisible": { outline: "auto" },
        },
        focusVisible: {},
      },
      { name: "PwzrLink" }
    )(xp),
    Q(),
    Q();
  var jy = mh.createContext({}),
    of = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.component,
        a = void 0 === o ? "ul" : o,
        s = e.dense,
        l = void 0 !== s && s,
        c = e.disablePadding,
        o = void 0 !== c && c,
        s = e.subheader,
        c = xu(e, [
          "children",
          "classes",
          "className",
          "component",
          "dense",
          "disablePadding",
          "subheader",
        ]),
        e = mh.useMemo(
          function () {
            return { dense: l };
          },
          [l]
        );
      return mh.createElement(
        jy.Provider,
        { value: e },
        mh.createElement(
          a,
          Su(
            {
              className: Ph(
                r.root,
                i,
                l && r.dense,
                !o && r.padding,
                s && r.subheader
              ),
              ref: t,
            },
            c
          ),
          s,
          n
        )
      );
    }),
    Hy = Uh(
      {
        root: {
          listStyle: "none",
          margin: 0,
          padding: 0,
          position: "relative",
        },
        padding: { paddingTop: 8, paddingBottom: 8 },
        dense: {},
        subheader: { paddingTop: 0 },
      },
      { name: "PwzrList" }
    )(of);
  Q();
  var Vy = "undefined" == typeof window ? mh.useEffect : mh.useLayoutEffect,
    vp = mh.forwardRef(function (e, t) {
      var n = e.alignItems,
        r = void 0 === n ? "center" : n,
        i = e.autoFocus,
        o = void 0 !== i && i,
        a = e.button,
        s = void 0 !== a && a,
        l = e.children,
        c = e.classes,
        u = e.className,
        d = e.component,
        p = e.ContainerComponent,
        f = void 0 === p ? "li" : p,
        h = e.ContainerProps,
        m = (h = void 0 === h ? {} : h).className,
        g = xu(h, ["className"]),
        v = e.dense,
        y = void 0 !== v && v,
        n = e.disabled,
        i = void 0 !== n && n,
        a = e.disableGutters,
        p = void 0 !== a && a,
        h = e.divider,
        v = void 0 !== h && h,
        n = e.focusVisibleClassName,
        a = e.selected,
        h = void 0 !== a && a,
        a = xu(e, [
          "alignItems",
          "autoFocus",
          "button",
          "children",
          "classes",
          "className",
          "component",
          "ContainerComponent",
          "ContainerProps",
          "dense",
          "disabled",
          "disableGutters",
          "divider",
          "focusVisibleClassName",
          "selected",
        ]),
        e = mh.useContext(jy),
        y = { dense: y || e.dense || !1, alignItems: r },
        b = mh.useRef(null);
      Vy(
        function () {
          o && b.current && b.current.focus();
        },
        [o]
      );
      (e = mh.Children.toArray(l)),
        (l = e.length && Cy(e[e.length - 1], ["ListItemSecondaryAction"])),
        (t = Ig(
          mh.useCallback(function (e) {
            b.current = zg.findDOMNode(e);
          }, []),
          t
        )),
        (i = Su(
          {
            className: Ph(
              c.root,
              u,
              y.dense && c.dense,
              !p && c.gutters,
              v && c.divider,
              i && c.disabled,
              s && c.button,
              "center" !== r && c.alignItemsFlexStart,
              l && c.secondaryAction,
              h && c.selected
            ),
            disabled: i,
          },
          a
        )),
        (a = d || "li");
      return (
        s &&
          ((i.component = d || "div"),
          (i.focusVisibleClassName = Ph(c.focusVisible, n)),
          (a = nv)),
        l
          ? ((a = i.component || d ? a : "div"),
            "li" === f &&
              ("li" === a
                ? (a = "div")
                : "li" === i.component && (i.component = "div")),
            mh.createElement(
              jy.Provider,
              { value: y },
              mh.createElement(
                f,
                Su({ className: Ph(c.container, m), ref: t }, g),
                mh.createElement(a, i, e),
                e.pop()
              )
            ))
          : mh.createElement(
              jy.Provider,
              { value: y },
              mh.createElement(a, Su({ ref: t }, i), e)
            )
      );
    }),
    qy = Uh(
      function (e) {
        return {
          root: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            textDecoration: "none",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "left",
            paddingTop: 8,
            paddingBottom: 8,
            "&$focusVisible": { backgroundColor: e.palette.action.selected },
            "&$selected, &$selected:hover": {
              backgroundColor: e.palette.action.selected,
            },
            "&$disabled": { opacity: 0.5 },
          },
          container: { position: "relative" },
          focusVisible: {},
          dense: { paddingTop: 4, paddingBottom: 4 },
          alignItemsFlexStart: { alignItems: "flex-start" },
          disabled: {},
          divider: {
            borderBottom: "1px solid ".concat(e.palette.divider),
            backgroundClip: "padding-box",
          },
          gutters: { paddingLeft: 16, paddingRight: 16 },
          button: {
            transition: e.transitions.create("background-color", {
              duration: e.transitions.duration.shortest,
            }),
            "&:hover": {
              textDecoration: "none",
              backgroundColor: e.palette.action.hover,
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
          },
          secondaryAction: { paddingRight: 48 },
          selected: {},
        };
      },
      { name: "PwzrListItem" }
    )(vp);
  function Uy(e, t) {
    var n = 0;
    return (
      "number" == typeof t
        ? (n = t)
        : "center" === t
        ? (n = e.height / 2)
        : "bottom" === t && (n = e.height),
      n
    );
  }
  function Gy(e, t) {
    var n = 0;
    return (
      "number" == typeof t
        ? (n = t)
        : "center" === t
        ? (n = e.width / 2)
        : "right" === t && (n = e.width),
      n
    );
  }
  function Yy(e) {
    return [e.horizontal, e.vertical]
      .map(function (e) {
        return "number" == typeof e ? "".concat(e, "px") : e;
      })
      .join(" ");
  }
  function Xy(e) {
    return "function" == typeof e ? e() : e;
  }
  Q(),
    (_f = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = xu(e, ["classes", "className"]),
        e = mh.useContext(jy);
      return mh.createElement(
        "div",
        Su(
          {
            className: Ph(
              n.root,
              r,
              "flex-start" === e.alignItems && n.alignItemsFlexStart
            ),
            ref: t,
          },
          i
        )
      );
    })),
    Uh(
      {
        root: { minWidth: 56, flexShrink: 0 },
        alignItemsFlexStart: { marginTop: 8 },
      },
      { name: "PwzrListItemAvatar" }
    )(_f),
    Q(),
    (xp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = xu(e, ["classes", "className"]),
        e = mh.useContext(jy);
      return mh.createElement(
        "div",
        Su(
          {
            className: Ph(
              n.root,
              r,
              "flex-start" === e.alignItems && n.alignItemsFlexStart
            ),
            ref: t,
          },
          i
        )
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            minWidth: 56,
            color: e.palette.action.active,
            flexShrink: 0,
            display: "inline-flex",
          },
          alignItemsFlexStart: { marginTop: 8 },
        };
      },
      { name: "PwzrListItemIcon" }
    )(xp),
    Q(),
    ((of = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        e = xu(e, ["classes", "className"]);
      return mh.createElement(
        "div",
        Su({ className: Ph(n.root, r), ref: t }, e)
      );
    })).muiName = "ListItemSecondaryAction"),
    Uh(
      {
        root: {
          position: "absolute",
          right: 16,
          top: "50%",
          transform: "translateY(-50%)",
        },
      },
      { name: "PwzrListItemSecondaryAction" }
    )(of),
    Q(),
    (vp = mh.forwardRef(function (e, t) {
      var n = e.children,
        r = e.classes,
        i = e.className,
        o = e.disableTypography,
        a = void 0 !== o && o,
        s = e.inset,
        l = void 0 !== s && s,
        c = e.primary,
        u = e.primaryTypographyProps,
        d = e.secondary,
        o = e.secondaryTypographyProps,
        s = xu(e, [
          "children",
          "classes",
          "className",
          "disableTypography",
          "inset",
          "primary",
          "primaryTypographyProps",
          "secondary",
          "secondaryTypographyProps",
        ]),
        e = mh.useContext(jy).dense,
        n = null != c ? c : n;
      null == n ||
        n.type === Cv ||
        a ||
        (n = mh.createElement(
          Cv,
          Su(
            {
              variant: e ? "body2" : "body1",
              className: r.primary,
              component: "span",
            },
            u
          ),
          n
        ));
      return (
        null == d ||
          d.type === Cv ||
          a ||
          (d = mh.createElement(
            Cv,
            Su(
              {
                variant: "body2",
                className: r.secondary,
                color: "textSecondary",
              },
              o
            ),
            d
          )),
        mh.createElement(
          "div",
          Su(
            {
              className: Ph(
                r.root,
                i,
                e && r.dense,
                l && r.inset,
                n && d && r.multiline
              ),
              ref: t,
            },
            s
          ),
          n,
          d
        )
      );
    })),
    Uh(
      {
        root: { flex: "1 1 auto", minWidth: 0, marginTop: 4, marginBottom: 4 },
        multiline: { marginTop: 6, marginBottom: 6 },
        dense: {},
        inset: { paddingLeft: 56 },
        primary: {},
        secondary: {},
      },
      { name: "PwzrListItemText" }
    )(vp),
    Q(),
    (_f = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.color,
        o = void 0 === i ? "default" : i,
        a = e.component,
        s = void 0 === a ? "li" : a,
        l = e.disableGutters,
        i = void 0 !== l && l,
        a = e.disableSticky,
        l = void 0 !== a && a,
        a = e.inset,
        a = void 0 !== a && a,
        e = xu(e, [
          "classes",
          "className",
          "color",
          "component",
          "disableGutters",
          "disableSticky",
          "inset",
        ]);
      return mh.createElement(
        s,
        Su(
          {
            className: Ph(
              n.root,
              r,
              "default" !== o && n["color".concat(ag(o))],
              a && n.inset,
              !l && n.sticky,
              !i && n.gutters
            ),
            ref: t,
          },
          e
        )
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            boxSizing: "border-box",
            lineHeight: "48px",
            listStyle: "none",
            color: e.palette.text.secondary,
            fontFamily: e.typography.fontFamily,
            fontWeight: e.typography.fontWeightMedium,
            fontSize: e.typography.pxToRem(14),
          },
          colorPrimary: { color: e.palette.primary.main },
          colorInherit: { color: "inherit" },
          gutters: { paddingLeft: 16, paddingRight: 16 },
          inset: { paddingLeft: 72 },
          sticky: {
            position: "sticky",
            top: 0,
            zIndex: 1,
            backgroundColor: "inherit",
          },
        };
      },
      { name: "PwzrListSubheader" }
    )(_f),
    Q();
  var xp = mh.forwardRef(function (e, t) {
      var n = e.action,
        c = e.anchorEl,
        r = e.anchorOrigin,
        i = void 0 === r ? { vertical: "top", horizontal: "left" } : r,
        o = e.anchorPosition,
        a = e.anchorReference,
        u = void 0 === a ? "anchorEl" : a,
        s = e.children,
        l = e.classes,
        d = e.className,
        p = e.container,
        f = e.elevation,
        h = void 0 === f ? 8 : f,
        m = e.getContentAnchorEl,
        g = e.marginThreshold,
        v = void 0 === g ? 16 : g,
        y = e.onEnter,
        b = e.onEntered,
        w = e.onEntering,
        x = e.onExit,
        E = e.onExited,
        S = e.onExiting,
        C = e.open,
        k = e.PaperProps,
        r = void 0 === k ? {} : k,
        a = e.transformOrigin,
        T = void 0 === a ? { vertical: "top", horizontal: "left" } : a,
        f = e.TransitionComponent,
        g = void 0 === f ? Dy : f,
        k = e.transitionDuration,
        a = void 0 === k ? "auto" : k,
        f = e.TransitionProps,
        k = void 0 === f ? {} : f,
        f = xu(e, [
          "action",
          "anchorEl",
          "anchorOrigin",
          "anchorPosition",
          "anchorReference",
          "children",
          "classes",
          "className",
          "container",
          "elevation",
          "getContentAnchorEl",
          "marginThreshold",
          "onEnter",
          "onEntered",
          "onEntering",
          "onExit",
          "onExited",
          "onExiting",
          "open",
          "PaperProps",
          "transformOrigin",
          "TransitionComponent",
          "transitionDuration",
          "TransitionProps",
        ]),
        P = mh.useRef(),
        z = mh.useCallback(
          function (e) {
            if ("anchorPosition" === u) return o;
            var t = Xy(c),
              t = (t instanceof Gv(t).Element
                ? t
                : Fv(P.current).body
              ).getBoundingClientRect(),
              e = 0 === e ? i.vertical : "center";
            return {
              top: t.top + Uy(t, e),
              left: t.left + Gy(t, i.horizontal),
            };
          },
          [c, i.horizontal, i.vertical, o, u]
        ),
        O = mh.useCallback(
          function (e) {
            var r,
              t = 0;
            return (
              !m ||
                "anchorEl" !== u ||
                ((r = m(e)) &&
                  e.contains(r) &&
                  ((e = (function (e) {
                    for (var t = r, n = 0; t && t !== e; )
                      n += (t = t.parentElement).scrollTop;
                    return n;
                  })(e)),
                  (t = r.offsetTop + r.clientHeight / 2 - e || 0))),
              t
            );
          },
          [i.vertical, u, m]
        ),
        R = mh.useCallback(
          function (e) {
            var t =
              1 < arguments.length && void 0 !== arguments[1]
                ? arguments[1]
                : 0;
            return {
              vertical: Uy(e, T.vertical) + t,
              horizontal: Gy(e, T.horizontal),
            };
          },
          [T.horizontal, T.vertical]
        ),
        M = mh.useCallback(
          function (e) {
            var t = O(e),
              n = { width: e.offsetWidth, height: e.offsetHeight },
              r = R(n, t);
            if ("none" === u)
              return { top: null, left: null, transformOrigin: Yy(r) };
            var i,
              o = z(t),
              a = o.top - r.vertical,
              s = o.left - r.horizontal,
              l = a + n.height,
              e = s + n.width,
              t = Gv(Xy(c)),
              o = t.innerHeight - v,
              n = t.innerWidth - v;
            return (
              a < v
                ? ((a -= t = a - v), (r.vertical += t))
                : o < l && ((a -= i = l - o), (r.vertical += i)),
              s < v
                ? ((s -= i = s - v), (r.horizontal += i))
                : n < e && ((s -= n = e - n), (r.horizontal += n)),
              {
                top: "".concat(Math.round(a), "px"),
                left: "".concat(Math.round(s), "px"),
                transformOrigin: Yy(r),
              }
            );
          },
          [c, u, z, O, R, v]
        ),
        N = mh.useCallback(
          function () {
            var e,
              t = P.current;
            t &&
              (null !== (e = M(t)).top && (t.style.top = e.top),
              null !== e.left && (t.style.left = e.left),
              (t.style.transformOrigin = e.transformOrigin));
          },
          [M]
        ),
        e = mh.useCallback(function (e) {
          P.current = zg.findDOMNode(e);
        }, []);
      mh.useEffect(function () {
        C && N();
      }),
        mh.useImperativeHandle(
          n,
          function () {
            return C
              ? {
                  updatePosition: function () {
                    N();
                  },
                }
              : null;
          },
          [C, N]
        ),
        mh.useEffect(
          function () {
            if (C) {
              var e = oy(function () {
                N();
              });
              return (
                window.addEventListener("resize", e),
                function () {
                  e.clear(), window.removeEventListener("rezise", e);
                }
              );
            }
          },
          [C, N]
        );
      n = a;
      "auto" !== a || g.muiSupportAuto || (n = void 0);
      p = p || (c ? Fv(Xy(c)).body : void 0);
      return mh.createElement(
        ry,
        Su(
          {
            container: p,
            open: C,
            ref: t,
            BackdropProps: { invisible: !0 },
            className: Ph(l.root, d),
          },
          f
        ),
        mh.createElement(
          g,
          Su(
            {
              appear: !0,
              in: C,
              onEnter: y,
              onEntered: b,
              onExit: x,
              onExited: E,
              onExiting: S,
              timeout: n,
            },
            k,
            {
              onEntering: qv(function (e, t) {
                w && w(e, t), N();
              }, k.onEntering),
            }
          ),
          mh.createElement(
            mg,
            Su({ elevation: h, ref: e }, r, {
              className: Ph(l.paper, r.className),
            }),
            s
          )
        )
      );
    }),
    Ky = Uh(
      {
        root: {},
        paper: {
          position: "absolute",
          overflowY: "auto",
          overflowX: "hidden",
          minWidth: 16,
          minHeight: 16,
          maxWidth: "calc(100% - 32px)",
          maxHeight: "calc(100% - 32px)",
          outline: 0,
        },
      },
      { name: "PwzrPopover" }
    )(xp);
  function Zy(e, t, n) {
    return e === t
      ? e.firstChild
      : t && t.nextElementSibling
      ? t.nextElementSibling
      : n
      ? null
      : e.firstChild;
  }
  function Qy(e, t, n) {
    return e === t
      ? n
        ? e.firstChild
        : e.lastChild
      : t && t.previousElementSibling
      ? t.previousElementSibling
      : n
      ? null
      : e.lastChild;
  }
  function Jy(e, t) {
    if (void 0 === t) return !0;
    var n = e.innerText;
    return (
      void 0 === n && (n = e.textContent),
      0 !== (n = n.trim().toLowerCase()).length &&
        (t.repeating ? n[0] === t.keys[0] : 0 === n.indexOf(t.keys.join("")))
    );
  }
  function eb(e, t, n, r, i) {
    for (var o = !1, a = r(e, t, !!t && n); a; ) {
      if (a === e.firstChild) {
        if (o) return;
        o = !0;
      }
      if (
        a.hasAttribute("tabindex") &&
        !a.disabled &&
        "true" !== a.getAttribute("aria-disabled") &&
        Jy(a, i)
      )
        return a.focus(), 1;
      a = r(e, a, n);
    }
  }
  Q();
  var tb = "undefined" == typeof window ? mh.useEffect : mh.useLayoutEffect,
    nb = mh.forwardRef(function (e, t) {
      var n = e.actions,
        r = e.autoFocus,
        i = void 0 !== r && r,
        o = e.autoFocusItem,
        a = void 0 !== o && o,
        s = e.children,
        r = e.className,
        l = e.onKeyDown,
        o = e.disableListWrap,
        c = void 0 !== o && o,
        o = e.variant,
        u = void 0 === o ? "selectedMenu" : o,
        e = xu(e, [
          "actions",
          "autoFocus",
          "autoFocusItem",
          "children",
          "className",
          "onKeyDown",
          "disableListWrap",
          "variant",
        ]),
        d = mh.useRef(null),
        p = mh.useRef({
          keys: [],
          repeating: !0,
          previousKeyMatched: !0,
          lastTime: null,
        });
      tb(
        function () {
          i && d.current.focus();
        },
        [i]
      ),
        mh.useImperativeHandle(
          n,
          function () {
            return {
              adjustStyleForScrollbar: function (e, t) {
                var n = !d.current.style.width;
                return (
                  e.clientHeight < d.current.clientHeight &&
                    n &&
                    ((n = "".concat(Uv(), "px")),
                    (d.current.style[
                      "rtl" === t.direction ? "paddingLeft" : "paddingRight"
                    ] = n),
                    (d.current.style.width = "calc(100% + ".concat(n, ")"))),
                  d.current
                );
              },
            };
          },
          []
        );
      var t = Ig(
          mh.useCallback(function (e) {
            d.current = zg.findDOMNode(e);
          }, []),
          t
        ),
        f = -1;
      mh.Children.forEach(s, function (e, t) {
        mh.isValidElement(e) &&
          (e.props.disabled ||
            ((("selectedMenu" === u && e.props.selected) || -1 === f) &&
              (f = t)));
      });
      s = mh.Children.map(s, function (e, t) {
        if (t === f) {
          t = {};
          if (
            (a && (t.autoFocus = !0),
            void 0 === e.props.tabIndex &&
              "selectedMenu" === u &&
              (t.tabIndex = 0),
            null !== t)
          )
            return mh.cloneElement(e, t);
        }
        return e;
      });
      return mh.createElement(
        Hy,
        Su(
          {
            role: "menu",
            ref: t,
            className: r,
            onKeyDown: function (e) {
              var t,
                n,
                r = d.current,
                i = e.key,
                o = Fv(r).activeElement;
              "ArrowDown" === i
                ? (e.preventDefault(), eb(r, o, c, Zy))
                : "ArrowUp" === i
                ? (e.preventDefault(), eb(r, o, c, Qy))
                : "Home" === i
                ? (e.preventDefault(), eb(r, null, c, Zy))
                : "End" === i
                ? (e.preventDefault(), eb(r, null, c, Qy))
                : 1 === i.length &&
                  ((t = p.current),
                  (n = i.toLowerCase()),
                  (i = performance.now()),
                  0 < t.keys.length &&
                    (500 < i - t.lastTime
                      ? ((t.keys = []),
                        (t.repeating = !0),
                        (t.previousKeyMatched = !0))
                      : t.repeating && n !== t.keys[0] && (t.repeating = !1)),
                  (t.lastTime = i),
                  t.keys.push(n),
                  (n = o && !t.repeating && Jy(o, t)),
                  t.previousKeyMatched && (n || eb(r, o, !1, Zy, t))
                    ? e.preventDefault()
                    : (t.previousKeyMatched = !1)),
                l && l(e);
            },
            tabIndex: i ? 0 : -1,
          },
          e
        ),
        s
      );
    });
  Q();
  var rb = { vertical: "top", horizontal: "right" },
    ib = { vertical: "top", horizontal: "left" },
    of = mh.forwardRef(function (e, t) {
      var n = e.autoFocus,
        r = void 0 === n || n,
        i = e.children,
        o = e.classes,
        a = e.disableAutoFocusItem,
        s = void 0 !== a && a,
        l = e.MenuListProps,
        c = void 0 === l ? {} : l,
        u = e.onClose,
        d = e.onEntering,
        p = e.open,
        f = e.PaperProps,
        n = void 0 === f ? {} : f,
        a = e.PopoverClasses,
        l = e.transitionDuration,
        f = void 0 === l ? "auto" : l,
        l = e.variant,
        h = void 0 === l ? "selectedMenu" : l,
        l = xu(e, [
          "autoFocus",
          "children",
          "classes",
          "disableAutoFocusItem",
          "MenuListProps",
          "onClose",
          "onEntering",
          "open",
          "PaperProps",
          "PopoverClasses",
          "transitionDuration",
          "variant",
        ]),
        m = qh(),
        e = r && !s && p,
        g = mh.useRef(null),
        v = mh.useRef(null),
        y = -1;
      mh.Children.map(i, function (e, t) {
        mh.isValidElement(e) &&
          (e.props.disabled ||
            ((("menu" !== h && e.props.selected) || -1 === y) && (y = t)));
      });
      i = mh.Children.map(i, function (t, e) {
        return e === y
          ? mh.cloneElement(t, {
              ref: function (e) {
                (v.current = zg.findDOMNode(e)), Lg(t.ref, e);
              },
            })
          : t;
      });
      return mh.createElement(
        Ky,
        Su(
          {
            getContentAnchorEl: function () {
              return v.current;
            },
            classes: a,
            onClose: u,
            onEntering: function (e, t) {
              g.current && g.current.adjustStyleForScrollbar(e, m),
                d && d(e, t);
            },
            anchorOrigin: "rtl" === m.direction ? rb : ib,
            transformOrigin: "rtl" === m.direction ? rb : ib,
            PaperProps: Su({}, n, {
              classes: Su({}, n.classes, { root: o.paper }),
            }),
            open: p,
            ref: t,
            transitionDuration: f,
          },
          l
        ),
        mh.createElement(
          nb,
          Su(
            {
              onKeyDown: function (e) {
                "Tab" === e.key &&
                  (e.preventDefault(), u && u(e, "tabKeyDown"));
              },
              actions: g,
              autoFocus: r && (-1 === y || s),
              autoFocusItem: e,
              variant: h,
            },
            c,
            { className: Ph(o.list, c.className) }
          ),
          i
        )
      );
    }),
    ob = Uh(
      {
        paper: {
          maxHeight: "calc(100% - 96px)",
          WebkitOverflowScrolling: "touch",
        },
        list: { outline: 0 },
      },
      { name: "PwzrMenu" }
    )(of);
  Q();
  var vp = mh.forwardRef(function (e, t) {
      var n,
        r = e.classes,
        i = e.className,
        o = e.component,
        a = void 0 === o ? "li" : o,
        s = e.disableGutters,
        l = void 0 !== s && s,
        c = e.role,
        u = void 0 === c ? "menuitem" : c,
        o = e.selected,
        s = e.tabIndex,
        c = xu(e, [
          "classes",
          "className",
          "component",
          "disableGutters",
          "role",
          "selected",
          "tabIndex",
        ]);
      return (
        e.disabled || (n = void 0 !== s ? s : -1),
        mh.createElement(
          qy,
          Su(
            {
              button: !0,
              role: u,
              tabIndex: n,
              component: a,
              selected: o,
              disableGutters: l,
              classes: { dense: r.dense },
              className: Ph(r.root, i, o && r.selected, !l && r.gutters),
              ref: t,
            },
            c
          )
        )
      );
    }),
    ab = Uh(
      function (e) {
        return {
          root: Su(
            {},
            e.typography.body1,
            bu(
              {
                minHeight: 48,
                paddingTop: 6,
                paddingBottom: 6,
                boxSizing: "border-box",
                width: "auto",
                overflow: "hidden",
                whiteSpace: "nowrap",
              },
              e.breakpoints.up("sm"),
              { minHeight: "auto" }
            )
          ),
          gutters: {},
          selected: {},
          dense: Su({}, e.typography.body2, { minHeight: "auto" }),
        };
      },
      { name: "PwzrMenuItem" }
    )(vp);
  Q(),
    (_f = mh.forwardRef(function (e, t) {
      var n = e.activeStep,
        r = void 0 === n ? 0 : n,
        i = e.backButton,
        o = e.classes,
        a = e.className,
        s = e.LinearProgressProps,
        l = e.nextButton,
        c = e.position,
        u = void 0 === c ? "bottom" : c,
        n = e.steps,
        c = e.variant,
        c = void 0 === c ? "dots" : c,
        e = xu(e, [
          "activeStep",
          "backButton",
          "classes",
          "className",
          "LinearProgressProps",
          "nextButton",
          "position",
          "steps",
          "variant",
        ]);
      return mh.createElement(
        mg,
        Su(
          {
            square: !0,
            elevation: 0,
            className: Ph(o.root, o["position".concat(ag(u))], a),
            ref: t,
          },
          e
        ),
        i,
        "text" === c && mh.createElement(mh.Fragment, null, r + 1, " / ", n),
        "dots" === c &&
          mh.createElement(
            "div",
            { className: o.dots },
            Mf(new Array(n)).map(function (e, t) {
              return mh.createElement("div", {
                key: t,
                className: Ph(o.dot, t === r && o.dotActive),
              });
            })
          ),
        "progress" === c &&
          mh.createElement(
            $y,
            Su(
              {
                className: o.progress,
                variant: "determinate",
                value: Math.ceil((r / (n - 1)) * 100),
              },
              s
            )
          ),
        l
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            background: e.palette.background.default,
            padding: 8,
          },
          positionBottom: {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: e.zIndex.mobileStepper,
          },
          positionTop: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: e.zIndex.mobileStepper,
          },
          positionStatic: {},
          dots: { display: "flex", flexDirection: "row" },
          dot: {
            backgroundColor: e.palette.action.disabled,
            borderRadius: "50%",
            width: 8,
            height: 8,
            margin: "0 2px",
          },
          dotActive: { backgroundColor: e.palette.primary.main },
          progress: { width: "50%" },
        };
      },
      { name: "PwzrMobileStepper" }
    )(_f),
    Q(),
    Q();
  var sb = mh.forwardRef(function (e, t) {
    var n = e.classes,
      r = e.className,
      i = e.disabled,
      o = e.IconComponent,
      a = e.inputRef,
      s = e.variant,
      l = void 0 === s ? "standard" : s,
      s = xu(e, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant",
      ]);
    return mh.createElement(
      mh.Fragment,
      null,
      mh.createElement(
        "select",
        Su(
          {
            className: Ph(n.root, n.select, n[l], r, i && n.disabled),
            disabled: i,
            ref: a || t,
          },
          s
        )
      ),
      e.multiple
        ? null
        : mh.createElement(o, {
            className: Ph(n.icon, n["icon".concat(ag(l))]),
          })
    );
  });
  Q();
  var lb = gg(mh.createElement("path", { d: "M7 10l5 5 5-5z" })),
    xp = function (e) {
      return {
        root: {},
        select: {
          "-moz-appearance": "none",
          "-webkit-appearance": "none",
          userSelect: "none",
          borderRadius: 0,
          minWidth: 16,
          cursor: "pointer",
          "&:focus": {
            backgroundColor:
              "light" === e.palette.type
                ? "rgba(0, 0, 0, 0.05)"
                : "rgba(255, 255, 255, 0.05)",
            borderRadius: 0,
          },
          "&::-ms-expand": { display: "none" },
          "&$disabled": { cursor: "default" },
          "&[multiple]": { height: "auto" },
          "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: e.palette.background.paper,
          },
          "&&": { paddingRight: 24 },
        },
        filled: { "&&": { paddingRight: 32 } },
        outlined: {
          borderRadius: e.shape.borderRadius,
          "&&": { paddingRight: 32 },
        },
        selectMenu: {
          height: "auto",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
        },
        disabled: {},
        icon: {
          position: "absolute",
          right: 0,
          top: "calc(50% - 12px)",
          color: e.palette.action.active,
          pointerEvents: "none",
        },
        iconOpen: { transform: "rotate(180deg)" },
        iconFilled: { right: 7 },
        iconOutlined: { right: 7 },
      };
    },
    cb = mh.createElement(If, null);
  ((of = mh.forwardRef(function (e, t) {
    var n = e.children,
      r = e.classes,
      i = e.IconComponent,
      o = void 0 === i ? lb : i,
      a = e.input,
      s = void 0 === a ? cb : a,
      i = e.inputProps,
      a =
        (e.variant,
        xu(e, [
          "children",
          "classes",
          "IconComponent",
          "input",
          "inputProps",
          "variant",
        ])),
      e = my({ props: e, muiFormControl: Mv(), states: ["variant"] });
    return mh.cloneElement(
      s,
      Su(
        {
          inputComponent: sb,
          inputProps: Su(
            {
              children: n,
              classes: r,
              IconComponent: o,
              variant: e.variant,
              type: void 0,
            },
            i,
            {},
            s ? s.props.inputProps : {}
          ),
          ref: t,
        },
        a
      )
    );
  })).muiName = "Select"),
    Uh(xp, { name: "PwzrNativeSelect" })(of),
    Q(),
    Q();
  var vp = mh.forwardRef(function (e, t) {
      e.children;
      var n = e.classes,
        r = e.className,
        i = e.label,
        o = e.labelWidth,
        a = e.notched,
        s = e.style,
        l = xu(e, [
          "children",
          "classes",
          "className",
          "label",
          "labelWidth",
          "notched",
          "style",
        ]),
        e = "rtl" === qh().direction ? "right" : "left";
      if (void 0 !== i)
        return mh.createElement(
          "fieldset",
          Su(
            { "aria-hidden": !0, className: Ph(n.root, r), ref: t, style: s },
            l
          ),
          mh.createElement(
            "legend",
            { className: Ph(n.legendLabelled, a && n.legendNotched) },
            i
              ? mh.createElement("span", null, i)
              : mh.createElement("span", {
                  dangerouslySetInnerHTML: { __html: "&#8203;" },
                })
          )
        );
      o = 0 < o ? 0.75 * o + 8 : 0.01;
      return mh.createElement(
        "fieldset",
        Su(
          {
            "aria-hidden": !0,
            style: Su(bu({}, "padding".concat(ag(e)), 8), s),
            className: Ph(n.root, r),
            ref: t,
          },
          l
        ),
        mh.createElement(
          "legend",
          { className: n.legend, style: { width: a ? o : 0.01 } },
          mh.createElement("span", {
            dangerouslySetInnerHTML: { __html: "&#8203;" },
          })
        )
      );
    }),
    ub = Uh(
      function (e) {
        return {
          root: {
            position: "absolute",
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: 0,
            paddingLeft: 8,
            pointerEvents: "none",
            borderRadius: "inherit",
            borderStyle: "solid",
            borderWidth: 1,
          },
          legend: {
            textAlign: "left",
            padding: 0,
            lineHeight: "11px",
            transition: e.transitions.create("width", {
              duration: 150,
              easing: e.transitions.easing.easeOut,
            }),
          },
          legendLabelled: {
            display: "block",
            width: "auto",
            textAlign: "left",
            padding: 0,
            height: 11,
            fontSize: "0.75em",
            visibility: "hidden",
            maxWidth: 0.01,
            transition: e.transitions.create("max-width", {
              duration: 50,
              easing: e.transitions.easing.easeOut,
            }),
            "& span": { paddingLeft: 5, paddingRight: 5 },
          },
          legendNotched: {
            maxWidth: 1e3,
            transition: e.transitions.create("max-width", {
              duration: 100,
              easing: e.transitions.easing.easeOut,
              delay: 50,
            }),
          },
        };
      },
      { name: "PrivateNotchedOutline" }
    )(vp);
  (_f = mh.forwardRef(function (e, t) {
    var n = e.classes,
      r = e.fullWidth,
      i = void 0 !== r && r,
      o = e.inputComponent,
      a = void 0 === o ? "input" : o,
      s = e.label,
      r = e.labelWidth,
      l = void 0 === r ? 0 : r,
      o = e.multiline,
      r = void 0 !== o && o,
      c = e.notched,
      o = e.type,
      o = void 0 === o ? "text" : o,
      e = xu(e, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type",
      ]);
    return mh.createElement(
      Sy,
      Su(
        {
          renderSuffix: function (e) {
            return mh.createElement(ub, {
              className: n.notchedOutline,
              label: s,
              labelWidth: l,
              notched:
                void 0 !== c
                  ? c
                  : Boolean(e.startAdornment || e.filled || e.focused),
            });
          },
          classes: Su({}, n, {
            root: Ph(n.root, n.underline),
            notchedOutline: null,
          }),
          fullWidth: i,
          inputComponent: a,
          multiline: r,
          ref: t,
          type: o,
        },
        e
      )
    );
  })).muiName = "Input";
  var db = Uh(
    function (e) {
      var t =
        "light" === e.palette.type
          ? "rgba(0, 0, 0, 0.23)"
          : "rgba(255, 255, 255, 0.23)";
      return {
        root: {
          position: "relative",
          borderRadius: e.shape.borderRadius,
          "&:hover $notchedOutline": { borderColor: e.palette.text.primary },
          "@media (hover: none)": {
            "&:hover $notchedOutline": { borderColor: t },
          },
          "&$focused $notchedOutline": {
            borderColor: e.palette.primary.main,
            borderWidth: 2,
          },
          "&$error $notchedOutline": { borderColor: e.palette.error.main },
          "&$disabled $notchedOutline": {
            borderColor: e.palette.action.disabled,
          },
        },
        colorSecondary: {
          "&$focused $notchedOutline": {
            borderColor: e.palette.secondary.main,
          },
        },
        focused: {},
        disabled: {},
        adornedStart: { paddingLeft: 14 },
        adornedEnd: { paddingRight: 14 },
        error: {},
        marginDense: {},
        multiline: {
          padding: "18.5px 14px",
          "&$marginDense": { paddingTop: 10.5, paddingBottom: 10.5 },
        },
        notchedOutline: { borderColor: t },
        input: {
          padding: "18.5px 14px",
          "&:-webkit-autofill": {
            WebkitBoxShadow:
              "dark" === e.palette.type ? "0 0 0 100px #266798 inset" : null,
            WebkitTextFillColor: "dark" === e.palette.type ? "#fff" : null,
            borderRadius: "inherit",
          },
        },
        inputMarginDense: { paddingTop: 10.5, paddingBottom: 10.5 },
        inputMultiline: { padding: 0 },
        inputAdornedStart: { paddingLeft: 0 },
        inputAdornedEnd: { paddingRight: 0 },
      };
    },
    { name: "PwzrOutlinedInput" }
  )(_f);
  Q();
  var pb =
      "undefined" != typeof window &&
      "undefined" != typeof document &&
      "undefined" != typeof navigator,
    fb = (function () {
      for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1)
        if (pb && 0 <= navigator.userAgent.indexOf(e[t])) return 1;
      return 0;
    })(),
    hb =
      pb && window.Promise
        ? function (e) {
            var t = !1;
            return function () {
              t ||
                ((t = !0),
                window.Promise.resolve().then(function () {
                  (t = !1), e();
                }));
            };
          }
        : function (e) {
            var t = !1;
            return function () {
              t ||
                ((t = !0),
                setTimeout(function () {
                  (t = !1), e();
                }, fb));
            };
          };
  function mb(e) {
    return e && "[object Function]" === {}.toString.call(e);
  }
  function gb(e, t) {
    if (1 !== e.nodeType) return [];
    e = e.ownerDocument.defaultView.getComputedStyle(e, null);
    return t ? e[t] : e;
  }
  function vb(e) {
    return "HTML" === e.nodeName ? e : e.parentNode || e.host;
  }
  function yb(e) {
    if (!e) return document.body;
    switch (e.nodeName) {
      case "HTML":
      case "BODY":
        return e.ownerDocument.body;
      case "#document":
        return e.body;
    }
    var t = gb(e),
      n = t.overflow,
      r = t.overflowX,
      t = t.overflowY;
    return /(auto|scroll|overlay)/.test(n + t + r) ? e : yb(vb(e));
  }
  function bb(e) {
    return e && e.referenceNode ? e.referenceNode : e;
  }
  var wb = pb && !(!window.MSInputMethodContext || !document.documentMode),
    xb = pb && /MSIE 10/.test(navigator.userAgent);
  function Eb(e) {
    return 11 === e ? wb : (10 !== e && wb) || xb;
  }
  function Sb(e) {
    if (!e) return document.documentElement;
    for (
      var t = Eb(10) ? document.body : null, n = e.offsetParent || null;
      n === t && e.nextElementSibling;

    )
      n = (e = e.nextElementSibling).offsetParent;
    var r = n && n.nodeName;
    return r && "BODY" !== r && "HTML" !== r
      ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) &&
        "static" === gb(n, "position")
        ? Sb(n)
        : n
      : (e ? e.ownerDocument : document).documentElement;
  }
  function Cb(e) {
    return null !== e.parentNode ? Cb(e.parentNode) : e;
  }
  function kb(e, t) {
    if (!(e && e.nodeType && t && t.nodeType)) return document.documentElement;
    var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
      r = n ? e : t,
      i = n ? t : e,
      n = document.createRange();
    n.setStart(r, 0), n.setEnd(i, 0);
    n = n.commonAncestorContainer;
    if ((e !== n && t !== n) || r.contains(i))
      return "BODY" === (i = (r = n).nodeName) ||
        ("HTML" !== i && Sb(r.firstElementChild) !== r)
        ? Sb(n)
        : n;
    n = Cb(e);
    return n.host ? kb(n.host, t) : kb(e, Cb(t).host);
  }
  function Tb(e, t) {
    var n =
        "top" === (1 < arguments.length && void 0 !== t ? t : "top")
          ? "scrollTop"
          : "scrollLeft",
      r = e.nodeName;
    if ("BODY" !== r && "HTML" !== r) return e[n];
    r = e.ownerDocument.documentElement;
    return (e.ownerDocument.scrollingElement || r)[n];
  }
  function Pb(e, t) {
    var n = "x" === t ? "Left" : "Top",
      t = "Left" == n ? "Right" : "Bottom";
    return (
      parseFloat(e["border" + n + "Width"]) +
      parseFloat(e["border" + t + "Width"])
    );
  }
  function zb(e, t, n, r) {
    return Math.max(
      t["offset" + e],
      t["scroll" + e],
      n["client" + e],
      n["offset" + e],
      n["scroll" + e],
      Eb(10)
        ? parseInt(n["offset" + e]) +
            parseInt(r["margin" + ("Height" === e ? "Top" : "Left")]) +
            parseInt(r["margin" + ("Height" === e ? "Bottom" : "Right")])
        : 0
    );
  }
  function Ob(e) {
    var t = e.body,
      n = e.documentElement,
      e = Eb(10) && getComputedStyle(n);
    return { height: zb("Height", t, n, e), width: zb("Width", t, n, e) };
  }
  function Rb(e, t, n) {
    return (
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  var Mb = function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    },
    of = function (e, t, n) {
      return t && Lb(e.prototype, t), n && Lb(e, n), e;
    },
    Nb =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
            r = arguments[t];
          for (n in r)
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      };
  function Lb(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  function Ib(e) {
    return Nb({}, e, { right: e.left + e.width, bottom: e.top + e.height });
  }
  function _b(e) {
    var t,
      n,
      r = {};
    try {
      Eb(10)
        ? ((r = e.getBoundingClientRect()),
          (t = Tb(e, "top")),
          (n = Tb(e, "left")),
          (r.top += t),
          (r.left += n),
          (r.bottom += t),
          (r.right += n))
        : (r = e.getBoundingClientRect());
    } catch (e) {}
    var i = {
        left: r.left,
        top: r.top,
        width: r.right - r.left,
        height: r.bottom - r.top,
      },
      o = "HTML" === e.nodeName ? Ob(e.ownerDocument) : {},
      a = o.width || e.clientWidth || i.width,
      s = o.height || e.clientHeight || i.height,
      o = e.offsetWidth - a,
      a = e.offsetHeight - s;
    return (
      (o || a) &&
        ((o -= Pb((s = gb(e)), "x")),
        (a -= Pb(s, "y")),
        (i.width -= o),
        (i.height -= a)),
      Ib(i)
    );
  }
  function Db(e, t, n) {
    var r = 2 < arguments.length && void 0 !== n && n,
      i = Eb(10),
      o = "HTML" === t.nodeName,
      a = _b(e),
      s = _b(t),
      l = yb(e),
      c = gb(t),
      u = parseFloat(c.borderTopWidth),
      d = parseFloat(c.borderLeftWidth);
    r && o && ((s.top = Math.max(s.top, 0)), (s.left = Math.max(s.left, 0)));
    a = Ib({
      top: a.top - s.top - u,
      left: a.left - s.left - d,
      width: a.width,
      height: a.height,
    });
    return (
      (a.marginTop = 0),
      (a.marginLeft = 0),
      !i &&
        o &&
        ((o = parseFloat(c.marginTop)),
        (c = parseFloat(c.marginLeft)),
        (a.top -= u - o),
        (a.bottom -= u - o),
        (a.left -= d - c),
        (a.right -= d - c),
        (a.marginTop = o),
        (a.marginLeft = c)),
      (i && !r ? t.contains(l) : t === l && "BODY" !== l.nodeName) &&
        (a = (function (e, t, n) {
          var r = 2 < arguments.length && void 0 !== n && n,
            i = Tb(t, "top"),
            o = Tb(t, "left"),
            r = r ? -1 : 1;
          return (
            (e.top += i * r),
            (e.bottom += i * r),
            (e.left += o * r),
            (e.right += o * r),
            e
          );
        })(a, t)),
      a
    );
  }
  function Ab(e) {
    if (!e || !e.parentElement || Eb()) return document.documentElement;
    for (var t = e.parentElement; t && "none" === gb(t, "transform"); )
      t = t.parentElement;
    return t || document.documentElement;
  }
  function Fb(e, t, n, r, i) {
    var o,
      a = 4 < arguments.length && void 0 !== i && i,
      s = { top: 0, left: 0 },
      l = a ? Ab(e) : kb(e, bb(t));
    "viewport" === r
      ? (s = (function (e, t) {
          var n = 1 < arguments.length && void 0 !== t && t,
            r = e.ownerDocument.documentElement,
            i = Db(e, r),
            o = Math.max(r.clientWidth, window.innerWidth || 0),
            a = Math.max(r.clientHeight, window.innerHeight || 0),
            s = n ? 0 : Tb(r),
            r = n ? 0 : Tb(r, "left");
          return Ib({
            top: s - i.top + i.marginTop,
            left: r - i.left + i.marginLeft,
            width: o,
            height: a,
          });
        })(l, a))
      : ((o = void 0),
        "scrollParent" === r
          ? "BODY" === (o = yb(vb(t))).nodeName &&
            (o = e.ownerDocument.documentElement)
          : (o = "window" === r ? e.ownerDocument.documentElement : r),
        (c = Db(o, l, a)),
        "HTML" !== o.nodeName ||
        (function e(t) {
          var n = t.nodeName;
          if ("BODY" === n || "HTML" === n) return !1;
          if ("fixed" === gb(t, "position")) return !0;
          t = vb(t);
          return !!t && e(t);
        })(l)
          ? (s = c)
          : ((l = (o = Ob(e.ownerDocument)).height),
            (o = o.width),
            (s.top += c.top - c.marginTop),
            (s.bottom = l + c.top),
            (s.left += c.left - c.marginLeft),
            (s.right = o + c.left)));
    var c = "number" == typeof (n = n || 0);
    return (
      (s.left += c ? n : n.left || 0),
      (s.top += c ? n : n.top || 0),
      (s.right -= c ? n : n.right || 0),
      (s.bottom -= c ? n : n.bottom || 0),
      s
    );
  }
  function Bb(e, t, n, r, i, o) {
    var a = 5 < arguments.length && void 0 !== o ? o : 0;
    if (-1 === e.indexOf("auto")) return e;
    var s = Fb(n, r, a, i),
      l = {
        top: { width: s.width, height: t.top - s.top },
        right: { width: s.right - t.right, height: s.height },
        bottom: { width: s.width, height: s.bottom - t.bottom },
        left: { width: t.left - s.left, height: s.height },
      },
      a = Object.keys(l)
        .map(function (e) {
          return Nb({ key: e }, l[e], { area: (e = l[e]).width * e.height });
        })
        .sort(function (e, t) {
          return t.area - e.area;
        }),
      s = a.filter(function (e) {
        var t = e.width,
          e = e.height;
        return t >= n.clientWidth && e >= n.clientHeight;
      }),
      s = (0 < s.length ? s : a)[0].key,
      a = e.split("-")[1];
    return s + (a ? "-" + a : "");
  }
  function Wb(e, t, n, r) {
    var i = 3 < arguments.length && void 0 !== r ? r : null;
    return Db(n, i ? Ab(t) : kb(t, bb(n)), i);
  }
  function $b(e) {
    var t = e.ownerDocument.defaultView.getComputedStyle(e),
      n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0),
      t = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
    return { width: e.offsetWidth + t, height: e.offsetHeight + n };
  }
  function jb(e) {
    var t = { left: "right", right: "left", bottom: "top", top: "bottom" };
    return e.replace(/left|right|bottom|top/g, function (e) {
      return t[e];
    });
  }
  function Hb(e, t, n) {
    n = n.split("-")[0];
    var r = $b(e),
      i = { width: r.width, height: r.height },
      o = -1 !== ["right", "left"].indexOf(n),
      a = o ? "top" : "left",
      s = o ? "left" : "top",
      e = o ? "height" : "width",
      o = o ? "width" : "height";
    return (
      (i[a] = t[a] + t[e] / 2 - r[e] / 2),
      (i[s] = n === s ? t[s] - r[o] : t[jb(s)]),
      i
    );
  }
  function Vb(e, t) {
    return Array.prototype.find ? e.find(t) : e.filter(t)[0];
  }
  function qb(e, n, t) {
    return (
      (void 0 === t
        ? e
        : e.slice(
            0,
            (function (e, t) {
              if (Array.prototype.findIndex)
                return e.findIndex(function (e) {
                  return e.name === t;
                });
              var n = Vb(e, function (e) {
                return e.name === t;
              });
              return e.indexOf(n);
            })(e, t)
          )
      ).forEach(function (e) {
        e.function &&
          console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
        var t = e.function || e.fn;
        e.enabled &&
          mb(t) &&
          ((n.offsets.popper = Ib(n.offsets.popper)),
          (n.offsets.reference = Ib(n.offsets.reference)),
          (n = t(n, e)));
      }),
      n
    );
  }
  function Ub(e, n) {
    return e.some(function (e) {
      var t = e.name;
      return e.enabled && t === n;
    });
  }
  function Gb(e) {
    for (
      var t = [!1, "ms", "Webkit", "Moz", "O"],
        n = e.charAt(0).toUpperCase() + e.slice(1),
        r = 0;
      r < t.length;
      r++
    ) {
      var i = t[r],
        i = i ? "" + i + n : e;
      if (void 0 !== document.body.style[i]) return i;
    }
    return null;
  }
  function Yb(e) {
    e = e.ownerDocument;
    return e ? e.defaultView : window;
  }
  function Xb() {
    var e, t, n;
    this.state.eventsEnabled ||
      (this.state =
        ((e = this.reference),
        this.options,
        (t = this.state),
        (n = this.scheduleUpdate),
        (t.updateBound = n),
        Yb(e).addEventListener("resize", t.updateBound, { passive: !0 }),
        (function e(t, n, r, i) {
          var o = "BODY" === t.nodeName,
            t = o ? t.ownerDocument.defaultView : t;
          t.addEventListener(n, r, { passive: !0 }),
            o || e(yb(t.parentNode), n, r, i),
            i.push(t);
        })((e = yb(e)), "scroll", t.updateBound, t.scrollParents),
        (t.scrollElement = e),
        (t.eventsEnabled = !0),
        t));
  }
  function Kb(e) {
    return "" !== e && !isNaN(parseFloat(e)) && isFinite(e);
  }
  function Zb(n, r) {
    Object.keys(r).forEach(function (e) {
      var t = "";
      -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(e) &&
        Kb(r[e]) &&
        (t = "px"),
        (n.style[e] = r[e] + t);
    });
  }
  var Qb = pb && /Firefox/i.test(navigator.userAgent);
  function Jb(e, t, n) {
    var r,
      i = Vb(e, function (e) {
        return e.name === t;
      }),
      o =
        !!i &&
        e.some(function (e) {
          return e.name === n && e.enabled && e.order < i.order;
        });
    return (
      o ||
        ((r = "`" + t + "`"),
        (e = "`" + n + "`"),
        console.warn(
          e +
            " modifier is required by " +
            r +
            " modifier in order to work, be sure to include it before " +
            r +
            "!"
        )),
      o
    );
  }
  var ew = (vp = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start",
  ]).slice(3);
  function tw(e, t) {
    var n = 1 < arguments.length && void 0 !== t && t,
      r = ew.indexOf(e),
      r = ew.slice(r + 1).concat(ew.slice(0, r));
    return n ? r.reverse() : r;
  }
  var _f = {
      placement: "bottom",
      positionFixed: !1,
      eventsEnabled: !0,
      removeOnDestroy: !1,
      onCreate: function () {},
      onUpdate: function () {},
      modifiers: {
        shift: {
          order: 100,
          enabled: !0,
          fn: function (e) {
            var t,
              n,
              r = e.placement,
              i = r.split("-")[0],
              o = r.split("-")[1];
            return (
              o &&
                ((t = (n = e.offsets).reference),
                (r = n.popper),
                (i = (n = -1 !== ["bottom", "top"].indexOf(i))
                  ? "width"
                  : "height"),
                (i = {
                  start: Rb({}, (n = n ? "left" : "top"), t[n]),
                  end: Rb({}, n, t[n] + t[i] - r[i]),
                }),
                (e.offsets.popper = Nb({}, r, i[o]))),
              e
            );
          },
        },
        offset: {
          order: 200,
          enabled: !0,
          fn: function (e, t) {
            var i,
              o,
              a,
              s,
              n = t.offset,
              r = e.placement,
              l = e.offsets,
              c = l.popper,
              u = l.reference,
              t = r.split("-")[0],
              l = Kb(+n)
                ? [+n, 0]
                : ((r = n),
                  (i = c),
                  (o = u),
                  (a = [0, 0]),
                  (s = -1 !== ["right", "left"].indexOf((n = t))),
                  (u = r.split(/(\+|\-)/).map(function (e) {
                    return e.trim();
                  })),
                  (n = u.indexOf(
                    Vb(u, function (e) {
                      return -1 !== e.search(/,|\s/);
                    })
                  )),
                  u[n] &&
                    -1 === u[n].indexOf(",") &&
                    console.warn(
                      "Offsets separated by white space(s) are deprecated, use a comma (,) instead."
                    ),
                  (r = /\s*,\s*|\s+/),
                  (-1 !== n
                    ? [
                        u.slice(0, n).concat([u[n].split(r)[0]]),
                        [u[n].split(r)[1]].concat(u.slice(n + 1)),
                      ]
                    : [u]
                  )
                    .map(function (e, t) {
                      var n = (1 === t ? !s : s) ? "height" : "width",
                        r = !1;
                      return e
                        .reduce(function (e, t) {
                          return "" === e[e.length - 1] &&
                            -1 !== ["+", "-"].indexOf(t)
                            ? ((e[e.length - 1] = t), (r = !0), e)
                            : r
                            ? ((e[e.length - 1] += t), (r = !1), e)
                            : e.concat(t);
                        }, [])
                        .map(function (e) {
                          return (function (e, t, n, r) {
                            var i = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                              o = +i[1],
                              i = i[2];
                            if (!o) return e;
                            if (0 !== i.indexOf("%"))
                              return "vh" === i || "vw" === i
                                ? (("vh" === i
                                    ? Math.max(
                                        document.documentElement.clientHeight,
                                        window.innerHeight || 0
                                      )
                                    : Math.max(
                                        document.documentElement.clientWidth,
                                        window.innerWidth || 0
                                      )) /
                                    100) *
                                    o
                                : o;
                            var a = void 0;
                            switch (i) {
                              case "%p":
                                a = n;
                                break;
                              case "%":
                              case "%r":
                              default:
                                a = r;
                            }
                            return (Ib(a)[t] / 100) * o;
                          })(e, n, i, o);
                        });
                    })
                    .forEach(function (n, r) {
                      n.forEach(function (e, t) {
                        Kb(e) && (a[r] += e * ("-" === n[t - 1] ? -1 : 1));
                      });
                    }),
                  a);
            return (
              "left" === t
                ? ((c.top += l[0]), (c.left -= l[1]))
                : "right" === t
                ? ((c.top += l[0]), (c.left += l[1]))
                : "top" === t
                ? ((c.left += l[0]), (c.top -= l[1]))
                : "bottom" === t && ((c.left += l[0]), (c.top += l[1])),
              (e.popper = c),
              e
            );
          },
          offset: 0,
        },
        preventOverflow: {
          order: 300,
          enabled: !0,
          fn: function (e, r) {
            var t = r.boundariesElement || Sb(e.instance.popper);
            e.instance.reference === t && (t = Sb(t));
            var n = Gb("transform"),
              i = e.instance.popper.style,
              o = i.top,
              a = i.left,
              s = i[n];
            (i.top = ""), (i.left = ""), (i[n] = "");
            var l = Fb(
              e.instance.popper,
              e.instance.reference,
              r.padding,
              t,
              e.positionFixed
            );
            (i.top = o), (i.left = a), (i[n] = s), (r.boundaries = l);
            var s = r.priority,
              c = e.offsets.popper,
              u = {
                primary: function (e) {
                  var t = c[e];
                  return (
                    c[e] < l[e] &&
                      !r.escapeWithReference &&
                      (t = Math.max(c[e], l[e])),
                    Rb({}, e, t)
                  );
                },
                secondary: function (e) {
                  var t = "right" === e ? "left" : "top",
                    n = c[t];
                  return (
                    c[e] > l[e] &&
                      !r.escapeWithReference &&
                      (n = Math.min(
                        c[t],
                        l[e] - ("right" === e ? c.width : c.height)
                      )),
                    Rb({}, t, n)
                  );
                },
              };
            return (
              s.forEach(function (e) {
                var t =
                  -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                c = Nb({}, c, u[t](e));
              }),
              (e.offsets.popper = c),
              e
            );
          },
          priority: ["left", "right", "top", "bottom"],
          padding: 5,
          boundariesElement: "scrollParent",
        },
        keepTogether: {
          order: 400,
          enabled: !0,
          fn: function (e) {
            var t = e.offsets,
              n = t.popper,
              r = t.reference,
              i = e.placement.split("-")[0],
              o = Math.floor,
              a = -1 !== ["top", "bottom"].indexOf(i),
              t = a ? "right" : "bottom",
              i = a ? "left" : "top",
              a = a ? "width" : "height";
            return (
              n[t] < o(r[i]) && (e.offsets.popper[i] = o(r[i]) - n[a]),
              n[i] > o(r[t]) && (e.offsets.popper[i] = o(r[t])),
              e
            );
          },
        },
        arrow: {
          order: 500,
          enabled: !0,
          fn: function (e, t) {
            if (!Jb(e.instance.modifiers, "arrow", "keepTogether")) return e;
            var n = t.element;
            if ("string" == typeof n) {
              if (!(n = e.instance.popper.querySelector(n))) return e;
            } else if (!e.instance.popper.contains(n))
              return (
                console.warn(
                  "WARNING: `arrow.element` must be child of its popper element!"
                ),
                e
              );
            var r = e.placement.split("-")[0],
              i = e.offsets,
              o = i.popper,
              a = i.reference,
              s = -1 !== ["left", "right"].indexOf(r),
              l = s ? "height" : "width",
              c = s ? "Top" : "Left",
              u = c.toLowerCase(),
              t = s ? "left" : "top",
              i = s ? "bottom" : "right",
              r = $b(n)[l];
            a[i] - r < o[u] && (e.offsets.popper[u] -= o[u] - (a[i] - r)),
              a[u] + r > o[i] && (e.offsets.popper[u] += a[u] + r - o[i]),
              (e.offsets.popper = Ib(e.offsets.popper));
            (s = a[u] + a[l] / 2 - r / 2),
              (i = gb(e.instance.popper)),
              (a = parseFloat(i["margin" + c])),
              (c = parseFloat(i["border" + c + "Width"])),
              (c = s - e.offsets.popper[u] - a - c),
              (c = Math.max(Math.min(o[l] - r, c), 0));
            return (
              (e.arrowElement = n),
              (e.offsets.arrow =
                (Rb((n = {}), u, Math.round(c)), Rb(n, t, ""), n)),
              e
            );
          },
          element: "[x-arrow]",
        },
        flip: {
          order: 600,
          enabled: !0,
          fn: function (c, u) {
            if (Ub(c.instance.modifiers, "inner")) return c;
            if (c.flipped && c.placement === c.originalPlacement) return c;
            var d = Fb(
                c.instance.popper,
                c.instance.reference,
                u.padding,
                u.boundariesElement,
                c.positionFixed
              ),
              p = c.placement.split("-")[0],
              f = jb(p),
              h = c.placement.split("-")[1] || "",
              m = [];
            switch (u.behavior) {
              case "flip":
                m = [p, f];
                break;
              case "clockwise":
                m = tw(p);
                break;
              case "counterclockwise":
                m = tw(p, !0);
                break;
              default:
                m = u.behavior;
            }
            return (
              m.forEach(function (e, t) {
                if (p !== e || m.length === t + 1) return c;
                (p = c.placement.split("-")[0]), (f = jb(p));
                var n = c.offsets.popper,
                  r = c.offsets.reference,
                  i = Math.floor,
                  o =
                    ("left" === p && i(n.right) > i(r.left)) ||
                    ("right" === p && i(n.left) < i(r.right)) ||
                    ("top" === p && i(n.bottom) > i(r.top)) ||
                    ("bottom" === p && i(n.top) < i(r.bottom)),
                  a = i(n.left) < i(d.left),
                  s = i(n.right) > i(d.right),
                  l = i(n.top) < i(d.top),
                  e = i(n.bottom) > i(d.bottom),
                  r =
                    ("left" === p && a) ||
                    ("right" === p && s) ||
                    ("top" === p && l) ||
                    ("bottom" === p && e),
                  n = -1 !== ["top", "bottom"].indexOf(p),
                  i =
                    !!u.flipVariations &&
                    ((n && "start" === h && a) ||
                      (n && "end" === h && s) ||
                      (!n && "start" === h && l) ||
                      (!n && "end" === h && e)),
                  l =
                    !!u.flipVariationsByContent &&
                    ((n && "start" === h && s) ||
                      (n && "end" === h && a) ||
                      (!n && "start" === h && e) ||
                      (!n && "end" === h && l)),
                  l = i || l;
                (o || r || l) &&
                  ((c.flipped = !0),
                  (o || r) && (p = m[t + 1]),
                  l && (h = "end" === h ? "start" : "start" === h ? "end" : h),
                  (c.placement = p + (h ? "-" + h : "")),
                  (c.offsets.popper = Nb(
                    {},
                    c.offsets.popper,
                    Hb(c.instance.popper, c.offsets.reference, c.placement)
                  )),
                  (c = qb(c.instance.modifiers, c, "flip")));
              }),
              c
            );
          },
          behavior: "flip",
          padding: 5,
          boundariesElement: "viewport",
          flipVariations: !1,
          flipVariationsByContent: !1,
        },
        inner: {
          order: 700,
          enabled: !1,
          fn: function (e) {
            var t = e.placement,
              n = t.split("-")[0],
              r = e.offsets,
              i = r.popper,
              o = r.reference,
              a = -1 !== ["left", "right"].indexOf(n),
              r = -1 === ["top", "left"].indexOf(n);
            return (
              (i[a ? "left" : "top"] =
                o[n] - (r ? i[a ? "width" : "height"] : 0)),
              (e.placement = jb(t)),
              (e.offsets.popper = Ib(i)),
              e
            );
          },
        },
        hide: {
          order: 800,
          enabled: !0,
          fn: function (e) {
            if (!Jb(e.instance.modifiers, "hide", "preventOverflow")) return e;
            var t = e.offsets.reference,
              n = Vb(e.instance.modifiers, function (e) {
                return "preventOverflow" === e.name;
              }).boundaries;
            if (
              t.bottom < n.top ||
              t.left > n.right ||
              t.top > n.bottom ||
              t.right < n.left
            ) {
              if (!0 === e.hide) return e;
              (e.hide = !0), (e.attributes["x-out-of-boundaries"] = "");
            } else {
              if (!1 === e.hide) return e;
              (e.hide = !1), (e.attributes["x-out-of-boundaries"] = !1);
            }
            return e;
          },
        },
        computeStyle: {
          order: 850,
          enabled: !0,
          fn: function (e, t) {
            var n = t.x,
              r = t.y,
              i = e.offsets.popper,
              o = Vb(e.instance.modifiers, function (e) {
                return "applyStyle" === e.name;
              }).gpuAcceleration;
            void 0 !== o &&
              console.warn(
                "WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!"
              );
            var a,
              s,
              l,
              c,
              u,
              d,
              p = void 0 !== o ? o : t.gpuAcceleration,
              f = Sb(e.instance.popper),
              h = _b(f),
              m = { position: i.position },
              s =
                ((a = e),
                (s = window.devicePixelRatio < 2 || !Qb),
                (l = a.offsets),
                (d = l.popper),
                (c = l.reference),
                (u = Math.round),
                (o = Math.floor),
                (t = function (e) {
                  return e;
                }),
                (i = u(c.width)),
                (l = u(d.width)),
                (c = -1 !== ["left", "right"].indexOf(a.placement)),
                (a = -1 !== a.placement.indexOf("-")),
                (o = s ? (c || a || i % 2 == l % 2 ? u : o) : t),
                (t = s ? u : t),
                {
                  left: o(
                    i % 2 == 1 && l % 2 == 1 && !a && s ? d.left - 1 : d.left
                  ),
                  top: t(d.top),
                  bottom: t(d.bottom),
                  right: o(d.right),
                }),
              t = "bottom" === n ? "top" : "bottom",
              o = "right" === r ? "left" : "right",
              d = Gb("transform"),
              r =
                "bottom" == t
                  ? "HTML" === f.nodeName
                    ? -f.clientHeight + s.bottom
                    : -h.height + s.bottom
                  : s.top,
              n =
                "right" == o
                  ? "HTML" === f.nodeName
                    ? -f.clientWidth + s.right
                    : -h.width + s.right
                  : s.left;
            p && d
              ? ((m[d] = "translate3d(" + n + "px, " + r + "px, 0)"),
                (m[t] = 0),
                (m[o] = 0),
                (m.willChange = "transform"))
              : ((p = "bottom" == t ? -1 : 1),
                (d = "right" == o ? -1 : 1),
                (m[t] = r * p),
                (m[o] = n * d),
                (m.willChange = t + ", " + o));
            o = { "x-placement": e.placement };
            return (
              (e.attributes = Nb({}, o, e.attributes)),
              (e.styles = Nb({}, m, e.styles)),
              (e.arrowStyles = Nb({}, e.offsets.arrow, e.arrowStyles)),
              e
            );
          },
          gpuAcceleration: !0,
          x: "bottom",
          y: "right",
        },
        applyStyle: {
          order: 900,
          enabled: !0,
          fn: function (e) {
            var t, n;
            return (
              Zb(e.instance.popper, e.styles),
              (t = e.instance.popper),
              (n = e.attributes),
              Object.keys(n).forEach(function (e) {
                !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e);
              }),
              e.arrowElement &&
                Object.keys(e.arrowStyles).length &&
                Zb(e.arrowElement, e.arrowStyles),
              e
            );
          },
          onLoad: function (e, t, n, r, i) {
            (i = Wb(i, t, e, n.positionFixed)),
              (e = Bb(
                n.placement,
                i,
                t,
                e,
                n.modifiers.flip.boundariesElement,
                n.modifiers.flip.padding
              ));
            return (
              t.setAttribute("x-placement", e),
              Zb(t, { position: n.positionFixed ? "fixed" : "absolute" }),
              n
            );
          },
          gpuAcceleration: void 0,
        },
      },
    },
    nw =
      (of(rw, [
        {
          key: "update",
          value: function () {
            return function () {
              var e;
              this.state.isDestroyed ||
                (((e = {
                  instance: this,
                  styles: {},
                  arrowStyles: {},
                  attributes: {},
                  flipped: !1,
                  offsets: {},
                }).offsets.reference = Wb(
                  this.state,
                  this.popper,
                  this.reference,
                  this.options.positionFixed
                )),
                (e.placement = Bb(
                  this.options.placement,
                  e.offsets.reference,
                  this.popper,
                  this.reference,
                  this.options.modifiers.flip.boundariesElement,
                  this.options.modifiers.flip.padding
                )),
                (e.originalPlacement = e.placement),
                (e.positionFixed = this.options.positionFixed),
                (e.offsets.popper = Hb(
                  this.popper,
                  e.offsets.reference,
                  e.placement
                )),
                (e.offsets.popper.position = this.options.positionFixed
                  ? "fixed"
                  : "absolute"),
                (e = qb(this.modifiers, e)),
                this.state.isCreated
                  ? this.options.onUpdate(e)
                  : ((this.state.isCreated = !0), this.options.onCreate(e)));
            }.call(this);
          },
        },
        {
          key: "destroy",
          value: function () {
            return function () {
              return (
                (this.state.isDestroyed = !0),
                Ub(this.modifiers, "applyStyle") &&
                  (this.popper.removeAttribute("x-placement"),
                  (this.popper.style.position = ""),
                  (this.popper.style.top = ""),
                  (this.popper.style.left = ""),
                  (this.popper.style.right = ""),
                  (this.popper.style.bottom = ""),
                  (this.popper.style.willChange = ""),
                  (this.popper.style[Gb("transform")] = "")),
                this.disableEventListeners(),
                this.options.removeOnDestroy &&
                  this.popper.parentNode.removeChild(this.popper),
                this
              );
            }.call(this);
          },
        },
        {
          key: "enableEventListeners",
          value: function () {
            return Xb.call(this);
          },
        },
        {
          key: "disableEventListeners",
          value: function () {
            return function () {
              var e, t;
              this.state.eventsEnabled &&
                (cancelAnimationFrame(this.scheduleUpdate),
                (this.state =
                  ((e = this.reference),
                  (t = this.state),
                  Yb(e).removeEventListener("resize", t.updateBound),
                  t.scrollParents.forEach(function (e) {
                    e.removeEventListener("scroll", t.updateBound);
                  }),
                  (t.updateBound = null),
                  (t.scrollParents = []),
                  (t.scrollElement = null),
                  (t.eventsEnabled = !1),
                  t)));
            }.call(this);
          },
        },
      ]),
      rw);
  function rw(e, t) {
    var n = this,
      r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
    Mb(this, rw),
      (this.scheduleUpdate = function () {
        return requestAnimationFrame(n.update);
      }),
      (this.update = hb(this.update.bind(this))),
      (this.options = Nb({}, rw.Defaults, r)),
      (this.state = { isDestroyed: !1, isCreated: !1, scrollParents: [] }),
      (this.reference = e && e.jquery ? e[0] : e),
      (this.popper = t && t.jquery ? t[0] : t),
      (this.options.modifiers = {}),
      Object.keys(Nb({}, rw.Defaults.modifiers, r.modifiers)).forEach(function (
        e
      ) {
        n.options.modifiers[e] = Nb(
          {},
          rw.Defaults.modifiers[e] || {},
          r.modifiers ? r.modifiers[e] : {}
        );
      }),
      (this.modifiers = Object.keys(this.options.modifiers)
        .map(function (e) {
          return Nb({ name: e }, n.options.modifiers[e]);
        })
        .sort(function (e, t) {
          return e.order - t.order;
        })),
      this.modifiers.forEach(function (e) {
        e.enabled &&
          mb(e.onLoad) &&
          e.onLoad(n.reference, n.popper, n.options, e, n.state);
      }),
      this.update();
    var i = this.options.eventsEnabled;
    i && this.enableEventListeners(), (this.state.eventsEnabled = i);
  }
  function iw(e) {
    return "function" == typeof e ? e() : e;
  }
  (nw.Utils = ("undefined" != typeof window ? window : i).PopperUtils),
    (nw.placements = vp),
    (nw.Defaults = _f);
  var ow = "undefined" != typeof window ? mh.useLayoutEffect : mh.useEffect,
    aw = {},
    sw = mh.forwardRef(function (e, t) {
      var n = e.anchorEl,
        r = e.children,
        i = e.container,
        o = e.disablePortal,
        a = void 0 !== o && o,
        s = e.keepMounted,
        l = void 0 !== s && s,
        c = e.modifiers,
        u = e.open,
        d = e.placement,
        o = void 0 === d ? "bottom" : d,
        s = e.popperOptions,
        p = void 0 === s ? aw : s,
        d = e.popperRef,
        s = e.transition,
        f = void 0 !== s && s,
        e = xu(e, [
          "anchorEl",
          "children",
          "container",
          "disablePortal",
          "keepMounted",
          "modifiers",
          "open",
          "placement",
          "popperOptions",
          "popperRef",
          "transition",
        ]),
        h = mh.useRef(null),
        m = Ig(h, t),
        g = mh.useRef(null),
        v = Ig(g, d),
        y = mh.useRef(v);
      ow(
        function () {
          y.current = v;
        },
        [v]
      ),
        mh.useImperativeHandle(
          d,
          function () {
            return g.current;
          },
          []
        );
      var t = mh.useState(!0),
        d = t[0],
        b = t[1],
        w = (function (e, t) {
          if ("ltr" === ((t && t.direction) || "ltr")) return e;
          switch (e) {
            case "bottom-end":
              return "bottom-start";
            case "bottom-start":
              return "bottom-end";
            case "top-end":
              return "top-start";
            case "top-start":
              return "top-end";
            default:
              return e;
          }
        })(o, wh()),
        t = mh.useState(w),
        o = t[0],
        x = t[1];
      mh.useEffect(function () {
        g.current && g.current.update();
      });
      function E() {
        g.current && (g.current.destroy(), y.current(null));
      }
      var S = mh.useCallback(
          function () {
            var e;
            h.current &&
              n &&
              u &&
              (g.current && (g.current.destroy(), y.current(null)),
              (e = function (e) {
                x(e.placement);
              }),
              iw(n),
              (e = new nw(
                iw(n),
                h.current,
                Su({ placement: w }, p, {
                  modifiers: Su(
                    {},
                    a
                      ? {}
                      : { preventOverflow: { boundariesElement: "window" } },
                    {},
                    c,
                    {},
                    p.modifiers
                  ),
                  onCreate: qv(e, p.onCreate),
                  onUpdate: qv(e, p.onUpdate),
                })
              )),
              y.current(e));
          },
          [n, a, c, u, w, p]
        ),
        t = mh.useCallback(
          function (e) {
            Lg(m, e), S();
          },
          [m, S]
        );
      if (
        (mh.useEffect(
          function () {
            S();
          },
          [S]
        ),
        mh.useEffect(function () {
          return function () {
            E();
          };
        }, []),
        mh.useEffect(
          function () {
            u || f || E();
          },
          [u, f]
        ),
        !l && !u && (!f || d))
      )
        return null;
      o = { placement: o };
      return (
        f &&
          (o.TransitionProps = {
            in: u,
            onEnter: function () {
              b(!1);
            },
            onExited: function () {
              b(!0), E();
            },
          }),
        mh.createElement(
          Vv,
          { disablePortal: a, container: i },
          mh.createElement(
            "div",
            Su({ ref: t, role: "tooltip" }, e, {
              style: Su({ position: "fixed", top: 0, left: 0 }, e.style),
            }),
            "function" == typeof r ? r(o) : r
          )
        )
      );
    });
  Q(), Q(), Q();
  var lw = gg(
    mh.createElement("path", {
      d:
        "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
    })
  );
  Q();
  var cw = gg(
    mh.createElement("path", {
      d:
        "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z",
    })
  );
  (vp = Uh(
    function (e) {
      return {
        root: {
          position: "relative",
          display: "flex",
          "&$checked $layer": {
            transform: "scale(1)",
            transition: e.transitions.create("transform", {
              easing: e.transitions.easing.easeOut,
              duration: e.transitions.duration.shortest,
            }),
          },
        },
        layer: {
          left: 0,
          position: "absolute",
          transform: "scale(0)",
          transition: e.transitions.create("transform", {
            easing: e.transitions.easing.easeIn,
            duration: e.transitions.duration.shortest,
          }),
        },
        checked: {},
      };
    },
    { name: "PrivateRadioButtonIcon" }
  )(function (e) {
    var t = e.checked,
      n = e.classes,
      e = e.fontSize;
    return mh.createElement(
      "div",
      { className: Ph(n.root, t && n.checked) },
      mh.createElement(lw, { fontSize: e }),
      mh.createElement(cw, { fontSize: e, className: n.layer })
    );
  })),
    Q(),
    Q();
  var uw = mh.createContext(),
    dw = mh.createElement(vp, { checked: !0 }),
    pw = mh.createElement(vp, null),
    _f = mh.forwardRef(function (e, t) {
      var n = e.checked,
        r = e.classes,
        i = e.color,
        o = void 0 === i ? "secondary" : i,
        a = e.name,
        s = e.onChange,
        l = e.size,
        c = void 0 === l ? "medium" : l,
        i = xu(e, ["checked", "classes", "color", "name", "onChange", "size"]),
        l = mh.useContext(uw),
        n = n,
        s = qv(s, l && l.onChange),
        a = a;
      return (
        l &&
          (void 0 === n && (n = l.value === e.value),
          void 0 === a && (a = l.name)),
        mh.createElement(
          Lv,
          Su(
            {
              color: o,
              type: "radio",
              icon: mh.cloneElement(pw, {
                fontSize: "small" === c ? "small" : "default",
              }),
              checkedIcon: mh.cloneElement(dw, {
                fontSize: "small" === c ? "small" : "default",
              }),
              classes: {
                root: Ph(r.root, r["color".concat(ag(o))]),
                checked: r.checked,
                disabled: r.disabled,
              },
              name: a,
              checked: n,
              onChange: s,
              ref: t,
            },
            i
          )
        )
      );
    });
  function fw(e, t) {
    return "object" === Tu(t) && null !== t ? e === t : String(e) === String(t);
  }
  Uh(
    function (e) {
      return {
        root: { color: e.palette.text.secondary },
        checked: {},
        disabled: {},
        colorPrimary: {
          "&$checked": {
            color: e.palette.primary.main,
            "&:hover": {
              backgroundColor: gu(
                e.palette.primary.main,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
          },
          "&$disabled": { color: e.palette.action.disabled },
        },
        colorSecondary: {
          "&$checked": {
            color: e.palette.secondary.main,
            "&:hover": {
              backgroundColor: gu(
                e.palette.secondary.main,
                e.palette.action.hoverOpacity
              ),
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
          },
          "&$disabled": { color: e.palette.action.disabled },
        },
      };
    },
    { name: "PwzrRadio" }
  )(_f),
    Q(),
    mh.forwardRef(function (e, t) {
      var n = e.actions,
        r = e.children,
        i = e.name,
        o = e.value,
        a = e.onChange,
        s = xu(e, ["actions", "children", "name", "value", "onChange"]),
        l = mh.useRef(null),
        o = hv(
          zv({ controlled: o, default: e.defaultValue, name: "RadioGroup" }),
          2
        ),
        e = o[0],
        c = o[1];
      mh.useImperativeHandle(
        n,
        function () {
          return {
            focus: function () {
              var e = l.current.querySelector("input:not(:disabled):checked");
              (e = e || l.current.querySelector("input:not(:disabled)")) &&
                e.focus();
            },
          };
        },
        []
      );
      t = Ig(t, l);
      return mh.createElement(
        uw.Provider,
        {
          value: {
            name: i,
            onChange: function (e) {
              c(e.target.value), a && a(e, e.target.value);
            },
            value: e,
          },
        },
        mh.createElement(Ty, Su({ role: "radiogroup", ref: t }, s), r)
      );
    }),
    Q(),
    mh.Component,
    Q(),
    Q();
  var hw = mh.forwardRef(function (e, t) {
      var n = e.autoFocus,
        r = e.autoWidth,
        i = e.children,
        o = e.classes,
        a = e.className,
        s = e.defaultValue,
        l = e.disabled,
        c = e.displayEmpty,
        u = e.IconComponent,
        d = e.inputRef,
        p = e.labelId,
        f = e.MenuProps,
        h = void 0 === f ? {} : f,
        m = e.multiple,
        g = e.name,
        v = e.onBlur,
        y = e.onChange,
        b = e.onClose,
        w = e.onFocus,
        x = e.onOpen,
        E = e.open,
        S = e.readOnly,
        C = e.renderValue,
        k = (e.required, e.SelectDisplayProps),
        T = void 0 === k ? {} : k,
        P = e.tabIndex,
        z = (e.type, e.value),
        O = e.variant,
        f = void 0 === O ? "standard" : O,
        k = xu(e, [
          "autoFocus",
          "autoWidth",
          "children",
          "classes",
          "className",
          "defaultValue",
          "disabled",
          "displayEmpty",
          "IconComponent",
          "inputRef",
          "labelId",
          "MenuProps",
          "multiple",
          "name",
          "onBlur",
          "onChange",
          "onClose",
          "onFocus",
          "onOpen",
          "open",
          "readOnly",
          "renderValue",
          "required",
          "SelectDisplayProps",
          "tabIndex",
          "type",
          "value",
          "variant",
        ]),
        O = hv(zv({ controlled: z, default: s, name: "SelectInput" }), 2),
        R = O[0],
        M = O[1],
        N = mh.useRef(null),
        e = mh.useState(null),
        L = e[0],
        z = e[1],
        I = mh.useRef(null != E).current,
        s = mh.useState(),
        O = s[0],
        _ = s[1],
        e = mh.useState(!1),
        s = e[0],
        D = e[1],
        d = Ig(t, d);
      mh.useImperativeHandle(
        d,
        function () {
          return {
            focus: function () {
              L.focus();
            },
            node: N.current,
            value: R,
          };
        },
        [L, R]
      ),
        mh.useEffect(
          function () {
            n && L && L.focus();
          },
          [n, L]
        );
      function A(e, t) {
        e ? x && x(t) : b && b(t), I || (_(r ? null : L.clientWidth), D(e));
      }
      var F,
        B,
        W = null !== L && (I ? E : s);
      delete k["aria-invalid"];
      var $ = [],
        j = !1;
      (xy({ value: R }) || c) && (C ? (F = C(R)) : (j = !0));
      C = mh.Children.map(i, function (n) {
        if (!mh.isValidElement(n)) return null;
        var e, r;
        if (m) {
          if (!Array.isArray(R))
            throw new Error(
              "Material-UI: the `value` prop must be an array when using the `Select` component with `multiple`."
            );
          (e = R.some(function (e) {
            return fw(e, n.props.value);
          })) &&
            j &&
            $.push(n.props.children);
        } else (e = fw(R, n.props.value)) && j && (B = n.props.children);
        return mh.cloneElement(n, {
          "aria-selected": e ? "true" : void 0,
          onClick: function (e) {
            var t, n;
            m || A(!1, e),
              m
                ? ((t = Array.isArray(R) ? Mf(R) : []),
                  -1 === (n = R.indexOf(r.props.value))
                    ? t.push(r.props.value)
                    : t.splice(n, 1))
                : (t = r.props.value),
              M(t),
              y &&
                (e.persist(),
                Object.defineProperty(e, "target", {
                  writable: !0,
                  value: { value: t, name: g },
                }),
                y(e, r));
          },
          onKeyUp: function (e) {
            " " === e.key && e.preventDefault();
            var t = n.props.onKeyUp;
            "function" == typeof t && t(e);
          },
          role: "option",
          selected: e,
          value: void 0,
          "data-value": (r = n).props.value,
        });
      });
      j && (F = m ? $.join(", ") : B);
      i = O;
      !r && I && L && (i = L.clientWidth),
        (O = void 0 !== P ? P : l ? null : 0);
      P = T.id || (g ? "mui-component-select-".concat(g) : void 0);
      return mh.createElement(
        mh.Fragment,
        null,
        mh.createElement(
          "div",
          Su(
            {
              className: Ph(
                o.root,
                o.select,
                o.selectMenu,
                o[f],
                a,
                l && o.disabled
              ),
              ref: z,
              tabIndex: O,
              role: "button",
              "aria-expanded": W ? "true" : void 0,
              "aria-labelledby": "".concat(p || "", " ").concat(P || ""),
              "aria-haspopup": "listbox",
              onKeyDown: function (e) {
                S ||
                  (-1 !==
                    [" ", "ArrowUp", "ArrowDown", "Enter"].indexOf(e.key) &&
                    (e.preventDefault(), A(!0, e)));
              },
              onMouseDown:
                l || S
                  ? null
                  : function (e) {
                      0 === e.button &&
                        (e.preventDefault(), L.focus(), A(!0, e));
                    },
              onBlur: function (e) {
                !W &&
                  v &&
                  (e.persist(),
                  Object.defineProperty(e, "target", {
                    writable: !0,
                    value: { value: R, name: g },
                  }),
                  v(e));
              },
              onFocus: w,
            },
            T,
            { id: P }
          ),
          null == F || ("string" == typeof F && !F.trim())
            ? mh.createElement("span", {
                dangerouslySetInnerHTML: { __html: "&#8203;" },
              })
            : F
        ),
        mh.createElement(
          "input",
          Su(
            {
              value: Array.isArray(R) ? R.join(",") : R,
              name: g,
              ref: N,
              type: "hidden",
              autoFocus: n,
            },
            k
          )
        ),
        mh.createElement(u, {
          className: Ph(o.icon, o["icon".concat(ag(f))], W && o.iconOpen),
        }),
        mh.createElement(
          ob,
          Su(
            {
              id: "menu-".concat(g || ""),
              anchorEl: L,
              open: W,
              onClose: function (e) {
                A(!1, e);
              },
            },
            h,
            {
              MenuListProps: Su(
                { "aria-labelledby": p, role: "listbox", disableListWrap: !0 },
                h.MenuListProps
              ),
              PaperProps: Su({}, h.PaperProps, {
                style: Su(
                  { minWidth: i },
                  null != h.PaperProps ? h.PaperProps.style : null
                ),
              }),
            }
          ),
          C
        )
      );
    }),
    vp = xp,
    mw = mh.createElement(If, null),
    gw = mh.createElement(Yu, null);
  (_f = mh.forwardRef(function e(t, n) {
    var r = t.autoWidth,
      i = void 0 !== r && r,
      o = t.children,
      a = t.classes,
      s = t.displayEmpty,
      l = void 0 !== s && s,
      c = t.IconComponent,
      u = void 0 === c ? lb : c,
      d = t.id,
      p = t.input,
      f = t.inputProps,
      h = t.label,
      m = t.labelId,
      g = t.labelWidth,
      v = void 0 === g ? 0 : g,
      y = t.MenuProps,
      b = t.multiple,
      w = void 0 !== b && b,
      x = t.native,
      E = void 0 !== x && x,
      S = t.onClose,
      C = t.onOpen,
      r = t.open,
      s = t.renderValue,
      c = t.SelectDisplayProps,
      g = t.variant,
      b = void 0 === g ? "standard" : g,
      x = xu(t, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant",
      ]),
      g = E ? sb : hw,
      b =
        my({ props: t, muiFormControl: Mv(), states: ["variant"] }).variant ||
        b,
      v =
        p ||
        {
          standard: mw,
          outlined: mh.createElement(db, { label: h, labelWidth: v }),
          filled: gw,
        }[b];
    return mh.cloneElement(
      v,
      Su(
        {
          inputComponent: g,
          inputProps: Su(
            {
              children: o,
              IconComponent: u,
              variant: b,
              type: void 0,
              multiple: w,
            },
            E
              ? { id: d }
              : {
                  autoWidth: i,
                  displayEmpty: l,
                  labelId: m,
                  MenuProps: y,
                  onClose: S,
                  onOpen: C,
                  open: r,
                  renderValue: s,
                  SelectDisplayProps: Su({ id: d }, c),
                },
            {},
            f,
            {
              classes: f
                ? hh({ baseClasses: a, newClasses: f.classes, Component: e })
                : a,
            },
            p ? p.props.inputProps : {}
          ),
          ref: n,
        },
        x
      )
    );
  })).muiName = "Select";
  var vw = Uh(vp, { name: "PwzrSelect" })(_f);
  Q(), Q();
  var yw = Uh(
    function (e) {
      return {
        thumb: {
          "&$open": {
            "& $offset": { transform: "scale(1) translateY(-10px)" },
          },
        },
        open: {},
        offset: Su({ zIndex: 1 }, e.typography.body2, {
          fontSize: e.typography.pxToRem(12),
          lineHeight: 1.2,
          transition: e.transitions.create(["transform"], {
            duration: e.transitions.duration.shortest,
          }),
          top: -34,
          transformOrigin: "bottom center",
          transform: "scale(0)",
          position: "absolute",
        }),
        circle: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 32,
          height: 32,
          borderRadius: "50% 50% 50% 0",
          backgroundColor: "currentColor",
          transform: "rotate(-45deg)",
        },
        label: {
          color: e.palette.primary.contrastText,
          transform: "rotate(45deg)",
        },
      };
    },
    { name: "PrivateValueLabel" }
  )(function (e) {
    var t = e.children,
      n = e.classes,
      r = e.className,
      i = e.open,
      o = e.value,
      e = e.valueLabelDisplay;
    return "off" === e
      ? t
      : mh.cloneElement(
          t,
          {
            className: Ph(
              t.props.className,
              (i || "on" === e) && n.open,
              n.thumb
            ),
          },
          mh.createElement(
            "span",
            { className: Ph(n.offset, r) },
            mh.createElement(
              "span",
              { className: n.circle },
              mh.createElement("span", { className: n.label }, o)
            )
          )
        );
  });
  function bw(e, t) {
    return e - t;
  }
  function ww(e, t, n) {
    return Math.min(Math.max(t, e), n);
  }
  function xw(e, r) {
    return e.reduce(function (e, t, n) {
      t = Math.abs(r - t);
      return null === e || t < e.distance || t === e.distance
        ? { distance: t, index: n }
        : e;
    }, null).index;
  }
  function Ew(e, t) {
    if (void 0 !== t.current && e.changedTouches) {
      for (var n = 0; n < e.changedTouches.length; n += 1) {
        var r = e.changedTouches[n];
        if (r.identifier === t.current) return { x: r.clientX, y: r.clientY };
      }
      return !1;
    }
    return { x: e.clientX, y: e.clientY };
  }
  function Sw(e, t, n) {
    return (100 * (e - t)) / (n - t);
  }
  function Cw(e, t, n) {
    n = Math.round((e - n) / t) * t + n;
    return Number(
      n.toFixed(
        (function (e) {
          if (Math.abs(e) < 1) {
            var t = e.toExponential().split("e-"),
              n = t[0].split(".")[1];
            return (n ? n.length : 0) + parseInt(t[1], 10);
          }
          e = e.toString().split(".")[1];
          return e ? e.length : 0;
        })(t)
      )
    );
  }
  function kw(e) {
    var t = e.values,
      n = e.source,
      r = e.newValue,
      e = e.index;
    if (t[e] === r) return n;
    t = Mf(t);
    return (t[e] = r), t;
  }
  function Tw(e) {
    var t = e.sliderRef,
      n = e.activeIndex,
      e = e.setActive;
    (t.current.contains(document.activeElement) &&
      Number(document.activeElement.getAttribute("data-index")) === n) ||
      t.current.querySelector('[data-index="'.concat(n, '"]')).focus(),
      e && e(n);
  }
  function Pw(e) {
    return e;
  }
  var zw = {
      horizontal: {
        offset: function (e) {
          return { left: "".concat(e, "%") };
        },
        leap: function (e) {
          return { width: "".concat(e, "%") };
        },
      },
      "horizontal-reverse": {
        offset: function (e) {
          return { right: "".concat(e, "%") };
        },
        leap: function (e) {
          return { width: "".concat(e, "%") };
        },
      },
      vertical: {
        offset: function (e) {
          return { bottom: "".concat(e, "%") };
        },
        leap: function (e) {
          return { height: "".concat(e, "%") };
        },
      },
    },
    xp = mh.forwardRef(function (e, t) {
      var r = e["aria-label"],
        i = e["aria-labelledby"],
        o = e["aria-valuetext"],
        a = e.classes,
        n = e.className,
        s = e.color,
        l = void 0 === s ? "primary" : s,
        c = e.component,
        u = void 0 === c ? "span" : c,
        d = e.defaultValue,
        p = e.disabled,
        f = void 0 !== p && p,
        h = e.getAriaLabel,
        m = e.getAriaValueText,
        g = e.marks,
        v = void 0 !== g && g,
        s = e.max,
        y = void 0 === s ? 100 : s,
        c = e.min,
        b = void 0 === c ? 0 : c,
        p = e.name,
        w = e.onChange,
        x = e.onChangeCommitted,
        E = e.onMouseDown,
        g = e.orientation,
        S = void 0 === g ? "horizontal" : g,
        s = e.scale,
        C = void 0 === s ? Pw : s,
        c = e.step,
        k = void 0 === c ? 1 : c,
        g = e.ThumbComponent,
        T = void 0 === g ? "span" : g,
        s = e.track,
        P = void 0 === s ? "normal" : s,
        c = e.value,
        g = e.ValueLabelComponent,
        z = void 0 === g ? yw : g,
        s = e.valueLabelDisplay,
        O = void 0 === s ? "off" : s,
        g = e.valueLabelFormat,
        R = void 0 === g ? Pw : g,
        s = xu(e, [
          "aria-label",
          "aria-labelledby",
          "aria-valuetext",
          "classes",
          "className",
          "color",
          "component",
          "defaultValue",
          "disabled",
          "getAriaLabel",
          "getAriaValueText",
          "marks",
          "max",
          "min",
          "name",
          "onChange",
          "onChangeCommitted",
          "onMouseDown",
          "orientation",
          "scale",
          "step",
          "ThumbComponent",
          "track",
          "value",
          "ValueLabelComponent",
          "valueLabelDisplay",
          "valueLabelFormat",
        ]),
        g = qh(),
        M = mh.useRef(),
        e = mh.useState(-1),
        N = e[0],
        L = e[1],
        e = mh.useState(-1),
        I = e[0],
        _ = e[1],
        d = hv(zv({ controlled: c, default: d, name: "Slider" }), 2),
        D = d[0],
        A = d[1],
        F = Array.isArray(D),
        d = mh.useRef(),
        B = (B = F ? Mf(D).sort(bw) : [D]).map(function (e) {
          return ww(e, b, y);
        }),
        W =
          !0 === v && null !== k
            ? Mf(Array(Math.floor((y - b) / k) + 1)).map(function (e, t) {
                return { value: b + k * t };
              })
            : v || [];
      d.current = { source: D };
      var v = Qg(),
        $ = v.isFocusVisible,
        j = v.onBlurVisible,
        d = v.ref,
        v = mh.useState(-1),
        H = v[0],
        V = v[1],
        q = mh.useRef(),
        v = Ig(d, q),
        d = Ig(t, v),
        U = jg(function (e) {
          var t = Number(e.currentTarget.getAttribute("data-index"));
          $(e) && V(t), _(t);
        }),
        G = jg(function () {
          -1 !== H && (V(-1), j()), _(-1);
        }),
        Y = jg(function (e) {
          e = Number(e.currentTarget.getAttribute("data-index"));
          _(e);
        }),
        X = jg(function () {
          _(-1);
        }),
        K = jg(function (e) {
          var t,
            n,
            r = Number(e.currentTarget.getAttribute("data-index")),
            i = B[r],
            o = (y - b) / 10,
            a = W.map(function (e) {
              return e.value;
            }),
            s = a.indexOf(i);
          switch (e.key) {
            case "Home":
              n = b;
              break;
            case "End":
              n = y;
              break;
            case "PageUp":
              k && (n = i + o);
              break;
            case "PageDown":
              k && (n = i - o);
              break;
            case "ArrowRight":
            case "ArrowUp":
              n = k ? i + k : a[s + 1] || a[a.length - 1];
              break;
            case "ArrowLeft":
            case "ArrowDown":
              n = k ? i - k : a[s - 1] || a[0];
              break;
            default:
              return;
          }
          e.preventDefault(),
            k && (n = Cw(n, k, b)),
            (n = ww(n, b, y)),
            F &&
              ((n = kw({
                values: B,
                source: D,
                newValue: (t = n),
                index: r,
              }).sort(bw)),
              Tw({ sliderRef: q, activeIndex: n.indexOf(t) })),
            A(n),
            V(r),
            w && w(e, n),
            x && x(e, n);
        }),
        Z = mh.useRef(),
        Q = S;
      "rtl" === g.direction && "vertical" !== S && (Q += "-reverse");
      function J(e) {
        var t = e.finger,
          n = void 0 !== (a = e.move) && a,
          r = e.values,
          i = e.source,
          o = (s = q.current.getBoundingClientRect()).width,
          a = s.height,
          e = s.bottom,
          s = s.left,
          o = 0 === Q.indexOf("vertical") ? (e - t.y) / a : (t.x - s) / o;
        -1 !== Q.indexOf("-reverse") && (o = 1 - o),
          (o = (y - b) * o + b),
          (o = ww(
            (o = k
              ? Cw(o, k, b)
              : (l = W.map(function (e) {
                  return e.value;
                }))[xw(l, o)]),
            b,
            y
          ));
        var l = 0;
        return (
          F &&
            ((l = (o = kw({
              values: r,
              source: i,
              newValue: (i = o),
              index: (l = n ? Z.current : xw(r, o)),
            }).sort(bw)).indexOf(i)),
            (Z.current = l)),
          { newValue: o, activeIndex: l }
        );
      }
      var ee = jg(function (e) {
          var t,
            n = Ew(e, M);
          n &&
            ((n = (t = J({ finger: n, move: !0, values: B, source: D }))
              .newValue),
            (t = t.activeIndex),
            Tw({ sliderRef: q, activeIndex: t, setActive: L }),
            A(n),
            w && w(e, n));
        }),
        te = jg(function (e) {
          var t = Ew(e, M);
          t &&
            ((t = J({ finger: t, values: B, source: D }).newValue),
            L(-1),
            "touchend" === e.type && _(-1),
            x && x(e, t),
            (M.current = void 0),
            (t = Fv(q.current)).removeEventListener("mousemove", ee),
            t.removeEventListener("mouseup", te),
            t.removeEventListener("touchmove", ee),
            t.removeEventListener("touchend", te));
        }),
        ne = jg(function (e) {
          e.preventDefault();
          var t = e.changedTouches[0];
          null != t && (M.current = t.identifier);
          var n = Ew(e, M),
            t = J({ finger: n, values: B, source: D }),
            n = t.newValue,
            t = t.activeIndex;
          Tw({ sliderRef: q, activeIndex: t, setActive: L }),
            A(n),
            w && w(e, n);
          n = Fv(q.current);
          n.addEventListener("touchmove", ee),
            n.addEventListener("touchend", te);
        });
      mh.useEffect(
        function () {
          var e = q.current;
          e.addEventListener("touchstart", ne);
          var t = Fv(e);
          return function () {
            e.removeEventListener("touchstart", ne),
              t.removeEventListener("mousemove", ee),
              t.removeEventListener("mouseup", te),
              t.removeEventListener("touchmove", ee),
              t.removeEventListener("touchend", te);
          };
        },
        [te, ee, ne]
      );
      (t = jg(function (e) {
        E && E(e), e.preventDefault();
        var t = Ew(e, M),
          n = J({ finger: t, values: B, source: D }),
          t = n.newValue,
          n = n.activeIndex;
        Tw({ sliderRef: q, activeIndex: n, setActive: L }), A(t), w && w(e, t);
        t = Fv(q.current);
        t.addEventListener("mousemove", ee), t.addEventListener("mouseup", te);
      })),
        (v = Sw(F ? B[0] : b, b, y)),
        (g = Sw(B[B.length - 1], b, y) - v),
        (g = Su({}, zw[Q].offset(v), {}, zw[Q].leap(g)));
      return mh.createElement(
        u,
        Su(
          {
            ref: d,
            className: Ph(
              a.root,
              a["color".concat(ag(l))],
              n,
              f && a.disabled,
              0 < W.length &&
                W.some(function (e) {
                  return e.label;
                }) &&
                a.marked,
              !1 === P && a.trackFalse,
              "vertical" === S && a.vertical,
              "inverted" === P && a.trackInverted
            ),
            onMouseDown: t,
          },
          s
        ),
        mh.createElement("span", { className: a.rail }),
        mh.createElement("span", { className: a.track, style: g }),
        mh.createElement("input", {
          value: B.join(","),
          name: p,
          type: "hidden",
        }),
        W.map(function (e) {
          var t = Sw(e.value, b, y),
            n = zw[Q].offset(t),
            t =
              !1 === P
                ? -1 !== B.indexOf(e.value)
                : ("normal" === P &&
                    (F
                      ? e.value >= B[0] && e.value <= B[B.length - 1]
                      : e.value <= B[0])) ||
                  ("inverted" === P &&
                    (F
                      ? e.value <= B[0] || e.value >= B[B.length - 1]
                      : e.value >= B[0]));
          return mh.createElement(
            mh.Fragment,
            { key: e.value },
            mh.createElement("span", {
              style: n,
              className: Ph(a.mark, t && a.markActive),
            }),
            mh.createElement(
              "span",
              {
                "aria-hidden": !0,
                style: n,
                className: Ph(a.markLabel, t && a.markLabelActive),
              },
              e.label
            )
          );
        }),
        B.map(function (e, t) {
          var n = Sw(e, b, y),
            n = zw[Q].offset(n);
          return mh.createElement(
            z,
            {
              key: t,
              valueLabelFormat: R,
              valueLabelDisplay: O,
              className: a.valueLabel,
              value: "function" == typeof R ? R(C(e), t) : R,
              index: t,
              open: I === t || N === t || "on" === O,
              disabled: f,
            },
            mh.createElement(T, {
              className: Ph(
                a.thumb,
                a["thumbColor".concat(ag(l))],
                N === t && a.active,
                f && a.disabled,
                H === t && a.focusVisible
              ),
              tabIndex: f ? null : 0,
              role: "slider",
              style: n,
              "data-index": t,
              "aria-label": h ? h(t) : r,
              "aria-labelledby": i,
              "aria-orientation": S,
              "aria-valuemax": C(y),
              "aria-valuemin": C(b),
              "aria-valuenow": C(e),
              "aria-valuetext": m ? m(C(e), t) : o,
              onKeyDown: K,
              onFocus: U,
              onBlur: G,
              onMouseOver: Y,
              onMouseLeave: X,
            })
          );
        })
      );
    });
  Uh(
    function (e) {
      return {
        root: {
          height: 2,
          width: "100%",
          boxSizing: "content-box",
          padding: "13px 0",
          display: "inline-block",
          position: "relative",
          cursor: "pointer",
          touchAction: "none",
          color: e.palette.primary.main,
          WebkitTapHighlightColor: "transparent",
          "&$disabled": {
            pointerEvents: "none",
            cursor: "default",
            color: e.palette.grey[400],
          },
          "&$vertical": { width: 2, height: "100%", padding: "0 13px" },
          "@media (pointer: coarse)": {
            padding: "20px 0",
            "&$vertical": { padding: "0 20px" },
          },
        },
        colorPrimary: {},
        colorSecondary: { color: e.palette.secondary.main },
        marked: {
          marginBottom: 20,
          "&$vertical": { marginBottom: "auto", marginRight: 20 },
        },
        vertical: {},
        disabled: {},
        rail: {
          display: "block",
          position: "absolute",
          width: "100%",
          height: 2,
          borderRadius: 1,
          backgroundColor: "currentColor",
          opacity: 0.38,
          "$vertical &": { height: "100%", width: 2 },
        },
        track: {
          display: "block",
          position: "absolute",
          height: 2,
          borderRadius: 1,
          backgroundColor: "currentColor",
          "$vertical &": { width: 2 },
        },
        trackFalse: { "& $track": { display: "none" } },
        trackInverted: {
          "& $track": {
            backgroundColor:
              "light" === e.palette.type
                ? yu(e.palette.primary.main, 0.62)
                : vu(e.palette.primary.main, 0.5),
          },
          "& $rail": { opacity: 1 },
        },
        thumb: {
          position: "absolute",
          width: 12,
          height: 12,
          marginLeft: -6,
          marginTop: -5,
          boxSizing: "border-box",
          borderRadius: "50%",
          outline: 0,
          backgroundColor: "currentColor",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: e.transitions.create(["box-shadow"], {
            duration: e.transitions.duration.shortest,
          }),
          "&::after": {
            position: "absolute",
            content: '""',
            borderRadius: "50%",
            left: -15,
            top: -15,
            right: -15,
            bottom: -15,
          },
          "&$focusVisible,&:hover": {
            boxShadow: "0px 0px 0px 8px ".concat(
              gu(e.palette.primary.main, 0.16)
            ),
            "@media (hover: none)": { boxShadow: "none" },
          },
          "&$active": {
            boxShadow: "0px 0px 0px 14px ".concat(
              gu(e.palette.primary.main, 0.16)
            ),
          },
          "&$disabled": {
            width: 8,
            height: 8,
            marginLeft: -4,
            marginTop: -3,
            "&:hover": { boxShadow: "none" },
          },
          "$vertical &": { marginLeft: -5, marginBottom: -6 },
          "$vertical &$disabled": { marginLeft: -3, marginBottom: -4 },
        },
        thumbColorPrimary: {},
        thumbColorSecondary: {
          "&$focusVisible,&:hover": {
            boxShadow: "0px 0px 0px 8px ".concat(
              gu(e.palette.secondary.main, 0.16)
            ),
          },
          "&$active": {
            boxShadow: "0px 0px 0px 14px ".concat(
              gu(e.palette.secondary.main, 0.16)
            ),
          },
        },
        active: {},
        focusVisible: {},
        valueLabel: {},
        mark: {
          position: "absolute",
          width: 2,
          height: 2,
          borderRadius: 1,
          backgroundColor: "currentColor",
        },
        markActive: {
          backgroundColor: e.palette.background.paper,
          opacity: 0.8,
        },
        markLabel: Su({}, e.typography.body2, {
          color: e.palette.text.secondary,
          position: "absolute",
          top: 26,
          transform: "translateX(-50%)",
          whiteSpace: "nowrap",
          "$vertical &": {
            top: "auto",
            left: 26,
            transform: "translateY(50%)",
          },
          "@media (pointer: coarse)": { top: 40, "$vertical &": { left: 31 } },
        }),
        markLabelActive: { color: e.palette.text.primary },
      };
    },
    { name: "PwzrSlider" }
  )(xp),
    Q();
  var vp = mh.forwardRef(function (e, t) {
      var n = e.action,
        r = e.classes,
        i = e.className,
        o = e.message,
        a = e.role,
        a = void 0 === a ? "alert" : a,
        e = xu(e, ["action", "classes", "className", "message", "role"]);
      return mh.createElement(
        mg,
        Su(
          {
            role: a,
            square: !0,
            elevation: 6,
            className: Ph(r.root, i),
            ref: t,
          },
          e
        ),
        mh.createElement("div", { className: r.message }, o),
        n ? mh.createElement("div", { className: r.action }, n) : null
      );
    }),
    Ow = Uh(
      function (e) {
        var t = "light" === e.palette.type ? 0.8 : 0.98,
          t = mu(e.palette.background.default, t);
        return {
          root: Su(
            {},
            e.typography.body2,
            bu(
              {
                color: e.palette.getContrastText(t),
                backgroundColor: t,
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                padding: "6px 16px",
                borderRadius: e.shape.borderRadius,
                flexGrow: 1,
              },
              e.breakpoints.up("sm"),
              { flexGrow: "initial", minWidth: 288 }
            )
          ),
          message: { padding: "8px 0" },
          action: {
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            paddingLeft: 16,
            marginRight: -8,
          },
        };
      },
      { name: "PwzrSnackbarContent" }
    )(vp);
  Q(),
    (_f = mh.forwardRef(function (e, t) {
      var n = e.action,
        r = e.anchorOrigin,
        i = (r =
          void 0 === r ? { vertical: "bottom", horizontal: "center" } : r)
          .vertical,
        o = r.horizontal,
        a = e.autoHideDuration,
        s = void 0 === a ? null : a,
        l = e.children,
        c = e.classes,
        u = e.className,
        d = e.ClickAwayListenerProps,
        p = e.ContentProps,
        f = e.disableWindowBlurListener,
        h = void 0 !== f && f,
        m = e.message,
        g = e.onClose,
        v = e.onEnter,
        y = e.onEntered,
        b = e.onEntering,
        w = e.onExit,
        x = e.onExited,
        E = e.onExiting,
        S = e.onMouseEnter,
        C = e.onMouseLeave,
        k = e.open,
        T = e.resumeHideDuration,
        P = e.TransitionComponent,
        z = void 0 === P ? Dy : P,
        r = e.transitionDuration,
        a =
          void 0 === r
            ? { enter: Nd.enteringScreen, exit: Nd.leavingScreen }
            : r,
        f = e.TransitionProps,
        P = xu(e, [
          "action",
          "anchorOrigin",
          "autoHideDuration",
          "children",
          "classes",
          "className",
          "ClickAwayListenerProps",
          "ContentProps",
          "disableWindowBlurListener",
          "message",
          "onClose",
          "onEnter",
          "onEntered",
          "onEntering",
          "onExit",
          "onExited",
          "onExiting",
          "onMouseEnter",
          "onMouseLeave",
          "open",
          "resumeHideDuration",
          "TransitionComponent",
          "transitionDuration",
          "TransitionProps",
        ]),
        O = mh.useRef(),
        r = mh.useState(!0),
        e = r[0],
        R = r[1],
        M = jg(function () {
          g && g.apply(void 0, arguments);
        }),
        N = jg(function (e) {
          g &&
            null != e &&
            (clearTimeout(O.current),
            (O.current = setTimeout(function () {
              M(null, "timeout");
            }, e)));
        });
      mh.useEffect(
        function () {
          return (
            k && N(s),
            function () {
              clearTimeout(O.current);
            }
          );
        },
        [k, s, N]
      );
      function L() {
        clearTimeout(O.current);
      }
      var I = mh.useCallback(
        function () {
          null != s && N(null != T ? T : 0.5 * s);
        },
        [s, T, N]
      );
      return (
        mh.useEffect(
          function () {
            if (!h && k)
              return (
                window.addEventListener("focus", I),
                window.addEventListener("blur", L),
                function () {
                  window.removeEventListener("focus", I),
                    window.removeEventListener("blur", L);
                }
              );
          },
          [h, I, k]
        ),
        !k && e
          ? null
          : mh.createElement(
              Wv,
              Su(
                {
                  onClickAway: function (e) {
                    g && g(e, "clickaway");
                  },
                },
                d
              ),
              mh.createElement(
                "div",
                Su(
                  {
                    className: Ph(
                      c.root,
                      c["anchorOrigin".concat(ag(i)).concat(ag(o))],
                      u
                    ),
                    onMouseEnter: function (e) {
                      S && S(e), L();
                    },
                    onMouseLeave: function (e) {
                      C && C(e), I();
                    },
                    ref: t,
                  },
                  P
                ),
                mh.createElement(
                  z,
                  Su(
                    {
                      appear: !0,
                      in: k,
                      onEnter: qv(function () {
                        R(!1);
                      }, v),
                      onEntered: y,
                      onEntering: b,
                      onExit: w,
                      onExited: qv(function () {
                        R(!0);
                      }, x),
                      onExiting: E,
                      timeout: a,
                      direction: "top" === i ? "down" : "up",
                    },
                    f
                  ),
                  l || mh.createElement(Ow, Su({ message: m, action: n }, p))
                )
              )
            )
      );
    })),
    Uh(
      function (e) {
        var t = { top: 8 },
          n = { bottom: 8 },
          r = { justifyContent: "flex-end" },
          i = { justifyContent: "flex-start" },
          o = { top: 24 },
          a = { bottom: 24 },
          s = { right: 24 },
          l = { left: 24 },
          c = { left: "50%", right: "auto", transform: "translateX(-50%)" };
        return {
          root: {
            zIndex: e.zIndex.snackbar,
            position: "fixed",
            display: "flex",
            left: 8,
            right: 8,
            justifyContent: "center",
            alignItems: "center",
          },
          anchorOriginTopCenter: Su(
            {},
            t,
            bu({}, e.breakpoints.up("sm"), Su({}, o, {}, c))
          ),
          anchorOriginBottomCenter: Su(
            {},
            n,
            bu({}, e.breakpoints.up("sm"), Su({}, a, {}, c))
          ),
          anchorOriginTopRight: Su(
            {},
            t,
            {},
            r,
            bu({}, e.breakpoints.up("sm"), Su({ left: "auto" }, o, {}, s))
          ),
          anchorOriginBottomRight: Su(
            {},
            n,
            {},
            r,
            bu({}, e.breakpoints.up("sm"), Su({ left: "auto" }, a, {}, s))
          ),
          anchorOriginTopLeft: Su(
            {},
            t,
            {},
            i,
            bu({}, e.breakpoints.up("sm"), Su({ right: "auto" }, o, {}, l))
          ),
          anchorOriginBottomLeft: Su(
            {},
            n,
            {},
            i,
            bu({}, e.breakpoints.up("sm"), Su({ right: "auto" }, a, {}, l))
          ),
        };
      },
      { flip: !1, name: "PwzrSnackbar" }
    )(_f),
    Q(),
    (xp = mh.forwardRef(function (e, t) {
      var n = e.active,
        r = void 0 !== n && n,
        i = e.alternativeLabel,
        o = e.children,
        a = e.classes,
        s = e.className,
        l = e.completed,
        c = void 0 !== l && l,
        n = e.connector,
        l = e.disabled,
        u = void 0 !== l && l,
        l = e.expanded,
        d = void 0 !== l && l,
        p = e.index,
        f = e.last,
        h = e.orientation,
        e = xu(e, [
          "active",
          "alternativeLabel",
          "children",
          "classes",
          "className",
          "completed",
          "connector",
          "disabled",
          "expanded",
          "index",
          "last",
          "orientation",
        ]);
      return mh.createElement(
        "div",
        Su(
          {
            className: Ph(
              a.root,
              a[h],
              s,
              i && a.alternativeLabel,
              c && a.completed
            ),
            ref: t,
          },
          e
        ),
        n &&
          i &&
          0 !== p &&
          mh.cloneElement(n, {
            orientation: h,
            alternativeLabel: i,
            index: p,
            active: r,
            completed: c,
            disabled: u,
          }),
        mh.Children.map(o, function (e) {
          return mh.isValidElement(e)
            ? mh.cloneElement(
                e,
                Su(
                  {
                    active: r,
                    alternativeLabel: i,
                    completed: c,
                    disabled: u,
                    expanded: d,
                    last: f,
                    icon: p + 1,
                    orientation: h,
                  },
                  e.props
                )
              )
            : null;
        })
      );
    })),
    Uh(
      {
        root: {},
        horizontal: { paddingLeft: 8, paddingRight: 8 },
        vertical: {},
        alternativeLabel: { flex: 1, position: "relative" },
        completed: {},
      },
      { name: "PwzrStep" }
    )(xp),
    Q(),
    Q();
  var Rw = gg(
    mh.createElement("path", {
      d:
        "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z",
    })
  );
  Q();
  var Mw = gg(
      mh.createElement("path", {
        d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
      })
    ),
    Nw = mh.createElement("circle", { cx: "12", cy: "12", r: "12" }),
    vp = mh.forwardRef(function (e, t) {
      var n = e.completed,
        r = void 0 !== n && n,
        i = e.icon,
        o = e.active,
        n = void 0 !== o && o,
        o = e.error,
        o = void 0 !== o && o,
        e = e.classes;
      if ("number" != typeof i && "string" != typeof i) return i;
      n = Ph(e.root, n && e.active, o && e.error, r && e.completed);
      return o
        ? mh.createElement(Mw, { className: n, ref: t })
        : r
        ? mh.createElement(Rw, { className: n, ref: t })
        : mh.createElement(
            sg,
            { className: n, ref: t },
            Nw,
            mh.createElement(
              "text",
              { className: e.text, x: "12", y: "16", textAnchor: "middle" },
              i
            )
          );
    }),
    Lw = Uh(
      function (e) {
        return {
          root: {
            display: "block",
            color: e.palette.text.disabled,
            "&$completed": { color: e.palette.primary.main },
            "&$active": { color: e.palette.primary.main },
            "&$error": { color: e.palette.error.main },
          },
          text: {
            fill: e.palette.primary.contrastText,
            fontSize: e.typography.caption.fontSize,
            fontFamily: e.typography.fontFamily,
          },
          active: {},
          completed: {},
          error: {},
        };
      },
      { name: "PwzrStepIcon" }
    )(vp);
  Q(),
    ((_f = mh.forwardRef(function (e, t) {
      var n = e.active,
        r = void 0 !== n && n,
        i = e.alternativeLabel,
        o = void 0 !== i && i,
        a = e.children,
        s = e.classes,
        l = e.className,
        c = e.completed,
        u = void 0 !== c && c,
        d = e.disabled,
        p = void 0 !== d && d,
        f = e.error,
        h = void 0 !== f && f,
        n = (e.expanded, e.icon),
        i = (e.last, e.optional),
        c = e.orientation,
        d = void 0 === c ? "horizontal" : c,
        f = e.StepIconComponent,
        c = e.StepIconProps,
        e = xu(e, [
          "active",
          "alternativeLabel",
          "children",
          "classes",
          "className",
          "completed",
          "disabled",
          "error",
          "expanded",
          "icon",
          "last",
          "optional",
          "orientation",
          "StepIconComponent",
          "StepIconProps",
        ]),
        f = f;
      return (
        n && !f && (f = Lw),
        mh.createElement(
          "span",
          Su(
            {
              className: Ph(
                s.root,
                s[d],
                l,
                p && s.disabled,
                o && s.alternativeLabel,
                h && s.error
              ),
              ref: t,
            },
            e
          ),
          n || f
            ? mh.createElement(
                "span",
                { className: Ph(s.iconContainer, o && s.alternativeLabel) },
                mh.createElement(
                  f,
                  Su({ completed: u, active: r, error: h, icon: n }, c)
                )
              )
            : null,
          mh.createElement(
            "span",
            { className: s.labelContainer },
            mh.createElement(
              Cv,
              {
                variant: "body2",
                component: "span",
                className: Ph(
                  s.label,
                  o && s.alternativeLabel,
                  u && s.completed,
                  r && s.active,
                  h && s.error
                ),
                display: "block",
              },
              a
            ),
            i
          )
        )
      );
    })).muiName = "StepLabel");
  var Iw = Uh(
    function (e) {
      return {
        root: {
          display: "flex",
          alignItems: "center",
          "&$alternativeLabel": { flexDirection: "column" },
          "&$disabled": { cursor: "default" },
        },
        horizontal: {},
        vertical: {},
        label: {
          color: e.palette.text.secondary,
          "&$active": { color: e.palette.text.primary, fontWeight: 500 },
          "&$completed": { color: e.palette.text.primary, fontWeight: 500 },
          "&$alternativeLabel": { textAlign: "center", marginTop: 16 },
          "&$error": { color: e.palette.error.main },
        },
        active: {},
        completed: {},
        error: {},
        disabled: {},
        iconContainer: {
          flexShrink: 0,
          display: "flex",
          paddingRight: 8,
          "&$alternativeLabel": { paddingRight: 0 },
        },
        alternativeLabel: {},
        labelContainer: { width: "100%" },
      };
    },
    { name: "PwzrStepLabel" }
  )(_f);
  Q(),
    (xp = mh.forwardRef(function (e, t) {
      var n = e.active,
        r = e.alternativeLabel,
        i = e.children,
        o = e.classes,
        a = e.className,
        s = e.completed,
        l = e.disabled,
        c = (e.expanded, e.icon),
        u = (e.last, e.optional),
        d = e.orientation,
        e = xu(e, [
          "active",
          "alternativeLabel",
          "children",
          "classes",
          "className",
          "completed",
          "disabled",
          "expanded",
          "icon",
          "last",
          "optional",
          "orientation",
        ]),
        u = {
          active: n,
          alternativeLabel: r,
          completed: s,
          disabled: l,
          icon: c,
          optional: u,
          orientation: d,
        },
        i = Cy(i, ["StepLabel"])
          ? mh.cloneElement(i, u)
          : mh.createElement(Iw, u, i);
      return mh.createElement(
        nv,
        Su(
          {
            disabled: l,
            TouchRippleProps: { className: o.touchRipple },
            className: Ph(o.root, o[d], a),
            ref: t,
          },
          e
        ),
        i
      );
    })),
    Uh(
      {
        root: {
          width: "100%",
          padding: "24px 16px",
          margin: "-24px -16px",
          boxSizing: "content-box",
        },
        horizontal: {},
        vertical: {
          justifyContent: "flex-start",
          padding: "8px",
          margin: "-8px",
        },
        touchRipple: { color: "rgba(0, 0, 0, 0.3)" },
      },
      { name: "PwzrStepButton" }
    )(xp),
    Q(),
    (vp = mh.forwardRef(function (e, t) {
      var n = e.active,
        r = e.alternativeLabel,
        i = void 0 !== r && r,
        o = e.classes,
        a = e.className,
        s = e.completed,
        l = e.disabled,
        r = (e.index, e.orientation),
        r = void 0 === r ? "horizontal" : r,
        e = xu(e, [
          "active",
          "alternativeLabel",
          "classes",
          "className",
          "completed",
          "disabled",
          "index",
          "orientation",
        ]);
      return mh.createElement(
        "div",
        Su(
          {
            className: Ph(
              o.root,
              o[r],
              a,
              i && o.alternativeLabel,
              n && o.active,
              s && o.completed,
              l && o.disabled
            ),
            ref: t,
          },
          e
        ),
        mh.createElement("span", {
          className: Ph(
            o.line,
            "vertical" === r ? o.lineVertical : o.lineHorizontal
          ),
        })
      );
    })),
    (_f = Uh(
      function (e) {
        return {
          root: { flex: "1 1 auto" },
          horizontal: {},
          vertical: { marginLeft: 12, padding: "0 0 8px" },
          alternativeLabel: {
            position: "absolute",
            top: 12,
            left: "calc(-50% + 20px)",
            right: "calc(50% + 20px)",
          },
          active: {},
          completed: {},
          disabled: {},
          line: {
            display: "block",
            borderColor:
              "light" === e.palette.type
                ? e.palette.grey[400]
                : e.palette.grey[600],
          },
          lineHorizontal: { borderTopStyle: "solid", borderTopWidth: 1 },
          lineVertical: {
            borderLeftStyle: "solid",
            borderLeftWidth: 1,
            minHeight: 24,
          },
        };
      },
      { name: "PwzrStepConnector" }
    )(vp)),
    Q(),
    (xp = mh.forwardRef(function (e, t) {
      var n = e.active,
        r = (e.alternativeLabel, e.children),
        i = e.classes,
        o = e.className,
        a = (e.completed, e.expanded),
        s = e.last,
        l = (e.optional, e.orientation, e.TransitionComponent),
        c = void 0 === l ? $v : l,
        u = e.transitionDuration,
        d = void 0 === u ? "auto" : u,
        l = e.TransitionProps,
        u = xu(e, [
          "active",
          "alternativeLabel",
          "children",
          "classes",
          "className",
          "completed",
          "expanded",
          "last",
          "optional",
          "orientation",
          "TransitionComponent",
          "transitionDuration",
          "TransitionProps",
        ]),
        e = d;
      return (
        "auto" !== d || c.muiSupportAuto || (e = void 0),
        mh.createElement(
          "div",
          Su({ className: Ph(i.root, o, s && i.last), ref: t }, u),
          mh.createElement(
            c,
            Su(
              {
                in: n || a,
                className: i.transition,
                timeout: e,
                unmountOnExit: !0,
              },
              l
            ),
            r
          )
        )
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            marginTop: 8,
            marginLeft: 12,
            paddingLeft: 20,
            paddingRight: 8,
            borderLeft: "1px solid ".concat(
              "light" === e.palette.type
                ? e.palette.grey[400]
                : e.palette.grey[600]
            ),
          },
          last: { borderLeft: "none" },
          transition: {},
        };
      },
      { name: "PwzrStepContent" }
    )(xp),
    Q();
  var _w = mh.createElement(_f, null),
    vp = mh.forwardRef(function (e, t) {
      var n = e.activeStep,
        i = void 0 === n ? 0 : n,
        r = e.alternativeLabel,
        o = void 0 !== r && r,
        a = e.children,
        s = e.classes,
        n = e.className,
        r = e.connector,
        l = void 0 === r ? _w : r,
        r = e.nonLinear,
        c = void 0 !== r && r,
        r = e.orientation,
        u = void 0 === r ? "horizontal" : r,
        e = xu(e, [
          "activeStep",
          "alternativeLabel",
          "children",
          "classes",
          "className",
          "connector",
          "nonLinear",
          "orientation",
        ]),
        d = mh.isValidElement(l)
          ? mh.cloneElement(l, { orientation: u })
          : null,
        p = mh.Children.toArray(a),
        a = p.map(function (e, t) {
          var n = {
              alternativeLabel: o,
              connector: l,
              last: t + 1 === p.length,
              orientation: u,
            },
            r = { index: t, active: !1, completed: !1, disabled: !1 };
          return (
            i === t
              ? (r.active = !0)
              : !c && t < i
              ? (r.completed = !0)
              : !c && i < t && (r.disabled = !0),
            [
              !o && d && 0 !== t && mh.cloneElement(d, Su({ key: t }, r)),
              mh.cloneElement(e, Su({}, n, {}, r, {}, e.props)),
            ]
          );
        });
      return mh.createElement(
        mg,
        Su(
          {
            square: !0,
            elevation: 0,
            className: Ph(s.root, s[u], n, o && s.alternativeLabel),
            ref: t,
          },
          e
        ),
        a
      );
    });
  Uh(
    {
      root: { display: "flex", padding: 24 },
      horizontal: { flexDirection: "row", alignItems: "center" },
      vertical: { flexDirection: "column" },
      alternativeLabel: { alignItems: "flex-start" },
    },
    { name: "PwzrStepper" }
  )(vp),
    Q(),
    Q();
  var xp = mh.forwardRef(function (e, t) {
      var n = e.anchor,
        r = e.classes,
        i = e.className,
        o = e.width,
        e = xu(e, ["anchor", "classes", "className", "width"]);
      return mh.createElement(
        "div",
        Su(
          {
            className: Ph(r.root, r["anchor".concat(ag(n))], i),
            ref: t,
            style: bu({}, uy(n) ? "width" : "height", o),
          },
          e
        )
      );
    }),
    Dw = Uh(
      function (e) {
        return {
          root: {
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            zIndex: e.zIndex.drawer - 1,
          },
          anchorLeft: { right: "auto" },
          anchorRight: { left: "auto", right: 0 },
          anchorTop: { bottom: "auto", right: 0 },
          anchorBottom: { top: "auto", bottom: 0, right: 0 },
        };
      },
      { name: "PrivateSwipeArea" }
    )(xp),
    Aw = null;
  function Fw(e, t) {
    return "right" === e ? document.body.offsetWidth - t[0].pageX : t[0].pageX;
  }
  function Bw(e, t) {
    return "bottom" === e ? window.innerHeight - t[0].clientY : t[0].clientY;
  }
  function Ww(e, t) {
    return e ? t.clientWidth : t.clientHeight;
  }
  function $w(e, t, n, r) {
    return Math.min(Math.max(n ? t - e : r + t - e, 0), r);
  }
  var jw =
      "undefined" != typeof navigator &&
      /iPad|iPhone|iPod/.test(navigator.userAgent),
    Hw = { enter: Nd.enteringScreen, exit: Nd.leavingScreen },
    Vw = "undefined" != typeof window ? mh.useLayoutEffect : mh.useEffect;
  mh.forwardRef(function (e, t) {
    var n = e.anchor,
      f = void 0 === n ? "left" : n,
      r = e.disableBackdropTransition,
      a = void 0 !== r && r,
      i = e.disableDiscovery,
      h = void 0 !== i && i,
      o = e.disableSwipeToOpen,
      s = void 0 === o ? jw : o,
      l = e.hideBackdrop,
      c = e.hysteresis,
      u = void 0 === c ? 0.52 : c,
      d = e.minFlingVelocity,
      p = void 0 === d ? 450 : d,
      m = e.ModalProps,
      n = (m = void 0 === m ? {} : m).BackdropProps,
      r = xu(m, ["BackdropProps"]),
      g = e.onClose,
      v = e.onOpen,
      y = e.open,
      i = e.PaperProps,
      o = void 0 === i ? {} : i,
      c = e.SwipeAreaProps,
      d = e.swipeAreaWidth,
      b = void 0 === d ? 20 : d,
      m = e.transitionDuration,
      w = void 0 === m ? Hw : m,
      i = e.variant,
      x = void 0 === i ? "temporary" : i,
      d = xu(e, [
        "anchor",
        "disableBackdropTransition",
        "disableDiscovery",
        "disableSwipeToOpen",
        "hideBackdrop",
        "hysteresis",
        "minFlingVelocity",
        "ModalProps",
        "onClose",
        "onOpen",
        "open",
        "PaperProps",
        "SwipeAreaProps",
        "swipeAreaWidth",
        "transitionDuration",
        "variant",
      ]),
      E = qh(),
      m = mh.useState(!1),
      i = m[0],
      S = m[1],
      C = mh.useRef({ isSwiping: null }),
      k = mh.useRef(),
      T = mh.useRef(),
      P = mh.useRef(),
      z = mh.useRef(!1),
      O = mh.useRef();
    Vw(
      function () {
        O.current = null;
      },
      [y]
    );
    var R = mh.useCallback(
        function (e) {
          var t =
              1 < arguments.length && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            n = t.mode,
            r = void 0 === n ? null : n,
            i = t.changeTransition,
            o = void 0 === i || i,
            n = dy(E, f),
            t = -1 !== ["right", "bottom"].indexOf(n) ? 1 : -1,
            i = uy(f),
            n = i
              ? "translate(".concat(t * e, "px, 0)")
              : "translate(0, ".concat(t * e, "px)"),
            t = P.current.style;
          (t.webkitTransform = n), (t.transform = n);
          n = "";
          r &&
            (n = E.transitions.create("all", Ng({ timeout: w }, { mode: r }))),
            o && ((t.webkitTransition = n), (t.transition = n)),
            a ||
              l ||
              (((t = T.current.style).opacity = 1 - e / Ww(i, P.current)),
              o && ((t.webkitTransition = n), (t.transition = n)));
        },
        [f, a, l, E, w]
      ),
      M = jg(function (e) {
        var t, n, r;
        z.current &&
          ((Aw = null),
          (z.current = !1),
          S(!1),
          C.current.isSwiping
            ? ((C.current.isSwiping = null),
              (r = dy(E, f)),
              (n = ((t = uy(f)) ? Fw : Bw)(r, e.changedTouches)),
              (r = t ? C.current.startX : C.current.startY),
              (e = Ww(t, P.current)),
              (r = (n = $w(n, r, y, e)) / e),
              Math.abs(C.current.velocity) > p &&
                (O.current = 1e3 * Math.abs((e - n) / C.current.velocity)),
              y
                ? C.current.velocity > p || u < r
                  ? g()
                  : R(0, { mode: "exit" })
                : C.current.velocity < -p || u < 1 - r
                ? v()
                : R(Ww(t, P.current), { mode: "enter" }))
            : (C.current.isSwiping = null));
      }),
      N = jg(function (e) {
        if (P.current && z.current && (null == Aw || Aw === C.current)) {
          var t = dy(E, f),
            n = uy(f),
            r = Fw(t, e.touches),
            t = Bw(t, e.touches);
          if (y && P.current.contains(e.target) && null == Aw) {
            o =
              ((o = {
                domTreeShapes: (function (e, t) {
                  for (var n = []; e && e !== t; ) {
                    var r = window.getComputedStyle(e);
                    "absolute" === r.getPropertyValue("position") ||
                    "hidden" === r.getPropertyValue("overflow-x")
                      ? (n = [])
                      : ((0 < e.clientWidth && e.scrollWidth > e.clientWidth) ||
                          (0 < e.clientHeight &&
                            e.scrollHeight > e.clientHeight)) &&
                        n.push(e),
                      (e = e.parentElement);
                  }
                  return n;
                })(e.target, P.current),
                start: n ? C.current.startX : C.current.startY,
                current: n ? r : t,
                anchor: f,
              }),
              (s = o.start),
              (l = o.current),
              (c = o.anchor),
              (u = { x: "scrollLeft", y: "scrollTop" }),
              (d = { x: "scrollWidth", y: "scrollHeight" }),
              (p = { x: "clientWidth", y: "clientHeight" }),
              o.domTreeShapes.some(function (e) {
                var t = s <= l;
                ("top" !== c && "left" !== c) || (t = !t);
                var n = "left" === c || "right" === c ? "x" : "y",
                  r = e[u[n]],
                  i = 0 < r,
                  n = r + e[p[n]] < e[d[n]];
                return (t && n) || (!t && i) ? e : null;
              }));
            if (o) return void (Aw = o);
            Aw = C.current;
          }
          if (null == C.current.isSwiping) {
            var i = Math.abs(r - C.current.startX),
              o = Math.abs(t - C.current.startY);
            o < i && e.cancelable && e.preventDefault();
            var a = n ? o < i && 3 < i : i < o && 3 < o;
            if (!0 == a || (n ? 3 < o : 3 < i)) {
              if (!(C.current.isSwiping = a)) return void M(e);
              (C.current.startX = r),
                (C.current.startY = t),
                h ||
                  y ||
                  (n ? (C.current.startX -= b) : (C.current.startY -= b));
            }
          }
          if (C.current.isSwiping) {
            (i = Ww(n, P.current)),
              (a = n ? C.current.startX : C.current.startY);
            y && !C.current.paperHit && (a = Math.min(a, i));
            a = $w(n ? r : t, a, y, i);
            if (y)
              if (C.current.paperHit)
                0 === a && ((C.current.startX = r), (C.current.startY = t));
              else {
                if (!(n ? r < i : t < i)) return;
                (C.current.paperHit = !0),
                  (C.current.startX = r),
                  (C.current.startY = t);
              }
            null === C.current.lastTranslate &&
              ((C.current.lastTranslate = a),
              (C.current.lastTime = performance.now() + 1));
            t =
              ((a - C.current.lastTranslate) /
                (performance.now() - C.current.lastTime)) *
              1e3;
            (C.current.velocity = 0.4 * C.current.velocity + 0.6 * t),
              (C.current.lastTranslate = a),
              (C.current.lastTime = performance.now()),
              e.cancelable && e.preventDefault(),
              R(a);
          }
        }
        var o, s, l, c, u, d, p;
      }),
      L = jg(function (e) {
        if (
          !e.defaultPrevented &&
          !e.muiHandled &&
          (!y || T.current.contains(e.target) || P.current.contains(e.target))
        ) {
          var t = dy(E, f),
            n = uy(f),
            r = Fw(t, e.touches),
            t = Bw(t, e.touches);
          if (!y) {
            if (s || e.target !== k.current) return;
            if (n) {
              if (b < r) return;
            } else if (b < t) return;
          }
          (e.muiHandled = !0),
            (Aw = null),
            (C.current.startX = r),
            (C.current.startY = t),
            S(!0),
            !y &&
              P.current &&
              R(Ww(n, P.current) + (h ? 20 : -b), { changeTransition: !1 }),
            (C.current.velocity = 0),
            (C.current.lastTime = null),
            (C.current.lastTranslate = null),
            (C.current.paperHit = !1),
            (z.current = !0);
        }
      });
    mh.useEffect(
      function () {
        if ("temporary" === x) {
          var e = Fv(P.current);
          return (
            e.addEventListener("touchstart", L),
            e.addEventListener("touchmove", N, { passive: !1 }),
            e.addEventListener("touchend", M),
            function () {
              e.removeEventListener("touchstart", L),
                e.removeEventListener("touchmove", N, { passive: !1 }),
                e.removeEventListener("touchend", M);
            }
          );
        }
      },
      [x, L, N, M]
    ),
      mh.useEffect(function () {
        return function () {
          Aw === C.current && (Aw = null);
        };
      }, []),
      mh.useEffect(
        function () {
          y || S(!1);
        },
        [y]
      );
    (e = mh.useCallback(function (e) {
      T.current = zg.findDOMNode(e);
    }, [])),
      (m = mh.useCallback(function (e) {
        P.current = zg.findDOMNode(e);
      }, []));
    return mh.createElement(
      mh.Fragment,
      null,
      mh.createElement(
        fy,
        Su(
          {
            open: !("temporary" !== x || !i) || y,
            variant: x,
            ModalProps: Su({ BackdropProps: Su({}, n, { ref: e }) }, r),
            PaperProps: Su({}, o, {
              style: Su(
                { pointerEvents: "temporary" !== x || y ? "" : "none" },
                o.style
              ),
              ref: m,
            }),
            anchor: f,
            transitionDuration: O.current || w,
            onClose: g,
            ref: t,
          },
          d
        )
      ),
      !s &&
        "temporary" === x &&
        mh.createElement(
          Wg,
          null,
          mh.createElement(Dw, Su({ anchor: f, ref: k, width: b }, c))
        )
    );
  }),
    Q(),
    (_f = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.color,
        o = void 0 === i ? "secondary" : i,
        a = e.edge,
        s = void 0 !== a && a,
        i = e.size,
        a = void 0 === i ? "medium" : i,
        i = xu(e, ["classes", "className", "color", "edge", "size"]),
        e = mh.createElement("span", { className: n.thumb });
      return mh.createElement(
        "span",
        {
          className: Ph(
            n.root,
            r,
            { start: n.edgeStart, end: n.edgeEnd }[s],
            "small" === a && n["size".concat(ag(a))]
          ),
        },
        mh.createElement(
          Lv,
          Su(
            {
              type: "checkbox",
              icon: e,
              checkedIcon: e,
              classes: {
                root: Ph(n.switchBase, n["color".concat(ag(o))]),
                input: n.input,
                checked: n.checked,
                disabled: n.disabled,
              },
              ref: t,
            },
            i
          )
        ),
        mh.createElement("span", { className: n.track })
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            display: "inline-flex",
            width: 58,
            height: 38,
            overflow: "hidden",
            padding: 12,
            boxSizing: "border-box",
            position: "relative",
            flexShrink: 0,
            zIndex: 0,
            verticalAlign: "middle",
          },
          edgeStart: { marginLeft: -8 },
          edgeEnd: { marginRight: -8 },
          switchBase: {
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
            color:
              "light" === e.palette.type
                ? e.palette.grey[50]
                : e.palette.grey[400],
            transition: e.transitions.create(["left", "transform"], {
              duration: e.transitions.duration.shortest,
            }),
            "&$checked": { transform: "translateX(20px)" },
            "&$disabled": {
              color:
                "light" === e.palette.type
                  ? e.palette.grey[400]
                  : e.palette.grey[800],
            },
            "&$checked + $track": { opacity: 0.5 },
            "&$disabled + $track": {
              opacity: "light" === e.palette.type ? 0.12 : 0.1,
            },
          },
          colorPrimary: {
            "&$checked": {
              color: e.palette.primary.main,
              "&:hover": {
                backgroundColor: gu(
                  e.palette.primary.main,
                  e.palette.action.hoverOpacity
                ),
                "@media (hover: none)": { backgroundColor: "transparent" },
              },
            },
            "&$disabled": {
              color:
                "light" === e.palette.type
                  ? e.palette.grey[400]
                  : e.palette.grey[800],
            },
            "&$checked + $track": { backgroundColor: e.palette.primary.main },
            "&$disabled + $track": {
              backgroundColor:
                "light" === e.palette.type
                  ? e.palette.common.black
                  : e.palette.common.white,
            },
          },
          colorSecondary: {
            "&$checked": {
              color: e.palette.secondary.main,
              "&:hover": {
                backgroundColor: gu(
                  e.palette.secondary.main,
                  e.palette.action.hoverOpacity
                ),
                "@media (hover: none)": { backgroundColor: "transparent" },
              },
            },
            "&$disabled": {
              color:
                "light" === e.palette.type
                  ? e.palette.grey[400]
                  : e.palette.grey[800],
            },
            "&$checked + $track": { backgroundColor: e.palette.secondary.main },
            "&$disabled + $track": {
              backgroundColor:
                "light" === e.palette.type
                  ? e.palette.common.black
                  : e.palette.common.white,
            },
          },
          sizeSmall: {
            width: 40,
            height: 24,
            padding: 7,
            "& $thumb": { width: 16, height: 16 },
            "& $switchBase": {
              padding: 4,
              "&$checked": { transform: "translateX(16px)" },
            },
          },
          checked: {},
          disabled: {},
          input: { left: "-100%", width: "300%" },
          thumb: {
            boxShadow: e.shadows[1],
            backgroundColor: "currentColor",
            width: 20,
            height: 20,
            borderRadius: "50%",
          },
          track: {
            height: "100%",
            width: "100%",
            borderRadius: 7,
            zIndex: -1,
            transition: e.transitions.create(["opacity", "background-color"], {
              duration: e.transitions.duration.shortest,
            }),
            backgroundColor:
              "light" === e.palette.type
                ? e.palette.common.black
                : e.palette.common.white,
            opacity: "light" === e.palette.type ? 0.38 : 0.3,
          },
        };
      },
      { name: "PwzrSwitch" }
    )(_f),
    Q(),
    (vp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.disabled,
        o = void 0 !== i && i,
        a = e.disableFocusRipple,
        s = void 0 !== a && a,
        l = e.fullWidth,
        c = e.icon,
        u = e.indicator,
        d = e.label,
        p = e.onChange,
        f = e.onClick,
        h = e.selected,
        i = e.textColor,
        a = void 0 === i ? "inherit" : i,
        m = e.value,
        i = e.wrapped,
        i = void 0 !== i && i,
        e = xu(e, [
          "classes",
          "className",
          "disabled",
          "disableFocusRipple",
          "fullWidth",
          "icon",
          "indicator",
          "label",
          "onChange",
          "onClick",
          "selected",
          "textColor",
          "value",
          "wrapped",
        ]);
      return mh.createElement(
        nv,
        Su(
          {
            focusRipple: !s,
            className: Ph(
              n.root,
              n["textColor".concat(ag(a))],
              r,
              o && n.disabled,
              h && n.selected,
              d && c && n.labelIcon,
              l && n.fullWidth,
              i && n.wrapped
            ),
            ref: t,
            role: "tab",
            "aria-selected": h,
            disabled: o,
            onClick: function (e) {
              p && p(e, m), f && f(e);
            },
          },
          e
        ),
        mh.createElement("span", { className: n.wrapper }, c, d),
        u
      );
    })),
    Uh(
      function (e) {
        var t;
        return {
          root: Su(
            {},
            e.typography.button,
            (bu(
              (t = {
                maxWidth: 264,
                minWidth: 72,
                position: "relative",
                boxSizing: "border-box",
                minHeight: 48,
                flexShrink: 0,
                padding: "6px 12px",
              }),
              e.breakpoints.up("sm"),
              { padding: "6px 24px" }
            ),
            bu(t, "overflow", "hidden"),
            bu(t, "whiteSpace", "normal"),
            bu(t, "textAlign", "center"),
            bu(t, e.breakpoints.up("sm"), { minWidth: 160 }),
            t)
          ),
          labelIcon: {
            minHeight: 72,
            paddingTop: 9,
            "& $wrapper > *:first-child": { marginBottom: 6 },
          },
          textColorInherit: {
            color: "inherit",
            opacity: 0.7,
            "&$selected": { opacity: 1 },
            "&$disabled": { opacity: 0.5 },
          },
          textColorPrimary: {
            color: e.palette.text.secondary,
            "&$selected": { color: e.palette.primary.main },
            "&$disabled": { color: e.palette.text.disabled },
          },
          textColorSecondary: {
            color: e.palette.text.secondary,
            "&$selected": { color: e.palette.secondary.main },
            "&$disabled": { color: e.palette.text.disabled },
          },
          selected: {},
          disabled: {},
          fullWidth: {
            flexShrink: 1,
            flexGrow: 1,
            flexBasis: 0,
            maxWidth: "none",
          },
          wrapped: { fontSize: e.typography.pxToRem(12), lineHeight: 1.5 },
          wrapper: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            flexDirection: "column",
          },
        };
      },
      { name: "PwzrTab" }
    )(vp),
    Q(),
    Q();
  var qw = mh.createContext(),
    xp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.component,
        o = void 0 === i ? "table" : i,
        i = e.padding,
        a = void 0 === i ? "default" : i,
        i = e.size,
        s = void 0 === i ? "medium" : i,
        i = e.stickyHeader,
        l = void 0 !== i && i,
        i = xu(e, [
          "classes",
          "className",
          "component",
          "padding",
          "size",
          "stickyHeader",
        ]),
        e = mh.useMemo(
          function () {
            return { padding: a, size: s, stickyHeader: l };
          },
          [a, s, l]
        );
      return mh.createElement(
        qw.Provider,
        { value: e },
        mh.createElement(
          o,
          Su({ ref: t, className: Ph(n.root, r, l && n.stickyHeader) }, i)
        )
      );
    });
  Uh(
    function (e) {
      return {
        root: {
          display: "table",
          width: "100%",
          borderCollapse: "collapse",
          borderSpacing: 0,
          "& caption": Su({}, e.typography.body2, {
            padding: e.spacing(2),
            color: e.palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom",
          }),
        },
        stickyHeader: { borderCollapse: "separate" },
      };
    },
    { name: "PwzrTable" }
  )(xp),
    Q(),
    Q();
  var Uw = mh.createContext(),
    Gw = { variant: "body" },
    _f = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.component,
        i = void 0 === i ? "tbody" : i,
        e = xu(e, ["classes", "className", "component"]);
      return mh.createElement(
        Uw.Provider,
        { value: Gw },
        mh.createElement(i, Su({ className: Ph(n.root, r), ref: t }, e))
      );
    });
  Uh({ root: { display: "table-row-group" } }, { name: "PwzrTableBody" })(_f),
    Q();
  var vp = mh.forwardRef(function (e, t) {
      var n = e.align,
        r = void 0 === n ? "inherit" : n,
        i = e.classes,
        o = e.className,
        a = e.component,
        s = e.padding,
        l = e.scope,
        c = e.size,
        u = e.sortDirection,
        d = e.variant,
        p = xu(e, [
          "align",
          "classes",
          "className",
          "component",
          "padding",
          "scope",
          "size",
          "sortDirection",
          "variant",
        ]),
        n = mh.useContext(qw),
        e = mh.useContext(Uw),
        a = a || (e && "head" === e.variant ? "th" : "td"),
        l = l;
      !l && e && "head" === e.variant && (l = "col");
      (s = s || (n && n.padding ? n.padding : "default")),
        (c = c || (n && n.size ? n.size : "medium")),
        (e = d || (e && e.variant)),
        (u = u ? ("asc" === u ? "ascending" : "descending") : null);
      return mh.createElement(
        a,
        Su(
          {
            ref: t,
            className: Ph(
              i.root,
              i[e],
              o,
              "inherit" !== r && i["align".concat(ag(r))],
              "default" !== s && i["padding".concat(ag(s))],
              "medium" !== c && i["size".concat(ag(c))],
              "head" === e && n && n.stickyHeader && i.stickyHeader
            ),
            "aria-sort": u,
            scope: l,
          },
          p
        )
      );
    }),
    Yw = Uh(
      function (e) {
        return {
          root: Su({}, e.typography.body2, {
            display: "table-cell",
            verticalAlign: "inherit",
            borderBottom: "1px solid\n    ".concat(
              "light" === e.palette.type
                ? yu(gu(e.palette.divider, 1), 0.88)
                : vu(gu(e.palette.divider, 1), 0.68)
            ),
            textAlign: "left",
            padding: 16,
          }),
          head: {
            color: e.palette.text.primary,
            lineHeight: e.typography.pxToRem(24),
            fontWeight: e.typography.fontWeightMedium,
          },
          body: { color: e.palette.text.primary },
          footer: {
            color: e.palette.text.secondary,
            lineHeight: e.typography.pxToRem(21),
            fontSize: e.typography.pxToRem(12),
          },
          sizeSmall: {
            padding: "6px 24px 6px 16px",
            "&:last-child": { paddingRight: 16 },
            "&$paddingCheckbox": {
              width: 24,
              padding: "0px 12px 0 16px",
              "&:last-child": { paddingLeft: 12, paddingRight: 16 },
              "& > *": { padding: 0 },
            },
          },
          paddingCheckbox: {
            width: 48,
            padding: "0 0 0 4px",
            "&:last-child": { paddingLeft: 0, paddingRight: 4 },
          },
          paddingNone: { padding: 0, "&:last-child": { padding: 0 } },
          alignLeft: { textAlign: "left" },
          alignCenter: { textAlign: "center" },
          alignRight: { textAlign: "right", flexDirection: "row-reverse" },
          alignJustify: { textAlign: "justify" },
          stickyHeader: {
            position: "sticky",
            top: 0,
            left: 0,
            zIndex: 2,
            backgroundColor: e.palette.background.default,
          },
        };
      },
      { name: "PwzrTableCell" }
    )(vp);
  Q(),
    (xp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.component,
        i = void 0 === i ? "div" : i,
        e = xu(e, ["classes", "className", "component"]);
      return mh.createElement(i, Su({ ref: t, className: Ph(n.root, r) }, e));
    })),
    Uh(
      { root: { width: "100%", overflowX: "auto" } },
      { name: "PwzrTableContainer" }
    )(xp),
    Q();
  var Xw = { variant: "footer" },
    _f = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.component,
        i = void 0 === i ? "tfoot" : i,
        e = xu(e, ["classes", "className", "component"]);
      return mh.createElement(
        Uw.Provider,
        { value: Xw },
        mh.createElement(i, Su({ className: Ph(n.root, r), ref: t }, e))
      );
    });
  Uh(
    { root: { display: "table-footer-group" } },
    { name: "PwzrTableFooter" }
  )(_f),
    Q();
  var Kw = { variant: "head" },
    vp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.component,
        i = void 0 === i ? "thead" : i,
        e = xu(e, ["classes", "className", "component"]);
      return mh.createElement(
        Uw.Provider,
        { value: Kw },
        mh.createElement(i, Su({ className: Ph(n.root, r), ref: t }, e))
      );
    });
  Uh(
    { root: { display: "table-header-group" } },
    { name: "PwzrTableHead" }
  )(vp),
    Q();
  var xp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.component,
        o = void 0 === i ? "div" : i,
        a = e.disableGutters,
        i = void 0 !== a && a,
        a = e.variant,
        a = void 0 === a ? "regular" : a,
        e = xu(e, [
          "classes",
          "className",
          "component",
          "disableGutters",
          "variant",
        ]);
      return mh.createElement(
        o,
        Su({ className: Ph(n.root, n[a], r, !i && n.gutters), ref: t }, e)
      );
    }),
    Zw = Uh(
      function (e) {
        return {
          root: { position: "relative", display: "flex", alignItems: "center" },
          gutters: bu(
            { paddingLeft: e.spacing(2), paddingRight: e.spacing(2) },
            e.breakpoints.up("sm"),
            { paddingLeft: e.spacing(3), paddingRight: e.spacing(3) }
          ),
          regular: e.mixins.toolbar,
          dense: { minHeight: 48 },
        };
      },
      { name: "PwzrToolbar" }
    )(xp);
  function Qw(e) {
    var t = e.from,
      n = e.to,
      e = e.count;
    return ""
      .concat(t, "-")
      .concat(-1 === n ? e : n, " of ")
      .concat(-1 !== e ? e : "more than ".concat(n));
  }
  Q(),
    Q(),
    Q(),
    (_f = gg(
      mh.createElement("path", {
        d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z",
      })
    )),
    Q();
  var vp = gg(
      mh.createElement("path", {
        d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z",
      })
    ),
    Jw = mh.createElement(vp, null),
    ex = mh.createElement(_f, null),
    tx = mh.createElement(_f, null),
    nx = mh.createElement(vp, null),
    rx = mh.forwardRef(function (e, t) {
      var n = e.backIconButtonProps,
        r = e.count,
        i = e.nextIconButtonProps,
        o = e.onChangePage,
        a = e.page,
        s = e.rowsPerPage,
        l = xu(e, [
          "backIconButtonProps",
          "count",
          "nextIconButtonProps",
          "onChangePage",
          "page",
          "rowsPerPage",
        ]),
        e = qh();
      return mh.createElement(
        "div",
        Su({ ref: t }, l),
        mh.createElement(
          Nv,
          Su(
            {
              onClick: function (e) {
                o(e, a - 1);
              },
              disabled: 0 === a,
              color: "inherit",
            },
            n
          ),
          "rtl" === e.direction ? Jw : ex
        ),
        mh.createElement(
          Nv,
          Su(
            {
              onClick: function (e) {
                o(e, a + 1);
              },
              disabled: -1 !== r && a >= Math.ceil(r / s) - 1,
              color: "inherit",
            },
            i
          ),
          "rtl" === e.direction ? tx : nx
        )
      );
    }),
    ix = [10, 25, 50, 100],
    xp = mh.forwardRef(function (e, t) {
      var n,
        r = e.ActionsComponent,
        i = void 0 === r ? rx : r,
        o = e.backIconButtonProps,
        a = e.backIconButtonText,
        s = void 0 === a ? "Previous page" : a,
        l = e.classes,
        c = e.className,
        u = e.colSpan,
        d = e.component,
        p = void 0 === d ? Yw : d,
        f = e.count,
        h = e.labelDisplayedRows,
        m = void 0 === h ? Qw : h,
        g = e.labelRowsPerPage,
        v = void 0 === g ? "Rows per page:" : g,
        y = e.nextIconButtonProps,
        b = e.nextIconButtonText,
        w = void 0 === b ? "Next page" : b,
        r = e.onChangePage,
        a = e.onChangeRowsPerPage,
        d = e.page,
        h = e.rowsPerPage,
        g = e.rowsPerPageOptions,
        b = void 0 === g ? ix : g,
        g = e.SelectProps,
        g = void 0 === g ? {} : g,
        e = xu(e, [
          "ActionsComponent",
          "backIconButtonProps",
          "backIconButtonText",
          "classes",
          "className",
          "colSpan",
          "component",
          "count",
          "labelDisplayedRows",
          "labelRowsPerPage",
          "nextIconButtonProps",
          "nextIconButtonText",
          "onChangePage",
          "onChangeRowsPerPage",
          "page",
          "rowsPerPage",
          "rowsPerPageOptions",
          "SelectProps",
        ]);
      (p !== Yw && "td" !== p) || (n = u || 1e3);
      var x = g.native ? "option" : ab;
      return mh.createElement(
        p,
        Su({ className: Ph(l.root, c), colSpan: n, ref: t }, e),
        mh.createElement(
          Zw,
          { className: l.toolbar },
          mh.createElement("div", { className: l.spacer }),
          1 < b.length &&
            mh.createElement(
              Cv,
              { color: "inherit", variant: "body2", className: l.caption },
              v
            ),
          1 < b.length &&
            mh.createElement(
              vw,
              Su(
                {
                  classes: { select: l.select, icon: l.selectIcon },
                  input: mh.createElement(Sy, {
                    className: Ph(l.input, l.selectRoot),
                  }),
                  value: h,
                  onChange: a,
                },
                g
              ),
              b.map(function (e) {
                return mh.createElement(
                  x,
                  {
                    className: l.menuItem,
                    key: e.value || e,
                    value: e.value || e,
                  },
                  e.label || e
                );
              })
            ),
          mh.createElement(
            Cv,
            { color: "inherit", variant: "body2", className: l.caption },
            m({
              from: 0 === f ? 0 : d * h + 1,
              to: -1 !== f ? Math.min(f, (d + 1) * h) : (d + 1) * h,
              count: f,
              page: d,
            })
          ),
          mh.createElement(i, {
            className: l.actions,
            backIconButtonProps: Su({ title: s, "aria-label": s }, o),
            count: f,
            nextIconButtonProps: Su({ title: w, "aria-label": w }, y),
            onChangePage: r,
            page: d,
            rowsPerPage: h,
          })
        )
      );
    });
  Uh(
    function (e) {
      return {
        root: {
          color: e.palette.text.primary,
          fontSize: e.typography.pxToRem(14),
          overflow: "auto",
          "&:last-child": { padding: 0 },
        },
        toolbar: { minHeight: 52, paddingRight: 2 },
        spacer: { flex: "1 1 100%" },
        caption: { flexShrink: 0 },
        selectRoot: { marginRight: 32, marginLeft: 8 },
        select: {
          paddingLeft: 8,
          paddingRight: 24,
          textAlign: "right",
          textAlignLast: "right",
        },
        selectIcon: {},
        input: { color: "inherit", fontSize: "inherit", flexShrink: 0 },
        menuItem: {},
        actions: { flexShrink: 0, marginLeft: 20 },
      };
    },
    { name: "PwzrTablePagination" }
  )(xp),
    Q(),
    (xp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.component,
        o = void 0 === i ? "tr" : i,
        a = e.hover,
        s = void 0 !== a && a,
        i = e.selected,
        a = void 0 !== i && i,
        i = xu(e, ["classes", "className", "component", "hover", "selected"]),
        e = mh.useContext(Uw);
      return mh.createElement(
        o,
        Su(
          {
            ref: t,
            className: Ph(
              n.root,
              r,
              e && { head: n.head, footer: n.footer }[e.variant],
              s && n.hover,
              a && n.selected
            ),
          },
          i
        )
      );
    })),
    Uh(
      function (e) {
        return {
          root: {
            color: "inherit",
            display: "table-row",
            verticalAlign: "middle",
            outline: 0,
            "&$hover:hover": { backgroundColor: e.palette.action.hover },
            "&$selected,&$selected:hover": {
              backgroundColor: gu(
                e.palette.secondary.main,
                e.palette.action.selectedOpacity
              ),
            },
          },
          selected: {},
          hover: {},
          head: {},
          footer: {},
        };
      },
      { name: "PwzrTableRow" }
    )(xp),
    Q(),
    Q();
  var ox,
    ax = gg(
      mh.createElement("path", {
        d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z",
      })
    ),
    xp = mh.forwardRef(function (e, t) {
      var n = e.active,
        r = void 0 !== n && n,
        i = e.children,
        o = e.classes,
        a = e.className,
        s = e.direction,
        l = void 0 === s ? "asc" : s,
        n = e.hideSortIcon,
        s = void 0 !== n && n,
        n = e.IconComponent,
        n = void 0 === n ? ax : n,
        e = xu(e, [
          "active",
          "children",
          "classes",
          "className",
          "direction",
          "hideSortIcon",
          "IconComponent",
        ]);
      return mh.createElement(
        nv,
        Su(
          {
            className: Ph(o.root, a, r && o.active),
            component: "span",
            disableRipple: !0,
            ref: t,
          },
          e
        ),
        i,
        s && !r
          ? null
          : mh.createElement(n, {
              className: Ph(o.icon, o["iconDirection".concat(ag(l))]),
            })
      );
    });
  function sx() {
    if (ox) return ox;
    var e = document.createElement("div");
    return (
      e.appendChild(document.createTextNode("ABCD")),
      (e.dir = "rtl"),
      (e.style.fontSize = "14px"),
      (e.style.width = "4px"),
      (e.style.height = "1px"),
      (e.style.position = "absolute"),
      (e.style.top = "-1000px"),
      (e.style.overflow = "scroll"),
      document.body.appendChild(e),
      (ox = "reverse"),
      0 < e.scrollLeft
        ? (ox = "default")
        : ((e.scrollLeft = 1), 0 === e.scrollLeft && (ox = "negative")),
      document.body.removeChild(e),
      ox
    );
  }
  function lx(e, t) {
    var n = e.scrollLeft;
    if ("rtl" !== t) return n;
    switch (sx()) {
      case "negative":
        return e.scrollWidth - e.clientWidth + n;
      case "reverse":
        return e.scrollWidth - e.clientWidth - n;
      default:
        return n;
    }
  }
  function cx(e) {
    return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
  }
  Uh(
    function (e) {
      return {
        root: {
          cursor: "pointer",
          display: "inline-flex",
          justifyContent: "flex-start",
          flexDirection: "inherit",
          alignItems: "center",
          "&:focus": { color: e.palette.text.secondary },
          "&:hover": {
            color: e.palette.text.secondary,
            "& $icon": { opacity: 0.5 },
          },
          "&$active": {
            color: e.palette.text.primary,
            "&& $icon": { opacity: 1, color: e.palette.text.secondary },
          },
        },
        active: {},
        icon: {
          fontSize: 18,
          marginRight: 4,
          marginLeft: 4,
          opacity: 0,
          transition: e.transitions.create(["opacity", "transform"], {
            duration: e.transitions.duration.shorter,
          }),
          userSelect: "none",
        },
        iconDirectionDesc: { transform: "rotate(0deg)" },
        iconDirectionAsc: { transform: "rotate(180deg)" },
      };
    },
    { name: "PwzrTableSortLabel" }
  )(xp),
    Q(),
    Q();
  var ux = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll",
  };
  function dx(e) {
    function t() {
      r.current = i.current.offsetHeight - i.current.clientHeight;
    }
    var n = e.onChange,
      e = xu(e, ["onChange"]),
      r = mh.useRef(),
      i = mh.useRef(null);
    return (
      mh.useEffect(
        function () {
          var e = oy(function () {
            var e = r.current;
            t(), e !== r.current && n(r.current);
          });
          return (
            window.addEventListener("resize", e),
            function () {
              e.clear(), window.removeEventListener("resize", e);
            }
          );
        },
        [n]
      ),
      mh.useEffect(
        function () {
          t(), n(r.current);
        },
        [n]
      ),
      mh.createElement("div", Su({ style: ux, ref: i }, e))
    );
  }
  Q();
  var xp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.color,
        o = e.orientation,
        e = xu(e, ["classes", "className", "color", "orientation"]);
      return mh.createElement(
        "span",
        Su(
          {
            className: Ph(
              n.root,
              n["color".concat(ag(i))],
              r,
              "vertical" === o && n.vertical
            ),
            ref: t,
          },
          e
        )
      );
    }),
    px = Uh(
      function (e) {
        return {
          root: {
            position: "absolute",
            height: 2,
            bottom: 0,
            width: "100%",
            transition: e.transitions.create(),
          },
          colorPrimary: { backgroundColor: e.palette.primary.main },
          colorSecondary: { backgroundColor: e.palette.secondary.main },
          vertical: { height: "100%", width: 2, right: 0 },
        };
      },
      { name: "PrivateTabIndicator" }
    )(xp);
  Q();
  var fx = mh.createElement(_f, { fontSize: "small" }),
    hx = mh.createElement(vp, { fontSize: "small" }),
    xp = mh.forwardRef(function (e, t) {
      var n = e.classes,
        r = e.className,
        i = e.direction,
        o = e.orientation,
        a = e.visible,
        e = xu(e, [
          "classes",
          "className",
          "direction",
          "orientation",
          "visible",
        ]),
        n = Ph(n.root, r, "vertical" === o && n.vertical);
      return a
        ? mh.createElement(
            nv,
            Su(
              {
                component: "div",
                className: n,
                ref: t,
                role: null,
                tabIndex: null,
              },
              e
            ),
            "left" === i ? fx : hx
          )
        : mh.createElement("div", { className: n });
    }),
    mx = Uh(
      {
        root: { width: 40, flexShrink: 0 },
        vertical: {
          width: "100%",
          height: 40,
          "& svg": { transform: "rotate(90deg)" },
        },
      },
      { name: "PrivateTabScrollButton" }
    )(xp),
    _f = mh.forwardRef(function (e, t) {
      function i() {
        var e,
          t,
          n = $.current;
        return (
          n &&
            ((e = n.getBoundingClientRect()),
            (e = {
              clientWidth: n.clientWidth,
              scrollLeft: n.scrollLeft,
              scrollTop: n.scrollTop,
              scrollLeftNormalized: lx(n, C.direction),
              scrollWidth: n.scrollWidth,
              top: e.top,
              bottom: e.bottom,
              left: e.left,
              right: e.right,
            })),
          !n ||
            !1 === E ||
            (0 < (n = j.current.children).length &&
              (t = (t = n[W.get(E)]) ? t.getBoundingClientRect() : null)),
          { tabsMeta: e, tabMeta: t }
        );
      }
      function r(e) {
        !(function (n, r, i, e, t) {
          var o = 3 < arguments.length && void 0 !== e ? e : {},
            a = 4 < arguments.length && void 0 !== t ? t : function () {},
            s = o.ease,
            l = void 0 === s ? cx : s,
            c = void 0 === (o = o.duration) ? 300 : o,
            u = null,
            d = r[n],
            p = !1,
            o = function e(t) {
              p
                ? a(new Error("Animation cancelled"))
                : (null === u && (u = t),
                  (t = Math.min(1, (t - u) / c)),
                  (r[n] = l(t) * (i - d) + d),
                  1 <= t
                    ? requestAnimationFrame(function () {
                        a(null);
                      })
                    : requestAnimationFrame(e));
            };
          d === i
            ? a(new Error("Element already at target position"))
            : requestAnimationFrame(o);
        })(z, $.current, e);
      }
      function n(e) {
        var t = $.current[z];
        P
          ? (t += e)
          : ((t += e * (T ? -1 : 1)), (t *= T && "reverse" === sx() ? -1 : 1)),
          r(t);
      }
      function o() {
        n(-$.current[M]);
      }
      function a() {
        n($.current[M]);
      }
      var s = e.action,
        l = e.centered,
        c = void 0 !== l && l,
        u = e.children,
        d = e.classes,
        p = e.className,
        f = e.component,
        h = void 0 === f ? "div" : f,
        m = e.indicatorColor,
        g = void 0 === m ? "secondary" : m,
        v = e.onChange,
        l = e.orientation,
        y = void 0 === l ? "horizontal" : l,
        f = e.ScrollButtonComponent,
        b = void 0 === f ? mx : f,
        m = e.scrollButtons,
        w = void 0 === m ? "auto" : m,
        l = e.TabIndicatorProps,
        f = void 0 === l ? {} : l,
        m = e.textColor,
        x = void 0 === m ? "inherit" : m,
        E = e.value,
        l = e.variant,
        S = void 0 === l ? "standard" : l,
        m = xu(e, [
          "action",
          "centered",
          "children",
          "classes",
          "className",
          "component",
          "indicatorColor",
          "onChange",
          "orientation",
          "ScrollButtonComponent",
          "scrollButtons",
          "TabIndicatorProps",
          "textColor",
          "value",
          "variant",
        ]),
        C = qh(),
        k = "scrollable" === S,
        T = "rtl" === C.direction,
        P = "vertical" === y,
        z = P ? "scrollTop" : "scrollLeft",
        O = P ? "top" : "left",
        R = P ? "bottom" : "right",
        M = P ? "clientHeight" : "clientWidth",
        N = P ? "height" : "width",
        l = mh.useState(!1),
        L = l[0],
        I = l[1],
        e = mh.useState({}),
        _ = e[0],
        D = e[1],
        l = mh.useState({ start: !1, end: !1 }),
        A = l[0],
        F = l[1],
        e = mh.useState({ overflow: "hidden", marginBottom: null }),
        l = e[0],
        B = e[1],
        W = new Map(),
        $ = mh.useRef(null),
        j = mh.useRef(null),
        H = jg(function () {
          var e = i(),
            t = e.tabsMeta,
            n = e.tabMeta,
            e = 0;
          n &&
            t &&
            (e = P
              ? n.top - t.top + t.scrollTop
              : ((r = T
                  ? t.scrollLeftNormalized + t.clientWidth - t.scrollWidth
                  : t.scrollLeft),
                n.left - t.left + r));
          var r,
            e = (bu((r = {}), O, e), bu(r, N, n ? n[N] : 0), r);
          isNaN(_[O]) || isNaN(_[N])
            ? D(e)
            : ((n = Math.abs(_[O] - e[O])),
              (r = Math.abs(_[N] - e[N])),
              (1 <= n || 1 <= r) && D(e));
        }),
        V = mh.useCallback(function (e) {
          B({ overflow: null, marginBottom: -e });
        }, []),
        q = jg(function () {
          var e = i(),
            t = e.tabsMeta,
            n = e.tabMeta;
          n &&
            t &&
            (n[O] < t[O]
              ? ((e = t[z] + (n[O] - t[O])), r(e))
              : n[R] > t[R] && ((t = t[z] + (n[R] - t[R])), r(t)));
        }),
        U = jg(function () {
          var e, t, n, r, i, o;
          k &&
            "off" !== w &&
            ((e = (o = $.current).scrollTop),
            (t = o.scrollHeight),
            (r = o.clientHeight),
            (n = o.scrollWidth),
            (o = o.clientWidth),
            (o = P
              ? ((i = 1 < e), e < t - r - 1)
              : ((r = lx($.current, C.direction)),
                (i = T ? r < n - o - 1 : 1 < r),
                T ? 1 < r : r < n - o - 1)),
            (i === A.start && o === A.end) || F({ start: i, end: o }));
        });
      mh.useEffect(
        function () {
          var e = oy(function () {
              H(), U();
            }),
            t = Gv($.current);
          return (
            t.addEventListener("resize", e),
            function () {
              e.clear(), t.removeEventListener("resize", e);
            }
          );
        },
        [H, U]
      );
      var G = mh.useCallback(
        oy(function () {
          U();
        })
      );
      mh.useEffect(
        function () {
          return function () {
            G.clear();
          };
        },
        [G]
      ),
        mh.useEffect(function () {
          I(!0);
        }, []),
        mh.useEffect(function () {
          H(), U();
        }),
        mh.useEffect(
          function () {
            q();
          },
          [q, _]
        ),
        mh.useImperativeHandle(
          s,
          function () {
            return { updateIndicator: H, updateScrollButtons: U };
          },
          [H, U]
        );
      var Y = mh.createElement(
          px,
          Su({ className: d.indicator, orientation: y, color: g }, f, {
            style: Su({}, _, {}, f.style),
          })
        ),
        X = 0,
        f = mh.Children.map(u, function (e) {
          if (!mh.isValidElement(e)) return null;
          var t = void 0 === e.props.value ? X : e.props.value;
          W.set(t, X);
          var n = t === E;
          return (
            (X += 1),
            mh.cloneElement(e, {
              fullWidth: "fullWidth" === S,
              indicator: n && !L && Y,
              selected: n,
              onChange: v,
              textColor: x,
              value: t,
            })
          );
        }),
        u = (function () {
          var e = {};
          e.scrollbarSizeListener = k
            ? mh.createElement(dx, { className: d.scrollable, onChange: V })
            : null;
          var t = A.start || A.end,
            t = k && (("auto" === w && t) || "desktop" === w || "on" === w);
          return (
            (e.scrollButtonStart = t
              ? mh.createElement(b, {
                  orientation: y,
                  direction: T ? "right" : "left",
                  onClick: o,
                  visible: A.start,
                  className: Ph(
                    d.scrollButtons,
                    "on" !== w && d.scrollButtonsDesktop
                  ),
                })
              : null),
            (e.scrollButtonEnd = t
              ? mh.createElement(b, {
                  orientation: y,
                  direction: T ? "left" : "right",
                  onClick: a,
                  visible: A.end,
                  className: Ph(
                    d.scrollButtons,
                    "on" !== w && d.scrollButtonsDesktop
                  ),
                })
              : null),
            e
          );
        })();
      return mh.createElement(
        h,
        Su({ className: Ph(d.root, p, P && d.vertical), ref: t }, m),
        u.scrollButtonStart,
        u.scrollbarSizeListener,
        mh.createElement(
          "div",
          {
            className: Ph(d.scroller, k ? d.scrollable : d.fixed),
            style: l,
            ref: $,
            onScroll: G,
          },
          mh.createElement(
            "div",
            {
              className: Ph(
                d.flexContainer,
                P && d.flexContainerVertical,
                c && !k && d.centered
              ),
              ref: j,
              role: "tablist",
            },
            f
          ),
          L && Y
        ),
        u.scrollButtonEnd
      );
    });
  Uh(
    function (e) {
      return {
        root: {
          overflow: "hidden",
          minHeight: 48,
          WebkitOverflowScrolling: "touch",
          display: "flex",
        },
        vertical: { flexDirection: "column" },
        flexContainer: { display: "flex" },
        flexContainerVertical: { flexDirection: "column" },
        centered: { justifyContent: "center" },
        scroller: {
          position: "relative",
          display: "inline-block",
          flex: "1 1 auto",
          whiteSpace: "nowrap",
        },
        fixed: { overflowX: "hidden", width: "100%" },
        scrollable: {
          overflowX: "scroll",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        },
        scrollButtons: {},
        scrollButtonsDesktop: bu({}, e.breakpoints.down("xs"), {
          display: "none",
        }),
        indicator: {},
      };
    },
    { name: "PwzrTabs" }
  )(_f),
    Q();
  var gx = { standard: If, filled: Yu, outlined: db },
    vp = mh.forwardRef(function (e, t) {
      var n = e.autoComplete,
        r = e.autoFocus,
        i = void 0 !== r && r,
        o = e.children,
        a = e.classes,
        s = e.className,
        l = e.color,
        c = void 0 === l ? "primary" : l,
        u = e.defaultValue,
        d = e.disabled,
        p = void 0 !== d && d,
        f = e.error,
        h = void 0 !== f && f,
        m = e.FormHelperTextProps,
        g = e.fullWidth,
        v = void 0 !== g && g,
        y = e.helperText,
        b = e.hiddenLabel,
        w = e.id,
        x = e.InputLabelProps,
        E = e.inputProps,
        S = e.InputProps,
        C = e.inputRef,
        k = e.label,
        T = e.multiline,
        P = void 0 !== T && T,
        z = e.name,
        O = e.onBlur,
        R = e.onChange,
        M = e.onFocus,
        N = e.placeholder,
        L = e.required,
        I = void 0 !== L && L,
        _ = e.rows,
        D = e.rowsMax,
        A = e.select,
        F = void 0 !== A && A,
        r = e.SelectProps,
        l = e.type,
        d = e.value,
        f = e.variant,
        g = void 0 === f ? "standard" : f,
        T = xu(e, [
          "autoComplete",
          "autoFocus",
          "children",
          "classes",
          "className",
          "color",
          "defaultValue",
          "disabled",
          "error",
          "FormHelperTextProps",
          "fullWidth",
          "helperText",
          "hiddenLabel",
          "id",
          "InputLabelProps",
          "inputProps",
          "InputProps",
          "inputRef",
          "label",
          "multiline",
          "name",
          "onBlur",
          "onChange",
          "onFocus",
          "placeholder",
          "required",
          "rows",
          "rowsMax",
          "select",
          "SelectProps",
          "type",
          "value",
          "variant",
        ]),
        L = {};
      "outlined" === g &&
        (x && void 0 !== x.shrink && (L.notched = x.shrink),
        (L.label = k && mh.createElement(mh.Fragment, null, k, I && " *"))),
        F &&
          ((r && r.native) || (L.id = void 0),
          (L["aria-describedby"] = void 0));
      (A = y && w ? "".concat(w, "-helper-text") : void 0),
        (f = k && w ? "".concat(w, "-label") : void 0),
        (e = gx[g]),
        (S = mh.createElement(
          e,
          Su(
            {
              "aria-describedby": A,
              autoComplete: n,
              autoFocus: i,
              defaultValue: u,
              fullWidth: v,
              multiline: P,
              name: z,
              rows: _,
              rowsMax: D,
              type: l,
              value: d,
              id: w,
              inputRef: C,
              onBlur: O,
              onChange: R,
              onFocus: M,
              placeholder: N,
              inputProps: E,
            },
            L,
            S
          )
        ));
      return mh.createElement(
        ky,
        Su(
          {
            className: Ph(a.root, s),
            disabled: p,
            error: h,
            fullWidth: v,
            hiddenLabel: b,
            ref: t,
            required: I,
            color: c,
            variant: g,
          },
          T
        ),
        k && mh.createElement(Wy, Su({ htmlFor: w, id: f }, x), k),
        F
          ? mh.createElement(
              vw,
              Su(
                {
                  "aria-describedby": A,
                  id: w,
                  labelId: f,
                  value: d,
                  input: S,
                },
                r
              ),
              o
            )
          : S,
        y && mh.createElement(Py, Su({ id: A }, m), y)
      );
    });
  function vx(e) {
    return Math.round(1e5 * e) / 1e5;
  }
  Uh({ root: {} }, { name: "PwzrTextField" })(vp), Q();
  var yx = !1,
    bx = null,
    xp = mh.forwardRef(function (e, t) {
      var n = e.arrow,
        r = void 0 !== n && n,
        i = e.children,
        o = e.classes,
        a = e.disableFocusListener,
        s = void 0 !== a && a,
        l = e.disableHoverListener,
        c = void 0 !== l && l,
        u = e.disableTouchListener,
        d = void 0 !== u && u,
        p = e.enterDelay,
        f = void 0 === p ? 0 : p,
        h = e.enterTouchDelay,
        m = void 0 === h ? 700 : h,
        n = e.id,
        a = e.interactive,
        l = void 0 !== a && a,
        u = e.leaveDelay,
        g = void 0 === u ? 0 : u,
        p = e.leaveTouchDelay,
        v = void 0 === p ? 1500 : p,
        y = e.onClose,
        b = e.onOpen,
        h = e.open,
        a = e.placement,
        u = void 0 === a ? "bottom" : a,
        p = e.PopperProps,
        w = e.title,
        a = e.TransitionComponent,
        x = void 0 === a ? Dy : a,
        E = e.TransitionProps,
        a = xu(e, [
          "arrow",
          "children",
          "classes",
          "disableFocusListener",
          "disableHoverListener",
          "disableTouchListener",
          "enterDelay",
          "enterTouchDelay",
          "id",
          "interactive",
          "leaveDelay",
          "leaveTouchDelay",
          "onClose",
          "onOpen",
          "open",
          "placement",
          "PopperProps",
          "title",
          "TransitionComponent",
          "TransitionProps",
        ]),
        S = qh(),
        e = mh.useState(),
        C = e[0],
        k = e[1],
        e = mh.useState(null),
        T = e[0],
        P = e[1],
        z = mh.useRef(!1),
        O = mh.useRef(),
        R = mh.useRef(),
        M = mh.useRef(),
        N = mh.useRef(),
        e = hv(zv({ controlled: h, default: !1, name: "Tooltip" }), 2),
        h = e[0],
        L = e[1],
        I = h,
        e = mh.useState(),
        _ = e[0],
        D = e[1],
        h = n || _;
      mh.useEffect(
        function () {
          I && !_ && D("mui-tooltip-".concat(Math.round(1e5 * Math.random())));
        },
        [I, _]
      ),
        mh.useEffect(function () {
          return function () {
            clearTimeout(O.current),
              clearTimeout(R.current),
              clearTimeout(M.current),
              clearTimeout(N.current);
          };
        }, []);
      function A(e) {
        clearTimeout(bx), L((yx = !0)), b && b(e);
      }
      function F(e) {
        var t = i.props;
        "mouseover" === e.type &&
          t.onMouseOver &&
          e.currentTarget === C &&
          t.onMouseOver(e),
          (z.current && "touchstart" !== e.type) ||
            (C && C.removeAttribute("title"),
            clearTimeout(R.current),
            clearTimeout(M.current),
            f && !yx
              ? (e.persist(),
                (R.current = setTimeout(function () {
                  A(e);
                }, f)))
              : A(e));
      }
      function B(e) {
        clearTimeout(bx),
          (bx = setTimeout(function () {
            yx = !1;
          }, 500)),
          L(!1),
          y && y(e),
          clearTimeout(O.current),
          (O.current = setTimeout(function () {
            z.current = !1;
          }, S.transitions.duration.shortest));
      }
      var e = Qg(),
        W = e.isFocusVisible,
        $ = e.onBlurVisible,
        n = e.ref,
        e = mh.useState(!1),
        j = e[0],
        H = e[1],
        e = function (e) {
          var t = i.props;
          "blur" === e.type &&
            (t.onBlur && e.currentTarget === C && t.onBlur(e),
            j && (H(!1), $())),
            "mouseleave" === e.type &&
              t.onMouseLeave &&
              e.currentTarget === C &&
              t.onMouseLeave(e),
            clearTimeout(R.current),
            clearTimeout(M.current),
            e.persist(),
            (M.current = setTimeout(function () {
              B(e);
            }, g));
        },
        t = Ig(k, t),
        V = Ig(n, t),
        t = mh.useCallback(
          function (e) {
            Lg(V, zg.findDOMNode(e));
          },
          [V]
        ),
        t = Ig(i.ref, t);
      "" === w && (I = !1);
      a = Su(
        {
          "aria-describedby": I ? h : null,
          title: I || c || "string" != typeof w ? null : w,
        },
        a,
        {},
        i.props,
        { className: Ph(a.className, i.props.className) }
      );
      d ||
        ((a.onTouchStart = function (e) {
          z.current = !0;
          var t = i.props;
          t.onTouchStart && t.onTouchStart(e),
            clearTimeout(M.current),
            clearTimeout(O.current),
            clearTimeout(N.current),
            e.persist(),
            (N.current = setTimeout(function () {
              F(e);
            }, m));
        }),
        (a.onTouchEnd = function (e) {
          i.props.onTouchEnd && i.props.onTouchEnd(e),
            clearTimeout(N.current),
            clearTimeout(M.current),
            e.persist(),
            (M.current = setTimeout(function () {
              B(e);
            }, v));
        })),
        c || ((a.onMouseOver = F), (a.onMouseLeave = e)),
        s ||
          ((a.onFocus = function (e) {
            C || k(e.currentTarget), W(e) && (H(!0), F(e));
            var t = i.props;
            t.onFocus && e.currentTarget === C && t.onFocus(e);
          }),
          (a.onBlur = e));
      (s = l
        ? {
            onMouseOver: a.onMouseOver,
            onMouseLeave: a.onMouseLeave,
            onFocus: a.onFocus,
            onBlur: a.onBlur,
          }
        : {}),
        (e = mh.useMemo(
          function () {
            return {
              modifiers: { arrow: { enabled: Boolean(T), element: T } },
            };
          },
          [T]
        ));
      return mh.createElement(
        mh.Fragment,
        null,
        mh.cloneElement(i, Su({ ref: t }, a)),
        mh.createElement(
          sw,
          Su(
            {
              className: Ph(
                o.popper,
                l && o.popperInteractive,
                r && o.popperArrow
              ),
              placement: u,
              anchorEl: C,
              open: !!C && I,
              id: a["aria-describedby"],
              transition: !0,
              popperOptions: e,
            },
            s,
            p
          ),
          function (e) {
            var t = e.placement,
              e = e.TransitionProps;
            return mh.createElement(
              x,
              Su({ timeout: S.transitions.duration.shorter }, e, E),
              mh.createElement(
                "div",
                {
                  className: Ph(
                    o.tooltip,
                    o["tooltipPlacement".concat(ag(t.split("-")[0]))],
                    z.current && o.touch,
                    r && o.tooltipArrow
                  ),
                },
                w,
                r
                  ? mh.createElement("span", { className: o.arrow, ref: P })
                  : null
              )
            );
          }
        )
      );
    });
  Uh(
    function (e) {
      return {
        popper: { zIndex: e.zIndex.tooltip, pointerEvents: "none", flip: !1 },
        popperInteractive: { pointerEvents: "auto" },
        popperArrow: {
          '&[x-placement*="bottom"] $arrow': {
            flip: !1,
            top: 0,
            left: 0,
            marginTop: "-0.95em",
            marginLeft: 4,
            marginRight: 4,
            width: "2em",
            height: "1em",
            "&::before": {
              flip: !1,
              borderWidth: "0 1em 1em 1em",
              borderColor: "transparent transparent currentcolor transparent",
            },
          },
          '&[x-placement*="top"] $arrow': {
            flip: !1,
            bottom: 0,
            left: 0,
            marginBottom: "-0.95em",
            marginLeft: 4,
            marginRight: 4,
            width: "2em",
            height: "1em",
            "&::before": {
              flip: !1,
              borderWidth: "1em 1em 0 1em",
              borderColor: "currentcolor transparent transparent transparent",
            },
          },
          '&[x-placement*="right"] $arrow': {
            flip: !1,
            left: 0,
            marginLeft: "-0.95em",
            marginTop: 4,
            marginBottom: 4,
            height: "2em",
            width: "1em",
            "&::before": {
              flip: !1,
              borderWidth: "1em 1em 1em 0",
              borderColor: "transparent currentcolor transparent transparent",
            },
          },
          '&[x-placement*="left"] $arrow': {
            flip: !1,
            right: 0,
            marginRight: "-0.95em",
            marginTop: 4,
            marginBottom: 4,
            height: "2em",
            width: "1em",
            "&::before": {
              flip: !1,
              borderWidth: "1em 0 1em 1em",
              borderColor: "transparent transparent transparent currentcolor",
            },
          },
        },
        tooltip: {
          backgroundColor: gu(e.palette.grey[700], 0.9),
          borderRadius: e.shape.borderRadius,
          color: e.palette.common.white,
          fontFamily: e.typography.fontFamily,
          padding: "4px 8px",
          fontSize: e.typography.pxToRem(10),
          lineHeight: "".concat(vx(1.4), "em"),
          maxWidth: 300,
          wordWrap: "break-word",
          fontWeight: e.typography.fontWeightMedium,
        },
        tooltipArrow: { position: "relative", margin: "0" },
        arrow: {
          position: "absolute",
          fontSize: 6,
          color: gu(e.palette.grey[700], 0.9),
          "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: 0,
            height: 0,
            borderStyle: "solid",
          },
        },
        touch: {
          padding: "8px 16px",
          fontSize: e.typography.pxToRem(14),
          lineHeight: "".concat(vx(16 / 14), "em"),
          fontWeight: e.typography.fontWeightRegular,
        },
        tooltipPlacementLeft: bu(
          { transformOrigin: "right center", margin: "0 24px " },
          e.breakpoints.up("sm"),
          { margin: "0 14px" }
        ),
        tooltipPlacementRight: bu(
          { transformOrigin: "left center", margin: "0 24px" },
          e.breakpoints.up("sm"),
          { margin: "0 14px" }
        ),
        tooltipPlacementTop: bu(
          { transformOrigin: "center bottom", margin: "24px 0" },
          e.breakpoints.up("sm"),
          { margin: "14px 0" }
        ),
        tooltipPlacementBottom: bu(
          { transformOrigin: "center top", margin: "24px 0" },
          e.breakpoints.up("sm"),
          { margin: "14px 0" }
        ),
      };
    },
    { name: "PwzrTooltip" }
  )(xp),
    Q(),
    Q(),
    Q();
  var wx,
    xx,
    Ex,
    Sx,
    Cx,
    kx,
    Tx,
    Px,
    zx,
    Ox,
    Rx = { entering: { transform: "none" }, entered: { transform: "none" } },
    Mx = { enter: Nd.enteringScreen, exit: Nd.leavingScreen },
    Nx =
      (mh.forwardRef(function (e, t) {
        var n = e.children,
          r = e.in,
          i = e.onEnter,
          o = e.onExit,
          a = e.style,
          s = e.timeout,
          l = void 0 === s ? Mx : s,
          e = xu(e, [
            "children",
            "in",
            "onEnter",
            "onExit",
            "style",
            "timeout",
          ]),
          c = qh(),
          u = Ig(n.ref, t);
        return mh.createElement(
          Og,
          Su(
            {
              appear: !0,
              in: r,
              onEnter: function (e, t) {
                Mg(e);
                var n = Ng({ style: a, timeout: l }, { mode: "enter" });
                (e.style.webkitTransition = c.transitions.create(
                  "transform",
                  n
                )),
                  (e.style.transition = c.transitions.create("transform", n)),
                  i && i(e, t);
              },
              onExit: function (e) {
                var t = Ng({ style: a, timeout: l }, { mode: "exit" });
                (e.style.webkitTransition = c.transitions.create(
                  "transform",
                  t
                )),
                  (e.style.transition = c.transitions.create("transform", t)),
                  o && o(e);
              },
              timeout: l,
            },
            e
          ),
          function (e, t) {
            return mh.cloneElement(
              n,
              Su(
                {
                  style: Su(
                    {
                      transform: "scale(0)",
                      visibility: "exited" !== e || r ? void 0 : "hidden",
                    },
                    Rx[e],
                    {},
                    a,
                    {},
                    n.props.style
                  ),
                  ref: u,
                },
                t
              )
            );
          }
        );
      }),
      !1);
  function Lx() {
    Nx ||
      ((Nx = !0),
      (wx =
        (29945008).toString(36).toLowerCase() +
        (10)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -39);
          })
          .join("") +
        (1147)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -71);
          })
          .join("") +
        (73112640253685).toString(36).toLowerCase() +
        (30)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -71);
          })
          .join("") +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 10 - t);
            })
            .join("");
        })(
          50,
          178,
          175,
          187,
          182,
          156,
          181,
          174,
          182,
          114,
          171,
          177,
          161,
          110,
          171,
          172,
          159
        ) +
        (40924532533).toString(36).toLowerCase() +
        (15)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -39);
          })
          .join("") +
        (1025).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 37 - t);
            })
            .join("");
        })(44, 144, 194, 192)),
      (xx =
        (1517381).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 53 - t);
            })
            .join("");
        })(58, 178) +
        (46020191).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 62 - t);
            })
            .join("");
        })(35, 203, 213) +
        (381).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 7 - t);
            })
            .join("");
        })(53, 175)),
      (Ex =
        (986).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 12 - t);
            })
            .join("");
        })(54, 179, 181) +
        (1150574).toString(36).toLowerCase() +
        (10)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -13);
          })
          .join("") +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 9 - t);
            })
            .join("");
        })(23, 135, 145, 153)),
      (Sx =
        (1058).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 15 - t);
            })
            .join("");
        })(32, 164, 167)),
      (Cx =
        (34).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 56 - t);
            })
            .join("");
        })(41, 198) +
        (28).toString(36).toLowerCase()),
      (kx =
        (33587).toString(36).toLowerCase() +
        (29)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -71);
          })
          .join("") +
        (1103).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 56 - t);
            })
            .join("");
        })(35, 205) +
        (40790289862453).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 23 - t);
            })
            .join("");
        })(52, 120) +
        (1003952).toString(36).toLowerCase()),
      (Tx =
        (33587).toString(36).toLowerCase() +
        (29)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -71);
          })
          .join("") +
        (2402647788845).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 5 - t);
            })
            .join("");
        })(9, 129, 115) +
        (517).toString(36).toLowerCase() +
        (29)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -71);
          })
          .join("") +
        (1003952).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 61 - t);
            })
            .join("");
        })(53, 219, 172) +
        (1160451).toString(36).toLowerCase()),
      (Px =
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 9 - t);
            })
            .join("");
        })(39, 156, 102, 101, 111, 167, 163, 166, 165, 152) +
        (31564).toString(36).toLowerCase() +
        (30)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -71);
          })
          .join("") +
        (43281714).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 16 - t);
            })
            .join("");
        })(16, 83, 158, 140, 153, 149, 131) +
        (672).toString(36).toLowerCase() +
        (31)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -71);
          })
          .join("") +
        (51497080).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 31 - t);
            })
            .join("");
        })(16, 165, 163, 152) +
        (688693).toString(36).toLowerCase() +
        (29)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -71);
          })
          .join("") +
        (10).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 28 - t);
            })
            .join("");
        })(9, 149) +
        (25).toString(36).toLowerCase()),
      (zx =
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 29 - t);
            })
            .join("");
        })(49, 189, 189, 201, 187, 201, 199, 188, 185, 182, 194, 189, 163) +
        (16)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -71);
          })
          .join("") +
        (32)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -39);
          })
          .join("") +
        (1673543405).toString(36).toLowerCase() +
        (13)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -13);
          })
          .join("") +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 38 - t);
            })
            .join("");
        })(60, 203) +
        (35).toString(36).toLowerCase() +
        (16)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -71);
          })
          .join("") +
        (17)
          .toString(36)
          .toLowerCase()
          .split("")
          .map(function (e) {
            return String.fromCharCode(e.charCodeAt() + -39);
          })
          .join("") +
        (25).toString(36).toLowerCase() +
        (function () {
          var e = Array.prototype.slice.call(arguments),
            n = e.shift();
          return e
            .reverse()
            .map(function (e, t) {
              return String.fromCharCode(e - n - 60 - t);
            })
            .join("");
        })(34, 206)),
      (Ox = { b: wx, c: xx, d: Ex, e: Sx, f: Cx, g: kx, h: Tx, i: Px, j: zx }));
  }
  Q();
  var Ix = new Error("Element already at target scroll position"),
    _x = new Error("Scroll cancelled"),
    Dx = Math.min,
    Ax = Date.now,
    Fx = { left: Bx("scrollLeft"), top: Bx("scrollTop") };
  function Bx(p) {
    return function (i, o, e, a) {
      "function" == typeof (e = e || {}) && ((a = e), (e = {})),
        "function" != typeof a && (a = $x);
      var s = Ax(),
        l = i[p],
        c = e.ease || Wx,
        u = isNaN(e.duration) ? 350 : +e.duration,
        d = !1;
      return (
        l === o
          ? a(Ix, i[p])
          : requestAnimationFrame(function e(t) {
              if (d) return a(_x, i[p]);
              var n = Ax(),
                r = Dx(1, (n - s) / u),
                n = c(r);
              (i[p] = n * (o - l) + l),
                r < 1
                  ? requestAnimationFrame(e)
                  : requestAnimationFrame(function () {
                      a(null, i[p]);
                    });
            }),
        function () {
          d = !0;
        }
      );
    };
  }
  function Wx(e) {
    return 0.5 * (1 - Math.cos(Math.PI * e));
  }
  function $x() {}
  var jx,
    Hx,
    Vx,
    qx = function (n, r) {
      return function () {
        for (var e = new Array(arguments.length), t = 0; t < e.length; t++)
          e[t] = arguments[t];
        return n.apply(r, e);
      };
    },
    Ux = !1;
  function Gx(e) {
    return "[object Array]" === Hx.call(e);
  }
  function Yx(e) {
    return void 0 === e;
  }
  function Xx(e) {
    return (
      null !== e &&
      !Yx(e) &&
      null !== e.constructor &&
      !Yx(e.constructor) &&
      "function" == typeof e.constructor.isBuffer &&
      e.constructor.isBuffer(e)
    );
  }
  function Kx(e) {
    return "[object ArrayBuffer]" === Hx.call(e);
  }
  function Zx(e) {
    return "undefined" != typeof FormData && e instanceof FormData;
  }
  function Qx(e) {
    return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView
      ? ArrayBuffer.isView(e)
      : e && e.buffer && e.buffer instanceof ArrayBuffer;
  }
  function Jx(e) {
    return "string" == typeof e;
  }
  function eE(e) {
    return "number" == typeof e;
  }
  function tE(e) {
    return null !== e && "object" == typeof e;
  }
  function nE(e) {
    if ("[object Object]" !== Hx.call(e)) return !1;
    e = Object.getPrototypeOf(e);
    return null === e || e === Object.prototype;
  }
  function rE(e) {
    return "[object Date]" === Hx.call(e);
  }
  function iE(e) {
    return "[object File]" === Hx.call(e);
  }
  function oE(e) {
    return "[object Blob]" === Hx.call(e);
  }
  function aE(e) {
    return "[object Function]" === Hx.call(e);
  }
  function sE(e) {
    return tE(e) && aE(e.pipe);
  }
  function lE(e) {
    return (
      "undefined" != typeof URLSearchParams && e instanceof URLSearchParams
    );
  }
  function cE(e) {
    return e.replace(/^\s*/, "").replace(/\s*$/, "");
  }
  function uE() {
    return (
      ("undefined" == typeof navigator ||
        ("ReactNative" !== navigator.product &&
          "NativeScript" !== navigator.product &&
          "NS" !== navigator.product)) &&
      "undefined" != typeof window &&
      "undefined" != typeof document
    );
  }
  function dE(e, t) {
    if (null != e)
      if (("object" != typeof e && (e = [e]), Gx(e)))
        for (var n = 0, r = e.length; n < r; n++) t.call(null, e[n], n, e);
      else
        for (var i in e)
          Object.prototype.hasOwnProperty.call(e, i) &&
            t.call(null, e[i], i, e);
  }
  function pE() {
    var n = {};
    function e(e, t) {
      nE(n[t]) && nE(e)
        ? (n[t] = pE(n[t], e))
        : nE(e)
        ? (n[t] = pE({}, e))
        : Gx(e)
        ? (n[t] = e.slice())
        : (n[t] = e);
    }
    for (var t = 0, r = arguments.length; t < r; t++) dE(arguments[t], e);
    return n;
  }
  function fE(n, e, r) {
    return (
      dE(e, function (e, t) {
        n[t] = r && "function" == typeof e ? jx(e, r) : e;
      }),
      n
    );
  }
  function hE(e) {
    return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e;
  }
  function mE() {
    Ux ||
      ((Ux = !0),
      (jx = qx),
      (Hx = Object.prototype.toString),
      (Vx = {
        isArray: Gx,
        isArrayBuffer: Kx,
        isBuffer: Xx,
        isFormData: Zx,
        isArrayBufferView: Qx,
        isString: Jx,
        isNumber: eE,
        isObject: tE,
        isPlainObject: nE,
        isUndefined: Yx,
        isDate: rE,
        isFile: iE,
        isBlob: oE,
        isFunction: aE,
        isStream: sE,
        isURLSearchParams: lE,
        isStandardBrowserEnv: uE,
        forEach: dE,
        merge: pE,
        extend: fE,
        trim: cE,
        stripBOM: hE,
      }));
  }
  var gE,
    vE,
    yE = !1;
  function bE(e) {
    return encodeURIComponent(e)
      .replace(/%3A/gi, ":")
      .replace(/%24/g, "$")
      .replace(/%2C/gi, ",")
      .replace(/%20/g, "+")
      .replace(/%5B/gi, "[")
      .replace(/%5D/gi, "]");
  }
  function wE() {
    yE ||
      ((yE = !0),
      mE(),
      (gE = Vx),
      (vE = function (e, t, n) {
        if (!t) return e;
        var r,
          n = n
            ? n(t)
            : gE.isURLSearchParams(t)
            ? t.toString()
            : ((r = []),
              gE.forEach(t, function (e, t) {
                null != e &&
                  (gE.isArray(e) ? (t += "[]") : (e = [e]),
                  gE.forEach(e, function (e) {
                    gE.isDate(e)
                      ? (e = e.toISOString())
                      : gE.isObject(e) && (e = JSON.stringify(e)),
                      r.push(bE(t) + "=" + bE(e));
                  }));
              }),
              r.join("&"));
        return (
          n &&
            (-1 !== (t = e.indexOf("#")) && (e = e.slice(0, t)),
            (e += (-1 === e.indexOf("?") ? "?" : "&") + n)),
          e
        );
      }));
  }
  var xE = (mE(), Vx);
  function EE() {
    this.handlers = [];
  }
  function SE(t, n, e) {
    return (
      RE.forEach(e, function (e) {
        t = e(t, n);
      }),
      t
    );
  }
  function CE(e) {
    return !(!e || !e.__CANCEL__);
  }
  function kE(n, r) {
    ME.forEach(n, function (e, t) {
      t !== r &&
        t.toUpperCase() === r.toUpperCase() &&
        ((n[r] = e), delete n[t]);
    });
  }
  (EE.prototype.use = function (e, t) {
    return (
      this.handlers.push({ fulfilled: e, rejected: t }),
      this.handlers.length - 1
    );
  }),
    (EE.prototype.eject = function (e) {
      this.handlers[e] && (this.handlers[e] = null);
    }),
    (EE.prototype.forEach = function (t) {
      xE.forEach(this.handlers, function (e) {
        null !== e && t(e);
      });
    });
  var TE,
    PE,
    zE,
    OE = EE,
    RE = (mE(), Vx),
    ME = (mE(), Vx),
    NE = !1,
    LE = !1;
  function IE() {
    LE ||
      ((LE = !0),
      NE ||
        ((NE = !0),
        (TE = function (e, t, n, r, i) {
          return (
            (e.config = t),
            n && (e.code = n),
            (e.request = r),
            (e.response = i),
            (e.isAxiosError = !0),
            (e.toJSON = function () {
              return {
                message: this.message,
                name: this.name,
                description: this.description,
                number: this.number,
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                config: this.config,
                code: this.code,
              };
            }),
            e
          );
        })),
      (PE = TE),
      (zE = function (e, t, n, r, i) {
        e = new Error(e);
        return PE(e, t, n, r, i);
      }));
  }
  var _E,
    DE,
    AE,
    FE,
    BE,
    WE,
    $E,
    jE,
    HE,
    VE,
    qE,
    UE,
    GE,
    YE,
    XE,
    KE,
    ZE,
    QE,
    JE,
    eS,
    tS,
    nS,
    rS = !1,
    iS = !1,
    oS = !1,
    aS = !1,
    sS = !1,
    lS = !1,
    cS = !1,
    uS = !1;
  function dS() {
    function t(e) {
      return (
        r && (i.setAttribute("href", e), (e = i.href)),
        i.setAttribute("href", e),
        {
          href: i.href,
          protocol: i.protocol ? i.protocol.replace(/:$/, "") : "",
          host: i.host,
          search: i.search ? i.search.replace(/^\?/, "") : "",
          hash: i.hash ? i.hash.replace(/^#/, "") : "",
          hostname: i.hostname,
          port: i.port,
          pathname:
            "/" === i.pathname.charAt(0) ? i.pathname : "/" + i.pathname,
        }
      );
    }
    var n, r, i;
    uS ||
      ((uS = !0),
      mE(),
      (YE = Vx),
      rS ||
        ((rS = !0),
        IE(),
        (_E = zE),
        (DE = function (e, t, n) {
          var r = n.config.validateStatus;
          n.status && r && !r(n.status)
            ? t(
                _E(
                  "Request failed with status code " + n.status,
                  n.config,
                  null,
                  n.request,
                  n
                )
              )
            : e(n);
        })),
      (XE = DE),
      iS ||
        ((iS = !0),
        mE(),
        (FE = (AE = Vx).isStandardBrowserEnv()
          ? {
              write: function (e, t, n, r, i, o) {
                var a = [];
                a.push(e + "=" + encodeURIComponent(t)),
                  AE.isNumber(n) &&
                    a.push("expires=" + new Date(n).toGMTString()),
                  AE.isString(r) && a.push("path=" + r),
                  AE.isString(i) && a.push("domain=" + i),
                  !0 === o && a.push("secure"),
                  (document.cookie = a.join("; "));
              },
              read: function (e) {
                e = document.cookie.match(
                  new RegExp("(^|;\\s*)(" + e + ")=([^;]*)")
                );
                return e ? decodeURIComponent(e[3]) : null;
              },
              remove: function (e) {
                this.write(e, "", Date.now() - 864e5);
              },
            }
          : {
              write: function () {},
              read: function () {
                return null;
              },
              remove: function () {},
            })),
      (KE = FE),
      wE(),
      (ZE = vE),
      sS ||
        ((sS = !0),
        oS ||
          ((oS = !0),
          (BE = function (e) {
            return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
          })),
        (WE = BE),
        aS ||
          ((aS = !0),
          (jE = function (e, t) {
            return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
          })),
        ($E = jE),
        (jE = function (e, t) {
          return e && !WE(t) ? $E(e, t) : t;
        })),
      (QE = jE),
      lS ||
        ((lS = !0),
        mE(),
        (HE = Vx),
        (VE = [
          "age",
          "authorization",
          "content-length",
          "content-type",
          "etag",
          "expires",
          "from",
          "host",
          "if-modified-since",
          "if-unmodified-since",
          "last-modified",
          "location",
          "max-forwards",
          "proxy-authorization",
          "referer",
          "retry-after",
          "user-agent",
        ]),
        (qE = function (e) {
          var t,
            n,
            r = {};
          return (
            e &&
              HE.forEach(e.split("\n"), function (e) {
                (n = e.indexOf(":")),
                  (t = HE.trim(e.substr(0, n)).toLowerCase()),
                  (n = HE.trim(e.substr(n + 1))),
                  t &&
                    ((r[t] && 0 <= VE.indexOf(t)) ||
                      (r[t] =
                        "set-cookie" === t
                          ? (r[t] || []).concat([n])
                          : r[t]
                          ? r[t] + ", " + n
                          : n));
              }),
            r
          );
        })),
      (JE = qE),
      cS ||
        ((cS = !0),
        mE(),
        (GE = (UE = Vx).isStandardBrowserEnv()
          ? ((r = /(msie|trident)/i.test(navigator.userAgent)),
            (i = document.createElement("a")),
            (n = t(window.location.href)),
            function (e) {
              e = UE.isString(e) ? t(e) : e;
              return e.protocol === n.protocol && e.host === n.host;
            })
          : function () {
              return !0;
            })),
      (eS = GE),
      IE(),
      (tS = zE),
      (nS = function (l) {
        return new Promise(function (t, n) {
          var r = l.data,
            i = l.headers;
          YE.isFormData(r) && delete i["Content-Type"],
            (YE.isBlob(r) || YE.isFile(r)) &&
              r.type &&
              delete i["Content-Type"];
          var e,
            o = new XMLHttpRequest();
          l.auth &&
            ((e = l.auth.username || ""),
            (s = unescape(encodeURIComponent(l.auth.password)) || ""),
            (i.Authorization = "Basic " + btoa(e + ":" + s)));
          var a,
            s = QE(l.baseURL, l.url);
          if (
            (o.open(
              l.method.toUpperCase(),
              ZE(s, l.params, l.paramsSerializer),
              !0
            ),
            (o.timeout = l.timeout),
            (o.onreadystatechange = function () {
              var e;
              o &&
                4 === o.readyState &&
                (0 !== o.status ||
                  (o.responseURL && 0 === o.responseURL.indexOf("file:"))) &&
                ((e =
                  "getAllResponseHeaders" in o
                    ? JE(o.getAllResponseHeaders())
                    : null),
                (e = {
                  data:
                    l.responseType && "text" !== l.responseType
                      ? o.response
                      : o.responseText,
                  status: o.status,
                  statusText: o.statusText,
                  headers: e,
                  config: l,
                  request: o,
                }),
                XE(t, n, e),
                (o = null));
            }),
            (o.onabort = function () {
              o && (n(tS("Request aborted", l, "ECONNABORTED", o)), (o = null));
            }),
            (o.onerror = function () {
              n(tS("Network Error", l, null, o)), (o = null);
            }),
            (o.ontimeout = function () {
              var e = "timeout of " + l.timeout + "ms exceeded";
              l.timeoutErrorMessage && (e = l.timeoutErrorMessage),
                n(tS(e, l, "ECONNABORTED", o)),
                (o = null);
            }),
            YE.isStandardBrowserEnv() &&
              (a =
                (l.withCredentials || eS(s)) && l.xsrfCookieName
                  ? KE.read(l.xsrfCookieName)
                  : void 0) &&
              (i[l.xsrfHeaderName] = a),
            "setRequestHeader" in o &&
              YE.forEach(i, function (e, t) {
                void 0 === r && "content-type" === t.toLowerCase()
                  ? delete i[t]
                  : o.setRequestHeader(t, e);
              }),
            YE.isUndefined(l.withCredentials) ||
              (o.withCredentials = !!l.withCredentials),
            l.responseType)
          )
            try {
              o.responseType = l.responseType;
            } catch (t) {
              if ("json" !== l.responseType) throw t;
            }
          "function" == typeof l.onDownloadProgress &&
            o.addEventListener("progress", l.onDownloadProgress),
            "function" == typeof l.onUploadProgress &&
              o.upload &&
              o.upload.addEventListener("progress", l.onUploadProgress),
            l.cancelToken &&
              l.cancelToken.promise.then(function (e) {
                o && (o.abort(), n(e), (o = null));
              }),
            (r = r || null),
            o.send(r);
        });
      }));
  }
  var pS,
    fS,
    hS,
    _f = (pS = {});
  function mS() {
    throw new Error("setTimeout has not been defined");
  }
  function gS() {
    throw new Error("clearTimeout has not been defined");
  }
  function vS(t) {
    if (fS === setTimeout) return setTimeout(t, 0);
    if ((fS === mS || !fS) && setTimeout)
      return (fS = setTimeout), setTimeout(t, 0);
    try {
      return fS(t, 0);
    } catch (e) {
      try {
        return fS.call(null, t, 0);
      } catch (e) {
        return fS.call(this, t, 0);
      }
    }
  }
  !(function () {
    try {
      fS = "function" == typeof setTimeout ? setTimeout : mS;
    } catch (e) {
      fS = mS;
    }
    try {
      hS = "function" == typeof clearTimeout ? clearTimeout : gS;
    } catch (e) {
      hS = gS;
    }
  })();
  var yS,
    bS = [],
    wS = !1,
    xS = -1;
  function ES() {
    wS &&
      yS &&
      ((wS = !1),
      yS.length ? (bS = yS.concat(bS)) : (xS = -1),
      bS.length && SS());
  }
  function SS() {
    if (!wS) {
      var e = vS(ES);
      wS = !0;
      for (var t = bS.length; t; ) {
        for (yS = bS, bS = []; ++xS < t; ) yS && yS[xS].run();
        (xS = -1), (t = bS.length);
      }
      (yS = null),
        (wS = !1),
        (function (t) {
          if (hS === clearTimeout) return clearTimeout(t);
          if ((hS === gS || !hS) && clearTimeout)
            return (hS = clearTimeout), clearTimeout(t);
          try {
            hS(t);
          } catch (e) {
            try {
              return hS.call(null, t);
            } catch (e) {
              return hS.call(this, t);
            }
          }
        })(e);
    }
  }
  function CS(e, t) {
    (this.fun = e), (this.array = t);
  }
  function kS() {}
  (_f.nextTick = function (e) {
    var t = new Array(arguments.length - 1);
    if (1 < arguments.length)
      for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
    bS.push(new CS(e, t)), 1 !== bS.length || wS || vS(SS);
  }),
    (CS.prototype.run = function () {
      this.fun.apply(null, this.array);
    }),
    (_f.title = "browser"),
    (_f.browser = !0),
    (_f.env = {}),
    (_f.argv = []),
    (_f.version = ""),
    (_f.versions = {}),
    (_f.on = kS),
    (_f.addListener = kS),
    (_f.once = kS),
    (_f.off = kS),
    (_f.removeListener = kS),
    (_f.removeAllListeners = kS),
    (_f.emit = kS),
    (_f.prependListener = kS),
    (_f.prependOnceListener = kS),
    (_f.listeners = function (e) {
      return [];
    }),
    (_f.binding = function (e) {
      throw new Error("process.binding is not supported");
    }),
    (_f.cwd = function () {
      return "/";
    }),
    (_f.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }),
    (_f.umask = function () {
      return 0;
    });
  var TS = (mE(), Vx),
    PS = { "Content-Type": "application/x-www-form-urlencoded" };
  function zS(e, t) {
    !TS.isUndefined(e) &&
      TS.isUndefined(e["Content-Type"]) &&
      (e["Content-Type"] = t);
  }
  var OS = {
    adapter:
      (("undefined" == typeof XMLHttpRequest &&
        "[object process]" !== Object.prototype.toString.call(pS)) ||
        (dS(), (wC = nS)),
      wC),
    transformRequest: [
      function (e, t) {
        return (
          kE(t, "Accept"),
          kE(t, "Content-Type"),
          TS.isFormData(e) ||
          TS.isArrayBuffer(e) ||
          TS.isBuffer(e) ||
          TS.isStream(e) ||
          TS.isFile(e) ||
          TS.isBlob(e)
            ? e
            : TS.isArrayBufferView(e)
            ? e.buffer
            : TS.isURLSearchParams(e)
            ? (zS(t, "application/x-www-form-urlencoded;charset=utf-8"),
              e.toString())
            : TS.isObject(e)
            ? (zS(t, "application/json;charset=utf-8"), JSON.stringify(e))
            : e
        );
      },
    ],
    transformResponse: [
      function (e) {
        if ("string" == typeof e)
          try {
            e = JSON.parse(e);
          } catch (e) {}
        return e;
      },
    ],
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function (e) {
      return 200 <= e && e < 300;
    },
    headers: { common: { Accept: "application/json, text/plain, */*" } },
  };
  TS.forEach(["delete", "get", "head"], function (e) {
    OS.headers[e] = {};
  }),
    TS.forEach(["post", "put", "patch"], function (e) {
      OS.headers[e] = TS.merge(PS);
    });
  var RS = OS,
    MS = (mE(), Vx);
  function NS(e) {
    e.cancelToken && e.cancelToken.throwIfRequested();
  }
  function LS(t) {
    return (
      NS(t),
      (t.headers = t.headers || {}),
      (t.data = SE(t.data, t.headers, t.transformRequest)),
      (t.headers = MS.merge(
        t.headers.common || {},
        t.headers[t.method] || {},
        t.headers
      )),
      MS.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function (e) {
          delete t.headers[e];
        }
      ),
      (t.adapter || RS.adapter)(t).then(
        function (e) {
          return (
            NS(t), (e.data = SE(e.data, e.headers, t.transformResponse)), e
          );
        },
        function (e) {
          return (
            CE(e) ||
              (NS(t),
              e &&
                e.response &&
                (e.response.data = SE(
                  e.response.data,
                  e.response.headers,
                  t.transformResponse
                ))),
            Promise.reject(e)
          );
        }
      )
    );
  }
  function IS(t, n) {
    n = n || {};
    var r = {},
      e = ["url", "method", "data"],
      i = ["headers", "auth", "proxy", "params"],
      o = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding",
      ],
      a = ["validateStatus"];
    function s(e, t) {
      return _S.isPlainObject(e) && _S.isPlainObject(t)
        ? _S.merge(e, t)
        : _S.isPlainObject(t)
        ? _S.merge({}, t)
        : _S.isArray(t)
        ? t.slice()
        : t;
    }
    function l(e) {
      _S.isUndefined(n[e])
        ? _S.isUndefined(t[e]) || (r[e] = s(void 0, t[e]))
        : (r[e] = s(t[e], n[e]));
    }
    _S.forEach(e, function (e) {
      _S.isUndefined(n[e]) || (r[e] = s(void 0, n[e]));
    }),
      _S.forEach(i, l),
      _S.forEach(o, function (e) {
        _S.isUndefined(n[e])
          ? _S.isUndefined(t[e]) || (r[e] = s(void 0, t[e]))
          : (r[e] = s(void 0, n[e]));
      }),
      _S.forEach(a, function (e) {
        e in n ? (r[e] = s(t[e], n[e])) : e in t && (r[e] = s(void 0, t[e]));
      });
    var c = e.concat(i).concat(o).concat(a),
      a = Object.keys(t)
        .concat(Object.keys(n))
        .filter(function (e) {
          return -1 === c.indexOf(e);
        });
    return _S.forEach(a, l), r;
  }
  var _S = (mE(), Vx),
    If = (mE(), Vx),
    DS = (wE(), vE);
  function AS(e) {
    (this.defaults = e),
      (this.interceptors = { request: new OE(), response: new OE() });
  }
  (AS.prototype.request = function (e) {
    "string" == typeof e
      ? ((e = arguments[1] || {}).url = arguments[0])
      : (e = e || {}),
      (e = IS(this.defaults, e)).method
        ? (e.method = e.method.toLowerCase())
        : this.defaults.method
        ? (e.method = this.defaults.method.toLowerCase())
        : (e.method = "get");
    var t = [LS, void 0],
      n = Promise.resolve(e);
    for (
      this.interceptors.request.forEach(function (e) {
        t.unshift(e.fulfilled, e.rejected);
      }),
        this.interceptors.response.forEach(function (e) {
          t.push(e.fulfilled, e.rejected);
        });
      t.length;

    )
      n = n.then(t.shift(), t.shift());
    return n;
  }),
    (AS.prototype.getUri = function (e) {
      return (
        (e = IS(this.defaults, e)),
        DS(e.url, e.params, e.paramsSerializer).replace(/^\?/, "")
      );
    }),
    If.forEach(["delete", "get", "head", "options"], function (n) {
      AS.prototype[n] = function (e, t) {
        return this.request(IS(t || {}, { method: n, url: e }));
      };
    }),
    If.forEach(["post", "put", "patch"], function (r) {
      AS.prototype[r] = function (e, t, n) {
        return this.request(IS(n || {}, { method: r, url: e, data: t }));
      };
    });
  var FS = AS,
    BS = (mE(), Vx);
  function WS(e) {
    var t = new FS(e),
      e = qx(FS.prototype.request, t);
    return BS.extend(e, FS.prototype, t), BS.extend(e, t), e;
  }
  var $S = WS(RS);
  function jS(e) {
    this.message = e;
  }
  ($S.Axios = FS),
    ($S.create = function (e) {
      return WS(IS($S.defaults, e));
    }),
    (jS.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }),
    (jS.prototype.__CANCEL__ = !0);
  var HS = jS;
  function VS(e) {
    if ("function" != typeof e)
      throw new TypeError("executor must be a function.");
    var t;
    this.promise = new Promise(function (e) {
      t = e;
    });
    var n = this;
    e(function (e) {
      n.reason || ((n.reason = new HS(e)), t(n.reason));
    });
  }
  ($S.Cancel = HS),
    (VS.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }),
    (VS.source = function () {
      var t;
      return {
        token: new VS(function (e) {
          t = e;
        }),
        cancel: t,
      };
    }),
    ($S.CancelToken = VS),
    ($S.isCancel = CE),
    ($S.all = function (e) {
      return Promise.all(e);
    }),
    ($S.spread = function (t) {
      return function (e) {
        return t.apply(null, e);
      };
    });
  var qS = $S;
  qS.default = $S;
  var US,
    GS,
    YS = {},
    XS =
      ("undefined" != typeof crypto &&
        crypto.getRandomValues &&
        crypto.getRandomValues.bind(crypto)) ||
      ("undefined" != typeof msCrypto &&
        "function" == typeof window.msCrypto.getRandomValues &&
        msCrypto.getRandomValues.bind(msCrypto));
  YS = XS
    ? ((US = new Uint8Array(16)),
      function () {
        return XS(US), US;
      })
    : ((GS = new Array(16)),
      function () {
        for (var e, t = 0; t < 16; t++)
          0 == (3 & t) && (e = 4294967296 * Math.random()),
            (GS[t] = (e >>> ((3 & t) << 3)) & 255);
        return GS;
      });
  for (var KS = [], ZS = 0; ZS < 256; ++ZS)
    KS[ZS] = (ZS + 256).toString(16).substr(1);
  function QS(e, t, n) {
    var r = (t && n) || 0;
    "string" == typeof e &&
      ((t = "binary" === e ? new Array(16) : null), (e = null));
    var i = (e = e || {}).random || (e.rng || YS)();
    if (((i[6] = (15 & i[6]) | 64), (i[8] = (63 & i[8]) | 128), t))
      for (var o = 0; o < 16; ++o) t[r + o] = i[o];
    return (
      t ||
      (function (e, t) {
        t = t || 0;
        return [
          KS[e[t++]],
          KS[e[t++]],
          KS[e[t++]],
          KS[e[t++]],
          "-",
          KS[e[t++]],
          KS[e[t++]],
          "-",
          KS[e[t++]],
          KS[e[t++]],
          "-",
          KS[e[t++]],
          KS[e[t++]],
          "-",
          KS[e[t++]],
          KS[e[t++]],
          KS[e[t++]],
          KS[e[t++]],
          KS[e[t++]],
          KS[e[t++]],
        ].join("");
      })(i)
    );
  }
  function JS(e) {
    if (void 0 === e)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return e;
  }
  var eC = {};
  function tC(e) {
    return (
      (eC = tC = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }),
      tC(e)
    );
  }
  function nC(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  eC = tC;
  var rC = {};
  function iC(e, t) {
    return (
      (rC = iC =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        }),
      iC(e, t)
    );
  }
  function oC(e) {
    return (oC =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              "function" == typeof Symbol &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          })(e);
  }
  function aC(e) {
    return (aC =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              "function" == typeof Symbol &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          })(e);
  }
  function sC(e) {
    return (sC =
      "function" == typeof Symbol && "symbol" === aC(Symbol.iterator)
        ? function (e) {
            return aC(e);
          }
        : function (e) {
            return e &&
              "function" == typeof Symbol &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : aC(e);
          })(e);
  }
  (rC = iC),
    Q(),
    (vp = function () {
      var d =
          "undefined" == typeof document
            ? {
                body: {},
                addEventListener: function () {},
                removeEventListener: function () {},
                activeElement: { blur: function () {}, nodeName: "" },
                querySelector: function () {
                  return null;
                },
                querySelectorAll: function () {
                  return [];
                },
                getElementById: function () {
                  return null;
                },
                createEvent: function () {
                  return { initEvent: function () {} };
                },
                createElement: function () {
                  return {
                    children: [],
                    childNodes: [],
                    style: {},
                    setAttribute: function () {},
                    getElementsByTagName: function () {
                      return [];
                    },
                  };
                },
                location: { hash: "" },
              }
            : document,
        G =
          "undefined" == typeof window
            ? {
                document: d,
                navigator: { userAgent: "" },
                location: {},
                history: {},
                CustomEvent: function () {
                  return this;
                },
                addEventListener: function () {},
                removeEventListener: function () {},
                getComputedStyle: function () {
                  return {
                    getPropertyValue: function () {
                      return "";
                    },
                  };
                },
                Image: function () {},
                Date: function () {},
                screen: {},
                setTimeout: function () {},
                clearTimeout: function () {},
              }
            : window,
        l = function (e) {
          for (var t = 0; t < e.length; t += 1) this[t] = e[t];
          return (this.length = e.length), this;
        };
      function E(e, t) {
        var n = [],
          r = 0;
        if (e && !t && e instanceof l) return e;
        if (e)
          if ("string" == typeof e) {
            var i,
              o,
              a = e.trim();
            if (0 <= a.indexOf("<") && 0 <= a.indexOf(">")) {
              var s = "div";
              for (
                0 === a.indexOf("<li") && (s = "ul"),
                  0 === a.indexOf("<tr") && (s = "tbody"),
                  (0 !== a.indexOf("<td") && 0 !== a.indexOf("<th")) ||
                    (s = "tr"),
                  0 === a.indexOf("<tbody") && (s = "table"),
                  0 === a.indexOf("<option") && (s = "select"),
                  (o = d.createElement(s)).innerHTML = a,
                  r = 0;
                r < o.childNodes.length;
                r += 1
              )
                n.push(o.childNodes[r]);
            } else
              for (
                i =
                  t || "#" !== e[0] || e.match(/[ .<>:~]/)
                    ? (t || d).querySelectorAll(e.trim())
                    : [d.getElementById(e.trim().split("#")[1])],
                  r = 0;
                r < i.length;
                r += 1
              )
                i[r] && n.push(i[r]);
          } else if (e.nodeType || e === G || e === d) n.push(e);
          else if (0 < e.length && e[0].nodeType)
            for (r = 0; r < e.length; r += 1) n.push(e[r]);
        return new l(n);
      }
      function o(e) {
        for (var t = [], n = 0; n < e.length; n += 1)
          -1 === t.indexOf(e[n]) && t.push(e[n]);
        return t;
      }
      (E.fn = l.prototype), (E.Class = l), (E.Dom7 = l);
      var t = {
        addClass: function (e) {
          if (void 0 === e) return this;
          for (var t = e.split(" "), n = 0; n < t.length; n += 1)
            for (var r = 0; r < this.length; r += 1)
              void 0 !== this[r] &&
                void 0 !== this[r].classList &&
                this[r].classList.add(t[n]);
          return this;
        },
        removeClass: function (e) {
          for (var t = e.split(" "), n = 0; n < t.length; n += 1)
            for (var r = 0; r < this.length; r += 1)
              void 0 !== this[r] &&
                void 0 !== this[r].classList &&
                this[r].classList.remove(t[n]);
          return this;
        },
        hasClass: function (e) {
          return !!this[0] && this[0].classList.contains(e);
        },
        toggleClass: function (e) {
          for (var t = e.split(" "), n = 0; n < t.length; n += 1)
            for (var r = 0; r < this.length; r += 1)
              void 0 !== this[r] &&
                void 0 !== this[r].classList &&
                this[r].classList.toggle(t[n]);
          return this;
        },
        attr: function (e, t) {
          var n = arguments;
          if (1 === arguments.length && "string" == typeof e)
            return this[0] ? this[0].getAttribute(e) : void 0;
          for (var r = 0; r < this.length; r += 1)
            if (2 === n.length) this[r].setAttribute(e, t);
            else
              for (var i in e)
                (this[r][i] = e[i]), this[r].setAttribute(i, e[i]);
          return this;
        },
        removeAttr: function (e) {
          for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
          return this;
        },
        data: function (e, t) {
          var n;
          if (void 0 !== t) {
            for (var r = 0; r < this.length; r += 1)
              (n = this[r]).dom7ElementDataStorage ||
                (n.dom7ElementDataStorage = {}),
                (n.dom7ElementDataStorage[e] = t);
            return this;
          }
          if ((n = this[0]))
            return n.dom7ElementDataStorage && e in n.dom7ElementDataStorage
              ? n.dom7ElementDataStorage[e]
              : n.getAttribute("data-" + e) || void 0;
        },
        transform: function (e) {
          for (var t = 0; t < this.length; t += 1) {
            var n = this[t].style;
            (n.webkitTransform = e), (n.transform = e);
          }
          return this;
        },
        transition: function (e) {
          "string" != typeof e && (e += "ms");
          for (var t = 0; t < this.length; t += 1) {
            var n = this[t].style;
            (n.webkitTransitionDuration = e), (n.transitionDuration = e);
          }
          return this;
        },
        on: function () {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var n = e[0],
            o = e[1],
            a = e[2],
            r = e[3];
          function i(e) {
            var t = e.target;
            if (t) {
              var n = e.target.dom7EventData || [];
              if ((n.indexOf(e) < 0 && n.unshift(e), E(t).is(o))) a.apply(t, n);
              else
                for (var r = E(t).parents(), i = 0; i < r.length; i += 1)
                  E(r[i]).is(o) && a.apply(r[i], n);
            }
          }
          function s(e) {
            var t = (e && e.target && e.target.dom7EventData) || [];
            t.indexOf(e) < 0 && t.unshift(e), a.apply(this, t);
          }
          "function" == typeof e[1] &&
            ((n = e[0]), (a = e[1]), (r = e[2]), (o = void 0)),
            (r = r || !1);
          for (var l, c = n.split(" "), u = 0; u < this.length; u += 1) {
            var d = this[u];
            if (o)
              for (l = 0; l < c.length; l += 1) {
                var p = c[l];
                d.dom7LiveListeners || (d.dom7LiveListeners = {}),
                  d.dom7LiveListeners[p] || (d.dom7LiveListeners[p] = []),
                  d.dom7LiveListeners[p].push({
                    listener: a,
                    proxyListener: i,
                  }),
                  d.addEventListener(p, i, r);
              }
            else
              for (l = 0; l < c.length; l += 1) {
                var f = c[l];
                d.dom7Listeners || (d.dom7Listeners = {}),
                  d.dom7Listeners[f] || (d.dom7Listeners[f] = []),
                  d.dom7Listeners[f].push({ listener: a, proxyListener: s }),
                  d.addEventListener(f, s, r);
              }
          }
          return this;
        },
        off: function () {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var n = e[0],
            r = e[1],
            i = e[2],
            o = e[3];
          "function" == typeof e[1] &&
            ((n = e[0]), (i = e[1]), (o = e[2]), (r = void 0)),
            (o = o || !1);
          for (var a = n.split(" "), s = 0; s < a.length; s += 1)
            for (var l = a[s], c = 0; c < this.length; c += 1) {
              var u = this[c],
                d = void 0;
              if (
                (!r && u.dom7Listeners
                  ? (d = u.dom7Listeners[l])
                  : r && u.dom7LiveListeners && (d = u.dom7LiveListeners[l]),
                d && d.length)
              )
                for (var p = d.length - 1; 0 <= p; --p) {
                  var f = d[p];
                  ((i && f.listener === i) ||
                    (i &&
                      f.listener &&
                      f.listener.dom7proxy &&
                      f.listener.dom7proxy === i) ||
                    !i) &&
                    (u.removeEventListener(l, f.proxyListener, o),
                    d.splice(p, 1));
                }
            }
          return this;
        },
        trigger: function () {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          for (var n = e[0].split(" "), r = e[1], i = 0; i < n.length; i += 1)
            for (var o = n[i], a = 0; a < this.length; a += 1) {
              var s = this[a],
                l = void 0;
              try {
                l = new G.CustomEvent(o, {
                  detail: r,
                  bubbles: !0,
                  cancelable: !0,
                });
              } catch (e) {
                (l = d.createEvent("Event")).initEvent(o, !0, !0),
                  (l.detail = r);
              }
              (s.dom7EventData = e.filter(function (e, t) {
                return 0 < t;
              })),
                s.dispatchEvent(l),
                (s.dom7EventData = []),
                delete s.dom7EventData;
            }
          return this;
        },
        transitionEnd: function (t) {
          var n,
            r = ["webkitTransitionEnd", "transitionend"],
            i = this;
          function o(e) {
            if (e.target === this)
              for (t.call(this, e), n = 0; n < r.length; n += 1) i.off(r[n], o);
          }
          if (t) for (n = 0; n < r.length; n += 1) i.on(r[n], o);
          return this;
        },
        outerWidth: function (e) {
          if (0 < this.length) {
            if (e) {
              e = this.styles();
              return (
                this[0].offsetWidth +
                parseFloat(e.getPropertyValue("margin-right")) +
                parseFloat(e.getPropertyValue("margin-left"))
              );
            }
            return this[0].offsetWidth;
          }
          return null;
        },
        outerHeight: function (e) {
          if (0 < this.length) {
            if (e) {
              e = this.styles();
              return (
                this[0].offsetHeight +
                parseFloat(e.getPropertyValue("margin-top")) +
                parseFloat(e.getPropertyValue("margin-bottom"))
              );
            }
            return this[0].offsetHeight;
          }
          return null;
        },
        offset: function () {
          if (0 < this.length) {
            var e = this[0],
              t = e.getBoundingClientRect(),
              n = d.body,
              r = e.clientTop || n.clientTop || 0,
              i = e.clientLeft || n.clientLeft || 0,
              n = e === G ? G.scrollY : e.scrollTop,
              e = e === G ? G.scrollX : e.scrollLeft;
            return { top: t.top + n - r, left: t.left + e - i };
          }
          return null;
        },
        css: function (e, t) {
          var n;
          if (1 === arguments.length) {
            if ("string" != typeof e) {
              for (n = 0; n < this.length; n += 1)
                for (var r in e) this[n].style[r] = e[r];
              return this;
            }
            if (this[0])
              return G.getComputedStyle(this[0], null).getPropertyValue(e);
          }
          if (2 !== arguments.length || "string" != typeof e) return this;
          for (n = 0; n < this.length; n += 1) this[n].style[e] = t;
          return this;
        },
        each: function (e) {
          if (!e) return this;
          for (var t = 0; t < this.length; t += 1)
            if (!1 === e.call(this[t], t, this[t])) return this;
          return this;
        },
        html: function (e) {
          if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
          for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
          return this;
        },
        text: function (e) {
          if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
          for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
          return this;
        },
        is: function (e) {
          var t,
            n,
            r = this[0];
          if (!r || void 0 === e) return !1;
          if ("string" == typeof e) {
            if (r.matches) return r.matches(e);
            if (r.webkitMatchesSelector) return r.webkitMatchesSelector(e);
            if (r.msMatchesSelector) return r.msMatchesSelector(e);
            for (t = E(e), n = 0; n < t.length; n += 1)
              if (t[n] === r) return !0;
            return !1;
          }
          if (e === d) return r === d;
          if (e === G) return r === G;
          if (e.nodeType || e instanceof l) {
            for (t = e.nodeType ? [e] : e, n = 0; n < t.length; n += 1)
              if (t[n] === r) return !0;
            return !1;
          }
          return !1;
        },
        index: function () {
          var e,
            t = this[0];
          if (t) {
            for (e = 0; null !== (t = t.previousSibling); )
              1 === t.nodeType && (e += 1);
            return e;
          }
        },
        eq: function (e) {
          if (void 0 === e) return this;
          var t = this.length;
          return new l(
            t - 1 < e
              ? []
              : e < 0
              ? (t = t + e) < 0
                ? []
                : [this[t]]
              : [this[e]]
          );
        },
        append: function () {
          for (var e, t = [], n = arguments.length; n--; ) t[n] = arguments[n];
          for (var r = 0; r < t.length; r += 1) {
            e = t[r];
            for (var i = 0; i < this.length; i += 1)
              if ("string" == typeof e) {
                var o = d.createElement("div");
                for (o.innerHTML = e; o.firstChild; )
                  this[i].appendChild(o.firstChild);
              } else if (e instanceof l)
                for (var a = 0; a < e.length; a += 1) this[i].appendChild(e[a]);
              else this[i].appendChild(e);
          }
          return this;
        },
        prepend: function (e) {
          for (var t, n = 0; n < this.length; n += 1)
            if ("string" == typeof e) {
              var r = d.createElement("div");
              for (r.innerHTML = e, t = r.childNodes.length - 1; 0 <= t; --t)
                this[n].insertBefore(r.childNodes[t], this[n].childNodes[0]);
            } else if (e instanceof l)
              for (t = 0; t < e.length; t += 1)
                this[n].insertBefore(e[t], this[n].childNodes[0]);
            else this[n].insertBefore(e, this[n].childNodes[0]);
          return this;
        },
        next: function (e) {
          return 0 < this.length
            ? e
              ? this[0].nextElementSibling &&
                E(this[0].nextElementSibling).is(e)
                ? new l([this[0].nextElementSibling])
                : new l([])
              : this[0].nextElementSibling
              ? new l([this[0].nextElementSibling])
              : new l([])
            : new l([]);
        },
        nextAll: function (e) {
          var t = [],
            n = this[0];
          if (!n) return new l([]);
          for (; n.nextElementSibling; ) {
            var r = n.nextElementSibling;
            (e && !E(r).is(e)) || t.push(r), (n = r);
          }
          return new l(t);
        },
        prev: function (e) {
          if (0 < this.length) {
            var t = this[0];
            return e
              ? t.previousElementSibling && E(t.previousElementSibling).is(e)
                ? new l([t.previousElementSibling])
                : new l([])
              : t.previousElementSibling
              ? new l([t.previousElementSibling])
              : new l([]);
          }
          return new l([]);
        },
        prevAll: function (e) {
          var t = [],
            n = this[0];
          if (!n) return new l([]);
          for (; n.previousElementSibling; ) {
            var r = n.previousElementSibling;
            (e && !E(r).is(e)) || t.push(r), (n = r);
          }
          return new l(t);
        },
        parent: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1)
            null === this[n].parentNode ||
              (e && !E(this[n].parentNode).is(e)) ||
              t.push(this[n].parentNode);
          return E(o(t));
        },
        parents: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1)
            for (var r = this[n].parentNode; r; )
              (e && !E(r).is(e)) || t.push(r), (r = r.parentNode);
          return E(o(t));
        },
        closest: function (e) {
          var t = this;
          return void 0 === e
            ? new l([])
            : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1)
            for (
              var r = this[n].querySelectorAll(e), i = 0;
              i < r.length;
              i += 1
            )
              t.push(r[i]);
          return new l(t);
        },
        children: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1)
            for (var r = this[n].childNodes, i = 0; i < r.length; i += 1)
              e
                ? 1 === r[i].nodeType && E(r[i]).is(e) && t.push(r[i])
                : 1 === r[i].nodeType && t.push(r[i]);
          return new l(o(t));
        },
        filter: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1)
            e.call(this[n], n, this[n]) && t.push(this[n]);
          return new l(t);
        },
        remove: function () {
          for (var e = 0; e < this.length; e += 1)
            this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this;
        },
        add: function () {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          for (var n = 0; n < e.length; n += 1)
            for (var r = E(e[n]), i = 0; i < r.length; i += 1)
              (this[this.length] = r[i]), (this.length += 1);
          return this;
        },
        styles: function () {
          return this[0] ? G.getComputedStyle(this[0], null) : {};
        },
      };
      Object.keys(t).forEach(function (e) {
        E.fn[e] = E.fn[e] || t[e];
      });
      var Y = {
          deleteProps: function (e) {
            var t = e;
            Object.keys(t).forEach(function (e) {
              try {
                t[e] = null;
              } catch (e) {}
              try {
                delete t[e];
              } catch (e) {}
            });
          },
          nextTick: function (e, t) {
            return void 0 === t && (t = 0), setTimeout(e, t);
          },
          now: function () {
            return Date.now();
          },
          getTranslate: function (e, t) {
            var n, r, i;
            void 0 === t && (t = "x");
            e = G.getComputedStyle(e, null);
            return (
              G.WebKitCSSMatrix
                ? (6 <
                    (r = e.transform || e.webkitTransform).split(",").length &&
                    (r = r
                      .split(", ")
                      .map(function (e) {
                        return e.replace(",", ".");
                      })
                      .join(", ")),
                  (i = new G.WebKitCSSMatrix("none" === r ? "" : r)))
                : (n = (i =
                    e.MozTransform ||
                    e.OTransform ||
                    e.MsTransform ||
                    e.msTransform ||
                    e.transform ||
                    e
                      .getPropertyValue("transform")
                      .replace("translate(", "matrix(1, 0, 0, 1,"))
                    .toString()
                    .split(",")),
              "x" === t &&
                (r = G.WebKitCSSMatrix
                  ? i.m41
                  : 16 === n.length
                  ? parseFloat(n[12])
                  : parseFloat(n[4])),
              "y" === t &&
                (r = G.WebKitCSSMatrix
                  ? i.m42
                  : 16 === n.length
                  ? parseFloat(n[13])
                  : parseFloat(n[5])),
              r || 0
            );
          },
          parseUrlQuery: function (e) {
            var t,
              n,
              r,
              i,
              o = {},
              e = e || G.location.href;
            if ("string" == typeof e && e.length)
              for (
                i = (n = (e = -1 < e.indexOf("?") ? e.replace(/\S*\?/, "") : "")
                  .split("&")
                  .filter(function (e) {
                    return "" !== e;
                  })).length,
                  t = 0;
                t < i;
                t += 1
              )
                (r = n[t].replace(/#\S+/g, "").split("=")),
                  (o[decodeURIComponent(r[0])] =
                    void 0 === r[1] ? void 0 : decodeURIComponent(r[1]) || "");
            return o;
          },
          isObject: function (e) {
            return (
              "object" === oC(e) &&
              null !== e &&
              e.constructor &&
              e.constructor === Object
            );
          },
          extend: function () {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            for (var n = Object(e[0]), r = 1; r < e.length; r += 1) {
              var i = e[r];
              if (null != i)
                for (
                  var o = Object.keys(Object(i)), a = 0, s = o.length;
                  a < s;
                  a += 1
                ) {
                  var l = o[a],
                    c = Object.getOwnPropertyDescriptor(i, l);
                  void 0 !== c &&
                    c.enumerable &&
                    (Y.isObject(n[l]) && Y.isObject(i[l])
                      ? Y.extend(n[l], i[l])
                      : !Y.isObject(n[l]) && Y.isObject(i[l])
                      ? ((n[l] = {}), Y.extend(n[l], i[l]))
                      : (n[l] = i[l]));
                }
            }
            return n;
          },
        },
        w = {
          touch:
            (G.Modernizr && !0 === G.Modernizr.touch) ||
            !!(
              0 < G.navigator.maxTouchPoints ||
              "ontouchstart" in G ||
              (G.DocumentTouch && d instanceof G.DocumentTouch)
            ),
          pointerEvents:
            !!G.PointerEvent &&
            "maxTouchPoints" in G.navigator &&
            0 < G.navigator.maxTouchPoints,
          observer: "MutationObserver" in G || "WebkitMutationObserver" in G,
          passiveListener: (function () {
            var e = !1;
            try {
              var t = Object.defineProperty({}, "passive", {
                get: function () {
                  e = !0;
                },
              });
              G.addEventListener("testPassiveListener", null, t);
            } catch (e) {}
            return e;
          })(),
          gestures: "ongesturestart" in G,
        },
        e = function (e) {
          void 0 === e && (e = {});
          var t = this;
          (t.params = e),
            (t.eventsListeners = {}),
            t.params &&
              t.params.on &&
              Object.keys(t.params.on).forEach(function (e) {
                t.on(e, t.params.on[e]);
              });
        },
        n = { components: { configurable: !0 } };
      (e.prototype.on = function (e, t, n) {
        var r = this;
        if ("function" != typeof t) return r;
        var i = n ? "unshift" : "push";
        return (
          e.split(" ").forEach(function (e) {
            r.eventsListeners[e] || (r.eventsListeners[e] = []),
              r.eventsListeners[e][i](t);
          }),
          r
        );
      }),
        (e.prototype.once = function (n, r, e) {
          var i = this;
          return "function" != typeof r ? i : ((o.f7proxy = r), i.on(n, o, e));
          function o() {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            i.off(n, o), o.f7proxy && delete o.f7proxy, r.apply(i, e);
          }
        }),
        (e.prototype.off = function (e, r) {
          var i = this;
          return (
            i.eventsListeners &&
              e.split(" ").forEach(function (n) {
                void 0 === r
                  ? (i.eventsListeners[n] = [])
                  : i.eventsListeners[n] &&
                    i.eventsListeners[n].length &&
                    i.eventsListeners[n].forEach(function (e, t) {
                      (e === r || (e.f7proxy && e.f7proxy === r)) &&
                        i.eventsListeners[n].splice(t, 1);
                    });
              }),
            i
          );
        }),
        (e.prototype.emit = function () {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var n,
            r,
            i,
            o = this;
          return (
            o.eventsListeners &&
              ((i =
                "string" == typeof e[0] || Array.isArray(e[0])
                  ? ((n = e[0]), (r = e.slice(1, e.length)), o)
                  : ((n = e[0].events), (r = e[0].data), e[0].context || o)),
              (Array.isArray(n) ? n : n.split(" ")).forEach(function (e) {
                var t;
                o.eventsListeners &&
                  o.eventsListeners[e] &&
                  ((t = []),
                  o.eventsListeners[e].forEach(function (e) {
                    t.push(e);
                  }),
                  t.forEach(function (e) {
                    e.apply(i, r);
                  }));
              })),
            o
          );
        }),
        (e.prototype.useModulesParams = function (t) {
          var n = this;
          n.modules &&
            Object.keys(n.modules).forEach(function (e) {
              e = n.modules[e];
              e.params && Y.extend(t, e.params);
            });
        }),
        (e.prototype.useModules = function (t) {
          void 0 === t && (t = {});
          var r = this;
          r.modules &&
            Object.keys(r.modules).forEach(function (e) {
              var n = r.modules[e],
                e = t[e] || {};
              n.instance &&
                Object.keys(n.instance).forEach(function (e) {
                  var t = n.instance[e];
                  r[e] = "function" == typeof t ? t.bind(r) : t;
                }),
                n.on &&
                  r.on &&
                  Object.keys(n.on).forEach(function (e) {
                    r.on(e, n.on[e]);
                  }),
                n.create && n.create.bind(r)(e);
            });
        }),
        (n.components.set = function (e) {
          this.use && this.use(e);
        }),
        (e.installModule = function (t) {
          for (var e = [], n = arguments.length - 1; 0 < n--; )
            e[n] = arguments[n + 1];
          var r = this;
          r.prototype.modules || (r.prototype.modules = {});
          var i =
            t.name || Object.keys(r.prototype.modules).length + "_" + Y.now();
          return (
            (r.prototype.modules[i] = t).proto &&
              Object.keys(t.proto).forEach(function (e) {
                r.prototype[e] = t.proto[e];
              }),
            t.static &&
              Object.keys(t.static).forEach(function (e) {
                r[e] = t.static[e];
              }),
            t.install && t.install.apply(r, e),
            r
          );
        }),
        (e.use = function (e) {
          for (var t = [], n = arguments.length - 1; 0 < n--; )
            t[n] = arguments[n + 1];
          var r = this;
          return Array.isArray(e)
            ? (e.forEach(function (e) {
                return r.installModule(e);
              }),
              r)
            : r.installModule.apply(r, [e].concat(t));
        }),
        Object.defineProperties(e, n);
      var r,
        i,
        a,
        s,
        c,
        u,
        p,
        f,
        h,
        m,
        g,
        v,
        y,
        b = {
          updateSize: function () {
            var e = this.$el,
              t =
                void 0 !== this.params.width
                  ? this.params.width
                  : e[0].clientWidth,
              n =
                void 0 !== this.params.height
                  ? this.params.height
                  : e[0].clientHeight;
            (0 === t && this.isHorizontal()) ||
              (0 === n && this.isVertical()) ||
              ((t =
                t -
                parseInt(e.css("padding-left"), 10) -
                parseInt(e.css("padding-right"), 10)),
              (n =
                n -
                parseInt(e.css("padding-top"), 10) -
                parseInt(e.css("padding-bottom"), 10)),
              Y.extend(this, {
                width: t,
                height: n,
                size: this.isHorizontal() ? t : n,
              }));
          },
          updateSlides: function () {
            var t = this.params,
              e = this.$wrapperEl,
              n = this.size,
              r = this.rtlTranslate,
              i = this.wrongRTL,
              o = this.virtual && t.virtual.enabled,
              a = (o ? this.virtual : this).slides.length,
              s = e.children("." + this.params.slideClass),
              l = (o ? this.virtual.slides : s).length,
              c = [],
              u = [],
              d = [];
            function p(e) {
              return !t.cssMode || e !== s.length - 1;
            }
            var f = t.slidesOffsetBefore;
            "function" == typeof f && (f = t.slidesOffsetBefore.call(this));
            var h = t.slidesOffsetAfter;
            "function" == typeof h && (h = t.slidesOffsetAfter.call(this));
            var m,
              g = this.snapGrid.length,
              o = this.snapGrid.length,
              v = t.spaceBetween,
              y = -f,
              b = 0,
              w = 0;
            if (void 0 !== n) {
              "string" == typeof v &&
                0 <= v.indexOf("%") &&
                (v = (parseFloat(v.replace("%", "")) / 100) * n),
                (this.virtualSize = -v),
                r
                  ? s.css({ marginLeft: "", marginTop: "" })
                  : s.css({ marginRight: "", marginBottom: "" }),
                1 < t.slidesPerColumn &&
                  ((m =
                    Math.floor(l / t.slidesPerColumn) ===
                    l / this.params.slidesPerColumn
                      ? l
                      : Math.ceil(l / t.slidesPerColumn) * t.slidesPerColumn),
                  "auto" !== t.slidesPerView &&
                    "row" === t.slidesPerColumnFill &&
                    (m = Math.max(m, t.slidesPerView * t.slidesPerColumn)));
              for (
                var x,
                  E,
                  S,
                  C,
                  k,
                  T = t.slidesPerColumn,
                  P = m / T,
                  z = Math.floor(l / t.slidesPerColumn),
                  O = 0;
                O < l;
                O += 1
              ) {
                _ = 0;
                var R,
                  M,
                  N,
                  L,
                  I,
                  _,
                  D,
                  A,
                  F,
                  B,
                  W,
                  $,
                  j = s.eq(O);
                1 < t.slidesPerColumn &&
                  ((I = L = N = void 0),
                  "row" === t.slidesPerColumnFill && 1 < t.slidesPerGroup
                    ? (($ = Math.floor(
                        O / (t.slidesPerGroup * t.slidesPerColumn)
                      )),
                      (R = O - t.slidesPerColumn * t.slidesPerGroup * $),
                      (M =
                        0 === $
                          ? t.slidesPerGroup
                          : Math.min(
                              Math.ceil((l - $ * T * t.slidesPerGroup) / T),
                              t.slidesPerGroup
                            )),
                      (N =
                        (L =
                          R -
                          (I = Math.floor(R / M)) * M +
                          $ * t.slidesPerGroup) +
                        (I * m) / T),
                      j.css({
                        "-webkit-box-ordinal-group": N,
                        "-moz-box-ordinal-group": N,
                        "-ms-flex-order": N,
                        "-webkit-order": N,
                        order: N,
                      }))
                    : "column" === t.slidesPerColumnFill
                    ? ((I = O - (L = Math.floor(O / T)) * T),
                      (z < L || (L === z && I === T - 1)) &&
                        (I += 1) >= T &&
                        ((I = 0), (L += 1)))
                    : (L = O - (I = Math.floor(O / P)) * P),
                  j.css(
                    "margin-" + (this.isHorizontal() ? "top" : "left"),
                    0 !== I && t.spaceBetween && t.spaceBetween + "px"
                  )),
                  "none" !== j.css("display") &&
                    ("auto" === t.slidesPerView
                      ? (($ = G.getComputedStyle(j[0], null)),
                        (N = j[0].style.transform),
                        (L = j[0].style.webkitTransform),
                        N && (j[0].style.transform = "none"),
                        L && (j[0].style.webkitTransform = "none"),
                        (_ = t.roundLengths
                          ? this.isHorizontal()
                            ? j.outerWidth(!0)
                            : j.outerHeight(!0)
                          : this.isHorizontal()
                          ? ((D = parseFloat($.getPropertyValue("width"))),
                            (A = parseFloat(
                              $.getPropertyValue("padding-left")
                            )),
                            (F = parseFloat(
                              $.getPropertyValue("padding-right")
                            )),
                            (B = parseFloat($.getPropertyValue("margin-left"))),
                            (W = parseFloat(
                              $.getPropertyValue("margin-right")
                            )),
                            (I = $.getPropertyValue("box-sizing")) &&
                            "border-box" === I
                              ? D + B + W
                              : D + A + F + B + W)
                          : ((D = parseFloat($.getPropertyValue("height"))),
                            (A = parseFloat($.getPropertyValue("padding-top"))),
                            (F = parseFloat(
                              $.getPropertyValue("padding-bottom")
                            )),
                            (B = parseFloat($.getPropertyValue("margin-top"))),
                            (W = parseFloat(
                              $.getPropertyValue("margin-bottom")
                            )),
                            ($ = $.getPropertyValue("box-sizing")) &&
                            "border-box" === $
                              ? D + B + W
                              : D + A + F + B + W)),
                        N && (j[0].style.transform = N),
                        L && (j[0].style.webkitTransform = L),
                        t.roundLengths && (_ = Math.floor(_)))
                      : ((_ =
                          (n - (t.slidesPerView - 1) * v) / t.slidesPerView),
                        t.roundLengths && (_ = Math.floor(_)),
                        s[O] &&
                          (this.isHorizontal()
                            ? (s[O].style.width = _ + "px")
                            : (s[O].style.height = _ + "px"))),
                    s[O] && (s[O].swiperSlideSize = _),
                    d.push(_),
                    t.centeredSlides
                      ? ((y = y + _ / 2 + b / 2 + v),
                        0 === b && 0 !== O && (y = y - n / 2 - v),
                        0 === O && (y = y - n / 2 - v),
                        Math.abs(y) < 0.001 && (y = 0),
                        t.roundLengths && (y = Math.floor(y)),
                        w % t.slidesPerGroup == 0 && c.push(y),
                        u.push(y))
                      : (t.roundLengths && (y = Math.floor(y)),
                        (w - Math.min(this.params.slidesPerGroupSkip, w)) %
                          this.params.slidesPerGroup ==
                          0 && c.push(y),
                        u.push(y),
                        (y = y + _ + v)),
                    (this.virtualSize += _ + v),
                    (b = _),
                    (w += 1));
              }
              if (
                ((this.virtualSize = Math.max(this.virtualSize, n) + h),
                r &&
                  i &&
                  ("slide" === t.effect || "coverflow" === t.effect) &&
                  e.css({ width: this.virtualSize + t.spaceBetween + "px" }),
                t.setWrapperSize &&
                  (this.isHorizontal()
                    ? e.css({ width: this.virtualSize + t.spaceBetween + "px" })
                    : e.css({
                        height: this.virtualSize + t.spaceBetween + "px",
                      })),
                1 < t.slidesPerColumn &&
                  ((this.virtualSize = (_ + t.spaceBetween) * m),
                  (this.virtualSize =
                    Math.ceil(this.virtualSize / t.slidesPerColumn) -
                    t.spaceBetween),
                  this.isHorizontal()
                    ? e.css({ width: this.virtualSize + t.spaceBetween + "px" })
                    : e.css({
                        height: this.virtualSize + t.spaceBetween + "px",
                      }),
                  t.centeredSlides))
              ) {
                x = [];
                for (var H = 0; H < c.length; H += 1) {
                  var V = c[H];
                  t.roundLengths && (V = Math.floor(V)),
                    c[H] < this.virtualSize + c[0] && x.push(V);
                }
                c = x;
              }
              if (!t.centeredSlides) {
                x = [];
                for (var q = 0; q < c.length; q += 1) {
                  var U = c[q];
                  t.roundLengths && (U = Math.floor(U)),
                    c[q] <= this.virtualSize - n && x.push(U);
                }
                (c = x),
                  1 <
                    Math.floor(this.virtualSize - n) -
                      Math.floor(c[c.length - 1]) &&
                    c.push(this.virtualSize - n);
              }
              0 === c.length && (c = [0]),
                0 !== t.spaceBetween &&
                  (this.isHorizontal()
                    ? r
                      ? s.filter(p).css({ marginLeft: v + "px" })
                      : s.filter(p).css({ marginRight: v + "px" })
                    : s.filter(p).css({ marginBottom: v + "px" })),
                t.centeredSlides &&
                  t.centeredSlidesBounds &&
                  ((E = 0),
                  d.forEach(function (e) {
                    E += e + (t.spaceBetween || 0);
                  }),
                  (S = (E -= t.spaceBetween) - n),
                  (c = c.map(function (e) {
                    return e < 0 ? -f : S < e ? S + h : e;
                  }))),
                t.centerInsufficientSlides &&
                  ((C = 0),
                  d.forEach(function (e) {
                    C += e + (t.spaceBetween || 0);
                  }),
                  (C -= t.spaceBetween) < n &&
                    ((k = (n - C) / 2),
                    c.forEach(function (e, t) {
                      c[t] = e - k;
                    }),
                    u.forEach(function (e, t) {
                      u[t] = e + k;
                    }))),
                Y.extend(this, {
                  slides: s,
                  snapGrid: c,
                  slidesGrid: u,
                  slidesSizesGrid: d,
                }),
                l !== a && this.emit("slidesLengthChange"),
                c.length !== g &&
                  (this.params.watchOverflow && this.checkOverflow(),
                  this.emit("snapGridLengthChange")),
                u.length !== o && this.emit("slidesGridLengthChange"),
                (t.watchSlidesProgress || t.watchSlidesVisibility) &&
                  this.updateSlidesOffset();
            }
          },
          updateAutoHeight: function (e) {
            var t,
              n,
              r = [],
              i = 0;
            if (
              ("number" == typeof e
                ? this.setTransition(e)
                : !0 === e && this.setTransition(this.params.speed),
              "auto" !== this.params.slidesPerView &&
                1 < this.params.slidesPerView)
            )
              for (t = 0; t < Math.ceil(this.params.slidesPerView); t += 1) {
                var o = this.activeIndex + t;
                if (o > this.slides.length) break;
                r.push(this.slides.eq(o)[0]);
              }
            else r.push(this.slides.eq(this.activeIndex)[0]);
            for (t = 0; t < r.length; t += 1)
              void 0 !== r[t] && (i = i < (n = r[t].offsetHeight) ? n : i);
            i && this.$wrapperEl.css("height", i + "px");
          },
          updateSlidesOffset: function () {
            for (var e = this.slides, t = 0; t < e.length; t += 1)
              e[t].swiperSlideOffset = this.isHorizontal()
                ? e[t].offsetLeft
                : e[t].offsetTop;
          },
          updateSlidesProgress: function (e) {
            void 0 === e && (e = (this && this.translate) || 0);
            var t = this.params,
              n = this.slides,
              r = this.rtlTranslate;
            if (0 !== n.length) {
              void 0 === n[0].swiperSlideOffset && this.updateSlidesOffset();
              var i = r ? e : -e;
              n.removeClass(t.slideVisibleClass),
                (this.visibleSlidesIndexes = []),
                (this.visibleSlides = []);
              for (var o = 0; o < n.length; o += 1) {
                var a,
                  s,
                  l = n[o],
                  c =
                    (i +
                      (t.centeredSlides ? this.minTranslate() : 0) -
                      l.swiperSlideOffset) /
                    (l.swiperSlideSize + t.spaceBetween);
                t.watchSlidesVisibility &&
                  ((s =
                    (a = -(i - l.swiperSlideOffset)) + this.slidesSizesGrid[o]),
                  ((0 <= a && a < this.size - 1) ||
                    (1 < s && s <= this.size) ||
                    (a <= 0 && s >= this.size)) &&
                    (this.visibleSlides.push(l),
                    this.visibleSlidesIndexes.push(o),
                    n.eq(o).addClass(t.slideVisibleClass))),
                  (l.progress = r ? -c : c);
              }
              this.visibleSlides = E(this.visibleSlides);
            }
          },
          updateProgress: function (e) {
            void 0 === e &&
              ((a = this.rtlTranslate ? -1 : 1),
              (e = (this && this.translate && this.translate * a) || 0));
            var t = this.params,
              n = this.maxTranslate() - this.minTranslate(),
              r = this.progress,
              i = this.isBeginning,
              o = i,
              a = (s = this.isEnd),
              s =
                0 == n
                  ? (i = !(r = 0))
                  : ((i = (r = (e - this.minTranslate()) / n) <= 0), 1 <= r);
            Y.extend(this, { progress: r, isBeginning: i, isEnd: s }),
              (t.watchSlidesProgress || t.watchSlidesVisibility) &&
                this.updateSlidesProgress(e),
              i && !o && this.emit("reachBeginning toEdge"),
              s && !a && this.emit("reachEnd toEdge"),
              ((o && !i) || (a && !s)) && this.emit("fromEdge"),
              this.emit("progress", r);
          },
          updateSlidesClasses: function () {
            var e = this.slides,
              t = this.params,
              n = this.$wrapperEl,
              r = this.activeIndex,
              i = this.realIndex,
              o = this.virtual && t.virtual.enabled;
            e.removeClass(
              t.slideActiveClass +
                " " +
                t.slideNextClass +
                " " +
                t.slidePrevClass +
                " " +
                t.slideDuplicateActiveClass +
                " " +
                t.slideDuplicateNextClass +
                " " +
                t.slideDuplicatePrevClass
            ),
              (r = o
                ? this.$wrapperEl.find(
                    "." +
                      t.slideClass +
                      '[data-pwzrswiper-slide-index="' +
                      r +
                      '"]'
                  )
                : e.eq(r)).addClass(t.slideActiveClass),
              t.loop &&
                (r.hasClass(t.slideDuplicateClass)
                  ? n.children(
                      "." +
                        t.slideClass +
                        ":not(." +
                        t.slideDuplicateClass +
                        ')[data-pwzrswiper-slide-index="' +
                        i +
                        '"]'
                    )
                  : n.children(
                      "." +
                        t.slideClass +
                        "." +
                        t.slideDuplicateClass +
                        '[data-pwzrswiper-slide-index="' +
                        i +
                        '"]'
                    )
                ).addClass(t.slideDuplicateActiveClass);
            i = r
              .nextAll("." + t.slideClass)
              .eq(0)
              .addClass(t.slideNextClass);
            t.loop &&
              0 === i.length &&
              (i = e.eq(0)).addClass(t.slideNextClass);
            r = r
              .prevAll("." + t.slideClass)
              .eq(0)
              .addClass(t.slidePrevClass);
            t.loop &&
              0 === r.length &&
              (r = e.eq(-1)).addClass(t.slidePrevClass),
              t.loop &&
                ((i.hasClass(t.slideDuplicateClass)
                  ? n.children(
                      "." +
                        t.slideClass +
                        ":not(." +
                        t.slideDuplicateClass +
                        ')[data-pwzrswiper-slide-index="' +
                        i.attr("data-pwzrswiper-slide-index") +
                        '"]'
                    )
                  : n.children(
                      "." +
                        t.slideClass +
                        "." +
                        t.slideDuplicateClass +
                        '[data-pwzrswiper-slide-index="' +
                        i.attr("data-pwzrswiper-slide-index") +
                        '"]'
                    )
                ).addClass(t.slideDuplicateNextClass),
                (r.hasClass(t.slideDuplicateClass)
                  ? n.children(
                      "." +
                        t.slideClass +
                        ":not(." +
                        t.slideDuplicateClass +
                        ')[data-pwzrswiper-slide-index="' +
                        r.attr("data-pwzrswiper-slide-index") +
                        '"]'
                    )
                  : n.children(
                      "." +
                        t.slideClass +
                        "." +
                        t.slideDuplicateClass +
                        '[data-pwzrswiper-slide-index="' +
                        r.attr("data-pwzrswiper-slide-index") +
                        '"]'
                    )
                ).addClass(t.slideDuplicatePrevClass));
          },
          updateActiveIndex: function (e) {
            var t = this.rtlTranslate ? this.translate : -this.translate,
              n = this.slidesGrid,
              r = this.snapGrid,
              i = this.params,
              o = this.activeIndex,
              a = this.realIndex,
              s = this.snapIndex,
              l = e;
            if (void 0 === l) {
              for (var c = 0; c < n.length; c += 1)
                void 0 !== n[c + 1]
                  ? t >= n[c] && t < n[c + 1] - (n[c + 1] - n[c]) / 2
                    ? (l = c)
                    : t >= n[c] && t < n[c + 1] && (l = c + 1)
                  : t >= n[c] && (l = c);
              i.normalizeSlideIndex && (l < 0 || void 0 === l) && (l = 0);
            }
            (i =
              0 <= r.indexOf(t)
                ? r.indexOf(t)
                : (e = Math.min(i.slidesPerGroupSkip, l)) +
                  Math.floor((l - e) / i.slidesPerGroup)) >= r.length &&
              (i = r.length - 1),
              l !== o
                ? ((r = parseInt(
                    this.slides.eq(l).attr("data-pwzrswiper-slide-index") || l,
                    10
                  )),
                  Y.extend(this, {
                    snapIndex: i,
                    realIndex: r,
                    previousIndex: o,
                    activeIndex: l,
                  }),
                  this.emit("activeIndexChange"),
                  this.emit("snapIndexChange"),
                  a !== r && this.emit("realIndexChange"),
                  (this.initialized || this.runCallbacksOnInit) &&
                    this.emit("slideChange"))
                : i !== s &&
                  ((this.snapIndex = i), this.emit("snapIndexChange"));
          },
          updateClickedSlide: function (e) {
            var t = this.params,
              n = E(e.target).closest("." + t.slideClass)[0],
              r = !1;
            if (n)
              for (var i = 0; i < this.slides.length; i += 1)
                this.slides[i] === n && (r = !0);
            if (!n || !r)
              return (
                (this.clickedSlide = void 0), void (this.clickedIndex = void 0)
              );
            (this.clickedSlide = n),
              this.virtual && this.params.virtual.enabled
                ? (this.clickedIndex = parseInt(
                    E(n).attr("data-pwzrswiper-slide-index"),
                    10
                  ))
                : (this.clickedIndex = E(n).index()),
              t.slideToClickedSlide &&
                void 0 !== this.clickedIndex &&
                this.clickedIndex !== this.activeIndex &&
                this.slideToClickedSlide();
          },
        },
        x = {
          getTranslate: function (e) {
            void 0 === e && (e = this.isHorizontal() ? "x" : "y");
            var t = this.params,
              n = this.rtlTranslate,
              r = this.translate,
              i = this.$wrapperEl;
            if (t.virtualTranslate) return n ? -r : r;
            if (t.cssMode) return r;
            e = Y.getTranslate(i[0], e);
            return n && (e = -e), e || 0;
          },
          setTranslate: function (e, t) {
            var n = this.rtlTranslate,
              r = this.params,
              i = this.$wrapperEl,
              o = this.wrapperEl,
              a = this.progress,
              s = 0,
              l = 0;
            this.isHorizontal() ? (s = n ? -e : e) : (l = e),
              r.roundLengths && ((s = Math.floor(s)), (l = Math.floor(l))),
              r.cssMode
                ? (o[
                    this.isHorizontal() ? "scrollLeft" : "scrollTop"
                  ] = this.isHorizontal() ? -s : -l)
                : r.virtualTranslate ||
                  i.transform("translate3d(" + s + "px, " + l + "px, 0px)"),
              (this.previousTranslate = this.translate),
              (this.translate = this.isHorizontal() ? s : l);
            l = this.maxTranslate() - this.minTranslate();
            (0 == l ? 0 : (e - this.minTranslate()) / l) !== a &&
              this.updateProgress(e),
              this.emit("setTranslate", this.translate, t);
          },
          minTranslate: function () {
            return -this.snapGrid[0];
          },
          maxTranslate: function () {
            return -this.snapGrid[this.snapGrid.length - 1];
          },
          translateTo: function (e, t, n, r, i) {
            void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0),
              void 0 === r && (r = !0);
            var o = this,
              a = o.params,
              s = o.wrapperEl;
            if (o.animating && a.preventInteractionOnTransition) return !1;
            var l = o.minTranslate(),
              c = o.maxTranslate(),
              c = r && l < e ? l : r && e < c ? c : e;
            if ((o.updateProgress(c), a.cssMode)) {
              e = o.isHorizontal();
              return (
                0 !== t && s.scrollTo
                  ? s.scrollTo(
                      (((a = {})[e ? "left" : "top"] = -c),
                      (a.behavior = "smooth"),
                      a)
                    )
                  : (s[e ? "scrollLeft" : "scrollTop"] = -c),
                !0
              );
            }
            return (
              0 === t
                ? (o.setTransition(0),
                  o.setTranslate(c),
                  n &&
                    (o.emit("beforeTransitionStart", t, i),
                    o.emit("transitionEnd")))
                : (o.setTransition(t),
                  o.setTranslate(c),
                  n &&
                    (o.emit("beforeTransitionStart", t, i),
                    o.emit("transitionStart")),
                  o.animating ||
                    ((o.animating = !0),
                    o.onTranslateToWrapperTransitionEnd ||
                      (o.onTranslateToWrapperTransitionEnd = function (e) {
                        o &&
                          !o.destroyed &&
                          e.target === this &&
                          (o.$wrapperEl[0].removeEventListener(
                            "transitionend",
                            o.onTranslateToWrapperTransitionEnd
                          ),
                          o.$wrapperEl[0].removeEventListener(
                            "webkitTransitionEnd",
                            o.onTranslateToWrapperTransitionEnd
                          ),
                          (o.onTranslateToWrapperTransitionEnd = null),
                          delete o.onTranslateToWrapperTransitionEnd,
                          n && o.emit("transitionEnd"));
                      }),
                    o.$wrapperEl[0].addEventListener(
                      "transitionend",
                      o.onTranslateToWrapperTransitionEnd
                    ),
                    o.$wrapperEl[0].addEventListener(
                      "webkitTransitionEnd",
                      o.onTranslateToWrapperTransitionEnd
                    ))),
              !0
            );
          },
        },
        S = {
          slideTo: function (e, t, n, r) {
            void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0);
            var i = this,
              o = e;
            o < 0 && (o = 0);
            var a = i.params,
              s = i.snapGrid,
              l = i.slidesGrid,
              c = i.previousIndex,
              u = i.activeIndex,
              d = i.rtlTranslate,
              p = i.wrapperEl;
            if (i.animating && a.preventInteractionOnTransition) return !1;
            (e = Math.min(i.params.slidesPerGroupSkip, o)),
              (e += Math.floor((o - e) / i.params.slidesPerGroup));
            e >= l.length && (e = l.length - 1),
              (u || a.initialSlide || 0) === (c || 0) &&
                n &&
                i.emit("beforeSlideChangeStart");
            var f,
              h = -s[e];
            if ((i.updateProgress(h), a.normalizeSlideIndex))
              for (var m = 0; m < l.length; m += 1)
                -Math.floor(100 * h) >= Math.floor(100 * l[m]) && (o = m);
            if (i.initialized && o !== u) {
              if (!i.allowSlideNext && h < i.translate && h < i.minTranslate())
                return !1;
              if (
                !i.allowSlidePrev &&
                h > i.translate &&
                h > i.maxTranslate() &&
                (u || 0) !== o
              )
                return !1;
            }
            if (
              ((f = u < o ? "next" : o < u ? "prev" : "reset"),
              (d && -h === i.translate) || (!d && h === i.translate))
            )
              return (
                i.updateActiveIndex(o),
                a.autoHeight && i.updateAutoHeight(),
                i.updateSlidesClasses(),
                "slide" !== a.effect && i.setTranslate(h),
                "reset" != f &&
                  (i.transitionStart(n, f), i.transitionEnd(n, f)),
                !1
              );
            if (a.cssMode) {
              d = i.isHorizontal();
              return (
                0 !== t && p.scrollTo
                  ? p.scrollTo(
                      (((a = {})[d ? "left" : "top"] = -h),
                      (a.behavior = "smooth"),
                      a)
                    )
                  : (p[d ? "scrollLeft" : "scrollTop"] = -h),
                !0
              );
            }
            return (
              0 === t
                ? (i.setTransition(0),
                  i.setTranslate(h),
                  i.updateActiveIndex(o),
                  i.updateSlidesClasses(),
                  i.emit("beforeTransitionStart", t, r),
                  i.transitionStart(n, f),
                  i.transitionEnd(n, f))
                : (i.setTransition(t),
                  i.setTranslate(h),
                  i.updateActiveIndex(o),
                  i.updateSlidesClasses(),
                  i.emit("beforeTransitionStart", t, r),
                  i.transitionStart(n, f),
                  i.animating ||
                    ((i.animating = !0),
                    i.onSlideToWrapperTransitionEnd ||
                      (i.onSlideToWrapperTransitionEnd = function (e) {
                        i &&
                          !i.destroyed &&
                          e.target === this &&
                          (i.$wrapperEl[0].removeEventListener(
                            "transitionend",
                            i.onSlideToWrapperTransitionEnd
                          ),
                          i.$wrapperEl[0].removeEventListener(
                            "webkitTransitionEnd",
                            i.onSlideToWrapperTransitionEnd
                          ),
                          (i.onSlideToWrapperTransitionEnd = null),
                          delete i.onSlideToWrapperTransitionEnd,
                          i.transitionEnd(n, f));
                      }),
                    i.$wrapperEl[0].addEventListener(
                      "transitionend",
                      i.onSlideToWrapperTransitionEnd
                    ),
                    i.$wrapperEl[0].addEventListener(
                      "webkitTransitionEnd",
                      i.onSlideToWrapperTransitionEnd
                    ))),
              !0
            );
          },
          slideToLoop: function (e, t, n, r) {
            void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0);
            return (
              this.params.loop && (e += this.loopedSlides),
              this.slideTo(e, t, n, r)
            );
          },
          slideNext: function (e, t, n) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var r = this.params,
              i = this.animating,
              o =
                this.activeIndex < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup;
            if (r.loop) {
              if (i) return !1;
              this.loopFix(),
                (this._clientLeft = this.$wrapperEl[0].clientLeft);
            }
            return this.slideTo(this.activeIndex + o, e, t, n);
          },
          slidePrev: function (e, t, n) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var r = this.params,
              i = this.animating,
              o = this.snapGrid,
              a = this.slidesGrid,
              s = this.rtlTranslate;
            if (r.loop) {
              if (i) return !1;
              this.loopFix(),
                (this._clientLeft = this.$wrapperEl[0].clientLeft);
            }
            function l(e) {
              return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            var c,
              u = l(s ? this.translate : -this.translate),
              s = o.map(l),
              d = (a.map(l), o[s.indexOf(u)], o[s.indexOf(u) - 1]);
            return (
              void 0 === d &&
                r.cssMode &&
                o.forEach(function (e) {
                  !d && e <= u && (d = e);
                }),
              void 0 !== d &&
                (c = a.indexOf(d)) < 0 &&
                (c = this.activeIndex - 1),
              this.slideTo(c, e, t, n)
            );
          },
          slideReset: function (e, t, n) {
            return (
              void 0 === e && (e = this.params.speed),
              void 0 === t && (t = !0),
              this.slideTo(this.activeIndex, e, t, n)
            );
          },
          slideToClosest: function (e, t, n, r) {
            void 0 === e && (e = this.params.speed),
              void 0 === t && (t = !0),
              void 0 === r && (r = 0.5);
            var i = this.activeIndex,
              o = Math.min(this.params.slidesPerGroupSkip, i),
              a = o + Math.floor((i - o) / this.params.slidesPerGroup),
              s = this.rtlTranslate ? this.translate : -this.translate;
            return (
              s >= this.snapGrid[a]
                ? s - (o = this.snapGrid[a]) > (this.snapGrid[a + 1] - o) * r &&
                  (i += this.params.slidesPerGroup)
                : s - (s = this.snapGrid[a - 1]) <=
                    (this.snapGrid[a] - s) * r &&
                  (i -= this.params.slidesPerGroup),
              (i = Math.max(i, 0)),
              (i = Math.min(i, this.slidesGrid.length - 1)),
              this.slideTo(i, e, t, n)
            );
          },
          slideToClickedSlide: function () {
            var e,
              t = this,
              n = t.params,
              r = t.$wrapperEl,
              i =
                "auto" === n.slidesPerView
                  ? t.slidesPerViewDynamic()
                  : n.slidesPerView,
              o = t.clickedIndex;
            n.loop
              ? t.animating ||
                ((e = parseInt(
                  E(t.clickedSlide).attr("data-pwzrswiper-slide-index"),
                  10
                )),
                n.centeredSlides
                  ? o < t.loopedSlides - i / 2 ||
                    o > t.slides.length - t.loopedSlides + i / 2
                    ? (t.loopFix(),
                      (o = r
                        .children(
                          "." +
                            n.slideClass +
                            '[data-pwzrswiper-slide-index="' +
                            e +
                            '"]:not(.' +
                            n.slideDuplicateClass +
                            ")"
                        )
                        .eq(0)
                        .index()),
                      Y.nextTick(function () {
                        t.slideTo(o);
                      }))
                    : t.slideTo(o)
                  : o > t.slides.length - i
                  ? (t.loopFix(),
                    (o = r
                      .children(
                        "." +
                          n.slideClass +
                          '[data-pwzrswiper-slide-index="' +
                          e +
                          '"]:not(.' +
                          n.slideDuplicateClass +
                          ")"
                      )
                      .eq(0)
                      .index()),
                    Y.nextTick(function () {
                      t.slideTo(o);
                    }))
                  : t.slideTo(o))
              : t.slideTo(o);
          },
        },
        C = {
          loopCreate: function () {
            var r = this,
              e = r.params,
              t = r.$wrapperEl;
            t.children(
              "." + e.slideClass + "." + e.slideDuplicateClass
            ).remove();
            var i = t.children("." + e.slideClass);
            if (e.loopFillGroupWithBlank) {
              var n = e.slidesPerGroup - (i.length % e.slidesPerGroup);
              if (n !== e.slidesPerGroup) {
                for (var o = 0; o < n; o += 1) {
                  var a = E(d.createElement("div")).addClass(
                    e.slideClass + " " + e.slideBlankClass
                  );
                  t.append(a);
                }
                i = t.children("." + e.slideClass);
              }
            }
            "auto" !== e.slidesPerView ||
              e.loopedSlides ||
              (e.loopedSlides = i.length),
              (r.loopedSlides = Math.ceil(
                parseFloat(e.loopedSlides || e.slidesPerView, 10)
              )),
              (r.loopedSlides += e.loopAdditionalSlides),
              r.loopedSlides > i.length && (r.loopedSlides = i.length);
            var s = [],
              l = [];
            i.each(function (e, t) {
              var n = E(t);
              e < r.loopedSlides && l.push(t),
                e < i.length && e >= i.length - r.loopedSlides && s.push(t),
                n.attr("data-pwzrswiper-slide-index", e);
            });
            for (var c = 0; c < l.length; c += 1)
              t.append(E(l[c].cloneNode(!0)).addClass(e.slideDuplicateClass));
            for (var u = s.length - 1; 0 <= u; --u)
              t.prepend(E(s[u].cloneNode(!0)).addClass(e.slideDuplicateClass));
          },
          loopFix: function () {
            this.emit("beforeLoopFix");
            var e,
              t = this.activeIndex,
              n = this.slides,
              r = this.loopedSlides,
              i = this.allowSlidePrev,
              o = this.allowSlideNext,
              a = this.snapGrid,
              s = this.rtlTranslate;
            (this.allowSlidePrev = !0), (this.allowSlideNext = !0);
            a = -a[t] - this.getTranslate();
            t < r
              ? ((e = n.length - 3 * r + t),
                (e += r),
                this.slideTo(e, 0, !1, !0) &&
                  0 != a &&
                  this.setTranslate((s ? -this.translate : this.translate) - a))
              : t >= n.length - r &&
                ((e = -n.length + t + r),
                (e += r),
                this.slideTo(e, 0, !1, !0) &&
                  0 != a &&
                  this.setTranslate(
                    (s ? -this.translate : this.translate) - a
                  )),
              (this.allowSlidePrev = i),
              (this.allowSlideNext = o),
              this.emit("loopFix");
          },
          loopDestroy: function () {
            var e = this.$wrapperEl,
              t = this.params,
              n = this.slides;
            e
              .children(
                "." +
                  t.slideClass +
                  "." +
                  t.slideDuplicateClass +
                  ",." +
                  t.slideClass +
                  "." +
                  t.slideBlankClass
              )
              .remove(),
              n.removeAttr("data-pwzrswiper-slide-index");
          },
        },
        k = {
          setGrabCursor: function (e) {
            var t;
            w.touch ||
              !this.params.simulateTouch ||
              (this.params.watchOverflow && this.isLocked) ||
              this.params.cssMode ||
              (((t = this.el).style.cursor = "move"),
              (t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
              (t.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
              (t.style.cursor = e ? "grabbing" : "grab"));
          },
          unsetGrabCursor: function () {
            w.touch ||
              (this.params.watchOverflow && this.isLocked) ||
              this.params.cssMode ||
              (this.el.style.cursor = "");
          },
        },
        T = {
          appendSlide: function (e) {
            var t = this.$wrapperEl,
              n = this.params;
            if (
              (n.loop && this.loopDestroy(),
              "object" === oC(e) && "length" in e)
            )
              for (var r = 0; r < e.length; r += 1) e[r] && t.append(e[r]);
            else t.append(e);
            n.loop && this.loopCreate(),
              (n.observer && w.observer) || this.update();
          },
          prependSlide: function (e) {
            var t = this.params,
              n = this.$wrapperEl,
              r = this.activeIndex;
            t.loop && this.loopDestroy();
            var i = r + 1;
            if ("object" === oC(e) && "length" in e) {
              for (var o = 0; o < e.length; o += 1) e[o] && n.prepend(e[o]);
              i = r + e.length;
            } else n.prepend(e);
            t.loop && this.loopCreate(),
              (t.observer && w.observer) || this.update(),
              this.slideTo(i, 0, !1);
          },
          addSlide: function (e, t) {
            var n = this.$wrapperEl,
              r = this.params,
              i = this.activeIndex;
            r.loop &&
              ((i -= this.loopedSlides),
              this.loopDestroy(),
              (this.slides = n.children("." + r.slideClass)));
            var o = this.slides.length;
            if (e <= 0) this.prependSlide(t);
            else if (o <= e) this.appendSlide(t);
            else {
              for (var a = e < i ? i + 1 : i, s = [], l = o - 1; e <= l; --l) {
                var c = this.slides.eq(l);
                c.remove(), s.unshift(c);
              }
              if ("object" === oC(t) && "length" in t) {
                for (var u = 0; u < t.length; u += 1) t[u] && n.append(t[u]);
                a = e < i ? i + t.length : i;
              } else n.append(t);
              for (var d = 0; d < s.length; d += 1) n.append(s[d]);
              r.loop && this.loopCreate(),
                (r.observer && w.observer) || this.update(),
                r.loop
                  ? this.slideTo(a + this.loopedSlides, 0, !1)
                  : this.slideTo(a, 0, !1);
            }
          },
          removeSlide: function (e) {
            var t = this.params,
              n = this.$wrapperEl,
              r = this.activeIndex;
            t.loop &&
              ((r -= this.loopedSlides),
              this.loopDestroy(),
              (this.slides = n.children("." + t.slideClass)));
            var i,
              o = r;
            if ("object" === oC(e) && "length" in e) {
              for (var a = 0; a < e.length; a += 1)
                (i = e[a]),
                  this.slides[i] && this.slides.eq(i).remove(),
                  i < o && --o;
              o = Math.max(o, 0);
            } else
              (i = e),
                this.slides[i] && this.slides.eq(i).remove(),
                i < o && --o,
                (o = Math.max(o, 0));
            t.loop && this.loopCreate(),
              (t.observer && w.observer) || this.update(),
              t.loop
                ? this.slideTo(o + this.loopedSlides, 0, !1)
                : this.slideTo(o, 0, !1);
          },
          removeAllSlides: function () {
            for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
            this.removeSlide(e);
          },
        },
        P =
          ((r = G.navigator.platform),
          (i = G.navigator.userAgent),
          (a = {
            ios: !1,
            android: !1,
            androidChrome: !1,
            desktop: !1,
            iphone: !1,
            ipod: !1,
            ipad: !1,
            edge: !1,
            ie: !1,
            firefox: !1,
            macos: !1,
            windows: !1,
            cordova: !(!G.cordova && !G.phonegap),
            phonegap: !(!G.cordova && !G.phonegap),
            electron: !1,
          }),
          (s = G.screen.width),
          (c = G.screen.height),
          (u = i.match(/(Android);?[\s\/]+([\d.]+)?/)),
          (p = i.match(/(iPad).*OS\s([\d_]+)/)),
          (f = i.match(/(iPod)(.*OS\s([\d_]+))?/)),
          (h = !p && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/)),
          (m = 0 <= i.indexOf("MSIE ") || 0 <= i.indexOf("Trident/")),
          (g = 0 <= i.indexOf("Edge/")),
          (v = 0 <= i.indexOf("Gecko/") && 0 <= i.indexOf("Firefox/")),
          (y = "Win32" === r),
          (n = 0 <= i.toLowerCase().indexOf("electron")),
          (r = "MacIntel" === r),
          !p &&
            r &&
            w.touch &&
            ((1024 === s && 1366 === c) ||
              (834 === s && 1194 === c) ||
              (834 === s && 1112 === c) ||
              (768 === s && 1024 === c)) &&
            ((p = i.match(/(Version)\/([\d.]+)/)), (r = !1)),
          (a.ie = m),
          (a.edge = g),
          (a.firefox = v),
          u &&
            !y &&
            ((a.os = "android"),
            (a.osVersion = u[2]),
            (a.android = !0),
            (a.androidChrome = 0 <= i.toLowerCase().indexOf("chrome"))),
          (p || h || f) && ((a.os = "ios"), (a.ios = !0)),
          h && !f && ((a.osVersion = h[2].replace(/_/g, ".")), (a.iphone = !0)),
          p && ((a.osVersion = p[2].replace(/_/g, ".")), (a.ipad = !0)),
          f &&
            ((a.osVersion = f[3] ? f[3].replace(/_/g, ".") : null),
            (a.ipod = !0)),
          a.ios &&
            a.osVersion &&
            0 <= i.indexOf("Version/") &&
            "10" === a.osVersion.split(".")[0] &&
            (a.osVersion = i.toLowerCase().split("version/")[1].split(" ")[0]),
          (a.webView =
            !(
              !(h || p || f) ||
              (!i.match(/.*AppleWebKit(?!.*Safari)/i) &&
                !G.navigator.standalone)
            ) ||
            (G.matchMedia &&
              G.matchMedia("(display-mode: standalone)").matches)),
          (a.webview = a.webView),
          (a.standalone = a.webView),
          (a.desktop = !(a.ios || a.android) || n),
          a.desktop &&
            ((a.electron = n),
            (a.macos = r),
            (a.windows = y),
            a.macos && (a.os = "macos"),
            a.windows && (a.os = "windows")),
          (a.pixelRatio = G.devicePixelRatio || 1),
          a);
      function z() {
        var e,
          t,
          n = this.params,
          r = this.el;
        (r && 0 === r.offsetWidth) ||
          (n.breakpoints && this.setBreakpoint(),
          (e = this.allowSlideNext),
          (t = this.allowSlidePrev),
          (r = this.snapGrid),
          (this.allowSlideNext = !0),
          (this.allowSlidePrev = !0),
          this.updateSize(),
          this.updateSlides(),
          this.updateSlidesClasses(),
          ("auto" === n.slidesPerView || 1 < n.slidesPerView) &&
          this.isEnd &&
          !this.params.centeredSlides
            ? this.slideTo(this.slides.length - 1, 0, !1, !0)
            : this.slideTo(this.activeIndex, 0, !1, !0),
          this.autoplay &&
            this.autoplay.running &&
            this.autoplay.paused &&
            this.autoplay.run(),
          (this.allowSlidePrev = t),
          (this.allowSlideNext = e),
          this.params.watchOverflow &&
            r !== this.snapGrid &&
            this.checkOverflow());
      }
      var O = !1;
      function R() {}
      var M = {
          init: !0,
          direction: "horizontal",
          touchEventsTarget: "container",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          preventInteractionOnTransition: !1,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          freeMode: !1,
          freeModeMomentum: !0,
          freeModeMomentumRatio: 1,
          freeModeMomentumBounce: !0,
          freeModeMomentumBounceRatio: 1,
          freeModeMomentumVelocityRatio: 1,
          freeModeSticky: !1,
          freeModeMinimumVelocity: 0.02,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerColumnFill: "column",
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !1,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 0,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          watchSlidesVisibility: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          preloadImages: !0,
          updateOnImagesReady: !0,
          loop: !1,
          loopAdditionalSlides: 0,
          loopedSlides: null,
          loopFillGroupWithBlank: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "pwzrswiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          containerModifierClass: "pwzrswiper-container-",
          slideClass: "pwzrswiper-slide",
          slideBlankClass: "pwzrswiper-slide-invisible-blank",
          slideActiveClass: "pwzrswiper-slide-active",
          slideDuplicateActiveClass: "pwzrswiper-slide-duplicate-active",
          slideVisibleClass: "pwzrswiper-slide-visible",
          slideDuplicateClass: "pwzrswiper-slide-duplicate",
          slideNextClass: "pwzrswiper-slide-next",
          slideDuplicateNextClass: "pwzrswiper-slide-duplicate-next",
          slidePrevClass: "pwzrswiper-slide-prev",
          slideDuplicatePrevClass: "pwzrswiper-slide-duplicate-prev",
          wrapperClass: "pwzrswiper-wrapper",
          runCallbacksOnInit: !0,
        },
        N = {
          update: b,
          translate: x,
          transition: {
            setTransition: function (e, t) {
              this.params.cssMode || this.$wrapperEl.transition(e),
                this.emit("setTransition", e, t);
            },
            transitionStart: function (e, t) {
              void 0 === e && (e = !0);
              var n = this.activeIndex,
                r = this.params,
                i = this.previousIndex;
              r.cssMode ||
                (r.autoHeight && this.updateAutoHeight(),
                (t = (t = t) || (i < n ? "next" : n < i ? "prev" : "reset")),
                this.emit("transitionStart"),
                e &&
                  n !== i &&
                  ("reset" !== t
                    ? (this.emit("slideChangeTransitionStart"),
                      "next" === t
                        ? this.emit("slideNextTransitionStart")
                        : this.emit("slidePrevTransitionStart"))
                    : this.emit("slideResetTransitionStart")));
            },
            transitionEnd: function (e, t) {
              void 0 === e && (e = !0);
              var n = this.activeIndex,
                r = this.previousIndex,
                i = this.params;
              (this.animating = !1),
                i.cssMode ||
                  (this.setTransition(0),
                  (t = (t = t) || (r < n ? "next" : n < r ? "prev" : "reset")),
                  this.emit("transitionEnd"),
                  e &&
                    n !== r &&
                    ("reset" !== t
                      ? (this.emit("slideChangeTransitionEnd"),
                        "next" === t
                          ? this.emit("slideNextTransitionEnd")
                          : this.emit("slidePrevTransitionEnd"))
                      : this.emit("slideResetTransitionEnd")));
            },
          },
          slide: S,
          loop: C,
          grabCursor: k,
          manipulation: T,
          events: {
            attachEvents: function () {
              var e = this.params,
                t = this.touchEvents,
                n = this.el,
                r = this.wrapperEl;
              (this.onTouchStart = function (e) {
                var t,
                  n,
                  r,
                  i,
                  o,
                  a = this.touchEventsData,
                  s = this.params,
                  l = this.touches;
                (this.animating && s.preventInteractionOnTransition) ||
                  ((t = e).originalEvent && (t = t.originalEvent),
                  (n = E(t.target)),
                  ("wrapper" === s.touchEventsTarget &&
                    !n.closest(this.wrapperEl).length) ||
                    ((a.isTouchEvent = "touchstart" === t.type),
                    (!a.isTouchEvent && "which" in t && 3 === t.which) ||
                      (!a.isTouchEvent && "button" in t && 0 < t.button) ||
                      (a.isTouched && a.isMoved)) ||
                    (s.noSwiping &&
                    n.closest(s.noSwipingSelector || "." + s.noSwipingClass)[0]
                      ? (this.allowClick = !0)
                      : (s.swipeHandler && !n.closest(s.swipeHandler)[0]) ||
                        ((l.currentX = ("touchstart" === t.type
                          ? t.targetTouches[0]
                          : t
                        ).pageX),
                        (l.currentY = ("touchstart" === t.type
                          ? t.targetTouches[0]
                          : t
                        ).pageY),
                        (r = l.currentX),
                        (o = l.currentY),
                        (i = s.edgeSwipeDetection || s.iOSEdgeSwipeDetection),
                        (e = s.edgeSwipeThreshold || s.iOSEdgeSwipeThreshold),
                        (i && (r <= e || r >= G.screen.width - e)) ||
                          (Y.extend(a, {
                            isTouched: !0,
                            isMoved: !1,
                            allowTouchCallbacks: !0,
                            isScrolling: void 0,
                            startMoving: void 0,
                          }),
                          (l.startX = r),
                          (l.startY = o),
                          (a.touchStartTime = Y.now()),
                          (this.allowClick = !0),
                          this.updateSize(),
                          (this.swipeDirection = void 0),
                          0 < s.threshold && (a.allowThresholdMove = !1),
                          "touchstart" !== t.type &&
                            ((o = !0),
                            n.is(a.formElements) && (o = !1),
                            d.activeElement &&
                              E(d.activeElement).is(a.formElements) &&
                              d.activeElement !== n[0] &&
                              d.activeElement.blur(),
                            (o =
                              o &&
                              this.allowTouchMove &&
                              s.touchStartPreventDefault),
                            (s.touchStartForcePreventDefault || o) &&
                              t.preventDefault()),
                          this.emit("touchStart", t)))));
              }.bind(this)),
                (this.onTouchMove = function (e) {
                  var t = this.touchEventsData,
                    n = this.params,
                    r = this.touches,
                    i = this.rtlTranslate,
                    o = e;
                  if ((o.originalEvent && (o = o.originalEvent), t.isTouched)) {
                    if (!t.isTouchEvent || "mousemove" !== o.type) {
                      var a =
                          "touchmove" === o.type &&
                          o.targetTouches &&
                          (o.targetTouches[0] || o.changedTouches[0]),
                        s = ("touchmove" === o.type ? a : o).pageX,
                        e = ("touchmove" === o.type ? a : o).pageY;
                      if (o.preventedByNestedSwiper)
                        return (r.startX = s), void (r.startY = e);
                      if (!this.allowTouchMove)
                        return (
                          (this.allowClick = !1),
                          void (
                            t.isTouched &&
                            (Y.extend(r, {
                              startX: s,
                              startY: e,
                              currentX: s,
                              currentY: e,
                            }),
                            (t.touchStartTime = Y.now()))
                          )
                        );
                      if (t.isTouchEvent && n.touchReleaseOnEdges && !n.loop)
                        if (this.isVertical()) {
                          if (
                            (e < r.startY &&
                              this.translate <= this.maxTranslate()) ||
                            (e > r.startY &&
                              this.translate >= this.minTranslate())
                          )
                            return (t.isTouched = !1), void (t.isMoved = !1);
                        } else if (
                          (s < r.startX &&
                            this.translate <= this.maxTranslate()) ||
                          (s > r.startX &&
                            this.translate >= this.minTranslate())
                        )
                          return;
                      if (
                        t.isTouchEvent &&
                        d.activeElement &&
                        o.target === d.activeElement &&
                        E(o.target).is(t.formElements)
                      )
                        return (t.isMoved = !0), void (this.allowClick = !1);
                      if (
                        (t.allowTouchCallbacks && this.emit("touchMove", o),
                        !(o.targetTouches && 1 < o.targetTouches.length))
                      ) {
                        (r.currentX = s), (r.currentY = e);
                        (a = r.currentX - r.startX),
                          (s = r.currentY - r.startY);
                        if (
                          !(
                            this.params.threshold &&
                            Math.sqrt(Math.pow(a, 2) + Math.pow(s, 2)) <
                              this.params.threshold
                          )
                        )
                          if (
                            (void 0 === t.isScrolling &&
                              ((this.isHorizontal() &&
                                r.currentY === r.startY) ||
                              (this.isVertical() && r.currentX === r.startX)
                                ? (t.isScrolling = !1)
                                : 25 <= a * a + s * s &&
                                  ((e =
                                    (180 *
                                      Math.atan2(Math.abs(s), Math.abs(a))) /
                                    Math.PI),
                                  (t.isScrolling = this.isHorizontal()
                                    ? e > n.touchAngle
                                    : 90 - e > n.touchAngle))),
                            t.isScrolling && this.emit("touchMoveOpposite", o),
                            void 0 === t.startMoving &&
                              ((r.currentX === r.startX &&
                                r.currentY === r.startY) ||
                                (t.startMoving = !0)),
                            t.isScrolling)
                          )
                            t.isTouched = !1;
                          else if (t.startMoving) {
                            (this.allowClick = !1),
                              n.cssMode || o.preventDefault(),
                              n.touchMoveStopPropagation &&
                                !n.nested &&
                                o.stopPropagation(),
                              t.isMoved ||
                                (n.loop && this.loopFix(),
                                (t.startTranslate = this.getTranslate()),
                                this.setTransition(0),
                                this.animating &&
                                  this.$wrapperEl.trigger(
                                    "webkitTransitionEnd transitionend"
                                  ),
                                (t.allowMomentumBounce = !1),
                                !n.grabCursor ||
                                  (!0 !== this.allowSlideNext &&
                                    !0 !== this.allowSlidePrev) ||
                                  this.setGrabCursor(!0),
                                this.emit("sliderFirstMove", o)),
                              this.emit("sliderMove", o),
                              (t.isMoved = !0);
                            a = this.isHorizontal() ? a : s;
                            (r.diff = a),
                              (a *= n.touchRatio),
                              i && (a = -a),
                              (this.swipeDirection = 0 < a ? "prev" : "next"),
                              (t.currentTranslate = a + t.startTranslate);
                            (s = !0), (i = n.resistanceRatio);
                            if (
                              (n.touchReleaseOnEdges && (i = 0),
                              0 < a && t.currentTranslate > this.minTranslate()
                                ? ((s = !1),
                                  n.resistance &&
                                    (t.currentTranslate =
                                      this.minTranslate() -
                                      1 +
                                      Math.pow(
                                        -this.minTranslate() +
                                          t.startTranslate +
                                          a,
                                        i
                                      )))
                                : a < 0 &&
                                  t.currentTranslate < this.maxTranslate() &&
                                  ((s = !1),
                                  n.resistance &&
                                    (t.currentTranslate =
                                      this.maxTranslate() +
                                      1 -
                                      Math.pow(
                                        this.maxTranslate() -
                                          t.startTranslate -
                                          a,
                                        i
                                      ))),
                              s && (o.preventedByNestedSwiper = !0),
                              !this.allowSlideNext &&
                                "next" === this.swipeDirection &&
                                t.currentTranslate < t.startTranslate &&
                                (t.currentTranslate = t.startTranslate),
                              !this.allowSlidePrev &&
                                "prev" === this.swipeDirection &&
                                t.currentTranslate > t.startTranslate &&
                                (t.currentTranslate = t.startTranslate),
                              0 < n.threshold)
                            ) {
                              if (
                                !(
                                  Math.abs(a) > n.threshold ||
                                  t.allowThresholdMove
                                )
                              )
                                return void (t.currentTranslate =
                                  t.startTranslate);
                              if (!t.allowThresholdMove)
                                return (
                                  (t.allowThresholdMove = !0),
                                  (r.startX = r.currentX),
                                  (r.startY = r.currentY),
                                  (t.currentTranslate = t.startTranslate),
                                  void (r.diff = this.isHorizontal()
                                    ? r.currentX - r.startX
                                    : r.currentY - r.startY)
                                );
                            }
                            n.followFinger &&
                              !n.cssMode &&
                              ((n.freeMode ||
                                n.watchSlidesProgress ||
                                n.watchSlidesVisibility) &&
                                (this.updateActiveIndex(),
                                this.updateSlidesClasses()),
                              n.freeMode &&
                                (0 === t.velocities.length &&
                                  t.velocities.push({
                                    position:
                                      r[
                                        this.isHorizontal()
                                          ? "startX"
                                          : "startY"
                                      ],
                                    time: t.touchStartTime,
                                  }),
                                t.velocities.push({
                                  position:
                                    r[
                                      this.isHorizontal()
                                        ? "currentX"
                                        : "currentY"
                                    ],
                                  time: Y.now(),
                                })),
                              this.updateProgress(t.currentTranslate),
                              this.setTranslate(t.currentTranslate));
                          }
                      }
                    }
                  } else
                    t.startMoving &&
                      t.isScrolling &&
                      this.emit("touchMoveOpposite", o);
                }.bind(this)),
                (this.onTouchEnd = function (e) {
                  var t = this,
                    n = t.touchEventsData,
                    r = t.params,
                    i = t.touches,
                    o = t.rtlTranslate,
                    a = t.$wrapperEl,
                    s = t.slidesGrid,
                    l = t.snapGrid,
                    c = e;
                  if (
                    (c.originalEvent && (c = c.originalEvent),
                    n.allowTouchCallbacks && t.emit("touchEnd", c),
                    (n.allowTouchCallbacks = !1),
                    !n.isTouched)
                  )
                    return (
                      n.isMoved && r.grabCursor && t.setGrabCursor(!1),
                      (n.isMoved = !1),
                      void (n.startMoving = !1)
                    );
                  r.grabCursor &&
                    n.isMoved &&
                    n.isTouched &&
                    (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
                    t.setGrabCursor(!1);
                  var u,
                    d = Y.now(),
                    e = d - n.touchStartTime;
                  if (
                    (t.allowClick &&
                      (t.updateClickedSlide(c),
                      t.emit("tap click", c),
                      e < 300 &&
                        d - n.lastClickTime < 300 &&
                        t.emit("doubleTap doubleClick", c)),
                    (n.lastClickTime = Y.now()),
                    Y.nextTick(function () {
                      t.destroyed || (t.allowClick = !0);
                    }),
                    !n.isTouched ||
                      !n.isMoved ||
                      !t.swipeDirection ||
                      0 === i.diff ||
                      n.currentTranslate === n.startTranslate)
                  )
                    return (
                      (n.isTouched = !1),
                      (n.isMoved = !1),
                      void (n.startMoving = !1)
                    );
                  if (
                    ((n.isTouched = !1),
                    (n.isMoved = !1),
                    (n.startMoving = !1),
                    (u = r.followFinger
                      ? o
                        ? t.translate
                        : -t.translate
                      : -n.currentTranslate),
                    !r.cssMode)
                  )
                    if (r.freeMode)
                      if (u < -t.minTranslate()) t.slideTo(t.activeIndex);
                      else if (u > -t.maxTranslate())
                        t.slides.length < l.length
                          ? t.slideTo(l.length - 1)
                          : t.slideTo(t.slides.length - 1);
                      else {
                        if (r.freeModeMomentum) {
                          1 < n.velocities.length
                            ? ((v = n.velocities.pop()),
                              (f = n.velocities.pop()),
                              (p = v.position - f.position),
                              (f = v.time - f.time),
                              (t.velocity = p / f),
                              (t.velocity /= 2),
                              Math.abs(t.velocity) <
                                r.freeModeMinimumVelocity && (t.velocity = 0),
                              (150 < f || 300 < Y.now() - v.time) &&
                                (t.velocity = 0))
                            : (t.velocity = 0),
                            (t.velocity *= r.freeModeMomentumVelocityRatio),
                            (n.velocities.length = 0);
                          var p = 1e3 * r.freeModeMomentumRatio,
                            f = t.velocity * p,
                            h = t.translate + f;
                          o && (h = -h);
                          var m,
                            g,
                            v = !1,
                            f =
                              20 *
                              Math.abs(t.velocity) *
                              r.freeModeMomentumBounceRatio;
                          if (h < t.maxTranslate())
                            r.freeModeMomentumBounce
                              ? (h + t.maxTranslate() < -f &&
                                  (h = t.maxTranslate() - f),
                                (m = t.maxTranslate()),
                                (v = !0),
                                (n.allowMomentumBounce = !0))
                              : (h = t.maxTranslate()),
                              r.loop && r.centeredSlides && (g = !0);
                          else if (h > t.minTranslate())
                            r.freeModeMomentumBounce
                              ? (h - t.minTranslate() > f &&
                                  (h = t.minTranslate() + f),
                                (m = t.minTranslate()),
                                (v = !0),
                                (n.allowMomentumBounce = !0))
                              : (h = t.minTranslate()),
                              r.loop && r.centeredSlides && (g = !0);
                          else if (r.freeModeSticky) {
                            for (var y, b = 0; b < l.length; b += 1)
                              if (l[b] > -h) {
                                y = b;
                                break;
                              }
                            h = -(Math.abs(l[y] - h) < Math.abs(l[y - 1] - h) ||
                            "next" === t.swipeDirection
                              ? l[y]
                              : l[y - 1]);
                          }
                          if (
                            (g &&
                              t.once("transitionEnd", function () {
                                t.loopFix();
                              }),
                            0 !== t.velocity)
                          )
                            (p = o
                              ? Math.abs((-h - t.translate) / t.velocity)
                              : Math.abs((h - t.translate) / t.velocity)),
                              r.freeModeSticky &&
                                (p =
                                  (g = Math.abs((o ? -h : h) - t.translate)) <
                                  (o = t.slidesSizesGrid[t.activeIndex])
                                    ? r.speed
                                    : g < 2 * o
                                    ? 1.5 * r.speed
                                    : 2.5 * r.speed);
                          else if (r.freeModeSticky)
                            return void t.slideToClosest();
                          r.freeModeMomentumBounce && v
                            ? (t.updateProgress(m),
                              t.setTransition(p),
                              t.setTranslate(h),
                              t.transitionStart(!0, t.swipeDirection),
                              (t.animating = !0),
                              a.transitionEnd(function () {
                                t &&
                                  !t.destroyed &&
                                  n.allowMomentumBounce &&
                                  (t.emit("momentumBounce"),
                                  t.setTransition(r.speed),
                                  t.setTranslate(m),
                                  a.transitionEnd(function () {
                                    t && !t.destroyed && t.transitionEnd();
                                  }));
                              }))
                            : t.velocity
                            ? (t.updateProgress(h),
                              t.setTransition(p),
                              t.setTranslate(h),
                              t.transitionStart(!0, t.swipeDirection),
                              t.animating ||
                                ((t.animating = !0),
                                a.transitionEnd(function () {
                                  t && !t.destroyed && t.transitionEnd();
                                })))
                            : t.updateProgress(h),
                            t.updateActiveIndex(),
                            t.updateSlidesClasses();
                        } else if (r.freeModeSticky)
                          return void t.slideToClosest();
                        (!r.freeModeMomentum || e >= r.longSwipesMs) &&
                          (t.updateProgress(),
                          t.updateActiveIndex(),
                          t.updateSlidesClasses());
                      }
                    else {
                      for (
                        var w = 0, x = t.slidesSizesGrid[0], E = 0;
                        E < s.length;
                        E += E < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup
                      ) {
                        var S =
                          E < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
                        void 0 !== s[E + S]
                          ? u >= s[E] &&
                            u < s[E + S] &&
                            (x = s[(w = E) + S] - s[E])
                          : u >= s[E] &&
                            ((w = E), (x = s[s.length - 1] - s[s.length - 2]));
                      }
                      (v = (u - s[w]) / x),
                        (p =
                          w < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup);
                      e > r.longSwipesMs
                        ? r.longSwipes
                          ? ("next" === t.swipeDirection &&
                              (v >= r.longSwipesRatio
                                ? t.slideTo(w + p)
                                : t.slideTo(w)),
                            "prev" === t.swipeDirection &&
                              (v > 1 - r.longSwipesRatio
                                ? t.slideTo(w + p)
                                : t.slideTo(w)))
                          : t.slideTo(t.activeIndex)
                        : r.shortSwipes
                        ? !t.navigation ||
                          (c.target !== t.navigation.nextEl &&
                            c.target !== t.navigation.prevEl)
                          ? ("next" === t.swipeDirection && t.slideTo(w + p),
                            "prev" === t.swipeDirection && t.slideTo(w))
                          : c.target === t.navigation.nextEl
                          ? t.slideTo(w + p)
                          : t.slideTo(w)
                        : t.slideTo(t.activeIndex);
                    }
                }.bind(this)),
                e.cssMode &&
                  (this.onScroll = function () {
                    var e = this.wrapperEl;
                    (this.previousTranslate = this.translate),
                      (this.translate = this.isHorizontal()
                        ? -e.scrollLeft
                        : -e.scrollTop),
                      -0 === this.translate && (this.translate = 0),
                      this.updateActiveIndex(),
                      this.updateSlidesClasses(),
                      (0 == (e = this.maxTranslate() - this.minTranslate())
                        ? 0
                        : (this.translate - this.minTranslate()) / e) !==
                        this.progress && this.updateProgress(this.translate),
                      this.emit("setTranslate", this.translate, !1);
                  }.bind(this)),
                (this.onClick = function (e) {
                  this.allowClick ||
                    (this.params.preventClicks && e.preventDefault(),
                    this.params.preventClicksPropagation &&
                      this.animating &&
                      (e.stopPropagation(), e.stopImmediatePropagation()));
                }.bind(this));
              var i,
                o = !!e.nested;
              !w.touch && w.pointerEvents
                ? (n.addEventListener(t.start, this.onTouchStart, !1),
                  d.addEventListener(t.move, this.onTouchMove, o),
                  d.addEventListener(t.end, this.onTouchEnd, !1))
                : (w.touch &&
                    ((i = !(
                      "touchstart" !== t.start ||
                      !w.passiveListener ||
                      !e.passiveListeners
                    ) && { passive: !0, capture: !1 }),
                    n.addEventListener(t.start, this.onTouchStart, i),
                    n.addEventListener(
                      t.move,
                      this.onTouchMove,
                      w.passiveListener ? { passive: !1, capture: o } : o
                    ),
                    n.addEventListener(t.end, this.onTouchEnd, i),
                    t.cancel &&
                      n.addEventListener(t.cancel, this.onTouchEnd, i),
                    O || (d.addEventListener("touchstart", R), (O = !0))),
                  ((e.simulateTouch && !P.ios && !P.android) ||
                    (e.simulateTouch && !w.touch && P.ios)) &&
                    (n.addEventListener("mousedown", this.onTouchStart, !1),
                    d.addEventListener("mousemove", this.onTouchMove, o),
                    d.addEventListener("mouseup", this.onTouchEnd, !1))),
                (e.preventClicks || e.preventClicksPropagation) &&
                  n.addEventListener("click", this.onClick, !0),
                e.cssMode && r.addEventListener("scroll", this.onScroll),
                e.updateOnWindowResize
                  ? this.on(
                      P.ios || P.android
                        ? "resize orientationchange observerUpdate"
                        : "resize observerUpdate",
                      z,
                      !0
                    )
                  : this.on("observerUpdate", z, !0);
            },
            detachEvents: function () {
              var e,
                t = this.params,
                n = this.touchEvents,
                r = this.el,
                i = this.wrapperEl,
                o = !!t.nested;
              !w.touch && w.pointerEvents
                ? (r.removeEventListener(n.start, this.onTouchStart, !1),
                  d.removeEventListener(n.move, this.onTouchMove, o),
                  d.removeEventListener(n.end, this.onTouchEnd, !1))
                : (w.touch &&
                    ((e = !(
                      "onTouchStart" !== n.start ||
                      !w.passiveListener ||
                      !t.passiveListeners
                    ) && { passive: !0, capture: !1 }),
                    r.removeEventListener(n.start, this.onTouchStart, e),
                    r.removeEventListener(n.move, this.onTouchMove, o),
                    r.removeEventListener(n.end, this.onTouchEnd, e),
                    n.cancel &&
                      r.removeEventListener(n.cancel, this.onTouchEnd, e)),
                  ((t.simulateTouch && !P.ios && !P.android) ||
                    (t.simulateTouch && !w.touch && P.ios)) &&
                    (r.removeEventListener("mousedown", this.onTouchStart, !1),
                    d.removeEventListener("mousemove", this.onTouchMove, o),
                    d.removeEventListener("mouseup", this.onTouchEnd, !1))),
                (t.preventClicks || t.preventClicksPropagation) &&
                  r.removeEventListener("click", this.onClick, !0),
                t.cssMode && i.removeEventListener("scroll", this.onScroll),
                this.off(
                  P.ios || P.android
                    ? "resize orientationchange observerUpdate"
                    : "resize observerUpdate",
                  z
                );
            },
          },
          breakpoints: {
            setBreakpoint: function () {
              var e = this.activeIndex,
                t = this.initialized,
                n = this.loopedSlides;
              void 0 === n && (n = 0);
              var r,
                i,
                o,
                a,
                s = this.params,
                l = this.$el,
                c = s.breakpoints;
              !c ||
                (c && 0 === Object.keys(c).length) ||
                ((r = this.getBreakpoint(c)) &&
                  this.currentBreakpoint !== r &&
                  ((i = r in c ? c[r] : void 0) &&
                    [
                      "slidesPerView",
                      "spaceBetween",
                      "slidesPerGroup",
                      "slidesPerGroupSkip",
                      "slidesPerColumn",
                    ].forEach(function (e) {
                      var t = i[e];
                      void 0 !== t &&
                        (i[e] =
                          "slidesPerView" !== e ||
                          ("AUTO" !== t && "auto" !== t)
                            ? "slidesPerView" === e
                              ? parseFloat(t)
                              : parseInt(t, 10)
                            : "auto");
                    }),
                  (o = i || this.originalParams),
                  (a = 1 < s.slidesPerColumn),
                  (c = 1 < o.slidesPerColumn),
                  a && !c
                    ? l.removeClass(
                        s.containerModifierClass +
                          "multirow " +
                          s.containerModifierClass +
                          "multirow-column"
                      )
                    : !a &&
                      c &&
                      (l.addClass(s.containerModifierClass + "multirow"),
                      "column" === o.slidesPerColumnFill &&
                        l.addClass(
                          s.containerModifierClass + "multirow-column"
                        )),
                  (l = o.direction && o.direction !== s.direction),
                  (s = s.loop && (o.slidesPerView !== s.slidesPerView || l)),
                  l && t && this.changeDirection(),
                  Y.extend(this.params, o),
                  Y.extend(this, {
                    allowTouchMove: this.params.allowTouchMove,
                    allowSlideNext: this.params.allowSlideNext,
                    allowSlidePrev: this.params.allowSlidePrev,
                  }),
                  (this.currentBreakpoint = r),
                  s &&
                    t &&
                    (this.loopDestroy(),
                    this.loopCreate(),
                    this.updateSlides(),
                    this.slideTo(e - n + this.loopedSlides, 0, !1)),
                  this.emit("breakpoint", o)));
            },
            getBreakpoint: function (e) {
              if (e) {
                var t = !1,
                  n = Object.keys(e).map(function (e) {
                    if ("string" == typeof e && e.startsWith("@")) {
                      var t = parseFloat(e.substr(1));
                      return { value: G.innerHeight * t, point: e };
                    }
                    return { value: e, point: e };
                  });
                n.sort(function (e, t) {
                  return parseInt(e.value, 10) - parseInt(t.value, 10);
                });
                for (var r = 0; r < n.length; r += 1) {
                  var i = n[r],
                    o = i.point;
                  i.value <= G.innerWidth && (t = o);
                }
                return t || "max";
              }
            },
          },
          checkOverflow: {
            checkOverflow: function () {
              var e = this.params,
                t = this.isLocked,
                n =
                  0 < this.slides.length &&
                  e.slidesOffsetBefore +
                    e.spaceBetween * (this.slides.length - 1) +
                    this.slides[0].offsetWidth * this.slides.length;
              e.slidesOffsetBefore && e.slidesOffsetAfter && n
                ? (this.isLocked = n <= this.size)
                : (this.isLocked = 1 === this.snapGrid.length),
                (this.allowSlideNext = !this.isLocked),
                (this.allowSlidePrev = !this.isLocked),
                t !== this.isLocked &&
                  this.emit(this.isLocked ? "lock" : "unlock"),
                t &&
                  t !== this.isLocked &&
                  ((this.isEnd = !1), this.navigation.update());
            },
          },
          classes: {
            addClasses: function () {
              var t = this.classNames,
                n = this.params,
                e = this.rtl,
                r = this.$el,
                i = [];
              i.push("initialized"),
                i.push(n.direction),
                n.freeMode && i.push("free-mode"),
                n.autoHeight && i.push("autoheight"),
                e && i.push("rtl"),
                1 < n.slidesPerColumn &&
                  (i.push("multirow"),
                  "column" === n.slidesPerColumnFill &&
                    i.push("multirow-column")),
                P.android && i.push("android"),
                P.ios && i.push("ios"),
                n.cssMode && i.push("css-mode"),
                i.forEach(function (e) {
                  t.push(n.containerModifierClass + e);
                }),
                r.addClass(t.join(" "));
            },
            removeClasses: function () {
              var e = this.$el,
                t = this.classNames;
              e.removeClass(t.join(" "));
            },
          },
          images: {
            loadImage: function (e, t, n, r, i, o) {
              function a() {
                o && o();
              }
              (!e.complete || !i) && t
                ? (((i = new G.Image()).onload = a),
                  (i.onerror = a),
                  r && (i.sizes = r),
                  n && (i.srcset = n),
                  t && (i.src = t))
                : a();
            },
            preloadImages: function () {
              var e = this;
              function t() {
                null != e &&
                  e &&
                  !e.destroyed &&
                  (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                  e.imagesLoaded === e.imagesToLoad.length &&
                    (e.params.updateOnImagesReady && e.update(),
                    e.emit("imagesReady")));
              }
              e.imagesToLoad = e.$el.find("img");
              for (var n = 0; n < e.imagesToLoad.length; n += 1) {
                var r = e.imagesToLoad[n];
                e.loadImage(
                  r,
                  r.currentSrc || r.getAttribute("src"),
                  r.srcset || r.getAttribute("srcset"),
                  r.sizes || r.getAttribute("sizes"),
                  !0,
                  t
                );
              }
            },
          },
        },
        L = {},
        I = (function (c) {
          function u() {
            for (var n, e = [], t = arguments.length; t--; )
              e[t] = arguments[t];
            (n =
              (n =
                1 === e.length &&
                e[0].constructor &&
                e[0].constructor === Object
                  ? e[0]
                  : ((o = e[0]), e[1])) || {}),
              (n = Y.extend({}, n)),
              o && !n.el && (n.el = o),
              c.call(this, n),
              Object.keys(N).forEach(function (t) {
                Object.keys(N[t]).forEach(function (e) {
                  u.prototype[e] || (u.prototype[e] = N[t][e]);
                });
              });
            var r = this;
            void 0 === r.modules && (r.modules = {}),
              Object.keys(r.modules).forEach(function (e) {
                var t = r.modules[e];
                t.params &&
                  ((e = Object.keys(t.params)[0]),
                  "object" === oC((t = t.params[e])) &&
                    null !== t &&
                    e in n &&
                    "enabled" in t &&
                    (!0 === n[e] && (n[e] = { enabled: !0 }),
                    "object" !== oC(n[e]) ||
                      "enabled" in n[e] ||
                      (n[e].enabled = !0),
                    n[e] || (n[e] = { enabled: !1 })));
              });
            var i = Y.extend({}, M);
            r.useModulesParams(i),
              (r.params = Y.extend({}, i, L, n)),
              (r.originalParams = Y.extend({}, r.params)),
              (r.passedParams = Y.extend({}, n));
            var o,
              a,
              s = (r.$ = E)(r.params.el);
            if ((o = s[0])) {
              if (1 < s.length) {
                var l = [];
                return (
                  s.each(function (e, t) {
                    t = Y.extend({}, n, { el: t });
                    l.push(new u(t));
                  }),
                  l
                );
              }
              return (
                (o.swiper = r),
                s.data("pwzrswiper", r),
                o && o.shadowRoot && o.shadowRoot.querySelector
                  ? ((a = E(
                      o.shadowRoot.querySelector("." + r.params.wrapperClass)
                    )).children = function (e) {
                      return s.children(e);
                    })
                  : (a = s.children("." + r.params.wrapperClass)),
                Y.extend(r, {
                  $el: s,
                  el: o,
                  $wrapperEl: a,
                  wrapperEl: a[0],
                  classNames: [],
                  slides: E(),
                  slidesGrid: [],
                  snapGrid: [],
                  slidesSizesGrid: [],
                  isHorizontal: function () {
                    return "horizontal" === r.params.direction;
                  },
                  isVertical: function () {
                    return "vertical" === r.params.direction;
                  },
                  rtl:
                    "rtl" === o.dir.toLowerCase() ||
                    "rtl" === s.css("direction"),
                  rtlTranslate:
                    "horizontal" === r.params.direction &&
                    ("rtl" === o.dir.toLowerCase() ||
                      "rtl" === s.css("direction")),
                  wrongRTL: "-webkit-box" === a.css("display"),
                  activeIndex: 0,
                  realIndex: 0,
                  isBeginning: !0,
                  isEnd: !1,
                  translate: 0,
                  previousTranslate: 0,
                  progress: 0,
                  velocity: 0,
                  animating: !1,
                  allowSlideNext: r.params.allowSlideNext,
                  allowSlidePrev: r.params.allowSlidePrev,
                  touchEvents:
                    ((o = [
                      "touchstart",
                      "touchmove",
                      "touchend",
                      "touchcancel",
                    ]),
                    (a = ["mousedown", "mousemove", "mouseup"]),
                    w.pointerEvents &&
                      (a = ["pointerdown", "pointermove", "pointerup"]),
                    (r.touchEventsTouch = {
                      start: o[0],
                      move: o[1],
                      end: o[2],
                      cancel: o[3],
                    }),
                    (r.touchEventsDesktop = {
                      start: a[0],
                      move: a[1],
                      end: a[2],
                    }),
                    w.touch || !r.params.simulateTouch
                      ? r.touchEventsTouch
                      : r.touchEventsDesktop),
                  touchEventsData: {
                    isTouched: void 0,
                    isMoved: void 0,
                    allowTouchCallbacks: void 0,
                    touchStartTime: void 0,
                    isScrolling: void 0,
                    currentTranslate: void 0,
                    startTranslate: void 0,
                    allowThresholdMove: void 0,
                    formElements:
                      "input, select, option, textarea, button, video",
                    lastClickTime: Y.now(),
                    clickTimeout: void 0,
                    velocities: [],
                    allowMomentumBounce: void 0,
                    isTouchEvent: void 0,
                    startMoving: void 0,
                  },
                  allowClick: !0,
                  allowTouchMove: r.params.allowTouchMove,
                  touches: {
                    startX: 0,
                    startY: 0,
                    currentX: 0,
                    currentY: 0,
                    diff: 0,
                  },
                  imagesToLoad: [],
                  imagesLoaded: 0,
                }),
                r.useModules(),
                r.params.init && r.init(),
                r
              );
            }
          }
          c && (u.__proto__ = c),
            (u.prototype = Object.create(c && c.prototype));
          var e = {
            extendedDefaults: { configurable: !0 },
            defaults: { configurable: !0 },
            Class: { configurable: !0 },
            $: { configurable: !0 },
          };
          return (
            ((u.prototype.constructor = u).prototype.slidesPerViewDynamic = function () {
              var e = this.params,
                t = this.slides,
                n = this.slidesGrid,
                r = this.size,
                i = this.activeIndex,
                o = 1;
              if (e.centeredSlides) {
                for (
                  var a, s = t[i].swiperSlideSize, l = i + 1;
                  l < t.length;
                  l += 1
                )
                  t[l] &&
                    !a &&
                    ((o += 1), (s += t[l].swiperSlideSize) > r && (a = !0));
                for (var c = i - 1; 0 <= c; --c)
                  t[c] &&
                    !a &&
                    ((o += 1), (s += t[c].swiperSlideSize) > r && (a = !0));
              } else
                for (var u = i + 1; u < t.length; u += 1)
                  n[u] - n[i] < r && (o += 1);
              return o;
            }),
            (u.prototype.update = function () {
              var e,
                t,
                n = this;
              function r() {
                var e = n.rtlTranslate ? -1 * n.translate : n.translate,
                  e = Math.min(Math.max(e, n.maxTranslate()), n.minTranslate());
                n.setTranslate(e),
                  n.updateActiveIndex(),
                  n.updateSlidesClasses();
              }
              n &&
                !n.destroyed &&
                ((e = n.snapGrid),
                (t = n.params).breakpoints && n.setBreakpoint(),
                n.updateSize(),
                n.updateSlides(),
                n.updateProgress(),
                n.updateSlidesClasses(),
                n.params.freeMode
                  ? (r(), n.params.autoHeight && n.updateAutoHeight())
                  : (("auto" === n.params.slidesPerView ||
                      1 < n.params.slidesPerView) &&
                    n.isEnd &&
                    !n.params.centeredSlides
                      ? n.slideTo(n.slides.length - 1, 0, !1, !0)
                      : n.slideTo(n.activeIndex, 0, !1, !0)) || r(),
                t.watchOverflow && e !== n.snapGrid && n.checkOverflow(),
                n.emit("update"));
            }),
            (u.prototype.changeDirection = function (n, e) {
              void 0 === e && (e = !0);
              var t = this.params.direction;
              return (
                (n = n || ("horizontal" === t ? "vertical" : "horizontal")) ===
                  t ||
                  ("horizontal" !== n && "vertical" !== n) ||
                  (this.$el
                    .removeClass("" + this.params.containerModifierClass + t)
                    .addClass("" + this.params.containerModifierClass + n),
                  (this.params.direction = n),
                  this.slides.each(function (e, t) {
                    "vertical" === n
                      ? (t.style.width = "")
                      : (t.style.height = "");
                  }),
                  this.emit("changeDirection"),
                  e && this.update()),
                this
              );
            }),
            (u.prototype.init = function () {
              this.initialized ||
                (this.emit("beforeInit"),
                this.params.breakpoints && this.setBreakpoint(),
                this.addClasses(),
                this.params.loop && this.loopCreate(),
                this.updateSize(),
                this.updateSlides(),
                this.params.watchOverflow && this.checkOverflow(),
                this.params.grabCursor && this.setGrabCursor(),
                this.params.preloadImages && this.preloadImages(),
                this.params.loop
                  ? this.slideTo(
                      this.params.initialSlide + this.loopedSlides,
                      0,
                      this.params.runCallbacksOnInit
                    )
                  : this.slideTo(
                      this.params.initialSlide,
                      0,
                      this.params.runCallbacksOnInit
                    ),
                this.attachEvents(),
                (this.initialized = !0),
                this.emit("init"));
            }),
            (u.prototype.destroy = function (e, t) {
              void 0 === e && (e = !0), void 0 === t && (t = !0);
              var n = this,
                r = n.params,
                i = n.$el,
                o = n.$wrapperEl,
                a = n.slides;
              return (
                void 0 === n.params ||
                  n.destroyed ||
                  (n.emit("beforeDestroy"),
                  (n.initialized = !1),
                  n.detachEvents(),
                  r.loop && n.loopDestroy(),
                  t &&
                    (n.removeClasses(),
                    i.removeAttr("style"),
                    o.removeAttr("style"),
                    a &&
                      a.length &&
                      a
                        .removeClass(
                          [
                            r.slideVisibleClass,
                            r.slideActiveClass,
                            r.slideNextClass,
                            r.slidePrevClass,
                          ].join(" ")
                        )
                        .removeAttr("style")
                        .removeAttr("data-pwzrswiper-slide-index")),
                  n.emit("destroy"),
                  Object.keys(n.eventsListeners).forEach(function (e) {
                    n.off(e);
                  }),
                  !1 !== e &&
                    ((n.$el[0].swiper = null),
                    n.$el.data("pwzrswiper", null),
                    Y.deleteProps(n)),
                  (n.destroyed = !0)),
                null
              );
            }),
            (u.extendDefaults = function (e) {
              Y.extend(L, e);
            }),
            (e.extendedDefaults.get = function () {
              return L;
            }),
            (e.defaults.get = function () {
              return M;
            }),
            (e.Class.get = function () {
              return c;
            }),
            (e.$.get = function () {
              return E;
            }),
            Object.defineProperties(u, e),
            u
          );
        })(e),
        b = { name: "device", proto: { device: P }, static: { device: P } },
        x = { name: "support", proto: { support: w }, static: { support: w } },
        _ = {
          isEdge: !!G.navigator.userAgent.match(/Edge/g),
          isSafari:
            0 <= (S = G.navigator.userAgent.toLowerCase()).indexOf("safari") &&
            S.indexOf("chrome") < 0 &&
            S.indexOf("android") < 0,
          isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
            G.navigator.userAgent
          ),
        },
        C = { name: "browser", proto: { browser: _ }, static: { browser: _ } },
        k = {
          name: "resize",
          create: function () {
            var e = this;
            Y.extend(e, {
              resize: {
                resizeHandler: function () {
                  e &&
                    !e.destroyed &&
                    e.initialized &&
                    (e.emit("beforeResize"), e.emit("resize"));
                },
                orientationChangeHandler: function () {
                  e &&
                    !e.destroyed &&
                    e.initialized &&
                    e.emit("orientationchange");
                },
              },
            });
          },
          on: {
            init: function () {
              G.addEventListener("resize", this.resize.resizeHandler),
                G.addEventListener(
                  "orientationchange",
                  this.resize.orientationChangeHandler
                );
            },
            destroy: function () {
              G.removeEventListener("resize", this.resize.resizeHandler),
                G.removeEventListener(
                  "orientationchange",
                  this.resize.orientationChangeHandler
                );
            },
          },
        },
        D = {
          func: G.MutationObserver || G.WebkitMutationObserver,
          attach: function (e, t) {
            void 0 === t && (t = {});
            var n = this,
              r = new D.func(function (e) {
                var t;
                1 !== e.length
                  ? ((t = function () {
                      n.emit("observerUpdate", e[0]);
                    }),
                    G.requestAnimationFrame
                      ? G.requestAnimationFrame(t)
                      : G.setTimeout(t, 0))
                  : n.emit("observerUpdate", e[0]);
              });
            r.observe(e, {
              attributes: void 0 === t.attributes || t.attributes,
              childList: void 0 === t.childList || t.childList,
              characterData: void 0 === t.characterData || t.characterData,
            }),
              n.observer.observers.push(r);
          },
          init: function () {
            if (w.observer && this.params.observer) {
              if (this.params.observeParents)
                for (var e = this.$el.parents(), t = 0; t < e.length; t += 1)
                  this.observer.attach(e[t]);
              this.observer.attach(this.$el[0], {
                childList: this.params.observeSlideChildren,
              }),
                this.observer.attach(this.$wrapperEl[0], { attributes: !1 });
            }
          },
          destroy: function () {
            this.observer.observers.forEach(function (e) {
              e.disconnect();
            }),
              (this.observer.observers = []);
          },
        },
        T = {
          name: "observer",
          params: {
            observer: !1,
            observeParents: !1,
            observeSlideChildren: !1,
          },
          create: function () {
            Y.extend(this, {
              observer: {
                init: D.init.bind(this),
                attach: D.attach.bind(this),
                destroy: D.destroy.bind(this),
                observers: [],
              },
            });
          },
          on: {
            init: function () {
              this.observer.init();
            },
            destroy: function () {
              this.observer.destroy();
            },
          },
        },
        A = {
          update: function (e) {
            var t = this,
              n = t.params,
              r = n.slidesPerView,
              i = n.slidesPerGroup,
              o = n.centeredSlides,
              a = t.params.virtual,
              s = a.addSlidesBefore,
              l = a.addSlidesAfter,
              c = t.virtual,
              u = c.from,
              d = c.to,
              p = c.slides,
              f = c.slidesGrid,
              h = c.renderSlide,
              n = c.offset;
            t.updateActiveIndex();
            var a = t.activeIndex || 0,
              c = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top",
              l = o
                ? ((v = Math.floor(r / 2) + i + s), Math.floor(r / 2) + i + l)
                : ((v = r + (i - 1) + s), i + l),
              m = Math.max((a || 0) - l, 0),
              g = Math.min((a || 0) + v, p.length - 1),
              v = (t.slidesGrid[m] || 0) - (t.slidesGrid[0] || 0);
            function y() {
              t.updateSlides(),
                t.updateProgress(),
                t.updateSlidesClasses(),
                t.lazy && t.params.lazy.enabled && t.lazy.load();
            }
            if (
              (Y.extend(t.virtual, {
                from: m,
                to: g,
                offset: v,
                slidesGrid: t.slidesGrid,
              }),
              u === m && d === g && !e)
            )
              return (
                t.slidesGrid !== f && v !== n && t.slides.css(c, v + "px"),
                void t.updateProgress()
              );
            if (t.params.virtual.renderExternal)
              return (
                t.params.virtual.renderExternal.call(t, {
                  offset: v,
                  from: m,
                  to: g,
                  slides: (function () {
                    for (var e = [], t = m; t <= g; t += 1) e.push(p[t]);
                    return e;
                  })(),
                }),
                void y()
              );
            var b = [],
              w = [];
            if (e) t.$wrapperEl.find("." + t.params.slideClass).remove();
            else
              for (var x = u; x <= d; x += 1)
                (x < m || g < x) &&
                  t.$wrapperEl
                    .find(
                      "." +
                        t.params.slideClass +
                        '[data-pwzrswiper-slide-index="' +
                        x +
                        '"]'
                    )
                    .remove();
            for (var E = 0; E < p.length; E += 1)
              m <= E &&
                E <= g &&
                (void 0 === d || e
                  ? w.push(E)
                  : (d < E && w.push(E), E < u && b.push(E)));
            w.forEach(function (e) {
              t.$wrapperEl.append(h(p[e], e));
            }),
              b
                .sort(function (e, t) {
                  return t - e;
                })
                .forEach(function (e) {
                  t.$wrapperEl.prepend(h(p[e], e));
                }),
              t.$wrapperEl.children(".pwzrswiper-slide").css(c, v + "px"),
              y();
          },
          renderSlide: function (e, t) {
            var n = this.params.virtual;
            if (n.cache && this.virtual.cache[t]) return this.virtual.cache[t];
            e = n.renderSlide
              ? E(n.renderSlide.call(this, e, t))
              : E(
                  '<div class="' +
                    this.params.slideClass +
                    '" data-pwzrswiper-slide-index="' +
                    t +
                    '">' +
                    e +
                    "</div>"
                );
            return (
              e.attr("data-pwzrswiper-slide-index") ||
                e.attr("data-pwzrswiper-slide-index", t),
              n.cache && (this.virtual.cache[t] = e),
              e
            );
          },
          appendSlide: function (e) {
            if ("object" === oC(e) && "length" in e)
              for (var t = 0; t < e.length; t += 1)
                e[t] && this.virtual.slides.push(e[t]);
            else this.virtual.slides.push(e);
            this.virtual.update(!0);
          },
          prependSlide: function (e) {
            var r,
              i,
              t = this.activeIndex,
              n = t + 1,
              o = 1;
            if (Array.isArray(e)) {
              for (var a = 0; a < e.length; a += 1)
                e[a] && this.virtual.slides.unshift(e[a]);
              (n = t + e.length), (o = e.length);
            } else this.virtual.slides.unshift(e);
            this.params.virtual.cache &&
              ((r = this.virtual.cache),
              (i = {}),
              Object.keys(r).forEach(function (e) {
                var t = r[e],
                  n = t.attr("data-pwzrswiper-slide-index");
                n && t.attr("data-pwzrswiper-slide-index", parseInt(n, 10) + 1),
                  (i[parseInt(e, 10) + o] = t);
              }),
              (this.virtual.cache = i)),
              this.virtual.update(!0),
              this.slideTo(n, 0);
          },
          removeSlide: function (e) {
            if (null != e) {
              var t = this.activeIndex;
              if (Array.isArray(e))
                for (var n = e.length - 1; 0 <= n; --n)
                  this.virtual.slides.splice(e[n], 1),
                    this.params.virtual.cache &&
                      delete this.virtual.cache[e[n]],
                    e[n] < t && --t,
                    (t = Math.max(t, 0));
              else
                this.virtual.slides.splice(e, 1),
                  this.params.virtual.cache && delete this.virtual.cache[e],
                  e < t && --t,
                  (t = Math.max(t, 0));
              this.virtual.update(!0), this.slideTo(t, 0);
            }
          },
          removeAllSlides: function () {
            (this.virtual.slides = []),
              this.params.virtual.cache && (this.virtual.cache = {}),
              this.virtual.update(!0),
              this.slideTo(0, 0);
          },
        },
        e = {
          name: "virtual",
          params: {
            virtual: {
              enabled: !1,
              slides: [],
              cache: !0,
              renderSlide: null,
              renderExternal: null,
              addSlidesBefore: 0,
              addSlidesAfter: 0,
            },
          },
          create: function () {
            Y.extend(this, {
              virtual: {
                update: A.update.bind(this),
                appendSlide: A.appendSlide.bind(this),
                prependSlide: A.prependSlide.bind(this),
                removeSlide: A.removeSlide.bind(this),
                removeAllSlides: A.removeAllSlides.bind(this),
                renderSlide: A.renderSlide.bind(this),
                slides: this.params.virtual.slides,
                cache: {},
              },
            });
          },
          on: {
            beforeInit: function () {
              var e;
              this.params.virtual.enabled &&
                (this.classNames.push(
                  this.params.containerModifierClass + "virtual"
                ),
                (e = { watchSlidesProgress: !0 }),
                Y.extend(this.params, e),
                Y.extend(this.originalParams, e),
                this.params.initialSlide || this.virtual.update());
            },
            setTranslate: function () {
              this.params.virtual.enabled && this.virtual.update();
            },
          },
        },
        F = {
          handle: function (e) {
            var t = this.rtlTranslate,
              n = e;
            n.originalEvent && (n = n.originalEvent);
            var r = n.keyCode || n.charCode;
            if (
              !this.allowSlideNext &&
              ((this.isHorizontal() && 39 === r) ||
                (this.isVertical() && 40 === r) ||
                34 === r)
            )
              return !1;
            if (
              !this.allowSlidePrev &&
              ((this.isHorizontal() && 37 === r) ||
                (this.isVertical() && 38 === r) ||
                33 === r)
            )
              return !1;
            if (
              !(
                n.shiftKey ||
                n.altKey ||
                n.ctrlKey ||
                n.metaKey ||
                (d.activeElement &&
                  d.activeElement.nodeName &&
                  ("input" === d.activeElement.nodeName.toLowerCase() ||
                    "textarea" === d.activeElement.nodeName.toLowerCase()))
              )
            ) {
              if (
                this.params.keyboard.onlyInViewport &&
                (33 === r ||
                  34 === r ||
                  37 === r ||
                  39 === r ||
                  38 === r ||
                  40 === r)
              ) {
                var i = !1;
                if (
                  0 < this.$el.parents("." + this.params.slideClass).length &&
                  0 ===
                    this.$el.parents("." + this.params.slideActiveClass).length
                )
                  return;
                var o = G.innerWidth,
                  a = G.innerHeight,
                  e = this.$el.offset();
                t && (e.left -= this.$el[0].scrollLeft);
                for (
                  var s = [
                      [e.left, e.top],
                      [e.left + this.width, e.top],
                      [e.left, e.top + this.height],
                      [e.left + this.width, e.top + this.height],
                    ],
                    l = 0;
                  l < s.length;
                  l += 1
                ) {
                  var c = s[l];
                  0 <= c[0] && c[0] <= o && 0 <= c[1] && c[1] <= a && (i = !0);
                }
                if (!i) return;
              }
              this.isHorizontal()
                ? ((33 !== r && 34 !== r && 37 !== r && 39 !== r) ||
                    (n.preventDefault
                      ? n.preventDefault()
                      : (n.returnValue = !1)),
                  (((34 !== r && 39 !== r) || t) &&
                    ((33 !== r && 37 !== r) || !t)) ||
                    this.slideNext(),
                  (((33 !== r && 37 !== r) || t) &&
                    ((34 !== r && 39 !== r) || !t)) ||
                    this.slidePrev())
                : ((33 !== r && 34 !== r && 38 !== r && 40 !== r) ||
                    (n.preventDefault
                      ? n.preventDefault()
                      : (n.returnValue = !1)),
                  (34 !== r && 40 !== r) || this.slideNext(),
                  (33 !== r && 38 !== r) || this.slidePrev()),
                this.emit("keyPress", r);
            }
          },
          enable: function () {
            this.keyboard.enabled ||
              (E(d).on("keydown", this.keyboard.handle),
              (this.keyboard.enabled = !0));
          },
          disable: function () {
            this.keyboard.enabled &&
              (E(d).off("keydown", this.keyboard.handle),
              (this.keyboard.enabled = !1));
          },
        },
        S = {
          name: "keyboard",
          params: { keyboard: { enabled: !1, onlyInViewport: !0 } },
          create: function () {
            Y.extend(this, {
              keyboard: {
                enabled: !1,
                enable: F.enable.bind(this),
                disable: F.disable.bind(this),
                handle: F.handle.bind(this),
              },
            });
          },
          on: {
            init: function () {
              this.params.keyboard.enabled && this.keyboard.enable();
            },
            destroy: function () {
              this.keyboard.enabled && this.keyboard.disable();
            },
          },
        },
        B = {
          lastScrollTime: Y.now(),
          lastEventBeforeSnap: void 0,
          recentWheelEvents: [],
          event: function () {
            return -1 < G.navigator.userAgent.indexOf("firefox")
              ? "DOMMouseScroll"
              : ((t = "onwheel" in d) ||
                  ((e = d.createElement("div")).setAttribute(
                    "onwheel",
                    "return;"
                  ),
                  (t = "function" == typeof e.onwheel)),
                !t &&
                  d.implementation &&
                  d.implementation.hasFeature &&
                  !0 !== d.implementation.hasFeature("", "") &&
                  (t = d.implementation.hasFeature("Events.wheel", "3.0")),
                t ? "wheel" : "mousewheel");
            var e, t;
          },
          normalize: function (e) {
            var t = 0,
              n = 0,
              r = 0,
              i = 0;
            return (
              "detail" in e && (n = e.detail),
              "wheelDelta" in e && (n = -e.wheelDelta / 120),
              "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120),
              "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
              "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = n), (n = 0)),
              (r = 10 * t),
              (i = 10 * n),
              "deltaY" in e && (i = e.deltaY),
              "deltaX" in e && (r = e.deltaX),
              e.shiftKey && !r && ((r = i), (i = 0)),
              (r || i) &&
                e.deltaMode &&
                (1 === e.deltaMode
                  ? ((r *= 40), (i *= 40))
                  : ((r *= 800), (i *= 800))),
              r && !t && (t = r < 1 ? -1 : 1),
              i && !n && (n = i < 1 ? -1 : 1),
              { spinX: t, spinY: n, pixelX: r, pixelY: i }
            );
          },
          handleMouseEnter: function () {
            this.mouseEntered = !0;
          },
          handleMouseLeave: function () {
            this.mouseEntered = !1;
          },
          handle: function (e) {
            var t = e,
              n = this,
              r = n.params.mousewheel;
            n.params.cssMode && t.preventDefault();
            var i = n.$el;
            if (
              ("container" !== n.params.mousewheel.eventsTarged &&
                (i = E(n.params.mousewheel.eventsTarged)),
              !n.mouseEntered && !i[0].contains(t.target) && !r.releaseOnEdges)
            )
              return !0;
            t.originalEvent && (t = t.originalEvent);
            var o = 0,
              a = n.rtlTranslate ? -1 : 1,
              i = B.normalize(t);
            if (r.forceToAxis)
              if (n.isHorizontal()) {
                if (!(Math.abs(i.pixelX) > Math.abs(i.pixelY))) return !0;
                o = i.pixelX * a;
              } else {
                if (!(Math.abs(i.pixelY) > Math.abs(i.pixelX))) return !0;
                o = i.pixelY;
              }
            else
              o =
                Math.abs(i.pixelX) > Math.abs(i.pixelY)
                  ? -i.pixelX * a
                  : -i.pixelY;
            if (0 === o) return !0;
            if ((r.invert && (o = -o), n.params.freeMode)) {
              var s = {
                  time: Y.now(),
                  delta: Math.abs(o),
                  direction: Math.sign(o),
                },
                a = n.mousewheel.lastEventBeforeSnap,
                i =
                  a &&
                  s.time < a.time + 500 &&
                  s.delta <= a.delta &&
                  s.direction === a.direction;
              if (!i) {
                (n.mousewheel.lastEventBeforeSnap = void 0),
                  n.params.loop && n.loopFix();
                var l,
                  c,
                  u = n.getTranslate() + o * r.sensitivity,
                  a = n.isBeginning,
                  r = n.isEnd;
                if (
                  (u >= n.minTranslate() && (u = n.minTranslate()),
                  u <= n.maxTranslate() && (u = n.maxTranslate()),
                  n.setTransition(0),
                  n.setTranslate(u),
                  n.updateProgress(),
                  n.updateActiveIndex(),
                  n.updateSlidesClasses(),
                  ((!a && n.isBeginning) || (!r && n.isEnd)) &&
                    n.updateSlidesClasses(),
                  n.params.freeModeSticky &&
                    (clearTimeout(n.mousewheel.timeout),
                    (n.mousewheel.timeout = void 0),
                    15 <= (l = n.mousewheel.recentWheelEvents).length &&
                      l.shift(),
                    (a = l.length ? l[l.length - 1] : void 0),
                    (r = l[0]),
                    l.push(s),
                    a && (s.delta > a.delta || s.direction !== a.direction)
                      ? l.splice(0)
                      : 15 <= l.length &&
                        s.time - r.time < 500 &&
                        1 <= r.delta - s.delta &&
                        s.delta <= 6 &&
                        ((c = 0 < o ? 0.8 : 0.2),
                        (n.mousewheel.lastEventBeforeSnap = s),
                        l.splice(0),
                        (n.mousewheel.timeout = Y.nextTick(function () {
                          n.slideToClosest(n.params.speed, !0, void 0, c);
                        }, 0))),
                    n.mousewheel.timeout ||
                      (n.mousewheel.timeout = Y.nextTick(function () {
                        (n.mousewheel.lastEventBeforeSnap = s),
                          l.splice(0),
                          n.slideToClosest(n.params.speed, !0, void 0, 0.5);
                      }, 500))),
                  i || n.emit("scroll", t),
                  n.params.autoplay &&
                    n.params.autoplayDisableOnInteraction &&
                    n.autoplay.stop(),
                  u === n.minTranslate() || u === n.maxTranslate())
                )
                  return !0;
              }
            } else {
              (u = {
                time: Y.now(),
                delta: Math.abs(o),
                direction: Math.sign(o),
                raw: e,
              }),
                (o = n.mousewheel.recentWheelEvents);
              2 <= o.length && o.shift();
              e = o.length ? o[o.length - 1] : void 0;
              if (
                (o.push(u),
                (!e || u.direction !== e.direction || u.delta > e.delta) &&
                  n.mousewheel.animateSlider(u),
                n.mousewheel.releaseScroll(u))
              )
                return !0;
            }
            return (
              t.preventDefault ? t.preventDefault() : (t.returnValue = !1), !1
            );
          },
          animateSlider: function (e) {
            return (
              (6 <= e.delta && Y.now() - this.mousewheel.lastScrollTime < 60) ||
              (e.direction < 0
                ? (this.isEnd && !this.params.loop) ||
                  this.animating ||
                  (this.slideNext(), this.emit("scroll", e.raw))
                : (this.isBeginning && !this.params.loop) ||
                  this.animating ||
                  (this.slidePrev(), this.emit("scroll", e.raw)),
              (this.mousewheel.lastScrollTime = new G.Date().getTime()),
              !1)
            );
          },
          releaseScroll: function (e) {
            var t = this.params.mousewheel;
            if (e.direction < 0) {
              if (this.isEnd && !this.params.loop && t.releaseOnEdges)
                return !0;
            } else if (
              this.isBeginning &&
              !this.params.loop &&
              t.releaseOnEdges
            )
              return !0;
            return !1;
          },
          enable: function () {
            var e = B.event();
            if (this.params.cssMode)
              return (
                this.wrapperEl.removeEventListener(e, this.mousewheel.handle),
                !0
              );
            if (!e) return !1;
            if (this.mousewheel.enabled) return !1;
            var t = this.$el;
            return (
              "container" !== this.params.mousewheel.eventsTarged &&
                (t = E(this.params.mousewheel.eventsTarged)),
              t.on("mouseenter", this.mousewheel.handleMouseEnter),
              t.on("mouseleave", this.mousewheel.handleMouseLeave),
              t.on(e, this.mousewheel.handle),
              (this.mousewheel.enabled = !0)
            );
          },
          disable: function () {
            var e = B.event();
            if (this.params.cssMode)
              return (
                this.wrapperEl.addEventListener(e, this.mousewheel.handle), !0
              );
            if (!e) return !1;
            if (!this.mousewheel.enabled) return !1;
            var t = this.$el;
            return (
              "container" !== this.params.mousewheel.eventsTarged &&
                (t = E(this.params.mousewheel.eventsTarged)),
              t.off(e, this.mousewheel.handle),
              !(this.mousewheel.enabled = !1)
            );
          },
        },
        W = {
          update: function () {
            var e,
              t,
              n = this.params.navigation;
            this.params.loop ||
              ((e = (t = this.navigation).$nextEl),
              (t = t.$prevEl) &&
                0 < t.length &&
                (this.isBeginning
                  ? t.addClass(n.disabledClass)
                  : t.removeClass(n.disabledClass),
                t[
                  this.params.watchOverflow && this.isLocked
                    ? "addClass"
                    : "removeClass"
                ](n.lockClass)),
              e &&
                0 < e.length &&
                (this.isEnd
                  ? e.addClass(n.disabledClass)
                  : e.removeClass(n.disabledClass),
                e[
                  this.params.watchOverflow && this.isLocked
                    ? "addClass"
                    : "removeClass"
                ](n.lockClass)));
          },
          onPrevClick: function (e) {
            e.preventDefault(),
              (this.isBeginning && !this.params.loop) || this.slidePrev();
          },
          onNextClick: function (e) {
            e.preventDefault(),
              (this.isEnd && !this.params.loop) || this.slideNext();
          },
          init: function () {
            var e,
              t,
              n = this.params.navigation;
            (n.nextEl || n.prevEl) &&
              (n.nextEl &&
                ((e = E(n.nextEl)),
                this.params.uniqueNavElements &&
                  "string" == typeof n.nextEl &&
                  1 < e.length &&
                  1 === this.$el.find(n.nextEl).length &&
                  (e = this.$el.find(n.nextEl))),
              n.prevEl &&
                ((t = E(n.prevEl)),
                this.params.uniqueNavElements &&
                  "string" == typeof n.prevEl &&
                  1 < t.length &&
                  1 === this.$el.find(n.prevEl).length &&
                  (t = this.$el.find(n.prevEl))),
              e && 0 < e.length && e.on("click", this.navigation.onNextClick),
              t && 0 < t.length && t.on("click", this.navigation.onPrevClick),
              Y.extend(this.navigation, {
                $nextEl: e,
                nextEl: e && e[0],
                $prevEl: t,
                prevEl: t && t[0],
              }));
          },
          destroy: function () {
            var e = this.navigation,
              t = e.$nextEl,
              e = e.$prevEl;
            t &&
              t.length &&
              (t.off("click", this.navigation.onNextClick),
              t.removeClass(this.params.navigation.disabledClass)),
              e &&
                e.length &&
                (e.off("click", this.navigation.onPrevClick),
                e.removeClass(this.params.navigation.disabledClass));
          },
        },
        $ = {
          update: function () {
            var e = this.rtl,
              r = this.params.pagination;
            if (
              r.el &&
              this.pagination.el &&
              this.pagination.$el &&
              0 !== this.pagination.$el.length
            ) {
              var i,
                t = (this.virtual && this.params.virtual.enabled
                  ? this.virtual
                  : this
                ).slides.length,
                n = this.pagination.$el,
                o = this.params.loop
                  ? Math.ceil(
                      (t - 2 * this.loopedSlides) / this.params.slidesPerGroup
                    )
                  : this.snapGrid.length;
              if (
                (this.params.loop
                  ? ((i = Math.ceil(
                      (this.activeIndex - this.loopedSlides) /
                        this.params.slidesPerGroup
                    )) >
                      t - 1 - 2 * this.loopedSlides &&
                      (i -= t - 2 * this.loopedSlides),
                    o - 1 < i && (i -= o),
                    i < 0 &&
                      "bullets" !== this.params.paginationType &&
                      (i = o + i))
                  : (i =
                      void 0 !== this.snapIndex
                        ? this.snapIndex
                        : this.activeIndex || 0),
                "bullets" === r.type &&
                  this.pagination.bullets &&
                  0 < this.pagination.bullets.length)
              ) {
                var a,
                  s,
                  l,
                  c,
                  u,
                  d = this.pagination.bullets;
                if (
                  (r.dynamicBullets &&
                    ((this.pagination.bulletSize = d
                      .eq(0)
                      [this.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                    n.css(
                      this.isHorizontal() ? "width" : "height",
                      this.pagination.bulletSize * (r.dynamicMainBullets + 4) +
                        "px"
                    ),
                    1 < r.dynamicMainBullets &&
                      void 0 !== this.previousIndex &&
                      ((this.pagination.dynamicBulletIndex +=
                        i - this.previousIndex),
                      this.pagination.dynamicBulletIndex >
                      r.dynamicMainBullets - 1
                        ? (this.pagination.dynamicBulletIndex =
                            r.dynamicMainBullets - 1)
                        : this.pagination.dynamicBulletIndex < 0 &&
                          (this.pagination.dynamicBulletIndex = 0)),
                    (a = i - this.pagination.dynamicBulletIndex),
                    (l =
                      ((s =
                        a + (Math.min(d.length, r.dynamicMainBullets) - 1)) +
                        a) /
                      2)),
                  d.removeClass(
                    r.bulletActiveClass +
                      " " +
                      r.bulletActiveClass +
                      "-next " +
                      r.bulletActiveClass +
                      "-next-next " +
                      r.bulletActiveClass +
                      "-prev " +
                      r.bulletActiveClass +
                      "-prev-prev " +
                      r.bulletActiveClass +
                      "-main"
                  ),
                  1 < n.length)
                )
                  d.each(function (e, t) {
                    var n = E(t),
                      t = n.index();
                    t === i && n.addClass(r.bulletActiveClass),
                      r.dynamicBullets &&
                        (a <= t &&
                          t <= s &&
                          n.addClass(r.bulletActiveClass + "-main"),
                        t === a &&
                          n
                            .prev()
                            .addClass(r.bulletActiveClass + "-prev")
                            .prev()
                            .addClass(r.bulletActiveClass + "-prev-prev"),
                        t === s &&
                          n
                            .next()
                            .addClass(r.bulletActiveClass + "-next")
                            .next()
                            .addClass(r.bulletActiveClass + "-next-next"));
                  });
                else {
                  var p = d.eq(i),
                    f = p.index();
                  if ((p.addClass(r.bulletActiveClass), r.dynamicBullets)) {
                    for (var t = d.eq(a), p = d.eq(s), h = a; h <= s; h += 1)
                      d.eq(h).addClass(r.bulletActiveClass + "-main");
                    if (this.params.loop)
                      if (f >= d.length - r.dynamicMainBullets) {
                        for (var m = r.dynamicMainBullets; 0 <= m; --m)
                          d.eq(d.length - m).addClass(
                            r.bulletActiveClass + "-main"
                          );
                        d.eq(d.length - r.dynamicMainBullets - 1).addClass(
                          r.bulletActiveClass + "-prev"
                        );
                      } else
                        t
                          .prev()
                          .addClass(r.bulletActiveClass + "-prev")
                          .prev()
                          .addClass(r.bulletActiveClass + "-prev-prev"),
                          p
                            .next()
                            .addClass(r.bulletActiveClass + "-next")
                            .next()
                            .addClass(r.bulletActiveClass + "-next-next");
                    else
                      t
                        .prev()
                        .addClass(r.bulletActiveClass + "-prev")
                        .prev()
                        .addClass(r.bulletActiveClass + "-prev-prev"),
                        p
                          .next()
                          .addClass(r.bulletActiveClass + "-next")
                          .next()
                          .addClass(r.bulletActiveClass + "-next-next");
                  }
                }
                r.dynamicBullets &&
                  ((u = Math.min(d.length, r.dynamicMainBullets + 4)),
                  (c =
                    (this.pagination.bulletSize * u -
                      this.pagination.bulletSize) /
                      2 -
                    l * this.pagination.bulletSize),
                  (u = e ? "right" : "left"),
                  d.css(this.isHorizontal() ? u : "top", c + "px"));
              }
              "fraction" === r.type &&
                (n
                  .find("." + r.currentClass)
                  .text(r.formatFractionCurrent(i + 1)),
                n.find("." + r.totalClass).text(r.formatFractionTotal(o))),
                "progressbar" === r.type &&
                  ((l = r.progressbarOpposite
                    ? this.isHorizontal()
                      ? "vertical"
                      : "horizontal"
                    : this.isHorizontal()
                    ? "horizontal"
                    : "vertical"),
                  (e = (i + 1) / o),
                  (c = u = 1),
                  "horizontal" == l ? (u = e) : (c = e),
                  n
                    .find("." + r.progressbarFillClass)
                    .transform(
                      "translate3d(0,0,0) scaleX(" + u + ") scaleY(" + c + ")"
                    )
                    .transition(this.params.speed)),
                "custom" === r.type && r.renderCustom
                  ? (n.html(r.renderCustom(this, i + 1, o)),
                    this.emit("paginationRender", this, n[0]))
                  : this.emit("paginationUpdate", this, n[0]),
                n[
                  this.params.watchOverflow && this.isLocked
                    ? "addClass"
                    : "removeClass"
                ](r.lockClass);
            }
          },
          render: function () {
            var e = this.params.pagination;
            if (
              e.el &&
              this.pagination.el &&
              this.pagination.$el &&
              0 !== this.pagination.$el.length
            ) {
              var t = (this.virtual && this.params.virtual.enabled
                  ? this.virtual
                  : this
                ).slides.length,
                n = this.pagination.$el,
                r = "";
              if ("bullets" === e.type) {
                for (
                  var i = this.params.loop
                      ? Math.ceil(
                          (t - 2 * this.loopedSlides) /
                            this.params.slidesPerGroup
                        )
                      : this.snapGrid.length,
                    o = 0;
                  o < i;
                  o += 1
                )
                  e.renderBullet
                    ? (r += e.renderBullet.call(this, o, e.bulletClass))
                    : (r +=
                        "<" +
                        e.bulletElement +
                        ' class="' +
                        e.bulletClass +
                        '"></' +
                        e.bulletElement +
                        ">");
                n.html(r),
                  (this.pagination.bullets = n.find("." + e.bulletClass));
              }
              "fraction" === e.type &&
                ((r = e.renderFraction
                  ? e.renderFraction.call(this, e.currentClass, e.totalClass)
                  : '<span class="' +
                    e.currentClass +
                    '"></span> / <span class="' +
                    e.totalClass +
                    '"></span>'),
                n.html(r)),
                "progressbar" === e.type &&
                  ((r = e.renderProgressbar
                    ? e.renderProgressbar.call(this, e.progressbarFillClass)
                    : '<span class="' + e.progressbarFillClass + '"></span>'),
                  n.html(r)),
                "custom" !== e.type &&
                  this.emit("paginationRender", this.pagination.$el[0]);
            }
          },
          init: function () {
            var e,
              t = this,
              n = t.params.pagination;
            !n.el ||
              (0 !== (e = E(n.el)).length &&
                (t.params.uniqueNavElements &&
                  "string" == typeof n.el &&
                  1 < e.length &&
                  1 === t.$el.find(n.el).length &&
                  (e = t.$el.find(n.el)),
                "bullets" === n.type &&
                  n.clickable &&
                  e.addClass(n.clickableClass),
                e.addClass(n.modifierClass + n.type),
                "bullets" === n.type &&
                  n.dynamicBullets &&
                  (e.addClass("" + n.modifierClass + n.type + "-dynamic"),
                  (t.pagination.dynamicBulletIndex = 0),
                  n.dynamicMainBullets < 1 && (n.dynamicMainBullets = 1)),
                "progressbar" === n.type &&
                  n.progressbarOpposite &&
                  e.addClass(n.progressbarOppositeClass),
                n.clickable &&
                  e.on("click", "." + n.bulletClass, function (e) {
                    e.preventDefault();
                    e = E(this).index() * t.params.slidesPerGroup;
                    t.params.loop && (e += t.loopedSlides), t.slideTo(e);
                  }),
                Y.extend(t.pagination, { $el: e, el: e[0] })));
          },
          destroy: function () {
            var e,
              t = this.params.pagination;
            t.el &&
              this.pagination.el &&
              this.pagination.$el &&
              0 !== this.pagination.$el.length &&
              ((e = this.pagination.$el).removeClass(t.hiddenClass),
              e.removeClass(t.modifierClass + t.type),
              this.pagination.bullets &&
                this.pagination.bullets.removeClass(t.bulletActiveClass),
              t.clickable && e.off("click", "." + t.bulletClass));
          },
        },
        j = {
          setTranslate: function () {
            var e, t, n, r, i, o, a, s;
            this.params.scrollbar.el &&
              this.scrollbar.el &&
              ((a = this.scrollbar),
              (e = this.rtlTranslate),
              (s = this.progress),
              (t = a.dragSize),
              (n = a.trackSize),
              (r = a.$dragEl),
              (i = a.$el),
              (o = this.params.scrollbar),
              (s = (n - (a = t)) * s),
              e
                ? 0 < (s = -s)
                  ? ((a = t - s), (s = 0))
                  : n < -s + t && (a = n + s)
                : s < 0
                ? ((a = t + s), (s = 0))
                : n < s + t && (a = n - s),
              this.isHorizontal()
                ? (r.transform("translate3d(" + s + "px, 0, 0)"),
                  (r[0].style.width = a + "px"))
                : (r.transform("translate3d(0px, " + s + "px, 0)"),
                  (r[0].style.height = a + "px")),
              o.hide &&
                (clearTimeout(this.scrollbar.timeout),
                (i[0].style.opacity = 1),
                (this.scrollbar.timeout = setTimeout(function () {
                  (i[0].style.opacity = 0), i.transition(400);
                }, 1e3))));
          },
          setTransition: function (e) {
            this.params.scrollbar.el &&
              this.scrollbar.el &&
              this.scrollbar.$dragEl.transition(e);
          },
          updateSize: function () {
            var e, t, n, r, i, o, a;
            this.params.scrollbar.el &&
              this.scrollbar.el &&
              ((t = (e = this.scrollbar).$dragEl),
              (n = e.$el),
              (t[0].style.width = ""),
              (t[0].style.height = ""),
              (r = this.isHorizontal() ? n[0].offsetWidth : n[0].offsetHeight),
              (o = (i = this.size / this.virtualSize) * (r / this.size)),
              (a =
                "auto" === this.params.scrollbar.dragSize
                  ? r * i
                  : parseInt(this.params.scrollbar.dragSize, 10)),
              this.isHorizontal()
                ? (t[0].style.width = a + "px")
                : (t[0].style.height = a + "px"),
              (n[0].style.display = 1 <= i ? "none" : ""),
              this.params.scrollbar.hide && (n[0].style.opacity = 0),
              Y.extend(e, {
                trackSize: r,
                divider: i,
                moveDivider: o,
                dragSize: a,
              }),
              e.$el[
                this.params.watchOverflow && this.isLocked
                  ? "addClass"
                  : "removeClass"
              ](this.params.scrollbar.lockClass));
          },
          getPointerPosition: function (e) {
            return this.isHorizontal()
              ? ("touchstart" === e.type || "touchmove" === e.type
                  ? e.targetTouches[0]
                  : e
                ).clientX
              : ("touchstart" === e.type || "touchmove" === e.type
                  ? e.targetTouches[0]
                  : e
                ).clientY;
          },
          setDragPosition: function (e) {
            var t = this.scrollbar,
              n = this.rtlTranslate,
              r = t.$el,
              i = t.dragSize,
              o = t.trackSize,
              a = t.dragStartPos,
              i =
                (t.getPointerPosition(e) -
                  r.offset()[this.isHorizontal() ? "left" : "top"] -
                  (null !== a ? a : i / 2)) /
                (o - i);
            (i = Math.max(Math.min(i, 1), 0)), n && (i = 1 - i);
            i =
              this.minTranslate() +
              (this.maxTranslate() - this.minTranslate()) * i;
            this.updateProgress(i),
              this.setTranslate(i),
              this.updateActiveIndex(),
              this.updateSlidesClasses();
          },
          onDragStart: function (e) {
            var t = this.params.scrollbar,
              n = this.scrollbar,
              r = this.$wrapperEl,
              i = n.$el,
              o = n.$dragEl;
            (this.scrollbar.isTouched = !0),
              (this.scrollbar.dragStartPos =
                e.target === o[0] || e.target === o
                  ? n.getPointerPosition(e) -
                    e.target.getBoundingClientRect()[
                      this.isHorizontal() ? "left" : "top"
                    ]
                  : null),
              e.preventDefault(),
              e.stopPropagation(),
              r.transition(100),
              o.transition(100),
              n.setDragPosition(e),
              clearTimeout(this.scrollbar.dragTimeout),
              i.transition(0),
              t.hide && i.css("opacity", 1),
              this.params.cssMode &&
                this.$wrapperEl.css("scroll-snap-type", "none"),
              this.emit("scrollbarDragStart", e);
          },
          onDragMove: function (e) {
            var t = this.scrollbar,
              n = this.$wrapperEl,
              r = t.$el,
              i = t.$dragEl;
            this.scrollbar.isTouched &&
              (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
              t.setDragPosition(e),
              n.transition(0),
              r.transition(0),
              i.transition(0),
              this.emit("scrollbarDragMove", e));
          },
          onDragEnd: function (e) {
            var t = this.params.scrollbar,
              n = this.scrollbar,
              r = this.$wrapperEl,
              i = n.$el;
            this.scrollbar.isTouched &&
              ((this.scrollbar.isTouched = !1),
              this.params.cssMode &&
                (this.$wrapperEl.css("scroll-snap-type", ""), r.transition("")),
              t.hide &&
                (clearTimeout(this.scrollbar.dragTimeout),
                (this.scrollbar.dragTimeout = Y.nextTick(function () {
                  i.css("opacity", 0), i.transition(400);
                }, 1e3))),
              this.emit("scrollbarDragEnd", e),
              t.snapOnRelease && this.slideToClosest());
          },
          enableDraggable: function () {
            var e, t, n, r, i;
            this.params.scrollbar.el &&
              ((r = this.scrollbar),
              (e = this.touchEventsTouch),
              (t = this.touchEventsDesktop),
              (i = this.params),
              (n = r.$el[0]),
              (r = !(!w.passiveListener || !i.passiveListeners) && {
                passive: !1,
                capture: !1,
              }),
              (i = !(!w.passiveListener || !i.passiveListeners) && {
                passive: !0,
                capture: !1,
              }),
              w.touch
                ? (n.addEventListener(e.start, this.scrollbar.onDragStart, r),
                  n.addEventListener(e.move, this.scrollbar.onDragMove, r),
                  n.addEventListener(e.end, this.scrollbar.onDragEnd, i))
                : (n.addEventListener(t.start, this.scrollbar.onDragStart, r),
                  d.addEventListener(t.move, this.scrollbar.onDragMove, r),
                  d.addEventListener(t.end, this.scrollbar.onDragEnd, i)));
          },
          disableDraggable: function () {
            var e, t, n, r, i;
            this.params.scrollbar.el &&
              ((r = this.scrollbar),
              (e = this.touchEventsTouch),
              (t = this.touchEventsDesktop),
              (i = this.params),
              (n = r.$el[0]),
              (r = !(!w.passiveListener || !i.passiveListeners) && {
                passive: !1,
                capture: !1,
              }),
              (i = !(!w.passiveListener || !i.passiveListeners) && {
                passive: !0,
                capture: !1,
              }),
              w.touch
                ? (n.removeEventListener(
                    e.start,
                    this.scrollbar.onDragStart,
                    r
                  ),
                  n.removeEventListener(e.move, this.scrollbar.onDragMove, r),
                  n.removeEventListener(e.end, this.scrollbar.onDragEnd, i))
                : (n.removeEventListener(
                    t.start,
                    this.scrollbar.onDragStart,
                    r
                  ),
                  d.removeEventListener(t.move, this.scrollbar.onDragMove, r),
                  d.removeEventListener(t.end, this.scrollbar.onDragEnd, i)));
          },
          init: function () {
            var e, t, n, r;
            this.params.scrollbar.el &&
              ((e = this.scrollbar),
              (r = this.$el),
              (n = E((t = this.params.scrollbar).el)),
              this.params.uniqueNavElements &&
                "string" == typeof t.el &&
                1 < n.length &&
                1 === r.find(t.el).length &&
                (n = r.find(t.el)),
              0 ===
                (r = n.find("." + this.params.scrollbar.dragClass)).length &&
                ((r = E(
                  '<div class="' + this.params.scrollbar.dragClass + '"></div>'
                )),
                n.append(r)),
              Y.extend(e, { $el: n, el: n[0], $dragEl: r, dragEl: r[0] }),
              t.draggable && e.enableDraggable());
          },
          destroy: function () {
            this.scrollbar.disableDraggable();
          },
        },
        H = {
          setTransform: function (e, t) {
            var n = this.rtl,
              r = E(e),
              i = n ? -1 : 1,
              o = r.attr("data-pwzrswiper-parallax") || "0",
              a = r.attr("data-pwzrswiper-parallax-x"),
              s = r.attr("data-pwzrswiper-parallax-y"),
              e = r.attr("data-pwzrswiper-parallax-scale"),
              n = r.attr("data-pwzrswiper-parallax-opacity");
            a || s
              ? ((a = a || "0"), (s = s || "0"))
              : this.isHorizontal()
              ? ((a = o), (s = "0"))
              : ((s = o), (a = "0")),
              (a =
                0 <= a.indexOf("%")
                  ? parseInt(a, 10) * t * i + "%"
                  : a * t * i + "px"),
              (s =
                0 <= s.indexOf("%") ? parseInt(s, 10) * t + "%" : s * t + "px"),
              null != n &&
                ((n = n - (n - 1) * (1 - Math.abs(t))),
                (r[0].style.opacity = n)),
              null == e
                ? r.transform("translate3d(" + a + ", " + s + ", 0px)")
                : ((t = e - (e - 1) * (1 - Math.abs(t))),
                  r.transform(
                    "translate3d(" + a + ", " + s + ", 0px) scale(" + t + ")"
                  ));
          },
          setTranslate: function () {
            var r = this,
              e = r.$el,
              t = r.slides,
              i = r.progress,
              o = r.snapGrid;
            e
              .children(
                "[data-pwzrswiper-parallax], [data-pwzrswiper-parallax-x], [data-pwzrswiper-parallax-y], [data-pwzrswiper-parallax-opacity], [data-pwzrswiper-parallax-scale]"
              )
              .each(function (e, t) {
                r.parallax.setTransform(t, i);
              }),
              t.each(function (e, t) {
                var n = t.progress;
                1 < r.params.slidesPerGroup &&
                  "auto" !== r.params.slidesPerView &&
                  (n += Math.ceil(e / 2) - i * (o.length - 1)),
                  (n = Math.min(Math.max(n, -1), 1)),
                  E(t)
                    .find(
                      "[data-pwzrswiper-parallax], [data-pwzrswiper-parallax-x], [data-pwzrswiper-parallax-y], [data-pwzrswiper-parallax-opacity], [data-pwzrswiper-parallax-scale]"
                    )
                    .each(function (e, t) {
                      r.parallax.setTransform(t, n);
                    });
              });
          },
          setTransition: function (r) {
            void 0 === r && (r = this.params.speed),
              this.$el
                .find(
                  "[data-pwzrswiper-parallax], [data-pwzrswiper-parallax-x], [data-pwzrswiper-parallax-y], [data-pwzrswiper-parallax-opacity], [data-pwzrswiper-parallax-scale]"
                )
                .each(function (e, t) {
                  var n = E(t),
                    t =
                      parseInt(
                        n.attr("data-pwzrswiper-parallax-duration"),
                        10
                      ) || r;
                  0 === r && (t = 0), n.transition(t);
                });
          },
        },
        V = {
          getDistanceBetweenTouches: function (e) {
            if (e.targetTouches.length < 2) return 1;
            var t = e.targetTouches[0].pageX,
              n = e.targetTouches[0].pageY,
              r = e.targetTouches[1].pageX,
              e = e.targetTouches[1].pageY;
            return Math.sqrt(Math.pow(r - t, 2) + Math.pow(e - n, 2));
          },
          onGestureStart: function (e) {
            var t = this.params.zoom,
              n = this.zoom,
              r = n.gesture;
            if (
              ((n.fakeGestureTouched = !1),
              (n.fakeGestureMoved = !1),
              !w.gestures)
            ) {
              if (
                "touchstart" !== e.type ||
                ("touchstart" === e.type && e.targetTouches.length < 2)
              )
                return;
              (n.fakeGestureTouched = !0),
                (r.scaleStart = V.getDistanceBetweenTouches(e));
            }
            (r.$slideEl && r.$slideEl.length) ||
            ((r.$slideEl = E(e.target).closest(".pwzrswiper-slide")),
            0 === r.$slideEl.length &&
              (r.$slideEl = this.slides.eq(this.activeIndex)),
            (r.$imageEl = r.$slideEl.find("img, svg, canvas")),
            (r.$imageWrapEl = r.$imageEl.parent("." + t.containerClass)),
            (r.maxRatio =
              r.$imageWrapEl.attr("data-pwzrswiper-zoom") || t.maxRatio),
            0 !== r.$imageWrapEl.length)
              ? (r.$imageEl.transition(0), (this.zoom.isScaling = !0))
              : (r.$imageEl = void 0);
          },
          onGestureChange: function (e) {
            var t = this.params.zoom,
              n = this.zoom,
              r = n.gesture;
            if (!w.gestures) {
              if (
                "touchmove" !== e.type ||
                ("touchmove" === e.type && e.targetTouches.length < 2)
              )
                return;
              (n.fakeGestureMoved = !0),
                (r.scaleMove = V.getDistanceBetweenTouches(e));
            }
            r.$imageEl &&
              0 !== r.$imageEl.length &&
              ((n.scale = w.gestures
                ? e.scale * n.currentScale
                : (r.scaleMove / r.scaleStart) * n.currentScale),
              n.scale > r.maxRatio &&
                (n.scale =
                  r.maxRatio - 1 + Math.pow(n.scale - r.maxRatio + 1, 0.5)),
              n.scale < t.minRatio &&
                (n.scale =
                  t.minRatio + 1 - Math.pow(t.minRatio - n.scale + 1, 0.5)),
              r.$imageEl.transform(
                "translate3d(0,0,0) scale(" + n.scale + ")"
              ));
          },
          onGestureEnd: function (e) {
            var t = this.params.zoom,
              n = this.zoom,
              r = n.gesture;
            if (!w.gestures) {
              if (!n.fakeGestureTouched || !n.fakeGestureMoved) return;
              if (
                "touchend" !== e.type ||
                ("touchend" === e.type &&
                  e.changedTouches.length < 2 &&
                  !P.android)
              )
                return;
              (n.fakeGestureTouched = !1), (n.fakeGestureMoved = !1);
            }
            r.$imageEl &&
              0 !== r.$imageEl.length &&
              ((n.scale = Math.max(Math.min(n.scale, r.maxRatio), t.minRatio)),
              r.$imageEl
                .transition(this.params.speed)
                .transform("translate3d(0,0,0) scale(" + n.scale + ")"),
              (n.currentScale = n.scale),
              (n.isScaling = !1),
              1 === n.scale && (r.$slideEl = void 0));
          },
          onTouchStart: function (e) {
            var t = this.zoom,
              n = t.gesture,
              t = t.image;
            n.$imageEl &&
              0 !== n.$imageEl.length &&
              (t.isTouched ||
                (P.android && e.preventDefault(),
                (t.isTouched = !0),
                (t.touchesStart.x = ("touchstart" === e.type
                  ? e.targetTouches[0]
                  : e
                ).pageX),
                (t.touchesStart.y = ("touchstart" === e.type
                  ? e.targetTouches[0]
                  : e
                ).pageY)));
          },
          onTouchMove: function (e) {
            var t = this.zoom,
              n = t.gesture,
              r = t.image,
              i = t.velocity;
            if (
              n.$imageEl &&
              0 !== n.$imageEl.length &&
              ((this.allowClick = !1), r.isTouched && n.$slideEl)
            ) {
              r.isMoved ||
                ((r.width = n.$imageEl[0].offsetWidth),
                (r.height = n.$imageEl[0].offsetHeight),
                (r.startX = Y.getTranslate(n.$imageWrapEl[0], "x") || 0),
                (r.startY = Y.getTranslate(n.$imageWrapEl[0], "y") || 0),
                (n.slideWidth = n.$slideEl[0].offsetWidth),
                (n.slideHeight = n.$slideEl[0].offsetHeight),
                n.$imageWrapEl.transition(0),
                this.rtl && ((r.startX = -r.startX), (r.startY = -r.startY)));
              var o = r.width * t.scale,
                a = r.height * t.scale;
              if (!(o < n.slideWidth && a < n.slideHeight)) {
                if (
                  ((r.minX = Math.min(n.slideWidth / 2 - o / 2, 0)),
                  (r.maxX = -r.minX),
                  (r.minY = Math.min(n.slideHeight / 2 - a / 2, 0)),
                  (r.maxY = -r.minY),
                  (r.touchesCurrent.x = ("touchmove" === e.type
                    ? e.targetTouches[0]
                    : e
                  ).pageX),
                  (r.touchesCurrent.y = ("touchmove" === e.type
                    ? e.targetTouches[0]
                    : e
                  ).pageY),
                  !r.isMoved && !t.isScaling)
                ) {
                  if (
                    this.isHorizontal() &&
                    ((Math.floor(r.minX) === Math.floor(r.startX) &&
                      r.touchesCurrent.x < r.touchesStart.x) ||
                      (Math.floor(r.maxX) === Math.floor(r.startX) &&
                        r.touchesCurrent.x > r.touchesStart.x))
                  )
                    return void (r.isTouched = !1);
                  if (
                    !this.isHorizontal() &&
                    ((Math.floor(r.minY) === Math.floor(r.startY) &&
                      r.touchesCurrent.y < r.touchesStart.y) ||
                      (Math.floor(r.maxY) === Math.floor(r.startY) &&
                        r.touchesCurrent.y > r.touchesStart.y))
                  )
                    return void (r.isTouched = !1);
                }
                e.preventDefault(),
                  e.stopPropagation(),
                  (r.isMoved = !0),
                  (r.currentX =
                    r.touchesCurrent.x - r.touchesStart.x + r.startX),
                  (r.currentY =
                    r.touchesCurrent.y - r.touchesStart.y + r.startY),
                  r.currentX < r.minX &&
                    (r.currentX =
                      r.minX + 1 - Math.pow(r.minX - r.currentX + 1, 0.8)),
                  r.currentX > r.maxX &&
                    (r.currentX =
                      r.maxX - 1 + Math.pow(r.currentX - r.maxX + 1, 0.8)),
                  r.currentY < r.minY &&
                    (r.currentY =
                      r.minY + 1 - Math.pow(r.minY - r.currentY + 1, 0.8)),
                  r.currentY > r.maxY &&
                    (r.currentY =
                      r.maxY - 1 + Math.pow(r.currentY - r.maxY + 1, 0.8)),
                  i.prevPositionX || (i.prevPositionX = r.touchesCurrent.x),
                  i.prevPositionY || (i.prevPositionY = r.touchesCurrent.y),
                  i.prevTime || (i.prevTime = Date.now()),
                  (i.x =
                    (r.touchesCurrent.x - i.prevPositionX) /
                    (Date.now() - i.prevTime) /
                    2),
                  (i.y =
                    (r.touchesCurrent.y - i.prevPositionY) /
                    (Date.now() - i.prevTime) /
                    2),
                  Math.abs(r.touchesCurrent.x - i.prevPositionX) < 2 &&
                    (i.x = 0),
                  Math.abs(r.touchesCurrent.y - i.prevPositionY) < 2 &&
                    (i.y = 0),
                  (i.prevPositionX = r.touchesCurrent.x),
                  (i.prevPositionY = r.touchesCurrent.y),
                  (i.prevTime = Date.now()),
                  n.$imageWrapEl.transform(
                    "translate3d(" + r.currentX + "px, " + r.currentY + "px,0)"
                  );
              }
            }
          },
          onTouchEnd: function () {
            var e = this.zoom,
              t = e.gesture,
              n = e.image,
              r = e.velocity;
            if (t.$imageEl && 0 !== t.$imageEl.length) {
              if (!n.isTouched || !n.isMoved)
                return (n.isTouched = !1), void (n.isMoved = !1);
              (n.isTouched = !1), (n.isMoved = !1);
              var i = 300,
                o = 300,
                a = r.x * i,
                s = n.currentX + a,
                a = r.y * o,
                a = n.currentY + a;
              0 !== r.x && (i = Math.abs((s - n.currentX) / r.x)),
                0 !== r.y && (o = Math.abs((a - n.currentY) / r.y));
              o = Math.max(i, o);
              (n.currentX = s), (n.currentY = a);
              (a = n.width * e.scale), (e = n.height * e.scale);
              (n.minX = Math.min(t.slideWidth / 2 - a / 2, 0)),
                (n.maxX = -n.minX),
                (n.minY = Math.min(t.slideHeight / 2 - e / 2, 0)),
                (n.maxY = -n.minY),
                (n.currentX = Math.max(Math.min(n.currentX, n.maxX), n.minX)),
                (n.currentY = Math.max(Math.min(n.currentY, n.maxY), n.minY)),
                t.$imageWrapEl
                  .transition(o)
                  .transform(
                    "translate3d(" + n.currentX + "px, " + n.currentY + "px,0)"
                  );
            }
          },
          onTransitionEnd: function () {
            var e = this.zoom,
              t = e.gesture;
            t.$slideEl &&
              this.previousIndex !== this.activeIndex &&
              (t.$imageEl.transform("translate3d(0,0,0) scale(1)"),
              t.$imageWrapEl.transform("translate3d(0,0,0)"),
              (e.scale = 1),
              (e.currentScale = 1),
              (t.$slideEl = void 0),
              (t.$imageEl = void 0),
              (t.$imageWrapEl = void 0));
          },
          toggle: function (e) {
            var t = this.zoom;
            t.scale && 1 !== t.scale ? t.out() : t.in(e);
          },
          in: function (e) {
            var t,
              n,
              r,
              i = this.zoom,
              o = this.params.zoom,
              a = i.gesture,
              s = i.image;
            a.$slideEl ||
              ((a.$slideEl = this.clickedSlide
                ? E(this.clickedSlide)
                : this.slides.eq(this.activeIndex)),
              (a.$imageEl = a.$slideEl.find("img, svg, canvas")),
              (a.$imageWrapEl = a.$imageEl.parent("." + o.containerClass))),
              a.$imageEl &&
                0 !== a.$imageEl.length &&
                (a.$slideEl.addClass("" + o.zoomedSlideClass),
                (s =
                  void 0 === s.touchesStart.x && e
                    ? ((r = ("touchend" === e.type ? e.changedTouches[0] : e)
                        .pageX),
                      ("touchend" === e.type ? e.changedTouches[0] : e).pageY)
                    : ((r = s.touchesStart.x), s.touchesStart.y)),
                (i.scale =
                  a.$imageWrapEl.attr("data-pwzrswiper-zoom") || o.maxRatio),
                (i.currentScale =
                  a.$imageWrapEl.attr("data-pwzrswiper-zoom") || o.maxRatio),
                e
                  ? ((o = a.$slideEl[0].offsetWidth),
                    (e = a.$slideEl[0].offsetHeight),
                    (t = a.$slideEl.offset().left + o / 2 - r),
                    (n = a.$slideEl.offset().top + e / 2 - s),
                    (r = a.$imageEl[0].offsetWidth),
                    (s = a.$imageEl[0].offsetHeight),
                    (r = r * i.scale),
                    (s = s * i.scale),
                    (r = -(o = Math.min(o / 2 - r / 2, 0))),
                    (s = -(e = Math.min(e / 2 - s / 2, 0))),
                    (t = t * i.scale) < o && (t = o),
                    r < t && (t = r),
                    (n = n * i.scale) < e && (n = e),
                    s < n && (n = s))
                  : (n = t = 0),
                a.$imageWrapEl
                  .transition(300)
                  .transform("translate3d(" + t + "px, " + n + "px,0)"),
                a.$imageEl
                  .transition(300)
                  .transform("translate3d(0,0,0) scale(" + i.scale + ")"));
          },
          out: function () {
            var e = this.zoom,
              t = this.params.zoom,
              n = e.gesture;
            n.$slideEl ||
              ((n.$slideEl = this.clickedSlide
                ? E(this.clickedSlide)
                : this.slides.eq(this.activeIndex)),
              (n.$imageEl = n.$slideEl.find("img, svg, canvas")),
              (n.$imageWrapEl = n.$imageEl.parent("." + t.containerClass))),
              n.$imageEl &&
                0 !== n.$imageEl.length &&
                ((e.scale = 1),
                (e.currentScale = 1),
                n.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
                n.$imageEl
                  .transition(300)
                  .transform("translate3d(0,0,0) scale(1)"),
                n.$slideEl.removeClass("" + t.zoomedSlideClass),
                (n.$slideEl = void 0));
          },
          enable: function () {
            var e,
              t,
              n = this.zoom;
            n.enabled ||
              ((n.enabled = !0),
              (e = !(
                "touchstart" !== this.touchEvents.start ||
                !w.passiveListener ||
                !this.params.passiveListeners
              ) && { passive: !0, capture: !1 }),
              (t = !w.passiveListener || { passive: !1, capture: !0 }),
              w.gestures
                ? (this.$wrapperEl.on(
                    "gesturestart",
                    ".pwzrswiper-slide",
                    n.onGestureStart,
                    e
                  ),
                  this.$wrapperEl.on(
                    "gesturechange",
                    ".pwzrswiper-slide",
                    n.onGestureChange,
                    e
                  ),
                  this.$wrapperEl.on(
                    "gestureend",
                    ".pwzrswiper-slide",
                    n.onGestureEnd,
                    e
                  ))
                : "touchstart" === this.touchEvents.start &&
                  (this.$wrapperEl.on(
                    this.touchEvents.start,
                    ".pwzrswiper-slide",
                    n.onGestureStart,
                    e
                  ),
                  this.$wrapperEl.on(
                    this.touchEvents.move,
                    ".pwzrswiper-slide",
                    n.onGestureChange,
                    t
                  ),
                  this.$wrapperEl.on(
                    this.touchEvents.end,
                    ".pwzrswiper-slide",
                    n.onGestureEnd,
                    e
                  ),
                  this.touchEvents.cancel &&
                    this.$wrapperEl.on(
                      this.touchEvents.cancel,
                      ".pwzrswiper-slide",
                      n.onGestureEnd,
                      e
                    )),
              this.$wrapperEl.on(
                this.touchEvents.move,
                "." + this.params.zoom.containerClass,
                n.onTouchMove,
                t
              ));
          },
          disable: function () {
            var e,
              t,
              n = this.zoom;
            n.enabled &&
              ((this.zoom.enabled = !1),
              (e = !(
                "touchstart" !== this.touchEvents.start ||
                !w.passiveListener ||
                !this.params.passiveListeners
              ) && { passive: !0, capture: !1 }),
              (t = !w.passiveListener || { passive: !1, capture: !0 }),
              w.gestures
                ? (this.$wrapperEl.off(
                    "gesturestart",
                    ".pwzrswiper-slide",
                    n.onGestureStart,
                    e
                  ),
                  this.$wrapperEl.off(
                    "gesturechange",
                    ".pwzrswiper-slide",
                    n.onGestureChange,
                    e
                  ),
                  this.$wrapperEl.off(
                    "gestureend",
                    ".pwzrswiper-slide",
                    n.onGestureEnd,
                    e
                  ))
                : "touchstart" === this.touchEvents.start &&
                  (this.$wrapperEl.off(
                    this.touchEvents.start,
                    ".pwzrswiper-slide",
                    n.onGestureStart,
                    e
                  ),
                  this.$wrapperEl.off(
                    this.touchEvents.move,
                    ".pwzrswiper-slide",
                    n.onGestureChange,
                    t
                  ),
                  this.$wrapperEl.off(
                    this.touchEvents.end,
                    ".pwzrswiper-slide",
                    n.onGestureEnd,
                    e
                  ),
                  this.touchEvents.cancel &&
                    this.$wrapperEl.off(
                      this.touchEvents.cancel,
                      ".pwzrswiper-slide",
                      n.onGestureEnd,
                      e
                    )),
              this.$wrapperEl.off(
                this.touchEvents.move,
                "." + this.params.zoom.containerClass,
                n.onTouchMove,
                t
              ));
          },
        },
        q = {
          loadInSlide: function (e, s) {
            void 0 === s && (s = !0);
            var l,
              c = this,
              u = c.params.lazy;
            void 0 !== e &&
              0 !== c.slides.length &&
              ((e = (l =
                c.virtual && c.params.virtual.enabled
                  ? c.$wrapperEl.children(
                      "." +
                        c.params.slideClass +
                        '[data-pwzrswiper-slide-index="' +
                        e +
                        '"]'
                    )
                  : c.slides.eq(e)).find(
                "." +
                  u.elementClass +
                  ":not(." +
                  u.loadedClass +
                  "):not(." +
                  u.loadingClass +
                  ")"
              )),
              !l.hasClass(u.elementClass) ||
                l.hasClass(u.loadedClass) ||
                l.hasClass(u.loadingClass) ||
                (e = e.add(l[0])),
              0 !== e.length &&
                e.each(function (e, t) {
                  var n = E(t);
                  n.addClass(u.loadingClass);
                  var r = n.attr("data-background"),
                    i = n.attr("data-src"),
                    o = n.attr("data-srcset"),
                    a = n.attr("data-sizes");
                  c.loadImage(n[0], i || r, o, a, !1, function () {
                    var e, t;
                    null == c ||
                      !c ||
                      (c && !c.params) ||
                      c.destroyed ||
                      (r
                        ? (n.css("background-image", 'url("' + r + '")'),
                          n.removeAttr("data-background"))
                        : (o &&
                            (n.attr("srcset", o), n.removeAttr("data-srcset")),
                          a && (n.attr("sizes", a), n.removeAttr("data-sizes")),
                          i && (n.attr("src", i), n.removeAttr("data-src"))),
                      n.addClass(u.loadedClass).removeClass(u.loadingClass),
                      l.find("." + u.preloaderClass).remove(),
                      c.params.loop &&
                        s &&
                        ((t = l.attr("data-pwzrswiper-slide-index")),
                        l.hasClass(c.params.slideDuplicateClass)
                          ? ((e = c.$wrapperEl.children(
                              '[data-pwzrswiper-slide-index="' +
                                t +
                                '"]:not(.' +
                                c.params.slideDuplicateClass +
                                ")"
                            )),
                            c.lazy.loadInSlide(e.index(), !1))
                          : ((t = c.$wrapperEl.children(
                              "." +
                                c.params.slideDuplicateClass +
                                '[data-pwzrswiper-slide-index="' +
                                t +
                                '"]'
                            )),
                            c.lazy.loadInSlide(t.index(), !1))),
                      c.emit("lazyImageReady", l[0], n[0]));
                  }),
                    c.emit("lazyImageLoad", l[0], n[0]);
                }));
          },
          load: function () {
            var n = this,
              t = n.$wrapperEl,
              r = n.params,
              i = n.slides,
              e = n.activeIndex,
              o = n.virtual && r.virtual.enabled,
              a = r.lazy,
              s = r.slidesPerView;
            function l(e) {
              if (o) {
                if (
                  t.children(
                    "." +
                      r.slideClass +
                      '[data-pwzrswiper-slide-index="' +
                      e +
                      '"]'
                  ).length
                )
                  return 1;
              } else if (i[e]) return 1;
            }
            function c(e) {
              return o
                ? E(e).attr("data-pwzrswiper-slide-index")
                : E(e).index();
            }
            if (
              ("auto" === s && (s = 0),
              n.lazy.initialImageLoaded || (n.lazy.initialImageLoaded = !0),
              n.params.watchSlidesVisibility)
            )
              t.children("." + r.slideVisibleClass).each(function (e, t) {
                t = o ? E(t).attr("data-pwzrswiper-slide-index") : E(t).index();
                n.lazy.loadInSlide(t);
              });
            else if (1 < s)
              for (var u = e; u < e + s; u += 1) l(u) && n.lazy.loadInSlide(u);
            else n.lazy.loadInSlide(e);
            if (a.loadPrevNext)
              if (1 < s || (a.loadPrevNextAmount && 1 < a.loadPrevNextAmount)) {
                for (
                  var d = a.loadPrevNextAmount,
                    a = s,
                    p = Math.min(e + a + Math.max(d, a), i.length),
                    d = Math.max(e - Math.max(a, d), 0),
                    f = e + s;
                  f < p;
                  f += 1
                )
                  l(f) && n.lazy.loadInSlide(f);
                for (var h = d; h < e; h += 1) l(h) && n.lazy.loadInSlide(h);
              } else {
                d = t.children("." + r.slideNextClass);
                0 < d.length && n.lazy.loadInSlide(c(d));
                d = t.children("." + r.slidePrevClass);
                0 < d.length && n.lazy.loadInSlide(c(d));
              }
          },
        },
        U = {
          LinearSpline: function (e, t) {
            var n, r, i, o, a;
            return (
              (this.x = e),
              (this.y = t),
              (this.lastIndex = e.length - 1),
              (this.interpolate = function (e) {
                return e
                  ? ((a = (function (e, t) {
                      for (r = -1, n = e.length; 1 < n - r; )
                        e[(i = (n + r) >> 1)] <= t ? (r = i) : (n = i);
                      return n;
                    })(this.x, e)),
                    (o = a - 1),
                    ((e - this.x[o]) * (this.y[a] - this.y[o])) /
                      (this.x[a] - this.x[o]) +
                      this.y[o])
                  : 0;
              }),
              this
            );
          },
          getInterpolateFunction: function (e) {
            this.controller.spline ||
              (this.controller.spline = this.params.loop
                ? new U.LinearSpline(this.slidesGrid, e.slidesGrid)
                : new U.LinearSpline(this.snapGrid, e.snapGrid));
          },
          setTranslate: function (e, t) {
            var n,
              r,
              i = this,
              o = i.controller.control;
            function a(e) {
              var t = i.rtlTranslate ? -i.translate : i.translate;
              "slide" === i.params.controller.by &&
                (i.controller.getInterpolateFunction(e),
                (r = -i.controller.spline.interpolate(-t))),
                (r && "container" !== i.params.controller.by) ||
                  ((n =
                    (e.maxTranslate() - e.minTranslate()) /
                    (i.maxTranslate() - i.minTranslate())),
                  (r = (t - i.minTranslate()) * n + e.minTranslate())),
                i.params.controller.inverse && (r = e.maxTranslate() - r),
                e.updateProgress(r),
                e.setTranslate(r, i),
                e.updateActiveIndex(),
                e.updateSlidesClasses();
            }
            if (Array.isArray(o))
              for (var s = 0; s < o.length; s += 1)
                o[s] !== t && o[s] instanceof I && a(o[s]);
            else o instanceof I && t !== o && a(o);
          },
          setTransition: function (t, e) {
            var n,
              r = this,
              i = r.controller.control;
            function o(e) {
              e.setTransition(t, r),
                0 !== t &&
                  (e.transitionStart(),
                  e.params.autoHeight &&
                    Y.nextTick(function () {
                      e.updateAutoHeight();
                    }),
                  e.$wrapperEl.transitionEnd(function () {
                    i &&
                      (e.params.loop &&
                        "slide" === r.params.controller.by &&
                        e.loopFix(),
                      e.transitionEnd());
                  }));
            }
            if (Array.isArray(i))
              for (n = 0; n < i.length; n += 1)
                i[n] !== e && i[n] instanceof I && o(i[n]);
            else i instanceof I && e !== i && o(i);
          },
        },
        X = {
          makeElFocusable: function (e) {
            return e.attr("tabIndex", "0"), e;
          },
          addElRole: function (e, t) {
            return e.attr("role", t), e;
          },
          addElLabel: function (e, t) {
            return e.attr("aria-label", t), e;
          },
          disableEl: function (e) {
            return e.attr("aria-disabled", !0), e;
          },
          enableEl: function (e) {
            return e.attr("aria-disabled", !1), e;
          },
          onEnterKey: function (e) {
            var t = this.params.a11y;
            13 === e.keyCode &&
              ((e = E(e.target)),
              this.navigation &&
                this.navigation.$nextEl &&
                e.is(this.navigation.$nextEl) &&
                ((this.isEnd && !this.params.loop) || this.slideNext(),
                this.isEnd
                  ? this.a11y.notify(t.lastSlideMessage)
                  : this.a11y.notify(t.nextSlideMessage)),
              this.navigation &&
                this.navigation.$prevEl &&
                e.is(this.navigation.$prevEl) &&
                ((this.isBeginning && !this.params.loop) || this.slidePrev(),
                this.isBeginning
                  ? this.a11y.notify(t.firstSlideMessage)
                  : this.a11y.notify(t.prevSlideMessage)),
              this.pagination &&
                e.is("." + this.params.pagination.bulletClass) &&
                e[0].click());
          },
          notify: function (e) {
            var t = this.a11y.liveRegion;
            0 !== t.length && (t.html(""), t.html(e));
          },
          updateNavigation: function () {
            var e, t;
            !this.params.loop &&
              this.navigation &&
              ((e = (t = this.navigation).$nextEl),
              (t = t.$prevEl) &&
                0 < t.length &&
                (this.isBeginning
                  ? this.a11y.disableEl(t)
                  : this.a11y.enableEl(t)),
              e &&
                0 < e.length &&
                (this.isEnd ? this.a11y.disableEl(e) : this.a11y.enableEl(e)));
          },
          updatePagination: function () {
            var n = this,
              r = n.params.a11y;
            n.pagination &&
              n.params.pagination.clickable &&
              n.pagination.bullets &&
              n.pagination.bullets.length &&
              n.pagination.bullets.each(function (e, t) {
                t = E(t);
                n.a11y.makeElFocusable(t),
                  n.a11y.addElRole(t, "button"),
                  n.a11y.addElLabel(
                    t,
                    r.paginationBulletMessage.replace(
                      /{{index}}/,
                      t.index() + 1
                    )
                  );
              });
          },
          init: function () {
            this.$el.append(this.a11y.liveRegion);
            var e,
              t,
              n = this.params.a11y;
            this.navigation &&
              this.navigation.$nextEl &&
              (e = this.navigation.$nextEl),
              this.navigation &&
                this.navigation.$prevEl &&
                (t = this.navigation.$prevEl),
              e &&
                (this.a11y.makeElFocusable(e),
                this.a11y.addElRole(e, "button"),
                this.a11y.addElLabel(e, n.nextSlideMessage),
                e.on("keydown", this.a11y.onEnterKey)),
              t &&
                (this.a11y.makeElFocusable(t),
                this.a11y.addElRole(t, "button"),
                this.a11y.addElLabel(t, n.prevSlideMessage),
                t.on("keydown", this.a11y.onEnterKey)),
              this.pagination &&
                this.params.pagination.clickable &&
                this.pagination.bullets &&
                this.pagination.bullets.length &&
                this.pagination.$el.on(
                  "keydown",
                  "." + this.params.pagination.bulletClass,
                  this.a11y.onEnterKey
                );
          },
          destroy: function () {
            var e, t;
            this.a11y.liveRegion &&
              0 < this.a11y.liveRegion.length &&
              this.a11y.liveRegion.remove(),
              this.navigation &&
                this.navigation.$nextEl &&
                (e = this.navigation.$nextEl),
              this.navigation &&
                this.navigation.$prevEl &&
                (t = this.navigation.$prevEl),
              e && e.off("keydown", this.a11y.onEnterKey),
              t && t.off("keydown", this.a11y.onEnterKey),
              this.pagination &&
                this.params.pagination.clickable &&
                this.pagination.bullets &&
                this.pagination.bullets.length &&
                this.pagination.$el.off(
                  "keydown",
                  "." + this.params.pagination.bulletClass,
                  this.a11y.onEnterKey
                );
          },
        },
        K = {
          init: function () {
            if (this.params.history) {
              if (!G.history || !G.history.pushState)
                return (
                  (this.params.history.enabled = !1),
                  void (this.params.hashNavigation.enabled = !0)
                );
              var e = this.history;
              (e.initialized = !0),
                (e.paths = K.getPathValues()),
                (e.paths.key || e.paths.value) &&
                  (e.scrollToSlide(
                    0,
                    e.paths.value,
                    this.params.runCallbacksOnInit
                  ),
                  this.params.history.replaceState ||
                    G.addEventListener(
                      "popstate",
                      this.history.setHistoryPopState
                    ));
            }
          },
          destroy: function () {
            this.params.history.replaceState ||
              G.removeEventListener(
                "popstate",
                this.history.setHistoryPopState
              );
          },
          setHistoryPopState: function () {
            (this.history.paths = K.getPathValues()),
              this.history.scrollToSlide(
                this.params.speed,
                this.history.paths.value,
                !1
              );
          },
          getPathValues: function () {
            var e = G.location.pathname
                .slice(1)
                .split("/")
                .filter(function (e) {
                  return "" !== e;
                }),
              t = e.length;
            return { key: e[t - 2], value: e[t - 1] };
          },
          setHistory: function (e, t) {
            this.history.initialized &&
              this.params.history.enabled &&
              ((t = this.slides.eq(t)),
              (t = K.slugify(t.attr("data-history"))),
              G.location.pathname.includes(e) || (t = e + "/" + t),
              ((e = G.history.state) && e.value === t) ||
                (this.params.history.replaceState
                  ? G.history.replaceState({ value: t }, null, t)
                  : G.history.pushState({ value: t }, null, t)));
          },
          slugify: function (e) {
            return e
              .toString()
              .replace(/\s+/g, "-")
              .replace(/[^\w-]+/g, "")
              .replace(/--+/g, "-")
              .replace(/^-+/, "")
              .replace(/-+$/, "");
          },
          scrollToSlide: function (e, t, n) {
            if (t)
              for (var r = 0, i = this.slides.length; r < i; r += 1) {
                var o = this.slides.eq(r);
                K.slugify(o.attr("data-history")) !== t ||
                  o.hasClass(this.params.slideDuplicateClass) ||
                  ((o = o.index()), this.slideTo(o, e, n));
              }
            else this.slideTo(0, e, n);
          },
        },
        Z = {
          onHashCange: function () {
            var e = d.location.hash.replace("#", "");
            e === this.slides.eq(this.activeIndex).attr("data-hash") ||
              (void 0 !==
                (e = this.$wrapperEl
                  .children(
                    "." + this.params.slideClass + '[data-hash="' + e + '"]'
                  )
                  .index()) &&
                this.slideTo(e));
          },
          setHash: function () {
            var e;
            this.hashNavigation.initialized &&
              this.params.hashNavigation.enabled &&
              (this.params.hashNavigation.replaceState &&
              G.history &&
              G.history.replaceState
                ? G.history.replaceState(
                    null,
                    null,
                    "#" + this.slides.eq(this.activeIndex).attr("data-hash") ||
                      ""
                  )
                : ((e =
                    (e = this.slides.eq(this.activeIndex)).attr("data-hash") ||
                    e.attr("data-history")),
                  (d.location.hash = e || "")));
          },
          init: function () {
            if (
              !(
                !this.params.hashNavigation.enabled ||
                (this.params.history && this.params.history.enabled)
              )
            ) {
              this.hashNavigation.initialized = !0;
              var e = d.location.hash.replace("#", "");
              if (e)
                for (var t = 0, n = this.slides.length; t < n; t += 1) {
                  var r = this.slides.eq(t);
                  (r.attr("data-hash") || r.attr("data-history")) !== e ||
                    r.hasClass(this.params.slideDuplicateClass) ||
                    ((r = r.index()),
                    this.slideTo(r, 0, this.params.runCallbacksOnInit, !0));
                }
              this.params.hashNavigation.watchState &&
                E(G).on("hashchange", this.hashNavigation.onHashCange);
            }
          },
          destroy: function () {
            this.params.hashNavigation.watchState &&
              E(G).off("hashchange", this.hashNavigation.onHashCange);
          },
        },
        Q = {
          run: function () {
            var e = this,
              t = e.slides.eq(e.activeIndex),
              n = e.params.autoplay.delay;
            t.attr("data-pwzrswiper-autoplay") &&
              (n =
                t.attr("data-pwzrswiper-autoplay") || e.params.autoplay.delay),
              clearTimeout(e.autoplay.timeout),
              (e.autoplay.timeout = Y.nextTick(function () {
                e.params.autoplay.reverseDirection
                  ? e.params.loop
                    ? (e.loopFix(),
                      e.slidePrev(e.params.speed, !0, !0),
                      e.emit("autoplay"))
                    : e.isBeginning
                    ? e.params.autoplay.stopOnLastSlide
                      ? e.autoplay.stop()
                      : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0),
                        e.emit("autoplay"))
                    : (e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay"))
                  : e.params.loop
                  ? (e.loopFix(),
                    e.slideNext(e.params.speed, !0, !0),
                    e.emit("autoplay"))
                  : e.isEnd
                  ? e.params.autoplay.stopOnLastSlide
                    ? e.autoplay.stop()
                    : (e.slideTo(0, e.params.speed, !0, !0), e.emit("autoplay"))
                  : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")),
                  e.params.cssMode && e.autoplay.running && e.autoplay.run();
              }, n));
          },
          start: function () {
            return (
              void 0 === this.autoplay.timeout &&
              !this.autoplay.running &&
              ((this.autoplay.running = !0),
              this.emit("autoplayStart"),
              this.autoplay.run(),
              !0)
            );
          },
          stop: function () {
            return (
              !!this.autoplay.running &&
              void 0 !== this.autoplay.timeout &&
              (this.autoplay.timeout &&
                (clearTimeout(this.autoplay.timeout),
                (this.autoplay.timeout = void 0)),
              (this.autoplay.running = !1),
              this.emit("autoplayStop"),
              !0)
            );
          },
          pause: function (e) {
            this.autoplay.running &&
              (this.autoplay.paused ||
                (this.autoplay.timeout && clearTimeout(this.autoplay.timeout),
                (this.autoplay.paused = !0),
                0 !== e && this.params.autoplay.waitForTransition
                  ? (this.$wrapperEl[0].addEventListener(
                      "transitionend",
                      this.autoplay.onTransitionEnd
                    ),
                    this.$wrapperEl[0].addEventListener(
                      "webkitTransitionEnd",
                      this.autoplay.onTransitionEnd
                    ))
                  : ((this.autoplay.paused = !1), this.autoplay.run())));
          },
        },
        J = {
          setTranslate: function () {
            for (var e = this.slides, t = 0; t < e.length; t += 1) {
              var n = this.slides.eq(t),
                r = -n[0].swiperSlideOffset;
              this.params.virtualTranslate || (r -= this.translate);
              var i = 0;
              this.isHorizontal() || ((i = r), (r = 0));
              var o = this.params.fadeEffect.crossFade
                ? Math.max(1 - Math.abs(n[0].progress), 0)
                : 1 + Math.min(Math.max(n[0].progress, -1), 0);
              n.css({ opacity: o }).transform(
                "translate3d(" + r + "px, " + i + "px, 0px)"
              );
            }
          },
          setTransition: function (e) {
            var n,
              r = this,
              t = r.slides,
              i = r.$wrapperEl;
            t.transition(e),
              r.params.virtualTranslate &&
                0 !== e &&
                ((n = !1),
                t.transitionEnd(function () {
                  if (!n && r && !r.destroyed) {
                    (n = !0), (r.animating = !1);
                    for (
                      var e = ["webkitTransitionEnd", "transitionend"], t = 0;
                      t < e.length;
                      t += 1
                    )
                      i.trigger(e[t]);
                  }
                }));
          },
        },
        ee = {
          setTranslate: function () {
            var e,
              t = this.$el,
              n = this.$wrapperEl,
              r = this.slides,
              i = this.width,
              o = this.height,
              a = this.rtlTranslate,
              s = this.size,
              l = this.params.cubeEffect,
              c = this.isHorizontal(),
              u = this.virtual && this.params.virtual.enabled,
              d = 0;
            l.shadow &&
              (c
                ? (0 === (e = n.find(".pwzrswiper-cube-shadow")).length &&
                    ((e = E('<div class="pwzrswiper-cube-shadow"></div>')),
                    n.append(e)),
                  e.css({ height: i + "px" }))
                : 0 === (e = t.find(".pwzrswiper-cube-shadow")).length &&
                  ((e = E('<div class="pwzrswiper-cube-shadow"></div>')),
                  t.append(e)));
            for (var p = 0; p < r.length; p += 1) {
              var f = r.eq(p),
                h = p;
              u && (h = parseInt(f.attr("data-pwzrswiper-slide-index"), 10));
              var m = 90 * h,
                g = Math.floor(m / 360);
              a && ((m = -m), (g = Math.floor(-m / 360)));
              var v = Math.max(Math.min(f[0].progress, 1), -1),
                y = 0,
                b = 0,
                w = 0;
              h % 4 == 0
                ? ((y = 4 * -g * s), (w = 0))
                : (h - 1) % 4 == 0
                ? ((y = 0), (w = 4 * -g * s))
                : (h - 2) % 4 == 0
                ? ((y = s + 4 * g * s), (w = s))
                : (h - 3) % 4 == 0 && ((y = -s), (w = 3 * s + 4 * s * g)),
                a && (y = -y),
                c || ((b = y), (y = 0));
              w =
                "rotateX(" +
                (c ? 0 : -m) +
                "deg) rotateY(" +
                (c ? m : 0) +
                "deg) translate3d(" +
                y +
                "px, " +
                b +
                "px, " +
                w +
                "px)";
              v <= 1 && -1 < v && (d = a ? 90 * -h - 90 * v : 90 * h + 90 * v),
                f.transform(w),
                l.slideShadows &&
                  ((h = c
                    ? f.find(".pwzrswiper-slide-shadow-left")
                    : f.find(".pwzrswiper-slide-shadow-top")),
                  (w = c
                    ? f.find(".pwzrswiper-slide-shadow-right")
                    : f.find(".pwzrswiper-slide-shadow-bottom")),
                  0 === h.length &&
                    ((h = E(
                      '<div class="pwzrswiper-slide-shadow-' +
                        (c ? "left" : "top") +
                        '"></div>'
                    )),
                    f.append(h)),
                  0 === w.length &&
                    ((w = E(
                      '<div class="pwzrswiper-slide-shadow-' +
                        (c ? "right" : "bottom") +
                        '"></div>'
                    )),
                    f.append(w)),
                  h.length && (h[0].style.opacity = Math.max(-v, 0)),
                  w.length && (w[0].style.opacity = Math.max(v, 0)));
            }
            n.css({
              "-webkit-transform-origin": "50% 50% -" + s / 2 + "px",
              "-moz-transform-origin": "50% 50% -" + s / 2 + "px",
              "-ms-transform-origin": "50% 50% -" + s / 2 + "px",
              "transform-origin": "50% 50% -" + s / 2 + "px",
            }),
              l.shadow &&
                (c
                  ? e.transform(
                      "translate3d(0px, " +
                        (i / 2 + l.shadowOffset) +
                        "px, " +
                        -i / 2 +
                        "px) rotateX(90deg) rotateZ(0deg) scale(" +
                        l.shadowScale +
                        ")"
                    )
                  : ((x = Math.abs(d) - 90 * Math.floor(Math.abs(d) / 90)),
                    (t =
                      1.5 -
                      (Math.sin((2 * x * Math.PI) / 360) / 2 +
                        Math.cos((2 * x * Math.PI) / 360) / 2)),
                    (i = l.shadowScale),
                    (x = l.shadowScale / t),
                    (t = l.shadowOffset),
                    e.transform(
                      "scale3d(" +
                        i +
                        ", 1, " +
                        x +
                        ") translate3d(0px, " +
                        (o / 2 + t) +
                        "px, " +
                        -o / 2 / x +
                        "px) rotateX(-90deg)"
                    )));
            var x = _.isSafari || _.isUiWebView ? -s / 2 : 0;
            n.transform(
              "translate3d(0px,0," +
                x +
                "px) rotateX(" +
                (this.isHorizontal() ? 0 : d) +
                "deg) rotateY(" +
                (this.isHorizontal() ? -d : 0) +
                "deg)"
            );
          },
          setTransition: function (e) {
            var t = this.$el;
            this.slides
              .transition(e)
              .find(
                ".pwzrswiper-slide-shadow-top, .pwzrswiper-slide-shadow-right, .pwzrswiper-slide-shadow-bottom, .pwzrswiper-slide-shadow-left"
              )
              .transition(e),
              this.params.cubeEffect.shadow &&
                !this.isHorizontal() &&
                t.find(".pwzrswiper-cube-shadow").transition(e);
          },
        },
        te = {
          setTranslate: function () {
            for (
              var e = this.slides, t = this.rtlTranslate, n = 0;
              n < e.length;
              n += 1
            ) {
              var r = e.eq(n),
                i = r[0].progress;
              this.params.flipEffect.limitRotation &&
                (i = Math.max(Math.min(r[0].progress, 1), -1));
              var o,
                a,
                s = -180 * i,
                l = 0,
                c = -r[0].swiperSlideOffset,
                u = 0;
              this.isHorizontal()
                ? t && (s = -s)
                : ((u = c), (l = -s), (s = c = 0)),
                (r[0].style.zIndex = -Math.abs(Math.round(i)) + e.length),
                this.params.flipEffect.slideShadows &&
                  ((o = this.isHorizontal()
                    ? r.find(".pwzrswiper-slide-shadow-left")
                    : r.find(".pwzrswiper-slide-shadow-top")),
                  (a = this.isHorizontal()
                    ? r.find(".pwzrswiper-slide-shadow-right")
                    : r.find(".pwzrswiper-slide-shadow-bottom")),
                  0 === o.length &&
                    ((o = E(
                      '<div class="pwzrswiper-slide-shadow-' +
                        (this.isHorizontal() ? "left" : "top") +
                        '"></div>'
                    )),
                    r.append(o)),
                  0 === a.length &&
                    ((a = E(
                      '<div class="pwzrswiper-slide-shadow-' +
                        (this.isHorizontal() ? "right" : "bottom") +
                        '"></div>'
                    )),
                    r.append(a)),
                  o.length && (o[0].style.opacity = Math.max(-i, 0)),
                  a.length && (a[0].style.opacity = Math.max(i, 0))),
                r.transform(
                  "translate3d(" +
                    c +
                    "px, " +
                    u +
                    "px, 0px) rotateX(" +
                    l +
                    "deg) rotateY(" +
                    s +
                    "deg)"
                );
            }
          },
          setTransition: function (e) {
            var n,
              r = this,
              t = r.slides,
              i = r.activeIndex,
              o = r.$wrapperEl;
            t
              .transition(e)
              .find(
                ".pwzrswiper-slide-shadow-top, .pwzrswiper-slide-shadow-right, .pwzrswiper-slide-shadow-bottom, .pwzrswiper-slide-shadow-left"
              )
              .transition(e),
              r.params.virtualTranslate &&
                0 !== e &&
                ((n = !1),
                t.eq(i).transitionEnd(function () {
                  if (!n && r && !r.destroyed) {
                    (n = !0), (r.animating = !1);
                    for (
                      var e = ["webkitTransitionEnd", "transitionend"], t = 0;
                      t < e.length;
                      t += 1
                    )
                      o.trigger(e[t]);
                  }
                }));
          },
        },
        ne = {
          setTranslate: function () {
            for (
              var e = this.width,
                t = this.height,
                n = this.slides,
                r = this.$wrapperEl,
                i = this.slidesSizesGrid,
                o = this.params.coverflowEffect,
                a = this.isHorizontal(),
                s = this.translate,
                l = a ? e / 2 - s : t / 2 - s,
                c = a ? o.rotate : -o.rotate,
                u = o.depth,
                d = 0,
                p = n.length;
              d < p;
              d += 1
            ) {
              var f = n.eq(d),
                h = i[d],
                m = ((l - f[0].swiperSlideOffset - h / 2) / h) * o.modifier,
                g = a ? c * m : 0,
                v = a ? 0 : c * m,
                y = -u * Math.abs(m),
                b = a ? 0 : o.stretch * m,
                h = a ? o.stretch * m : 0;
              Math.abs(h) < 0.001 && (h = 0),
                Math.abs(b) < 0.001 && (b = 0),
                Math.abs(y) < 0.001 && (y = 0),
                Math.abs(g) < 0.001 && (g = 0),
                Math.abs(v) < 0.001 && (v = 0);
              v =
                "translate3d(" +
                h +
                "px," +
                b +
                "px," +
                y +
                "px)  rotateX(" +
                v +
                "deg) rotateY(" +
                g +
                "deg)";
              f.transform(v),
                (f[0].style.zIndex = 1 - Math.abs(Math.round(m))),
                o.slideShadows &&
                  ((g = a
                    ? f.find(".pwzrswiper-slide-shadow-left")
                    : f.find(".pwzrswiper-slide-shadow-top")),
                  (v = a
                    ? f.find(".pwzrswiper-slide-shadow-right")
                    : f.find(".pwzrswiper-slide-shadow-bottom")),
                  0 === g.length &&
                    ((g = E(
                      '<div class="pwzrswiper-slide-shadow-' +
                        (a ? "left" : "top") +
                        '"></div>'
                    )),
                    f.append(g)),
                  0 === v.length &&
                    ((v = E(
                      '<div class="pwzrswiper-slide-shadow-' +
                        (a ? "right" : "bottom") +
                        '"></div>'
                    )),
                    f.append(v)),
                  g.length && (g[0].style.opacity = 0 < m ? m : 0),
                  v.length && (v[0].style.opacity = 0 < -m ? -m : 0));
            }
            (w.pointerEvents || w.prefixedPointerEvents) &&
              (r[0].style.perspectiveOrigin = l + "px 50%");
          },
          setTransition: function (e) {
            this.slides
              .transition(e)
              .find(
                ".pwzrswiper-slide-shadow-top, .pwzrswiper-slide-shadow-right, .pwzrswiper-slide-shadow-bottom, .pwzrswiper-slide-shadow-left"
              )
              .transition(e);
          },
        },
        re = {
          init: function () {
            var e = this.params.thumbs,
              t = this.constructor;
            e.swiper instanceof t
              ? ((this.thumbs.swiper = e.swiper),
                Y.extend(this.thumbs.swiper.originalParams, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }),
                Y.extend(this.thumbs.swiper.params, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }))
              : Y.isObject(e.swiper) &&
                ((this.thumbs.swiper = new t(
                  Y.extend({}, e.swiper, {
                    watchSlidesVisibility: !0,
                    watchSlidesProgress: !0,
                    slideToClickedSlide: !1,
                  })
                )),
                (this.thumbs.swiperCreated = !0)),
              this.thumbs.swiper.$el.addClass(
                this.params.thumbs.thumbsContainerClass
              ),
              this.thumbs.swiper.on("tap", this.thumbs.onThumbClick);
          },
          onThumbClick: function () {
            var e,
              t,
              n,
              r = this.thumbs.swiper;
            r &&
              ((t = r.clickedIndex),
              ((e = r.clickedSlide) &&
                E(e).hasClass(this.params.thumbs.slideThumbActiveClass)) ||
                null == t ||
                ((n = r.params.loop
                  ? parseInt(
                      E(r.clickedSlide).attr("data-pwzrswiper-slide-index"),
                      10
                    )
                  : t),
                this.params.loop &&
                  ((e = this.activeIndex),
                  this.slides.eq(e).hasClass(this.params.slideDuplicateClass) &&
                    (this.loopFix(),
                    (this._clientLeft = this.$wrapperEl[0].clientLeft),
                    (e = this.activeIndex)),
                  (r = this.slides
                    .eq(e)
                    .prevAll('[data-pwzrswiper-slide-index="' + n + '"]')
                    .eq(0)
                    .index()),
                  (t = this.slides
                    .eq(e)
                    .nextAll('[data-pwzrswiper-slide-index="' + n + '"]')
                    .eq(0)
                    .index()),
                  (n =
                    void 0 === r || (void 0 !== t && t - e < e - r) ? t : r)),
                this.slideTo(n)));
          },
          update: function (e) {
            var t = this.thumbs.swiper;
            if (t) {
              var n,
                r,
                i,
                o =
                  "auto" === t.params.slidesPerView
                    ? t.slidesPerViewDynamic()
                    : t.params.slidesPerView;
              this.realIndex !== t.realIndex &&
                ((n = t.activeIndex),
                (i = t.params.loop
                  ? (t.slides.eq(n).hasClass(t.params.slideDuplicateClass) &&
                      (t.loopFix(),
                      (t._clientLeft = t.$wrapperEl[0].clientLeft),
                      (n = t.activeIndex)),
                    (i = t.slides
                      .eq(n)
                      .prevAll(
                        '[data-pwzrswiper-slide-index="' + this.realIndex + '"]'
                      )
                      .eq(0)
                      .index()),
                    (r = t.slides
                      .eq(n)
                      .nextAll(
                        '[data-pwzrswiper-slide-index="' + this.realIndex + '"]'
                      )
                      .eq(0)
                      .index()),
                    void 0 === i
                      ? r
                      : void 0 === r
                      ? i
                      : r - n == n - i
                      ? n
                      : r - n < n - i
                      ? r
                      : i)
                  : this.realIndex),
                t.visibleSlidesIndexes &&
                  t.visibleSlidesIndexes.indexOf(i) < 0 &&
                  (t.params.centeredSlides
                    ? (i =
                        n < i
                          ? i - Math.floor(o / 2) + 1
                          : i + Math.floor(o / 2) - 1)
                    : n < i && (i = i - o + 1),
                  t.slideTo(i, e ? 0 : void 0)));
              var a = 1,
                s = this.params.thumbs.slideThumbActiveClass;
              if (
                (1 < this.params.slidesPerView &&
                  !this.params.centeredSlides &&
                  (a = this.params.slidesPerView),
                this.params.thumbs.multipleActiveThumbs || (a = 1),
                (a = Math.floor(a)),
                t.slides.removeClass(s),
                t.params.loop || (t.params.virtual && t.params.virtual.enabled))
              )
                for (var l = 0; l < a; l += 1)
                  t.$wrapperEl
                    .children(
                      '[data-pwzrswiper-slide-index="' +
                        (this.realIndex + l) +
                        '"]'
                    )
                    .addClass(s);
              else
                for (var c = 0; c < a; c += 1)
                  t.slides.eq(this.realIndex + c).addClass(s);
            }
          },
        },
        S = [
          b,
          x,
          C,
          k,
          T,
          e,
          S,
          {
            name: "mousewheel",
            params: {
              mousewheel: {
                enabled: !1,
                releaseOnEdges: !1,
                invert: !1,
                forceToAxis: !1,
                sensitivity: 1,
                eventsTarged: "container",
              },
            },
            create: function () {
              Y.extend(this, {
                mousewheel: {
                  enabled: !1,
                  enable: B.enable.bind(this),
                  disable: B.disable.bind(this),
                  handle: B.handle.bind(this),
                  handleMouseEnter: B.handleMouseEnter.bind(this),
                  handleMouseLeave: B.handleMouseLeave.bind(this),
                  animateSlider: B.animateSlider.bind(this),
                  releaseScroll: B.releaseScroll.bind(this),
                  lastScrollTime: Y.now(),
                  lastEventBeforeSnap: void 0,
                  recentWheelEvents: [],
                },
              });
            },
            on: {
              init: function () {
                !this.params.mousewheel.enabled &&
                  this.params.cssMode &&
                  this.mousewheel.disable(),
                  this.params.mousewheel.enabled && this.mousewheel.enable();
              },
              destroy: function () {
                this.params.cssMode && this.mousewheel.enable(),
                  this.mousewheel.enabled && this.mousewheel.disable();
              },
            },
          },
          {
            name: "navigation",
            params: {
              navigation: {
                nextEl: null,
                prevEl: null,
                hideOnClick: !1,
                disabledClass: "pwzrswiper-button-disabled",
                hiddenClass: "pwzrswiper-button-hidden",
                lockClass: "pwzrswiper-button-lock",
              },
            },
            create: function () {
              Y.extend(this, {
                navigation: {
                  init: W.init.bind(this),
                  update: W.update.bind(this),
                  destroy: W.destroy.bind(this),
                  onNextClick: W.onNextClick.bind(this),
                  onPrevClick: W.onPrevClick.bind(this),
                },
              });
            },
            on: {
              init: function () {
                this.navigation.init(), this.navigation.update();
              },
              toEdge: function () {
                this.navigation.update();
              },
              fromEdge: function () {
                this.navigation.update();
              },
              destroy: function () {
                this.navigation.destroy();
              },
              click: function (e) {
                var t,
                  n = this.navigation,
                  r = n.$nextEl,
                  n = n.$prevEl;
                !this.params.navigation.hideOnClick ||
                  E(e.target).is(n) ||
                  E(e.target).is(r) ||
                  (r
                    ? (t = r.hasClass(this.params.navigation.hiddenClass))
                    : n && (t = n.hasClass(this.params.navigation.hiddenClass)),
                  !0 === t
                    ? this.emit("navigationShow", this)
                    : this.emit("navigationHide", this),
                  r && r.toggleClass(this.params.navigation.hiddenClass),
                  n && n.toggleClass(this.params.navigation.hiddenClass));
              },
            },
          },
          {
            name: "pagination",
            params: {
              pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: function (e) {
                  return e;
                },
                formatFractionTotal: function (e) {
                  return e;
                },
                bulletClass: "pwzrswiper-pagination-bullet",
                bulletActiveClass: "pwzrswiper-pagination-bullet-active",
                modifierClass: "pwzrswiper-pagination-",
                currentClass: "pwzrswiper-pagination-current",
                totalClass: "pwzrswiper-pagination-total",
                hiddenClass: "pwzrswiper-pagination-hidden",
                progressbarFillClass: "pwzrswiper-pagination-progressbar-fill",
                progressbarOppositeClass:
                  "pwzrswiper-pagination-progressbar-opposite",
                clickableClass: "pwzrswiper-pagination-clickable",
                lockClass: "pwzrswiper-pagination-lock",
              },
            },
            create: function () {
              Y.extend(this, {
                pagination: {
                  init: $.init.bind(this),
                  render: $.render.bind(this),
                  update: $.update.bind(this),
                  destroy: $.destroy.bind(this),
                  dynamicBulletIndex: 0,
                },
              });
            },
            on: {
              init: function () {
                this.pagination.init(),
                  this.pagination.render(),
                  this.pagination.update();
              },
              activeIndexChange: function () {
                (!this.params.loop && void 0 !== this.snapIndex) ||
                  this.pagination.update();
              },
              snapIndexChange: function () {
                this.params.loop || this.pagination.update();
              },
              slidesLengthChange: function () {
                this.params.loop &&
                  (this.pagination.render(), this.pagination.update());
              },
              snapGridLengthChange: function () {
                this.params.loop ||
                  (this.pagination.render(), this.pagination.update());
              },
              destroy: function () {
                this.pagination.destroy();
              },
              click: function (e) {
                this.params.pagination.el &&
                  this.params.pagination.hideOnClick &&
                  0 < this.pagination.$el.length &&
                  !E(e.target).hasClass(this.params.pagination.bulletClass) &&
                  (!0 ===
                  this.pagination.$el.hasClass(
                    this.params.pagination.hiddenClass
                  )
                    ? this.emit("paginationShow", this)
                    : this.emit("paginationHide", this),
                  this.pagination.$el.toggleClass(
                    this.params.pagination.hiddenClass
                  ));
              },
            },
          },
          {
            name: "scrollbar",
            params: {
              scrollbar: {
                el: null,
                dragSize: "auto",
                hide: !1,
                draggable: !1,
                snapOnRelease: !0,
                lockClass: "pwzrswiper-scrollbar-lock",
                dragClass: "pwzrswiper-scrollbar-drag",
              },
            },
            create: function () {
              Y.extend(this, {
                scrollbar: {
                  init: j.init.bind(this),
                  destroy: j.destroy.bind(this),
                  updateSize: j.updateSize.bind(this),
                  setTranslate: j.setTranslate.bind(this),
                  setTransition: j.setTransition.bind(this),
                  enableDraggable: j.enableDraggable.bind(this),
                  disableDraggable: j.disableDraggable.bind(this),
                  setDragPosition: j.setDragPosition.bind(this),
                  getPointerPosition: j.getPointerPosition.bind(this),
                  onDragStart: j.onDragStart.bind(this),
                  onDragMove: j.onDragMove.bind(this),
                  onDragEnd: j.onDragEnd.bind(this),
                  isTouched: !1,
                  timeout: null,
                  dragTimeout: null,
                },
              });
            },
            on: {
              init: function () {
                this.scrollbar.init(),
                  this.scrollbar.updateSize(),
                  this.scrollbar.setTranslate();
              },
              update: function () {
                this.scrollbar.updateSize();
              },
              resize: function () {
                this.scrollbar.updateSize();
              },
              observerUpdate: function () {
                this.scrollbar.updateSize();
              },
              setTranslate: function () {
                this.scrollbar.setTranslate();
              },
              setTransition: function (e) {
                this.scrollbar.setTransition(e);
              },
              destroy: function () {
                this.scrollbar.destroy();
              },
            },
          },
          {
            name: "parallax",
            params: { parallax: { enabled: !1 } },
            create: function () {
              Y.extend(this, {
                parallax: {
                  setTransform: H.setTransform.bind(this),
                  setTranslate: H.setTranslate.bind(this),
                  setTransition: H.setTransition.bind(this),
                },
              });
            },
            on: {
              beforeInit: function () {
                this.params.parallax.enabled &&
                  ((this.params.watchSlidesProgress = !0),
                  (this.originalParams.watchSlidesProgress = !0));
              },
              init: function () {
                this.params.parallax.enabled && this.parallax.setTranslate();
              },
              setTranslate: function () {
                this.params.parallax.enabled && this.parallax.setTranslate();
              },
              setTransition: function (e) {
                this.params.parallax.enabled && this.parallax.setTransition(e);
              },
            },
          },
          {
            name: "zoom",
            params: {
              zoom: {
                enabled: !1,
                maxRatio: 3,
                minRatio: 1,
                toggle: !0,
                containerClass: "pwzrswiper-zoom-container",
                zoomedSlideClass: "pwzrswiper-slide-zoomed",
              },
            },
            create: function () {
              var r = this,
                t = {
                  enabled: !1,
                  scale: 1,
                  currentScale: 1,
                  isScaling: !1,
                  gesture: {
                    $slideEl: void 0,
                    slideWidth: void 0,
                    slideHeight: void 0,
                    $imageEl: void 0,
                    $imageWrapEl: void 0,
                    maxRatio: 3,
                  },
                  image: {
                    isTouched: void 0,
                    isMoved: void 0,
                    currentX: void 0,
                    currentY: void 0,
                    minX: void 0,
                    minY: void 0,
                    maxX: void 0,
                    maxY: void 0,
                    width: void 0,
                    height: void 0,
                    startX: void 0,
                    startY: void 0,
                    touchesStart: {},
                    touchesCurrent: {},
                  },
                  velocity: {
                    x: void 0,
                    y: void 0,
                    prevPositionX: void 0,
                    prevPositionY: void 0,
                    prevTime: void 0,
                  },
                };
              "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out"
                .split(" ")
                .forEach(function (e) {
                  t[e] = V[e].bind(r);
                }),
                Y.extend(r, { zoom: t });
              var i = 1;
              Object.defineProperty(r.zoom, "scale", {
                get: function () {
                  return i;
                },
                set: function (e) {
                  var t, n;
                  i !== e &&
                    ((t = r.zoom.gesture.$imageEl
                      ? r.zoom.gesture.$imageEl[0]
                      : void 0),
                    (n = r.zoom.gesture.$slideEl
                      ? r.zoom.gesture.$slideEl[0]
                      : void 0),
                    r.emit("zoomChange", e, t, n)),
                    (i = e);
                },
              });
            },
            on: {
              init: function () {
                this.params.zoom.enabled && this.zoom.enable();
              },
              destroy: function () {
                this.zoom.disable();
              },
              touchStart: function (e) {
                this.zoom.enabled && this.zoom.onTouchStart(e);
              },
              touchEnd: function (e) {
                this.zoom.enabled && this.zoom.onTouchEnd(e);
              },
              doubleTap: function (e) {
                this.params.zoom.enabled &&
                  this.zoom.enabled &&
                  this.params.zoom.toggle &&
                  this.zoom.toggle(e);
              },
              transitionEnd: function () {
                this.zoom.enabled &&
                  this.params.zoom.enabled &&
                  this.zoom.onTransitionEnd();
              },
              slideChange: function () {
                this.zoom.enabled &&
                  this.params.zoom.enabled &&
                  this.params.cssMode &&
                  this.zoom.onTransitionEnd();
              },
            },
          },
          {
            name: "lazy",
            params: {
              lazy: {
                enabled: !1,
                loadPrevNext: !1,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: !1,
                elementClass: "pwzrswiper-lazy",
                loadingClass: "pwzrswiper-lazy-loading",
                loadedClass: "pwzrswiper-lazy-loaded",
                preloaderClass: "pwzrswiper-lazy-preloader",
              },
            },
            create: function () {
              Y.extend(this, {
                lazy: {
                  initialImageLoaded: !1,
                  load: q.load.bind(this),
                  loadInSlide: q.loadInSlide.bind(this),
                },
              });
            },
            on: {
              beforeInit: function () {
                this.params.lazy.enabled &&
                  this.params.preloadImages &&
                  (this.params.preloadImages = !1);
              },
              init: function () {
                this.params.lazy.enabled &&
                  !this.params.loop &&
                  0 === this.params.initialSlide &&
                  this.lazy.load();
              },
              scroll: function () {
                this.params.freeMode &&
                  !this.params.freeModeSticky &&
                  this.lazy.load();
              },
              resize: function () {
                this.params.lazy.enabled && this.lazy.load();
              },
              scrollbarDragMove: function () {
                this.params.lazy.enabled && this.lazy.load();
              },
              transitionStart: function () {
                this.params.lazy.enabled &&
                  (this.params.lazy.loadOnTransitionStart ||
                    (!this.params.lazy.loadOnTransitionStart &&
                      !this.lazy.initialImageLoaded)) &&
                  this.lazy.load();
              },
              transitionEnd: function () {
                this.params.lazy.enabled &&
                  !this.params.lazy.loadOnTransitionStart &&
                  this.lazy.load();
              },
              slideChange: function () {
                this.params.lazy.enabled &&
                  this.params.cssMode &&
                  this.lazy.load();
              },
            },
          },
          {
            name: "controller",
            params: {
              controller: { control: void 0, inverse: !1, by: "slide" },
            },
            create: function () {
              Y.extend(this, {
                controller: {
                  control: this.params.controller.control,
                  getInterpolateFunction: U.getInterpolateFunction.bind(this),
                  setTranslate: U.setTranslate.bind(this),
                  setTransition: U.setTransition.bind(this),
                },
              });
            },
            on: {
              update: function () {
                this.controller.control &&
                  this.controller.spline &&
                  ((this.controller.spline = void 0),
                  delete this.controller.spline);
              },
              resize: function () {
                this.controller.control &&
                  this.controller.spline &&
                  ((this.controller.spline = void 0),
                  delete this.controller.spline);
              },
              observerUpdate: function () {
                this.controller.control &&
                  this.controller.spline &&
                  ((this.controller.spline = void 0),
                  delete this.controller.spline);
              },
              setTranslate: function (e, t) {
                this.controller.control && this.controller.setTranslate(e, t);
              },
              setTransition: function (e, t) {
                this.controller.control && this.controller.setTransition(e, t);
              },
            },
          },
          {
            name: "a11y",
            params: {
              a11y: {
                enabled: !0,
                notificationClass: "pwzrswiper-notification",
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
              },
            },
            create: function () {
              var t = this;
              Y.extend(t, {
                a11y: {
                  liveRegion: E(
                    '<span class="' +
                      t.params.a11y.notificationClass +
                      '" aria-live="assertive" aria-atomic="true"></span>'
                  ),
                },
              }),
                Object.keys(X).forEach(function (e) {
                  t.a11y[e] = X[e].bind(t);
                });
            },
            on: {
              init: function () {
                this.params.a11y.enabled &&
                  (this.a11y.init(), this.a11y.updateNavigation());
              },
              toEdge: function () {
                this.params.a11y.enabled && this.a11y.updateNavigation();
              },
              fromEdge: function () {
                this.params.a11y.enabled && this.a11y.updateNavigation();
              },
              paginationUpdate: function () {
                this.params.a11y.enabled && this.a11y.updatePagination();
              },
              destroy: function () {
                this.params.a11y.enabled && this.a11y.destroy();
              },
            },
          },
          {
            name: "history",
            params: {
              history: { enabled: !1, replaceState: !1, key: "slides" },
            },
            create: function () {
              Y.extend(this, {
                history: {
                  init: K.init.bind(this),
                  setHistory: K.setHistory.bind(this),
                  setHistoryPopState: K.setHistoryPopState.bind(this),
                  scrollToSlide: K.scrollToSlide.bind(this),
                  destroy: K.destroy.bind(this),
                },
              });
            },
            on: {
              init: function () {
                this.params.history.enabled && this.history.init();
              },
              destroy: function () {
                this.params.history.enabled && this.history.destroy();
              },
              transitionEnd: function () {
                this.history.initialized &&
                  this.history.setHistory(
                    this.params.history.key,
                    this.activeIndex
                  );
              },
              slideChange: function () {
                this.history.initialized &&
                  this.params.cssMode &&
                  this.history.setHistory(
                    this.params.history.key,
                    this.activeIndex
                  );
              },
            },
          },
          {
            name: "hash-navigation",
            params: {
              hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 },
            },
            create: function () {
              Y.extend(this, {
                hashNavigation: {
                  initialized: !1,
                  init: Z.init.bind(this),
                  destroy: Z.destroy.bind(this),
                  setHash: Z.setHash.bind(this),
                  onHashCange: Z.onHashCange.bind(this),
                },
              });
            },
            on: {
              init: function () {
                this.params.hashNavigation.enabled &&
                  this.hashNavigation.init();
              },
              destroy: function () {
                this.params.hashNavigation.enabled &&
                  this.hashNavigation.destroy();
              },
              transitionEnd: function () {
                this.hashNavigation.initialized &&
                  this.hashNavigation.setHash();
              },
              slideChange: function () {
                this.hashNavigation.initialized &&
                  this.params.cssMode &&
                  this.hashNavigation.setHash();
              },
            },
          },
          {
            name: "autoplay",
            params: {
              autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1,
              },
            },
            create: function () {
              var t = this;
              Y.extend(t, {
                autoplay: {
                  running: !1,
                  paused: !1,
                  run: Q.run.bind(t),
                  start: Q.start.bind(t),
                  stop: Q.stop.bind(t),
                  pause: Q.pause.bind(t),
                  onVisibilityChange: function () {
                    "hidden" === document.visibilityState &&
                      t.autoplay.running &&
                      t.autoplay.pause(),
                      "visible" === document.visibilityState &&
                        t.autoplay.paused &&
                        (t.autoplay.run(), (t.autoplay.paused = !1));
                  },
                  onTransitionEnd: function (e) {
                    t &&
                      !t.destroyed &&
                      t.$wrapperEl &&
                      e.target === this &&
                      (t.$wrapperEl[0].removeEventListener(
                        "transitionend",
                        t.autoplay.onTransitionEnd
                      ),
                      t.$wrapperEl[0].removeEventListener(
                        "webkitTransitionEnd",
                        t.autoplay.onTransitionEnd
                      ),
                      (t.autoplay.paused = !1),
                      t.autoplay.running
                        ? t.autoplay.run()
                        : t.autoplay.stop());
                  },
                },
              });
            },
            on: {
              init: function () {
                this.params.autoplay.enabled &&
                  (this.autoplay.start(),
                  document.addEventListener(
                    "visibilitychange",
                    this.autoplay.onVisibilityChange
                  ));
              },
              beforeTransitionStart: function (e, t) {
                this.autoplay.running &&
                  (t || !this.params.autoplay.disableOnInteraction
                    ? this.autoplay.pause(e)
                    : this.autoplay.stop());
              },
              sliderFirstMove: function () {
                this.autoplay.running &&
                  (this.params.autoplay.disableOnInteraction
                    ? this.autoplay.stop()
                    : this.autoplay.pause());
              },
              touchEnd: function () {
                this.params.cssMode &&
                  this.autoplay.paused &&
                  !this.params.autoplay.disableOnInteraction &&
                  this.autoplay.run();
              },
              destroy: function () {
                this.autoplay.running && this.autoplay.stop(),
                  document.removeEventListener(
                    "visibilitychange",
                    this.autoplay.onVisibilityChange
                  );
              },
            },
          },
          {
            name: "effect-fade",
            params: { fadeEffect: { crossFade: !1 } },
            create: function () {
              Y.extend(this, {
                fadeEffect: {
                  setTranslate: J.setTranslate.bind(this),
                  setTransition: J.setTransition.bind(this),
                },
              });
            },
            on: {
              beforeInit: function () {
                var e;
                "fade" === this.params.effect &&
                  (this.classNames.push(
                    this.params.containerModifierClass + "fade"
                  ),
                  (e = {
                    slidesPerView: 1,
                    slidesPerColumn: 1,
                    slidesPerGroup: 1,
                    watchSlidesProgress: !0,
                    spaceBetween: 0,
                    virtualTranslate: !0,
                  }),
                  Y.extend(this.params, e),
                  Y.extend(this.originalParams, e));
              },
              setTranslate: function () {
                "fade" === this.params.effect && this.fadeEffect.setTranslate();
              },
              setTransition: function (e) {
                "fade" === this.params.effect &&
                  this.fadeEffect.setTransition(e);
              },
            },
          },
          {
            name: "effect-cube",
            params: {
              cubeEffect: {
                slideShadows: !0,
                shadow: !0,
                shadowOffset: 20,
                shadowScale: 0.94,
              },
            },
            create: function () {
              Y.extend(this, {
                cubeEffect: {
                  setTranslate: ee.setTranslate.bind(this),
                  setTransition: ee.setTransition.bind(this),
                },
              });
            },
            on: {
              beforeInit: function () {
                var e;
                "cube" === this.params.effect &&
                  (this.classNames.push(
                    this.params.containerModifierClass + "cube"
                  ),
                  this.classNames.push(
                    this.params.containerModifierClass + "3d"
                  ),
                  (e = {
                    slidesPerView: 1,
                    slidesPerColumn: 1,
                    slidesPerGroup: 1,
                    watchSlidesProgress: !0,
                    resistanceRatio: 0,
                    spaceBetween: 0,
                    centeredSlides: !1,
                    virtualTranslate: !0,
                  }),
                  Y.extend(this.params, e),
                  Y.extend(this.originalParams, e));
              },
              setTranslate: function () {
                "cube" === this.params.effect && this.cubeEffect.setTranslate();
              },
              setTransition: function (e) {
                "cube" === this.params.effect &&
                  this.cubeEffect.setTransition(e);
              },
            },
          },
          {
            name: "effect-flip",
            params: { flipEffect: { slideShadows: !0, limitRotation: !0 } },
            create: function () {
              Y.extend(this, {
                flipEffect: {
                  setTranslate: te.setTranslate.bind(this),
                  setTransition: te.setTransition.bind(this),
                },
              });
            },
            on: {
              beforeInit: function () {
                var e;
                "flip" === this.params.effect &&
                  (this.classNames.push(
                    this.params.containerModifierClass + "flip"
                  ),
                  this.classNames.push(
                    this.params.containerModifierClass + "3d"
                  ),
                  (e = {
                    slidesPerView: 1,
                    slidesPerColumn: 1,
                    slidesPerGroup: 1,
                    watchSlidesProgress: !0,
                    spaceBetween: 0,
                    virtualTranslate: !0,
                  }),
                  Y.extend(this.params, e),
                  Y.extend(this.originalParams, e));
              },
              setTranslate: function () {
                "flip" === this.params.effect && this.flipEffect.setTranslate();
              },
              setTransition: function (e) {
                "flip" === this.params.effect &&
                  this.flipEffect.setTransition(e);
              },
            },
          },
          {
            name: "effect-coverflow",
            params: {
              coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: !0,
              },
            },
            create: function () {
              Y.extend(this, {
                coverflowEffect: {
                  setTranslate: ne.setTranslate.bind(this),
                  setTransition: ne.setTransition.bind(this),
                },
              });
            },
            on: {
              beforeInit: function () {
                "coverflow" === this.params.effect &&
                  (this.classNames.push(
                    this.params.containerModifierClass + "coverflow"
                  ),
                  this.classNames.push(
                    this.params.containerModifierClass + "3d"
                  ),
                  (this.params.watchSlidesProgress = !0),
                  (this.originalParams.watchSlidesProgress = !0));
              },
              setTranslate: function () {
                "coverflow" === this.params.effect &&
                  this.coverflowEffect.setTranslate();
              },
              setTransition: function (e) {
                "coverflow" === this.params.effect &&
                  this.coverflowEffect.setTransition(e);
              },
            },
          },
          {
            name: "thumbs",
            params: {
              thumbs: {
                multipleActiveThumbs: !0,
                swiper: null,
                slideThumbActiveClass: "pwzrswiper-slide-thumb-active",
                thumbsContainerClass: "pwzrswiper-container-thumbs",
              },
            },
            create: function () {
              Y.extend(this, {
                thumbs: {
                  swiper: null,
                  init: re.init.bind(this),
                  update: re.update.bind(this),
                  onThumbClick: re.onThumbClick.bind(this),
                },
              });
            },
            on: {
              beforeInit: function () {
                var e = this.params.thumbs;
                e && e.swiper && (this.thumbs.init(), this.thumbs.update(!0));
              },
              slideChange: function () {
                this.thumbs.swiper && this.thumbs.update();
              },
              update: function () {
                this.thumbs.swiper && this.thumbs.update();
              },
              resize: function () {
                this.thumbs.swiper && this.thumbs.update();
              },
              observerUpdate: function () {
                this.thumbs.swiper && this.thumbs.update();
              },
              setTransition: function (e) {
                var t = this.thumbs.swiper;
                t && t.setTransition(e);
              },
              beforeDestroy: function () {
                var e = this.thumbs.swiper;
                e && this.thumbs.swiperCreated && e && e.destroy();
              },
            },
          },
        ];
      return (
        void 0 === I.use &&
          ((I.use = I.Class.use), (I.installModule = I.Class.installModule)),
        I.use(S),
        I
      );
    }),
    "object" === (void 0 === (xp = Yu = {}) ? "undefined" : oC(Yu))
      ? (Yu = vp())
      : ((xp = xp || self).Swiper = vp()),
    function () {
      var e = { exports: this };
      this.__esModule = !0;
      var t,
        n,
        t =
          ("function" ==
          typeof (n = ("undefined" != typeof self
            ? self
            : "undefined" != typeof window
            ? window
            : void 0 !== i
            ? i
            : void 0 !== e
            ? e
            : Function("return this")()
          ).Symbol)
            ? n.observable
              ? (t = n.observable)
              : ((t = n("observable")), (n.observable = t))
            : (t = "@@observable"),
          t);
      return (this.default = t), e.exports;
    }.call({}),
    (_f = function () {
      return Math.random().toString(36).substring(7).split("").join(".");
    })(),
    _f();
  var lC =
    "object" ===
    ("undefined" == typeof HTMLElement ? "undefined" : sC(HTMLElement));
  function cC(e) {
    return lC
      ? e instanceof HTMLElement
      : e &&
          "object" === sC(e) &&
          null !== e &&
          1 === e.nodeType &&
          "string" == typeof e.nodeName;
  }
  function uC(t, e) {
    e.forEach(function (e) {
      t.classList.add(e);
    });
  }
  function dC(t, e) {
    e.forEach(function (e) {
      t.classList.remove(e);
    });
  }
  function pC() {
    throw new Error("Missing parameter");
  }
  function fC(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  var hC =
    (fC(mC.prototype, [
      {
        key: "_buildClasses",
        value: function (e) {
          var t = ["pwzrdrift-".concat(e)],
            n = this.settings.namespace;
          return n && t.push("".concat(n, "-").concat(e)), t;
        },
      },
      {
        key: "_buildElement",
        value: function () {
          (this.el = document.createElement("div")),
            uC(this.el, this._buildClasses("bounding-box"));
        },
      },
      {
        key: "show",
        value: function (e, t) {
          (this.isShowing = !0), this.settings.containerEl.appendChild(this.el);
          var n = this.el.style;
          (n.width = "".concat(Math.round(e / this.settings.zoomFactor), "px")),
            (n.height = "".concat(
              Math.round(t / this.settings.zoomFactor),
              "px"
            )),
            uC(this.el, this.openClasses);
        },
      },
      {
        key: "hide",
        value: function () {
          this.isShowing && this.settings.containerEl.removeChild(this.el),
            (this.isShowing = !1),
            dC(this.el, this.openClasses);
        },
      },
      {
        key: "setPosition",
        value: function (e, t, n) {
          var r = window.pageXOffset,
            i = window.pageYOffset,
            e = n.left + e * n.width - this.el.clientWidth / 2 + r,
            t = n.top + t * n.height - this.el.clientHeight / 2 + i;
          e < n.left + r
            ? (e = n.left + r)
            : e + this.el.clientWidth > n.left + n.width + r &&
              (e = n.left + n.width - this.el.clientWidth + r),
            t < n.top + i
              ? (t = n.top + i)
              : t + this.el.clientHeight > n.top + n.height + i &&
                (t = n.top + n.height - this.el.clientHeight + i),
            (this.el.style.left = "".concat(e, "px")),
            (this.el.style.top = "".concat(t, "px"));
        },
      },
    ]),
    mC);
  function mC(e) {
    !(function (e) {
      if (!(e instanceof mC))
        throw new TypeError("Cannot call a class as a function");
    })(this),
      (this.isShowing = !1);
    var t = e.namespace,
      n = void 0 === t ? null : t,
      t = e.zoomFactor,
      t = void 0 === t ? pC() : t,
      e = e.containerEl,
      e = void 0 === e ? pC() : e;
    (this.settings = { namespace: n, zoomFactor: t, containerEl: e }),
      (this.openClasses = this._buildClasses("open")),
      this._buildElement();
  }
  function gC(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  var vC =
    (gC(yC.prototype, [
      {
        key: "_preventDefault",
        value: function (e) {
          e.preventDefault();
        },
      },
      {
        key: "_preventDefaultAllowTouchScroll",
        value: function (e) {
          (this.settings.touchDelay &&
            this._isTouchEvent(e) &&
            !this.isShowing) ||
            e.preventDefault();
        },
      },
      {
        key: "_isTouchEvent",
        value: function (e) {
          return !!e.touches;
        },
      },
      {
        key: "_bindEvents",
        value: function () {
          this.settings.el.addEventListener(
            "mouseenter",
            this._handleEntry,
            !1
          ),
            this.settings.el.addEventListener("mouseleave", this._hide, !1),
            this.settings.el.addEventListener(
              "mousemove",
              this._handleMovement,
              !1
            ),
            this.settings.handleTouch
              ? (this.settings.el.addEventListener(
                  "touchstart",
                  this._handleEntry,
                  !1
                ),
                this.settings.el.addEventListener("touchend", this._hide, !1),
                this.settings.el.addEventListener(
                  "touchmove",
                  this._handleMovement,
                  !1
                ))
              : (this.settings.el.addEventListener(
                  "touchstart",
                  this._preventDefault,
                  !1
                ),
                this.settings.el.addEventListener(
                  "touchend",
                  this._preventDefault,
                  !1
                ),
                this.settings.el.addEventListener(
                  "touchmove",
                  this._preventDefault,
                  !1
                ));
        },
      },
      {
        key: "_unbindEvents",
        value: function () {
          this.settings.el.removeEventListener(
            "mouseenter",
            this._handleEntry,
            !1
          ),
            this.settings.el.removeEventListener("mouseleave", this._hide, !1),
            this.settings.el.removeEventListener(
              "mousemove",
              this._handleMovement,
              !1
            ),
            this.settings.handleTouch
              ? (this.settings.el.removeEventListener(
                  "touchstart",
                  this._handleEntry,
                  !1
                ),
                this.settings.el.removeEventListener(
                  "touchend",
                  this._hide,
                  !1
                ),
                this.settings.el.removeEventListener(
                  "touchmove",
                  this._handleMovement,
                  !1
                ))
              : (this.settings.el.removeEventListener(
                  "touchstart",
                  this._preventDefault,
                  !1
                ),
                this.settings.el.removeEventListener(
                  "touchend",
                  this._preventDefault,
                  !1
                ),
                this.settings.el.removeEventListener(
                  "touchmove",
                  this._preventDefault,
                  !1
                ));
        },
      },
      {
        key: "_handleEntry",
        value: function (e) {
          this._preventDefaultAllowTouchScroll(e),
            "mouseenter" == (this._lastMovement = e).type &&
            this.settings.hoverDelay
              ? (this.entryTimeout = setTimeout(
                  this._show,
                  this.settings.hoverDelay
                ))
              : this.settings.touchDelay
              ? (this.entryTimeout = setTimeout(
                  this._show,
                  this.settings.touchDelay
                ))
              : this._show();
        },
      },
      {
        key: "_show",
        value: function () {
          var e;
          this.enabled &&
            ((e = this.settings.onShow) && "function" == typeof e && e(),
            this.settings.zoomPane.show(
              this.settings.el.getAttribute(this.settings.sourceAttribute),
              this.settings.el.clientWidth,
              this.settings.el.clientHeight
            ),
            this._lastMovement &&
              (((e = this._lastMovement.touches) &&
                this.settings.touchBoundingBox) ||
                (!e && this.settings.hoverBoundingBox)) &&
              this.boundingBox.show(
                this.settings.zoomPane.el.clientWidth,
                this.settings.zoomPane.el.clientHeight
              ),
            this._handleMovement());
        },
      },
      {
        key: "_hide",
        value: function (e) {
          e && this._preventDefaultAllowTouchScroll(e),
            (this._lastMovement = null),
            this.entryTimeout && clearTimeout(this.entryTimeout),
            this.boundingBox && this.boundingBox.hide();
          e = this.settings.onHide;
          e && "function" == typeof e && e(), this.settings.zoomPane.hide();
        },
      },
      {
        key: "_handleMovement",
        value: function (e) {
          if (e)
            this._preventDefaultAllowTouchScroll(e), (this._lastMovement = e);
          else {
            if (!this._lastMovement) return;
            e = this._lastMovement;
          }
          r = e.touches
            ? ((n = (t = e.touches[0]).clientX), t.clientY)
            : ((n = e.clientX), e.clientY);
          var t = this.settings.el.getBoundingClientRect(),
            e = n - t.left,
            n = r - t.top,
            r = e / this.settings.el.clientWidth,
            e = n / this.settings.el.clientHeight,
            n = this.settings.inlineContainer.getBoundingClientRect(),
            t = {
              left: t.left - n.left,
              top: t.top - n.top,
              width: t.width,
              height: t.height,
            };
          this.boundingBox && this.boundingBox.setPosition(r, e, t),
            this.settings.zoomPane.setPosition(r, e, t);
        },
      },
      {
        key: "isShowing",
        get: function () {
          return this.settings.zoomPane.isShowing;
        },
      },
    ]),
    yC);
  function yC() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    (function (e) {
      if (!(e instanceof yC))
        throw new TypeError("Cannot call a class as a function");
    })(this),
      (this._show = this._show.bind(this)),
      (this._hide = this._hide.bind(this)),
      (this._handleEntry = this._handleEntry.bind(this)),
      (this._handleMovement = this._handleMovement.bind(this));
    var t = e.el,
      n = void 0 === t ? pC() : t,
      r = e.zoomPane,
      i = void 0 === r ? pC() : r,
      o = e.sourceAttribute,
      a = void 0 === o ? pC() : o,
      s = e.handleTouch,
      l = void 0 === s ? pC() : s,
      c = e.onShow,
      u = void 0 === c ? null : c,
      d = e.onHide,
      p = void 0 === d ? null : d,
      f = e.hoverDelay,
      t = void 0 === f ? 0 : f,
      r = e.touchDelay,
      o = void 0 === r ? 0 : r,
      s = e.hoverBoundingBox,
      c = void 0 === s ? pC() : s,
      d = e.touchBoundingBox,
      f = void 0 === d ? pC() : d,
      r = e.namespace,
      s = void 0 === r ? null : r,
      d = e.zoomFactor,
      r = void 0 === d ? pC() : d,
      d = e.boundingBoxContainer,
      d = void 0 === d ? pC() : d,
      e = e.inlineContainer,
      e = void 0 === e ? pC() : e;
    (this.settings = {
      el: n,
      zoomPane: i,
      sourceAttribute: a,
      handleTouch: l,
      onShow: u,
      onHide: p,
      hoverDelay: t,
      touchDelay: o,
      hoverBoundingBox: c,
      touchBoundingBox: f,
      namespace: s,
      zoomFactor: r,
      boundingBoxContainer: d,
      inlineContainer: e,
    }),
      (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) &&
        (this.boundingBox = new hC({
          namespace: this.settings.namespace,
          zoomFactor: this.settings.zoomFactor,
          containerEl: this.settings.boundingBoxContainer,
        })),
      (this.enabled = !0),
      this._bindEvents();
  }
  function bC(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  var wC = document.createElement("div").style,
    xC =
      "undefined" != typeof document &&
      ("animation" in wC || "webkitAnimation" in wC),
    EC =
      (bC(SC.prototype, [
        {
          key: "_buildClasses",
          value: function (e) {
            var t = ["pwzrdrift-".concat(e)],
              n = this.settings.namespace;
            return n && t.push("".concat(n, "-").concat(e)), t;
          },
        },
        {
          key: "_buildElement",
          value: function () {
            (this.el = document.createElement("div")),
              uC(this.el, this._buildClasses("zoom-pane"));
            var e = document.createElement("div");
            uC(e, this._buildClasses("zoom-pane-loader")),
              this.el.appendChild(e),
              (this.imgEl = document.createElement("img")),
              this.el.appendChild(this.imgEl);
          },
        },
        {
          key: "_setImageURL",
          value: function (e) {
            this.imgEl.setAttribute("src", e);
          },
        },
        {
          key: "_setImageSize",
          value: function (e, t) {
            (this.imgEl.style.width = "".concat(
              e * this.settings.zoomFactor,
              "px"
            )),
              (this.imgEl.style.height = "".concat(
                t * this.settings.zoomFactor,
                "px"
              )),
              (this.imgEl.style.maxWidth = "none");
          },
        },
        {
          key: "setPosition",
          value: function (e, t, n) {
            var r = this.imgEl.offsetWidth,
              i = this.imgEl.offsetHeight,
              o = this.el.offsetWidth,
              a = this.el.offsetHeight,
              s = o / 2 - r * e,
              l = a / 2 - i * t,
              c = o - r,
              u = a - i,
              d = 0 < c,
              p = 0 < u,
              r = d ? c / 2 : 0,
              i = p ? u / 2 : 0,
              c = d ? c / 2 : c,
              u = p ? u / 2 : u;
            this.el.parentElement === this.settings.inlineContainer &&
              ((e =
                n.left + e * n.width - o / 2 + this.settings.inlineOffsetX + 0),
              (t =
                n.top + t * n.height - a / 2 + this.settings.inlineOffsetY + 0),
              this.settings.containInline &&
                (e < n.left + 0
                  ? (e = n.left + 0)
                  : e + o > n.left + n.width + 0 && (e = n.left + n.width - o),
                t < n.top + 0
                  ? (t = n.top + 0)
                  : t + a > n.top + n.height + 0 && (t = n.top + n.height - a)),
              "yes" ===
                getComputedStyle(this.el).getPropertyValue(
                  "--magnify-width-full"
                ) && (e = 0),
              "yes" ===
                getComputedStyle(this.el).getPropertyValue(
                  "--magnify-height-full"
                ) && (t = 0),
              (this.el.style.left = "".concat(e, "px")),
              (this.el.style.top = "".concat(t, "px"))),
              this.settings.showWhitespaceAtEdges ||
                (r < s ? (s = r) : s < c && (s = c),
                i < l ? (l = i) : l < u && (l = u)),
              (this.imgEl.style.transform = "translate("
                .concat(s, "px, ")
                .concat(l, "px)")),
              (this.imgEl.style.webkitTransform = "translate("
                .concat(s, "px, ")
                .concat(l, "px)"));
          },
        },
        {
          key: "_removeListenersAndResetClasses",
          value: function () {
            this.el.removeEventListener("animationend", this._completeShow, !1),
              this.el.removeEventListener(
                "animationend",
                this._completeHide,
                !1
              ),
              this.el.removeEventListener(
                "webkitAnimationEnd",
                this._completeShow,
                !1
              ),
              this.el.removeEventListener(
                "webkitAnimationEnd",
                this._completeHide,
                !1
              ),
              dC(this.el, this.openClasses),
              dC(this.el, this.closingClasses);
          },
        },
        {
          key: "show",
          value: function (e, t, n) {
            var r;
            this._removeListenersAndResetClasses(),
              (this.isShowing = !0),
              uC(this.el, this.openClasses),
              this.imgEl.getAttribute("src") != e &&
                ((r = this.el.querySelector(".pwzrdrift-zoom-pane-loader")) &&
                  (r.style.display = "block"),
                uC(this.el, this.loadingClasses),
                this.imgEl.addEventListener("load", this._handleLoad, !1),
                this._setImageURL(e)),
              this._setImageSize(t, n),
              this._isInline ? this._showInline() : this._showInContainer(),
              xC &&
                (this.el.addEventListener(
                  "animationend",
                  this._completeShow,
                  !1
                ),
                this.el.addEventListener(
                  "webkitAnimationEnd",
                  this._completeShow,
                  !1
                ),
                uC(this.el, this.openingClasses));
          },
        },
        {
          key: "_showInline",
          value: function () {
            this.settings.inlineContainer.appendChild(this.el),
              uC(this.el, this.inlineClasses);
          },
        },
        {
          key: "_showInContainer",
          value: function () {
            this.settings.container.appendChild(this.el);
          },
        },
        {
          key: "hide",
          value: function () {
            this._removeListenersAndResetClasses(),
              (this.isShowing = !1),
              xC
                ? (this.el.addEventListener(
                    "animationend",
                    this._completeHide,
                    !1
                  ),
                  this.el.addEventListener(
                    "webkitAnimationEnd",
                    this._completeHide,
                    !1
                  ),
                  uC(this.el, this.closingClasses))
                : (dC(this.el, this.openClasses),
                  dC(this.el, this.inlineClasses));
          },
        },
        {
          key: "_completeShow",
          value: function () {
            this.el.removeEventListener("animationend", this._completeShow, !1),
              this.el.removeEventListener(
                "webkitAnimationEnd",
                this._completeShow,
                !1
              ),
              dC(this.el, this.openingClasses);
          },
        },
        {
          key: "_completeHide",
          value: function () {
            this.el.removeEventListener("animationend", this._completeHide, !1),
              this.el.removeEventListener(
                "webkitAnimationEnd",
                this._completeHide,
                !1
              ),
              dC(this.el, this.openClasses),
              dC(this.el, this.closingClasses),
              dC(this.el, this.inlineClasses),
              this.el.setAttribute("style", ""),
              this.el.parentElement === this.settings.container
                ? this.settings.container.removeChild(this.el)
                : this.el.parentElement === this.settings.inlineContainer &&
                  this.settings.inlineContainer.removeChild(this.el);
          },
        },
        {
          key: "_handleLoad",
          value: function () {
            var e = this.el.querySelector(".pwzrdrift-zoom-pane-loader");
            e && (e.style.display = "none"),
              this.imgEl.removeEventListener("load", this._handleLoad, !1),
              dC(this.el, this.loadingClasses);
          },
        },
        {
          key: "_isInline",
          get: function () {
            var e = this.settings.inline;
            return !0 === e || ("number" == typeof e && window.innerWidth <= e);
          },
        },
      ]),
      SC);
  function SC() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    (function (e) {
      if (!(e instanceof SC))
        throw new TypeError("Cannot call a class as a function");
    })(this),
      (this._completeShow = this._completeShow.bind(this)),
      (this._completeHide = this._completeHide.bind(this)),
      (this._handleLoad = this._handleLoad.bind(this)),
      (this.isShowing = !1);
    var t = e.container,
      n = void 0 === t ? null : t,
      r = e.zoomFactor,
      i = void 0 === r ? pC() : r,
      o = e.inline,
      a = void 0 === o ? pC() : o,
      s = e.namespace,
      l = void 0 === s ? null : s,
      t = e.showWhitespaceAtEdges,
      r = void 0 === t ? pC() : t,
      o = e.containInline,
      s = void 0 === o ? pC() : o,
      t = e.inlineOffsetX,
      o = void 0 === t ? 0 : t,
      t = e.inlineOffsetY,
      t = void 0 === t ? 0 : t,
      e = e.inlineContainer,
      e = void 0 === e ? document.body : e;
    (this.settings = {
      container: n,
      zoomFactor: i,
      inline: a,
      namespace: l,
      showWhitespaceAtEdges: r,
      containInline: s,
      inlineOffsetX: o,
      inlineOffsetY: t,
      inlineContainer: e,
    }),
      (this.openClasses = this._buildClasses("open")),
      (this.openingClasses = this._buildClasses("opening")),
      (this.closingClasses = this._buildClasses("closing")),
      (this.inlineClasses = this._buildClasses("inline")),
      (this.loadingClasses = this._buildClasses("loading")),
      this._buildElement();
  }
  function CC(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  var kC =
    (CC(TC.prototype, [
      {
        key: "_buildZoomPane",
        value: function () {
          this.zoomPane = new EC({
            container: this.settings.paneContainer,
            zoomFactor: this.settings.zoomFactor,
            showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
            containInline: this.settings.containInline,
            inline: this.settings.inlinePane,
            namespace: this.settings.namespace,
            inlineOffsetX: this.settings.inlineOffsetX,
            inlineOffsetY: this.settings.inlineOffsetY,
            inlineContainer: this.settings.inlineContainer,
          });
        },
      },
      {
        key: "_buildTrigger",
        value: function () {
          this.trigger = new vC({
            el: this.triggerEl,
            zoomPane: this.zoomPane,
            handleTouch: this.settings.handleTouch,
            onShow: this.settings.onShow,
            onHide: this.settings.onHide,
            sourceAttribute: this.settings.sourceAttribute,
            hoverDelay: this.settings.hoverDelay,
            touchDelay: this.settings.touchDelay,
            hoverBoundingBox: this.settings.hoverBoundingBox,
            touchBoundingBox: this.settings.touchBoundingBox,
            namespace: this.settings.namespace,
            zoomFactor: this.settings.zoomFactor,
            boundingBoxContainer: this.settings.boundingBoxContainer,
            inlineContainer: this.settings.inlineContainer,
          });
        },
      },
      {
        key: "setZoomImageURL",
        value: function (e) {
          this.zoomPane._setImageURL(e);
        },
      },
      {
        key: "disable",
        value: function () {
          this.trigger.enabled = !1;
        },
      },
      {
        key: "enable",
        value: function () {
          this.trigger.enabled = !0;
        },
      },
      {
        key: "destroy",
        value: function () {
          this.trigger._hide(), this.trigger._unbindEvents();
        },
      },
      {
        key: "isShowing",
        get: function () {
          return this.zoomPane.isShowing;
        },
      },
      {
        key: "zoomFactor",
        get: function () {
          return this.settings.zoomFactor;
        },
        set: function (e) {
          (this.settings.zoomFactor = e),
            (this.zoomPane.settings.zoomFactor = e),
            (this.trigger.settings.zoomFactor = e),
            (this.boundingBox.settings.zoomFactor = e);
        },
      },
    ]),
    TC);
  function TC(e) {
    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
    if (
      ((function (e, t) {
        if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function");
      })(this, TC),
      (this.VERSION = "1.4.0"),
      (this.triggerEl = e),
      (this.destroy = this.destroy.bind(this)),
      !cC(this.triggerEl))
    )
      throw new TypeError(
        "`new Drift` requires a DOM element as its first argument."
      );
    var n = t.namespace || null,
      r = t.showWhitespaceAtEdges || !1,
      i = t.containInline || !1,
      o = t.inlineOffsetX || 0,
      a = t.inlineOffsetY || 0,
      s = t.inlineContainer || document.body,
      l = t.sourceAttribute || "data-zoom",
      c = t.zoomFactor || 3,
      u = void 0 === t.paneContainer ? document.body : t.paneContainer,
      d = t.inlinePane || 375,
      p = !("handleTouch" in t && !t.handleTouch),
      f = t.onShow || null,
      h = t.onHide || null,
      m = !("injectBaseStyles" in t && !t.injectBaseStyles),
      g = t.hoverDelay || 0,
      v = t.touchDelay || 0,
      y = t.hoverBoundingBox || !1,
      b = t.touchBoundingBox || !1,
      t = t.boundingBoxContainer || document.body;
    if (!0 !== d && !cC(u))
      throw new TypeError(
        "`paneContainer` must be a DOM element when `inlinePane !== true`"
      );
    if (!cC(s)) throw new TypeError("`inlineContainer` must be a DOM element");
    (this.settings = {
      namespace: n,
      showWhitespaceAtEdges: r,
      containInline: i,
      inlineOffsetX: o,
      inlineOffsetY: a,
      inlineContainer: s,
      sourceAttribute: l,
      zoomFactor: c,
      paneContainer: u,
      inlinePane: d,
      handleTouch: p,
      onShow: f,
      onHide: h,
      injectBaseStyles: m,
      hoverDelay: g,
      touchDelay: v,
      hoverBoundingBox: y,
      touchBoundingBox: b,
      boundingBoxContainer: t,
    }),
      this.settings.injectBaseStyles &&
        (document.querySelector(".pwzrdrift-base-styles") ||
          (((b = document.createElement("style")).type = "text/css"),
          b.classList.add("pwzrdrift-base-styles"),
          b.appendChild(
            document.createTextNode(
              ".pwzrdrift-bounding-box,.pwzrdrift-zoom-pane{position:absolute;pointer-events:none}@keyframes pwzrnoop{0%{zoom:1}}@-webkit-keyframes pwzrnoop{0%{zoom:1}}.pwzrdrift-zoom-pane.pwzrdrift-open{display:block}.pwzrdrift-zoom-pane.pwzrdrift-closing,.pwzrdrift-zoom-pane.pwzrdrift-opening{animation:pwzrnoop 1ms;-webkit-animation:pwzrnoop 1ms}.pwzrdrift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.pwzrdrift-zoom-pane-loader{display:none}.pwzrdrift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}"
            )
          ),
          (t = document.head).insertBefore(b, t.firstChild))),
      this._buildZoomPane(),
      this._buildTrigger();
  }
  Object.defineProperty(kC.prototype, "isShowing", {
    get: function () {
      return this.isShowing;
    },
  }),
    Object.defineProperty(kC.prototype, "zoomFactor", {
      get: function () {
        return this.zoomFactor;
      },
      set: function (e) {
        this.zoomFactor = e;
      },
    }),
    (kC.prototype.setZoomImageURL = kC.prototype.setZoomImageURL),
    (kC.prototype.disable = kC.prototype.disable),
    (kC.prototype.enable = kC.prototype.enable),
    (kC.prototype.destroy = kC.prototype.destroy);
  var PC = "complete",
    zC = "canceled";
  function OC(e, t, n, r, i) {
    e.self === e
      ? e.scrollTo(t, n)
      : (r || (e.scrollLeft = t), i || (e.scrollTop = n));
  }
  function RC(e) {
    var t,
      n,
      r,
      i,
      o,
      a,
      s,
      l,
      c,
      u,
      d = e._scrollSettings;
    if (d) {
      var p = d.maxSynchronousAlignments,
        f =
          ((m = e),
          (o = (t = d).align),
          (a = t.target.getBoundingClientRect()),
          (s = o && null != o.left ? o.left : 0.5),
          (l = o && null != o.top ? o.top : 0.5),
          (c = o && null != o.leftOffset ? o.leftOffset : 0),
          (u = o && null != o.topOffset ? o.topOffset : 0),
          (o = s),
          (s = l),
          (m = t.isWindow(m)
            ? ((n = Math.min(a.width, m.innerWidth)),
              (r = Math.min(a.height, m.innerHeight)),
              (i = a.left + m.pageXOffset - m.innerWidth * o + n * o),
              (f = a.top + m.pageYOffset - m.innerHeight * s + r * s),
              (f -= u),
              (h = (i -= c) - m.pageXOffset),
              f - m.pageYOffset)
            : ((n = a.width),
              (r = a.height),
              (l = m.getBoundingClientRect()),
              (t = a.left - (l.left - m.scrollLeft)),
              (l = a.top - (l.top - m.scrollTop)),
              (i = t + n * o - m.clientWidth * o),
              (f = l + r * s - m.clientHeight * s),
              (i -= c),
              (f -= u),
              (i = Math.max(Math.min(i, m.scrollWidth - m.clientWidth), 0)),
              (f = Math.max(Math.min(f, m.scrollHeight - m.clientHeight), 0)),
              (h = i - m.scrollLeft),
              f - m.scrollTop)),
          { x: i, y: f, differenceX: h, differenceY: m }),
        h = Date.now() - d.startTime,
        m = Math.min((1 / d.time) * h, 1);
      if (d.endIterations >= p)
        return (
          OC(e, f.x, f.y, d.lockX, d.lockY),
          (e._scrollSettings = null),
          d.end(PC)
        );
      m = 1 - d.ease(m);
      if (
        (OC(
          e,
          f.x - f.differenceX * m,
          f.y - f.differenceY * m,
          d.lockX,
          d.lockY
        ),
        h >= d.time)
      )
        return d.endIterations++, RC(e);
      (e = RC.bind(null, e)),
        "requestAnimationFrame" in window
          ? window.requestAnimationFrame(e)
          : setTimeout(e, 16);
    }
  }
  function MC(e) {
    return e.self === e;
  }
  function NC(e) {
    return (
      "pageXOffset" in e ||
      ((e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth) &&
        "hidden" !== getComputedStyle(e).overflow)
    );
  }
  function LC() {
    return !0;
  }
  function IC(e) {
    if (e.assignedSlot) return IC(e.assignedSlot);
    if (e.parentElement)
      return "BODY" === e.parentElement.tagName
        ? e.parentElement.ownerDocument.defaultView ||
            e.parentElement.ownerDocument.ownerWindow
        : e.parentElement;
    if (e.getRootNode) {
      e = e.getRootNode();
      if (11 === e.nodeType) return e.host;
    }
  }
  function _C(e) {
    return (
      (function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++)
            n[t] = e[t];
          return n;
        }
      })(e) ||
      (function (e) {
        if (
          Symbol.iterator in Object(e) ||
          "[object Arguments]" === Object.prototype.toString.call(e)
        )
          return Array.from(e);
      })(e) ||
      (function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      })()
    );
  }
  var DC = function (e, t) {
      if (((t = t.split(":")[0]), !(e = +e))) return !1;
      switch (t) {
        case "http":
        case "ws":
          return 80 !== e;
        case "https":
        case "wss":
          return 443 !== e;
        case "ftp":
          return 21 !== e;
        case "gopher":
          return 70 !== e;
        case "file":
          return !1;
      }
      return 0 !== e;
    },
    If = {},
    AC = Object.prototype.hasOwnProperty;
  function FC(e) {
    try {
      return decodeURIComponent(e.replace(/\+/g, " "));
    } catch (e) {
      return null;
    }
  }
  function BC(e, t) {
    var n,
      r,
      i = [];
    for (r in ("string" != typeof (t = t || "") && (t = "?"), e))
      if (AC.call(e, r)) {
        if (
          ((n = e[r]) || (null != n && !isNaN(n)) || (n = ""),
          (r = encodeURIComponent(r)),
          (n = encodeURIComponent(n)),
          null === r || null === n)
        )
          continue;
        i.push(r + "=" + n);
      }
    return i.length ? t + i.join("&") : "";
  }
  If.stringify = BC;
  var WC = function (e) {
    for (var t = /([^=?&]+)=?([^&]*)/g, n = {}; (i = t.exec(e)); ) {
      var r = FC(i[1]),
        i = FC(i[2]);
      null === r || null === i || r in n || (n[r] = i);
    }
    return n;
  };
  If.parse = WC;
  var $C = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//,
    jC = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i,
    HC = new RegExp(
      "^[\\x09\\x0A\\x0B\\x0C\\x0D\\x20\\xA0\\u1680\\u180E\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200A\\u202F\\u205F\\u3000\\u2028\\u2029\\uFEFF]+"
    );
  function VC(e) {
    return (e || "").toString().replace(HC, "");
  }
  var qC = [
      ["#", "hash"],
      ["?", "query"],
      function (e) {
        return e.replace("\\", "/");
      },
      ["/", "pathname"],
      ["@", "auth", 1],
      [NaN, "host", void 0, 1, 1],
      [/:(\d+)$/, "port", void 0, 1],
      [NaN, "hostname", void 0, 1, 1],
    ],
    UC = { hash: 1, query: 1 };
  function GC(e) {
    var t,
      n =
        ("undefined" != typeof window
          ? window
          : void 0 !== i
          ? i
          : "undefined" != typeof self
          ? self
          : {}
        ).location || {},
      r = {},
      n = typeof (e = e || n);
    if ("blob:" === e.protocol) r = new XC(unescape(e.pathname), {});
    else if ("string" == n) for (t in ((r = new XC(e, {})), UC)) delete r[t];
    else if ("object" == n) {
      for (t in e) t in UC || (r[t] = e[t]);
      void 0 === r.slashes && (r.slashes = $C.test(e.href));
    }
    return r;
  }
  function YC(e) {
    e = VC(e);
    e = jC.exec(e);
    return {
      protocol: e[1] ? e[1].toLowerCase() : "",
      slashes: !!e[2],
      rest: e[3],
    };
  }
  function XC(e, t, n) {
    if (((e = VC(e)), !(this instanceof XC))) return new XC(e, t, n);
    var r,
      i,
      o,
      a,
      s,
      l = qC.slice(),
      c = typeof t,
      u = this,
      d = 0;
    for (
      "object" != c && "string" != c && ((n = t), (t = null)),
        n && "function" != typeof n && (n = WC),
        t = GC(t),
        r = !(c = YC(e || "")).protocol && !c.slashes,
        u.slashes = c.slashes || (r && t.slashes),
        u.protocol = c.protocol || t.protocol || "",
        e = c.rest,
        c.slashes || (l[3] = [/(.*)/, "pathname"]);
      d < l.length;
      d++
    )
      "function" != typeof (o = l[d])
        ? ((i = o[0]),
          (s = o[1]),
          i != i
            ? (u[s] = e)
            : "string" == typeof i
            ? ~(a = e.indexOf(i)) &&
              (e =
                "number" == typeof o[2]
                  ? ((u[s] = e.slice(0, a)), e.slice(a + o[2]))
                  : ((u[s] = e.slice(a)), e.slice(0, a)))
            : (a = i.exec(e)) && ((u[s] = a[1]), (e = e.slice(0, a.index))),
          (u[s] = u[s] || (r && o[3] && t[s]) || ""),
          o[4] && (u[s] = u[s].toLowerCase()))
        : (e = o(e));
    n && (u.query = n(u.query)),
      r &&
        t.slashes &&
        "/" !== u.pathname.charAt(0) &&
        ("" !== u.pathname || "" !== t.pathname) &&
        (u.pathname = (function (e, t) {
          if ("" === e) return t;
          for (
            var n = (t || "/").split("/").slice(0, -1).concat(e.split("/")),
              r = n.length,
              e = n[r - 1],
              i = !1,
              o = 0;
            r--;

          )
            "." === n[r]
              ? n.splice(r, 1)
              : ".." === n[r]
              ? (n.splice(r, 1), o++)
              : o && (0 === r && (i = !0), n.splice(r, 1), o--);
          return (
            i && n.unshift(""),
            ("." !== e && ".." !== e) || n.push(""),
            n.join("/")
          );
        })(u.pathname, t.pathname)),
      DC(u.port, u.protocol) || ((u.host = u.hostname), (u.port = "")),
      (u.username = u.password = ""),
      u.auth &&
        ((o = u.auth.split(":")),
        (u.username = o[0] || ""),
        (u.password = o[1] || "")),
      (u.origin =
        u.protocol && u.host && "file:" !== u.protocol
          ? u.protocol + "//" + u.host
          : "null"),
      (u.href = u.toString());
  }
  (XC.prototype = {
    set: function (e, t, n) {
      var r,
        i = this;
      switch (e) {
        case "query":
          "string" == typeof t && t.length && (t = (n || WC)(t)), (i[e] = t);
          break;
        case "port":
          (i[e] = t),
            DC(t, i.protocol)
              ? t && (i.host = i.hostname + ":" + t)
              : ((i.host = i.hostname), (i[e] = ""));
          break;
        case "hostname":
          (i[e] = t), i.port && (t += ":" + i.port), (i.host = t);
          break;
        case "host":
          (i[e] = t),
            /:\d+$/.test(t)
              ? ((t = t.split(":")),
                (i.port = t.pop()),
                (i.hostname = t.join(":")))
              : ((i.hostname = t), (i.port = ""));
          break;
        case "protocol":
          (i.protocol = t.toLowerCase()), (i.slashes = !n);
          break;
        case "pathname":
        case "hash":
          t
            ? ((r = "pathname" === e ? "/" : "#"),
              (i[e] = t.charAt(0) !== r ? r + t : t))
            : (i[e] = t);
          break;
        default:
          i[e] = t;
      }
      for (var o = 0; o < qC.length; o++) {
        var a = qC[o];
        a[4] && (i[a[1]] = i[a[1]].toLowerCase());
      }
      return (
        (i.origin =
          i.protocol && i.host && "file:" !== i.protocol
            ? i.protocol + "//" + i.host
            : "null"),
        (i.href = i.toString()),
        i
      );
    },
    toString: function (e) {
      (e && "function" == typeof e) || (e = BC);
      var t = this,
        n = t.protocol;
      n && ":" !== n.charAt(n.length - 1) && (n += ":");
      n += t.slashes ? "//" : "";
      return (
        t.username &&
          ((n += t.username),
          t.password && (n += ":" + t.password),
          (n += "@")),
        (n += t.host + t.pathname),
        (e = "object" == typeof t.query ? e(t.query) : t.query) &&
          (n += "?" !== e.charAt(0) ? "?" + e : e),
        t.hash && (n += t.hash),
        n
      );
    },
  }),
    (XC.extractProtocol = YC),
    (XC.location = GC),
    (XC.trimLeft = VC),
    (XC.qs = If);
  var KC = XC,
    xp = {};
  Object.defineProperty(xp, "__esModule", { value: !0 }),
    (xp.preload = function (e, t) {
      "string" == typeof e && (e = [e]);
      for (var n = 0; n < e.length; n++) QC(JC(e[n], t));
    }),
    (xp.loadImage = QC),
    (xp.imageSize = function (e) {
      e = e.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );
      return e ? e[1] : null;
    });
  var ZC = JC;
  function QC(e) {
    new Image().src = e;
  }
  function JC(e, t) {
    if (null === t) return e;
    if ("master" === t) return ek(e);
    var n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp|heic|psd)(\?.*)/i);
    if (n) {
      (e = e.split(n[0])), (n = n[0]);
      return ek(e[0] + "_" + t + n);
    }
    return null;
  }
  function ek(e) {
    return e.replace(/http(s)?:/, "");
  }
  function tk(t, e) {
    var n,
      r = Object.keys(t);
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(t)),
        e &&
          (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
        r.push.apply(r, n)),
      r
    );
  }
  function nk() {
    if (!pS.browser) return parseInt(void 0, 10) || 3e3;
    throw new Error("Must be server!");
  }
  function rk(t) {
    var n = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1],
      e = ik.find(function (e) {
        return !(!n && e.static) && e.id === t;
      });
    if (!e) throw Error("unknown plan id ".concat(t));
    return e;
  }
  (xp.getSizedImageUrl = ZC), (xp.removeProtocol = ek);
  var ik = [
      { id: "none", name: "None", static: !0 },
      { id: "partner", name: "Partner", static: !0 },
      { id: "free", name: "Free", static: !1 },
      { id: "starter", name: "Starter", price: 4.99, static: !1 },
      { id: "starter", name: "Starter", price: 3.99, static: !1 },
      { id: "pro", name: "Pro", price: 7.99, static: !1 },
      { id: "pro", name: "Pro", price: 6.99, static: !1 },
    ],
    ok = {
      getSizedImageUrl: function (r) {
        return function () {
          var e =
              0 < arguments.length && void 0 !== arguments[0]
                ? arguments[0]
                : null,
            t =
              1 < arguments.length && void 0 !== arguments[1]
                ? arguments[1]
                : null,
            n = 2 < arguments.length && void 0 !== arguments[2] && arguments[2];
          if (null === e && null === t) return r;
          n = (function (e) {
            return 1 < arguments.length &&
              void 0 !== arguments[1] &&
              arguments[1]
              ? "".concat(e, "_crop_center")
              : e;
          })(
            (function () {
              var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : null,
                t =
                  1 < arguments.length && void 0 !== arguments[1]
                    ? arguments[1]
                    : null;
              if (null === e) {
                var n = Math.min(Math.ceil(t), 5760);
                return "x".concat(n);
              }
              if (null === t) {
                n = Math.min(Math.ceil(e), 5760);
                return "".concat(n, "x");
              }
              (e = Math.min(Math.ceil(e), 5760)),
                (t = Math.min(Math.ceil(t), 5760));
              return "".concat(e, "x").concat(t);
            })(e, t),
            n
          );
          return ZC(r, n);
        };
      },
      getServerPort: nk,
      getServerEndpoint: function () {
        var e = nk();
        return "http://localhost:".concat(e);
      },
      getSubscriptionPlanByPrice: function (t) {
        var e = ik.find(function (e) {
          return "".concat(e.price) === t;
        });
        if (!e) throw Error("unknown plan price ".concat(t));
        return e;
      },
      getSubscriptionPlanById: rk,
      delay: function (t) {
        return new Promise(function (e) {
          return setTimeout(e, t);
        });
      },
      getRioMediaSettings: function (t, n, e) {
        var r = {
          muted: !1,
          autoPlay: !0,
          controls: !0,
          loop: !1,
          autoRotate: !0,
        };
        if (Array.isArray(e)) {
          e = e.find(function (e) {
            return e.id === t;
          });
          if (e) {
            e = e.media.find(function (e) {
              return e.id === n;
            });
            if (e)
              return (
                e.id,
                (function (r) {
                  for (var e = 1; e < arguments.length; e++) {
                    var i = null != arguments[e] ? arguments[e] : {};
                    e % 2
                      ? tk(Object(i), !0).forEach(function (e) {
                          var t, n;
                          (t = r),
                            (e = i[(n = e)]),
                            n in t
                              ? Object.defineProperty(t, n, {
                                  value: e,
                                  enumerable: !0,
                                  configurable: !0,
                                  writable: !0,
                                })
                              : (t[n] = e);
                        })
                      : Object.getOwnPropertyDescriptors
                      ? Object.defineProperties(
                          r,
                          Object.getOwnPropertyDescriptors(i)
                        )
                      : tk(Object(i)).forEach(function (e) {
                          Object.defineProperty(
                            r,
                            e,
                            Object.getOwnPropertyDescriptor(i, e)
                          );
                        });
                  }
                  return r;
                })(
                  {},
                  r,
                  {},
                  (function (e, t) {
                    if (null == e) return {};
                    var n,
                      r = (function (e, t) {
                        if (null == e) return {};
                        for (
                          var n, r = {}, i = Object.keys(e), o = 0;
                          o < i.length;
                          o++
                        )
                          (n = i[o]), 0 <= t.indexOf(n) || (r[n] = e[n]);
                        return r;
                      })(e, t);
                    if (Object.getOwnPropertySymbols)
                      for (
                        var i = Object.getOwnPropertySymbols(e), o = 0;
                        o < i.length;
                        o++
                      )
                        (n = i[o]),
                          0 <= t.indexOf(n) ||
                            (Object.prototype.propertyIsEnumerable.call(e, n) &&
                              (r[n] = e[n]));
                    return r;
                  })(e, ["id"])
                )
              );
          }
        }
        return r;
      },
      scaffoldRioMediaSettings: function () {
        return {
          muted: !1,
          autoPlay: !0,
          controls: !0,
          loop: !1,
          autoRotate: !0,
        };
      },
      getSubscriptionPlansById: function (t) {
        return ik.filter(function (e) {
          return e.id === t;
        });
      },
      getSubscriptionPaidPlans: function () {
        return [rk("starter"), rk("pro")];
      },
    };
  function ak(t, e) {
    var n,
      r = Object.keys(t);
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(t)),
        e &&
          (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
        r.push.apply(r, n)),
      r
    );
  }
  function sk(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2
        ? ak(Object(n), !0).forEach(function (e) {
            R(Kh)(t, e, n[e]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
        : ak(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
    }
    return t;
  }
  function lk(e) {
    return "left" === e || "right" === e;
  }
  function ck(e) {
    return Math.min(180 * Math.ceil(e / 180), 5760);
  }
  function uk() {
    return window.devicePixelRatio || 1;
  }
  function dk() {
    var e = window.location.href;
    return R(KC)(e, !0).query.variant || null;
  }
  var pk,
    fk = function (n) {
      return function (e, t) {
        return e[n] > t[n] ? 1 : t[n] > e[n] ? -1 : 0;
      };
    };
  function hk(e) {
    return "number" == typeof e && Number.isFinite(e)
      ? "".concat(((1 / e) * 100).toFixed(3), "%")
      : "100%";
  }
  function mk(e, t) {
    var n,
      r,
      i,
      o = !(1 < arguments.length && void 0 !== t) || t,
      a = e.media
        .concat()
        .sort(fk("position"))
        .map(function (e) {
          return (e = (function (e) {
            var t = e.media_type,
              n = e.aspect_ratio,
              r = e.preview_image,
              i = e.external_id,
              o = e.src,
              a = e.host,
              s = e.sources,
              l = e.id,
              c = e.alt,
              e = e.width,
              l = { id: "".concat(l), type: t, alt: c },
              c = s || [];
            if ("image" === t)
              return sk({}, l, {
                transformedSrc: ok.getSizedImageUrl(o),
                scale: hk(n),
                width: e,
              });
            if ("video" === t) {
              s = c
                .filter(function (e) {
                  return "video/mp4" === e.mime_type;
                })
                .sort(function (e, t) {
                  return t.height - e.height;
                })
                .map(function (e) {
                  return { mimeType: e.mime_type, url: e.url };
                });
              if (0 < s.length) {
                (o = []),
                  (e = c.find(function (e) {
                    return "application/x-mpegURL" === e.mime_type;
                  }));
                return (
                  e && o.push({ mimeType: e.mime_type, url: e.url }),
                  o.push(s[0]),
                  sk({}, l, {
                    transformedSrc: ok.getSizedImageUrl(r.src),
                    scale: hk(r.aspect_ratio),
                    sources: o,
                    scaleSources: hk(n),
                  })
                );
              }
            }
            if (
              "external_video" === t &&
              "youtube" === a &&
              "string" == typeof i
            )
              return sk({}, l, {
                transformedSrc: ok.getSizedImageUrl(r.src),
                scale: hk(r.aspect_ratio),
                sources: [i],
                scaleSources: hk(n),
              });
            if ("model" === t) {
              c = c.find(function (e) {
                return "glb" === e.format;
              });
              if (c && "string" == typeof c.url)
                return sk({}, l, {
                  transformedSrc: ok.getSizedImageUrl(r.src),
                  scale: hk(r.aspect_ratio),
                  sources: [c.url],
                  scaleSources: hk(r.aspect_ratio),
                });
            }
            return null;
          })(e))
            ? sk({}, e, { rioSettings: ok.scaffoldRioMediaSettings() })
            : null;
        })
        .filter(function (e) {
          return null !== e;
        });
    o &&
      ((n = a),
      (s = e.variants),
      (i = dk()) &&
        (!(r = s.find(function (e) {
          return "".concat(e.id) === i;
        })) ||
          (-1 <
            (o = n.findIndex(function (e) {
              return "".concat(r.featured_media.id) === e.id;
            })) &&
            ((s = n[o]), n.splice(o, 1), n.unshift(s)))));
    var s = e.variants.map(function (t) {
      return {
        id: "".concat(t.id),
        featuredMediaIndex: t.featured_media
          ? a.findIndex(function (e) {
              return "".concat(t.featured_media.id) === e.id;
            })
          : -1,
        available: t.available,
      };
    });
    return { media: a, variants: s };
  }
  function gk() {}
  function vk() {}
  (_f = {
    RioMediaSettingsProps:
      (!(vp = {}) || (YT = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"),
      (pk = YT),
      (vk.resetWarningCache = gk),
      (vp = (function () {
        function e(e, t, n, r, i, o) {
          if (o !== pk) {
            o = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ((o.name = "Invariant Violation"), o);
          }
        }
        function t() {
          return e;
        }
        var n = {
          array: (e.isRequired = e),
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          elementType: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t,
          checkPropTypes: vk,
          resetWarningCache: gk,
        };
        return (n.PropTypes = n);
      })()).shape({
        autoPlay: vp.bool.isRequired,
        autoRotate: vp.bool.isRequired,
        controls: vp.bool.isRequired,
        loop: vp.bool.isRequired,
        muted: vp.bool.isRequired,
      })),
  }),
    (wC = function (e, t, n) {
      return "number" != typeof e.thumbnailWidth &&
        "number" != typeof e.thumbnailsPerRow
        ? new Error(
            "One of 'thumbnails.thumbnailWidth' or 'thumbnails.thumbnailsPerRow' required by '".concat(
              n,
              "' component are not numbers"
            )
          )
        : e.thumbnailWidth || e.thumbnailsPerRow
        ? lk(e.orientation) &&
          e.thumbnailsPerRow &&
          !e.thumbnailWidth &&
          !e.container
          ? new Error(
              "Both 'thumbnails.thumbnailWidth' and 'thumbnails.thumbnailsPerRow' is required by '".concat(
                n,
                "' component."
              )
            )
          : void 0
        : new Error(
            "One of 'thumbnails.thumbnailWidth' or 'thumbnails.thumbnailsPerRow' is required by '".concat(
              n,
              "' component."
            )
          );
    }),
    (If = RP.shape({
      navigation: RP.bool.isRequired,
      pagination: RP.bool.isRequired,
      clickablePagination: RP.bool,
      swipe: RP.bool.isRequired,
      keyboard: RP.bool,
      vertical: function (e, t, n) {
        if (e.vertical)
          return e.magnify
            ? new Error(
                "'magnify' cannot be true when 'vertical' is true in '".concat(
                  n,
                  "' component."
                )
              )
            : e.thumbnails
            ? new Error(
                "'thumbnails' cannot be true when 'vertical' is true in '".concat(
                  n,
                  "' component."
                )
              )
            : void 0;
      },
      verticalSpacing: RP.string,
      maxHeight: RP.string,
      magnify: RP.oneOfType([
        RP.oneOf([!1]),
        RP.exact({ width: RP.string, height: RP.string, zoom: RP.number }),
      ]),
      thumbnails: RP.oneOfType([
        RP.oneOf([!1]),
        RP.exact({
          orientation: RP.oneOf(["bottom", "top", "right", "left"]).isRequired,
          multiRow: function (e, t, n) {
            return "boolean" != typeof e.multiRow
              ? new Error(
                  "'thumbnails.multiRow' is required to be a boolean by '".concat(
                    n,
                    "' component."
                  )
                )
              : !e.multiRow && lk(e.orientation)
              ? new Error(
                  "'thumbnails.muliRow' cannot be false with left or right 'thumbnails.orientation' in '".concat(
                    n,
                    "' component."
                  )
                )
              : void 0;
          },
          thumbnailWidth: wC,
          thumbnailsPerRow: wC,
          container: function (e, t, n) {
            if (e.container)
              return "number" != typeof e.container
                ? new Error(
                    "'thumbnails.container' needs to be a number in '".concat(
                      n,
                      "' component."
                    )
                  )
                : e.container < 0 || 1 < e.container
                ? new Error(
                    "'thumbnails.container' needs to be between 0.0 and 1.0 (inclusive) in '".concat(
                      n,
                      "' component."
                    )
                  )
                : "number" != typeof e.thumbnailsPerRow
                ? new Error(
                    "'thumbnails.thumbnailsPerRow' needs to also be set in conjuction with 'thumbnails.container' in '".concat(
                      n,
                      "' component."
                    )
                  )
                : "number" == typeof e.thumbnailWidth
                ? new Error(
                    "'thumbnails.thumbnailWidth' cannot also be set with 'thumbnails.container' and 'thumbnails.thumbnailsPerRow' in '".concat(
                      n,
                      "' component."
                    )
                  )
                : void 0;
          },
          navigation: RP.bool.isRequired,
          verticalOverflow: function (e, t, n) {
            if ("boolean" == typeof e.verticalOverflow)
              return e.verticalOverflow && !lk(e.orientation)
                ? new Error(
                    "'thumbnails.verticalOverflow' cannot be true with top or bottom 'thumbnails.orientation' in '".concat(
                      n,
                      "' component."
                    )
                  )
                : !e.verticalOverflow && e.navigation
                ? new Error(
                    "'thumbnails.verticalOverflow' cannot be false with 'thumbnails.navigation' also being true in '".concat(
                      n,
                      "' component."
                    )
                  )
                : void 0;
          },
          square: RP.bool,
          centerCrop: RP.bool,
        }),
      ]),
      lightBox: RP.bool.isRequired,
      lightBoxZoom: function (e, t, n) {
        if (e.lightBox && !Number.isFinite(e.lightBoxZoom))
          return new Error(
            "'lightBoxZoom' is required when 'lightBox' is true in '".concat(
              n,
              "' component."
            )
          );
      },
    })),
    (xp = RP.exact({
      id: RP.string.isRequired,
      type: RP.string.isRequired,
      alt: RP.string,
      width: RP.number,
      rioSettings: _f.RioMediaSettingsProps.isRequired,
      transformedSrc: RP.func.isRequired,
      scale: RP.string,
      sources: RP.oneOfType([
        RP.arrayOf(RP.string),
        RP.arrayOf(
          RP.shape({
            url: RP.string.isRequired,
            mimeType: RP.string.isRequired,
          })
        ),
      ]),
      scaleSources: RP.string,
    })),
    Q();
  var yk,
    bk,
    wk,
    xk,
    Ek,
    Sk,
    Ck,
    kk,
    Tk,
    Pk,
    zk,
    Ok,
    Rk,
    Mk,
    Nk,
    Lk,
    Ik,
    _k,
    Dk,
    Ak,
    Fk,
    Bk,
    Wk,
    $k,
    jk,
    Hk,
    Vk,
    qk,
    Uk,
    Gk,
    Yk,
    Xk,
    Kk,
    Zk,
    Qk,
    Jk,
    eT,
    tT,
    nT,
    rT,
    iT,
    oT,
    aT,
    sT,
    lT,
    cT,
    uT,
    dT,
    pT,
    fT,
    hT,
    mT,
    vp = (YT = {}),
    wC = function () {
      return function (f, n, e, t) {
        var h = {
          features: null,
          bind: function (e, t, n, r) {
            var i = (r ? "remove" : "add") + "EventListener";
            t = t.split(" ");
            for (var o = 0; o < t.length; o++) t[o] && e[i](t[o], n, !1);
          },
          isArray: function (e) {
            return e instanceof Array;
          },
          createEl: function (e, t) {
            t = document.createElement(t || "div");
            return e && (t.className = e), t;
          },
          getScrollY: function () {
            var e = window.pageYOffset;
            return void 0 !== e ? e : document.documentElement.scrollTop;
          },
          unbind: function (e, t, n) {
            h.bind(e, t, n, !0);
          },
          removeClass: function (e, t) {
            t = new RegExp("(\\s|^)" + t + "(\\s|$)");
            e.className = e.className
              .replace(t, " ")
              .replace(/^\s\s*/, "")
              .replace(/\s\s*$/, "");
          },
          addClass: function (e, t) {
            h.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
          },
          hasClass: function (e, t) {
            return (
              e.className &&
              new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className)
            );
          },
          getChildByClass: function (e, t) {
            for (var n = e.firstChild; n; ) {
              if (h.hasClass(n, t)) return n;
              n = n.nextSibling;
            }
          },
          arraySearch: function (e, t, n) {
            for (var r = e.length; r--; ) if (e[r][n] === t) return r;
            return -1;
          },
          extend: function (e, t, n) {
            for (var r in t)
              if (t.hasOwnProperty(r)) {
                if (n && e.hasOwnProperty(r)) continue;
                e[r] = t[r];
              }
          },
          easing: {
            sine: {
              out: function (e) {
                return Math.sin(e * (Math.PI / 2));
              },
              inOut: function (e) {
                return -(Math.cos(Math.PI * e) - 1) / 2;
              },
            },
            cubic: {
              out: function (e) {
                return --e * e * e + 1;
              },
            },
          },
          detectFeatures: function () {
            if (h.features) return h.features;
            var e,
              t,
              n = h.createEl().style,
              r = "",
              i = {};
            (i.oldIE = document.all && !document.addEventListener),
              (i.touch = "ontouchstart" in window),
              window.requestAnimationFrame &&
                ((i.raf = window.requestAnimationFrame),
                (i.caf = window.cancelAnimationFrame)),
              (i.pointerEvent =
                !!window.PointerEvent || navigator.msPointerEnabled),
              i.pointerEvent ||
                ((e = navigator.userAgent),
                !/iP(hone|od)/.test(navigator.platform) ||
                  ((t = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)) &&
                    0 < t.length &&
                    1 <= (t = parseInt(t[1], 10)) &&
                    t < 8 &&
                    (i.isOldIOSPhone = !0)),
                (t = (t = e.match(/Android\s([0-9\.]*)/)) ? t[1] : 0),
                1 <= (t = parseFloat(t)) &&
                  (t < 4.4 && (i.isOldAndroid = !0), (i.androidVersion = t)),
                (i.isMobileOpera = /opera mini|opera mobi/i.test(e)));
            for (
              var o,
                a,
                s,
                l = ["transform", "perspective", "animationName"],
                c = ["", "webkit", "Moz", "ms", "O"],
                u = 0;
              u < 4;
              u++
            ) {
              r = c[u];
              for (var d = 0; d < 3; d++)
                (o = l[d]),
                  (a = r + (r ? o.charAt(0).toUpperCase() + o.slice(1) : o)),
                  !i[o] && a in n && (i[o] = a);
              r &&
                !i.raf &&
                ((r = r.toLowerCase()),
                (i.raf = window[r + "RequestAnimationFrame"]),
                i.raf &&
                  (i.caf =
                    window[r + "CancelAnimationFrame"] ||
                    window[r + "CancelRequestAnimationFrame"]));
            }
            return (
              i.raf ||
                ((s = 0),
                (i.raf = function (e) {
                  var t = new Date().getTime(),
                    n = Math.max(0, 16 - (t - s)),
                    r = window.setTimeout(function () {
                      e(t + n);
                    }, n);
                  return (s = t + n), r;
                }),
                (i.caf = function (e) {
                  clearTimeout(e);
                })),
              (i.svg =
                !!document.createElementNS &&
                !!document.createElementNS("http://www.w3.org/2000/svg", "svg")
                  .createSVGRect),
              (h.features = i)
            );
          },
        };
        h.detectFeatures(),
          h.features.oldIE &&
            (h.bind = function (e, t, n, r) {
              t = t.split(" ");
              function i() {
                n.handleEvent.call(n);
              }
              for (
                var o, a = (r ? "detach" : "attach") + "Event", s = 0;
                s < t.length;
                s++
              )
                if ((o = t[s]))
                  if ("object" == typeof n && n.handleEvent) {
                    if (r) {
                      if (!n["oldIE" + o]) return !1;
                    } else n["oldIE" + o] = i;
                    e[a]("on" + o, n["oldIE" + o]);
                  } else e[a]("on" + o, n);
            });
        var m = this,
          g = {
            allowPanToNext: !0,
            spacing: 0.12,
            bgOpacity: 1,
            mouseUsed: !1,
            loop: !0,
            pinchToClose: !0,
            closeOnScroll: !0,
            closeOnVerticalDrag: !0,
            verticalDragRange: 0.75,
            hideAnimationDuration: 333,
            showAnimationDuration: 333,
            showHideOpacity: !1,
            focus: !0,
            escKey: !0,
            arrowKeys: !0,
            mainScrollEndFriction: 0.35,
            panEndFriction: 0.35,
            isClickableElement: function (e) {
              return "A" === e.tagName;
            },
            getDoubleTapZoom: function (e, t) {
              return e || t.initialZoomLevel < 0.7 ? 1 : 1.33;
            },
            maxSpreadZoom: 1.33,
            modal: !0,
            scaleMode: "fit",
          };
        h.extend(g, t);
        function r(e, t) {
          h.extend(m, t.publicMethods), Ke.push(e);
        }
        function a(e) {
          var t = Vt();
          return t - 1 < e ? e - t : e < 0 ? t + e : e;
        }
        function o(e, t) {
          return Je[e] || (Je[e] = []), Je[e].push(t);
        }
        function v(e) {
          var t = Je[e];
          if (t) {
            var n = Array.prototype.slice.call(arguments);
            n.shift();
            for (var r = 0; r < t.length; r++) t[r].apply(m, n);
          }
        }
        function u() {
          return new Date().getTime();
        }
        function y(e) {
          (Fe = e), (m.bg.style.opacity = e * g.bgOpacity);
        }
        function i(e, t, n, r, i) {
          (!Qe || (i && i !== m.currItem)) && (r /= (i || m.currItem).fitRatio),
            (e[ae] = K + t + "px, " + n + "px" + Z + " scale(" + r + ")");
        }
        function d(e, t) {
          var n;
          !g.loop &&
            t &&
            ((n = j + (Ge.x * qe - e) / Ge.x),
            (t = Math.round(e - bt.x)),
            ((n < 0 && 0 < t) || (n >= Vt() - 1 && t < 0)) &&
              (e = bt.x + t * g.mainScrollEndFriction)),
            (bt.x = e),
            nt(e, H);
        }
        function s(e, t) {
          var n = wt[e] - Ue[e];
          return je[e] + $e[e] + n - (t / X) * n;
        }
        function b(e, t) {
          (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
        }
        function c(e) {
          (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
        }
        function p(e, t) {
          return (e = Xt(m.currItem, Ve, e)), t && (Ne = e), e;
        }
        function l(e) {
          return (e = e || m.currItem).initialZoomLevel;
        }
        function w(e) {
          return 0 < (e = e || m.currItem).w ? g.maxSpreadZoom : 1;
        }
        function x(e, t, n, r) {
          return r === m.currItem.initialZoomLevel
            ? ((n[e] = m.currItem.initialPosition[e]), !0)
            : ((n[e] = s(e, r)),
              n[e] > t.min[e]
                ? ((n[e] = t.min[e]), !0)
                : n[e] < t.max[e] && ((n[e] = t.max[e]), !0));
        }
        function E(e) {
          var t = "";
          g.escKey && 27 === e.keyCode
            ? (t = "close")
            : g.arrowKeys &&
              (37 === e.keyCode
                ? (t = "prev")
                : 39 === e.keyCode && (t = "next")),
            t &&
              (e.ctrlKey ||
                e.altKey ||
                e.shiftKey ||
                e.metaKey ||
                (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
                m[t]()));
        }
        function S(e) {
          e &&
            (Te || ke || Ie || xe) &&
            (e.preventDefault(), e.stopPropagation());
        }
        function C() {
          m.setScrollOffset(0, h.getScrollY());
        }
        function k(e) {
          ot[e] && (ot[e].raf && ue(ot[e].raf), at--, delete ot[e]);
        }
        function T(e) {
          ot[e] && k(e), ot[e] || (at++, (ot[e] = {}));
        }
        function P() {
          for (var e in ot) ot.hasOwnProperty(e) && k(e);
        }
        function z(e, t, n, r, i, o, a) {
          var s,
            l = u();
          T(e);
          var c = function () {
            if (ot[e]) {
              if ((s = u() - l) >= r) return k(e), o(n), void (a && a());
              o((n - t) * i(s / r) + t), (ot[e].raf = ce(c));
            }
          };
          c();
        }
        function O(e, t) {
          return (
            (mt.x = Math.abs(e.x - t.x)),
            (mt.y = Math.abs(e.y - t.y)),
            Math.sqrt(mt.x * mt.x + mt.y * mt.y)
          );
        }
        function R(e, t) {
          return (
            (kt.prevent = !Ct(e.target, g.isClickableElement)),
            v("preventDragEvent", e, t, kt),
            kt.prevent
          );
        }
        function M(e, t) {
          return (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t;
        }
        function N(e, t, n) {
          (n.x = 0.5 * (e.x + t.x)), (n.y = 0.5 * (e.y + t.y));
        }
        function L() {
          var e = He.y - m.currItem.initialPosition.y;
          return 1 - Math.abs(e / (Ve.y / 2));
        }
        function I(e) {
          for (; 0 < zt.length; ) zt.pop();
          return (
            se
              ? ((We = 0),
                pt.forEach(function (e) {
                  0 === We ? (zt[0] = e) : 1 === We && (zt[1] = e), We++;
                }))
              : -1 < e.type.indexOf("touch")
              ? e.touches &&
                0 < e.touches.length &&
                ((zt[0] = M(e.touches[0], Tt)),
                1 < e.touches.length && (zt[1] = M(e.touches[1], Pt)))
              : ((Tt.x = e.pageX),
                (Tt.y = e.pageY),
                (Tt.id = ""),
                (zt[0] = Tt)),
            zt
          );
        }
        function _(e, t) {
          var n,
            r,
            i,
            o = He[e] + t[e],
            a = 0 < t[e],
            s = bt.x + t.x,
            l = bt.x - ft.x,
            c = o > Ne.min[e] || o < Ne.max[e] ? g.panEndFriction : 1,
            o = He[e] + t[e] * c;
          if (
            (g.allowPanToNext || Y === m.currItem.initialZoomLevel) &&
            (Le
              ? "h" !== _e ||
                "x" !== e ||
                ke ||
                (a
                  ? (o > Ne.min[e] &&
                      ((c = g.panEndFriction),
                      Ne.min[e],
                      (n = Ne.min[e] - je[e])),
                    (n <= 0 || l < 0) && 1 < Vt()
                      ? ((i = s), l < 0 && s > ft.x && (i = ft.x))
                      : Ne.min.x !== Ne.max.x && (r = o))
                  : (o < Ne.max[e] &&
                      ((c = g.panEndFriction),
                      Ne.max[e],
                      (n = je[e] - Ne.max[e])),
                    (n <= 0 || 0 < l) && 1 < Vt()
                      ? ((i = s), 0 < l && s < ft.x && (i = ft.x))
                      : Ne.min.x !== Ne.max.x && (r = o)))
              : (i = s),
            "x" === e)
          )
            return (
              void 0 !== i && (d(i, !0), (ze = i !== ft.x)),
              Ne.min.x !== Ne.max.x &&
                (void 0 !== r ? (He.x = r) : ze || (He.x += t.x * c)),
              void 0 !== i
            );
          Ie || ze || (Y > m.currItem.fitRatio && (He[e] += t[e] * c));
        }
        function D(e) {
          var t;
          ("mousedown" === e.type && 0 < e.button) ||
            (jt
              ? e.preventDefault()
              : (Ee && "mousedown" === e.type) ||
                (R(e, !0) && e.preventDefault(),
                v("pointerDown"),
                se &&
                  ((t = h.arraySearch(pt, e.pointerId, "id")) < 0 &&
                    (t = pt.length),
                  (pt[t] = { x: e.pageX, y: e.pageY, id: e.pointerId })),
                (e = (t = I(e)).length),
                (Oe = null),
                P(),
                (Se && 1 !== e) ||
                  ((Se = De = !0),
                  h.bind(window, q, m),
                  (we = Be = Ae = xe = ze = Te = Ce = ke = !1),
                  (_e = null),
                  v("firstTouchStart", t),
                  b(je, He),
                  ($e.x = $e.y = 0),
                  b(ut, t[0]),
                  b(dt, ut),
                  (ft.x = Ge.x * qe),
                  (ht = [{ x: ut.x, y: ut.y }]),
                  (ye = ve = u()),
                  p(Y, !0),
                  Et(),
                  St()),
                !Re &&
                  1 < e &&
                  !Ie &&
                  !ze &&
                  ((X = Y),
                  (Re = Ce = !(ke = !1)),
                  ($e.y = $e.x = 0),
                  b(je, He),
                  b(st, t[0]),
                  b(lt, t[1]),
                  N(st, lt, xt),
                  (wt.x = Math.abs(xt.x) - He.x),
                  (wt.y = Math.abs(xt.y) - He.y),
                  (Me = O(st, lt)))));
        }
        function A(e) {
          var t, n;
          e.preventDefault(),
            se &&
              -1 < (t = h.arraySearch(pt, e.pointerId, "id")) &&
              (((n = pt[t]).x = e.pageX), (n.y = e.pageY)),
            Se &&
              ((n = I(e)),
              _e || Te || Re
                ? (Oe = n)
                : bt.x !== Ge.x * qe
                ? (_e = "h")
                : ((e = Math.abs(n[0].x - ut.x) - Math.abs(n[0].y - ut.y)),
                  10 <= Math.abs(e) && ((_e = 0 < e ? "h" : "v"), (Oe = n))));
        }
        function F(e) {
          if (me.isOldAndroid) {
            if (Ee && "mouseup" === e.type) return;
            -1 < e.type.indexOf("touch") &&
              (clearTimeout(Ee),
              (Ee = setTimeout(function () {
                Ee = 0;
              }, 600)));
          }
          v("pointerUp"),
            R(e, !1) && e.preventDefault(),
            se &&
              -1 < (n = h.arraySearch(pt, e.pointerId, "id")) &&
              ((o = pt.splice(n, 1)[0]),
              navigator.msPointerEnabled
                ? ((o.type = { 4: "mouse", 2: "touch", 3: "pen" }[
                    e.pointerType
                  ]),
                  o.type || (o.type = e.pointerType || "mouse"))
                : (o.type = e.pointerType || "mouse"));
          var t = I(e),
            n = t.length;
          if (("mouseup" === e.type && (n = 0), 2 === n)) return !(Oe = null);
          1 === n && b(dt, t[0]),
            0 !== n ||
              _e ||
              Ie ||
              (o ||
                ("mouseup" === e.type
                  ? (o = { x: e.pageX, y: e.pageY, type: "mouse" })
                  : e.changedTouches &&
                    e.changedTouches[0] &&
                    (o = {
                      x: e.changedTouches[0].pageX,
                      y: e.changedTouches[0].pageY,
                      type: "touch",
                    })),
              v("touchRelease", e, o));
          var r,
            i,
            o = -1;
          if (
            (0 === n &&
              ((Se = !1),
              h.unbind(window, q, m),
              Et(),
              Re ? (o = 0) : -1 !== yt && (o = u() - yt)),
            (yt = 1 === n ? u() : -1),
            (o = -1 !== o && o < 150 ? "zoom" : "swipe"),
            Re &&
              n < 2 &&
              ((Re = !1),
              1 === n && (o = "zoomPointerUp"),
              v("zoomGestureEnded")),
            (Oe = null),
            Te || ke || Ie || xe)
          )
            if ((P(), (be = be || Rt()).calculateSwipeSpeed("x"), xe))
              L() < g.verticalDragRange
                ? m.close()
                : ((r = He.y),
                  (i = Fe),
                  z(
                    "verticalDrag",
                    0,
                    1,
                    300,
                    h.easing.cubic.out,
                    function (e) {
                      (He.y = (m.currItem.initialPosition.y - r) * e + r),
                        y((1 - i) * e + i),
                        et();
                    }
                  ),
                  v("onVerticalDrag", 1));
            else {
              if ((ze || Ie) && 0 === n) {
                if (Nt(o, be)) return;
                o = "zoomPointerUp";
              }
              Ie ||
                ("swipe" === o
                  ? !ze && Y > m.currItem.fitRatio && Mt(be)
                  : It());
            }
        }
        var B,
          W,
          $,
          j,
          H,
          V,
          q,
          U,
          G,
          Y,
          X,
          K,
          Z,
          Q,
          J,
          ee,
          te,
          ne,
          re,
          ie,
          oe,
          ae,
          se,
          le,
          ce,
          ue,
          de,
          pe,
          fe,
          he,
          me,
          ge,
          ve,
          ye,
          be,
          we,
          xe,
          Ee,
          Se,
          Ce,
          ke,
          Te,
          Pe,
          ze,
          Oe,
          Re,
          Me,
          Ne,
          Le,
          Ie,
          _e,
          De,
          Ae,
          Fe,
          Be,
          We,
          $e = { x: 0, y: 0 },
          je = { x: 0, y: 0 },
          He = { x: 0, y: 0 },
          Ve = {},
          qe = 0,
          Ue = {},
          Ge = { x: 0, y: 0 },
          Ye = 0,
          Xe = !0,
          Ke = [],
          Ze = {},
          Qe = !1,
          Je = {},
          et = function (e) {
            Le &&
              (e &&
                (Y > m.currItem.fitRatio
                  ? Qe || (Kt(m.currItem, !1, !0), (Qe = !0))
                  : Qe && (Kt(m.currItem), (Qe = !1))),
              i(Le, He.x, He.y, Y));
          },
          tt = function (e) {
            e.container &&
              i(
                e.container.style,
                e.initialPosition.x,
                e.initialPosition.y,
                e.initialZoomLevel,
                e
              );
          },
          nt = function (e, t) {
            t[ae] = K + e + "px, 0px" + Z;
          },
          rt = null,
          it = function () {
            rt &&
              (h.unbind(document, "mousemove", it),
              h.addClass(f, "pwwp--has_mouse"),
              (g.mouseUsed = !0),
              v("mouseUsed")),
              (rt = setTimeout(function () {
                rt = null;
              }, 100));
          },
          ot = {},
          at = 0,
          t = {
            shout: v,
            listen: o,
            viewportSize: Ve,
            options: g,
            isMainScrollAnimating: function () {
              return Ie;
            },
            getZoomLevel: function () {
              return Y;
            },
            getCurrentIndex: function () {
              return j;
            },
            isDragging: function () {
              return Se;
            },
            isZooming: function () {
              return Re;
            },
            setScrollOffset: function (e, t) {
              (Ue.x = e), (he = Ue.y = t), v("updateScrollOffset", Ue);
            },
            applyZoomPan: function (e, t, n, r) {
              (He.x = t), (He.y = n), (Y = e), et(r);
            },
            init: function () {
              if (!B && !W) {
                var e;
                (m.framework = h),
                  (m.template = f),
                  (m.bg = h.getChildByClass(f, "pwwp__bg")),
                  (de = f.className),
                  (B = !0),
                  (me = h.detectFeatures()),
                  (ce = me.raf),
                  (ue = me.caf),
                  (ae = me.transform),
                  (fe = me.oldIE),
                  (m.scrollWrap = h.getChildByClass(f, "pwwp__scroll-wrap")),
                  (m.container = h.getChildByClass(
                    m.scrollWrap,
                    "pwwp__container"
                  )),
                  (H = m.container.style),
                  (m.itemHolders = ee = [
                    { el: m.container.children[0], wrap: 0, index: -1 },
                    { el: m.container.children[1], wrap: 0, index: -1 },
                    { el: m.container.children[2], wrap: 0, index: -1 },
                  ]),
                  (ee[0].el.style.display = ee[2].el.style.display = "none"),
                  (function () {
                    if (ae) {
                      var e = me.perspective && !le;
                      return (
                        (K = "translate" + (e ? "3d(" : "(")),
                        (Z = me.perspective ? ", 0px)" : ")")
                      );
                    }
                    (ae = "left"),
                      h.addClass(f, "pwwp--ie"),
                      (nt = function (e, t) {
                        t.left = e + "px";
                      }),
                      (tt = function (e) {
                        var t = 1 < e.fitRatio ? 1 : e.fitRatio,
                          n = e.container.style,
                          r = t * e.w,
                          t = t * e.h;
                        (n.width = r + "px"),
                          (n.height = t + "px"),
                          (n.left = e.initialPosition.x + "px"),
                          (n.top = e.initialPosition.y + "px");
                      }),
                      (et = function () {
                        var e, t, n, r;
                        Le &&
                          ((e = Le),
                          (n =
                            (t =
                              1 < (r = m.currItem).fitRatio ? 1 : r.fitRatio) *
                            r.w),
                          (r = t * r.h),
                          (e.width = n + "px"),
                          (e.height = r + "px"),
                          (e.left = He.x + "px"),
                          (e.top = He.y + "px"));
                      });
                  })(),
                  (G = {
                    resize: m.updateSize,
                    orientationchange: function () {
                      clearTimeout(ge),
                        (ge = setTimeout(function () {
                          Ve.x !== m.scrollWrap.clientWidth && m.updateSize();
                        }, 500));
                    },
                    scroll: C,
                    keydown: E,
                    click: S,
                  });
                var t = me.isOldIOSPhone || me.isOldAndroid || me.isMobileOpera;
                for (
                  (me.animationName && me.transform && !t) ||
                    (g.showAnimationDuration = g.hideAnimationDuration = 0),
                    e = 0;
                  e < Ke.length;
                  e++
                )
                  m["init" + Ke[e]]();
                n && (m.ui = new n(m, h)).init(),
                  v("firstUpdate"),
                  (j = j || g.index || 0),
                  (isNaN(j) || j < 0 || j >= Vt()) && (j = 0),
                  (m.currItem = Ht(j)),
                  (me.isOldIOSPhone || me.isOldAndroid) && (Xe = !1),
                  f.setAttribute("aria-hidden", "false"),
                  g.modal &&
                    (Xe
                      ? (f.style.position = "fixed")
                      : ((f.style.position = "absolute"),
                        (f.style.top = h.getScrollY() + "px"))),
                  void 0 === he &&
                    (v("initialLayout"), (he = pe = h.getScrollY()));
                t = "pwwp--open ";
                for (
                  g.mainClass && (t += g.mainClass + " "),
                    g.showHideOpacity && (t += "pwwp--animate_opacity "),
                    t += le ? "pwwp--touch" : "pwwp--notouch",
                    t += me.animationName ? " pwwp--css_animation" : "",
                    t += me.svg ? " pwwp--svg" : "",
                    h.addClass(f, t),
                    m.updateSize(),
                    V = -1,
                    Ye = null,
                    e = 0;
                  e < 3;
                  e++
                )
                  nt((e + V) * Ge.x, ee[e].el.style);
                fe || h.bind(m.scrollWrap, U, m),
                  o("initialZoomInEnd", function () {
                    m.setContent(ee[0], j - 1),
                      m.setContent(ee[2], j + 1),
                      (ee[0].el.style.display = ee[2].el.style.display =
                        "block"),
                      g.focus && f.focus(),
                      h.bind(document, "keydown", m),
                      me.transform && h.bind(m.scrollWrap, "click", m),
                      g.mouseUsed || h.bind(document, "mousemove", it),
                      h.bind(window, "resize scroll orientationchange", m),
                      v("bindEvents");
                  }),
                  m.setContent(ee[1], j),
                  m.updateCurrItem(),
                  v("afterInit"),
                  Xe ||
                    (Q = setInterval(function () {
                      at ||
                        Se ||
                        Re ||
                        Y !== m.currItem.initialZoomLevel ||
                        m.updateSize();
                    }, 1e3)),
                  h.addClass(f, "pwwp--visible");
              }
            },
            close: function () {
              B &&
                ((W = !(B = !1)),
                v("close"),
                h.unbind(window, "resize scroll orientationchange", m),
                h.unbind(window, "scroll", G.scroll),
                h.unbind(document, "keydown", m),
                h.unbind(document, "mousemove", it),
                me.transform && h.unbind(m.scrollWrap, "click", m),
                Se && h.unbind(window, q, m),
                clearTimeout(ge),
                v("unbindEvents"),
                qt(m.currItem, null, !0, m.destroy));
            },
            destroy: function () {
              v("destroy"),
                Bt && clearTimeout(Bt),
                f.setAttribute("aria-hidden", "true"),
                (f.className = de),
                Q && clearInterval(Q),
                h.unbind(m.scrollWrap, U, m),
                h.unbind(window, "scroll", m),
                Et(),
                P(),
                (Je = null);
            },
            panTo: function (e, t, n) {
              n ||
                (e > Ne.min.x ? (e = Ne.min.x) : e < Ne.max.x && (e = Ne.max.x),
                t > Ne.min.y ? (t = Ne.min.y) : t < Ne.max.y && (t = Ne.max.y)),
                (He.x = e),
                (He.y = t),
                et();
            },
            handleEvent: function (e) {
              (e = e || window.event), G[e.type] && G[e.type](e);
            },
            goTo: function (e) {
              var t = (e = a(e)) - j;
              (Ye = t),
                (j = e),
                (m.currItem = Ht(j)),
                (qe -= t),
                d(Ge.x * qe),
                P(),
                (Ie = !1),
                m.updateCurrItem();
            },
            next: function () {
              m.goTo(j + 1);
            },
            prev: function () {
              m.goTo(j - 1);
            },
            updateCurrZoomItem: function (e) {
              var t;
              e && v("beforeChange", 0),
                (Le = ee[1].el.children.length
                  ? ((t = ee[1].el.children[0]),
                    h.hasClass(t, "pwwp__zoom-wrap") ? t.style : null)
                  : null),
                (Ne = m.currItem.bounds),
                (X = Y = m.currItem.initialZoomLevel),
                (He.x = Ne.center.x),
                (He.y = Ne.center.y),
                e && v("afterChange");
            },
            invalidateCurrItems: function () {
              J = !0;
              for (var e = 0; e < 3; e++)
                ee[e].item && (ee[e].item.needsUpdate = !0);
            },
            updateCurrItem: function (e) {
              if (0 !== Ye) {
                var t,
                  n = Math.abs(Ye);
                if (!(e && n < 2)) {
                  (m.currItem = Ht(j)),
                    (Qe = !1),
                    v("beforeChange", Ye),
                    3 <= n && ((V += Ye + (0 < Ye ? -3 : 3)), (n = 3));
                  for (var r = 0; r < n; r++)
                    0 < Ye
                      ? ((t = ee.shift()),
                        (ee[2] = t),
                        nt((++V + 2) * Ge.x, t.el.style),
                        m.setContent(t, j - n + r + 1 + 1))
                      : ((t = ee.pop()),
                        ee.unshift(t),
                        nt(--V * Ge.x, t.el.style),
                        m.setContent(t, j + n - r - 1 - 1));
                  !Le ||
                    1 !== Math.abs(Ye) ||
                    ((e = Ht(te)).initialZoomLevel !== Y &&
                      (Xt(e, Ve), Kt(e), tt(e))),
                    (Ye = 0),
                    m.updateCurrZoomItem(),
                    (te = j),
                    v("afterChange");
                }
              }
            },
            updateSize: function (e) {
              if (!Xe && g.modal) {
                var t = h.getScrollY();
                if (
                  (he !== t && ((f.style.top = t + "px"), (he = t)),
                  !e &&
                    Ze.x === window.innerWidth &&
                    Ze.y === window.innerHeight)
                )
                  return;
                (Ze.x = window.innerWidth),
                  (Ze.y = window.innerHeight),
                  (f.style.height = Ze.y + "px");
              }
              if (
                ((Ve.x = m.scrollWrap.clientWidth),
                (Ve.y = m.scrollWrap.clientHeight),
                C(),
                (Ge.x = Ve.x + Math.round(Ve.x * g.spacing)),
                (Ge.y = Ve.y),
                d(Ge.x * qe),
                v("beforeResize"),
                void 0 !== V)
              ) {
                for (var n, r, i, o = 0; o < 3; o++)
                  (n = ee[o]),
                    nt((o + V) * Ge.x, n.el.style),
                    (i = j + o - 1),
                    g.loop && 2 < Vt() && (i = a(i)),
                    (r = Ht(i)) && (J || r.needsUpdate || !r.bounds)
                      ? (m.cleanSlide(r),
                        m.setContent(n, i),
                        1 === o && ((m.currItem = r), m.updateCurrZoomItem(!0)),
                        (r.needsUpdate = !1))
                      : -1 === n.index && 0 <= i && m.setContent(n, i),
                    r && r.container && (Xt(r, Ve), Kt(r), tt(r));
                J = !1;
              }
              (X = Y = m.currItem.initialZoomLevel),
                (Ne = m.currItem.bounds) &&
                  ((He.x = Ne.center.x), (He.y = Ne.center.y), et(!0)),
                v("resize");
            },
            zoomTo: function (t, e, n, r, i) {
              e &&
                ((X = Y),
                (wt.x = Math.abs(e.x) - He.x),
                (wt.y = Math.abs(e.y) - He.y),
                b(je, He));
              var e = p(t, !1),
                o = {};
              x("x", e, o, t), x("y", e, o, t);
              var a = Y,
                s = He.x,
                l = He.y;
              c(o);
              e = function (e) {
                1 === e
                  ? ((Y = t), (He.x = o.x), (He.y = o.y))
                  : ((Y = (t - a) * e + a),
                    (He.x = (o.x - s) * e + s),
                    (He.y = (o.y - l) * e + l)),
                  i && i(e),
                  et(1 === e);
              };
              n
                ? z("customZoomTo", 0, 1, n, r || h.easing.sine.inOut, e)
                : e(1);
            },
          },
          st = {},
          lt = {},
          ct = {},
          ut = {},
          dt = {},
          pt = [],
          ft = {},
          ht = [],
          mt = {},
          gt = 0,
          vt = { x: 0, y: 0 },
          yt = 0,
          bt = { x: 0, y: 0 },
          wt = { x: 0, y: 0 },
          xt = { x: 0, y: 0 },
          Et = function () {
            Pe && (ue(Pe), (Pe = null));
          },
          St = function () {
            Se && ((Pe = ce(St)), Ot());
          },
          Ct = function (e, t) {
            return (
              !(!e || e === document) &&
              !(
                e.getAttribute("class") &&
                -1 < e.getAttribute("class").indexOf("pwwp__scroll-wrap")
              ) &&
              (t(e) ? e : Ct(e.parentNode, t))
            );
          },
          kt = {},
          Tt = {},
          Pt = {},
          zt = [],
          Ot = function () {
            if (Oe) {
              var e = Oe.length;
              if (0 !== e)
                if (
                  (b(st, Oe[0]),
                  (ct.x = st.x - ut.x),
                  (ct.y = st.y - ut.y),
                  Re && 1 < e)
                )
                  (ut.x = st.x),
                    (ut.y = st.y),
                    (ct.x || ct.y || (o = Oe[1]).x !== lt.x || o.y !== lt.y) &&
                      (b(lt, Oe[1]),
                      ke || ((ke = !0), v("zoomGestureStarted")),
                      (e = O(st, lt)),
                      (i = Lt(e)) >
                        m.currItem.initialZoomLevel +
                          m.currItem.initialZoomLevel / 15 && (Be = !0),
                      (r = 1),
                      (n = l()),
                      (o = w()),
                      i < n
                        ? g.pinchToClose &&
                          !Be &&
                          X <= m.currItem.initialZoomLevel
                          ? (y((e = 1 - (n - i) / (n / 1.2))),
                            v("onPinchClose", e),
                            (Ae = !0))
                          : (1 < (r = (n - i) / n) && (r = 1),
                            (i = n - r * (n / 3)))
                        : o < i &&
                          (1 < (r = (i - o) / (6 * n)) && (r = 1),
                          (i = o + r * n)),
                      r < 0 && (r = 0),
                      N(st, lt, vt),
                      ($e.x += vt.x - xt.x),
                      ($e.y += vt.y - xt.y),
                      b(xt, vt),
                      (He.x = s("x", i)),
                      (He.y = s("y", i)),
                      (we = Y < i),
                      (Y = i),
                      et());
                else if (
                  _e &&
                  (De &&
                    ((De = !1),
                    10 <= Math.abs(ct.x) && (ct.x -= Oe[0].x - dt.x),
                    10 <= Math.abs(ct.y) && (ct.y -= Oe[0].y - dt.y)),
                  (ut.x = st.x),
                  (ut.y = st.y),
                  0 !== ct.x || 0 !== ct.y)
                ) {
                  if (
                    "v" === _e &&
                    g.closeOnVerticalDrag &&
                    "fit" === g.scaleMode &&
                    Y === m.currItem.initialZoomLevel
                  ) {
                    ($e.y += ct.y), (He.y += ct.y);
                    var t = L();
                    return (xe = !0), v("onVerticalDrag", t), y(t), void et();
                  }
                  (n = u()),
                    (r = st.x),
                    (i = st.y),
                    50 < n - ye &&
                      (((t = 2 < ht.length ? ht.shift() : {}).x = r),
                      (t.y = i),
                      ht.push(t),
                      (ye = n)),
                    (Te = !0),
                    (Ne = m.currItem.bounds),
                    _("x", ct) || (_("y", ct), c(He), et());
                }
            }
            var n, r, i, o;
          },
          Rt = function () {
            var t,
              n,
              r = {
                lastFlickOffset: {},
                lastFlickDist: {},
                lastFlickSpeed: {},
                slowDownRatio: {},
                slowDownRatioReverse: {},
                speedDecelerationRatio: {},
                speedDecelerationRatioAbs: {},
                distanceOffset: {},
                backAnimDestination: {},
                backAnimStarted: {},
                calculateSwipeSpeed: function (e) {
                  (n =
                    1 < ht.length
                      ? ((t = u() - ye + 50), ht[ht.length - 2][e])
                      : ((t = u() - ve), dt[e])),
                    (r.lastFlickOffset[e] = ut[e] - n),
                    (r.lastFlickDist[e] = Math.abs(r.lastFlickOffset[e])),
                    20 < r.lastFlickDist[e]
                      ? (r.lastFlickSpeed[e] = r.lastFlickOffset[e] / t)
                      : (r.lastFlickSpeed[e] = 0),
                    Math.abs(r.lastFlickSpeed[e]) < 0.1 &&
                      (r.lastFlickSpeed[e] = 0),
                    (r.slowDownRatio[e] = 0.95),
                    (r.slowDownRatioReverse[e] = 1 - r.slowDownRatio[e]),
                    (r.speedDecelerationRatio[e] = 1);
                },
                calculateOverBoundsAnimOffset: function (t, e) {
                  r.backAnimStarted[t] ||
                    (He[t] > Ne.min[t]
                      ? (r.backAnimDestination[t] = Ne.min[t])
                      : He[t] < Ne.max[t] &&
                        (r.backAnimDestination[t] = Ne.max[t]),
                    void 0 !== r.backAnimDestination[t] &&
                      ((r.slowDownRatio[t] = 0.7),
                      (r.slowDownRatioReverse[t] = 1 - r.slowDownRatio[t]),
                      r.speedDecelerationRatioAbs[t] < 0.05 &&
                        ((r.lastFlickSpeed[t] = 0),
                        (r.backAnimStarted[t] = !0),
                        z(
                          "bounceZoomPan" + t,
                          He[t],
                          r.backAnimDestination[t],
                          e || 300,
                          h.easing.sine.out,
                          function (e) {
                            (He[t] = e), et();
                          }
                        ))));
                },
                calculateAnimOffset: function (e) {
                  r.backAnimStarted[e] ||
                    ((r.speedDecelerationRatio[e] =
                      r.speedDecelerationRatio[e] *
                      (r.slowDownRatio[e] +
                        r.slowDownRatioReverse[e] -
                        (r.slowDownRatioReverse[e] * r.timeDiff) / 10)),
                    (r.speedDecelerationRatioAbs[e] = Math.abs(
                      r.lastFlickSpeed[e] * r.speedDecelerationRatio[e]
                    )),
                    (r.distanceOffset[e] =
                      r.lastFlickSpeed[e] *
                      r.speedDecelerationRatio[e] *
                      r.timeDiff),
                    (He[e] += r.distanceOffset[e]));
                },
                panAnimLoop: function () {
                  if (
                    ot.zoomPan &&
                    ((ot.zoomPan.raf = ce(r.panAnimLoop)),
                    (r.now = u()),
                    (r.timeDiff = r.now - r.lastNow),
                    (r.lastNow = r.now),
                    r.calculateAnimOffset("x"),
                    r.calculateAnimOffset("y"),
                    et(),
                    r.calculateOverBoundsAnimOffset("x"),
                    r.calculateOverBoundsAnimOffset("y"),
                    r.speedDecelerationRatioAbs.x < 0.05 &&
                      r.speedDecelerationRatioAbs.y < 0.05)
                  )
                    return (
                      (He.x = Math.round(He.x)),
                      (He.y = Math.round(He.y)),
                      et(),
                      void k("zoomPan")
                    );
                },
              };
            return r;
          },
          Mt = function (e) {
            if (
              (e.calculateSwipeSpeed("y"),
              (Ne = m.currItem.bounds),
              (e.backAnimDestination = {}),
              (e.backAnimStarted = {}),
              Math.abs(e.lastFlickSpeed.x) <= 0.05 &&
                Math.abs(e.lastFlickSpeed.y) <= 0.05)
            )
              return (
                (e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0),
                e.calculateOverBoundsAnimOffset("x"),
                e.calculateOverBoundsAnimOffset("y"),
                !0
              );
            T("zoomPan"), (e.lastNow = u()), e.panAnimLoop();
          },
          Nt = function (e, t) {
            var n, r;
            Ie || (gt = j),
              "swipe" === e &&
                ((r = ut.x - dt.x),
                (e = t.lastFlickDist.x < 10),
                30 < r && (e || 20 < t.lastFlickOffset.x)
                  ? (o = -1)
                  : r < -30 && (e || t.lastFlickOffset.x < -20) && (o = 1)),
              o &&
                ((j += o) < 0
                  ? ((j = g.loop ? Vt() - 1 : 0), (i = !0))
                  : j >= Vt() && ((j = g.loop ? 0 : Vt() - 1), (i = !0)),
                (i && !g.loop) || ((Ye += o), (qe -= o), (n = !0)));
            var i = Ge.x * qe,
              o = Math.abs(i - bt.x),
              a =
                n || i > bt.x == 0 < t.lastFlickSpeed.x
                  ? ((a =
                      0 < Math.abs(t.lastFlickSpeed.x)
                        ? o / Math.abs(t.lastFlickSpeed.x)
                        : 333),
                    (a = Math.min(a, 400)),
                    Math.max(a, 250))
                  : 333;
            return (
              gt === j && (n = !1),
              (Ie = !0),
              v("mainScrollAnimStart"),
              z("mainScroll", bt.x, i, a, h.easing.cubic.out, d, function () {
                P(),
                  (Ie = !1),
                  (gt = -1),
                  (!n && gt === j) || m.updateCurrItem(),
                  v("mainScrollAnimComplete");
              }),
              n && m.updateCurrItem(!0),
              n
            );
          },
          Lt = function (e) {
            return (1 / Me) * e * X;
          },
          It = function () {
            var e = Y,
              t = l(),
              n = w();
            Y < t ? (e = t) : n < Y && (e = n);
            var r,
              i = Fe;
            return (
              Ae && !we && !Be && Y < t
                ? m.close()
                : (Ae &&
                    (r = function (e) {
                      y((1 - i) * e + i);
                    }),
                  m.zoomTo(e, 0, 200, h.easing.cubic.out, r)),
              !0
            );
          };
        r("Gestures", {
          publicMethods: {
            initGestures: function () {
              function e(e, t, n, r, i) {
                (ne = e + t), (re = e + n), (ie = e + r), (oe = i ? e + i : "");
              }
              (se = me.pointerEvent) && me.touch && (me.touch = !1),
                se
                  ? navigator.msPointerEnabled
                    ? e("MSPointer", "Down", "Move", "Up", "Cancel")
                    : e("pointer", "down", "move", "up", "cancel")
                  : me.touch
                  ? (e("touch", "start", "move", "end", "cancel"), (le = !0))
                  : e("mouse", "down", "move", "up"),
                (q = re + " " + ie + " " + oe),
                (U = ne),
                se &&
                  !le &&
                  (le =
                    1 < navigator.maxTouchPoints ||
                    1 < navigator.msMaxTouchPoints),
                (m.likelyTouchDevice = le),
                (G[ne] = D),
                (G[re] = A),
                (G[ie] = F),
                oe && (G[oe] = G[ie]),
                me.touch &&
                  ((U += " mousedown"),
                  (q += " mousemove mouseup"),
                  (G.mousedown = G[ne]),
                  (G.mousemove = G[re]),
                  (G.mouseup = G[ie])),
                le || (g.allowPanToNext = !1);
            },
          },
        });
        function _t(e, t, n, r, i, o) {
          t.loadError ||
            (r &&
              ((t.imageAppended = !0),
              Kt(t, r, t === m.currItem && Qe),
              n.appendChild(r),
              o &&
                setTimeout(function () {
                  t &&
                    t.loaded &&
                    t.placeholder &&
                    ((t.placeholder.style.display = "none"),
                    (t.placeholder = null));
                }, 500)));
        }
        function Dt(e) {
          function t() {
            (e.loading = !1),
              (e.loaded = !0),
              e.loadComplete ? e.loadComplete(e) : (e.img = null),
              (n.onload = n.onerror = null),
              (n = null);
          }
          (e.loading = !0), (e.loaded = !1);
          var n = (e.img = h.createEl("pwwp__img", "img"));
          return (
            (n.onload = t),
            (n.onerror = function () {
              (e.loadError = !0), t();
            }),
            (n.src = e.src),
            n
          );
        }
        function At(e, t) {
          return (
            e.src &&
            e.loadError &&
            e.container &&
            (t && (e.container.innerHTML = ""),
            (e.container.innerHTML = g.errorMsg.replace("%url%", e.src)),
            1)
          );
        }
        function Ft() {
          if (Gt.length) {
            for (var e, t = 0; t < Gt.length; t++)
              (e = Gt[t]).holder.index === e.index &&
                _t(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
            Gt = [];
          }
        }
        var Bt,
          Wt,
          $t,
          jt,
          Ht,
          Vt,
          qt = function (a, e, s, t) {
            var l;
            Bt && clearTimeout(Bt),
              ($t = jt = !0),
              a.initialLayout
                ? ((l = a.initialLayout), (a.initialLayout = null))
                : (l = g.getThumbBoundsFn && g.getThumbBoundsFn(j));
            function c() {
              k("initialZoom"),
                s
                  ? (m.template.removeAttribute("style"),
                    m.bg.removeAttribute("style"))
                  : (y(1),
                    e && (e.style.display = "block"),
                    h.addClass(f, "pwwp--animated-in"),
                    v("initialZoom" + (s ? "OutEnd" : "InEnd"))),
                t && t(),
                (jt = !1);
            }
            var u,
              d,
              p = s ? g.hideAnimationDuration : g.showAnimationDuration;
            if (!p || !l || void 0 === l.x)
              return (
                v("initialZoom" + (s ? "Out" : "In")),
                (Y = a.initialZoomLevel),
                b(He, a.initialPosition),
                et(),
                (f.style.opacity = s ? 0 : 1),
                y(1),
                void (p
                  ? setTimeout(function () {
                      c();
                    }, p)
                  : c())
              );
            (u = $),
              (d =
                !m.currItem.src || m.currItem.loadError || g.showHideOpacity),
              a.miniImg &&
                (a.miniImg.style.webkitBackfaceVisibility = "hidden"),
              s ||
                ((Y = l.w / a.w),
                (He.x = l.x),
                (He.y = l.y - pe),
                (m[d ? "template" : "bg"].style.opacity = 0.001),
                et()),
              T("initialZoom"),
              s && !u && h.removeClass(f, "pwwp--animated-in"),
              d &&
                (s
                  ? h[(u ? "remove" : "add") + "Class"](
                      f,
                      "pwwp--animate_opacity"
                    )
                  : setTimeout(function () {
                      h.addClass(f, "pwwp--animate_opacity");
                    }, 30)),
              (Bt = setTimeout(
                function () {
                  var t, n, r, i, o, e;
                  v("initialZoom" + (s ? "Out" : "In")),
                    s
                      ? ((t = l.w / a.w),
                        (n = He.x),
                        (r = He.y),
                        (i = Y),
                        (o = Fe),
                        (e = function (e) {
                          1 === e
                            ? ((Y = t), (He.x = l.x), (He.y = l.y - he))
                            : ((Y = (t - i) * e + i),
                              (He.x = (l.x - n) * e + n),
                              (He.y = (l.y - he - r) * e + r)),
                            et(),
                            d ? (f.style.opacity = 1 - e) : y(o - e * o);
                        }),
                        u
                          ? z("initialZoom", 0, 1, p, h.easing.cubic.out, e, c)
                          : (e(1), (Bt = setTimeout(c, p + 20))))
                      : ((Y = a.initialZoomLevel),
                        b(He, a.initialPosition),
                        et(),
                        y(1),
                        d ? (f.style.opacity = 1) : y(1),
                        (Bt = setTimeout(c, p + 20)));
                },
                s ? 25 : 90
              ));
          },
          Ut = {},
          Gt = [],
          Yt = {
            index: 0,
            errorMsg:
              '<div class="pwwp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
            forceProgressiveLoading: !1,
            preload: [1, 1],
            getNumItemsFn: function () {
              return Wt.length;
            },
          },
          Xt = function (e, t, n) {
            if (!e.src || e.loadError)
              return (
                (e.w = e.h = 0),
                (e.initialZoomLevel = e.fitRatio = 1),
                (e.bounds = {
                  center: { x: 0, y: 0 },
                  max: { x: 0, y: 0 },
                  min: { x: 0, y: 0 },
                }),
                (e.initialPosition = e.bounds.center),
                e.bounds
              );
            var r,
              i,
              o,
              a = !n;
            return (
              a &&
                (e.vGap || (e.vGap = { top: 0, bottom: 0 }),
                v("parseVerticalMargin", e)),
              (Ut.x = t.x),
              (Ut.y = t.y - e.vGap.top - e.vGap.bottom),
              a &&
                ((r = Ut.x / e.w),
                (i = Ut.y / e.h),
                (e.fitRatio = r < i ? r : i),
                "orig" === (o = g.scaleMode)
                  ? (n = 1)
                  : "fit" === o && (n = e.fitRatio),
                1 < n && (n = 1),
                (e.initialZoomLevel = n),
                e.bounds ||
                  (e.bounds = {
                    center: { x: 0, y: 0 },
                    max: { x: 0, y: 0 },
                    min: { x: 0, y: 0 },
                  })),
              n
                ? ((r = (t = e).w * n),
                  (i = e.h * n),
                  ((o = t.bounds).center.x = Math.round((Ut.x - r) / 2)),
                  (o.center.y = Math.round((Ut.y - i) / 2) + t.vGap.top),
                  (o.max.x = r > Ut.x ? Math.round(Ut.x - r) : o.center.x),
                  (o.max.y =
                    i > Ut.y ? Math.round(Ut.y - i) + t.vGap.top : o.center.y),
                  (o.min.x = r > Ut.x ? 0 : o.center.x),
                  (o.min.y = i > Ut.y ? t.vGap.top : o.center.y),
                  a &&
                    n === e.initialZoomLevel &&
                    (e.initialPosition = e.bounds.center),
                  e.bounds)
                : void 0
            );
          },
          Kt = function (e, t, n) {
            var r;
            e.src &&
              ((t = t || e.container.lastChild),
              (r = n ? e.w : Math.round(e.w * e.fitRatio)),
              (n = n ? e.h : Math.round(e.h * e.fitRatio)),
              e.placeholder &&
                !e.loaded &&
                ((e.placeholder.style.width = r + "px"),
                (e.placeholder.style.height = n + "px")),
              (t.style.width = r + "px"),
              (t.style.height = n + "px"));
          };
        r("Controller", {
          publicMethods: {
            lazyLoadItem: function (e) {
              e = a(e);
              var t = Ht(e);
              t &&
                ((!t.loaded && !t.loading) || J) &&
                (v("gettingData", e, t), t.src && Dt(t));
            },
            initController: function () {
              h.extend(g, Yt, !0),
                (m.items = Wt = e),
                (Ht = m.getItemAt),
                (Vt = g.getNumItemsFn),
                g.loop,
                Vt() < 3 && (g.loop = !1),
                o("beforeChange", function (e) {
                  for (
                    var t = g.preload,
                      n = null === e || 0 <= e,
                      r = Math.min(t[0], Vt()),
                      i = Math.min(t[1], Vt()),
                      o = 1;
                    o <= (n ? i : r);
                    o++
                  )
                    m.lazyLoadItem(j + o);
                  for (o = 1; o <= (n ? r : i); o++) m.lazyLoadItem(j - o);
                }),
                o("initialLayout", function () {
                  m.currItem.initialLayout =
                    g.getThumbBoundsFn && g.getThumbBoundsFn(j);
                }),
                o("mainScrollAnimComplete", Ft),
                o("initialZoomInEnd", Ft),
                o("destroy", function () {
                  for (var e, t = 0; t < Wt.length; t++)
                    (e = Wt[t]).container && (e.container = null),
                      e.placeholder && (e.placeholder = null),
                      e.img && (e.img = null),
                      e.preloader && (e.preloader = null),
                      e.loadError && (e.loaded = e.loadError = !1);
                  Gt = null;
                });
            },
            getItemAt: function (e) {
              return 0 <= e && void 0 !== Wt[e] && Wt[e];
            },
            allowProgressiveImg: function () {
              return (
                g.forceProgressiveLoading ||
                !le ||
                g.mouseUsed ||
                1200 < screen.width
              );
            },
            setContent: function (t, n) {
              g.loop && (n = a(n));
              var e = m.getItemAt(t.index);
              e && (e.container = null);
              var r,
                i,
                o = m.getItemAt(n);
              o
                ? (v("gettingData", n, o),
                  (t.index = n),
                  (i = (t.item = o).container = h.createEl("pwwp__zoom-wrap")),
                  !o.src &&
                    o.html &&
                    (o.html.tagName
                      ? i.appendChild(o.html)
                      : (i.innerHTML = o.html)),
                  At(o),
                  Xt(o, Ve),
                  !o.src || o.loadError || o.loaded
                    ? o.src &&
                      !o.loadError &&
                      (((r = h.createEl("pwwp__img", "img")).style.opacity = 1),
                      (r.src = o.src),
                      Kt(o, r),
                      _t(0, o, i, r))
                    : ((o.loadComplete = function (e) {
                        if (B) {
                          if (t && t.index === n) {
                            if (At(e, !0))
                              return (
                                (e.loadComplete = e.img = null),
                                Xt(e, Ve),
                                tt(e),
                                void (t.index === j && m.updateCurrZoomItem())
                              );
                            e.imageAppended
                              ? !jt &&
                                e.placeholder &&
                                ((e.placeholder.style.display = "none"),
                                (e.placeholder = null))
                              : me.transform && (Ie || jt)
                              ? Gt.push({
                                  item: e,
                                  baseDiv: i,
                                  img: e.img,
                                  index: n,
                                  holder: t,
                                  clearPlaceholder: !0,
                                })
                              : _t(0, e, i, e.img, 0, !0);
                          }
                          (e.loadComplete = null),
                            (e.img = null),
                            v("imageLoadComplete", n, e);
                        }
                      }),
                      h.features.transform &&
                        ((e = "pwwp__img pwwp__img--placeholder"),
                        (e += o.msrc ? "" : " pwwp__img--placeholder--blank"),
                        (e = h.createEl(e, o.msrc ? "img" : "")),
                        o.msrc && (e.src = o.msrc),
                        Kt(o, e),
                        i.appendChild(e),
                        (o.placeholder = e)),
                      o.loading || Dt(o),
                      m.allowProgressiveImg() &&
                        (!$t && me.transform
                          ? Gt.push({
                              item: o,
                              baseDiv: i,
                              img: o.img,
                              index: n,
                              holder: t,
                            })
                          : _t(0, o, i, o.img, 0, !0))),
                  $t || n !== j ? tt(o) : ((Le = i.style), qt(o, r || o.img)),
                  (t.el.innerHTML = ""),
                  t.el.appendChild(i))
                : (t.el.innerHTML = "");
            },
            cleanSlide: function (e) {
              e.img && (e.img.onload = e.img.onerror = null),
                (e.loaded = e.loading = e.img = e.imageAppended = !1);
            },
          },
        });
        function Zt(e, t, n) {
          var r = document.createEvent("CustomEvent"),
            n = {
              origEvent: e,
              target: e.target,
              releasePoint: t,
              pointerType: n || "touch",
            };
          r.initCustomEvent("pwwpTap", !0, !0, n), e.target.dispatchEvent(r);
        }
        var Qt,
          Jt,
          en = {};
        r("Tap", {
          publicMethods: {
            initTap: function () {
              o("firstTouchStart", m.onTapStart),
                o("touchRelease", m.onTapRelease),
                o("destroy", function () {
                  (en = {}), (Qt = null);
                });
            },
            onTapStart: function (e) {
              1 < e.length && (clearTimeout(Qt), (Qt = null));
            },
            onTapRelease: function (e, t) {
              var n, r, i;
              !t ||
                Te ||
                Ce ||
                at ||
                ((i = t),
                Qt &&
                (clearTimeout(Qt),
                (Qt = null),
                (n = i),
                (r = en),
                Math.abs(n.x - r.x) < 25 && Math.abs(n.y - r.y) < 25)
                  ? v("doubleTap", i)
                  : "mouse" !== t.type
                  ? "BUTTON" === e.target.tagName.toUpperCase() ||
                    h.hasClass(e.target, "pwwp__single-tap")
                    ? Zt(e, t)
                    : (b(en, i),
                      (Qt = setTimeout(function () {
                        Zt(e, t), (Qt = null);
                      }, 300)))
                  : Zt(e, t, "mouse"));
            },
          },
        }),
          r("DesktopZoom", {
            publicMethods: {
              initDesktopZoom: function () {
                fe ||
                  (le
                    ? o("mouseUsed", function () {
                        m.setupDesktopZoom();
                      })
                    : m.setupDesktopZoom(!0));
              },
              setupDesktopZoom: function (e) {
                Jt = {};
                var t = "wheel mousewheel DOMMouseScroll";
                o("bindEvents", function () {
                  h.bind(f, t, m.handleMouseWheel);
                }),
                  o("unbindEvents", function () {
                    Jt && h.unbind(f, t, m.handleMouseWheel);
                  }),
                  (m.mouseZoomedIn = !1);
                function n() {
                  m.mouseZoomedIn &&
                    (h.removeClass(f, "pwwp--zoomed-in"),
                    (m.mouseZoomedIn = !1)),
                    Y < 1
                      ? h.addClass(f, "pwwp--zoom-allowed")
                      : h.removeClass(f, "pwwp--zoom-allowed"),
                    i();
                }
                var r,
                  i = function () {
                    r && (h.removeClass(f, "pwwp--dragging"), (r = !1));
                  };
                o("resize", n),
                  o("afterChange", n),
                  o("pointerDown", function () {
                    m.mouseZoomedIn &&
                      ((r = !0), h.addClass(f, "pwwp--dragging"));
                  }),
                  o("pointerUp", i),
                  e || n();
              },
              handleMouseWheel: function (e) {
                if (Y <= m.currItem.fitRatio)
                  return (
                    g.modal &&
                      (!g.closeOnScroll || at || Se
                        ? e.preventDefault()
                        : ae &&
                          2 < Math.abs(e.deltaY) &&
                          (($ = !0), m.close())),
                    !0
                  );
                if ((e.stopPropagation(), (Jt.x = 0), "deltaX" in e))
                  1 === e.deltaMode
                    ? ((Jt.x = 18 * e.deltaX), (Jt.y = 18 * e.deltaY))
                    : ((Jt.x = e.deltaX), (Jt.y = e.deltaY));
                else if ("wheelDelta" in e)
                  e.wheelDeltaX && (Jt.x = -0.16 * e.wheelDeltaX),
                    e.wheelDeltaY
                      ? (Jt.y = -0.16 * e.wheelDeltaY)
                      : (Jt.y = -0.16 * e.wheelDelta);
                else {
                  if (!("detail" in e)) return;
                  Jt.y = e.detail;
                }
                p(Y, !0);
                var t = He.x - Jt.x,
                  n = He.y - Jt.y;
                (g.modal ||
                  (t <= Ne.min.x &&
                    t >= Ne.max.x &&
                    n <= Ne.min.y &&
                    n >= Ne.max.y)) &&
                  e.preventDefault(),
                  m.panTo(t, n);
              },
              toggleDesktopZoom: function (e) {
                e = e || { x: Ve.x / 2 + Ue.x, y: Ve.y / 2 + Ue.y };
                var t = g.getDoubleTapZoom(!0, m.currItem),
                  n = Y === t;
                (m.mouseZoomedIn = !n),
                  m.zoomTo(n ? m.currItem.initialZoomLevel : t, e, 333),
                  h[(n ? "remove" : "add") + "Class"](f, "pwwp--zoomed-in");
              },
            },
          });
        function tn() {
          return mn.hash.substring(1);
        }
        function nn() {
          on && clearTimeout(on), sn && clearTimeout(sn);
        }
        function rn() {
          var e = tn(),
            t = {};
          if (e.length < 5) return t;
          var n,
            r = e.split("&");
          for (o = 0; o < r.length; o++)
            r[o] && ((n = r[o].split("=")).length < 2 || (t[n[0]] = n[1]));
          if (g.galleryPIDs) {
            for (var i = t.pid, o = (t.pid = 0); o < Wt.length; o++)
              if (Wt[o].pid === i) {
                t.pid = o;
                break;
              }
          } else t.pid = parseInt(t.pid, 10) - 1;
          return t.pid < 0 && (t.pid = 0), t;
        }
        var on,
          an,
          sn,
          ln,
          cn,
          un,
          dn,
          pn,
          fn,
          hn,
          mn,
          gn,
          vn = { history: !0, galleryUID: 1 },
          yn = function () {
            var e, t;
            sn && clearTimeout(sn),
              at || Se
                ? (sn = setTimeout(yn, 500))
                : (ln ? clearTimeout(an) : (ln = !0),
                  (t = j + 1),
                  (e = Ht(j)).hasOwnProperty("pid") && (t = e.pid),
                  (e = dn + "&gid=" + g.galleryUID + "&pid=" + t),
                  pn || (-1 === mn.hash.indexOf(e) && (hn = !0)),
                  (t = mn.href.split("#")[0] + "#" + e),
                  gn
                    ? "#" + e !== window.location.hash &&
                      history[pn ? "replaceState" : "pushState"](
                        "",
                        document.title,
                        t
                      )
                    : pn
                    ? mn.replace(t)
                    : (mn.hash = e),
                  (pn = !0),
                  (an = setTimeout(function () {
                    ln = !1;
                  }, 60)));
          };
        r("History", {
          publicMethods: {
            initHistory: function () {
              var e, t;
              h.extend(g, vn, !0),
                g.history &&
                  ((mn = window.location),
                  (pn = fn = hn = !1),
                  (dn = tn()),
                  (gn = "pushState" in history),
                  -1 < dn.indexOf("gid=") &&
                    (dn = (dn = dn.split("&gid=")[0]).split("?gid=")[0]),
                  o("afterChange", m.updateURL),
                  o("unbindEvents", function () {
                    h.unbind(window, "hashchange", m.onHashChange);
                  }),
                  (e = function () {
                    (un = !0),
                      fn ||
                        (hn
                          ? history.back()
                          : dn
                          ? (mn.hash = dn)
                          : gn
                          ? history.pushState(
                              "",
                              document.title,
                              mn.pathname + mn.search
                            )
                          : (mn.hash = "")),
                      nn();
                  }),
                  o("unbindEvents", function () {
                    $ && e();
                  }),
                  o("destroy", function () {
                    un || e();
                  }),
                  o("firstUpdate", function () {
                    j = rn().pid;
                  }),
                  -1 < (t = dn.indexOf("pid=")) &&
                    "&" === (dn = dn.substring(0, t)).slice(-1) &&
                    (dn = dn.slice(0, -1)),
                  setTimeout(function () {
                    B && h.bind(window, "hashchange", m.onHashChange);
                  }, 40));
            },
            onHashChange: function () {
              if (tn() === dn) return (fn = !0), void m.close();
              ln || ((cn = !0), m.goTo(rn().pid), (cn = !1));
            },
            updateURL: function () {
              nn(), cn || (pn ? (on = setTimeout(yn, 800)) : yn());
            },
          },
        }),
          h.extend(m, t);
      };
    };
  function gT(e) {
    for (
      var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e,
        n = 1;
      n < arguments.length;
      n++
    )
      t += "&args[]=" + encodeURIComponent(arguments[n]);
    return (
      "Minified React error #" +
      e +
      "; visit " +
      t +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    );
  }
  function vT(e) {
    if (null == e) return null;
    if ("function" == typeof e) return e.displayName || e.name || null;
    if ("string" == typeof e) return e;
    switch (e) {
      case xk:
        return "Fragment";
      case wk:
        return "Portal";
      case Sk:
        return "Profiler";
      case Ek:
        return "StrictMode";
      case zk:
        return "Suspense";
      case Ok:
        return "SuspenseList";
    }
    if ("object" == typeof e)
      switch (e.$$typeof) {
        case kk:
          return "Context.Consumer";
        case Ck:
          return "Context.Provider";
        case Pk:
          var t = (t = e.render).displayName || t.name || "";
          return (
            e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef")
          );
        case Rk:
          return vT(e.type);
        case Mk:
          if ((e = 1 === e._status ? e._result : null)) return vT(e);
      }
    return null;
  }
  function yT(e, t) {
    for (var n = 0 | e._threadCount; n <= t; n++)
      (e[n] = e._currentValue2), (e._threadCount = n + 1);
  }
  function bT(e) {
    return (
      Dk.call(Fk, e) ||
      (!Dk.call(Ak, e) && (_k.test(e) ? (Fk[e] = !0) : ((Ak[e] = !0), 0)))
    );
  }
  function wT(e, t, n, r, i, o) {
    (this.acceptsBooleans = 2 === t || 3 === t || 4 === t),
      (this.attributeName = r),
      (this.attributeNamespace = i),
      (this.mustUseProperty = n),
      (this.propertyName = e),
      (this.type = t),
      (this.sanitizeURL = o);
  }
  function xT(e) {
    return e[1].toUpperCase();
  }
  function ET(e) {
    if ("boolean" == typeof e || "number" == typeof e) return "" + e;
    e = "" + e;
    var t = $k.exec(e);
    if (t) {
      for (var n = "", r = 0, i = t.index; i < e.length; i++) {
        switch (e.charCodeAt(i)) {
          case 34:
            t = "&quot;";
            break;
          case 38:
            t = "&amp;";
            break;
          case 39:
            t = "&#x27;";
            break;
          case 60:
            t = "&lt;";
            break;
          case 62:
            t = "&gt;";
            break;
          default:
            continue;
        }
        r !== i && (n += e.substring(r, i)), (r = i + 1), (n += t);
      }
      e = r !== i ? n + e.substring(r, i) : n;
    }
    return e;
  }
  function ST(e, t) {
    return (e === t && (0 !== e || 1 / e == 1 / t)) || (e != e && t != t);
  }
  function CT() {
    if (null === Hk) throw Error(gT(321));
    return Hk;
  }
  function kT() {
    if (0 < Xk) throw Error(gT(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function TT() {
    return (
      null === qk
        ? null === Vk
          ? ((Uk = !1), (Vk = qk = kT()))
          : ((Uk = !0), (qk = Vk))
        : (qk =
            null === qk.next
              ? ((Uk = !1), (qk.next = kT()))
              : ((Uk = !0), qk.next)),
      qk
    );
  }
  function PT(e, t, n, r) {
    for (; Gk; ) (Gk = !1), (Xk += 1), (qk = null), (n = e(t, r));
    return (Vk = Hk = null), (Xk = 0), (qk = Yk = null), n;
  }
  function zT(e, t) {
    return "function" == typeof t ? t(e) : t;
  }
  function OT(e, t, n) {
    if (((Hk = CT()), (qk = TT()), Uk)) {
      var r = qk.queue;
      if (((t = r.dispatch), null === Yk || void 0 === (n = Yk.get(r))))
        return [qk.memoizedState, t];
      for (
        Yk.delete(r), r = qk.memoizedState;
        (r = e(r, n.action)), (n = n.next), null !== n;

      );
      return [(qk.memoizedState = r), t];
    }
    return (
      (e =
        e === zT
          ? "function" == typeof t
            ? t()
            : t
          : void 0 !== n
          ? n(t)
          : t),
      (qk.memoizedState = e),
      (e = (e = qk.queue = { last: null, dispatch: null }).dispatch = function (
        e,
        t,
        n
      ) {
        if (!(Xk < 25)) throw Error(gT(301));
        if (e === Hk)
          if (
            ((Gk = !0),
            (e = { action: n, next: null }),
            null === Yk && (Yk = new Map()),
            void 0 === (n = Yk.get(t)))
          )
            Yk.set(t, e);
          else {
            for (t = n; null !== t.next; ) t = t.next;
            t.next = e;
          }
      }.bind(null, Hk, e)),
      [qk.memoizedState, e]
    );
  }
  function RT() {}
  function MT(e) {
    switch (e) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function NT(e, t) {
    if (void 0 === e) throw Error(gT(152, vT(t) || "Component"));
  }
  function LT(f, h, m) {
    for (; bk.isValidElement(f); ) {
      var e = f,
        t = e.type;
      if ("function" != typeof t) break;
      !(function (e, t) {
        var n = t.prototype && t.prototype.isReactComponent,
          r = (function (e, t, n, r) {
            if (r && "object" == typeof (r = e.contextType) && null !== r)
              return yT(r, n), r[n];
            if ((e = e.contextTypes)) {
              for (var i in ((n = {}), e)) n[i] = t[i];
              t = n;
            } else t = Ik;
            return t;
          })(t, h, m, n),
          i = [],
          o = !1,
          a = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {
              if (null === i) return null;
            },
            enqueueReplaceState: function (e, t) {
              (o = !0), (i = [t]);
            },
            enqueueSetState: function (e, t) {
              if (null === i) return null;
              i.push(t);
            },
          };
        if (n) {
          var s,
            n = new t(e.props, r, a);
          "function" == typeof t.getDerivedStateFromProps &&
            null !=
              (s = t.getDerivedStateFromProps.call(null, e.props, n.state)) &&
            (n.state = yk({}, n.state, s));
        } else if (
          ((Hk = {}),
          (n = t(e.props, r, a)),
          null == (n = PT(t, e.props, n, r)) || null == n.render)
        )
          return NT((f = n), t), 0;
        if (
          ((n.props = e.props),
          (n.context = r),
          (n.updater = a),
          void 0 === (a = n.state) && (n.state = a = null),
          "function" == typeof n.UNSAFE_componentWillMount ||
            "function" == typeof n.componentWillMount)
        )
          if (
            ("function" == typeof n.componentWillMount &&
              "function" != typeof t.getDerivedStateFromProps &&
              n.componentWillMount(),
            "function" == typeof n.UNSAFE_componentWillMount &&
              "function" != typeof t.getDerivedStateFromProps &&
              n.UNSAFE_componentWillMount(),
            i.length)
          ) {
            a = i;
            var l = o,
              i = null,
              o = !1;
            if (l && 1 === a.length) n.state = a[0];
            else {
              s = l ? a[0] : n.state;
              for (var c = !0, l = l ? 1 : 0; l < a.length; l++) {
                var u = a[l];
                null !=
                  (u = "function" == typeof u ? u.call(n, s, e.props, r) : u) &&
                  (c ? ((c = !1), (s = yk({}, s, u))) : yk(s, u));
              }
              n.state = s;
            }
          } else i = null;
        if (
          (NT((f = n.render()), t),
          "function" == typeof n.getChildContext &&
            "object" == typeof (e = t.childContextTypes))
        ) {
          var d,
            p = n.getChildContext();
          for (d in p)
            if (!(d in e)) throw Error(gT(108, vT(t) || "Unknown", d));
        }
        p && (h = yk({}, h, p));
      })(e, t);
    }
    return { child: f, context: h };
  }
  "object" == typeof YT ? (YT = wC()) : (vp.PhotoSwipe = wC()),
    (vp = function () {
      return function (r, s) {
        function e(e) {
          if (P) return !0;
          (e = e || window.event), T.timeToIdle && T.mouseUsed && !w && A();
          for (
            var t,
              n,
              r = (e.target || e.srcElement).getAttribute("class") || "",
              i = 0;
            i < F.length;
            i++
          )
            (t = F[i]).onTap &&
              -1 < r.indexOf("pwwp__" + t.name) &&
              (t.onTap(), (n = !0));
          n &&
            (e.stopPropagation && e.stopPropagation(),
            (P = !0),
            (e = s.features.isOldAndroid ? 600 : 30),
            setTimeout(function () {
              P = !1;
            }, e));
        }
        function t(e, t, n) {
          s[(n ? "add" : "remove") + "Class"](e, "pwwp__" + t);
        }
        function n() {
          var e = 1 === T.getNumItemsFn();
          e !== k && (t(f, "ui--one-slide", e), (k = e));
        }
        function i() {
          t(y, "share-modal--hidden", L);
        }
        function o() {
          return (
            (L = !L)
              ? (s.removeClass(y, "pwwp__share-modal--fade-in"),
                setTimeout(function () {
                  L && i();
                }, 300))
              : (i(),
                setTimeout(function () {
                  L || s.addClass(y, "pwwp__share-modal--fade-in");
                }, 30)),
            L || _(),
            0
          );
        }
        function a(e) {
          var t = (e = e || window.event).target || e.srcElement;
          return (
            r.shout("shareLinkClick", e, t),
            !(
              !t.href ||
              (!t.hasAttribute("download") &&
                (window.open(
                  t.href,
                  "pwwp_share",
                  "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" +
                    (window.screen ? Math.round(screen.width / 2 - 275) : 100)
                ),
                L || o(),
                1))
            )
          );
        }
        function l(e) {
          for (var t = 0; t < T.closeElClasses.length; t++)
            if (s.hasClass(e, "pwwp__" + T.closeElClasses[t])) return !0;
        }
        function c(e) {
          ((e = (e = e || window.event).relatedTarget || e.toElement) &&
            "HTML" !== e.nodeName) ||
            (clearTimeout(O),
            (O = setTimeout(function () {
              R.setIdle(!0);
            }, T.timeToIdleOutside)));
        }
        function u(e) {
          S !== e && (t(E, "preloader--active", !e), (S = e));
        }
        function d(e) {
          var t,
            n = e.vGap;
          !r.likelyTouchDevice ||
          T.mouseUsed ||
          screen.width > T.fitControlsWidth
            ? ((t = T.barsSize),
              T.captionEl && "auto" === t.bottom
                ? (m ||
                    ((m = s.createEl(
                      "pwwp__caption pwwp__caption--fake"
                    )).appendChild(s.createEl("pwwp__caption__center")),
                    f.insertBefore(m, h),
                    s.addClass(f, "pwwp__ui--fit")),
                  T.addCaptionHTMLFn(e, m, !0)
                    ? ((e = m.clientHeight), (n.bottom = parseInt(e, 10) || 44))
                    : (n.bottom = t.top))
                : (n.bottom = "auto" === t.bottom ? 0 : t.bottom),
              (n.top = t.top))
            : (n.top = n.bottom = 0);
        }
        var p,
          f,
          h,
          m,
          g,
          v,
          y,
          b,
          w,
          x,
          E,
          S,
          C,
          k,
          T,
          P,
          z,
          O,
          R = this,
          M = !1,
          N = !0,
          L = !0,
          I = {
            barsSize: { top: 44, bottom: "auto" },
            closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
            timeToIdle: 4e3,
            timeToIdleOutside: 1e3,
            loadingIndicatorDelay: 1e3,
            addCaptionHTMLFn: function (e, t) {
              return e.title
                ? ((t.children[0].innerHTML = e.title), !0)
                : ((t.children[0].innerHTML = ""), !1);
            },
            closeEl: !0,
            captionEl: !0,
            fullscreenEl: !0,
            zoomEl: !0,
            shareEl: !0,
            counterEl: !0,
            arrowEl: !0,
            preloaderEl: !0,
            tapToClose: !1,
            tapToToggleControls: !0,
            clickToCloseNonZoomable: !0,
            shareButtons: [
              {
                id: "facebook",
                label: "Share on Facebook",
                url: "https://www.facebook.com/sharer/sharer.php?u={{url}}",
              },
              {
                id: "twitter",
                label: "Tweet",
                url:
                  "https://twitter.com/intent/tweet?text={{text}}&url={{url}}",
              },
              {
                id: "pinterest",
                label: "Pin it",
                url:
                  "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}",
              },
              {
                id: "download",
                label: "Download image",
                url: "{{raw_image_url}}",
                download: !0,
              },
            ],
            getImageURLForShare: function () {
              return r.currItem.src || "";
            },
            getPageURLForShare: function () {
              return window.location.href;
            },
            getTextForShare: function () {
              return r.currItem.title || "";
            },
            indexIndicatorSep: " / ",
            fitControlsWidth: 1200,
          },
          _ = function () {
            for (var e, t, n, r, i = "", o = 0; o < T.shareButtons.length; o++)
              (e = T.shareButtons[o]),
                (t = T.getImageURLForShare(e)),
                (n = T.getPageURLForShare(e)),
                (r = T.getTextForShare(e)),
                (i +=
                  '<a href="' +
                  e.url
                    .replace("{{url}}", encodeURIComponent(n))
                    .replace("{{image_url}}", encodeURIComponent(t))
                    .replace("{{raw_image_url}}", t)
                    .replace("{{text}}", encodeURIComponent(r)) +
                  '" target="_blank" class="pwwp__share--' +
                  e.id +
                  '"' +
                  (e.download ? "download" : "") +
                  ">" +
                  e.label +
                  "</a>"),
                T.parseShareButtonOut && (i = T.parseShareButtonOut(e, i));
            (y.children[0].innerHTML = i), (y.children[0].onclick = a);
          },
          D = 0,
          A = function () {
            clearTimeout(O), (D = 0), w && R.setIdle(!1);
          },
          F = [
            {
              name: "caption",
              option: "captionEl",
              onInit: function (e) {
                h = e;
              },
            },
            {
              name: "share-modal",
              option: "shareEl",
              onInit: function (e) {
                y = e;
              },
              onTap: function () {
                o();
              },
            },
            {
              name: "button--share",
              option: "shareEl",
              onInit: function (e) {
                v = e;
              },
              onTap: function () {
                o();
              },
            },
            {
              name: "button--zoom",
              option: "zoomEl",
              onTap: r.toggleDesktopZoom,
            },
            {
              name: "counter",
              option: "counterEl",
              onInit: function (e) {
                g = e;
              },
            },
            { name: "button--close", option: "closeEl", onTap: r.close },
            { name: "button--arrow--left", option: "arrowEl", onTap: r.prev },
            { name: "button--arrow--right", option: "arrowEl", onTap: r.next },
            {
              name: "button--fs",
              option: "fullscreenEl",
              onTap: function () {
                p.isFullscreen() ? p.exit() : p.enter();
              },
            },
            {
              name: "preloader",
              option: "preloaderEl",
              onInit: function (e) {
                E = e;
              },
            },
          ];
        (R.init = function () {
          var t;
          s.extend(r.options, I, !0),
            (T = r.options),
            (f = s.getChildByClass(r.scrollWrap, "pwwp__ui")),
            (x = r.listen)("onVerticalDrag", function (e) {
              N && e < 0.95
                ? R.hideControls()
                : !N && 0.95 <= e && R.showControls();
            }),
            x("onPinchClose", function (e) {
              N && e < 0.9
                ? (R.hideControls(), (t = !0))
                : t && !N && 0.9 < e && R.showControls();
            }),
            x("zoomGestureEnded", function () {
              t = !1;
            }),
            x("beforeChange", R.update),
            x("doubleTap", function (e) {
              var t = r.currItem.initialZoomLevel;
              r.getZoomLevel() !== t
                ? r.zoomTo(t, e, 333)
                : r.zoomTo(T.getDoubleTapZoom(!1, r.currItem), e, 333);
            }),
            x("preventDragEvent", function (e, t, n) {
              var r = e.target || e.srcElement;
              r &&
                r.getAttribute("class") &&
                -1 < e.type.indexOf("mouse") &&
                (0 < r.getAttribute("class").indexOf("__caption") ||
                  /(SMALL|STRONG|EM)/i.test(r.tagName)) &&
                (n.prevent = !1);
            }),
            x("bindEvents", function () {
              s.bind(f, "pwwpTap click", e),
                s.bind(r.scrollWrap, "pwwpTap", R.onGlobalTap),
                r.likelyTouchDevice ||
                  s.bind(r.scrollWrap, "mouseover", R.onMouseOver);
            }),
            x("unbindEvents", function () {
              L || o(),
                z && clearInterval(z),
                s.unbind(document, "mouseout", c),
                s.unbind(document, "mousemove", A),
                s.unbind(f, "pwwpTap click", e),
                s.unbind(r.scrollWrap, "pwwpTap", R.onGlobalTap),
                s.unbind(r.scrollWrap, "mouseover", R.onMouseOver),
                p &&
                  (s.unbind(document, p.eventK, R.updateFullscreen),
                  p.isFullscreen() && ((T.hideAnimationDuration = 0), p.exit()),
                  (p = null));
            }),
            x("destroy", function () {
              T.captionEl &&
                (m && f.removeChild(m),
                s.removeClass(h, "pwwp__caption--empty")),
                y && (y.children[0].onclick = null),
                s.removeClass(f, "pwwp__ui--over-close"),
                s.addClass(f, "pwwp__ui--hidden"),
                R.setIdle(!1);
            }),
            T.showAnimationDuration || s.removeClass(f, "pwwp__ui--hidden"),
            x("initialZoomIn", function () {
              T.showAnimationDuration && s.removeClass(f, "pwwp__ui--hidden");
            }),
            x("initialZoomOut", function () {
              s.addClass(f, "pwwp__ui--hidden");
            }),
            x("parseVerticalMargin", d),
            (function () {
              function e(e) {
                if (e)
                  for (var t = e.length, n = 0; n < t; n++) {
                    (i = e[n]), (o = i.className);
                    for (var r = 0; r < F.length; r++)
                      (a = F[r]),
                        -1 < o.indexOf("pwwp__" + a.name) &&
                          (T[a.option]
                            ? (s.removeClass(i, "pwwp__element--disabled"),
                              a.onInit && a.onInit(i))
                            : s.addClass(i, "pwwp__element--disabled"));
                  }
              }
              var i, o, a;
              e(f.children);
              var t = s.getChildByClass(f, "pwwp__top-bar");
              t && e(t.children);
            })(),
            T.shareEl && v && y && (L = !0),
            n(),
            T.timeToIdle &&
              x("mouseUsed", function () {
                s.bind(document, "mousemove", A),
                  s.bind(document, "mouseout", c),
                  (z = setInterval(function () {
                    2 == ++D && R.setIdle(!0);
                  }, T.timeToIdle / 2));
              }),
            T.fullscreenEl &&
              !s.features.isOldAndroid &&
              ((p = p || R.getFullscreenAPI())
                ? (s.bind(document, p.eventK, R.updateFullscreen),
                  R.updateFullscreen(),
                  s.addClass(r.template, "pwwp--supports-fs"))
                : s.removeClass(r.template, "pwwp--supports-fs")),
            T.preloaderEl &&
              (u(!0),
              x("beforeChange", function () {
                clearTimeout(C),
                  (C = setTimeout(function () {
                    r.currItem && r.currItem.loading
                      ? (r.allowProgressiveImg() &&
                          (!r.currItem.img || r.currItem.img.naturalWidth)) ||
                        u(!1)
                      : u(!0);
                  }, T.loadingIndicatorDelay));
              }),
              x("imageLoadComplete", function (e, t) {
                r.currItem === t && u(!0);
              }));
        }),
          (R.setIdle = function (e) {
            t(f, "ui--idle", (w = e));
          }),
          (R.update = function () {
            (M =
              !(!N || !r.currItem) &&
              (R.updateIndexIndicator(),
              T.captionEl &&
                (T.addCaptionHTMLFn(r.currItem, h),
                t(h, "caption--empty", !r.currItem.title)),
              !0)),
              L || o(),
              n();
          }),
          (R.updateFullscreen = function (e) {
            e &&
              setTimeout(function () {
                r.setScrollOffset(0, s.getScrollY());
              }, 50),
              s[(p.isFullscreen() ? "add" : "remove") + "Class"](
                r.template,
                "pwwp--fs"
              );
          }),
          (R.updateIndexIndicator = function () {
            T.counterEl &&
              (g.innerHTML =
                r.getCurrentIndex() +
                1 +
                T.indexIndicatorSep +
                T.getNumItemsFn());
          }),
          (R.onGlobalTap = function (e) {
            var t = (e = e || window.event).target || e.srcElement;
            if (!P)
              if (e.detail && "mouse" === e.detail.pointerType)
                l(t)
                  ? r.close()
                  : s.hasClass(t, "pwwp__img") &&
                    (1 === r.getZoomLevel() &&
                    r.getZoomLevel() <= r.currItem.fitRatio
                      ? T.clickToCloseNonZoomable && r.close()
                      : r.toggleDesktopZoom(e.detail.releasePoint));
              else if (
                (T.tapToToggleControls &&
                  (N ? R.hideControls() : R.showControls()),
                T.tapToClose && (s.hasClass(t, "pwwp__img") || l(t)))
              )
                return void r.close();
          }),
          (R.onMouseOver = function (e) {
            e = (e = e || window.event).target || e.srcElement;
            t(f, "ui--over-close", l(e));
          }),
          (R.hideControls = function () {
            s.addClass(f, "pwwp__ui--hidden"), (N = !1);
          }),
          (R.showControls = function () {
            (N = !0), M || R.update(), s.removeClass(f, "pwwp__ui--hidden");
          }),
          (R.supportsFullscreen = function () {
            var e = document;
            return !!(
              e.exitFullscreen ||
              e.mozCancelFullScreen ||
              e.webkitExitFullscreen ||
              e.msExitFullscreen
            );
          }),
          (R.getFullscreenAPI = function () {
            var e,
              t = document.documentElement,
              n = "fullscreenchange";
            return (
              t.requestFullscreen
                ? (e = {
                    enterK: "requestFullscreen",
                    exitK: "exitFullscreen",
                    elementK: "fullscreenElement",
                    eventK: n,
                  })
                : t.mozRequestFullScreen
                ? (e = {
                    enterK: "mozRequestFullScreen",
                    exitK: "mozCancelFullScreen",
                    elementK: "mozFullScreenElement",
                    eventK: "moz" + n,
                  })
                : t.webkitRequestFullscreen
                ? (e = {
                    enterK: "webkitRequestFullscreen",
                    exitK: "webkitExitFullscreen",
                    elementK: "webkitFullscreenElement",
                    eventK: "webkit" + n,
                  })
                : t.msRequestFullscreen &&
                  (e = {
                    enterK: "msRequestFullscreen",
                    exitK: "msExitFullscreen",
                    elementK: "msFullscreenElement",
                    eventK: "MSFullscreenChange",
                  }),
              e &&
                ((e.enter = function () {
                  if (
                    ((b = T.closeOnScroll),
                    (T.closeOnScroll = !1),
                    "webkitRequestFullscreen" !== this.enterK)
                  )
                    return r.template[this.enterK]();
                  r.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                }),
                (e.exit = function () {
                  return (T.closeOnScroll = b), document[this.exitK]();
                }),
                (e.isFullscreen = function () {
                  return document[this.elementK];
                })),
              e
            );
          });
      };
    }),
    "object" == typeof (wC = _f = {})
      ? (_f = vp())
      : (wC.PhotoSwipeUI_Default = vp()),
    Q();
  var IT = {};
  function _T(t, e) {
    var n,
      r = Object.keys(t);
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(t)),
        e &&
          (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
        r.push.apply(r, n)),
      r
    );
  }
  (function () {
    S(),
      (yk = E),
      Q(),
      (bk = K),
      (hT = "function" == typeof Symbol && Symbol.for),
      (wk = hT ? Symbol.for("react.portal") : 60106),
      (xk = hT ? Symbol.for("react.fragment") : 60107),
      (Ek = hT ? Symbol.for("react.strict_mode") : 60108),
      (Sk = hT ? Symbol.for("react.profiler") : 60114),
      (Ck = hT ? Symbol.for("react.provider") : 60109),
      (kk = hT ? Symbol.for("react.context") : 60110),
      (Tk = hT ? Symbol.for("react.concurrent_mode") : 60111),
      (Pk = hT ? Symbol.for("react.forward_ref") : 60112),
      (zk = hT ? Symbol.for("react.suspense") : 60113),
      (Ok = hT ? Symbol.for("react.suspense_list") : 60120),
      (Rk = hT ? Symbol.for("react.memo") : 60115),
      (Mk = hT ? Symbol.for("react.lazy") : 60116),
      (Nk = hT ? Symbol.for("react.fundamental") : 60117),
      (Lk = hT ? Symbol.for("react.scope") : 60119),
      (hT =
        bk.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED).hasOwnProperty(
        "ReactCurrentDispatcher"
      ) || (hT.ReactCurrentDispatcher = { current: null }),
      hT.hasOwnProperty("ReactCurrentBatchConfig") ||
        (hT.ReactCurrentBatchConfig = { suspense: null }),
      (Ik = {});
    for (var e, d = new Uint16Array(16), t = 0; t < 15; t++) d[t] = t + 1;
    function n(e, t) {
      (e = bk.isValidElement(e)
        ? e.type !== xk
          ? [e]
          : ((e = e.props.children), bk.isValidElement(e) ? [e] : oT(e))
        : oT(e)),
        (e = {
          type: null,
          domNamespace: Qk.html,
          children: e,
          childIndex: 0,
          context: Ik,
          footer: "",
        });
      var n = d[0];
      if (0 === n) {
        var r = d,
          i = 2 * (n = r.length);
        if (!(i <= 65536)) throw Error(gT(304));
        var o = new Uint16Array(i);
        for (o.set(r), (d = o)[0] = n + 1, r = n; r < i - 1; r++) d[r] = r + 1;
        d[i - 1] = 0;
      } else d[0] = d[n];
      (this.threadID = n),
        (this.stack = [e]),
        (this.exhausted = !1),
        (this.currentSelectValue = null),
        (this.previousWasTextNode = !1),
        (this.makeStaticMarkup = t),
        (this.suspenseDepth = 0),
        (this.contextIndex = -1),
        (this.contextStack = []),
        (this.contextValueStack = []);
    }
    (d[15] = 0),
      (_k = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/),
      (Dk = Object.prototype.hasOwnProperty),
      (Ak = {}),
      (Fk = {}),
      (Bk = {}),
      "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
        .split(" ")
        .forEach(function (e) {
          Bk[e] = new wT(e, 0, !1, e, null, !1);
        }),
      [
        ["acceptCharset", "accept-charset"],
        ["className", "class"],
        ["htmlFor", "for"],
        ["httpEquiv", "http-equiv"],
      ].forEach(function (e) {
        var t = e[0];
        Bk[t] = new wT(t, 1, !1, e[1], null, !1);
      }),
      ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (
        e
      ) {
        Bk[e] = new wT(e, 2, !1, e.toLowerCase(), null, !1);
      }),
      [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha",
      ].forEach(function (e) {
        Bk[e] = new wT(e, 2, !1, e, null, !1);
      }),
      "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
        .split(" ")
        .forEach(function (e) {
          Bk[e] = new wT(e, 3, !1, e.toLowerCase(), null, !1);
        }),
      ["checked", "multiple", "muted", "selected"].forEach(function (e) {
        Bk[e] = new wT(e, 3, !0, e, null, !1);
      }),
      ["capture", "download"].forEach(function (e) {
        Bk[e] = new wT(e, 4, !1, e, null, !1);
      }),
      ["cols", "rows", "size", "span"].forEach(function (e) {
        Bk[e] = new wT(e, 6, !1, e, null, !1);
      }),
      ["rowSpan", "start"].forEach(function (e) {
        Bk[e] = new wT(e, 5, !1, e.toLowerCase(), null, !1);
      }),
      (Wk = /[\-:]([a-z])/g),
      "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
        .split(" ")
        .forEach(function (e) {
          var t = e.replace(Wk, xT);
          Bk[t] = new wT(t, 1, !1, e, null, !1);
        }),
      "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
        .split(" ")
        .forEach(function (e) {
          var t = e.replace(Wk, xT);
          Bk[t] = new wT(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
        }),
      ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
        var t = e.replace(Wk, xT);
        Bk[t] = new wT(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1);
      }),
      ["tabIndex", "crossOrigin"].forEach(function (e) {
        Bk[e] = new wT(e, 1, !1, e.toLowerCase(), null, !1);
      }),
      (Bk.xlinkHref = new wT(
        "xlinkHref",
        1,
        !1,
        "xlink:href",
        "http://www.w3.org/1999/xlink",
        !0
      )),
      ["src", "href", "action", "formAction"].forEach(function (e) {
        Bk[e] = new wT(e, 1, !1, e.toLowerCase(), null, !0);
      }),
      ($k = /["'&<>]/),
      (jk = "function" == typeof Object.is ? Object.is : ST),
      (Zk = {
        readContext: function (e) {
          var t = Kk;
          return yT(e, t), e[t];
        },
        useContext: function (e) {
          CT();
          var t = Kk;
          return yT(e, t), e[t];
        },
        useMemo: function (e, t) {
          if (
            ((Hk = CT()), (t = void 0 === t ? null : t), null !== (qk = TT()))
          ) {
            var n = qk.memoizedState;
            if (null !== n && null !== t) {
              e: {
                var r = n[1];
                if (null === r) r = !1;
                else {
                  for (var i = 0; i < r.length && i < t.length; i++)
                    if (!jk(t[i], r[i])) {
                      r = !1;
                      break e;
                    }
                  r = !0;
                }
              }
              if (r) return n[0];
            }
          }
          return (e = e()), (qk.memoizedState = [e, t]), e;
        },
        useReducer: OT,
        useRef: function (e) {
          Hk = CT();
          var t = (qk = TT()).memoizedState;
          return null === t
            ? ((e = { current: e }), (qk.memoizedState = e))
            : t;
        },
        useState: function (e) {
          return OT(zT, e);
        },
        useLayoutEffect: function () {},
        useCallback: function (e) {
          return e;
        },
        useImperativeHandle: RT,
        useEffect: RT,
        useDebugValue: RT,
        useResponder: function (e, t) {
          return { props: t, responder: e };
        },
        useDeferredValue: function (e) {
          return CT(), e;
        },
        useTransition: function () {
          return (
            CT(),
            [
              function (e) {
                e();
              },
              !1,
            ]
          );
        },
      }),
      (eT = yk(
        { menuitem: !(Kk = Xk = 0) },
        (Jk = {
          area: !(Yk = qk = Vk = Hk = null),
          base: !(Gk = Uk = !(Qk = {
            html: "http://www.w3.org/1999/xhtml",
            mathml: "http://www.w3.org/1998/Math/MathML",
            svg: "http://www.w3.org/2000/svg",
          })),
          br: !0,
          col: !0,
          embed: !0,
          hr: !0,
          img: !0,
          input: !0,
          keygen: !0,
          link: !0,
          meta: !0,
          param: !0,
          source: !0,
          track: !0,
          wbr: !0,
        })
      )),
      (tT = {
        animationIterationCount: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0,
      }),
      (nT = ["Webkit", "ms", "Moz", "O"]),
      Object.keys(tT).forEach(function (t) {
        nT.forEach(function (e) {
          (e = e + t.charAt(0).toUpperCase() + t.substring(1)), (tT[e] = tT[t]);
        });
      }),
      (rT = /([A-Z])/g),
      (iT = /^ms-/),
      (oT = bk.Children.toArray),
      (aT = hT.ReactCurrentDispatcher),
      (sT = { listing: !0, pre: !0, textarea: !0 }),
      (lT = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/),
      (cT = {}),
      (uT = {}),
      (dT = Object.prototype.hasOwnProperty),
      (pT = {
        children: null,
        dangerouslySetInnerHTML: null,
        suppressContentEditableWarning: null,
        suppressHydrationWarning: null,
      }),
      ((e = n.prototype).destroy = function () {
        var e;
        this.exhausted ||
          ((this.exhausted = !0),
          this.clearProviders(),
          (e = this.threadID),
          (d[e] = d[0]),
          (d[0] = e));
      }),
      (e.pushProvider = function (e) {
        var t = ++this.contextIndex,
          n = e.type._context,
          r = this.threadID;
        yT(n, r);
        var i = n[r];
        (this.contextStack[t] = n),
          (this.contextValueStack[t] = i),
          (n[r] = e.props.value);
      }),
      (e.popProvider = function () {
        var e = this.contextIndex,
          t = this.contextStack[e],
          n = this.contextValueStack[e];
        (this.contextStack[e] = null),
          (this.contextValueStack[e] = null),
          this.contextIndex--,
          (t[this.threadID] = n);
      }),
      (e.clearProviders = function () {
        for (var e = this.contextIndex; 0 <= e; e--)
          this.contextStack[e][this.threadID] = this.contextValueStack[e];
      }),
      (e.read = function (e) {
        if (this.exhausted) return null;
        var t = Kk;
        Kk = this.threadID;
        var n = aT.current;
        aT.current = Zk;
        try {
          for (var r = [""], i = !1; r[0].length < e; ) {
            if (0 === this.stack.length) {
              this.exhausted = !0;
              var o = this.threadID;
              (d[o] = d[0]), (d[0] = o);
              break;
            }
            var a = this.stack[this.stack.length - 1];
            if (i || a.childIndex >= a.children.length) {
              var s = a.footer;
              if (
                ("" !== s && (this.previousWasTextNode = !1),
                this.stack.pop(),
                "select" === a.type)
              )
                this.currentSelectValue = null;
              else if (
                null != a.type &&
                null != a.type.type &&
                a.type.type.$$typeof === Ck
              )
                this.popProvider(a.type);
              else if (a.type === zk) {
                this.suspenseDepth--;
                var l = r.pop();
                if (i) {
                  i = !1;
                  o = a.fallbackFrame;
                  if (!o) throw Error(gT(303));
                  this.stack.push(o),
                    (r[this.suspenseDepth] += "\x3c!--$!--\x3e");
                  continue;
                }
                r[this.suspenseDepth] += l;
              }
              r[this.suspenseDepth] += s;
            } else {
              var c = a.children[a.childIndex++],
                u = "";
              try {
                u += this.render(c, a.context, a.domNamespace);
              } catch (e) {
                if (null != e && "function" == typeof e.then)
                  throw Error(gT(294));
                throw e;
              }
              r.length <= this.suspenseDepth && r.push(""),
                (r[this.suspenseDepth] += u);
            }
          }
          return r[0];
        } finally {
          (aT.current = n), (Kk = t);
        }
      }),
      (e.render = function (e, t, n) {
        if ("string" == typeof e || "number" == typeof e)
          return (n = "" + e)
            ? this.makeStaticMarkup
              ? ET(n)
              : this.previousWasTextNode
              ? "\x3c!-- --\x3e" + ET(n)
              : ((this.previousWasTextNode = !0), ET(n))
            : "";
        if (
          ((e = (t = LT(e, t, this.threadID)).child),
          (t = t.context),
          null === e || !1 === e)
        )
          return "";
        if (!bk.isValidElement(e)) {
          if (null == e || null == e.$$typeof)
            return (
              (e = oT(e)),
              this.stack.push({
                type: null,
                domNamespace: n,
                children: e,
                childIndex: 0,
                context: t,
                footer: "",
              }),
              ""
            );
          if ((n = e.$$typeof) === wk) throw Error(gT(257));
          throw Error(gT(258, n.toString()));
        }
        var r,
          i = e.type;
        if ("string" == typeof i) return this.renderDOM(e, t, n);
        switch (i) {
          case Ek:
          case Tk:
          case Sk:
          case Ok:
          case xk:
            return (
              (e = oT(e.props.children)),
              this.stack.push({
                type: null,
                domNamespace: n,
                children: e,
                childIndex: 0,
                context: t,
                footer: "",
              }),
              ""
            );
          case zk:
            throw Error(gT(294));
        }
        if ("object" == typeof i && null !== i)
          switch (i.$$typeof) {
            case Pk:
              Hk = {};
              var o = i.render(e.props, e.ref),
                o = PT(i.render, e.props, o, e.ref);
              return (
                (o = oT(o)),
                this.stack.push({
                  type: null,
                  domNamespace: n,
                  children: o,
                  childIndex: 0,
                  context: t,
                  footer: "",
                }),
                ""
              );
            case Rk:
              return (
                (e = [bk.createElement(i.type, yk({ ref: e.ref }, e.props))]),
                this.stack.push({
                  type: null,
                  domNamespace: n,
                  children: e,
                  childIndex: 0,
                  context: t,
                  footer: "",
                }),
                ""
              );
            case Ck:
              return (
                (n = {
                  type: e,
                  domNamespace: n,
                  children: (i = oT(e.props.children)),
                  childIndex: 0,
                  context: t,
                  footer: "",
                }),
                this.pushProvider(e),
                this.stack.push(n),
                ""
              );
            case kk:
              (i = e.type), (o = e.props);
              var a = this.threadID;
              return (
                yT(i, a),
                (i = oT(o.children(i[a]))),
                this.stack.push({
                  type: e,
                  domNamespace: n,
                  children: i,
                  childIndex: 0,
                  context: t,
                  footer: "",
                }),
                ""
              );
            case Nk:
              throw Error(gT(338));
            case Mk:
              switch (
                (-1 === (r = i = e.type)._status &&
                  ((r._status = 0),
                  (a = (a = r._ctor)()),
                  (r._result = a).then(
                    function (e) {
                      0 === r._status &&
                        ((e = e.default), (r._status = 1), (r._result = e));
                    },
                    function (e) {
                      0 === r._status && ((r._status = 2), (r._result = e));
                    }
                  )),
                i._status)
              ) {
                case 1:
                  return (
                    (e = [
                      bk.createElement(i._result, yk({ ref: e.ref }, e.props)),
                    ]),
                    this.stack.push({
                      type: null,
                      domNamespace: n,
                      children: e,
                      childIndex: 0,
                      context: t,
                      footer: "",
                    }),
                    ""
                  );
                case 2:
                  throw i._result;
                default:
                  throw Error(gT(295));
              }
            case Lk:
              throw Error(gT(343));
          }
        throw Error(gT(130, null == i ? i : typeof i, ""));
      }),
      (e.renderDOM = function (e, t, n) {
        var r = e.type.toLowerCase();
        if ((n === Qk.html && MT(r), !cT.hasOwnProperty(r))) {
          if (!lT.test(r)) throw Error(gT(65, r));
          cT[r] = !0;
        }
        var i,
          o,
          a,
          s,
          l = e.props;
        if ("input" === r)
          l = yk({ type: void 0 }, l, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != l.value ? l.value : l.defaultValue,
            checked: null != l.checked ? l.checked : l.defaultChecked,
          });
        else if ("textarea" === r) {
          var c = l.value;
          if (null == c) {
            c = l.defaultValue;
            var u = l.children;
            if (null != u) {
              if (null != c) throw Error(gT(92));
              if (Array.isArray(u)) {
                if (!(u.length <= 1)) throw Error(gT(93));
                u = u[0];
              }
              c = "" + u;
            }
            null == c && (c = "");
          }
          l = yk({}, l, { value: void 0, children: "" + c });
        } else if ("select" === r)
          (this.currentSelectValue =
            null != l.value ? l.value : l.defaultValue),
            (l = yk({}, l, { value: void 0 }));
        else if ("option" === r) {
          u = this.currentSelectValue;
          var d = (function (e) {
            if (null == e) return e;
            var t = "";
            return (
              bk.Children.forEach(e, function (e) {
                null != e && (t += e);
              }),
              t
            );
          })(l.children);
          if (null != u) {
            var p = null != l.value ? l.value + "" : d,
              c = !1;
            if (Array.isArray(u)) {
              for (var f = 0; f < u.length; f++)
                if ("" + u[f] === p) {
                  c = !0;
                  break;
                }
            } else c = "" + u === p;
            l = yk({ selected: void 0, children: void 0 }, l, {
              selected: c,
              children: d,
            });
          }
        }
        if ((c = l)) {
          if (
            eT[r] &&
            (null != c.children || null != c.dangerouslySetInnerHTML)
          )
            throw Error(gT(137, r, ""));
          if (null != c.dangerouslySetInnerHTML) {
            if (null != c.children) throw Error(gT(60));
            if (
              !(
                "object" == typeof c.dangerouslySetInnerHTML &&
                "__html" in c.dangerouslySetInnerHTML
              )
            )
              throw Error(gT(61));
          }
          if (null != c.style && "object" != typeof c.style)
            throw Error(gT(62, ""));
        }
        for (x in ((c = l),
        (u = this.makeStaticMarkup),
        (d = 1 === this.stack.length),
        (p = "<" + e.type),
        c))
          if (dT.call(c, x)) {
            var h = c[x];
            if (null != h) {
              if ("style" === x) {
                f = void 0;
                var m,
                  g,
                  v,
                  y,
                  b = "",
                  w = "";
                for (f in h)
                  h.hasOwnProperty(f) &&
                    ((m = 0 === f.indexOf("--")),
                    null != (g = h[f]) &&
                      ((b +=
                        w +
                        (y = m
                          ? f
                          : ((y = f),
                            uT.hasOwnProperty(y)
                              ? uT[y]
                              : ((v = y
                                  .replace(rT, "-$1")
                                  .toLowerCase()
                                  .replace(iT, "-ms-")),
                                (uT[y] = v)))) +
                        ":"),
                      (w = f),
                      (b += m =
                        null == g || "boolean" == typeof g || "" === g
                          ? ""
                          : m ||
                            "number" != typeof g ||
                            0 === g ||
                            (tT.hasOwnProperty(w) && tT[w])
                          ? ("" + g).trim()
                          : g + "px"),
                      (w = ";")));
                h = b || null;
              }
              f = null;
              e: if (((m = r), (g = c), -1 === m.indexOf("-")))
                m = "string" == typeof g.is;
              else
                switch (m) {
                  case "annotation-xml":
                  case "color-profile":
                  case "font-face":
                  case "font-face-src":
                  case "font-face-uri":
                  case "font-face-format":
                  case "font-face-name":
                  case "missing-glyph":
                    m = !1;
                    break e;
                  default:
                    m = !0;
                }
              m
                ? pT.hasOwnProperty(x) ||
                  (f = bT((f = x)) && null != h ? f + '="' + ET(h) + '"' : "")
                : ((i = x),
                  (o = h),
                  (s = a = void 0),
                  (s = Bk.hasOwnProperty(i) ? Bk[i] : null),
                  (a = "style" !== i) &&
                    (a =
                      null !== s
                        ? 0 === s.type
                        : 2 < i.length &&
                          ("o" === i[0] || "O" === i[0]) &&
                          ("n" === i[1] || "N" === i[1])),
                  (f =
                    a ||
                    (function (n, e) {
                      if (
                        null == n ||
                        (function (e, t) {
                          if (null === t || 0 !== t.type)
                            switch (typeof n) {
                              case "function":
                              case "symbol":
                                return 1;
                              case "boolean":
                                return null !== t
                                  ? !t.acceptsBooleans
                                  : "data-" !==
                                      (e = e.toLowerCase().slice(0, 5)) &&
                                      "aria-" !== e;
                              default:
                                return;
                            }
                        })(i, e)
                      )
                        return 1;
                      if ((0, null !== e))
                        switch (e.type) {
                          case 3:
                            return !n;
                          case 4:
                            return !1 === n;
                          case 5:
                            return isNaN(n);
                          case 6:
                            return isNaN(n) || n < 1;
                        }
                    })(o, s)
                      ? ""
                      : null !== s
                      ? ((i = s.attributeName),
                        3 === (a = s.type) || (4 === a && !0 === o)
                          ? i + '=""'
                          : (s.sanitizeURL && (o = "" + o),
                            i + '="' + ET(o) + '"'))
                      : bT(i)
                      ? i + '="' + ET(o) + '"'
                      : "")),
                f && (p += " " + f);
            }
          }
        u || (d && (p += ' data-reactroot=""'));
        var x = p;
        (c = ""),
          Jk.hasOwnProperty(r)
            ? (x += "/>")
            : ((x += ">"), (c = "</" + e.type + ">"));
        e: {
          if (null != (u = l.dangerouslySetInnerHTML)) {
            if (null != u.__html) {
              u = u.__html;
              break e;
            }
          } else if (
            "string" == typeof (u = l.children) ||
            "number" == typeof u
          ) {
            u = ET(u);
            break e;
          }
          u = null;
        }
        return (
          null != u
            ? ((l = []), sT[r] && "\n" === u.charAt(0) && (x += "\n"), (x += u))
            : (l = oT(l.children)),
          (e = e.type),
          (n =
            null == n || "http://www.w3.org/1999/xhtml" === n
              ? MT(e)
              : "http://www.w3.org/2000/svg" === n && "foreignObject" === e
              ? "http://www.w3.org/1999/xhtml"
              : n),
          this.stack.push({
            domNamespace: n,
            type: r,
            children: l,
            childIndex: 0,
            context: t,
            footer: c,
          }),
          (this.previousWasTextNode = !1),
          x
        );
      }),
      (fT = n),
      (mT =
        (hT = hT = {
          renderToString: function (e) {
            e = new fT(e, !1);
            try {
              return e.read(1 / 0);
            } finally {
              e.destroy();
            }
          },
          renderToStaticMarkup: function (e) {
            e = new fT(e, !0);
            try {
              return e.read(1 / 0);
            } finally {
              e.destroy();
            }
          },
          renderToNodeStream: function () {
            throw Error(gT(207));
          },
          renderToStaticNodeStream: function () {
            throw Error(gT(208));
          },
          version: "16.12.0",
        }).default || hT);
  })(),
    (IT = mT);
  var DT = function (e) {
    var t = e.scale,
      n = e.mediaScale,
      e =
        ((e = window.innerHeight / window.innerWidth),
        { width: (t = window.innerWidth * t), height: t * e }),
      e = Math.min(e.width, e.height / n);
    return { width: e, height: e * n };
  };
  function AT(e) {
    var t = e.maxWidthParam,
      n = e.zoom,
      r = e.scale,
      e = [5760];
    "number" == typeof t && e.push(t);
    for (var i = Math.min.apply(Math, e), o = 10; 0 < o; --o) {
      var a = DT({ scale: n * (o / 10), mediaScale: r }),
        s = a.width,
        a = a.height;
      if (s <= i) return { width: s, height: a };
    }
    return { width: i, height: i * r };
  }
  function FT(e, t, n) {
    var r = e.type,
      i = e.sources,
      o = e.alt,
      a = e.scale,
      s = e.scaleSources,
      l = e.transformedSrc,
      c = e.rioSettings,
      u = e.ignoreScale,
      u = (function (e) {
        if (e.ignoreScale) return null;
        e = e.scaleSources || e.scaleParam;
        return e ? parseFloat(e) / 100 : null;
      })({ scaleSources: s, scaleParam: a, ignoreScale: void 0 !== u && u });
    if ("image" === r && null !== u) {
      var d = AT({ maxWidthParam: e.width, zoom: Math.max(n, uk()), scale: u }),
        p =
          ((n = {
            imageSizeScaled: AT({ maxWidthParam: e.width, zoom: n, scale: u }),
            imageSizeScaledWithDPP: d,
          }),
          (p = n.imageSizeScaledWithDPP),
          (n = n.imageSizeScaled),
          0 < p.width && p.width > n.width ? n.width / p.width : 1);
      return { src: l(d.width), msrc: t, w: d.width, h: d.height, maxZoom: p };
    }
    (d = DT({ scale: 0.8, mediaScale: null === u ? 1 : u })),
      (p = d.width),
      (u = d.height);
    if ("video" === r) {
      var f = R(QS),
        d = "video-".concat(f());
      return {
        rioId: d,
        html: IT.renderToString(
          mh.createElement(
            Ny,
            {
              container: !0,
              alignItems: "center",
              justify: "center",
              style: { width: "100%", height: "100%" },
            },
            mh.createElement(
              Ny,
              { item: !0, style: { width: p, height: u } },
              mh.createElement("iframe", {
                id: d,
                frameBorder: "0",
                style: { width: "100%", height: "100%" },
                allow:
                  "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: "allowfullscreen",
                src: "https://pwzcdn.com/rio-store/prod/video-player/index.html?payload=".concat(
                  encodeURIComponent(
                    JSON.stringify(
                      (function (t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var n = null != arguments[e] ? arguments[e] : {};
                          e % 2
                            ? _T(Object(n), !0).forEach(function (e) {
                                R(Kh)(t, e, n[e]);
                              })
                            : Object.getOwnPropertyDescriptors
                            ? Object.defineProperties(
                                t,
                                Object.getOwnPropertyDescriptors(n)
                              )
                            : _T(Object(n)).forEach(function (e) {
                                Object.defineProperty(
                                  t,
                                  e,
                                  Object.getOwnPropertyDescriptor(n, e)
                                );
                              });
                        }
                        return t;
                      })({}, c, { sources: i, autoPlay: !1, poster: t })
                    )
                  )
                ),
                title: o,
              })
            )
          )
        ),
      };
    }
    if ("external_video" === r) {
      f = R(QS);
      f = "external-video-".concat(f());
      return {
        rioId: f,
        html: IT.renderToString(
          mh.createElement(
            Ny,
            {
              container: !0,
              alignItems: "center",
              justify: "center",
              style: { width: "100%", height: "100%" },
            },
            mh.createElement(
              Ny,
              { item: !0, style: { width: p, height: u } },
              mh.createElement("iframe", {
                id: f,
                frameBorder: "0",
                style: { width: "100%", height: "100%" },
                allow:
                  "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: "allowfullscreen",
                src: "https://pwzcdn.com/rio-store/prod/yt-player/index.html?payload=".concat(
                  encodeURIComponent(
                    JSON.stringify({
                      source: i[0],
                      muted: c.muted,
                      controls: c.controls,
                      autoPlay: !1,
                      title: o || void 0,
                    })
                  )
                ),
                title: o,
              })
            )
          )
        ),
      };
    }
    if ("model" !== r) return {};
    return {
      html: IT.renderToString(
        mh.createElement(
          Ny,
          {
            container: !0,
            alignItems: "center",
            justify: "center",
            style: { width: "100%", height: "100%" },
          },
          mh.createElement(
            Ny,
            { item: !0, style: { width: p, height: u } },
            mh.createElement("iframe", {
              style: { width: "100%", height: "100%" },
              frameBorder: "0",
              allow: "fullscreen; accelerometer; gyroscope",
              allowFullScreen: "allowfullscreen",
              src: "https://pwzcdn.com/rio-store/prod/model-viewer/index.html?src="
                .concat(encodeURIComponent(i[0]))
                .concat(o ? "&alt=".concat(encodeURIComponent(o)) : "")
                .concat(t ? "&poster=".concat(encodeURIComponent(t)) : "")
                .concat(c.autoRotate ? "&autorotate=true" : ""),
              title: o,
            })
          )
        )
      ),
    };
  }
  var BT = R(YT),
    WT = R(_f),
    $T = function (e, f, h, m) {
      function a(e, i) {
        var t,
          s,
          l,
          c,
          n,
          r = document.querySelectorAll(".pwwp")[0],
          o = (function () {
            for (var e = i.childNodes, t = [], n = 0; n < e.length; n += 1) {
              var r = e[n];
              1 === r.nodeType
                ? "IMG" === (r = r.children[0]).tagName
                  ? t.push(r.getAttribute("src"))
                  : ("DIV" === r.tagName &&
                      "VIDEO" === r.getAttribute("data-tagname")) ||
                    ("DIV" === r.tagName &&
                      "MODEL" === r.getAttribute("data-tagname"))
                  ? t.push(r.getAttribute("data-poster"))
                  : t.push(null)
                : t.push(null);
            }
            return t;
          })(),
          a = h.map(function (e, t) {
            return FT(e, o[t], m);
          }),
          u =
            ((s = (t = { media: h, items: a }).media),
            (l = t.items),
            (c = []),
            (n = new MutationObserver(function () {
              for (var e, t, n = 0; n < l.length; n += 1)
                c[n] &&
                  ((e = (t = R(Gh)(c[n], 2))[0]),
                  (t = t[1]),
                  document.body.contains(t) || (p(e), delete c[n]));
            })).observe(document.body, { childList: !0, subtree: !0 }),
            {
              initVideo: function (e) {
                var t, n, r, i, o, a;
                c[e] ||
                  ((r = s[e]),
                  (i = l[e].rioId),
                  "external_video" === r.type &&
                    "string" == typeof i &&
                    ((t = document.querySelector("#".concat(i))),
                    (a = t.contentWindow),
                    (n = {
                      play: function () {
                        a.postMessage(
                          { rioOrigin: "video-player", play: !0 },
                          "*"
                        );
                      },
                      pause: function () {
                        a.postMessage(
                          { rioOrigin: "video-player", pause: !0 },
                          "*"
                        );
                      },
                      destroy: function () {
                        a.postMessage(
                          { rioOrigin: "video-player", destroy: !0 },
                          "*"
                        );
                      },
                    }),
                    (c[e] = [n, t])),
                  "video" === r.type &&
                    "string" == typeof i &&
                    ((r = document.querySelector("#".concat(i))),
                    (o = r.contentWindow),
                    (i = {
                      play: function () {
                        o.postMessage({ play: !0 }, "*");
                      },
                      pause: function () {
                        o.postMessage({ pause: !0 }, "*");
                      },
                      destroy: function () {
                        o.postMessage({ destroy: !0 }, "*");
                      },
                    }),
                    (c[e] = [i, r])));
              },
              playVideo: function (e) {
                for (var t = 0; t < l.length; t += 1)
                  if (t !== e && c[t]) {
                    var n = R(Gh)(c[t], 1)[0];
                    try {
                      n.pause();
                    } catch (e) {}
                  }
                if (c[e] && s[e].rioSettings.autoPlay) {
                  var r = R(Gh)(c[e], 1)[0];
                  try {
                    r.play();
                  } catch (e) {}
                }
              },
              destroyVideos: function () {
                n.disconnect();
                for (var e, t = 0; t < l.length; t += 1)
                  c[t] && ((e = R(Gh)(c[t], 1)[0]), p(e), delete c[t]);
              },
            }),
          e = {
            closeEl: !0,
            captionEl: !1,
            fullscreenEl: !0,
            zoomEl: !0,
            shareEl: !1,
            counterEl: !1,
            arrowEl: !0,
            preloaderEl: !0,
            history: !1,
            galleryUID: i.getAttribute("data-pwwp-uid"),
            index: e,
            getDoubleTapZoom: function (e, t) {
              var n = "number" == typeof t.maxZoom ? t.maxZoom : 1;
              return e || t.initialZoomLevel < 0.7 ? n : 1.5 * n;
            },
          },
          d = new BT(r, WT, a, e);
        function p(e) {
          try {
            e.destroy();
          } catch (e) {}
        }
        d.init(),
          (window.productWizRioLightboxOpen = !0),
          d.listen("unbindEvents", function () {
            var e = d.getCurrentIndex(),
              t = f();
            t && t.slideTo(e, 0),
              u.destroyVideos(),
              (window.productWizRioLightboxOpen = !1);
          }),
          d.listen("afterChange", function () {
            var e = d.getCurrentIndex();
            u.initVideo(e), u.playVideo(e);
          });
      }
      e = document.querySelector(e);
      e.setAttribute("data-pwwp-uid", 1),
        (e.onclick = function (e) {
          e = e || window.event;
          e.preventDefault ? e.preventDefault() : (e.returnValue = !1);
          var t = (function e(t, n) {
            return t && (n(t) ? t : e(t.parentNode, n));
          })(e.target || e.srcElement, function (e) {
            return e.tagName && "div" === e.tagName.toLowerCase();
          });
          if (t && t.id.startsWith("pwzrswiper-slide")) {
            for (
              var n,
                e = t.parentNode,
                r = t.parentNode.childNodes,
                i = 0,
                o = 0;
              o < r.length;
              o += 1
            )
              if (1 === r[o].nodeType) {
                if (r[o] === t) {
                  n = i;
                  break;
                }
                i += 1;
              }
            return 0 <= n && "image" === h[n].type && a(n, e), !1;
          }
        });
    };
  function jT(e) {
    var t = e.getSwiper,
      n = e.media,
      r = e.lightBoxZoom;
    return (
      K.useEffect(
        function () {
          $T("#pwzrswiper-wrapper", t, n, r);
        },
        [t, r, n]
      ),
      mh.createElement(
        "div",
        {
          className: "rio-photoswipe",
          style: { position: "absolute", zIndex: 2147483647 },
        },
        mh.createElement(
          "div",
          {
            className: "pwwp",
            tabIndex: "-1",
            role: "dialog",
            "aria-hidden": "true",
          },
          mh.createElement("div", { className: "pwwp__bg" }),
          mh.createElement(
            "div",
            { className: "pwwp__scroll-wrap" },
            mh.createElement(
              "div",
              { className: "pwwp__container" },
              mh.createElement("div", { className: "pwwp__item" }),
              mh.createElement("div", { className: "pwwp__item" }),
              mh.createElement("div", { className: "pwwp__item" })
            ),
            mh.createElement(
              "div",
              { className: "pwwp__ui pwwp__ui--hidden" },
              mh.createElement(
                "div",
                { className: "pwwp__top-bar" },
                mh.createElement("div", { className: "pwwp__counter" }),
                mh.createElement("button", {
                  className: "pwwp__button pwwp__button--close",
                  title: "Close (Esc)",
                }),
                mh.createElement("button", {
                  className: "pwwp__button pwwp__button--share",
                  title: "Share",
                }),
                mh.createElement("button", {
                  className: "pwwp__button pwwp__button--fs",
                  title: "Toggle fullscreen",
                }),
                mh.createElement("button", {
                  className: "pwwp__button pwwp__button--zoom",
                  title: "Zoom in/out",
                }),
                mh.createElement(
                  "div",
                  { className: "pwwp__preloader" },
                  mh.createElement(
                    "div",
                    { className: "pwwp__preloader__icn" },
                    mh.createElement(
                      "div",
                      { className: "pwwp__preloader__cut" },
                      mh.createElement("div", {
                        className: "pwwp__preloader__donut",
                      })
                    )
                  )
                )
              ),
              mh.createElement(
                "div",
                {
                  className:
                    "pwwp__share-modal pwwp__share-modal--hidden pwwp__single-tap",
                },
                mh.createElement("div", { className: "pwwp__share-tooltip" })
              ),
              mh.createElement("button", {
                className: "pwwp__button pwwp__button--arrow--left",
                title: "Previous (arrow left)",
              }),
              mh.createElement("button", {
                className: "pwwp__button pwwp__button--arrow--right",
                title: "Next (arrow right)",
              }),
              mh.createElement(
                "div",
                { className: "pwwp__caption" },
                mh.createElement("div", { className: "pwwp__caption__center" })
              )
            )
          )
        )
      )
    );
  }
  (jT.propTypes = {
    getSwiper: RP.func.isRequired,
    media: RP.arrayOf(xp).isRequired,
    lightBoxZoom: RP.number.isRequired,
  }),
    Q();
  var HT = {
      normal:
        "\n      .pwzrswiper-pagination-bullet {\n        margin: 0 4px;\n      }\n\n      .pwzrswiper-pagination-bullet-active {\n        color: #fff;\n        background: rgba(0, 0, 0, 0.75);\n      }\n    ",
      clickable:
        "\n      .pwzrswiper-pagination-bullet {\n        outline: none;\n        width: 20px;\n        height: 20px;\n        text-align: center;\n        line-height: 20px;\n        font-size: 12px;\n        color: #000;\n        opacity: 1;\n        background: rgba(0, 0, 0, 0.2);\n        margin: 0 4px;\n        user-select: none;\n      }\n  \n      .pwzrswiper-pagination-bullet-active {\n        color: #fff;\n        background: rgba(0, 0, 0, 0.75);\n      }\n    ",
    },
    VT = null;
  function qT(e) {
    e = e.clickablePagination;
    return mh.createElement(
      mh.Fragment,
      null,
      mh.createElement("style", null, HT[e ? "clickable" : "normal"]),
      mh.createElement(
        "div",
        {
          id: "pwzr-pagination-container",
          style: {
            display: "flex",
            justifyContent: "center",
            minHeight: VT || "initial",
          },
        },
        mh.createElement(ng, {
          handleHeight: !0,
          onResize: function (e, t) {
            VT = t;
            t = document.querySelector("#pwzr-pagination-container");
            t && (t.style.minHeight = "initial");
          },
        }),
        mh.createElement("div", {
          style: {
            position: "static",
            marginTop: e ? 10 : 5,
            marginBottom: e ? 5 : 2,
          },
          className: Ph("pwzrswiper-pagination"),
        })
      )
    );
  }
  function UT(t, e) {
    var n,
      r = Object.keys(t);
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(t)),
        e &&
          (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
        r.push.apply(r, n)),
      r
    );
  }
  function GT(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2
        ? UT(Object(n), !0).forEach(function (e) {
            R(Kh)(t, e, n[e]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
        : UT(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
    }
    return t;
  }
  (qT.defaultProps = { clickablePagination: !1 }),
    (qT.propTypes = { clickablePagination: RP.bool });
  var YT = R(function (e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && rC(e, t);
    }),
    _f = R(function (e, t, n) {
      return t && nC(e.prototype, t), n && nC(e, n), e;
    }),
    XT = R(function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }),
    KT = R(function (e, t) {
      return !t || ("object" !== Yh(t) && "function" != typeof t) ? JS(e) : t;
    }),
    ZT = R(eC),
    QT = R(Kh),
    JT = R(JS),
    eP = R(QS),
    tP = R(Yu),
    nP = R(function (e, t, n) {
      if (e) {
        "function" == typeof t && ((n = t), (t = null)),
          ((t = t || {}).time = isNaN(t.time) ? 1e3 : t.time),
          (t.ease =
            t.ease ||
            function (e) {
              return 1 - Math.pow(1 - e, e / 2);
            }),
          (t.lockX = t.lockX || !1),
          (t.lockY = t.lockY || !1),
          (t.scrollAllParents =
            "boolean" != typeof t.scrollAllParents || t.scrollAllParents);
        var r = IC(e),
          i = 1,
          o = t.validTarget || LC,
          a = t.isScrollable;
        for (
          t.debug &&
          (console.log("About to scroll to", e),
          r ||
            console.error(
              "Target did not have a parent, is it mounted in the DOM?"
            ));
          r;

        )
          if (
            (t.debug && console.log("Scrolling parent node", r),
            o(r, i) &&
              (a ? a(r, NC) : NC(r)) &&
              (i++,
              (function (e, t, n, r) {
                var i,
                  o = !t._scrollSettings,
                  a = t._scrollSettings,
                  s = Date.now(),
                  l = { passive: !0 };
                function c(e) {
                  (t._scrollSettings = null),
                    t.parentElement &&
                      t.parentElement._scrollSettings &&
                      t.parentElement._scrollSettings.end(e),
                    n.debug &&
                      console.log("Scrolling ended with type", e, "for", t),
                    r(e),
                    i &&
                      (t.removeEventListener("touchstart", i, l),
                      t.removeEventListener("wheel", i, l));
                }
                a && a.end(zC);
                var u = n.maxSynchronousAlignments;
                null == u && (u = 3),
                  (t._scrollSettings = {
                    startTime: a ? a.startTime : Date.now(),
                    endIterations: 0,
                    target: e,
                    time: n.time + (a ? s - a.startTime : 0),
                    ease: n.ease,
                    align: n.align,
                    isWindow: n.isWindow || MC,
                    maxSynchronousAlignments: u,
                    end: c,
                    lockX: n.lockX,
                    lockY: n.lockY,
                  }),
                  ("cancellable" in n && !n.cancellable) ||
                    ((i = c.bind(null, zC)),
                    t.addEventListener("touchstart", i, l),
                    t.addEventListener("wheel", i, l)),
                  o && RC(t);
              })(e, r, t, s)),
            (r = IC(r)),
            !t.scrollAllParents || !r)
          ) {
            s(PC);
            break;
          }
      }
      function s(e) {
        --i || (n && n(e));
      }
    });
  function rP(e) {
    var l;
    return (
      XT(this, rP),
      (l = KT(this, ZT(rP).call(this, e))),
      QT(JT(l), "mountPhotoSwipe", function () {
        var e = l.props,
          t = e.media,
          n = e.config,
          e = n.lightBox,
          n = n.lightBoxZoom;
        e &&
          ((l.photoSwipeId = "photo-swipe-".concat(eP())),
          ((e = document.createElement("div")).id = l.photoSwipeId),
          document.body.appendChild(e),
          du.render(
            mh.createElement(jT, {
              getSwiper: function () {
                return l.swiper;
              },
              media: t,
              lightBoxZoom: n,
            }),
            e
          ));
      }),
      QT(JT(l), "destroyPhotoSwipe", function () {
        var e;
        l.photoSwipeId &&
          (e = document.querySelector(
            "#".concat(l.photoSwipeId)
          )).parentNode.removeChild(e);
      }),
      QT(JT(l), "initVideoPlayers", function () {
        for (var i = l.props.media, e = 0; e < i.length; e += 1)
          !(function (e) {
            var t,
              n,
              r = i[e];
            "external_video" === r.type &&
              (l.videoPlayers[e] =
                ((t = document.querySelector("#pwzrswiper-img-frame-".concat(e))
                  .contentWindow),
                {
                  play: function () {
                    t.postMessage({ rioOrigin: "video-player", play: !0 }, "*");
                  },
                  pause: function () {
                    t.postMessage(
                      { rioOrigin: "video-player", pause: !0 },
                      "*"
                    );
                  },
                  destroy: function () {
                    t.postMessage(
                      { rioOrigin: "video-player", destroy: !0 },
                      "*"
                    );
                  },
                })),
              "video" === r.type &&
                (l.videoPlayers[e] =
                  ((n = document.querySelector(
                    "#pwzrswiper-img-frame-".concat(e)
                  ).contentWindow),
                  {
                    play: function () {
                      n.postMessage({ play: !0 }, "*");
                    },
                    pause: function () {
                      n.postMessage({ pause: !0 }, "*");
                    },
                    destroy: function () {
                      n.postMessage({ destroy: !0 }, "*");
                    },
                  }));
          })(e);
      }),
      QT(JT(l), "destroyVideoPlayers", function () {
        for (var e = l.props.media, t = 0; t < e.length; t += 1)
          l.videoPlayers[t] && l.videoPlayers[t].destroy();
      }),
      QT(JT(l), "mountVideos", function () {
        (l.videoPlayers = []), l.initVideoPlayers();
      }),
      QT(JT(l), "destroyVideos", function () {
        l.destroyVideoPlayers(), delete l.videoPlayers;
      }),
      QT(JT(l), "playVideo", function () {
        if (!window.productWizRioLightboxOpen) {
          for (var e = l.props.media, t = 0; t < e.length; t += 1)
            t !== l.selected && l.videoPlayers[t] && l.videoPlayers[t].pause();
          l.videoPlayers[l.selected] &&
            e[l.selected].rioSettings.autoPlay &&
            l.videoPlayers[l.selected].play();
        }
      }),
      QT(JT(l), "mountSwiper", function () {
        var e = l.props,
          t = e.onSlideChange,
          n = e.config,
          r = n.pagination,
          i = n.clickablePagination,
          o = n.navigation,
          a = n.swipe,
          e = n.keyboard,
          s = n.maxHeight;
        (l.swiper = new tP(".pwzrswiper-container", {
          init: !1,
          initialSlide: l.selected,
          autoHeight: !0,
          allowTouchMove: a,
          preloadImages: !1,
          simulateTouch: !1,
          lazy: !0,
          keyboard: { enabled: "boolean" != typeof e || e, onlyInViewport: !1 },
          pagination:
            !!r &&
            GT(
              { el: ".pwzrswiper-pagination" },
              i
                ? {
                    clickable: !0,
                    renderBullet: function (e, t) {
                      return '<span tabindex="-1" class="'
                        .concat(t, '">')
                        .concat(e + 1, "</span>");
                    },
                  }
                : { clickable: !1 }
            ),
          navigation: !!o && {
            nextEl: ".pwzrswiper-button-next",
            prevEl: ".pwzrswiper-button-prev",
          },
        })),
          l.swiper.on("slideChange", function () {
            (l.selected = l.swiper.activeIndex),
              l.updateSwiperContainerWidth(),
              t(l.selected),
              l.initOrReinitDriftIfNeeded(),
              l.playVideo();
          }),
          l.swiper.on("slideChangeTransitionStart", function () {
            "string" == typeof s && l.swiper.update();
          });
      }),
      QT(JT(l), "getSwiperContainerWrapperWidth", function () {
        var e = document.querySelector("#pwzrswiper-container-wrapper");
        return e && "number" == typeof e.clientWidth && 0 < e.clientWidth
          ? e.clientWidth
          : null;
      }),
      QT(JT(l), "getMaxHeightRatio", function (e) {
        return "width" === e || "square" === e
          ? 1
          : "short" === e
          ? 0.75
          : null;
      }),
      QT(JT(l), "getSwiperContainerMaxWidth", function () {
        var e = l.props,
          t = e.media,
          n = e.config.maxHeight;
        if ("string" == typeof n) {
          var r = parseFloat(l.getScale(t[l.selected]));
          if (Number.isFinite(r)) {
            e = l.getMaxHeightRatio(n);
            if ("number" == typeof e) {
              t = (1e4 * e) / r;
              if (Number.isFinite(t)) {
                e = t.toFixed(3);
                if (e < 100) {
                  t = l.getSwiperContainerWrapperWidth();
                  return "number" == typeof t
                    ? "".concat(Math.floor(t * (e / 100)), "px")
                    : "".concat(e, "%");
                }
              }
            }
            if (n.endsWith("px")) {
              n = parseFloat(n);
              if (Number.isFinite(n))
                return "".concat(Math.floor((100 * n) / Math.ceil(r)), "px");
            }
          }
        }
        return "100%";
      }),
      QT(JT(l), "updateSwiperContainerWidth", function () {
        var e, t;
        l.swiper &&
          (!(e = document.querySelector(".pwzrswiper-container")) ||
            ((t = l.getSwiperContainerWidth()) !== l.swiperContainerWidth &&
              ((e.style.width = t), (l.swiperContainerWidth = t))));
      }),
      QT(JT(l), "getSwiperContainerWidth", function () {
        var e = l.props,
          t = e.config.navigation,
          e = e.media,
          e = t && 1 < e.length ? " - 20px - (38px * 2)" : "";
        return "min(calc(100%"
          .concat(e, "), ")
          .concat(l.getSwiperContainerMaxWidth(), ")");
      }),
      QT(JT(l), "getInitialSwiperContainerWidth", function () {
        var e = l.getSwiperContainerWidth();
        return (l.swiperContainerWidth = e);
      }),
      QT(JT(l), "destroySwiper", function () {
        if (l.swiper)
          try {
            l.swiper.destroy();
          } catch (e) {}
        delete l.swiper;
      }),
      QT(JT(l), "initOrReinitDriftIfNeeded", function () {
        var e = l.props,
          t = e.config.magnify,
          e = e.media;
        t &&
          "image" === e[l.selected].type &&
          (l.destroyDrift(),
          (t = document.querySelector("#pwzrswiper-img-".concat(l.selected))),
          (e = document.querySelector("#pwzrswiper-slide-".concat(l.selected))),
          (l.drift = new kC(t, {
            inlineContainer: e,
            inlinePane: !0,
            containInline: !0,
            injectBaseStyles: !1,
            handleTouch: !0,
            zoomFactor: l.getMagnifyZoom(),
          })));
      }),
      QT(JT(l), "destroyDrift", function () {
        l.drift && l.drift.destroy(), delete l.drift;
      }),
      QT(JT(l), "updateResponsiveImages", function () {
        for (var e = l.props.media, t = 0; t < e.length; t += 1) {
          var n = e[t],
            r = document.querySelector("#pwzrswiper-img-".concat(t)),
            i = rP.generateResponsiveImage(n, l.responsiveImageWidth),
            o = rP.generateResponsiveImage(
              n,
              ck(l.containerWidth * Math.max(uk(), l.getMagnifyZoom()))
            );
          "video" === n.type
            ? r.setAttribute("poster", i)
            : "image" === n.type &&
              ("string" == typeof r.className &&
                (r.className = r.className.replace(
                  "pwzrswiper-lazy-loaded",
                  ""
                )),
              r.setAttribute(l.swiper ? "data-src" : "src", i),
              r.setAttribute("data-zoom", o));
        }
      }),
      QT(JT(l), "getMagnifyZoom", function () {
        var e = l.props.config.magnify;
        return (e && e.zoom) || 3;
      }),
      QT(JT(l), "getScale", function (e) {
        return e.scaleSources || e.scale;
      }),
      QT(JT(l), "updateScaling", function (e) {
        for (var t = 0; t < e.length; t += 1) {
          var n = e[t],
            r = document.querySelector("#pwzrswiper-slide-".concat(t)),
            n = l.getScale(n);
          r.style.paddingBottom = n;
        }
      }),
      (l.selected = e.selected),
      l
    );
  }
  (_f =
    ((Yu = mh.Component),
    YT(rP, Yu),
    _f(rP, null, [
      {
        key: "getPlaceholderImageWidth",
        value: function (e) {
          return Ay("xl", e)
            ? 900
            : Ay("lg", e)
            ? 720
            : Ay("md", e)
            ? 540
            : 360;
        },
      },
      {
        key: "generatePlaceholderImage",
        value: function (e, t) {
          t = rP.getPlaceholderImageWidth(t);
          return e.transformedSrc(t);
        },
      },
      {
        key: "generateResponsiveImage",
        value: function (e, t) {
          return e.transformedSrc(t);
        },
      },
    ]),
    _f(rP, [
      {
        key: "componentDidMount",
        value: function () {
          this.props.config.vertical || this.mountSwiper(),
            this.mountPhotoSwipe(),
            this.initOrReinitDriftIfNeeded(),
            this.mountVideos();
        },
      },
      {
        key: "shouldComponentUpdate",
        value: function (e) {
          e = e.selected;
          return (
            this.selected !== e &&
              (this.swiper
                ? this.swiper.slideTo(e)
                : ((this.selected = e),
                  (e = document.querySelector(
                    "#pwzrswiper-slide-".concat(this.selected)
                  )) && nP(e, { time: 300 }))),
            !1
          );
        },
      },
      {
        key: "componentWillUnmount",
        value: function () {
          this.destroyVideos(),
            this.destroyDrift(),
            this.destroySwiper(),
            this.destroyPhotoSwipe();
        },
      },
      {
        key: "render",
        value: function () {
          var c = this,
            e = this.props,
            u = e.media,
            d = e.classes,
            p = e.width,
            t = e.children,
            n = e.config,
            r = n.pagination,
            i = n.clickablePagination,
            e = n.navigation,
            o = n.magnify,
            f = n.lightBox,
            h = n.vertical,
            m = n.verticalSpacing,
            n = h ? { display: "flex", flexDirection: "column" } : {},
            a = h
              ? {}
              : GT(
                  { width: this.getInitialSwiperContainerWidth() },
                  o
                    ? (QT(
                        (a = {}),
                        o.width && "full" !== o.width && "--magnify-width",
                        o.width
                      ),
                      QT(
                        a,
                        o.height && "full" !== o.height && "--magnify-height",
                        o.height
                      ),
                      a)
                    : {}
                );
          return mh.createElement(
            "div",
            { id: "pwzrswiper-container-wrapper" },
            !h &&
              mh.createElement(ng, {
                handleWidth: !0,
                skipOnMount: !0,
                onResize: function () {
                  c.updateSwiperContainerWidth();
                },
              }),
            mh.createElement(
              "div",
              { style: { position: "relative" } },
              mh.createElement(
                "div",
                {
                  className: Ph(
                    "pwzrswiper-container",
                    d.container,
                    h ? null : d.containerHidden
                  ),
                  style: a,
                },
                t,
                mh.createElement(ng, {
                  handleWidth: !0,
                  handleHeight: !0,
                  onResize: function (t, e) {
                    var n,
                      r = function () {
                        var e = ck((c.containerWidth = t) * uk());
                        c.responsiveImageWidth !== e &&
                          ((c.responsiveImageWidth = Math.max(
                            e,
                            rP.getPlaceholderImageWidth(p)
                          )),
                          c.updateResponsiveImages());
                      };
                    h ||
                      (c.swiper || c.mountSwiper(), c.swiper.initialized) ||
                      (((n = document.querySelector(
                        ".pwzrswiper-container"
                      )).className = n.className.replace(
                        d.containerHidden,
                        d.containerVisible
                      )),
                      r(),
                      c.swiper.init(),
                      c.updateScaling(u),
                      c.updateSwiperContainerWidth()),
                      r(),
                      c.swiper && c.swiper.update(),
                      o &&
                        ((r = document.querySelector(".pwzrswiper-container")
                          .style),
                        "full" === o.width &&
                          (r.setProperty("--magnify-width", "".concat(t, "px")),
                          r.setProperty("--magnify-width-full", "yes")),
                        "full" === o.height &&
                          (r.setProperty(
                            "--magnify-height",
                            "".concat(e, "px")
                          ),
                          r.setProperty("--magnify-height-full", "yes")));
                  },
                }),
                mh.createElement(
                  "div",
                  {
                    id: "pwzrswiper-wrapper",
                    className: "pwzrswiper-wrapper",
                    style: n,
                  },
                  u.map(function (e, t) {
                    var n = rP.generatePlaceholderImage(e, p),
                      r = e.id,
                      i = e.alt,
                      o = e.type,
                      a = e.sources,
                      s = e.rioSettings,
                      l = (h || t === c.selected) && s.muted && s.autoPlay;
                    return mh.createElement(
                      "div",
                      {
                        id: "pwzrswiper-slide-".concat(t),
                        className: "pwzrswiper-slide",
                        style: {
                          cursor: f && "image" === o ? "pointer" : "default",
                          paddingBottom:
                            h || t === c.selected ? c.getScale(e) : void 0,
                          marginBottom:
                            h && m && t !== u.length - 1 ? m : void 0,
                        },
                        key: r,
                      },
                      "video" === o &&
                        mh.createElement(
                          "div",
                          {
                            id: "pwzrswiper-img-".concat(t),
                            className: Ph(
                              "pwzrswiper-lazy",
                              d.slideExternalVideo
                            ),
                            "data-tagname": "VIDEO",
                            "data-poster": n,
                          },
                          mh.createElement("iframe", {
                            id: "pwzrswiper-img-frame-".concat(t),
                            className: d.slideExternalVideoIframe,
                            frameBorder: "0",
                            allow:
                              "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                            allowFullScreen: "allowfullscreen",
                            src: "https://pwzcdn.com/rio-store/prod/video-player/index.html?payload=".concat(
                              encodeURIComponent(
                                JSON.stringify(
                                  GT({}, s, {
                                    autoPlay: l,
                                    sources: a,
                                    poster: n,
                                  })
                                )
                              )
                            ),
                            title: i,
                          })
                        ),
                      "model" === o &&
                        mh.createElement(
                          "div",
                          {
                            id: "pwzrswiper-img-".concat(t),
                            className: Ph("pwzrswiper-lazy", d.slideModel),
                            "data-tagname": "MODEL",
                            "data-poster": n,
                          },
                          mh.createElement("iframe", {
                            className: d.slideModelIframe,
                            frameBorder: "0",
                            allow: "fullscreen; accelerometer; gyroscope",
                            allowFullScreen: "allowfullscreen",
                            src: "https://pwzcdn.com/rio-store/prod/model-viewer/index.html?src="
                              .concat(encodeURIComponent(a[0]))
                              .concat(
                                i ? "&alt=".concat(encodeURIComponent(i)) : "",
                                "&poster="
                              )
                              .concat(encodeURIComponent(n))
                              .concat(s.autoRotate ? "&autorotate=true" : ""),
                            title: i,
                          })
                        ),
                      "external_video" === o &&
                        mh.createElement(
                          "div",
                          {
                            id: "pwzrswiper-img-".concat(t),
                            className: Ph(
                              "pwzrswiper-lazy",
                              d.slideExternalVideo
                            ),
                          },
                          mh.createElement("iframe", {
                            id: "pwzrswiper-img-frame-".concat(t),
                            className: d.slideExternalVideoIframe,
                            frameBorder: "0",
                            allow:
                              "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                            allowFullScreen: "allowfullscreen",
                            src: "https://pwzcdn.com/rio-store/prod/yt-player/index.html?payload=".concat(
                              encodeURIComponent(
                                JSON.stringify({
                                  source: a[0],
                                  muted: s.muted,
                                  controls: s.controls,
                                  autoPlay: l,
                                  title: i || void 0,
                                })
                              )
                            ),
                            title: i,
                          })
                        ),
                      "image" === o &&
                        mh.createElement("img", {
                          id: "pwzrswiper-img-".concat(t),
                          className: Ph("pwzrswiper-lazy", d.slideImg),
                          src: n,
                          alt: i,
                        })
                    );
                  })
                )
              ),
              !h &&
                e &&
                1 < u.length &&
                mh.createElement(
                  mh.Fragment,
                  null,
                  mh.createElement("div", {
                    className: Ph(
                      "pwzrswiper-button-next",
                      "pwzrswiper-button-black",
                      d.arrow,
                      d.arrowRight
                    ),
                  }),
                  mh.createElement("div", {
                    className: Ph(
                      "pwzrswiper-button-prev",
                      "pwzrswiper-button-black",
                      d.arrow,
                      d.arrowLeft
                    ),
                  })
                )
            ),
            !h &&
              r &&
              1 < u.length &&
              mh.createElement(qT, { clickablePagination: i })
          );
        },
      },
    ]),
    rP)).propTypes = {
    children: RP.oneOfType([RP.object, RP.bool]).isRequired,
    config: If.isRequired,
    onSlideChange: RP.func.isRequired,
    selected: RP.number.isRequired,
    width: RP.string.isRequired,
    media: RP.arrayOf(xp).isRequired,
    classes: RP.exact({
      slideImg: RP.string.isRequired,
      slideModel: RP.string.isRequired,
      slideModelIframe: RP.string.isRequired,
      slideExternalVideo: RP.string.isRequired,
      slideExternalVideoIframe: RP.string.isRequired,
      arrow: RP.string.isRequired,
      arrowRight: RP.string.isRequired,
      arrowLeft: RP.string.isRequired,
      containerVisible: RP.string.isRequired,
      containerHidden: RP.string.isRequired,
    }).isRequired,
  };
  var iP = (function () {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return 0 === t.length
      ? function (e) {
          return e;
        }
      : 1 === t.length
      ? t[0]
      : t.reduce(function (e, t) {
          return function () {
            return e(t.apply(void 0, arguments));
          };
        });
  })(
    Uh({
      containerVisible: { opacity: 1, transition: "opacity 0.2s ease-in-out" },
      containerHidden: { opacity: 0 },
      slideImg: {
        position: "absolute",
        width: "100%",
        height: "auto",
        maxWidth: "none",
      },
      slideModel: {
        position: "absolute",
        width: "100%",
        height: "100%",
        maxWidth: "none",
      },
      slideModelIframe: { width: "100%", height: "100%" },
      slideExternalVideo: {
        position: "absolute",
        width: "100%",
        height: "100%",
        maxWidth: "none",
      },
      slideExternalVideoIframe: { width: "100%", height: "100%" },
      arrow: {
        textRendering: "auto",
        backgroundColor: "rgb(255, 255, 255, 0.8)",
        width: "38px",
        height: "50px",
        borderRadius: "20px",
        outline: "none",
        "&:after": { fontSize: "30px" },
      },
      arrowRight: { right: "5px" },
      arrowLeft: { left: "5px" },
    }),
    Sp()
  )(_f);
  function oP() {
    return mh.createElement(
      "svg",
      {
        riocandrag: "true",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
      },
      mh.createElement("path", {
        fill: "#212b36",
        d:
          "M3.2 0h13.6A3.2 3.2 0 0120 3.2v13.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 16.8V3.2A3.2 3.2 0 013.2 0z",
        opacity: ".9",
      }),
      mh.createElement("path", {
        fill: "#c4cdd5",
        d:
          "M8.277 12.927V7.07l4.649 2.927-4.649 2.93zm-.134-7.235a.595.595 0 00-.32-.092c-.344 0-.623.292-.623.653v7.492c0 .119.03.235.089.337.177.309.56.41.855.224l5.954-3.747a.638.638 0 00.214-.224.673.673 0 00-.214-.897L8.144 5.691z",
      })
    );
  }
  function aP() {
    return mh.createElement(
      "svg",
      {
        riocandrag: "true",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
      },
      mh.createElement("path", {
        fill: "#212b36",
        d:
          "M3.2 0h13.6A3.2 3.2 0 0120 3.2v13.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 16.8V3.2A3.2 3.2 0 013.2 0z",
        opacity: ".9",
      }),
      mh.createElement("path", {
        fill: "#c4cdd5",
        d:
          "M14.139 7.816l-3.877-2.149a.54.54 0 00-.523 0L5.862 7.816a.496.496 0 00-.261.435v4.298c0 .179.1.345.261.435l3.877 2.149a.54.54 0 00.523 0l3.877-2.149a.496.496 0 00.261-.435V8.251c0-.179-.1-.345-.261-.435zM10 6.682l2.831 1.569L10 9.82 7.169 8.251 10 6.682zM6.646 9.12l2.831 1.569v3.139l-2.831-1.57V9.119zm3.877 4.709V10.69l2.831-1.569v3.138l-2.831 1.57z",
      })
    );
  }
  function sP(t, e) {
    var n,
      r = Object.keys(t);
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(t)),
        e &&
          (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
        r.push.apply(r, n)),
      r
    );
  }
  Q(), Q();
  var lP = Vh(function () {
      return {
        thumbnailImage: {
          position: "relative",
          display: "block",
          width: "100%",
          maxWidth: "none",
        },
        thumbnailPlay: {
          position: "absolute",
          top: "4px",
          right: "2px",
          width: "26px",
          height: "26px",
        },
        thumbnailButton: {
          outline: "none",
          position: "relative",
          boxSizing: "border-box",
          border: "solid",
          borderWidth: "1px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      };
    }),
    cP = R(Gh),
    uP = mh.forwardRef(function (e, t) {
      var n = e.config,
        r = n.thumbnails,
        i = r.thumbnailWidth,
        o = r.thumbnailsPerRow,
        a = r.orientation,
        s = r.multiRow,
        f = r.square,
        h = r.centerCrop,
        m = n.pagination,
        n = e.media,
        g = e.onThumbnailSelected,
        v = e.selected,
        l = e.swiperKey,
        c = e.onThumbnailsScrolled,
        u = e.onThumbnailsResized,
        y = lP(),
        e = Boolean(i),
        d = lk(a),
        i = K.useState(e ? i : 0),
        i = cP(i, 2),
        b = i[0],
        p = i[1],
        w = K.useRef(l),
        x = K.useRef(!0),
        E = K.useCallback(
          function (e) {
            e &&
              (w.current !== l && ((x.current = !0), (w.current = l)),
              x.current
                ? (x.current = !1)
                : nP(
                    e,
                    { time: 100, lockX: d, lockY: !d, scrollAllParents: !1 },
                    function () {
                      c();
                    }
                  ));
          },
          [d, c, l]
        );
      return mh.createElement(
        Ny,
        {
          onScroll: function () {
            c();
          },
          ref: t,
          container: !0,
          direction: "row",
          justify: s ? "center" : void 0,
          alignItems: "center",
          wrap: s ? "wrap" : "nowrap",
          style: { overflow: "auto" },
          className: "rio-hide-scrollbar",
        },
        mh.createElement(ng, {
          key: l,
          handleWidth: !d,
          handleHeight: d,
          refreshMode: "debounce",
          refreshRate: 250,
          onResize: function () {
            u();
          },
        }),
        !e &&
          mh.createElement(ng, {
            handleWidth: !0,
            onResize: function (e) {
              e /= o;
              p(Math.floor(e));
            },
          }),
        0 < b &&
          n.map(function (e, t) {
            var n,
              r,
              i,
              o,
              a,
              s,
              l = e.transformedSrc,
              c = e.id,
              u = e.alt,
              d = e.scale,
              p = e.type,
              e =
                ((i = (n = {
                  thumbnailWidth: b,
                  scale: d,
                  square: f,
                  centerCrop: h,
                }).scale),
                (o = n.square),
                (a = n.centerCrop),
                (n = (s = r = n.thumbnailWidth) * (parseFloat(i) / 100)),
                (i = (r -= 8) * (parseFloat(i) / 100)),
                {
                  width: s,
                  height: (o = o && n < s) ? s : n,
                  widthInner: r,
                  heightInner: o ? r : i,
                  imgWidth: r,
                  imgHeight: (a = o && a) ? r : i,
                  needsCenterCrop: a,
                }),
              d = e.width,
              s = e.height,
              n = e.widthInner,
              o = e.heightInner,
              r = e.imgWidth,
              i = e.imgHeight,
              a = e.needsCenterCrop,
              e = ck(b * uk());
            return mh.createElement(
              Ny,
              {
                item: !0,
                container: !0,
                ref: t === v ? E : void 0,
                key: c,
                style: { minWidth: d, minHeight: s, width: d, height: s },
                alignItems: "center",
                justify: "center",
              },
              mh.createElement(
                "div",
                {
                  role: "button",
                  onClick: function () {
                    g(t);
                  },
                  onKeyPress: function (e) {
                    "Enter" === e.key && g(t);
                  },
                  tabIndex: m ? -1 : t + 1,
                  className: y.thumbnailButton,
                  style: (function (t) {
                    for (var e = 1; e < arguments.length; e++) {
                      var n = null != arguments[e] ? arguments[e] : {};
                      e % 2
                        ? sP(Object(n), !0).forEach(function (e) {
                            QT(t, e, n[e]);
                          })
                        : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(
                            t,
                            Object.getOwnPropertyDescriptors(n)
                          )
                        : sP(Object(n)).forEach(function (e) {
                            Object.defineProperty(
                              t,
                              e,
                              Object.getOwnPropertyDescriptor(n, e)
                            );
                          });
                    }
                    return t;
                  })(
                    { width: n, height: o },
                    t === v
                      ? { borderColor: "black" }
                      : { borderColor: "transparent" }
                  ),
                },
                mh.createElement("img", {
                  src: l(e, a ? e : null, a),
                  style: { width: r - 2, height: i - 2 },
                  alt: u,
                  className: y.thumbnailImage,
                }),
                ("video" === p || "external_video" === p) &&
                  mh.createElement(
                    "div",
                    { className: y.thumbnailPlay },
                    mh.createElement(oP, null)
                  ),
                "model" === p &&
                  mh.createElement(
                    "div",
                    { className: y.thumbnailPlay },
                    mh.createElement(aP, null)
                  )
              )
            );
          })
      );
    });
  uP.propTypes = {
    config: If.isRequired,
    media: RP.arrayOf(xp).isRequired,
    selected: RP.number.isRequired,
    swiperKey: RP.string.isRequired,
    onThumbnailSelected: RP.func.isRequired,
    onThumbnailsScrolled: RP.func.isRequired,
    onThumbnailsResized: RP.func.isRequired,
  };
  var dP,
    pP,
    fP = Vh(function () {
      return {
        root: { display: "flex" },
        thumbnailsContainer: { display: "flex" },
        navigationRoot: {
          zIndex: 1,
          color: "white",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          "&:hover": {
            backgroundColor: gu("rgba(0, 0, 0, 0.5)", 0.5),
            "@media (hover: none)": { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          },
        },
      };
    });
  function hP(e, t) {
    var n = Math.ceil(e.scrollLeft),
      r = Math.ceil(e.scrollTop),
      i = Math.floor(e.scrollLeft),
      o = Math.floor(e.scrollTop);
    return {
      start: t ? 0 === o : 0 === i,
      end: t
        ? e.offsetHeight + r >= e.scrollHeight
        : e.offsetWidth + n >= e.scrollWidth,
    };
  }
  function mP(t, n, r) {
    return new Promise(function (e) {
      n
        ? R(Fx).top(t, t.scrollTop + r * t.clientHeight, function () {
            e(hP(t, n));
          })
        : R(Fx).left(t, t.scrollLeft + r * t.clientWidth, function () {
            e(hP(t, n));
          });
    });
  }
  function gP() {
    var e = (Lx(), Ox),
      t = e.g,
      n = e.h,
      r = e.i,
      e = e.j;
    return mh.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "center",
          paddingTop: 10,
          paddingLeft: 10,
          paddingRight: 10,
        },
      },
      mh.createElement(
        "div",
        {
          style: {
            backgroundColor: "rgb(255, 244, 229)",
            color: "rgb(102, 60, 0)",
            padding: 12,
            display: "flex",
            alignItems: "center",
            borderRadius: "4px",
          },
        },
        mh.createElement(
          "div",
          {
            style: {
              minWidth: 22,
              minHeight: 22,
              paddingRight: 5,
              fill: "rgb(255, 152, 0)",
            },
          },
          mh.createElement(
            "svg",
            { focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
            mh.createElement("path", {
              d:
                "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z",
            })
          )
        ),
        mh.createElement("style", {
          dangerouslySetInnerHTML: {
            __html: "\n              ."
              .concat(
                t,
                " {\n                color: rgb(63, 81, 181);\n                text-decoration-line: none;\n                text-decoration-color: rgb(63, 81, 181);\n                text-decoration-style: solid;\n                text-align: center;\n              }\n              ."
              )
              .concat(
                n,
                " {\n                text-decoration-line: underline;\n              }\n            "
              ),
          },
        }),
        mh.createElement("a", { className: t, href: r, target: "_blank" }, e)
      )
    );
  }
  function vP(e) {
    var t = e.isLrOrien,
      e = e.thumbnails;
    return t && e.verticalOverflow ? 0 : "auto";
  }
  function yP(e) {
    var t = e.isLrOrien,
      e = e.thumbnails;
    return t
      ? e.container
        ? "".concat(100 * e.container, "%")
        : "".concat(e.thumbnailWidth * e.thumbnailsPerRow, "px")
      : null;
  }
  function bP(e) {
    var t = e.media,
      n = e.config,
      r = e.selected,
      i = e.onSelectedChanged,
      o = e.swiperKey,
      a = qh(),
      s = fP(),
      l = n.thumbnails,
      c = n.pagination,
      u = 1 < t.length && l,
      d = !!u && lk(u.orientation),
      p = a.spacing(1),
      f = p / 2,
      h = K.useState(vP({ isLrOrien: d, thumbnails: u })),
      m = cP(h, 2),
      g = m[0],
      v = m[1],
      y = K.useState(yP({ isLrOrien: d, thumbnails: u })),
      b = cP(y, 2),
      w = b[0],
      x = b[1],
      e = K.useState(!1),
      l = cP(e, 2),
      a = l[0],
      E = l[1],
      h = K.useState(!1),
      m = cP(h, 2),
      y = m[0],
      S = m[1],
      b = K.useState(eP()),
      e = cP(b, 2),
      l = e[0],
      C = e[1];
    K.useEffect(
      function () {
        v(vP({ isLrOrien: d, thumbnails: u })),
          x(yP({ isLrOrien: d, thumbnails: u })),
          C(eP());
      },
      [d, u]
    );
    var h = K.useState("100%"),
      m = cP(h, 2),
      b = m[0],
      k = m[1],
      T = K.useRef(null),
      P = K.useCallback(
        function () {
          var e;
          !u.navigation ||
            ((e = T.current) && ((e = hP(e, d)), S(!e.start), E(!e.end)));
        },
        [d, u]
      ),
      e = K.useState(!1),
      h = cP(e, 2),
      m = h[0],
      z = h[1];
    K.useEffect(function () {
      function t() {
        var e = R(N),
          s = R(M);
        return (t = e(
          s.mark(function e() {
            var t, n, r, i, o, a;
            return s.wrap(
              function (e) {
                for (;;)
                  switch ((e.prev = e.next)) {
                    case 0:
                      return (
                        (e.prev = 0),
                        Lx(),
                        (a = Ox.b),
                        (t = Ox.c),
                        (n = Ox.d),
                        (r = Ox.e),
                        (i = Ox.f),
                        (o = a.concat(
                          (function () {
                            var e = Array.prototype.slice.call(arguments),
                              n = e.shift();
                            return e
                              .reverse()
                              .map(function (e, t) {
                                return String.fromCharCode(e - n - 8 - t);
                              })
                              .join("");
                          })(
                            31,
                            149,
                            159,
                            159,
                            147,
                            149,
                            155,
                            149,
                            141,
                            139,
                            142,
                            144,
                            155
                          ) +
                            (24).toString(36).toLowerCase() +
                            (30)
                              .toString(36)
                              .toLowerCase()
                              .split("")
                              .map(function (e) {
                                return String.fromCharCode(
                                  e.charCodeAt() + -71
                                );
                              })
                              .join("") +
                            (38574780).toString(36).toLowerCase() +
                            (function () {
                              var e = Array.prototype.slice.call(arguments),
                                n = e.shift();
                              return e
                                .reverse()
                                .map(function (e, t) {
                                  return String.fromCharCode(e - n - 8 - t);
                                })
                                .join("");
                            })(18, 130, 76, 150, 130, 132, 138) +
                            (24).toString(36).toLowerCase() +
                            (function () {
                              var e = Array.prototype.slice.call(arguments),
                                n = e.shift();
                              return e
                                .reverse()
                                .map(function (e, t) {
                                  return String.fromCharCode(e - n - 35 - t);
                                })
                                .join("");
                            })(59, 203)
                        )),
                        QT((a = {}), t, !1),
                        QT(a, n, r),
                        (a = a),
                        (e.next = 6),
                        R(qS).get(o, a)
                      );
                    case 6:
                      e.sent.data === i && z(!0), (e.next = 13);
                      break;
                    case 10:
                      (e.prev = 10), (e.t0 = e.catch(0)), console.log(e.t0);
                    case 13:
                    case "end":
                      return e.stop();
                  }
              },
              e,
              null,
              [[0, 10]]
            );
          })
        )).apply(this, arguments);
      }
      try {
        !(function () {
          t.apply(this, arguments);
        })();
      } catch (e) {
        console.log(e);
      }
    }, []);
    var e = u
        ? {
            flexDirection: (function (e) {
              if ("bottom" === e) return "column-reverse";
              if ("top" === e) return "column";
              if ("right" === e) return "row-reverse";
              if ("left" === e) return "row";
              throw Error("Unknown thumbnail orientation '".concat(e, "'"));
            })(u.orientation),
          }
        : { flexDirection: "column" },
      h = R(N),
      O = R(M);
    return mh.createElement(
      "div",
      { className: s.root, style: e },
      mh.createElement(ng, {
        handleWidth: !0,
        key: l,
        onResize: function (e) {
          var t = w;
          d &&
            u.container &&
            ((t = "".concat(Math.floor(e * u.container), "px")), x(t));
          e = "".concat(Math.floor(e), "px");
          k(
            "string" == typeof t
              ? "calc(".concat(e, " - ").concat(t, " - ").concat(p, "px)")
              : e
          );
        },
      }),
      u &&
        mh.createElement(
          "div",
          {
            style: d
              ? (QT(
                  (f = {
                    overflowY: "auto",
                    overflowX: "hidden",
                    flexDirection: "column",
                    alignItems: "center",
                    width: w,
                    height: g,
                    paddingTop: f,
                    paddingBottom: f,
                  }),
                  "margin".concat("left" === u.orientation ? "Right" : "Left"),
                  p
                ),
                QT(f, "position", "relative"),
                QT(f, "boxSizing", "border-box"),
                f)
              : {
                  flexDirection: "row",
                  paddingLeft: p,
                  paddingRight: p,
                  marginTop: c ? void 0 : p,
                  position: "relative",
                  alignItems: "center",
                },
            className: Ph("rio-hide-scrollbar", s.thumbnailsContainer),
          },
          u.navigation &&
            y &&
            mh.createElement(
              Nv,
              {
                size: "small",
                classes: { root: s.navigationRoot },
                onClick: h(
                  O.mark(function e() {
                    var t;
                    return O.wrap(function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (e.next = 2), mP(T.current, d, -1);
                          case 2:
                            (t = e.sent), S(!t.start), E(!t.end);
                          case 5:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  })
                ),
                style:
                  (QT((y = { position: "absolute" }), !d && "left", 0),
                  QT(y, d && "top", 0),
                  y),
              },
              d && mh.createElement(hg, { fontSize: "large" }),
              !d && mh.createElement(dg, { fontSize: "large" })
            ),
          mh.createElement(uP, {
            ref: T,
            swiperKey: o,
            config: n,
            media: t,
            selected: r,
            onThumbnailSelected: function (e) {
              i(e);
            },
            onThumbnailsScrolled: P,
            onThumbnailsResized: function () {
              P();
            },
          }),
          u.navigation &&
            a &&
            mh.createElement(
              Nv,
              {
                size: "small",
                classes: { root: s.navigationRoot },
                onClick: h(
                  O.mark(function e() {
                    var t;
                    return O.wrap(function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (e.next = 2), mP(T.current, d, 1);
                          case 2:
                            (t = e.sent), S(!t.start), E(!t.end);
                          case 5:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  })
                ),
                style:
                  (QT((h = { position: "absolute" }), !d && "right", 0),
                  QT(h, d && "bottom", 0),
                  h),
              },
              d && mh.createElement(fg, { fontSize: "large" }),
              !d && mh.createElement(pg, { fontSize: "large" })
            )
        ),
      mh.createElement(
        "div",
        { style: d ? { flex: 1, overflow: "hidden" } : void 0 },
        mh.createElement(
          "div",
          { style: { maxWidth: b } },
          mh.createElement(
            iP,
            {
              key: o,
              config: n,
              media: t,
              selected: r,
              onSlideChange: function (e) {
                i(e);
              },
            },
            d &&
              u.verticalOverflow &&
              mh.createElement(ng, {
                handleHeight: !0,
                key: l,
                onResize: function (e, t) {
                  v(t);
                },
              })
          )
        ),
        m && mh.createElement(gP, null)
      )
    );
  }
  function wP(t) {
    return function (e) {
      !(function (e, t) {
        try {
          var n;
          if (
            !(n =
              e.id.options && e.id.options[e.id.selectedIndex]
                ? e.id.options[e.id.selectedIndex]
                : e.id)
          )
            return;
          t(n.value);
        } catch (e) {
          console.warn(
            "[productwiz-rio] Error in trackViewedProductVariant: ".concat(
              e.message
            )
          );
        }
      })((e = e || window.event).currentTarget, t);
    };
  }
  function xP(t, e) {
    var n,
      r = Object.keys(t);
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(t)),
        e &&
          (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
        r.push.apply(r, n)),
      r
    );
  }
  function EP(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2
        ? xP(Object(n), !0).forEach(function (e) {
            QT(t, e, n[e]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
        : xP(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
    }
    return t;
  }
  function SP(e, t, n) {
    var r = n || dk();
    if (r)
      if (e) {
        var i = t.variants.find(function (e) {
          return e.id === r;
        });
        if (i && -1 < i.featuredMediaIndex) return i.featuredMediaIndex;
      } else {
        i = t.findIndex(function (e) {
          return e.variant === r;
        });
        if (-1 < i) return i;
      }
    if (e) {
      e = t.variants[0];
      if (-1 < e.featuredMediaIndex) return e.featuredMediaIndex;
    } else {
      t = t.findIndex(function (e) {
        return !0 === e.available;
      });
      if (-1 < t) return t;
    }
    return 0;
  }
  (bP.propTypes = {
    config: If.isRequired,
    media: RP.arrayOf(xp).isRequired,
    selected: RP.number.isRequired,
    onSelectedChanged: RP.func.isRequired,
    swiperKey: RP.string.isRequired,
  }),
    "function" != typeof window.CustomEvent &&
      (window.CustomEvent = function (e, t) {
        t = t || { bubbles: !1, cancelable: !1, detail: null };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
      }),
    (history.pushState =
      ((pP = history.pushState),
      function () {
        var e = pP.apply(this, arguments);
        return (
          window.dispatchEvent(new CustomEvent("pushState")),
          window.dispatchEvent(new CustomEvent("locationchange")),
          e
        );
      })),
    (history.replaceState =
      ((dP = history.replaceState),
      function () {
        var e = dP.apply(this, arguments);
        return (
          window.dispatchEvent(new CustomEvent("replaceState")),
          window.dispatchEvent(new CustomEvent("locationchange")),
          e
        );
      })),
    window.addEventListener("popstate", function () {
      window.dispatchEvent(new CustomEvent("locationchange"));
    });
  var CP = function (e) {
      var t = e.useFormListener,
        n = e.handleLocationChangeRef;
      if (t)
        return (function (e) {
          for (var t, n, r = null, i = 0; i < document.forms.length; i++) {
            var o = document.forms[i].getAttribute("action");
            o &&
              0 <= o.indexOf("/cart/add") &&
              ((r = r || wP(e)),
              (t = document.forms[i]),
              (n = "change"),
              (o = r),
              t.addEventListener(n, o));
          }
          return r;
        })(function (e) {
          n.current && n.current(e);
        });
      t = function () {
        n.current && n.current();
      };
      return window.addEventListener("locationchange", t), t;
    },
    kP = function (e) {
      var t = e.useFormListener,
        e = e.event;
      t
        ? (function (e) {
            for (var t, n, r = 0; r < document.forms.length; r++) {
              var i = document.forms[r].getAttribute("action");
              i &&
                0 <= i.indexOf("/cart/add") &&
                ((t = document.forms[r]),
                (n = "change"),
                (i = e),
                t.removeEventListener(n, i));
            }
          })(e)
        : window.removeEventListener("locationchange", e);
    };
  function TP(e) {
    var t,
      n,
      r,
      i,
      a,
      o,
      s,
      l,
      c,
      u,
      d,
      p,
      f = e.media,
      h = e.mobileConfig,
      m = e.desktopConfig,
      g = e.breakpoint,
      v = e.useFormListener,
      y = R(Yh),
      b = "object" === y(f.media) && "object" === y(f.variants),
      w = Zh("(min-width:".concat(g, ")"), { noSsr: !0 }),
      x = K.useState(SP(b, f)),
      E = cP(x, 2),
      S = E[0],
      C = E[1],
      e = K.useState(0),
      y = cP(e, 2),
      g = y[0],
      k = y[1],
      x = K.useState(b ? null : f[S].variant),
      E = cP(x, 2),
      e = E[0],
      y = E[1],
      x = w ? "desktop" : "mobile";
    (g = b
      ? ((n = t = x), (r = f.media), S)
      : ((E = f[S]),
        (t = x),
        (n = "".concat(e, "-").concat(x)),
        (r = E.media),
        g)),
      (i = (y = {
        isDefaultMedia: b,
        mediaParam: f,
        useFormListener: v,
        setSelectedVariant: C,
        setSelectedMedia: k,
        selectedVariant: S,
        setMediaKey: y,
      }).isDefaultMedia),
      (a = y.mediaParam),
      (o = y.useFormListener),
      (s = y.setSelectedVariant),
      (l = y.setSelectedMedia),
      (c = y.selectedVariant),
      (u = y.setMediaKey),
      (d = K.useRef(null)),
      (p = K.useCallback(
        function (e) {
          var o = SP(i, a, e);
          s(o),
            i ||
              (function () {
                var e = a[c].media,
                  t = a[o].media;
                if (Array.isArray(e) && Array.isArray(t)) {
                  var n = e.map(function (e) {
                      return e.id;
                    }),
                    r = t.map(function (e) {
                      return e.id;
                    });
                  if (n.length !== r.length) return;
                  for (var i = 0; i < n.length; i += 1)
                    if (n[i] !== r[i]) return;
                  return 1;
                }
              })() ||
              (l(0), (e = a[o].variant), u(e));
        },
        [i, a, c, u, l, s]
      )),
      K.useEffect(
        function () {
          d.current = p;
        },
        [p]
      ),
      K.useEffect(
        function () {
          var e = CP({ useFormListener: o, handleLocationChangeRef: d });
          return function () {
            e && kP(e);
          };
        },
        [o]
      );
    h = (function (e) {
      var t = e.isDefaultMedia,
        n = e.mediaParam,
        r = e.config;
      if (!1 !== r.thumbnails) return r;
      function i(e) {
        return (
          "video" === e.type ||
          "external_video" === e.type ||
          "model" === e.type
        );
      }
      if (t) {
        var o = !0,
          a = !1,
          s = void 0;
        try {
          for (
            var l, c = n.media[Symbol.iterator]();
            !(o = (l = c.next()).done);
            o = !0
          )
            if (i(l.value)) return EP({}, r, { navigation: !0 });
        } catch (e) {
          (a = !0), (s = e);
        } finally {
          try {
            o || null == c.return || c.return();
          } finally {
            if (a) throw s;
          }
        }
      } else {
        var u = !0,
          d = !1,
          p = void 0;
        try {
          for (
            var f, h = n[Symbol.iterator]();
            !(u = (f = h.next()).done);
            u = !0
          ) {
            var m = f.value,
              g = !0,
              v = !1,
              y = void 0;
            try {
              for (
                var b, w = m.media[Symbol.iterator]();
                !(g = (b = w.next()).done);
                g = !0
              )
                if (i(b.value)) return EP({}, r, { navigation: !0 });
            } catch (e) {
              (v = !0), (y = e);
            } finally {
              try {
                g || null == w.return || w.return();
              } finally {
                if (v) throw y;
              }
            }
          }
        } catch (e) {
          (d = !0), (p = e);
        } finally {
          try {
            u || null == h.return || h.return();
          } finally {
            if (d) throw p;
          }
        }
      }
      return r;
    })({ isDefaultMedia: b, mediaParam: f, config: w ? m : h });
    return mh.createElement(bP, {
      key: t,
      swiperKey: n,
      media: r,
      config: h,
      selected: g,
      onSelectedChanged: function (e) {
        (b ? C : k)(e);
      },
    });
  }
  (TP.defaultProps = { useFormListener: !1 }),
    (TP.propTypes = {
      breakpoint: RP.string.isRequired,
      useFormListener: RP.bool,
      mobileConfig: If.isRequired,
      desktopConfig: If.isRequired,
      media: RP.oneOfType([
        RP.arrayOf(
          RP.exact({
            variant: RP.string.isRequired,
            available: RP.bool.isRequired,
            media: RP.arrayOf(xp).isRequired,
          })
        ),
        RP.exact({
          media: RP.arrayOf(xp).isRequired,
          variants: RP.arrayOf(
            RP.exact({
              id: RP.string.isRequired,
              featuredMediaIndex: RP.number.isRequired,
              available: RP.bool.isRequired,
            })
          ).isRequired,
        }),
      ]).isRequired,
    });
  var PP,
    zP,
    OP,
    xp = (If = __productWizRio).enabled,
    RP = If.hijackInit,
    If = R(N);
  xp &&
    ((PP = function () {
      var e,
        t,
        n,
        i,
        o,
        a,
        r = __productWizRio,
        s =
          ((e = r.product),
          (t = r.productRio),
          (n = r.mediaSettings),
          e && !t
            ? mk(e)
            : ((i = t),
              (o = n),
              (a = mk(e, !1)),
              (e = a.variants.map(function (t) {
                var e,
                  n = [],
                  r = i.find(function (e) {
                    return e.id === t.id;
                  });
                return (
                  r &&
                    r.media.forEach(function (t) {
                      var e = a.media.find(function (e) {
                        return e.id === t;
                      });
                      e &&
                        n.push(
                          sk({}, e, {
                            rioSettings: ok.getRioMediaSettings(r.id, t, o),
                          })
                        );
                    }),
                  n.length < 1 && ((e = R(_C)), n.push.apply(n, e(a.media))),
                  { variant: t.id, available: t.available, media: n }
                );
              })).length < 1
                ? a
                : e)),
        l = __productWizRio.useFormListener,
        r = __productWizRio.config,
        t = r.mobile,
        n = r.desktop,
        e = r.breakpoint,
        r = Dd({
          overrides: {
            PwzrSvgIcon: { root: { width: "35px", height: "35px" } },
          },
        });
      return mh.createElement(
        "div",
        { style: { width: "100%", height: "auto", textAlign: "left" } },
        mh.createElement(
          Wh,
          { theme: r },
          mh.createElement(TP, {
            media: s,
            mobileConfig: t,
            desktopConfig: n,
            breakpoint: e,
            useFormListener: "boolean" == typeof l && l,
          })
        )
      );
    }),
    (zP = R(M)),
    (OP = If(
      zP.mark(function e() {
        var t;
        return zP.wrap(function (e) {
          for (;;)
            switch ((e.prev = e.next)) {
              case 0:
                (t = document.querySelector(".rio-media-gallery")) &&
                  du.render(mh.createElement(PP, null), t);
              case 2:
              case "end":
                return e.stop();
            }
        }, e);
      })
    )),
    (If = function () {
      return OP.apply(this, arguments);
    }),
    RP
      ? (__productWizRio.init = If)
      : "loading" === document.readyState
      ? document.addEventListener("DOMContentLoaded", If)
      : If());
})();
